import Ki, { ref as ue, computed as dr, unref as Xr, watch as Je, onMounted as hr, getCurrentInstance as yn, onUnmounted as n1, reactive as a1, nextTick as ni, defineEmits as Gw, toRefs as i1, onBeforeMount as o1 } from "vue";
var ru = !0, Ym = !1;
Ki.util.warn;
var qe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ln(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function fN(r) {
  if (r.__esModule)
    return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Vw = { exports: {} };
function vN(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var xd = { exports: {} };
const pN = {}, dN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pN
}, Symbol.toStringTag, { value: "Module" })), Qw = /* @__PURE__ */ fN(dN);
var s1;
function lr() {
  return s1 || (s1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n();
    })(qe, function() {
      var t = t || function(n, a) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof qe < "u" && qe.crypto && (i = qe.crypto), !i && typeof vN == "function")
          try {
            i = Qw;
          } catch {
          }
        var u = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, f = Object.create || function() {
          function y() {
          }
          return function(m) {
            var b;
            return y.prototype = m, b = new y(), y.prototype = null, b;
          };
        }(), c = {}, o = c.lib = {}, s = o.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(y) {
              var m = f(this);
              return y && m.mixIn(y), (!m.hasOwnProperty("init") || this.init === m.init) && (m.init = function() {
                m.$super.init.apply(this, arguments);
              }), m.init.prototype = m, m.$super = this, m;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var y = this.extend();
              return y.init.apply(y, arguments), y;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(y) {
              for (var m in y)
                y.hasOwnProperty(m) && (this[m] = y[m]);
              y.hasOwnProperty("toString") && (this.toString = y.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), l = o.WordArray = s.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(y, m) {
            y = this.words = y || [], m != a ? this.sigBytes = m : this.sigBytes = y.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(y) {
            return (y || p).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(y) {
            var m = this.words, b = y.words, w = this.sigBytes, A = y.sigBytes;
            if (this.clamp(), w % 4)
              for (var E = 0; E < A; E++) {
                var N = b[E >>> 2] >>> 24 - E % 4 * 8 & 255;
                m[w + E >>> 2] |= N << 24 - (w + E) % 4 * 8;
              }
            else
              for (var C = 0; C < A; C += 4)
                m[w + C >>> 2] = b[C >>> 2];
            return this.sigBytes += A, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var y = this.words, m = this.sigBytes;
            y[m >>> 2] &= 4294967295 << 32 - m % 4 * 8, y.length = n.ceil(m / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var y = s.clone.call(this);
            return y.words = this.words.slice(0), y;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(y) {
            for (var m = [], b = 0; b < y; b += 4)
              m.push(u());
            return new l.init(m, y);
          }
        }), v = c.enc = {}, p = v.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(y) {
            for (var m = y.words, b = y.sigBytes, w = [], A = 0; A < b; A++) {
              var E = m[A >>> 2] >>> 24 - A % 4 * 8 & 255;
              w.push((E >>> 4).toString(16)), w.push((E & 15).toString(16));
            }
            return w.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(y) {
            for (var m = y.length, b = [], w = 0; w < m; w += 2)
              b[w >>> 3] |= parseInt(y.substr(w, 2), 16) << 24 - w % 8 * 4;
            return new l.init(b, m / 2);
          }
        }, h = v.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(y) {
            for (var m = y.words, b = y.sigBytes, w = [], A = 0; A < b; A++) {
              var E = m[A >>> 2] >>> 24 - A % 4 * 8 & 255;
              w.push(String.fromCharCode(E));
            }
            return w.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(y) {
            for (var m = y.length, b = [], w = 0; w < m; w++)
              b[w >>> 2] |= (y.charCodeAt(w) & 255) << 24 - w % 4 * 8;
            return new l.init(b, m);
          }
        }, d = v.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(y) {
            try {
              return decodeURIComponent(escape(h.stringify(y)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(y) {
            return h.parse(unescape(encodeURIComponent(y)));
          }
        }, x = o.BufferedBlockAlgorithm = s.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new l.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(y) {
            typeof y == "string" && (y = d.parse(y)), this._data.concat(y), this._nDataBytes += y.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(y) {
            var m, b = this._data, w = b.words, A = b.sigBytes, E = this.blockSize, N = E * 4, C = A / N;
            y ? C = n.ceil(C) : C = n.max((C | 0) - this._minBufferSize, 0);
            var D = C * E, B = n.min(D * 4, A);
            if (D) {
              for (var S = 0; S < D; S += E)
                this._doProcessBlock(w, S);
              m = w.splice(0, D), b.sigBytes -= B;
            }
            return new l.init(m, B);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var y = s.clone.call(this);
            return y._data = this._data.clone(), y;
          },
          _minBufferSize: 0
        });
        o.Hasher = x.extend({
          /**
           * Configuration options.
           */
          cfg: s.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(y) {
            this.cfg = this.cfg.extend(y), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            x.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(y) {
            return this._append(y), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(y) {
            y && this._append(y);
            var m = this._doFinalize();
            return m;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(y) {
            return function(m, b) {
              return new y.init(b).finalize(m);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(y) {
            return function(m, b) {
              return new g.HMAC.init(y, b).finalize(m);
            };
          }
        });
        var g = c.algo = {};
        return c;
      }(Math);
      return t;
    });
  }(xd)), xd.exports;
}
var yd = { exports: {} }, u1;
function tu() {
  return u1 || (u1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function(n) {
        var a = t, i = a.lib, u = i.Base, f = i.WordArray, c = a.x64 = {};
        c.Word = u.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(o, s) {
            this.high = o, this.low = s;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), c.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(o, s) {
            o = this.words = o || [], s != n ? this.sigBytes = s : this.sigBytes = o.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var o = this.words, s = o.length, l = [], v = 0; v < s; v++) {
              var p = o[v];
              l.push(p.high), l.push(p.low);
            }
            return f.create(l, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var o = u.clone.call(this), s = o.words = this.words.slice(0), l = s.length, v = 0; v < l; v++)
              s[v] = s[v].clone();
            return o;
          }
        });
      }(), t;
    });
  }(yd)), yd.exports;
}
var Ad = { exports: {} }, c1;
function mN() {
  return c1 || (c1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var n = t, a = n.lib, i = a.WordArray, u = i.init, f = i.init = function(c) {
            if (c instanceof ArrayBuffer && (c = new Uint8Array(c)), (c instanceof Int8Array || typeof Uint8ClampedArray < "u" && c instanceof Uint8ClampedArray || c instanceof Int16Array || c instanceof Uint16Array || c instanceof Int32Array || c instanceof Uint32Array || c instanceof Float32Array || c instanceof Float64Array) && (c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength)), c instanceof Uint8Array) {
              for (var o = c.byteLength, s = [], l = 0; l < o; l++)
                s[l >>> 2] |= c[l] << 24 - l % 4 * 8;
              u.call(this, s, o);
            } else
              u.apply(this, arguments);
          };
          f.prototype = i;
        }
      }(), t.lib.WordArray;
    });
  }(Ad)), Ad.exports;
}
var bd = { exports: {} }, l1;
function hN() {
  return l1 || (l1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = n.enc;
        u.Utf16 = u.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(c) {
            for (var o = c.words, s = c.sigBytes, l = [], v = 0; v < s; v += 2) {
              var p = o[v >>> 2] >>> 16 - v % 4 * 8 & 65535;
              l.push(String.fromCharCode(p));
            }
            return l.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(c) {
            for (var o = c.length, s = [], l = 0; l < o; l++)
              s[l >>> 1] |= c.charCodeAt(l) << 16 - l % 2 * 16;
            return i.create(s, o * 2);
          }
        }, u.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(c) {
            for (var o = c.words, s = c.sigBytes, l = [], v = 0; v < s; v += 2) {
              var p = f(o[v >>> 2] >>> 16 - v % 4 * 8 & 65535);
              l.push(String.fromCharCode(p));
            }
            return l.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(c) {
            for (var o = c.length, s = [], l = 0; l < o; l++)
              s[l >>> 1] |= f(c.charCodeAt(l) << 16 - l % 2 * 16);
            return i.create(s, o * 2);
          }
        };
        function f(c) {
          return c << 8 & 4278255360 | c >>> 8 & 16711935;
        }
      }(), t.enc.Utf16;
    });
  }(bd)), bd.exports;
}
var wd = { exports: {} }, f1;
function Na() {
  return f1 || (f1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = n.enc;
        u.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(c) {
            var o = c.words, s = c.sigBytes, l = this._map;
            c.clamp();
            for (var v = [], p = 0; p < s; p += 3)
              for (var h = o[p >>> 2] >>> 24 - p % 4 * 8 & 255, d = o[p + 1 >>> 2] >>> 24 - (p + 1) % 4 * 8 & 255, x = o[p + 2 >>> 2] >>> 24 - (p + 2) % 4 * 8 & 255, g = h << 16 | d << 8 | x, y = 0; y < 4 && p + y * 0.75 < s; y++)
                v.push(l.charAt(g >>> 6 * (3 - y) & 63));
            var m = l.charAt(64);
            if (m)
              for (; v.length % 4; )
                v.push(m);
            return v.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(c) {
            var o = c.length, s = this._map, l = this._reverseMap;
            if (!l) {
              l = this._reverseMap = [];
              for (var v = 0; v < s.length; v++)
                l[s.charCodeAt(v)] = v;
            }
            var p = s.charAt(64);
            if (p) {
              var h = c.indexOf(p);
              h !== -1 && (o = h);
            }
            return f(c, o, l);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function f(c, o, s) {
          for (var l = [], v = 0, p = 0; p < o; p++)
            if (p % 4) {
              var h = s[c.charCodeAt(p - 1)] << p % 4 * 2, d = s[c.charCodeAt(p)] >>> 6 - p % 4 * 2, x = h | d;
              l[v >>> 2] |= x << 24 - v % 4 * 8, v++;
            }
          return i.create(l, v);
        }
      }(), t.enc.Base64;
    });
  }(wd)), wd.exports;
}
var Dd = { exports: {} }, v1;
function gN() {
  return v1 || (v1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = n.enc;
        u.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(c, o) {
            o === void 0 && (o = !0);
            var s = c.words, l = c.sigBytes, v = o ? this._safe_map : this._map;
            c.clamp();
            for (var p = [], h = 0; h < l; h += 3)
              for (var d = s[h >>> 2] >>> 24 - h % 4 * 8 & 255, x = s[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, g = s[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, y = d << 16 | x << 8 | g, m = 0; m < 4 && h + m * 0.75 < l; m++)
                p.push(v.charAt(y >>> 6 * (3 - m) & 63));
            var b = v.charAt(64);
            if (b)
              for (; p.length % 4; )
                p.push(b);
            return p.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(c, o) {
            o === void 0 && (o = !0);
            var s = c.length, l = o ? this._safe_map : this._map, v = this._reverseMap;
            if (!v) {
              v = this._reverseMap = [];
              for (var p = 0; p < l.length; p++)
                v[l.charCodeAt(p)] = p;
            }
            var h = l.charAt(64);
            if (h) {
              var d = c.indexOf(h);
              d !== -1 && (s = d);
            }
            return f(c, s, v);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function f(c, o, s) {
          for (var l = [], v = 0, p = 0; p < o; p++)
            if (p % 4) {
              var h = s[c.charCodeAt(p - 1)] << p % 4 * 2, d = s[c.charCodeAt(p)] >>> 6 - p % 4 * 2, x = h | d;
              l[v >>> 2] |= x << 24 - v % 4 * 8, v++;
            }
          return i.create(l, v);
        }
      }(), t.enc.Base64url;
    });
  }(Dd)), Dd.exports;
}
var Cd = { exports: {} }, p1;
function Ba() {
  return p1 || (p1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function(n) {
        var a = t, i = a.lib, u = i.WordArray, f = i.Hasher, c = a.algo, o = [];
        (function() {
          for (var d = 0; d < 64; d++)
            o[d] = n.abs(n.sin(d + 1)) * 4294967296 | 0;
        })();
        var s = c.MD5 = f.extend({
          _doReset: function() {
            this._hash = new u.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(d, x) {
            for (var g = 0; g < 16; g++) {
              var y = x + g, m = d[y];
              d[y] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360;
            }
            var b = this._hash.words, w = d[x + 0], A = d[x + 1], E = d[x + 2], N = d[x + 3], C = d[x + 4], D = d[x + 5], B = d[x + 6], S = d[x + 7], F = d[x + 8], I = d[x + 9], z = d[x + 10], P = d[x + 11], M = d[x + 12], H = d[x + 13], O = d[x + 14], Q = d[x + 15], k = b[0], L = b[1], R = b[2], X = b[3];
            k = l(k, L, R, X, w, 7, o[0]), X = l(X, k, L, R, A, 12, o[1]), R = l(R, X, k, L, E, 17, o[2]), L = l(L, R, X, k, N, 22, o[3]), k = l(k, L, R, X, C, 7, o[4]), X = l(X, k, L, R, D, 12, o[5]), R = l(R, X, k, L, B, 17, o[6]), L = l(L, R, X, k, S, 22, o[7]), k = l(k, L, R, X, F, 7, o[8]), X = l(X, k, L, R, I, 12, o[9]), R = l(R, X, k, L, z, 17, o[10]), L = l(L, R, X, k, P, 22, o[11]), k = l(k, L, R, X, M, 7, o[12]), X = l(X, k, L, R, H, 12, o[13]), R = l(R, X, k, L, O, 17, o[14]), L = l(L, R, X, k, Q, 22, o[15]), k = v(k, L, R, X, A, 5, o[16]), X = v(X, k, L, R, B, 9, o[17]), R = v(R, X, k, L, P, 14, o[18]), L = v(L, R, X, k, w, 20, o[19]), k = v(k, L, R, X, D, 5, o[20]), X = v(X, k, L, R, z, 9, o[21]), R = v(R, X, k, L, Q, 14, o[22]), L = v(L, R, X, k, C, 20, o[23]), k = v(k, L, R, X, I, 5, o[24]), X = v(X, k, L, R, O, 9, o[25]), R = v(R, X, k, L, N, 14, o[26]), L = v(L, R, X, k, F, 20, o[27]), k = v(k, L, R, X, H, 5, o[28]), X = v(X, k, L, R, E, 9, o[29]), R = v(R, X, k, L, S, 14, o[30]), L = v(L, R, X, k, M, 20, o[31]), k = p(k, L, R, X, D, 4, o[32]), X = p(X, k, L, R, F, 11, o[33]), R = p(R, X, k, L, P, 16, o[34]), L = p(L, R, X, k, O, 23, o[35]), k = p(k, L, R, X, A, 4, o[36]), X = p(X, k, L, R, C, 11, o[37]), R = p(R, X, k, L, S, 16, o[38]), L = p(L, R, X, k, z, 23, o[39]), k = p(k, L, R, X, H, 4, o[40]), X = p(X, k, L, R, w, 11, o[41]), R = p(R, X, k, L, N, 16, o[42]), L = p(L, R, X, k, B, 23, o[43]), k = p(k, L, R, X, I, 4, o[44]), X = p(X, k, L, R, M, 11, o[45]), R = p(R, X, k, L, Q, 16, o[46]), L = p(L, R, X, k, E, 23, o[47]), k = h(k, L, R, X, w, 6, o[48]), X = h(X, k, L, R, S, 10, o[49]), R = h(R, X, k, L, O, 15, o[50]), L = h(L, R, X, k, D, 21, o[51]), k = h(k, L, R, X, M, 6, o[52]), X = h(X, k, L, R, N, 10, o[53]), R = h(R, X, k, L, z, 15, o[54]), L = h(L, R, X, k, A, 21, o[55]), k = h(k, L, R, X, F, 6, o[56]), X = h(X, k, L, R, Q, 10, o[57]), R = h(R, X, k, L, B, 15, o[58]), L = h(L, R, X, k, H, 21, o[59]), k = h(k, L, R, X, C, 6, o[60]), X = h(X, k, L, R, P, 10, o[61]), R = h(R, X, k, L, E, 15, o[62]), L = h(L, R, X, k, I, 21, o[63]), b[0] = b[0] + k | 0, b[1] = b[1] + L | 0, b[2] = b[2] + R | 0, b[3] = b[3] + X | 0;
          },
          _doFinalize: function() {
            var d = this._data, x = d.words, g = this._nDataBytes * 8, y = d.sigBytes * 8;
            x[y >>> 5] |= 128 << 24 - y % 32;
            var m = n.floor(g / 4294967296), b = g;
            x[(y + 64 >>> 9 << 4) + 15] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, x[(y + 64 >>> 9 << 4) + 14] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, d.sigBytes = (x.length + 1) * 4, this._process();
            for (var w = this._hash, A = w.words, E = 0; E < 4; E++) {
              var N = A[E];
              A[E] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360;
            }
            return w;
          },
          clone: function() {
            var d = f.clone.call(this);
            return d._hash = this._hash.clone(), d;
          }
        });
        function l(d, x, g, y, m, b, w) {
          var A = d + (x & g | ~x & y) + m + w;
          return (A << b | A >>> 32 - b) + x;
        }
        function v(d, x, g, y, m, b, w) {
          var A = d + (x & y | g & ~y) + m + w;
          return (A << b | A >>> 32 - b) + x;
        }
        function p(d, x, g, y, m, b, w) {
          var A = d + (x ^ g ^ y) + m + w;
          return (A << b | A >>> 32 - b) + x;
        }
        function h(d, x, g, y, m, b, w) {
          var A = d + (g ^ (x | ~y)) + m + w;
          return (A << b | A >>> 32 - b) + x;
        }
        a.MD5 = f._createHelper(s), a.HmacMD5 = f._createHmacHelper(s);
      }(Math), t.MD5;
    });
  }(Cd)), Cd.exports;
}
var Ed = { exports: {} }, d1;
function Yw() {
  return d1 || (d1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = a.Hasher, f = n.algo, c = [], o = f.SHA1 = u.extend({
          _doReset: function() {
            this._hash = new i.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(s, l) {
            for (var v = this._hash.words, p = v[0], h = v[1], d = v[2], x = v[3], g = v[4], y = 0; y < 80; y++) {
              if (y < 16)
                c[y] = s[l + y] | 0;
              else {
                var m = c[y - 3] ^ c[y - 8] ^ c[y - 14] ^ c[y - 16];
                c[y] = m << 1 | m >>> 31;
              }
              var b = (p << 5 | p >>> 27) + g + c[y];
              y < 20 ? b += (h & d | ~h & x) + 1518500249 : y < 40 ? b += (h ^ d ^ x) + 1859775393 : y < 60 ? b += (h & d | h & x | d & x) - 1894007588 : b += (h ^ d ^ x) - 899497514, g = x, x = d, d = h << 30 | h >>> 2, h = p, p = b;
            }
            v[0] = v[0] + p | 0, v[1] = v[1] + h | 0, v[2] = v[2] + d | 0, v[3] = v[3] + x | 0, v[4] = v[4] + g | 0;
          },
          _doFinalize: function() {
            var s = this._data, l = s.words, v = this._nDataBytes * 8, p = s.sigBytes * 8;
            return l[p >>> 5] |= 128 << 24 - p % 32, l[(p + 64 >>> 9 << 4) + 14] = Math.floor(v / 4294967296), l[(p + 64 >>> 9 << 4) + 15] = v, s.sigBytes = l.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var s = u.clone.call(this);
            return s._hash = this._hash.clone(), s;
          }
        });
        n.SHA1 = u._createHelper(o), n.HmacSHA1 = u._createHmacHelper(o);
      }(), t.SHA1;
    });
  }(Ed)), Ed.exports;
}
var Nd = { exports: {} }, m1;
function Zm() {
  return m1 || (m1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      return function(n) {
        var a = t, i = a.lib, u = i.WordArray, f = i.Hasher, c = a.algo, o = [], s = [];
        (function() {
          function p(g) {
            for (var y = n.sqrt(g), m = 2; m <= y; m++)
              if (!(g % m))
                return !1;
            return !0;
          }
          function h(g) {
            return (g - (g | 0)) * 4294967296 | 0;
          }
          for (var d = 2, x = 0; x < 64; )
            p(d) && (x < 8 && (o[x] = h(n.pow(d, 1 / 2))), s[x] = h(n.pow(d, 1 / 3)), x++), d++;
        })();
        var l = [], v = c.SHA256 = f.extend({
          _doReset: function() {
            this._hash = new u.init(o.slice(0));
          },
          _doProcessBlock: function(p, h) {
            for (var d = this._hash.words, x = d[0], g = d[1], y = d[2], m = d[3], b = d[4], w = d[5], A = d[6], E = d[7], N = 0; N < 64; N++) {
              if (N < 16)
                l[N] = p[h + N] | 0;
              else {
                var C = l[N - 15], D = (C << 25 | C >>> 7) ^ (C << 14 | C >>> 18) ^ C >>> 3, B = l[N - 2], S = (B << 15 | B >>> 17) ^ (B << 13 | B >>> 19) ^ B >>> 10;
                l[N] = D + l[N - 7] + S + l[N - 16];
              }
              var F = b & w ^ ~b & A, I = x & g ^ x & y ^ g & y, z = (x << 30 | x >>> 2) ^ (x << 19 | x >>> 13) ^ (x << 10 | x >>> 22), P = (b << 26 | b >>> 6) ^ (b << 21 | b >>> 11) ^ (b << 7 | b >>> 25), M = E + P + F + s[N] + l[N], H = z + I;
              E = A, A = w, w = b, b = m + M | 0, m = y, y = g, g = x, x = M + H | 0;
            }
            d[0] = d[0] + x | 0, d[1] = d[1] + g | 0, d[2] = d[2] + y | 0, d[3] = d[3] + m | 0, d[4] = d[4] + b | 0, d[5] = d[5] + w | 0, d[6] = d[6] + A | 0, d[7] = d[7] + E | 0;
          },
          _doFinalize: function() {
            var p = this._data, h = p.words, d = this._nDataBytes * 8, x = p.sigBytes * 8;
            return h[x >>> 5] |= 128 << 24 - x % 32, h[(x + 64 >>> 9 << 4) + 14] = n.floor(d / 4294967296), h[(x + 64 >>> 9 << 4) + 15] = d, p.sigBytes = h.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var p = f.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        a.SHA256 = f._createHelper(v), a.HmacSHA256 = f._createHmacHelper(v);
      }(Math), t.SHA256;
    });
  }(Nd)), Nd.exports;
}
var Bd = { exports: {} }, h1;
function xN() {
  return h1 || (h1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Zm());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = n.algo, f = u.SHA256, c = u.SHA224 = f.extend({
          _doReset: function() {
            this._hash = new i.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var o = f._doFinalize.call(this);
            return o.sigBytes -= 4, o;
          }
        });
        n.SHA224 = f._createHelper(c), n.HmacSHA224 = f._createHmacHelper(c);
      }(), t.SHA224;
    });
  }(Bd)), Bd.exports;
}
var Sd = { exports: {} }, g1;
function Zw() {
  return g1 || (g1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), tu());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.Hasher, u = n.x64, f = u.Word, c = u.WordArray, o = n.algo;
        function s() {
          return f.create.apply(f, arguments);
        }
        var l = [
          s(1116352408, 3609767458),
          s(1899447441, 602891725),
          s(3049323471, 3964484399),
          s(3921009573, 2173295548),
          s(961987163, 4081628472),
          s(1508970993, 3053834265),
          s(2453635748, 2937671579),
          s(2870763221, 3664609560),
          s(3624381080, 2734883394),
          s(310598401, 1164996542),
          s(607225278, 1323610764),
          s(1426881987, 3590304994),
          s(1925078388, 4068182383),
          s(2162078206, 991336113),
          s(2614888103, 633803317),
          s(3248222580, 3479774868),
          s(3835390401, 2666613458),
          s(4022224774, 944711139),
          s(264347078, 2341262773),
          s(604807628, 2007800933),
          s(770255983, 1495990901),
          s(1249150122, 1856431235),
          s(1555081692, 3175218132),
          s(1996064986, 2198950837),
          s(2554220882, 3999719339),
          s(2821834349, 766784016),
          s(2952996808, 2566594879),
          s(3210313671, 3203337956),
          s(3336571891, 1034457026),
          s(3584528711, 2466948901),
          s(113926993, 3758326383),
          s(338241895, 168717936),
          s(666307205, 1188179964),
          s(773529912, 1546045734),
          s(1294757372, 1522805485),
          s(1396182291, 2643833823),
          s(1695183700, 2343527390),
          s(1986661051, 1014477480),
          s(2177026350, 1206759142),
          s(2456956037, 344077627),
          s(2730485921, 1290863460),
          s(2820302411, 3158454273),
          s(3259730800, 3505952657),
          s(3345764771, 106217008),
          s(3516065817, 3606008344),
          s(3600352804, 1432725776),
          s(4094571909, 1467031594),
          s(275423344, 851169720),
          s(430227734, 3100823752),
          s(506948616, 1363258195),
          s(659060556, 3750685593),
          s(883997877, 3785050280),
          s(958139571, 3318307427),
          s(1322822218, 3812723403),
          s(1537002063, 2003034995),
          s(1747873779, 3602036899),
          s(1955562222, 1575990012),
          s(2024104815, 1125592928),
          s(2227730452, 2716904306),
          s(2361852424, 442776044),
          s(2428436474, 593698344),
          s(2756734187, 3733110249),
          s(3204031479, 2999351573),
          s(3329325298, 3815920427),
          s(3391569614, 3928383900),
          s(3515267271, 566280711),
          s(3940187606, 3454069534),
          s(4118630271, 4000239992),
          s(116418474, 1914138554),
          s(174292421, 2731055270),
          s(289380356, 3203993006),
          s(460393269, 320620315),
          s(685471733, 587496836),
          s(852142971, 1086792851),
          s(1017036298, 365543100),
          s(1126000580, 2618297676),
          s(1288033470, 3409855158),
          s(1501505948, 4234509866),
          s(1607167915, 987167468),
          s(1816402316, 1246189591)
        ], v = [];
        (function() {
          for (var h = 0; h < 80; h++)
            v[h] = s();
        })();
        var p = o.SHA512 = i.extend({
          _doReset: function() {
            this._hash = new c.init([
              new f.init(1779033703, 4089235720),
              new f.init(3144134277, 2227873595),
              new f.init(1013904242, 4271175723),
              new f.init(2773480762, 1595750129),
              new f.init(1359893119, 2917565137),
              new f.init(2600822924, 725511199),
              new f.init(528734635, 4215389547),
              new f.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(h, d) {
            for (var x = this._hash.words, g = x[0], y = x[1], m = x[2], b = x[3], w = x[4], A = x[5], E = x[6], N = x[7], C = g.high, D = g.low, B = y.high, S = y.low, F = m.high, I = m.low, z = b.high, P = b.low, M = w.high, H = w.low, O = A.high, Q = A.low, k = E.high, L = E.low, R = N.high, X = N.low, ae = C, _ = D, re = B, te = S, ne = F, oe = I, le = z, fe = P, ge = M, Be = H, j = O, Y = Q, ie = k, V = L, J = R, $ = X, pe = 0; pe < 80; pe++) {
              var ve, q, G = v[pe];
              if (pe < 16)
                q = G.high = h[d + pe * 2] | 0, ve = G.low = h[d + pe * 2 + 1] | 0;
              else {
                var ee = v[pe - 15], se = ee.high, de = ee.low, me = (se >>> 1 | de << 31) ^ (se >>> 8 | de << 24) ^ se >>> 7, be = (de >>> 1 | se << 31) ^ (de >>> 8 | se << 24) ^ (de >>> 7 | se << 25), xe = v[pe - 2], Ee = xe.high, ye = xe.low, er = (Ee >>> 19 | ye << 13) ^ (Ee << 3 | ye >>> 29) ^ Ee >>> 6, rr = (ye >>> 19 | Ee << 13) ^ (ye << 3 | Ee >>> 29) ^ (ye >>> 6 | Ee << 26), Fe = v[pe - 7], Er = Fe.high, T = Fe.low, K = v[pe - 16], ce = K.high, we = K.low;
                ve = be + T, q = me + Er + (ve >>> 0 < be >>> 0 ? 1 : 0), ve = ve + rr, q = q + er + (ve >>> 0 < rr >>> 0 ? 1 : 0), ve = ve + we, q = q + ce + (ve >>> 0 < we >>> 0 ? 1 : 0), G.high = q, G.low = ve;
              }
              var ze = ge & j ^ ~ge & ie, ke = Be & Y ^ ~Be & V, gt = ae & re ^ ae & ne ^ re & ne, Xi = _ & te ^ _ & oe ^ te & oe, pd = (ae >>> 28 | _ << 4) ^ (ae << 30 | _ >>> 2) ^ (ae << 25 | _ >>> 7), Zo = (_ >>> 28 | ae << 4) ^ (_ << 30 | ae >>> 2) ^ (_ << 25 | ae >>> 7), dd = (ge >>> 14 | Be << 18) ^ (ge >>> 18 | Be << 14) ^ (ge << 23 | Be >>> 9), md = (Be >>> 14 | ge << 18) ^ (Be >>> 18 | ge << 14) ^ (Be << 23 | ge >>> 9), Wo = l[pe], hd = Wo.high, Ko = Wo.low, xt = $ + md, xn = J + dd + (xt >>> 0 < $ >>> 0 ? 1 : 0), xt = xt + ke, xn = xn + ze + (xt >>> 0 < ke >>> 0 ? 1 : 0), xt = xt + Ko, xn = xn + hd + (xt >>> 0 < Ko >>> 0 ? 1 : 0), xt = xt + ve, xn = xn + q + (xt >>> 0 < ve >>> 0 ? 1 : 0), Jo = Zo + Xi, gd = pd + gt + (Jo >>> 0 < Zo >>> 0 ? 1 : 0);
              J = ie, $ = V, ie = j, V = Y, j = ge, Y = Be, Be = fe + xt | 0, ge = le + xn + (Be >>> 0 < fe >>> 0 ? 1 : 0) | 0, le = ne, fe = oe, ne = re, oe = te, re = ae, te = _, _ = xt + Jo | 0, ae = xn + gd + (_ >>> 0 < xt >>> 0 ? 1 : 0) | 0;
            }
            D = g.low = D + _, g.high = C + ae + (D >>> 0 < _ >>> 0 ? 1 : 0), S = y.low = S + te, y.high = B + re + (S >>> 0 < te >>> 0 ? 1 : 0), I = m.low = I + oe, m.high = F + ne + (I >>> 0 < oe >>> 0 ? 1 : 0), P = b.low = P + fe, b.high = z + le + (P >>> 0 < fe >>> 0 ? 1 : 0), H = w.low = H + Be, w.high = M + ge + (H >>> 0 < Be >>> 0 ? 1 : 0), Q = A.low = Q + Y, A.high = O + j + (Q >>> 0 < Y >>> 0 ? 1 : 0), L = E.low = L + V, E.high = k + ie + (L >>> 0 < V >>> 0 ? 1 : 0), X = N.low = X + $, N.high = R + J + (X >>> 0 < $ >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var h = this._data, d = h.words, x = this._nDataBytes * 8, g = h.sigBytes * 8;
            d[g >>> 5] |= 128 << 24 - g % 32, d[(g + 128 >>> 10 << 5) + 30] = Math.floor(x / 4294967296), d[(g + 128 >>> 10 << 5) + 31] = x, h.sigBytes = d.length * 4, this._process();
            var y = this._hash.toX32();
            return y;
          },
          clone: function() {
            var h = i.clone.call(this);
            return h._hash = this._hash.clone(), h;
          },
          blockSize: 1024 / 32
        });
        n.SHA512 = i._createHelper(p), n.HmacSHA512 = i._createHmacHelper(p);
      }(), t.SHA512;
    });
  }(Sd)), Sd.exports;
}
var Pd = { exports: {} }, x1;
function yN() {
  return x1 || (x1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), tu(), Zw());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.x64, i = a.Word, u = a.WordArray, f = n.algo, c = f.SHA512, o = f.SHA384 = c.extend({
          _doReset: function() {
            this._hash = new u.init([
              new i.init(3418070365, 3238371032),
              new i.init(1654270250, 914150663),
              new i.init(2438529370, 812702999),
              new i.init(355462360, 4144912697),
              new i.init(1731405415, 4290775857),
              new i.init(2394180231, 1750603025),
              new i.init(3675008525, 1694076839),
              new i.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var s = c._doFinalize.call(this);
            return s.sigBytes -= 16, s;
          }
        });
        n.SHA384 = c._createHelper(o), n.HmacSHA384 = c._createHmacHelper(o);
      }(), t.SHA384;
    });
  }(Pd)), Pd.exports;
}
var Md = { exports: {} }, y1;
function AN() {
  return y1 || (y1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), tu());
    })(qe, function(t) {
      return function(n) {
        var a = t, i = a.lib, u = i.WordArray, f = i.Hasher, c = a.x64, o = c.Word, s = a.algo, l = [], v = [], p = [];
        (function() {
          for (var x = 1, g = 0, y = 0; y < 24; y++) {
            l[x + 5 * g] = (y + 1) * (y + 2) / 2 % 64;
            var m = g % 5, b = (2 * x + 3 * g) % 5;
            x = m, g = b;
          }
          for (var x = 0; x < 5; x++)
            for (var g = 0; g < 5; g++)
              v[x + 5 * g] = g + (2 * x + 3 * g) % 5 * 5;
          for (var w = 1, A = 0; A < 24; A++) {
            for (var E = 0, N = 0, C = 0; C < 7; C++) {
              if (w & 1) {
                var D = (1 << C) - 1;
                D < 32 ? N ^= 1 << D : E ^= 1 << D - 32;
              }
              w & 128 ? w = w << 1 ^ 113 : w <<= 1;
            }
            p[A] = o.create(E, N);
          }
        })();
        var h = [];
        (function() {
          for (var x = 0; x < 25; x++)
            h[x] = o.create();
        })();
        var d = s.SHA3 = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: f.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var x = this._state = [], g = 0; g < 25; g++)
              x[g] = new o.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(x, g) {
            for (var y = this._state, m = this.blockSize / 2, b = 0; b < m; b++) {
              var w = x[g + 2 * b], A = x[g + 2 * b + 1];
              w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, A = (A << 8 | A >>> 24) & 16711935 | (A << 24 | A >>> 8) & 4278255360;
              var E = y[b];
              E.high ^= A, E.low ^= w;
            }
            for (var N = 0; N < 24; N++) {
              for (var C = 0; C < 5; C++) {
                for (var D = 0, B = 0, S = 0; S < 5; S++) {
                  var E = y[C + 5 * S];
                  D ^= E.high, B ^= E.low;
                }
                var F = h[C];
                F.high = D, F.low = B;
              }
              for (var C = 0; C < 5; C++)
                for (var I = h[(C + 4) % 5], z = h[(C + 1) % 5], P = z.high, M = z.low, D = I.high ^ (P << 1 | M >>> 31), B = I.low ^ (M << 1 | P >>> 31), S = 0; S < 5; S++) {
                  var E = y[C + 5 * S];
                  E.high ^= D, E.low ^= B;
                }
              for (var H = 1; H < 25; H++) {
                var D, B, E = y[H], O = E.high, Q = E.low, k = l[H];
                k < 32 ? (D = O << k | Q >>> 32 - k, B = Q << k | O >>> 32 - k) : (D = Q << k - 32 | O >>> 64 - k, B = O << k - 32 | Q >>> 64 - k);
                var L = h[v[H]];
                L.high = D, L.low = B;
              }
              var R = h[0], X = y[0];
              R.high = X.high, R.low = X.low;
              for (var C = 0; C < 5; C++)
                for (var S = 0; S < 5; S++) {
                  var H = C + 5 * S, E = y[H], ae = h[H], _ = h[(C + 1) % 5 + 5 * S], re = h[(C + 2) % 5 + 5 * S];
                  E.high = ae.high ^ ~_.high & re.high, E.low = ae.low ^ ~_.low & re.low;
                }
              var E = y[0], te = p[N];
              E.high ^= te.high, E.low ^= te.low;
            }
          },
          _doFinalize: function() {
            var x = this._data, g = x.words;
            this._nDataBytes * 8;
            var y = x.sigBytes * 8, m = this.blockSize * 32;
            g[y >>> 5] |= 1 << 24 - y % 32, g[(n.ceil((y + 1) / m) * m >>> 5) - 1] |= 128, x.sigBytes = g.length * 4, this._process();
            for (var b = this._state, w = this.cfg.outputLength / 8, A = w / 8, E = [], N = 0; N < A; N++) {
              var C = b[N], D = C.high, B = C.low;
              D = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360, B = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360, E.push(B), E.push(D);
            }
            return new u.init(E, w);
          },
          clone: function() {
            for (var x = f.clone.call(this), g = x._state = this._state.slice(0), y = 0; y < 25; y++)
              g[y] = g[y].clone();
            return x;
          }
        });
        a.SHA3 = f._createHelper(d), a.HmacSHA3 = f._createHmacHelper(d);
      }(Math), t.SHA3;
    });
  }(Md)), Md.exports;
}
var Fd = { exports: {} }, A1;
function bN() {
  return A1 || (A1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(n) {
        var a = t, i = a.lib, u = i.WordArray, f = i.Hasher, c = a.algo, o = u.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), s = u.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), l = u.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), v = u.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), p = u.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), h = u.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), d = c.RIPEMD160 = f.extend({
          _doReset: function() {
            this._hash = u.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(A, E) {
            for (var N = 0; N < 16; N++) {
              var C = E + N, D = A[C];
              A[C] = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360;
            }
            var B = this._hash.words, S = p.words, F = h.words, I = o.words, z = s.words, P = l.words, M = v.words, H, O, Q, k, L, R, X, ae, _, re;
            R = H = B[0], X = O = B[1], ae = Q = B[2], _ = k = B[3], re = L = B[4];
            for (var te, N = 0; N < 80; N += 1)
              te = H + A[E + I[N]] | 0, N < 16 ? te += x(O, Q, k) + S[0] : N < 32 ? te += g(O, Q, k) + S[1] : N < 48 ? te += y(O, Q, k) + S[2] : N < 64 ? te += m(O, Q, k) + S[3] : te += b(O, Q, k) + S[4], te = te | 0, te = w(te, P[N]), te = te + L | 0, H = L, L = k, k = w(Q, 10), Q = O, O = te, te = R + A[E + z[N]] | 0, N < 16 ? te += b(X, ae, _) + F[0] : N < 32 ? te += m(X, ae, _) + F[1] : N < 48 ? te += y(X, ae, _) + F[2] : N < 64 ? te += g(X, ae, _) + F[3] : te += x(X, ae, _) + F[4], te = te | 0, te = w(te, M[N]), te = te + re | 0, R = re, re = _, _ = w(ae, 10), ae = X, X = te;
            te = B[1] + Q + _ | 0, B[1] = B[2] + k + re | 0, B[2] = B[3] + L + R | 0, B[3] = B[4] + H + X | 0, B[4] = B[0] + O + ae | 0, B[0] = te;
          },
          _doFinalize: function() {
            var A = this._data, E = A.words, N = this._nDataBytes * 8, C = A.sigBytes * 8;
            E[C >>> 5] |= 128 << 24 - C % 32, E[(C + 64 >>> 9 << 4) + 14] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360, A.sigBytes = (E.length + 1) * 4, this._process();
            for (var D = this._hash, B = D.words, S = 0; S < 5; S++) {
              var F = B[S];
              B[S] = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360;
            }
            return D;
          },
          clone: function() {
            var A = f.clone.call(this);
            return A._hash = this._hash.clone(), A;
          }
        });
        function x(A, E, N) {
          return A ^ E ^ N;
        }
        function g(A, E, N) {
          return A & E | ~A & N;
        }
        function y(A, E, N) {
          return (A | ~E) ^ N;
        }
        function m(A, E, N) {
          return A & N | E & ~N;
        }
        function b(A, E, N) {
          return A ^ (E | ~N);
        }
        function w(A, E) {
          return A << E | A >>> 32 - E;
        }
        a.RIPEMD160 = f._createHelper(d), a.HmacRIPEMD160 = f._createHmacHelper(d);
      }(), t.RIPEMD160;
    });
  }(Fd)), Fd.exports;
}
var Td = { exports: {} }, b1;
function Wm() {
  return b1 || (b1 = 1, function(r, e) {
    (function(t, n) {
      r.exports = n(lr());
    })(qe, function(t) {
      (function() {
        var n = t, a = n.lib, i = a.Base, u = n.enc, f = u.Utf8, c = n.algo;
        c.HMAC = i.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(o, s) {
            o = this._hasher = new o.init(), typeof s == "string" && (s = f.parse(s));
            var l = o.blockSize, v = l * 4;
            s.sigBytes > v && (s = o.finalize(s)), s.clamp();
            for (var p = this._oKey = s.clone(), h = this._iKey = s.clone(), d = p.words, x = h.words, g = 0; g < l; g++)
              d[g] ^= 1549556828, x[g] ^= 909522486;
            p.sigBytes = h.sigBytes = v, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var o = this._hasher;
            o.reset(), o.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(o) {
            return this._hasher.update(o), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(o) {
            var s = this._hasher, l = s.finalize(o);
            s.reset();
            var v = s.finalize(this._oKey.clone().concat(l));
            return v;
          }
        });
      })();
    });
  }(Td)), Td.exports;
}
var Od = { exports: {} }, w1;
function wN() {
  return w1 || (w1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Zm(), Wm());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.Base, u = a.WordArray, f = n.algo, c = f.SHA256, o = f.HMAC, s = f.PBKDF2 = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: c,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(l, v) {
            for (var p = this.cfg, h = o.create(p.hasher, l), d = u.create(), x = u.create([1]), g = d.words, y = x.words, m = p.keySize, b = p.iterations; g.length < m; ) {
              var w = h.update(v).finalize(x);
              h.reset();
              for (var A = w.words, E = A.length, N = w, C = 1; C < b; C++) {
                N = h.finalize(N), h.reset();
                for (var D = N.words, B = 0; B < E; B++)
                  A[B] ^= D[B];
              }
              d.concat(w), y[0]++;
            }
            return d.sigBytes = m * 4, d;
          }
        });
        n.PBKDF2 = function(l, v, p) {
          return s.create(p).compute(l, v);
        };
      }(), t.PBKDF2;
    });
  }(Od)), Od.exports;
}
var zd = { exports: {} }, D1;
function ta() {
  return D1 || (D1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Yw(), Wm());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.Base, u = a.WordArray, f = n.algo, c = f.MD5, o = f.EvpKDF = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: c,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(s) {
            this.cfg = this.cfg.extend(s);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(s, l) {
            for (var v, p = this.cfg, h = p.hasher.create(), d = u.create(), x = d.words, g = p.keySize, y = p.iterations; x.length < g; ) {
              v && h.update(v), v = h.update(s).finalize(l), h.reset();
              for (var m = 1; m < y; m++)
                v = h.finalize(v), h.reset();
              d.concat(v);
            }
            return d.sigBytes = g * 4, d;
          }
        });
        n.EvpKDF = function(s, l, v) {
          return o.create(v).compute(s, l);
        };
      }(), t.EvpKDF;
    });
  }(zd)), zd.exports;
}
var Rd = { exports: {} }, C1;
function Jr() {
  return C1 || (C1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), ta());
    })(qe, function(t) {
      t.lib.Cipher || function(n) {
        var a = t, i = a.lib, u = i.Base, f = i.WordArray, c = i.BufferedBlockAlgorithm, o = a.enc;
        o.Utf8;
        var s = o.Base64, l = a.algo, v = l.EvpKDF, p = i.Cipher = c.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: u.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(D, B) {
            return this.create(this._ENC_XFORM_MODE, D, B);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(D, B) {
            return this.create(this._DEC_XFORM_MODE, D, B);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(D, B, S) {
            this.cfg = this.cfg.extend(S), this._xformMode = D, this._key = B, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            c.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(D) {
            return this._append(D), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(D) {
            D && this._append(D);
            var B = this._doFinalize();
            return B;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function D(B) {
              return typeof B == "string" ? C : A;
            }
            return function(B) {
              return {
                encrypt: function(S, F, I) {
                  return D(F).encrypt(B, S, F, I);
                },
                decrypt: function(S, F, I) {
                  return D(F).decrypt(B, S, F, I);
                }
              };
            };
          }()
        });
        i.StreamCipher = p.extend({
          _doFinalize: function() {
            var D = this._process(!0);
            return D;
          },
          blockSize: 1
        });
        var h = a.mode = {}, d = i.BlockCipherMode = u.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(D, B) {
            return this.Encryptor.create(D, B);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(D, B) {
            return this.Decryptor.create(D, B);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(D, B) {
            this._cipher = D, this._iv = B;
          }
        }), x = h.CBC = function() {
          var D = d.extend();
          D.Encryptor = D.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(S, F) {
              var I = this._cipher, z = I.blockSize;
              B.call(this, S, F, z), I.encryptBlock(S, F), this._prevBlock = S.slice(F, F + z);
            }
          }), D.Decryptor = D.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(S, F) {
              var I = this._cipher, z = I.blockSize, P = S.slice(F, F + z);
              I.decryptBlock(S, F), B.call(this, S, F, z), this._prevBlock = P;
            }
          });
          function B(S, F, I) {
            var z, P = this._iv;
            P ? (z = P, this._iv = n) : z = this._prevBlock;
            for (var M = 0; M < I; M++)
              S[F + M] ^= z[M];
          }
          return D;
        }(), g = a.pad = {}, y = g.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(D, B) {
            for (var S = B * 4, F = S - D.sigBytes % S, I = F << 24 | F << 16 | F << 8 | F, z = [], P = 0; P < F; P += 4)
              z.push(I);
            var M = f.create(z, F);
            D.concat(M);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(D) {
            var B = D.words[D.sigBytes - 1 >>> 2] & 255;
            D.sigBytes -= B;
          }
        };
        i.BlockCipher = p.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: p.cfg.extend({
            mode: x,
            padding: y
          }),
          reset: function() {
            var D;
            p.reset.call(this);
            var B = this.cfg, S = B.iv, F = B.mode;
            this._xformMode == this._ENC_XFORM_MODE ? D = F.createEncryptor : (D = F.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == D ? this._mode.init(this, S && S.words) : (this._mode = D.call(F, this, S && S.words), this._mode.__creator = D);
          },
          _doProcessBlock: function(D, B) {
            this._mode.processBlock(D, B);
          },
          _doFinalize: function() {
            var D, B = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (B.pad(this._data, this.blockSize), D = this._process(!0)) : (D = this._process(!0), B.unpad(D)), D;
          },
          blockSize: 128 / 32
        });
        var m = i.CipherParams = u.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(D) {
            this.mixIn(D);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(D) {
            return (D || this.formatter).stringify(this);
          }
        }), b = a.format = {}, w = b.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(D) {
            var B, S = D.ciphertext, F = D.salt;
            return F ? B = f.create([1398893684, 1701076831]).concat(F).concat(S) : B = S, B.toString(s);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(D) {
            var B, S = s.parse(D), F = S.words;
            return F[0] == 1398893684 && F[1] == 1701076831 && (B = f.create(F.slice(2, 4)), F.splice(0, 4), S.sigBytes -= 16), m.create({ ciphertext: S, salt: B });
          }
        }, A = i.SerializableCipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: u.extend({
            format: w
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(D, B, S, F) {
            F = this.cfg.extend(F);
            var I = D.createEncryptor(S, F), z = I.finalize(B), P = I.cfg;
            return m.create({
              ciphertext: z,
              key: S,
              iv: P.iv,
              algorithm: D,
              mode: P.mode,
              padding: P.padding,
              blockSize: D.blockSize,
              formatter: F.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(D, B, S, F) {
            F = this.cfg.extend(F), B = this._parse(B, F.format);
            var I = D.createDecryptor(S, F).finalize(B.ciphertext);
            return I;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(D, B) {
            return typeof D == "string" ? B.parse(D, this) : D;
          }
        }), E = a.kdf = {}, N = E.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(D, B, S, F, I) {
            if (F || (F = f.random(64 / 8)), I)
              var z = v.create({ keySize: B + S, hasher: I }).compute(D, F);
            else
              var z = v.create({ keySize: B + S }).compute(D, F);
            var P = f.create(z.words.slice(B), S * 4);
            return z.sigBytes = B * 4, m.create({ key: z, iv: P, salt: F });
          }
        }, C = i.PasswordBasedCipher = A.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: A.cfg.extend({
            kdf: N
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(D, B, S, F) {
            F = this.cfg.extend(F);
            var I = F.kdf.execute(S, D.keySize, D.ivSize, F.salt, F.hasher);
            F.iv = I.iv;
            var z = A.encrypt.call(this, D, B, I.key, F);
            return z.mixIn(I), z;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(D, B, S, F) {
            F = this.cfg.extend(F), B = this._parse(B, F.format);
            var I = F.kdf.execute(S, D.keySize, D.ivSize, B.salt, F.hasher);
            F.iv = I.iv;
            var z = A.decrypt.call(this, D, B, I.key, F);
            return z;
          }
        });
      }();
    });
  }(Rd)), Rd.exports;
}
var Id = { exports: {} }, E1;
function DN() {
  return E1 || (E1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.mode.CFB = function() {
        var n = t.lib.BlockCipherMode.extend();
        n.Encryptor = n.extend({
          processBlock: function(i, u) {
            var f = this._cipher, c = f.blockSize;
            a.call(this, i, u, c, f), this._prevBlock = i.slice(u, u + c);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(i, u) {
            var f = this._cipher, c = f.blockSize, o = i.slice(u, u + c);
            a.call(this, i, u, c, f), this._prevBlock = o;
          }
        });
        function a(i, u, f, c) {
          var o, s = this._iv;
          s ? (o = s.slice(0), this._iv = void 0) : o = this._prevBlock, c.encryptBlock(o, 0);
          for (var l = 0; l < f; l++)
            i[u + l] ^= o[l];
        }
        return n;
      }(), t.mode.CFB;
    });
  }(Id)), Id.exports;
}
var Hd = { exports: {} }, N1;
function CN() {
  return N1 || (N1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.mode.CTR = function() {
        var n = t.lib.BlockCipherMode.extend(), a = n.Encryptor = n.extend({
          processBlock: function(i, u) {
            var f = this._cipher, c = f.blockSize, o = this._iv, s = this._counter;
            o && (s = this._counter = o.slice(0), this._iv = void 0);
            var l = s.slice(0);
            f.encryptBlock(l, 0), s[c - 1] = s[c - 1] + 1 | 0;
            for (var v = 0; v < c; v++)
              i[u + v] ^= l[v];
          }
        });
        return n.Decryptor = a, n;
      }(), t.mode.CTR;
    });
  }(Hd)), Hd.exports;
}
var Ld = { exports: {} }, B1;
function EN() {
  return B1 || (B1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return t.mode.CTRGladman = function() {
        var n = t.lib.BlockCipherMode.extend();
        function a(f) {
          if ((f >> 24 & 255) === 255) {
            var c = f >> 16 & 255, o = f >> 8 & 255, s = f & 255;
            c === 255 ? (c = 0, o === 255 ? (o = 0, s === 255 ? s = 0 : ++s) : ++o) : ++c, f = 0, f += c << 16, f += o << 8, f += s;
          } else
            f += 1 << 24;
          return f;
        }
        function i(f) {
          return (f[0] = a(f[0])) === 0 && (f[1] = a(f[1])), f;
        }
        var u = n.Encryptor = n.extend({
          processBlock: function(f, c) {
            var o = this._cipher, s = o.blockSize, l = this._iv, v = this._counter;
            l && (v = this._counter = l.slice(0), this._iv = void 0), i(v);
            var p = v.slice(0);
            o.encryptBlock(p, 0);
            for (var h = 0; h < s; h++)
              f[c + h] ^= p[h];
          }
        });
        return n.Decryptor = u, n;
      }(), t.mode.CTRGladman;
    });
  }(Ld)), Ld.exports;
}
var qd = { exports: {} }, S1;
function NN() {
  return S1 || (S1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.mode.OFB = function() {
        var n = t.lib.BlockCipherMode.extend(), a = n.Encryptor = n.extend({
          processBlock: function(i, u) {
            var f = this._cipher, c = f.blockSize, o = this._iv, s = this._keystream;
            o && (s = this._keystream = o.slice(0), this._iv = void 0), f.encryptBlock(s, 0);
            for (var l = 0; l < c; l++)
              i[u + l] ^= s[l];
          }
        });
        return n.Decryptor = a, n;
      }(), t.mode.OFB;
    });
  }(qd)), qd.exports;
}
var Ud = { exports: {} }, P1;
function BN() {
  return P1 || (P1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.mode.ECB = function() {
        var n = t.lib.BlockCipherMode.extend();
        return n.Encryptor = n.extend({
          processBlock: function(a, i) {
            this._cipher.encryptBlock(a, i);
          }
        }), n.Decryptor = n.extend({
          processBlock: function(a, i) {
            this._cipher.decryptBlock(a, i);
          }
        }), n;
      }(), t.mode.ECB;
    });
  }(Ud)), Ud.exports;
}
var kd = { exports: {} }, M1;
function SN() {
  return M1 || (M1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.pad.AnsiX923 = {
        pad: function(n, a) {
          var i = n.sigBytes, u = a * 4, f = u - i % u, c = i + f - 1;
          n.clamp(), n.words[c >>> 2] |= f << 24 - c % 4 * 8, n.sigBytes += f;
        },
        unpad: function(n) {
          var a = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= a;
        }
      }, t.pad.Ansix923;
    });
  }(kd)), kd.exports;
}
var Xd = { exports: {} }, F1;
function PN() {
  return F1 || (F1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.pad.Iso10126 = {
        pad: function(n, a) {
          var i = a * 4, u = i - n.sigBytes % i;
          n.concat(t.lib.WordArray.random(u - 1)).concat(t.lib.WordArray.create([u << 24], 1));
        },
        unpad: function(n) {
          var a = n.words[n.sigBytes - 1 >>> 2] & 255;
          n.sigBytes -= a;
        }
      }, t.pad.Iso10126;
    });
  }(Xd)), Xd.exports;
}
var jd = { exports: {} }, T1;
function MN() {
  return T1 || (T1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.pad.Iso97971 = {
        pad: function(n, a) {
          n.concat(t.lib.WordArray.create([2147483648], 1)), t.pad.ZeroPadding.pad(n, a);
        },
        unpad: function(n) {
          t.pad.ZeroPadding.unpad(n), n.sigBytes--;
        }
      }, t.pad.Iso97971;
    });
  }(jd)), jd.exports;
}
var Gd = { exports: {} }, O1;
function FN() {
  return O1 || (O1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.pad.ZeroPadding = {
        pad: function(n, a) {
          var i = a * 4;
          n.clamp(), n.sigBytes += i - (n.sigBytes % i || i);
        },
        unpad: function(n) {
          for (var a = n.words, i = n.sigBytes - 1, i = n.sigBytes - 1; i >= 0; i--)
            if (a[i >>> 2] >>> 24 - i % 4 * 8 & 255) {
              n.sigBytes = i + 1;
              break;
            }
        }
      }, t.pad.ZeroPadding;
    });
  }(Gd)), Gd.exports;
}
var Vd = { exports: {} }, z1;
function TN() {
  return z1 || (z1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return t.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, t.pad.NoPadding;
    });
  }(Vd)), Vd.exports;
}
var Qd = { exports: {} }, R1;
function ON() {
  return R1 || (R1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Jr());
    })(qe, function(t) {
      return function(n) {
        var a = t, i = a.lib, u = i.CipherParams, f = a.enc, c = f.Hex, o = a.format;
        o.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(s) {
            return s.ciphertext.toString(c);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(s) {
            var l = c.parse(s);
            return u.create({ ciphertext: l });
          }
        };
      }(), t.format.Hex;
    });
  }(Qd)), Qd.exports;
}
var Yd = { exports: {} }, I1;
function zN() {
  return I1 || (I1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.BlockCipher, u = n.algo, f = [], c = [], o = [], s = [], l = [], v = [], p = [], h = [], d = [], x = [];
        (function() {
          for (var m = [], b = 0; b < 256; b++)
            b < 128 ? m[b] = b << 1 : m[b] = b << 1 ^ 283;
          for (var w = 0, A = 0, b = 0; b < 256; b++) {
            var E = A ^ A << 1 ^ A << 2 ^ A << 3 ^ A << 4;
            E = E >>> 8 ^ E & 255 ^ 99, f[w] = E, c[E] = w;
            var N = m[w], C = m[N], D = m[C], B = m[E] * 257 ^ E * 16843008;
            o[w] = B << 24 | B >>> 8, s[w] = B << 16 | B >>> 16, l[w] = B << 8 | B >>> 24, v[w] = B;
            var B = D * 16843009 ^ C * 65537 ^ N * 257 ^ w * 16843008;
            p[E] = B << 24 | B >>> 8, h[E] = B << 16 | B >>> 16, d[E] = B << 8 | B >>> 24, x[E] = B, w ? (w = N ^ m[m[m[D ^ N]]], A ^= m[m[A]]) : w = A = 1;
          }
        })();
        var g = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], y = u.AES = i.extend({
          _doReset: function() {
            var m;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var b = this._keyPriorReset = this._key, w = b.words, A = b.sigBytes / 4, E = this._nRounds = A + 6, N = (E + 1) * 4, C = this._keySchedule = [], D = 0; D < N; D++)
                D < A ? C[D] = w[D] : (m = C[D - 1], D % A ? A > 6 && D % A == 4 && (m = f[m >>> 24] << 24 | f[m >>> 16 & 255] << 16 | f[m >>> 8 & 255] << 8 | f[m & 255]) : (m = m << 8 | m >>> 24, m = f[m >>> 24] << 24 | f[m >>> 16 & 255] << 16 | f[m >>> 8 & 255] << 8 | f[m & 255], m ^= g[D / A | 0] << 24), C[D] = C[D - A] ^ m);
              for (var B = this._invKeySchedule = [], S = 0; S < N; S++) {
                var D = N - S;
                if (S % 4)
                  var m = C[D];
                else
                  var m = C[D - 4];
                S < 4 || D <= 4 ? B[S] = m : B[S] = p[f[m >>> 24]] ^ h[f[m >>> 16 & 255]] ^ d[f[m >>> 8 & 255]] ^ x[f[m & 255]];
              }
            }
          },
          encryptBlock: function(m, b) {
            this._doCryptBlock(m, b, this._keySchedule, o, s, l, v, f);
          },
          decryptBlock: function(m, b) {
            var w = m[b + 1];
            m[b + 1] = m[b + 3], m[b + 3] = w, this._doCryptBlock(m, b, this._invKeySchedule, p, h, d, x, c);
            var w = m[b + 1];
            m[b + 1] = m[b + 3], m[b + 3] = w;
          },
          _doCryptBlock: function(m, b, w, A, E, N, C, D) {
            for (var B = this._nRounds, S = m[b] ^ w[0], F = m[b + 1] ^ w[1], I = m[b + 2] ^ w[2], z = m[b + 3] ^ w[3], P = 4, M = 1; M < B; M++) {
              var H = A[S >>> 24] ^ E[F >>> 16 & 255] ^ N[I >>> 8 & 255] ^ C[z & 255] ^ w[P++], O = A[F >>> 24] ^ E[I >>> 16 & 255] ^ N[z >>> 8 & 255] ^ C[S & 255] ^ w[P++], Q = A[I >>> 24] ^ E[z >>> 16 & 255] ^ N[S >>> 8 & 255] ^ C[F & 255] ^ w[P++], k = A[z >>> 24] ^ E[S >>> 16 & 255] ^ N[F >>> 8 & 255] ^ C[I & 255] ^ w[P++];
              S = H, F = O, I = Q, z = k;
            }
            var H = (D[S >>> 24] << 24 | D[F >>> 16 & 255] << 16 | D[I >>> 8 & 255] << 8 | D[z & 255]) ^ w[P++], O = (D[F >>> 24] << 24 | D[I >>> 16 & 255] << 16 | D[z >>> 8 & 255] << 8 | D[S & 255]) ^ w[P++], Q = (D[I >>> 24] << 24 | D[z >>> 16 & 255] << 16 | D[S >>> 8 & 255] << 8 | D[F & 255]) ^ w[P++], k = (D[z >>> 24] << 24 | D[S >>> 16 & 255] << 16 | D[F >>> 8 & 255] << 8 | D[I & 255]) ^ w[P++];
            m[b] = H, m[b + 1] = O, m[b + 2] = Q, m[b + 3] = k;
          },
          keySize: 256 / 32
        });
        n.AES = i._createHelper(y);
      }(), t.AES;
    });
  }(Yd)), Yd.exports;
}
var Zd = { exports: {} }, H1;
function RN() {
  return H1 || (H1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.WordArray, u = a.BlockCipher, f = n.algo, c = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], o = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], s = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], l = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], v = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], p = f.DES = u.extend({
          _doReset: function() {
            for (var g = this._key, y = g.words, m = [], b = 0; b < 56; b++) {
              var w = c[b] - 1;
              m[b] = y[w >>> 5] >>> 31 - w % 32 & 1;
            }
            for (var A = this._subKeys = [], E = 0; E < 16; E++) {
              for (var N = A[E] = [], C = s[E], b = 0; b < 24; b++)
                N[b / 6 | 0] |= m[(o[b] - 1 + C) % 28] << 31 - b % 6, N[4 + (b / 6 | 0)] |= m[28 + (o[b + 24] - 1 + C) % 28] << 31 - b % 6;
              N[0] = N[0] << 1 | N[0] >>> 31;
              for (var b = 1; b < 7; b++)
                N[b] = N[b] >>> (b - 1) * 4 + 3;
              N[7] = N[7] << 5 | N[7] >>> 27;
            }
            for (var D = this._invSubKeys = [], b = 0; b < 16; b++)
              D[b] = A[15 - b];
          },
          encryptBlock: function(g, y) {
            this._doCryptBlock(g, y, this._subKeys);
          },
          decryptBlock: function(g, y) {
            this._doCryptBlock(g, y, this._invSubKeys);
          },
          _doCryptBlock: function(g, y, m) {
            this._lBlock = g[y], this._rBlock = g[y + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), d.call(this, 2, 858993459), d.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var b = 0; b < 16; b++) {
              for (var w = m[b], A = this._lBlock, E = this._rBlock, N = 0, C = 0; C < 8; C++)
                N |= l[C][((E ^ w[C]) & v[C]) >>> 0];
              this._lBlock = E, this._rBlock = A ^ N;
            }
            var D = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = D, h.call(this, 1, 1431655765), d.call(this, 8, 16711935), d.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), g[y] = this._lBlock, g[y + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function h(g, y) {
          var m = (this._lBlock >>> g ^ this._rBlock) & y;
          this._rBlock ^= m, this._lBlock ^= m << g;
        }
        function d(g, y) {
          var m = (this._rBlock >>> g ^ this._lBlock) & y;
          this._lBlock ^= m, this._rBlock ^= m << g;
        }
        n.DES = u._createHelper(p);
        var x = f.TripleDES = u.extend({
          _doReset: function() {
            var g = this._key, y = g.words;
            if (y.length !== 2 && y.length !== 4 && y.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var m = y.slice(0, 2), b = y.length < 4 ? y.slice(0, 2) : y.slice(2, 4), w = y.length < 6 ? y.slice(0, 2) : y.slice(4, 6);
            this._des1 = p.createEncryptor(i.create(m)), this._des2 = p.createEncryptor(i.create(b)), this._des3 = p.createEncryptor(i.create(w));
          },
          encryptBlock: function(g, y) {
            this._des1.encryptBlock(g, y), this._des2.decryptBlock(g, y), this._des3.encryptBlock(g, y);
          },
          decryptBlock: function(g, y) {
            this._des3.decryptBlock(g, y), this._des2.encryptBlock(g, y), this._des1.decryptBlock(g, y);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        n.TripleDES = u._createHelper(x);
      }(), t.TripleDES;
    });
  }(Zd)), Zd.exports;
}
var Wd = { exports: {} }, L1;
function IN() {
  return L1 || (L1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.StreamCipher, u = n.algo, f = u.RC4 = i.extend({
          _doReset: function() {
            for (var s = this._key, l = s.words, v = s.sigBytes, p = this._S = [], h = 0; h < 256; h++)
              p[h] = h;
            for (var h = 0, d = 0; h < 256; h++) {
              var x = h % v, g = l[x >>> 2] >>> 24 - x % 4 * 8 & 255;
              d = (d + p[h] + g) % 256;
              var y = p[h];
              p[h] = p[d], p[d] = y;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(s, l) {
            s[l] ^= c.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function c() {
          for (var s = this._S, l = this._i, v = this._j, p = 0, h = 0; h < 4; h++) {
            l = (l + 1) % 256, v = (v + s[l]) % 256;
            var d = s[l];
            s[l] = s[v], s[v] = d, p |= s[(s[l] + s[v]) % 256] << 24 - h * 8;
          }
          return this._i = l, this._j = v, p;
        }
        n.RC4 = i._createHelper(f);
        var o = u.RC4Drop = f.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: f.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            f._doReset.call(this);
            for (var s = this.cfg.drop; s > 0; s--)
              c.call(this);
          }
        });
        n.RC4Drop = i._createHelper(o);
      }(), t.RC4;
    });
  }(Wd)), Wd.exports;
}
var Kd = { exports: {} }, q1;
function HN() {
  return q1 || (q1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.StreamCipher, u = n.algo, f = [], c = [], o = [], s = u.Rabbit = i.extend({
          _doReset: function() {
            for (var v = this._key.words, p = this.cfg.iv, h = 0; h < 4; h++)
              v[h] = (v[h] << 8 | v[h] >>> 24) & 16711935 | (v[h] << 24 | v[h] >>> 8) & 4278255360;
            var d = this._X = [
              v[0],
              v[3] << 16 | v[2] >>> 16,
              v[1],
              v[0] << 16 | v[3] >>> 16,
              v[2],
              v[1] << 16 | v[0] >>> 16,
              v[3],
              v[2] << 16 | v[1] >>> 16
            ], x = this._C = [
              v[2] << 16 | v[2] >>> 16,
              v[0] & 4294901760 | v[1] & 65535,
              v[3] << 16 | v[3] >>> 16,
              v[1] & 4294901760 | v[2] & 65535,
              v[0] << 16 | v[0] >>> 16,
              v[2] & 4294901760 | v[3] & 65535,
              v[1] << 16 | v[1] >>> 16,
              v[3] & 4294901760 | v[0] & 65535
            ];
            this._b = 0;
            for (var h = 0; h < 4; h++)
              l.call(this);
            for (var h = 0; h < 8; h++)
              x[h] ^= d[h + 4 & 7];
            if (p) {
              var g = p.words, y = g[0], m = g[1], b = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, w = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, A = b >>> 16 | w & 4294901760, E = w << 16 | b & 65535;
              x[0] ^= b, x[1] ^= A, x[2] ^= w, x[3] ^= E, x[4] ^= b, x[5] ^= A, x[6] ^= w, x[7] ^= E;
              for (var h = 0; h < 4; h++)
                l.call(this);
            }
          },
          _doProcessBlock: function(v, p) {
            var h = this._X;
            l.call(this), f[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, f[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, f[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, f[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var d = 0; d < 4; d++)
              f[d] = (f[d] << 8 | f[d] >>> 24) & 16711935 | (f[d] << 24 | f[d] >>> 8) & 4278255360, v[p + d] ^= f[d];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function l() {
          for (var v = this._X, p = this._C, h = 0; h < 8; h++)
            c[h] = p[h];
          p[0] = p[0] + 1295307597 + this._b | 0, p[1] = p[1] + 3545052371 + (p[0] >>> 0 < c[0] >>> 0 ? 1 : 0) | 0, p[2] = p[2] + 886263092 + (p[1] >>> 0 < c[1] >>> 0 ? 1 : 0) | 0, p[3] = p[3] + 1295307597 + (p[2] >>> 0 < c[2] >>> 0 ? 1 : 0) | 0, p[4] = p[4] + 3545052371 + (p[3] >>> 0 < c[3] >>> 0 ? 1 : 0) | 0, p[5] = p[5] + 886263092 + (p[4] >>> 0 < c[4] >>> 0 ? 1 : 0) | 0, p[6] = p[6] + 1295307597 + (p[5] >>> 0 < c[5] >>> 0 ? 1 : 0) | 0, p[7] = p[7] + 3545052371 + (p[6] >>> 0 < c[6] >>> 0 ? 1 : 0) | 0, this._b = p[7] >>> 0 < c[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var d = v[h] + p[h], x = d & 65535, g = d >>> 16, y = ((x * x >>> 17) + x * g >>> 15) + g * g, m = ((d & 4294901760) * d | 0) + ((d & 65535) * d | 0);
            o[h] = y ^ m;
          }
          v[0] = o[0] + (o[7] << 16 | o[7] >>> 16) + (o[6] << 16 | o[6] >>> 16) | 0, v[1] = o[1] + (o[0] << 8 | o[0] >>> 24) + o[7] | 0, v[2] = o[2] + (o[1] << 16 | o[1] >>> 16) + (o[0] << 16 | o[0] >>> 16) | 0, v[3] = o[3] + (o[2] << 8 | o[2] >>> 24) + o[1] | 0, v[4] = o[4] + (o[3] << 16 | o[3] >>> 16) + (o[2] << 16 | o[2] >>> 16) | 0, v[5] = o[5] + (o[4] << 8 | o[4] >>> 24) + o[3] | 0, v[6] = o[6] + (o[5] << 16 | o[5] >>> 16) + (o[4] << 16 | o[4] >>> 16) | 0, v[7] = o[7] + (o[6] << 8 | o[6] >>> 24) + o[5] | 0;
        }
        n.Rabbit = i._createHelper(s);
      }(), t.Rabbit;
    });
  }(Kd)), Kd.exports;
}
var Jd = { exports: {} }, U1;
function LN() {
  return U1 || (U1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.StreamCipher, u = n.algo, f = [], c = [], o = [], s = u.RabbitLegacy = i.extend({
          _doReset: function() {
            var v = this._key.words, p = this.cfg.iv, h = this._X = [
              v[0],
              v[3] << 16 | v[2] >>> 16,
              v[1],
              v[0] << 16 | v[3] >>> 16,
              v[2],
              v[1] << 16 | v[0] >>> 16,
              v[3],
              v[2] << 16 | v[1] >>> 16
            ], d = this._C = [
              v[2] << 16 | v[2] >>> 16,
              v[0] & 4294901760 | v[1] & 65535,
              v[3] << 16 | v[3] >>> 16,
              v[1] & 4294901760 | v[2] & 65535,
              v[0] << 16 | v[0] >>> 16,
              v[2] & 4294901760 | v[3] & 65535,
              v[1] << 16 | v[1] >>> 16,
              v[3] & 4294901760 | v[0] & 65535
            ];
            this._b = 0;
            for (var x = 0; x < 4; x++)
              l.call(this);
            for (var x = 0; x < 8; x++)
              d[x] ^= h[x + 4 & 7];
            if (p) {
              var g = p.words, y = g[0], m = g[1], b = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, w = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, A = b >>> 16 | w & 4294901760, E = w << 16 | b & 65535;
              d[0] ^= b, d[1] ^= A, d[2] ^= w, d[3] ^= E, d[4] ^= b, d[5] ^= A, d[6] ^= w, d[7] ^= E;
              for (var x = 0; x < 4; x++)
                l.call(this);
            }
          },
          _doProcessBlock: function(v, p) {
            var h = this._X;
            l.call(this), f[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, f[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, f[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, f[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var d = 0; d < 4; d++)
              f[d] = (f[d] << 8 | f[d] >>> 24) & 16711935 | (f[d] << 24 | f[d] >>> 8) & 4278255360, v[p + d] ^= f[d];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function l() {
          for (var v = this._X, p = this._C, h = 0; h < 8; h++)
            c[h] = p[h];
          p[0] = p[0] + 1295307597 + this._b | 0, p[1] = p[1] + 3545052371 + (p[0] >>> 0 < c[0] >>> 0 ? 1 : 0) | 0, p[2] = p[2] + 886263092 + (p[1] >>> 0 < c[1] >>> 0 ? 1 : 0) | 0, p[3] = p[3] + 1295307597 + (p[2] >>> 0 < c[2] >>> 0 ? 1 : 0) | 0, p[4] = p[4] + 3545052371 + (p[3] >>> 0 < c[3] >>> 0 ? 1 : 0) | 0, p[5] = p[5] + 886263092 + (p[4] >>> 0 < c[4] >>> 0 ? 1 : 0) | 0, p[6] = p[6] + 1295307597 + (p[5] >>> 0 < c[5] >>> 0 ? 1 : 0) | 0, p[7] = p[7] + 3545052371 + (p[6] >>> 0 < c[6] >>> 0 ? 1 : 0) | 0, this._b = p[7] >>> 0 < c[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var d = v[h] + p[h], x = d & 65535, g = d >>> 16, y = ((x * x >>> 17) + x * g >>> 15) + g * g, m = ((d & 4294901760) * d | 0) + ((d & 65535) * d | 0);
            o[h] = y ^ m;
          }
          v[0] = o[0] + (o[7] << 16 | o[7] >>> 16) + (o[6] << 16 | o[6] >>> 16) | 0, v[1] = o[1] + (o[0] << 8 | o[0] >>> 24) + o[7] | 0, v[2] = o[2] + (o[1] << 16 | o[1] >>> 16) + (o[0] << 16 | o[0] >>> 16) | 0, v[3] = o[3] + (o[2] << 8 | o[2] >>> 24) + o[1] | 0, v[4] = o[4] + (o[3] << 16 | o[3] >>> 16) + (o[2] << 16 | o[2] >>> 16) | 0, v[5] = o[5] + (o[4] << 8 | o[4] >>> 24) + o[3] | 0, v[6] = o[6] + (o[5] << 16 | o[5] >>> 16) + (o[4] << 16 | o[4] >>> 16) | 0, v[7] = o[7] + (o[6] << 8 | o[6] >>> 24) + o[5] | 0;
        }
        n.RabbitLegacy = i._createHelper(s);
      }(), t.RabbitLegacy;
    });
  }(Jd)), Jd.exports;
}
var _d = { exports: {} }, k1;
function qN() {
  return k1 || (k1 = 1, function(r, e) {
    (function(t, n, a) {
      r.exports = n(lr(), Na(), Ba(), ta(), Jr());
    })(qe, function(t) {
      return function() {
        var n = t, a = n.lib, i = a.BlockCipher, u = n.algo;
        const f = 16, c = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], o = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var s = {
          pbox: [],
          sbox: []
        };
        function l(x, g) {
          let y = g >> 24 & 255, m = g >> 16 & 255, b = g >> 8 & 255, w = g & 255, A = x.sbox[0][y] + x.sbox[1][m];
          return A = A ^ x.sbox[2][b], A = A + x.sbox[3][w], A;
        }
        function v(x, g, y) {
          let m = g, b = y, w;
          for (let A = 0; A < f; ++A)
            m = m ^ x.pbox[A], b = l(x, m) ^ b, w = m, m = b, b = w;
          return w = m, m = b, b = w, b = b ^ x.pbox[f], m = m ^ x.pbox[f + 1], { left: m, right: b };
        }
        function p(x, g, y) {
          let m = g, b = y, w;
          for (let A = f + 1; A > 1; --A)
            m = m ^ x.pbox[A], b = l(x, m) ^ b, w = m, m = b, b = w;
          return w = m, m = b, b = w, b = b ^ x.pbox[1], m = m ^ x.pbox[0], { left: m, right: b };
        }
        function h(x, g, y) {
          for (let E = 0; E < 4; E++) {
            x.sbox[E] = [];
            for (let N = 0; N < 256; N++)
              x.sbox[E][N] = o[E][N];
          }
          let m = 0;
          for (let E = 0; E < f + 2; E++)
            x.pbox[E] = c[E] ^ g[m], m++, m >= y && (m = 0);
          let b = 0, w = 0, A = 0;
          for (let E = 0; E < f + 2; E += 2)
            A = v(x, b, w), b = A.left, w = A.right, x.pbox[E] = b, x.pbox[E + 1] = w;
          for (let E = 0; E < 4; E++)
            for (let N = 0; N < 256; N += 2)
              A = v(x, b, w), b = A.left, w = A.right, x.sbox[E][N] = b, x.sbox[E][N + 1] = w;
          return !0;
        }
        var d = u.Blowfish = i.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var x = this._keyPriorReset = this._key, g = x.words, y = x.sigBytes / 4;
              h(s, g, y);
            }
          },
          encryptBlock: function(x, g) {
            var y = v(s, x[g], x[g + 1]);
            x[g] = y.left, x[g + 1] = y.right;
          },
          decryptBlock: function(x, g) {
            var y = p(s, x[g], x[g + 1]);
            x[g] = y.left, x[g + 1] = y.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        n.Blowfish = i._createHelper(d);
      }(), t.Blowfish;
    });
  }(_d)), _d.exports;
}
(function(r, e) {
  (function(t, n, a) {
    r.exports = n(lr(), tu(), mN(), hN(), Na(), gN(), Ba(), Yw(), Zm(), xN(), Zw(), yN(), AN(), bN(), Wm(), wN(), ta(), Jr(), DN(), CN(), EN(), NN(), BN(), SN(), PN(), MN(), FN(), TN(), ON(), zN(), RN(), IN(), HN(), LN(), qN());
  })(qe, function(t) {
    return t;
  });
})(Vw);
var UN = Vw.exports;
const _i = /* @__PURE__ */ Ln(UN), kN = navigator.platform, XN = kN.indexOf("Win") === 0, jN = {
  // product: isPc ? 'pc' : 'macdict',
  src: XN ? "deskdict.doctrans" : "macdict.doctrans"
};
function Ww(r) {
  return _i.MD5(r);
}
const GN = "secretKey";
function VN(r = {}) {
  const e = "ydsecret://pc.doctran/sign/=*jn4[84Lns-$Lg]K4o0N2}", t = { ...r };
  t[GN] = e;
  const n = `${t.src}${t.salt}${t.secretKey}${t.content ? t.content : ""}`;
  return [Ww(n)];
}
const { src: Kw } = jN;
console.log(Kw);
function QN(r) {
  const e = {
    // src: 'deskdict.doctrans',
    src: Kw,
    salt: Date.now()
  };
  if (r.docKey && (e.content = r.docKey), r.docKeyArray) {
    const n = JSON.parse(r.docKeyArray)[0];
    e.content = n;
  }
  const [t] = VN(e);
  return Object.assign(e, {
    sign: t
  }, r), delete e.content, e;
}
const YN = {
  md5: Ww,
  paramsAddSign: QN
};
function ZN(r, e) {
  const t = {
    "M+": e.getMonth() + 1,
    // 月份
    "d+": e.getDate(),
    // 日
    "H+": e.getHours(),
    // 小时
    "h+": e.getHours(),
    // 小时
    "m+": e.getMinutes(),
    // 分
    "s+": e.getSeconds(),
    // 秒
    "q+": Math.floor((e.getMonth() + 3) / 3),
    // 季度
    S: e.getMilliseconds()
    // 毫秒
  };
  /(y+)/.test(r) && (r = r.replace(RegExp.$1, (e.getFullYear() + "").substr(4 - RegExp.$1.length)));
  for (let n in t)
    new RegExp("(" + n + ")").test(r) && (r = r.replace(RegExp.$1, RegExp.$1.length === 1 ? t[n] : ("00" + t[n]).substr(("" + t[n]).length)));
  return r;
}
function WN(r) {
  for (var e = window.location.hash.split("?")[1] || "", t = e.split("&"), n = 0; n < t.length; n++) {
    var a = t[n].split("=");
    if (a[0] == r)
      return a[1];
  }
  return !1;
}
function KN(r, e) {
  const t = e || window.location.href, n = r.replace(/[[\]]/g, "\\$&"), i = new RegExp(`[?&]${n}(=([^&#]*)|&|#|$)`).exec(t);
  return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null;
}
function JN() {
  var r = "web";
  return navigator.userAgent.indexOf("youdaodict") > -1 ? r = "mac" : navigator.userAgent.indexOf("windowspc") > -1 && (r = "pc"), r;
}
function _N() {
  const r = "youdao-video-trans", e = (/* @__PURE__ */ new Date()).getTime(), n = `${e}${r}Aje2zbLQbW5mSsDS`;
  return {
    signData: YN.md5(n, "hex"),
    mysticTime: e
  };
}
function $N(r) {
  const e = Math.floor(r / 3600), t = e <= 9 ? `0${e}` : e, n = Math.floor(r / 60 % 60), a = n <= 9 ? `0${n}` : n, i = Math.floor(r % 60), u = i <= 9 ? `0${i}` : i;
  return `${t}:${a}:${u}`;
}
function e5(r) {
  const e = r / 1e3;
  let t = parseInt(e / 3600, 0), n = parseInt(e % 3600 / 60, 0), a = parseInt(e % 60, 0);
  return a < 10 && (a = `0${a}`), n < 10 && (n = `0${n}`), t < 10 && (t = `0${t}`), {
    hour: t,
    minute: n,
    second: a
  };
}
function r5(r) {
  const e = new Date(r), t = e.getFullYear(), n = e.getMonth() + 1, a = e.getDate();
  return `${t}.${n}.${a}`;
}
function t5(r) {
  const e = new Date(r), t = e.getFullYear(), n = e.getMonth() + 1, a = e.getDate();
  return `${t}年${n}月${a}日`;
}
const mr = {
  dateFormat: ZN,
  getQueryVariable: WN,
  getPlatform: JN,
  getAudioSign: _N,
  secondToformat: $N,
  dateFormatHMS: e5,
  formatTimeToYMD: r5,
  formatTimeToCYMD: t5,
  getParameterByName: KN
};
var n5 = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "login" }, [e.isLogin ? t("div", { staticClass: "haved-login" }, [t("div", { staticClass: "user-avatar" }, [t("img", { staticClass: "img", attrs: { src: e.userInfo.userAvatar } })]), t("div", { staticClass: "content" }, [t("div", { staticClass: "user-name", class: e.isSVip || e.isVip || e.slideVipInfo.aipptVip ? "color_text_vip_2" : "color_text_1" }, [e._v(e._s("hi, " + e.userInfo.userName))]), t("div", { staticClass: "content_push", class: e.isSVip || e.isVip || e.slideVipInfo.aipptVip ? "color_text_vip_3" : "color_text_3" }, [!e.isSVip && !e.isVip && !e.slideVipInfo.aipptVip && !n.expire && !n.svipExpire && !n.slideExpire ? t("div", { staticClass: "no-vip" }, [e._v("开通超级会员解锁学习办公最佳翻译搭档")]) : e.isSVip || e.isVip || e.slideVipInfo.aipptVip ? t("div", { staticClass: "no-expire" }, [e.vipInfo.svipTrialing ? t("div", { staticClass: "trial" }, [e._v("已开通免费试用，若未取消将于" + e._s(n.svipTrialExpire) + "自动续费超级会员")]) : t("div", { staticClass: "no-trial" }, [e._v(e._s(n.vipStatusText))])]) : !e.isSVip && !e.isVip && !e.isSlideVip ? t("div", { staticClass: "haved-expire" }, [e._v(e._s(n.hadVipStatusText))]) : e._e()])]), t("div", { staticClass: "button" }, [t("div", { staticClass: "haved-login_button color_text_vip_1", on: { click: n.quit } }, [e._v("退出登录")])])]) : t("div", { staticClass: "no-login" }, [e._m(0), t("div", { staticClass: "button" }, [t("div", { staticClass: "no-login_button color_text_vip_1", on: { click: n.goToLogin } }, [e._v("去登录")])])])]);
}, a5 = [function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "content" }, [e("div", { staticClass: "no-login_content color_text_vip_2" }, [r._v("未登录")]), e("div", { staticClass: "no-login_push color_text_vip_3" }, [r._v("解锁学习办公最佳翻译搭档")])]);
}];
function Rr(r, e, t, n, a, i, u, f) {
  var c = typeof r == "function" ? r.options : r;
  e && (c.render = e, c.staticRenderFns = t, c._compiled = !0), n && (c.functional = !0), i && (c._scopeId = "data-v-" + i);
  var o;
  if (u ? (o = function(v) {
    v = v || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !v && typeof __VUE_SSR_CONTEXT__ < "u" && (v = __VUE_SSR_CONTEXT__), a && a.call(this, v), v && v._registeredComponents && v._registeredComponents.add(u);
  }, c._ssrRegister = o) : a && (o = f ? function() {
    a.call(
      this,
      (c.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), o)
    if (c.functional) {
      c._injectStyles = o;
      var s = c.render;
      c.render = function(p, h) {
        return o.call(h), s(p, h);
      };
    } else {
      var l = c.beforeCreate;
      c.beforeCreate = l ? [].concat(l, o) : [o];
    }
  return {
    exports: r,
    options: c
  };
}
const i5 = {
  __name: "login",
  props: {
    isSVip: Boolean,
    isVip: Boolean,
    isLogin: Boolean,
    userInfo: Object,
    vipInfo: Object,
    slideVipInfo: Object
  },
  setup(r) {
    const e = r, t = ue(
      dr(() => e.vipInfo.expire ? mr.dateFormat("yyyy-MM-dd", new Date(e.vipInfo.expire)) : "")
    ), n = ue(
      dr(() => e.vipInfo.svipExpire ? mr.dateFormat("yyyy-MM-dd", new Date(e.vipInfo.svipExpire)) : "")
    ), a = ue(
      dr(() => e.vipInfo.svipTrialExpire ? mr.dateFormat(
        "yyyy.MM.dd",
        new Date(e.vipInfo.svipTrialExpire)
      ) : "")
    );
    function i() {
      window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${encodeURIComponent(
        window.location.href
      )}&t=${(/* @__PURE__ */ new Date()).getTime()}`;
    }
    function u() {
      const s = encodeURIComponent(window.location.href);
      window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${s}`;
    }
    const f = ue(
      dr(() => e.slideVipInfo.aipptVipExpire ? mr.dateFormat(
        "yyyy-MM-dd",
        new Date(e.slideVipInfo.aipptVipExpire)
      ) : "")
    ), c = dr(() => {
      let s = "";
      return e.isSVip && Xr(n) && (s += `有道翻译超级会员将于${Xr(n)}到期`), e.isVip && Xr(t) && (e.isSVip && Xr(n) && Xr(n) !== Xr(t) ? s += `，有道词典会员将于${Xr(t)}到期` : e.isSVip || (s += `有道词典会员将于${Xr(t)}到期`)), e.slideVipInfo.aipptVip && Xr(f) && (console.log("slideVipInfo"), e.isSVip || e.isVip ? s += `，AIPPT会员将于${Xr(f)}到期` : e.isSVip || (s += `AIPPT会员将于${Xr(f)}到期`)), s;
    }), o = dr(() => {
      if (Xr(n) || Xr(t) || Xr(f))
        return e.vipInfo.svipExpire < e.vipInfo.expire ? `有道词典会员已于${Xr(t)}到期` : e.vipInfo.svipExpire < e.slideVipInfo.aipptVipExpire ? `AIPPT会员已于${Xr(f)}到期` : `有道翻译超级会员已于${Xr(n)}到期`;
    });
    return { __sfc: !0, props: e, expire: t, svipExpire: n, svipTrialExpire: a, goToLogin: i, quit: u, slideExpire: f, vipStatusText: c, hadVipStatusText: o, ref: ue, computed: dr, unref: Xr, util: mr };
  }
};
var o5 = /* @__PURE__ */ Rr(
  i5,
  n5,
  a5,
  !1,
  null,
  "2a4b0e42",
  null,
  null
);
const s5 = o5.exports;
var Km = { exports: {} }, Jw = function(e, t) {
  return function() {
    for (var a = new Array(arguments.length), i = 0; i < a.length; i++)
      a[i] = arguments[i];
    return e.apply(t, a);
  };
}, u5 = Jw, Jm = Object.prototype.toString, _m = function(r) {
  return function(e) {
    var t = Jm.call(e);
    return r[t] || (r[t] = t.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function Sa(r) {
  return r = r.toLowerCase(), function(t) {
    return _m(t) === r;
  };
}
function $m(r) {
  return Array.isArray(r);
}
function Ps(r) {
  return typeof r > "u";
}
function c5(r) {
  return r !== null && !Ps(r) && r.constructor !== null && !Ps(r.constructor) && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
var _w = Sa("ArrayBuffer");
function l5(r) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && _w(r.buffer), e;
}
function f5(r) {
  return typeof r == "string";
}
function v5(r) {
  return typeof r == "number";
}
function $w(r) {
  return r !== null && typeof r == "object";
}
function Es(r) {
  if (_m(r) !== "object")
    return !1;
  var e = Object.getPrototypeOf(r);
  return e === null || e === Object.prototype;
}
var p5 = Sa("Date"), d5 = Sa("File"), m5 = Sa("Blob"), h5 = Sa("FileList");
function eh(r) {
  return Jm.call(r) === "[object Function]";
}
function g5(r) {
  return $w(r) && eh(r.pipe);
}
function x5(r) {
  var e = "[object FormData]";
  return r && (typeof FormData == "function" && r instanceof FormData || Jm.call(r) === e || eh(r.toString) && r.toString() === e);
}
var y5 = Sa("URLSearchParams");
function A5(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function b5() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function rh(r, e) {
  if (!(r === null || typeof r > "u"))
    if (typeof r != "object" && (r = [r]), $m(r))
      for (var t = 0, n = r.length; t < n; t++)
        e.call(null, r[t], t, r);
    else
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && e.call(null, r[a], a, r);
}
function Bm() {
  var r = {};
  function e(a, i) {
    Es(r[i]) && Es(a) ? r[i] = Bm(r[i], a) : Es(a) ? r[i] = Bm({}, a) : $m(a) ? r[i] = a.slice() : r[i] = a;
  }
  for (var t = 0, n = arguments.length; t < n; t++)
    rh(arguments[t], e);
  return r;
}
function w5(r, e, t) {
  return rh(e, function(a, i) {
    t && typeof a == "function" ? r[i] = u5(a, t) : r[i] = a;
  }), r;
}
function D5(r) {
  return r.charCodeAt(0) === 65279 && (r = r.slice(1)), r;
}
function C5(r, e, t, n) {
  r.prototype = Object.create(e.prototype, n), r.prototype.constructor = r, t && Object.assign(r.prototype, t);
}
function E5(r, e, t) {
  var n, a, i, u = {};
  e = e || {};
  do {
    for (n = Object.getOwnPropertyNames(r), a = n.length; a-- > 0; )
      i = n[a], u[i] || (e[i] = r[i], u[i] = !0);
    r = Object.getPrototypeOf(r);
  } while (r && (!t || t(r, e)) && r !== Object.prototype);
  return e;
}
function N5(r, e, t) {
  r = String(r), (t === void 0 || t > r.length) && (t = r.length), t -= e.length;
  var n = r.indexOf(e, t);
  return n !== -1 && n === t;
}
function B5(r) {
  if (!r)
    return null;
  var e = r.length;
  if (Ps(e))
    return null;
  for (var t = new Array(e); e-- > 0; )
    t[e] = r[e];
  return t;
}
var S5 = function(r) {
  return function(e) {
    return r && e instanceof r;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), nt = {
  isArray: $m,
  isArrayBuffer: _w,
  isBuffer: c5,
  isFormData: x5,
  isArrayBufferView: l5,
  isString: f5,
  isNumber: v5,
  isObject: $w,
  isPlainObject: Es,
  isUndefined: Ps,
  isDate: p5,
  isFile: d5,
  isBlob: m5,
  isFunction: eh,
  isStream: g5,
  isURLSearchParams: y5,
  isStandardBrowserEnv: b5,
  forEach: rh,
  merge: Bm,
  extend: w5,
  trim: A5,
  stripBOM: D5,
  inherits: C5,
  toFlatObject: E5,
  kindOf: _m,
  kindOfTest: Sa,
  endsWith: N5,
  toArray: B5,
  isTypedArray: S5,
  isFileList: h5
}, Qa = nt;
function X1(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var e2 = function(e, t, n) {
  if (!t)
    return e;
  var a;
  if (n)
    a = n(t);
  else if (Qa.isURLSearchParams(t))
    a = t.toString();
  else {
    var i = [];
    Qa.forEach(t, function(c, o) {
      c === null || typeof c > "u" || (Qa.isArray(c) ? o = o + "[]" : c = [c], Qa.forEach(c, function(l) {
        Qa.isDate(l) ? l = l.toISOString() : Qa.isObject(l) && (l = JSON.stringify(l)), i.push(X1(o) + "=" + X1(l));
      }));
    }), a = i.join("&");
  }
  if (a) {
    var u = e.indexOf("#");
    u !== -1 && (e = e.slice(0, u)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}, P5 = nt;
function nu() {
  this.handlers = [];
}
nu.prototype.use = function(e, t, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
nu.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
nu.prototype.forEach = function(e) {
  P5.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var M5 = nu, F5 = nt, T5 = function(e, t) {
  F5.forEach(e, function(a, i) {
    i !== t && i.toUpperCase() === t.toUpperCase() && (e[t] = a, delete e[i]);
  });
}, r2 = nt;
function ai(r, e, t, n, a) {
  Error.call(this), this.message = r, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), n && (this.request = n), a && (this.response = a);
}
r2.inherits(ai, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var t2 = ai.prototype, n2 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(r) {
  n2[r] = { value: r };
});
Object.defineProperties(ai, n2);
Object.defineProperty(t2, "isAxiosError", { value: !0 });
ai.from = function(r, e, t, n, a, i) {
  var u = Object.create(t2);
  return r2.toFlatObject(r, u, function(c) {
    return c !== Error.prototype;
  }), ai.call(u, r.message, e, t, n, a), u.name = r.name, i && Object.assign(u, i), u;
};
var pi = ai, a2 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, nn = nt;
function O5(r, e) {
  e = e || new FormData();
  var t = [];
  function n(i) {
    return i === null ? "" : nn.isDate(i) ? i.toISOString() : nn.isArrayBuffer(i) || nn.isTypedArray(i) ? typeof Blob == "function" ? new Blob([i]) : Buffer.from(i) : i;
  }
  function a(i, u) {
    if (nn.isPlainObject(i) || nn.isArray(i)) {
      if (t.indexOf(i) !== -1)
        throw Error("Circular reference detected in " + u);
      t.push(i), nn.forEach(i, function(c, o) {
        if (!nn.isUndefined(c)) {
          var s = u ? u + "." + o : o, l;
          if (c && !u && typeof c == "object") {
            if (nn.endsWith(o, "{}"))
              c = JSON.stringify(c);
            else if (nn.endsWith(o, "[]") && (l = nn.toArray(c))) {
              l.forEach(function(v) {
                !nn.isUndefined(v) && e.append(s, n(v));
              });
              return;
            }
          }
          a(c, s);
        }
      }), t.pop();
    } else
      e.append(u, n(i));
  }
  return a(r), e;
}
var i2 = O5, $d, j1;
function z5() {
  if (j1)
    return $d;
  j1 = 1;
  var r = pi;
  return $d = function(t, n, a) {
    var i = a.config.validateStatus;
    !a.status || !i || i(a.status) ? t(a) : n(new r(
      "Request failed with status code " + a.status,
      [r.ERR_BAD_REQUEST, r.ERR_BAD_RESPONSE][Math.floor(a.status / 100) - 4],
      a.config,
      a.request,
      a
    ));
  }, $d;
}
var em, G1;
function R5() {
  if (G1)
    return em;
  G1 = 1;
  var r = nt;
  return em = r.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(n, a, i, u, f, c) {
          var o = [];
          o.push(n + "=" + encodeURIComponent(a)), r.isNumber(i) && o.push("expires=" + new Date(i).toGMTString()), r.isString(u) && o.push("path=" + u), r.isString(f) && o.push("domain=" + f), c === !0 && o.push("secure"), document.cookie = o.join("; ");
        },
        read: function(n) {
          var a = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return a ? decodeURIComponent(a[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), em;
}
var I5 = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, H5 = function(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}, L5 = I5, q5 = H5, o2 = function(e, t) {
  return e && !L5(t) ? q5(e, t) : t;
}, rm, V1;
function U5() {
  if (V1)
    return rm;
  V1 = 1;
  var r = nt, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return rm = function(n) {
    var a = {}, i, u, f;
    return n && r.forEach(n.split(`
`), function(o) {
      if (f = o.indexOf(":"), i = r.trim(o.substr(0, f)).toLowerCase(), u = r.trim(o.substr(f + 1)), i) {
        if (a[i] && e.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? a[i] = (a[i] ? a[i] : []).concat([u]) : a[i] = a[i] ? a[i] + ", " + u : u;
      }
    }), a;
  }, rm;
}
var tm, Q1;
function k5() {
  if (Q1)
    return tm;
  Q1 = 1;
  var r = nt;
  return tm = r.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), a;
      function i(u) {
        var f = u;
        return t && (n.setAttribute("href", f), f = n.href), n.setAttribute("href", f), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return a = i(window.location.href), function(f) {
        var c = r.isString(f) ? i(f) : f;
        return c.protocol === a.protocol && c.host === a.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), tm;
}
var nm, Y1;
function au() {
  if (Y1)
    return nm;
  Y1 = 1;
  var r = pi, e = nt;
  function t(n) {
    r.call(this, n ?? "canceled", r.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(t, r, {
    __CANCEL__: !0
  }), nm = t, nm;
}
var am, Z1;
function X5() {
  return Z1 || (Z1 = 1, am = function(e) {
    var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
  }), am;
}
var im, W1;
function K1() {
  if (W1)
    return im;
  W1 = 1;
  var r = nt, e = z5(), t = R5(), n = e2, a = o2, i = U5(), u = k5(), f = a2, c = pi, o = au(), s = X5();
  return im = function(v) {
    return new Promise(function(h, d) {
      var x = v.data, g = v.headers, y = v.responseType, m;
      function b() {
        v.cancelToken && v.cancelToken.unsubscribe(m), v.signal && v.signal.removeEventListener("abort", m);
      }
      r.isFormData(x) && r.isStandardBrowserEnv() && delete g["Content-Type"];
      var w = new XMLHttpRequest();
      if (v.auth) {
        var A = v.auth.username || "", E = v.auth.password ? unescape(encodeURIComponent(v.auth.password)) : "";
        g.Authorization = "Basic " + btoa(A + ":" + E);
      }
      var N = a(v.baseURL, v.url);
      w.open(v.method.toUpperCase(), n(N, v.params, v.paramsSerializer), !0), w.timeout = v.timeout;
      function C() {
        if (w) {
          var S = "getAllResponseHeaders" in w ? i(w.getAllResponseHeaders()) : null, F = !y || y === "text" || y === "json" ? w.responseText : w.response, I = {
            data: F,
            status: w.status,
            statusText: w.statusText,
            headers: S,
            config: v,
            request: w
          };
          e(function(P) {
            h(P), b();
          }, function(P) {
            d(P), b();
          }, I), w = null;
        }
      }
      if ("onloadend" in w ? w.onloadend = C : w.onreadystatechange = function() {
        !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(C);
      }, w.onabort = function() {
        w && (d(new c("Request aborted", c.ECONNABORTED, v, w)), w = null);
      }, w.onerror = function() {
        d(new c("Network Error", c.ERR_NETWORK, v, w, w)), w = null;
      }, w.ontimeout = function() {
        var F = v.timeout ? "timeout of " + v.timeout + "ms exceeded" : "timeout exceeded", I = v.transitional || f;
        v.timeoutErrorMessage && (F = v.timeoutErrorMessage), d(new c(
          F,
          I.clarifyTimeoutError ? c.ETIMEDOUT : c.ECONNABORTED,
          v,
          w
        )), w = null;
      }, r.isStandardBrowserEnv()) {
        var D = (v.withCredentials || u(N)) && v.xsrfCookieName ? t.read(v.xsrfCookieName) : void 0;
        D && (g[v.xsrfHeaderName] = D);
      }
      "setRequestHeader" in w && r.forEach(g, function(F, I) {
        typeof x > "u" && I.toLowerCase() === "content-type" ? delete g[I] : w.setRequestHeader(I, F);
      }), r.isUndefined(v.withCredentials) || (w.withCredentials = !!v.withCredentials), y && y !== "json" && (w.responseType = v.responseType), typeof v.onDownloadProgress == "function" && w.addEventListener("progress", v.onDownloadProgress), typeof v.onUploadProgress == "function" && w.upload && w.upload.addEventListener("progress", v.onUploadProgress), (v.cancelToken || v.signal) && (m = function(S) {
        w && (d(!S || S && S.type ? new o() : S), w.abort(), w = null);
      }, v.cancelToken && v.cancelToken.subscribe(m), v.signal && (v.signal.aborted ? m() : v.signal.addEventListener("abort", m))), x || (x = null);
      var B = s(N);
      if (B && ["http", "https", "file"].indexOf(B) === -1) {
        d(new c("Unsupported protocol " + B + ":", c.ERR_BAD_REQUEST, v));
        return;
      }
      w.send(x);
    });
  }, im;
}
var om, J1;
function j5() {
  return J1 || (J1 = 1, om = null), om;
}
var Zr = nt, _1 = T5, $1 = pi, G5 = a2, V5 = i2, Q5 = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function ex(r, e) {
  !Zr.isUndefined(r) && Zr.isUndefined(r["Content-Type"]) && (r["Content-Type"] = e);
}
function Y5() {
  var r;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (r = K1()), r;
}
function Z5(r, e, t) {
  if (Zr.isString(r))
    try {
      return (e || JSON.parse)(r), Zr.trim(r);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(r);
}
var iu = {
  transitional: G5,
  adapter: Y5(),
  transformRequest: [function(e, t) {
    if (_1(t, "Accept"), _1(t, "Content-Type"), Zr.isFormData(e) || Zr.isArrayBuffer(e) || Zr.isBuffer(e) || Zr.isStream(e) || Zr.isFile(e) || Zr.isBlob(e))
      return e;
    if (Zr.isArrayBufferView(e))
      return e.buffer;
    if (Zr.isURLSearchParams(e))
      return ex(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var n = Zr.isObject(e), a = t && t["Content-Type"], i;
    if ((i = Zr.isFileList(e)) || n && a === "multipart/form-data") {
      var u = this.env && this.env.FormData;
      return V5(i ? { "files[]": e } : e, u && new u());
    } else if (n || a === "application/json")
      return ex(t, "application/json"), Z5(e);
    return e;
  }],
  transformResponse: [function(e) {
    var t = this.transitional || iu.transitional, n = t && t.silentJSONParsing, a = t && t.forcedJSONParsing, i = !n && this.responseType === "json";
    if (i || a && Zr.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (u) {
        if (i)
          throw u.name === "SyntaxError" ? $1.from(u, $1.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: j5()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Zr.forEach(["delete", "get", "head"], function(e) {
  iu.headers[e] = {};
});
Zr.forEach(["post", "put", "patch"], function(e) {
  iu.headers[e] = Zr.merge(Q5);
});
var th = iu, W5 = nt, K5 = th, J5 = function(e, t, n) {
  var a = this || K5;
  return W5.forEach(n, function(u) {
    e = u.call(a, e, t);
  }), e;
}, sm, rx;
function s2() {
  return rx || (rx = 1, sm = function(e) {
    return !!(e && e.__CANCEL__);
  }), sm;
}
var tx = nt, um = J5, _5 = s2(), $5 = th, eB = au();
function cm(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new eB();
}
var rB = function(e) {
  cm(e), e.headers = e.headers || {}, e.data = um.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = tx.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), tx.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(a) {
      delete e.headers[a];
    }
  );
  var t = e.adapter || $5.adapter;
  return t(e).then(function(a) {
    return cm(e), a.data = um.call(
      e,
      a.data,
      a.headers,
      e.transformResponse
    ), a;
  }, function(a) {
    return _5(a) || (cm(e), a && a.response && (a.response.data = um.call(
      e,
      a.response.data,
      a.response.headers,
      e.transformResponse
    ))), Promise.reject(a);
  });
}, Ht = nt, u2 = function(e, t) {
  t = t || {};
  var n = {};
  function a(s, l) {
    return Ht.isPlainObject(s) && Ht.isPlainObject(l) ? Ht.merge(s, l) : Ht.isPlainObject(l) ? Ht.merge({}, l) : Ht.isArray(l) ? l.slice() : l;
  }
  function i(s) {
    if (Ht.isUndefined(t[s])) {
      if (!Ht.isUndefined(e[s]))
        return a(void 0, e[s]);
    } else
      return a(e[s], t[s]);
  }
  function u(s) {
    if (!Ht.isUndefined(t[s]))
      return a(void 0, t[s]);
  }
  function f(s) {
    if (Ht.isUndefined(t[s])) {
      if (!Ht.isUndefined(e[s]))
        return a(void 0, e[s]);
    } else
      return a(void 0, t[s]);
  }
  function c(s) {
    if (s in t)
      return a(e[s], t[s]);
    if (s in e)
      return a(void 0, e[s]);
  }
  var o = {
    url: u,
    method: u,
    data: u,
    baseURL: f,
    transformRequest: f,
    transformResponse: f,
    paramsSerializer: f,
    timeout: f,
    timeoutMessage: f,
    withCredentials: f,
    adapter: f,
    responseType: f,
    xsrfCookieName: f,
    xsrfHeaderName: f,
    onUploadProgress: f,
    onDownloadProgress: f,
    decompress: f,
    maxContentLength: f,
    maxBodyLength: f,
    beforeRedirect: f,
    transport: f,
    httpAgent: f,
    httpsAgent: f,
    cancelToken: f,
    socketPath: f,
    responseEncoding: f,
    validateStatus: c
  };
  return Ht.forEach(Object.keys(e).concat(Object.keys(t)), function(l) {
    var v = o[l] || i, p = v(l);
    Ht.isUndefined(p) && v !== c || (n[l] = p);
  }), n;
}, lm, nx;
function c2() {
  return nx || (nx = 1, lm = {
    version: "0.27.2"
  }), lm;
}
var tB = c2().version, Wn = pi, nh = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(r, e) {
  nh[r] = function(n) {
    return typeof n === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
var ax = {};
nh.transitional = function(e, t, n) {
  function a(i, u) {
    return "[Axios v" + tB + "] Transitional option '" + i + "'" + u + (n ? ". " + n : "");
  }
  return function(i, u, f) {
    if (e === !1)
      throw new Wn(
        a(u, " has been removed" + (t ? " in " + t : "")),
        Wn.ERR_DEPRECATED
      );
    return t && !ax[u] && (ax[u] = !0, console.warn(
      a(
        u,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(i, u, f) : !0;
  };
};
function nB(r, e, t) {
  if (typeof r != "object")
    throw new Wn("options must be an object", Wn.ERR_BAD_OPTION_VALUE);
  for (var n = Object.keys(r), a = n.length; a-- > 0; ) {
    var i = n[a], u = e[i];
    if (u) {
      var f = r[i], c = f === void 0 || u(f, i, r);
      if (c !== !0)
        throw new Wn("option " + i + " must be " + c, Wn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Wn("Unknown option " + i, Wn.ERR_BAD_OPTION);
  }
}
var aB = {
  assertOptions: nB,
  validators: nh
}, l2 = nt, iB = e2, ix = M5, ox = rB, ou = u2, oB = o2, f2 = aB, Ya = f2.validators;
function ii(r) {
  this.defaults = r, this.interceptors = {
    request: new ix(),
    response: new ix()
  };
}
ii.prototype.request = function(e, t) {
  typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = ou(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var n = t.transitional;
  n !== void 0 && f2.assertOptions(n, {
    silentJSONParsing: Ya.transitional(Ya.boolean),
    forcedJSONParsing: Ya.transitional(Ya.boolean),
    clarifyTimeoutError: Ya.transitional(Ya.boolean)
  }, !1);
  var a = [], i = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(t) === !1 || (i = i && p.synchronous, a.unshift(p.fulfilled, p.rejected));
  });
  var u = [];
  this.interceptors.response.forEach(function(p) {
    u.push(p.fulfilled, p.rejected);
  });
  var f;
  if (!i) {
    var c = [ox, void 0];
    for (Array.prototype.unshift.apply(c, a), c = c.concat(u), f = Promise.resolve(t); c.length; )
      f = f.then(c.shift(), c.shift());
    return f;
  }
  for (var o = t; a.length; ) {
    var s = a.shift(), l = a.shift();
    try {
      o = s(o);
    } catch (v) {
      l(v);
      break;
    }
  }
  try {
    f = ox(o);
  } catch (v) {
    return Promise.reject(v);
  }
  for (; u.length; )
    f = f.then(u.shift(), u.shift());
  return f;
};
ii.prototype.getUri = function(e) {
  e = ou(this.defaults, e);
  var t = oB(e.baseURL, e.url);
  return iB(t, e.params, e.paramsSerializer);
};
l2.forEach(["delete", "get", "head", "options"], function(e) {
  ii.prototype[e] = function(t, n) {
    return this.request(ou(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
l2.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(i, u, f) {
      return this.request(ou(f || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: u
      }));
    };
  }
  ii.prototype[e] = t(), ii.prototype[e + "Form"] = t(!0);
});
var sB = ii, fm, sx;
function uB() {
  if (sx)
    return fm;
  sx = 1;
  var r = au();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(u) {
      n = u;
    });
    var a = this;
    this.promise.then(function(i) {
      if (a._listeners) {
        var u, f = a._listeners.length;
        for (u = 0; u < f; u++)
          a._listeners[u](i);
        a._listeners = null;
      }
    }), this.promise.then = function(i) {
      var u, f = new Promise(function(c) {
        a.subscribe(c), u = c;
      }).then(i);
      return f.cancel = function() {
        a.unsubscribe(u);
      }, f;
    }, t(function(u) {
      a.reason || (a.reason = new r(u), n(a.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var a = this._listeners.indexOf(n);
      a !== -1 && this._listeners.splice(a, 1);
    }
  }, e.source = function() {
    var n, a = new e(function(u) {
      n = u;
    });
    return {
      token: a,
      cancel: n
    };
  }, fm = e, fm;
}
var vm, ux;
function cB() {
  return ux || (ux = 1, vm = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), vm;
}
var pm, cx;
function lB() {
  if (cx)
    return pm;
  cx = 1;
  var r = nt;
  return pm = function(t) {
    return r.isObject(t) && t.isAxiosError === !0;
  }, pm;
}
var lx = nt, fB = Jw, Ns = sB, vB = u2, pB = th;
function v2(r) {
  var e = new Ns(r), t = fB(Ns.prototype.request, e);
  return lx.extend(t, Ns.prototype, e), lx.extend(t, e), t.create = function(a) {
    return v2(vB(r, a));
  }, t;
}
var Ft = v2(pB);
Ft.Axios = Ns;
Ft.CanceledError = au();
Ft.CancelToken = uB();
Ft.isCancel = s2();
Ft.VERSION = c2().version;
Ft.toFormData = i2;
Ft.AxiosError = pi;
Ft.Cancel = Ft.CanceledError;
Ft.all = function(e) {
  return Promise.all(e);
};
Ft.spread = cB();
Ft.isAxiosError = lB();
Km.exports = Ft;
Km.exports.default = Ft;
var dB = Km.exports, mB = dB;
const zt = /* @__PURE__ */ Ln(mB), fx = "key", p2 = (r = {}, e) => {
  const t = { ...r };
  Object.keys(t).forEach((i) => {
    t[i] === "" && delete t[i];
  });
  const n = Object.keys(t).sort().filter((i) => t[i] !== void 0);
  n.push(fx), t[fx] = e;
  const a = `${n.map((i) => `${i}=${t[i]}`).join("&")}`;
  return [_i.MD5(a).toString(_i.enc.Hex), n.join(",")];
}, hB = (r, e, t, n, a, i = 1, u = "web", f = 1, c = "web", o = 1, s = 1, l = 1, v = "wifi", p = "abcdefg") => {
  const h = Object.assign({
    product: n,
    appVersion: i,
    // 产品版本
    client: u,
    // 客户端
    mid: f,
    //系统版本
    vendor: c,
    //安装渠道
    screen: o,
    // 设备屏幕
    model: s,
    // 设备型号
    imei: l,
    // 设备国际移动设备识别码
    network: v,
    // 网络
    keyfrom: a,
    // 访问来源
    keyid: t,
    mysticTime: Date.now(),
    yduuid: p
  }, r), [d, x] = p2(h, e);
  return Object.assign(h, {
    sign: d,
    pointParam: x
  }), h;
};
var d2 = {
  genSign: p2,
  genParamV3: hB
};
const gB = {
  dev: {
    VUE_APP_MODE: "prod",
    VUE_APP_SERVICE_URL: "http://backendmarket.inner.youdao.com",
    VUE_APP_VIP_URL: "https://dict.youdao.com/viptest",
    VUE_APP_DICT_URL: "https://dict.youdao.com",
    VUE_APP_FANYI_DOWNLOAD_URL: "https://fanyi-test.youdao.com",
    VUE_APP_DOCSERVICE_URL: "https://doctrans-server-test.youdao.com",
    VUE_APP_BASE_URL: "https://cidian-test.youdao.com",
    VUE_APP_VOICE_URL: "https://media-tran-server-test.youdao.com/dictdesk",
    VUE_APP_SYNCUPLOAD_URL: "https://dict-tongchuan-server-test.youdao.com",
    VUE_APP_CONFIG_URL: "https://api-overmind.youdao.com/openapi/get/luna/dict/dict-common-config/test",
    VUE_APP_MESSAGE_CENTER_URL: "https://dict-message-test.youdao.com",
    VUE_APP_WELFARE_URP: "https://shared.youdao.com/dict/market/unite-member-test/#/",
    VUE_APP_DICTBILL_URL: "https://dict-bill.inner.youdao.com",
    VUE_APP_PPT_URL: "https://aippt.inner.youdao.com",
    VUE_APP_PPT_OVERMIND_URL: "https://api-overmind.youdao.com/openapi/get/luna/dict/luna-front/test/privilege_config"
  },
  prod: {
    VUE_APP_MODE: "production",
    VUE_APP_SERVICE_URL: "https://backendmarket.youdao.com",
    VUE_APP_VIP_URL: "https://dict.youdao.com/vip",
    VUE_APP_DICT_URL: "https://dict.youdao.com",
    VUE_APP_FANYI_DOWNLOAD_URL: "https://fanyi.youdao.com",
    VUE_APP_DOCSERVICE_URL: "https://doctrans-service.youdao.com",
    VUE_APP_BASE_URL: "https://cidian.youdao.com",
    VUE_APP_SYNCUPLOAD_URL: "https://dict-tongchuan-server.youdao.com",
    VUE_APP_VOICE_URL: "https://media-tran-server.youdao.com/dictdesk",
    VUE_APP_CONFIG_URL: "https://api-overmind.youdao.com/openapi/get/luna/dict/dict-common-config/prod",
    VUE_APP_MESSAGE_CENTER_URL: "https://dict.youdao.com",
    VUE_APP_WELFARE_URP: "https://shared.youdao.com/dict/market/unite-member/#/",
    VUE_APP_DICTBILL_URL: "https://dict-bill.youdao.com",
    VUE_APP_PPT_URL: "https://aippt-api.youdao.com",
    VUE_APP_PPT_OVERMIND_URL: "https://api-overmind.youdao.com/openapi/get/luna/dict/luna-front/prod/privilege_config"
  }
}, Lt = {
  serviceUrl: gB
}, $o = Lt.serviceUrl.dev.VUE_APP_SYNCUPLOAD_URL, es = {
  product: "mdict",
  keyId: "tongchuan-server",
  signSecretKey: "W0Lepryz72yOoA#J",
  whiteCodeList: [
    `${$o}/file/list`,
    `${$o}/file/delete`,
    `${$o}/file/rename`,
    `${$o}/user/info`
  ]
}, vx = Lt.serviceUrl.dev.VUE_APP_VIP_URL, rs = {
  product: "webdict",
  keyId: "dict-vip",
  signSecretKey: "PDdE4DR40ACSVW0KBIc3P1jgD31tbihD",
  whiteCodeList: [
    `${vx}/activity/couponinfo/V2`,
    `${vx}/plan/activity/info`
  ]
}, px = Lt.serviceUrl.dev.VUE_APP_DICTBILL_URL, ts = {
  product: "webdict",
  keyId: "dict-bill-server",
  signSecretKey: "ChWW2p7XZVMivnPC0iNwaDxOJyhiKU3P",
  whiteCodeList: [
    `${px}/user/bill/apply`,
    `${px}/user/bill/search`
  ]
}, dx = "key", m2 = (r = {}, e) => {
  const t = { ...r };
  Object.keys(t).forEach((i) => {
    t[i] === "" && delete t[i];
  });
  const n = Object.keys(t).sort().filter((i) => t[i] !== void 0);
  n.push(dx), t[dx] = e;
  const a = `${n.map((i) => `${i}=${t[i]}`).join("&")}`;
  return [_i.MD5(a).toString(_i.enc.Hex), n.join(",")];
}, xB = (r, e, t, n, a, i, u, f, c, o, s, l, v) => {
  const p = {
    product: n,
    appVersion: u || 1,
    // 产品版本
    client: f || "web",
    // 客户端
    mid: c || 1,
    // 系统版本
    vendor: o || "web",
    // 安装渠道
    screen: s || 1,
    // 设备屏幕
    model: l || 1,
    // 设备型号
    imei: v || 1,
    // 设备国际移动设备识别码
    network: "wifi",
    // 网络
    keyfrom: a,
    // 访问来源
    keyid: t,
    mysticTime: Date.now(),
    yduuid: i || "abcdefg",
    ...r
  }, [h, d] = m2(p, e);
  return Object.assign(p, {
    sign: h,
    pointParam: d
  }), p;
}, qt = {
  genSign: m2,
  genParamV3: xB
};
zt.defaults.withCredentials = !0;
zt.defaults.timeout = 1e3 * 10;
function Mr(r, e) {
  return new Promise((t, n) => {
    zt.get(r, {
      params: e
    }).then((a) => {
      t(a.data);
    }).catch((a) => {
      n(a);
    });
  });
}
function h2(r, e) {
  return new Promise((t) => {
    zt.post(r, e).then((n) => {
      t(n.data);
    }).catch((n) => {
      t(n);
    });
  });
}
function di(r, e) {
  const t = e, n = new FormData();
  return Object.keys(t).forEach((a) => {
    n.append(a, t[a]);
  }), new Promise((a, i) => {
    zt.post(r, n).then((u) => {
      a(u.data);
    }).catch((u) => {
      i(u);
    });
  });
}
zt.interceptors.response.use(
  (r) => {
    const { headers: e } = r, t = Object.keys(r.headers).find((n) => n.toLowerCase() === "exceedmaxdevicecnt");
    return (e == null ? void 0 : e[t]) === "true" && Ki.prototype.$CPopup({
      confirmButtonText: "重新登录",
      // 确认按钮文案
      text: "您同时登录的设备数过多，已被挤下线，登录新账号，可继续使用~",
      // 提示信息
      confirm: () => {
        const n = encodeURIComponent(window.location.href);
        window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${n}`;
      },
      cancel: () => {
        const n = encodeURIComponent(window.location.href);
        window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${n}`;
      }
    }), Promise.resolve(r);
  },
  (r) => (console.log("error", r), r.message.includes("timeout") ? (Ki.prototype.$toast("网络连接超时，请稍后重试"), Promise.resolve(r)) : (Ki.prototype.$toast("网络连接超时，请稍后重试"), Promise.resolve(r)))
);
function dm(r = {}) {
  const { method: e, data: t = {}, params: n = {} } = r;
  switch (e.toLowerCase()) {
    case "post":
    case "delete":
    case "put":
      return t;
    case "get":
      return n;
    default:
      return t;
  }
}
function mm(r = {}, e) {
  const { method: t } = r, n = r;
  switch (t.toLowerCase()) {
    case "post":
    case "delete":
    case "get":
      n.params = e;
      break;
    default:
      n.data = e;
      break;
  }
}
zt.interceptors.request.use(
  (r) => {
    if (es.whiteCodeList.indexOf(r.url) !== -1) {
      const e = dm(r), t = d2.genParamV3(e, es.signSecretKey, es.keyId, es.product);
      mm(r, t);
    }
    if (ts.whiteCodeList.some((e) => r.url.indexOf(e) !== -1)) {
      const e = dm(r), {
        yduuid: t,
        keyfrom: n,
        appVersion: a,
        client: i,
        mid: u,
        vendor: f,
        screen: c,
        model: o,
        imei: s
      } = e, l = qt.genParamV3(e, ts.signSecretKey, ts.keyId, ts.product, n, t, a, i, u, f, c, o, s);
      mm(r, l);
    }
    if (rs.whiteCodeList.some((e) => r.url.indexOf(e) !== -1)) {
      const e = dm(r);
      console.log("requestData", e);
      const {
        yduuid: t,
        keyfrom: n,
        appVersion: a,
        client: i,
        mid: u,
        vendor: f,
        screen: c,
        model: o,
        imei: s
      } = e, l = qt.genParamV3(e, rs.signSecretKey, rs.keyId, rs.product, n, t, a, i, u, f, c, o, s);
      mm(r, l);
    }
    return r;
  },
  (r) => {
    Promise.reject(r);
  }
);
const { dev: qn } = Lt.serviceUrl, ft = qn.VUE_APP_VIP_URL, g2 = qn.VUE_APP_DICTBILL_URL, yB = qn.VUE_APP_DOCSERVICE_URL, AB = qn.VUE_APP_VOICE_URL, bB = qn.VUE_APP_SYNCUPLOAD_URL, wB = qn.VUE_APP_CONFIG_URL, io = qn.VUE_APP_MESSAGE_CENTER_URL, x2 = qn.VUE_APP_PPT_URL, DB = qn.VUE_APP_PPT_OVERMIND_URL, CB = (r) => h2(`${ft}/user/status`, r), EB = (r) => Mr(`${ft}/plan/sviplist`, r), NB = (r) => di(`${ft}/pay/order`, r), BB = (r) => di(`${ft}/pay/qrcode`, r), SB = (r) => di(`${ft}/pay/status`, r), PB = (r) => Mr(`${ft}/increase/plans`, r), MB = (r) => Mr(`${yB}/doctrans/vip/getUserVipInfo`, r), FB = (r) => di(`${ft}/pay/verifyCode`, r), TB = (r, e) => Mr(`${AB}/login?sign=${r}&mysticTime=${e}`), OB = (r) => Mr(`${bB}/user/info`, r), zB = () => Mr(`${wB}//fanyiWebsiteHeaderMap`), RB = (r) => Mr(`${ft}/privilege/show`, r), IB = (r) => Mr(`${io}/message/official/list`, r), HB = (r) => Mr(`${io}/message/official/pull`, r), LB = (r) => di(`${io}/message/push`, r), qB = (r) => di(`${io}/message/official/markread`, r), UB = (r) => Mr(`${io}/message/official/unread`, r), kB = (r) => Mr(`${ft}/activity/svip/discount`, r), XB = () => Mr(`${ft}/user/desk/welfare`), jB = (r) => Mr(`${ft}/user/paymentlist`, r), GB = (r) => Mr(`${ft}/user/billlist`, r), VB = (r) => h2(`${g2}/user/bill/apply`, r), QB = (r) => Mr(`${g2}/user/bill/search`, r), YB = (r) => Mr(`${ft}/activity/couponinfo/V2`, r), ZB = (r) => Mr(`${ft}/plan/activity/info`, r), WB = (r) => Mr(`${ft}/plan/aippt/list`, r), KB = (r) => Mr(`${ft}/user/extra/status`, r), JB = (r) => Mr(`${x2}/userRight/remain`, r), _B = (r) => Mr(`${x2}/userRight/storage/usage`, r), $B = () => Mr(DB), Sr = {
  getVipStatus: CB,
  getVipList: EB,
  getPayOrder: NB,
  getQrcode: BB,
  getOrderStatus: SB,
  getPlans: PB,
  getDetailInfo: MB,
  exchangeVipCode: FB,
  getAudioInfo: TB,
  getSyncInfo: OB,
  getHomeBanner: zB,
  privilegeShow: RB,
  getMessageList: IB,
  getMessageDetail: HB,
  pushMessage: LB,
  setMessageRead: qB,
  getMessageUnread: UB,
  getSingleSvipWelfare: kB,
  getWelfareList: XB,
  getPaymentList: jB,
  getBilllist: GB,
  applyBill: VB,
  getBillStatus: QB,
  getCouponInfo: YB,
  getSingleSvipActivity: ZB,
  getSlidePlans: WB,
  getSlideStatus: KB,
  getSLideRemain: JB,
  getSlideStore: _B,
  getPrivilege: $B
}, ns = Lt.serviceUrl.prod.VUE_APP_SYNCUPLOAD_URL, as = {
  product: "mdict",
  keyId: "tongchuan-server",
  signSecretKey: "W0Lepryz72yOoA#J",
  whiteCodeList: [
    `${ns}/file/list`,
    `${ns}/file/delete`,
    `${ns}/file/rename`,
    `${ns}/user/info`
  ]
}, mx = Lt.serviceUrl.prod.VUE_APP_DICTBILL_URL, is = {
  product: "webdict",
  keyId: "dict-bill-server",
  signSecretKey: "ChWW2p7XZVMivnPC0iNwaDxOJyhiKU3P",
  whiteCodeList: [
    `${mx}/user/bill/apply`,
    `${mx}/user/bill/search`
  ]
}, hx = Lt.serviceUrl.prod.VUE_APP_VIP_URL, os = {
  product: "webdict",
  keyId: "dict-vip",
  signSecretKey: "PDdE4DR40ACSVW0KBIc3P1jgD31tbihD",
  whiteCodeList: [
    `${hx}/activity/couponinfo/V2`,
    `${hx}/plan/activity/info`
  ]
};
zt.defaults.withCredentials = !0;
zt.defaults.timeout = 1e3 * 10;
function Fr(r, e) {
  return new Promise((t, n) => {
    zt.get(r, {
      params: e
    }).then((a) => {
      t(a.data);
    }).catch((a) => {
      n(a);
    });
  });
}
function y2(r, e) {
  return new Promise((t) => {
    zt.post(r, e).then((n) => {
      t(n.data);
    }).catch((n) => {
      t(n);
    });
  });
}
function mi(r, e) {
  const t = e, n = new FormData();
  return Object.keys(t).forEach((a) => {
    n.append(a, t[a]);
  }), new Promise((a, i) => {
    zt.post(r, n).then((u) => {
      a(u.data);
    }).catch((u) => {
      i(u);
    });
  });
}
zt.interceptors.response.use(
  (r) => {
    const { headers: e } = r, t = Object.keys(r.headers).find((n) => n.toLowerCase() === "exceedmaxdevicecnt");
    return (e == null ? void 0 : e[t]) === "true" && Ki.prototype.$CPopup({
      confirmButtonText: "重新登录",
      // 确认按钮文案
      text: "您同时登录的设备数过多，已被挤下线，登录新账号，可继续使用~",
      // 提示信息
      confirm: () => {
        const n = encodeURIComponent(window.location.href);
        window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${n}`;
      },
      cancel: () => {
        const n = encodeURIComponent(window.location.href);
        window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${n}`;
      }
    }), Promise.resolve(r);
  },
  (r) => (console.log("error", r), r.message.includes("timeout"), Promise.resolve(r))
);
function hm(r = {}) {
  const { method: e, data: t = {}, params: n = {} } = r;
  switch (e.toLowerCase()) {
    case "post":
    case "delete":
    case "put":
      return t;
    case "get":
      return n;
    default:
      return t;
  }
}
function gm(r = {}, e) {
  const { method: t } = r, n = r;
  switch (t.toLowerCase()) {
    case "post":
    case "delete":
    case "get":
      n.params = e;
      break;
    default:
      n.data = e;
      break;
  }
}
zt.interceptors.request.use(
  (r) => {
    if (as.whiteCodeList.indexOf(r.url) !== -1) {
      const e = hm(r), t = d2.genParamV3(e, as.signSecretKey, as.keyId, as.product);
      gm(r, t);
    }
    if (is.whiteCodeList.some((e) => r.url.indexOf(e) !== -1)) {
      const e = hm(r), {
        yduuid: t,
        keyfrom: n,
        appVersion: a,
        client: i,
        mid: u,
        vendor: f,
        screen: c,
        model: o,
        imei: s
      } = e, l = qt.genParamV3(e, is.signSecretKey, is.keyId, is.product, n, t, a, i, u, f, c, o, s);
      gm(r, l);
    }
    if (os.whiteCodeList.some((e) => r.url.indexOf(e) !== -1)) {
      const e = hm(r);
      console.log("requestData", e);
      const {
        yduuid: t,
        keyfrom: n,
        appVersion: a,
        client: i,
        mid: u,
        vendor: f,
        screen: c,
        model: o,
        imei: s
      } = e, l = qt.genParamV3(e, os.signSecretKey, os.keyId, os.product, n, t, a, i, u, f, c, o, s);
      gm(r, l);
    }
    return r;
  },
  (r) => {
    Promise.reject(r);
  }
);
const { prod: Un } = Lt.serviceUrl, vt = Un.VUE_APP_VIP_URL, A2 = Un.VUE_APP_DICTBILL_URL, e6 = Un.VUE_APP_DOCSERVICE_URL, r6 = Un.VUE_APP_VOICE_URL, t6 = Un.VUE_APP_SYNCUPLOAD_URL, n6 = Un.VUE_APP_CONFIG_URL, oo = Un.VUE_APP_MESSAGE_CENTER_URL, b2 = Un.VUE_APP_PPT_URL, a6 = Un.VUE_APP_PPT_OVERMIND_URL, i6 = (r) => y2(`${vt}/user/status`, r), o6 = (r) => Fr(`${vt}/plan/sviplist`, r), s6 = (r) => mi(`${vt}/pay/order`, r), u6 = (r) => mi(`${vt}/pay/qrcode`, r), c6 = (r) => mi(`${vt}/pay/status`, r), l6 = (r) => Fr(`${vt}/increase/plans`, r), f6 = (r) => Fr(`${e6}/doctrans/vip/getUserVipInfo`, r), v6 = (r) => mi(`${vt}/pay/verifyCode`, r), p6 = (r, e) => Fr(`${r6}/login?sign=${r}&mysticTime=${e}`), d6 = (r) => Fr(`${t6}/user/info`, r), m6 = () => Fr(`${n6}//fanyiWebsiteHeaderMap`), h6 = (r) => Fr(`${vt}/privilege/show`, r), g6 = (r) => Fr(`${oo}/message/official/list`, r), x6 = (r) => Fr(`${oo}/message/official/pull`, r), y6 = (r) => mi(`${oo}/message/push`, r), A6 = (r) => mi(`${oo}/message/official/markread`, r), b6 = (r) => Fr(`${oo}/message/official/unread`, r), w6 = (r) => Fr(`${vt}/activity/svip/discount`, r), D6 = () => Fr(`${vt}/user/desk/welfare`), C6 = (r) => Fr(`${vt}/user/paymentlist`, r), E6 = (r) => Fr(`${vt}/user/billlist`, r), N6 = (r) => y2(`${A2}/user/bill/apply`, r), B6 = (r) => Fr(`${A2}/user/bill/search`, r), S6 = (r) => Fr(`${vt}/activity/couponinfo/V2`, r), P6 = (r) => Fr(`${vt}/plan/activity/info`, r), M6 = (r) => Fr(`${vt}/plan/aippt/list`, r), F6 = (r) => Fr(`${vt}/user/extra/status`, r), T6 = (r) => Fr(`${b2}/userRight/remain`, r), O6 = (r) => Fr(`${b2}/userRight/storage/usage`, r), z6 = () => Fr(a6), Pr = {
  getVipStatus: i6,
  getVipList: o6,
  getPayOrder: s6,
  getQrcode: u6,
  getOrderStatus: c6,
  getPlans: l6,
  getDetailInfo: f6,
  exchangeVipCode: v6,
  getAudioInfo: p6,
  getSyncInfo: d6,
  getHomeBanner: m6,
  privilegeShow: h6,
  getMessageList: g6,
  getMessageDetail: x6,
  pushMessage: y6,
  setMessageRead: A6,
  getMessageUnread: b6,
  getSingleSvipWelfare: w6,
  getWelfareList: D6,
  getPaymentList: C6,
  getBilllist: E6,
  applyBill: N6,
  getBillStatus: B6,
  getCouponInfo: S6,
  getSingleSvipActivity: P6,
  getSlidePlans: M6,
  getSlideStatus: F6,
  getSLideRemain: T6,
  getSlideStore: O6,
  getPrivilege: z6
};
var R6 = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return n.isShow ? t("div", { staticClass: "popUp color_bg_3" }, [t("div", { staticClass: "title color_text_0" }, [e._v("兑换码")]), t("input", { directives: [{ name: "model", rawName: "v-model", value: n.exchangeCode, expression: "exchangeCode" }], staticClass: "input color_divider_2_border", attrs: { placeholder: "请输入超级会员兑换码" }, domProps: { value: n.exchangeCode }, on: { input: function(a) {
    a.target.composing || (n.exchangeCode = a.target.value);
  } } }), t("div", { staticClass: "operation" }, [t("div", { staticClass: "cancel color_text_2", on: { click: n.cancel } }, [e._v("取消")]), t("div", { staticClass: "save color_pc_red color_text_white", on: { click: n.save } }, [e._v("兑换")])])]) : e._e();
}, I6 = [];
const H6 = {
  __name: "exchangePopUp",
  emits: ["exchange"],
  setup(r, { expose: e, emit: t }) {
    const n = ue(!1), a = ue("");
    e({
      showPopUp: i
    });
    function i() {
      n.value = !0, a.value = "";
    }
    function u() {
      n.value = !1;
    }
    function f() {
      t("exchange", a.value);
    }
    return { __sfc: !0, isShow: n, exchangeCode: a, emits: t, showPopUp: i, cancel: u, save: f, ref: ue, computed: dr, watch: Je, onMounted: hr };
  }
};
var L6 = /* @__PURE__ */ Rr(
  H6,
  R6,
  I6,
  !1,
  null,
  "bcae128d",
  null,
  null
);
const w2 = L6.exports;
var D2 = { exports: {} };
(function(r, e) {
  (function(t, n) {
    r.exports = n();
  })(qe, function() {
    return function(t) {
      function n(i) {
        if (a[i])
          return a[i].exports;
        var u = a[i] = { exports: {}, id: i, loaded: !1 };
        return t[i].call(u.exports, u, u.exports, n), u.loaded = !0, u.exports;
      }
      var a = {};
      return n.m = t, n.c = a, n.p = "", n(0);
    }([function(t, n, a) {
      t.exports = a(3);
    }, function(t, n) {
      (function() {
        Object.assign || Object.defineProperty(Object, "assign", { enumerable: !1, configurable: !0, writable: !0, value: function(a) {
          if (a == null)
            throw new TypeError("Cannot convert first argument to object");
          for (var i = Object(a), u = 1; u < arguments.length; u++) {
            var f = arguments[u];
            if (f != null) {
              f = Object(f);
              for (var c = Object.keys(Object(f)), o = 0, s = c.length; o < s; o++) {
                var l = c[o], v = Object.getOwnPropertyDescriptor(f, l);
                v !== void 0 && v.enumerable && (i[l] = f[l]);
              }
            }
          }
          return i;
        } });
      })();
    }, function(t, n) {
      t.exports = function() {
        var a = {};
        return a.utf16to8 = function(i) {
          var u, f, c, o;
          for (u = "", c = i.length, f = 0; f < c; f++)
            o = i.charCodeAt(f), o >= 1 && o <= 127 ? u += i.charAt(f) : o > 2047 ? (u += String.fromCharCode(224 | o >> 12 & 15), u += String.fromCharCode(128 | o >> 6 & 63), u += String.fromCharCode(128 | o >> 0 & 63)) : (u += String.fromCharCode(192 | o >> 6 & 31), u += String.fromCharCode(128 | o >> 0 & 63));
          return u;
        }, a.utf8to16 = function(i) {
          var u, f, c, o, s, l;
          for (u = "", c = i.length, f = 0; f < c; )
            switch (o = i.charCodeAt(f++), o >> 4) {
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
                u += i.charAt(f - 1);
                break;
              case 12:
              case 13:
                s = i.charCodeAt(f++), u += String.fromCharCode((31 & o) << 6 | 63 & s);
                break;
              case 14:
                s = i.charCodeAt(f++), l = i.charCodeAt(f++), u += String.fromCharCode((15 & o) << 12 | (63 & s) << 6 | (63 & l) << 0);
            }
          return u;
        }, a;
      }();
    }, function(t, n, a) {
      a(1), a(4);
      var i = a(2), u = function() {
        function f(o) {
          var s = new QRCode(o.typeNumber, o.correctLevel);
          s.addData(o.text), s.make();
          var l = document.createElement("canvas");
          l.width = o.width, l.height = o.height;
          var v = l.getContext("2d"), p = (o.width - 2 * o.padding) / s.getModuleCount(), h = (o.height - 2 * o.padding) / s.getModuleCount();
          if (o.reverse) {
            var d = "rgba(0, 0, 0, 0)";
            v.fillStyle = d, o.foreground = d;
          } else
            v.fillStyle = o.background;
          v.fillRect(0, 0, l.width, l.height);
          for (var x = 0; x < s.getModuleCount(); x++)
            for (var g = 0; g < s.getModuleCount(); g++) {
              v.fillStyle = s.isDark(x, g) ? o.foreground : o.background;
              var y = Math.ceil((g + 1) * p) - Math.floor(g * p), m = Math.ceil((x + 1) * p) - Math.floor(x * p);
              v.fillRect(Math.round(g * p) + o.padding, Math.round(x * h) + o.padding, y, m);
            }
          return l;
        }
        var c = {};
        return c.getQrBase64 = function(o, s) {
          typeof o != "string" && (o = ""), typeof s == "string" ? s = { text: s } : typeof s != "object" && (s = {}), s = Object.assign({ padding: 10, width: 256, height: 256, typeNumber: -1, correctLevel: QRErrorCorrectLevel.H, reverse: !1, background: "#ffffff", foreground: "#000000" }, s);
          try {
            s.text = i.utf16to8(o);
          } catch (v) {
            s.text = "" + v;
          }
          var l = f(s);
          return l.toDataURL();
        }, c.QRErrorCorrectLevel = QRErrorCorrectLevel, c;
      }();
      !window.jrQrcode && (window.jrQrcode = u), t.exports = u;
    }, function(t, n) {
      function a(d) {
        this.mode = o.MODE_8BIT_BYTE, this.data = d;
      }
      function i(d, x) {
        this.typeNumber = d, this.errorCorrectLevel = x, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = new Array();
      }
      function u(d, x) {
        if (d.length == null)
          throw new Error(d.length + "/" + x);
        for (var g = 0; g < d.length && d[g] == 0; )
          g++;
        this.num = new Array(d.length - g + x);
        for (var y = 0; y < d.length - g; y++)
          this.num[y] = d[y + g];
      }
      function f(d, x) {
        this.totalCount = d, this.dataCount = x;
      }
      function c() {
        this.buffer = new Array(), this.length = 0;
      }
      a.prototype = { getLength: function(d) {
        return this.data.length;
      }, write: function(d) {
        for (var x = 0; x < this.data.length; x++)
          d.put(this.data.charCodeAt(x), 8);
      } }, i.prototype = { addData: function(d) {
        var x = new a(d);
        this.dataList.push(x), this.dataCache = null;
      }, isDark: function(d, x) {
        if (d < 0 || this.moduleCount <= d || x < 0 || this.moduleCount <= x)
          throw new Error(d + "," + x);
        return this.modules[d][x];
      }, getModuleCount: function() {
        return this.moduleCount;
      }, make: function() {
        if (this.typeNumber < 1) {
          var d = 1;
          for (d = 1; d < 40; d++) {
            for (var x = f.getRSBlocks(d, this.errorCorrectLevel), g = new c(), y = 0, m = 0; m < x.length; m++)
              y += x[m].dataCount;
            for (var m = 0; m < this.dataList.length; m++) {
              var b = this.dataList[m];
              g.put(b.mode, 4), g.put(b.getLength(), v.getLengthInBits(b.mode, d)), b.write(g);
            }
            if (g.getLengthInBits() <= 8 * y)
              break;
          }
          this.typeNumber = d;
        }
        this.makeImpl(!1, this.getBestMaskPattern());
      }, makeImpl: function(d, x) {
        this.moduleCount = 4 * this.typeNumber + 17, this.modules = new Array(this.moduleCount);
        for (var g = 0; g < this.moduleCount; g++) {
          this.modules[g] = new Array(this.moduleCount);
          for (var y = 0; y < this.moduleCount; y++)
            this.modules[g][y] = null;
        }
        this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(d, x), this.typeNumber >= 7 && this.setupTypeNumber(d), this.dataCache == null && (this.dataCache = i.createData(this.typeNumber, this.errorCorrectLevel, this.dataList)), this.mapData(this.dataCache, x);
      }, setupPositionProbePattern: function(d, x) {
        for (var g = -1; g <= 7; g++)
          if (!(d + g <= -1 || this.moduleCount <= d + g))
            for (var y = -1; y <= 7; y++)
              x + y <= -1 || this.moduleCount <= x + y || (0 <= g && g <= 6 && (y == 0 || y == 6) || 0 <= y && y <= 6 && (g == 0 || g == 6) || 2 <= g && g <= 4 && 2 <= y && y <= 4 ? this.modules[d + g][x + y] = !0 : this.modules[d + g][x + y] = !1);
      }, getBestMaskPattern: function() {
        for (var d = 0, x = 0, g = 0; g < 8; g++) {
          this.makeImpl(!0, g);
          var y = v.getLostPoint(this);
          (g == 0 || d > y) && (d = y, x = g);
        }
        return x;
      }, createMovieClip: function(d, x, g) {
        var y = d.createEmptyMovieClip(x, g), m = 1;
        this.make();
        for (var b = 0; b < this.modules.length; b++)
          for (var w = b * m, A = 0; A < this.modules[b].length; A++) {
            var E = A * m, N = this.modules[b][A];
            N && (y.beginFill(0, 100), y.moveTo(E, w), y.lineTo(E + m, w), y.lineTo(E + m, w + m), y.lineTo(E, w + m), y.endFill());
          }
        return y;
      }, setupTimingPattern: function() {
        for (var d = 8; d < this.moduleCount - 8; d++)
          this.modules[d][6] == null && (this.modules[d][6] = d % 2 == 0);
        for (var x = 8; x < this.moduleCount - 8; x++)
          this.modules[6][x] == null && (this.modules[6][x] = x % 2 == 0);
      }, setupPositionAdjustPattern: function() {
        for (var d = v.getPatternPosition(this.typeNumber), x = 0; x < d.length; x++)
          for (var g = 0; g < d.length; g++) {
            var y = d[x], m = d[g];
            if (this.modules[y][m] == null)
              for (var b = -2; b <= 2; b++)
                for (var w = -2; w <= 2; w++)
                  b == -2 || b == 2 || w == -2 || w == 2 || b == 0 && w == 0 ? this.modules[y + b][m + w] = !0 : this.modules[y + b][m + w] = !1;
          }
      }, setupTypeNumber: function(d) {
        for (var x = v.getBCHTypeNumber(this.typeNumber), g = 0; g < 18; g++) {
          var y = !d && (x >> g & 1) == 1;
          this.modules[Math.floor(g / 3)][g % 3 + this.moduleCount - 8 - 3] = y;
        }
        for (var g = 0; g < 18; g++) {
          var y = !d && (x >> g & 1) == 1;
          this.modules[g % 3 + this.moduleCount - 8 - 3][Math.floor(g / 3)] = y;
        }
      }, setupTypeInfo: function(d, x) {
        for (var g = this.errorCorrectLevel << 3 | x, y = v.getBCHTypeInfo(g), m = 0; m < 15; m++) {
          var b = !d && (y >> m & 1) == 1;
          m < 6 ? this.modules[m][8] = b : m < 8 ? this.modules[m + 1][8] = b : this.modules[this.moduleCount - 15 + m][8] = b;
        }
        for (var m = 0; m < 15; m++) {
          var b = !d && (y >> m & 1) == 1;
          m < 8 ? this.modules[8][this.moduleCount - m - 1] = b : m < 9 ? this.modules[8][15 - m - 1 + 1] = b : this.modules[8][15 - m - 1] = b;
        }
        this.modules[this.moduleCount - 8][8] = !d;
      }, mapData: function(d, x) {
        for (var g = -1, y = this.moduleCount - 1, m = 7, b = 0, w = this.moduleCount - 1; w > 0; w -= 2)
          for (w == 6 && w--; ; ) {
            for (var A = 0; A < 2; A++)
              if (this.modules[y][w - A] == null) {
                var E = !1;
                b < d.length && (E = (d[b] >>> m & 1) == 1);
                var N = v.getMask(x, y, w - A);
                N && (E = !E), this.modules[y][w - A] = E, m--, m == -1 && (b++, m = 7);
              }
            if (y += g, y < 0 || this.moduleCount <= y) {
              y -= g, g = -g;
              break;
            }
          }
      } }, i.PAD0 = 236, i.PAD1 = 17, i.createData = function(d, x, g) {
        for (var y = f.getRSBlocks(d, x), m = new c(), b = 0; b < g.length; b++) {
          var w = g[b];
          m.put(w.mode, 4), m.put(w.getLength(), v.getLengthInBits(w.mode, d)), w.write(m);
        }
        for (var A = 0, b = 0; b < y.length; b++)
          A += y[b].dataCount;
        if (m.getLengthInBits() > 8 * A)
          throw new Error("code length overflow. (" + m.getLengthInBits() + ">" + 8 * A + ")");
        for (m.getLengthInBits() + 4 <= 8 * A && m.put(0, 4); m.getLengthInBits() % 8 != 0; )
          m.putBit(!1);
        for (; !(m.getLengthInBits() >= 8 * A || (m.put(i.PAD0, 8), m.getLengthInBits() >= 8 * A)); )
          m.put(i.PAD1, 8);
        return i.createBytes(m, y);
      }, i.createBytes = function(d, x) {
        for (var g = 0, y = 0, m = 0, b = new Array(x.length), w = new Array(x.length), A = 0; A < x.length; A++) {
          var E = x[A].dataCount, N = x[A].totalCount - E;
          y = Math.max(y, E), m = Math.max(m, N), b[A] = new Array(E);
          for (var C = 0; C < b[A].length; C++)
            b[A][C] = 255 & d.buffer[C + g];
          g += E;
          var D = v.getErrorCorrectPolynomial(N), B = new u(b[A], D.getLength() - 1), S = B.mod(D);
          w[A] = new Array(D.getLength() - 1);
          for (var C = 0; C < w[A].length; C++) {
            var F = C + S.getLength() - w[A].length;
            w[A][C] = F >= 0 ? S.get(F) : 0;
          }
        }
        for (var I = 0, C = 0; C < x.length; C++)
          I += x[C].totalCount;
        for (var z = new Array(I), P = 0, C = 0; C < y; C++)
          for (var A = 0; A < x.length; A++)
            C < b[A].length && (z[P++] = b[A][C]);
        for (var C = 0; C < m; C++)
          for (var A = 0; A < x.length; A++)
            C < w[A].length && (z[P++] = w[A][C]);
        return z;
      };
      for (var o = { MODE_NUMBER: 1, MODE_ALPHA_NUM: 2, MODE_8BIT_BYTE: 4, MODE_KANJI: 8 }, s = { L: 1, M: 0, Q: 3, H: 2 }, l = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 }, v = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1335, G18: 7973, G15_MASK: 21522, getBCHTypeInfo: function(d) {
        for (var x = d << 10; v.getBCHDigit(x) - v.getBCHDigit(v.G15) >= 0; )
          x ^= v.G15 << v.getBCHDigit(x) - v.getBCHDigit(v.G15);
        return (d << 10 | x) ^ v.G15_MASK;
      }, getBCHTypeNumber: function(d) {
        for (var x = d << 12; v.getBCHDigit(x) - v.getBCHDigit(v.G18) >= 0; )
          x ^= v.G18 << v.getBCHDigit(x) - v.getBCHDigit(v.G18);
        return d << 12 | x;
      }, getBCHDigit: function(d) {
        for (var x = 0; d != 0; )
          x++, d >>>= 1;
        return x;
      }, getPatternPosition: function(d) {
        return v.PATTERN_POSITION_TABLE[d - 1];
      }, getMask: function(d, x, g) {
        switch (d) {
          case l.PATTERN000:
            return (x + g) % 2 == 0;
          case l.PATTERN001:
            return x % 2 == 0;
          case l.PATTERN010:
            return g % 3 == 0;
          case l.PATTERN011:
            return (x + g) % 3 == 0;
          case l.PATTERN100:
            return (Math.floor(x / 2) + Math.floor(g / 3)) % 2 == 0;
          case l.PATTERN101:
            return x * g % 2 + x * g % 3 == 0;
          case l.PATTERN110:
            return (x * g % 2 + x * g % 3) % 2 == 0;
          case l.PATTERN111:
            return (x * g % 3 + (x + g) % 2) % 2 == 0;
          default:
            throw new Error("bad maskPattern:" + d);
        }
      }, getErrorCorrectPolynomial: function(d) {
        for (var x = new u([1], 0), g = 0; g < d; g++)
          x = x.multiply(new u([1, p.gexp(g)], 0));
        return x;
      }, getLengthInBits: function(d, x) {
        if (1 <= x && x < 10)
          switch (d) {
            case o.MODE_NUMBER:
              return 10;
            case o.MODE_ALPHA_NUM:
              return 9;
            case o.MODE_8BIT_BYTE:
              return 8;
            case o.MODE_KANJI:
              return 8;
            default:
              throw new Error("mode:" + d);
          }
        else if (x < 27)
          switch (d) {
            case o.MODE_NUMBER:
              return 12;
            case o.MODE_ALPHA_NUM:
              return 11;
            case o.MODE_8BIT_BYTE:
              return 16;
            case o.MODE_KANJI:
              return 10;
            default:
              throw new Error("mode:" + d);
          }
        else {
          if (!(x < 41))
            throw new Error("type:" + x);
          switch (d) {
            case o.MODE_NUMBER:
              return 14;
            case o.MODE_ALPHA_NUM:
              return 13;
            case o.MODE_8BIT_BYTE:
              return 16;
            case o.MODE_KANJI:
              return 12;
            default:
              throw new Error("mode:" + d);
          }
        }
      }, getLostPoint: function(d) {
        for (var x = d.getModuleCount(), g = 0, y = 0; y < x; y++)
          for (var m = 0; m < x; m++) {
            for (var b = 0, w = d.isDark(y, m), A = -1; A <= 1; A++)
              if (!(y + A < 0 || x <= y + A))
                for (var E = -1; E <= 1; E++)
                  m + E < 0 || x <= m + E || A == 0 && E == 0 || w == d.isDark(y + A, m + E) && b++;
            b > 5 && (g += 3 + b - 5);
          }
        for (var y = 0; y < x - 1; y++)
          for (var m = 0; m < x - 1; m++) {
            var N = 0;
            d.isDark(y, m) && N++, d.isDark(y + 1, m) && N++, d.isDark(y, m + 1) && N++, d.isDark(y + 1, m + 1) && N++, N != 0 && N != 4 || (g += 3);
          }
        for (var y = 0; y < x; y++)
          for (var m = 0; m < x - 6; m++)
            d.isDark(y, m) && !d.isDark(y, m + 1) && d.isDark(y, m + 2) && d.isDark(y, m + 3) && d.isDark(y, m + 4) && !d.isDark(y, m + 5) && d.isDark(y, m + 6) && (g += 40);
        for (var m = 0; m < x; m++)
          for (var y = 0; y < x - 6; y++)
            d.isDark(y, m) && !d.isDark(y + 1, m) && d.isDark(y + 2, m) && d.isDark(y + 3, m) && d.isDark(y + 4, m) && !d.isDark(y + 5, m) && d.isDark(y + 6, m) && (g += 40);
        for (var C = 0, m = 0; m < x; m++)
          for (var y = 0; y < x; y++)
            d.isDark(y, m) && C++;
        var D = Math.abs(100 * C / x / x - 50) / 5;
        return g += 10 * D;
      } }, p = { glog: function(d) {
        if (d < 1)
          throw new Error("glog(" + d + ")");
        return p.LOG_TABLE[d];
      }, gexp: function(d) {
        for (; d < 0; )
          d += 255;
        for (; d >= 256; )
          d -= 255;
        return p.EXP_TABLE[d];
      }, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) }, h = 0; h < 8; h++)
        p.EXP_TABLE[h] = 1 << h;
      for (var h = 8; h < 256; h++)
        p.EXP_TABLE[h] = p.EXP_TABLE[h - 4] ^ p.EXP_TABLE[h - 5] ^ p.EXP_TABLE[h - 6] ^ p.EXP_TABLE[h - 8];
      for (var h = 0; h < 255; h++)
        p.LOG_TABLE[p.EXP_TABLE[h]] = h;
      u.prototype = { get: function(d) {
        return this.num[d];
      }, getLength: function() {
        return this.num.length;
      }, multiply: function(d) {
        for (var x = new Array(this.getLength() + d.getLength() - 1), g = 0; g < this.getLength(); g++)
          for (var y = 0; y < d.getLength(); y++)
            x[g + y] ^= p.gexp(p.glog(this.get(g)) + p.glog(d.get(y)));
        return new u(x, 0);
      }, mod: function(d) {
        if (this.getLength() - d.getLength() < 0)
          return this;
        for (var x = p.glog(this.get(0)) - p.glog(d.get(0)), g = new Array(this.getLength()), y = 0; y < this.getLength(); y++)
          g[y] = this.get(y);
        for (var y = 0; y < d.getLength(); y++)
          g[y] ^= p.gexp(p.glog(d.get(y)) + x);
        return new u(g, 0).mod(d);
      } }, f.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]], f.getRSBlocks = function(d, x) {
        var g = f.getRsBlockTable(d, x);
        if (g == null)
          throw new Error("bad rs block @ typeNumber:" + d + "/errorCorrectLevel:" + x);
        for (var y = g.length / 3, m = new Array(), b = 0; b < y; b++)
          for (var w = g[3 * b + 0], A = g[3 * b + 1], E = g[3 * b + 2], N = 0; N < w; N++)
            m.push(new f(A, E));
        return m;
      }, f.getRsBlockTable = function(d, x) {
        switch (x) {
          case s.L:
            return f.RS_BLOCK_TABLE[4 * (d - 1) + 0];
          case s.M:
            return f.RS_BLOCK_TABLE[4 * (d - 1) + 1];
          case s.Q:
            return f.RS_BLOCK_TABLE[4 * (d - 1) + 2];
          case s.H:
            return f.RS_BLOCK_TABLE[4 * (d - 1) + 3];
          default:
            return;
        }
      }, c.prototype = { get: function(d) {
        var x = Math.floor(d / 8);
        return (this.buffer[x] >>> 7 - d % 8 & 1) == 1;
      }, put: function(d, x) {
        for (var g = 0; g < x; g++)
          this.putBit((d >>> x - g - 1 & 1) == 1);
      }, getLengthInBits: function() {
        return this.length;
      }, putBit: function(d) {
        var x = Math.floor(this.length / 8);
        this.buffer.length <= x && this.buffer.push(0), d && (this.buffer[x] |= 128 >>> this.length % 8), this.length++;
      } }, window.QRCode = i, window.QRErrorCorrectLevel = s;
      try {
        t.exports = { QRCode: i, QRErrorCorrectLevel: s };
      } catch {
      }
    }]);
  });
})(D2);
var q6 = D2.exports;
const Ms = /* @__PURE__ */ Ln(q6);
function Lr() {
  return Lr = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        ({}).hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, Lr.apply(null, arguments);
}
var su = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  epsilon: 1e-12,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
  number: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function Xe(r) {
  return typeof r == "number";
}
function Ue(r) {
  return !r || typeof r != "object" || typeof r.constructor != "function" ? !1 : r.isBigNumber === !0 && typeof r.constructor.prototype == "object" && r.constructor.prototype.isBigNumber === !0 || typeof r.constructor.isDecimal == "function" && r.constructor.isDecimal(r) === !0;
}
function Wt(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isComplex === !0 || !1;
}
function na(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isFraction === !0 || !1;
}
function yt(r) {
  return r && r.constructor.prototype.isUnit === !0 || !1;
}
function Wr(r) {
  return typeof r == "string";
}
var ur = Array.isArray;
function Oe(r) {
  return r && r.constructor.prototype.isMatrix === !0 || !1;
}
function Tt(r) {
  return Array.isArray(r) || Oe(r);
}
function oi(r) {
  return r && r.isDenseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function Tn(r) {
  return r && r.isSparseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function so(r) {
  return r && r.constructor.prototype.isRange === !0 || !1;
}
function hi(r) {
  return r && r.constructor.prototype.isIndex === !0 || !1;
}
function ah(r) {
  return typeof r == "boolean";
}
function ih(r) {
  return r && r.constructor.prototype.isResultSet === !0 || !1;
}
function uu(r) {
  return r && r.constructor.prototype.isHelp === !0 || !1;
}
function oh(r) {
  return typeof r == "function";
}
function sh(r) {
  return r instanceof Date;
}
function uh(r) {
  return r instanceof RegExp;
}
function gi(r) {
  return !!(r && typeof r == "object" && r.constructor === Object && !Wt(r) && !na(r));
}
function ch(r) {
  return r === null;
}
function lh(r) {
  return r === void 0;
}
function In(r) {
  return r && r.isAccessorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Mt(r) {
  return r && r.isArrayNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function fh(r) {
  return r && r.isAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function vh(r) {
  return r && r.isBlockNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function ph(r) {
  return r && r.isConditionalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function ar(r) {
  return r && r.isConstantNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Sm(r) {
  return ar(r) || zr(r) && r.args.length === 1 && ar(r.args[0]) && "-+~".includes(r.op);
}
function Pa(r) {
  return r && r.isFunctionAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function An(r) {
  return r && r.isFunctionNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function aa(r) {
  return r && r.isIndexNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function vr(r) {
  return r && r.isNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function xi(r) {
  return r && r.isObjectNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function zr(r) {
  return r && r.isOperatorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function un(r) {
  return r && r.isParenthesisNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function dh(r) {
  return r && r.isRangeNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function mh(r) {
  return r && r.isRelationalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function Ur(r) {
  return r && r.isSymbolNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function cu(r) {
  return r && r.constructor.prototype.isChain === !0 || !1;
}
function br(r) {
  var e = typeof r;
  return e === "object" ? r === null ? "null" : Ue(r) ? "BigNumber" : r.constructor && r.constructor.name ? r.constructor.name : "Object" : e;
}
function Ie(r) {
  var e = typeof r;
  if (e === "number" || e === "string" || e === "boolean" || r === null || r === void 0)
    return r;
  if (typeof r.clone == "function")
    return r.clone();
  if (Array.isArray(r))
    return r.map(function(t) {
      return Ie(t);
    });
  if (r instanceof Date)
    return new Date(r.valueOf());
  if (Ue(r))
    return r;
  if (gi(r))
    return Yi(r, Ie);
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(r, ")"));
}
function Yi(r, e) {
  var t = {};
  for (var n in r)
    Pe(r, n) && (t[n] = e(r[n]));
  return t;
}
function C2(r, e) {
  for (var t in e)
    Pe(e, t) && (r[t] = e[t]);
  return r;
}
function E2(r, e) {
  if (Array.isArray(e))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var t in e)
    if (Pe(e, t) && !(t in Object.prototype) && !(t in Function.prototype))
      if (e[t] && e[t].constructor === Object)
        r[t] === void 0 && (r[t] = {}), r[t] && r[t].constructor === Object ? E2(r[t], e[t]) : r[t] = e[t];
      else {
        if (Array.isArray(e[t]))
          throw new TypeError("Arrays are not supported by deepExtend");
        r[t] = e[t];
      }
  return r;
}
function Da(r, e) {
  var t, n, a;
  if (Array.isArray(r)) {
    if (!Array.isArray(e) || r.length !== e.length)
      return !1;
    for (n = 0, a = r.length; n < a; n++)
      if (!Da(r[n], e[n]))
        return !1;
    return !0;
  } else {
    if (typeof r == "function")
      return r === e;
    if (r instanceof Object) {
      if (Array.isArray(e) || !(e instanceof Object))
        return !1;
      for (t in r)
        if (!(t in e) || !Da(r[t], e[t]))
          return !1;
      for (t in e)
        if (!(t in r))
          return !1;
      return !0;
    } else
      return r === e;
  }
}
function U6(r) {
  var e = {};
  return N2(r, e), e;
}
function N2(r, e) {
  for (var t in r)
    if (Pe(r, t)) {
      var n = r[t];
      typeof n == "object" && n !== null ? N2(n, e) : e[t] = n;
    }
}
function Bs(r, e, t) {
  var n = !0, a;
  Object.defineProperty(r, e, {
    get: function() {
      return n && (a = t(), n = !1), a;
    },
    set: function(u) {
      a = u, n = !1;
    },
    configurable: !0,
    enumerable: !0
  });
}
function Pe(r, e) {
  return r && Object.hasOwnProperty.call(r, e);
}
function k6(r) {
  return r && typeof r.factory == "function";
}
function X6(r, e) {
  for (var t = {}, n = 0; n < e.length; n++) {
    var a = e[n], i = r[a];
    i !== void 0 && (t[a] = i);
  }
  return t;
}
var Pm = ["Matrix", "Array"], Mm = ["number", "BigNumber", "Fraction"];
function j6(r, e) {
  function t(n) {
    if (n) {
      var a = Yi(r, Ie);
      gx(n, "matrix", Pm), gx(n, "number", Mm), E2(r, n);
      var i = Yi(r, Ie), u = Yi(n, Ie);
      return e("config", i, a, u), i;
    } else
      return Yi(r, Ie);
  }
  return t.MATRIX_OPTIONS = Pm, t.NUMBER_OPTIONS = Mm, Object.keys(su).forEach((n) => {
    Object.defineProperty(t, n, {
      get: () => r[n],
      enumerable: !0,
      configurable: !0
    });
  }), t;
}
function gx(r, e, t) {
  r[e] !== void 0 && !t.includes(r[e]) && console.warn('Warning: Unknown value "' + r[e] + '" for configuration option "' + e + '". Available options: ' + t.map((n) => JSON.stringify(n)).join(", ") + ".");
}
var he = function(e) {
  if (e)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(su);
};
Lr(he, su, {
  MATRIX_OPTIONS: Pm,
  NUMBER_OPTIONS: Mm
});
function xx() {
  return !0;
}
function Yt() {
  return !1;
}
function Za() {
}
const yx = "Argument is not a typed-function.";
function B2() {
  function r(q) {
    return typeof q == "object" && q !== null && q.constructor === Object;
  }
  const e = [{
    name: "number",
    test: function(q) {
      return typeof q == "number";
    }
  }, {
    name: "string",
    test: function(q) {
      return typeof q == "string";
    }
  }, {
    name: "boolean",
    test: function(q) {
      return typeof q == "boolean";
    }
  }, {
    name: "Function",
    test: function(q) {
      return typeof q == "function";
    }
  }, {
    name: "Array",
    test: Array.isArray
  }, {
    name: "Date",
    test: function(q) {
      return q instanceof Date;
    }
  }, {
    name: "RegExp",
    test: function(q) {
      return q instanceof RegExp;
    }
  }, {
    name: "Object",
    test: r
  }, {
    name: "null",
    test: function(q) {
      return q === null;
    }
  }, {
    name: "undefined",
    test: function(q) {
      return q === void 0;
    }
  }], t = {
    name: "any",
    test: xx,
    isAny: !0
  };
  let n, a, i = 0, u = {
    createCount: 0
  };
  function f(q) {
    const G = n.get(q);
    if (G)
      return G;
    let ee = 'Unknown type "' + q + '"';
    const se = q.toLowerCase();
    let de;
    for (de of a)
      if (de.toLowerCase() === se) {
        ee += '. Did you mean "' + de + '" ?';
        break;
      }
    throw new TypeError(ee);
  }
  function c(q) {
    let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any";
    const ee = G ? f(G).index : a.length, se = [];
    for (let me = 0; me < q.length; ++me) {
      if (!q[me] || typeof q[me].name != "string" || typeof q[me].test != "function")
        throw new TypeError("Object with properties {name: string, test: function} expected");
      const be = q[me].name;
      if (n.has(be))
        throw new TypeError('Duplicate type name "' + be + '"');
      se.push(be), n.set(be, {
        name: be,
        test: q[me].test,
        isAny: q[me].isAny,
        index: ee + me,
        conversionsTo: []
        // Newly added type can't have any conversions to it
      });
    }
    const de = a.slice(ee);
    a = a.slice(0, ee).concat(se).concat(de);
    for (let me = ee + se.length; me < a.length; ++me)
      n.get(a[me]).index = me;
  }
  function o() {
    n = /* @__PURE__ */ new Map(), a = [], i = 0, c([t], !1);
  }
  o(), c(e);
  function s() {
    let q;
    for (q of a)
      n.get(q).conversionsTo = [];
    i = 0;
  }
  function l(q) {
    const G = a.filter((ee) => {
      const se = n.get(ee);
      return !se.isAny && se.test(q);
    });
    return G.length ? G : ["any"];
  }
  function v(q) {
    return q && typeof q == "function" && "_typedFunctionData" in q;
  }
  function p(q, G, ee) {
    if (!v(q))
      throw new TypeError(yx);
    const se = ee && ee.exact, de = Array.isArray(G) ? G.join(",") : G, me = b(de), be = x(me);
    if (!se || be in q.signatures) {
      const er = q._typedFunctionData.signatureMap.get(be);
      if (er)
        return er;
    }
    const xe = me.length;
    let Ee;
    if (se) {
      Ee = [];
      let er;
      for (er in q.signatures)
        Ee.push(q._typedFunctionData.signatureMap.get(er));
    } else
      Ee = q._typedFunctionData.signatures;
    for (let er = 0; er < xe; ++er) {
      const rr = me[er], Fe = [];
      let Er;
      for (Er of Ee) {
        const T = N(Er.params, er);
        if (!(!T || rr.restParam && !T.restParam)) {
          if (!T.hasAny) {
            const K = m(T);
            if (rr.types.some((ce) => !K.has(ce.name)))
              continue;
          }
          Fe.push(Er);
        }
      }
      if (Ee = Fe, Ee.length === 0)
        break;
    }
    let ye;
    for (ye of Ee)
      if (ye.params.length <= xe)
        return ye;
    throw new TypeError("Signature not found (signature: " + (q.name || "unnamed") + "(" + x(me, ", ") + "))");
  }
  function h(q, G, ee) {
    return p(q, G, ee).implementation;
  }
  function d(q, G) {
    const ee = f(G);
    if (ee.test(q))
      return q;
    const se = ee.conversionsTo;
    if (se.length === 0)
      throw new Error("There are no conversions to " + G + " defined.");
    for (let de = 0; de < se.length; de++)
      if (f(se[de].from).test(q))
        return se[de].convert(q);
    throw new Error("Cannot convert " + q + " to " + G);
  }
  function x(q) {
    let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return q.map((ee) => ee.name).join(G);
  }
  function g(q) {
    const G = q.indexOf("...") === 0, se = (G ? q.length > 3 ? q.slice(3) : "any" : q).split("|").map((xe) => f(xe.trim()));
    let de = !1, me = G ? "..." : "";
    return {
      types: se.map(function(xe) {
        return de = xe.isAny || de, me += xe.name + "|", {
          name: xe.name,
          typeIndex: xe.index,
          test: xe.test,
          isAny: xe.isAny,
          conversion: null,
          conversionIndex: -1
        };
      }),
      name: me.slice(0, -1),
      // remove trailing '|' from above
      hasAny: de,
      hasConversion: !1,
      restParam: G
    };
  }
  function y(q) {
    const G = q.types.map((be) => be.name), ee = M(G);
    let se = q.hasAny, de = q.name;
    const me = ee.map(function(be) {
      const xe = f(be.from);
      return se = xe.isAny || se, de += "|" + be.from, {
        name: be.from,
        typeIndex: xe.index,
        test: xe.test,
        isAny: xe.isAny,
        conversion: be,
        conversionIndex: be.index
      };
    });
    return {
      types: q.types.concat(me),
      name: de,
      hasAny: se,
      hasConversion: me.length > 0,
      restParam: q.restParam
    };
  }
  function m(q) {
    return q.typeSet || (q.typeSet = /* @__PURE__ */ new Set(), q.types.forEach((G) => q.typeSet.add(G.name))), q.typeSet;
  }
  function b(q) {
    const G = [];
    if (typeof q != "string")
      throw new TypeError("Signatures must be strings");
    const ee = q.trim();
    if (ee === "")
      return G;
    const se = ee.split(",");
    for (let de = 0; de < se.length; ++de) {
      const me = g(se[de].trim());
      if (me.restParam && de !== se.length - 1)
        throw new SyntaxError('Unexpected rest parameter "' + se[de] + '": only allowed for the last parameter');
      if (me.types.length === 0)
        return null;
      G.push(me);
    }
    return G;
  }
  function w(q) {
    const G = ne(q);
    return G ? G.restParam : !1;
  }
  function A(q) {
    if (!q || q.types.length === 0)
      return xx;
    if (q.types.length === 1)
      return f(q.types[0].name).test;
    if (q.types.length === 2) {
      const G = f(q.types[0].name).test, ee = f(q.types[1].name).test;
      return function(de) {
        return G(de) || ee(de);
      };
    } else {
      const G = q.types.map(function(ee) {
        return f(ee.name).test;
      });
      return function(se) {
        for (let de = 0; de < G.length; de++)
          if (G[de](se))
            return !0;
        return !1;
      };
    }
  }
  function E(q) {
    let G, ee, se;
    if (w(q)) {
      G = te(q).map(A);
      const de = G.length, me = A(ne(q)), be = function(xe) {
        for (let Ee = de; Ee < xe.length; Ee++)
          if (!me(xe[Ee]))
            return !1;
        return !0;
      };
      return function(Ee) {
        for (let ye = 0; ye < G.length; ye++)
          if (!G[ye](Ee[ye]))
            return !1;
        return be(Ee) && Ee.length >= de + 1;
      };
    } else
      return q.length === 0 ? function(me) {
        return me.length === 0;
      } : q.length === 1 ? (ee = A(q[0]), function(me) {
        return ee(me[0]) && me.length === 1;
      }) : q.length === 2 ? (ee = A(q[0]), se = A(q[1]), function(me) {
        return ee(me[0]) && se(me[1]) && me.length === 2;
      }) : (G = q.map(A), function(me) {
        for (let be = 0; be < G.length; be++)
          if (!G[be](me[be]))
            return !1;
        return me.length === G.length;
      });
  }
  function N(q, G) {
    return G < q.length ? q[G] : w(q) ? ne(q) : null;
  }
  function C(q, G) {
    const ee = N(q, G);
    return ee ? m(ee) : /* @__PURE__ */ new Set();
  }
  function D(q) {
    return q.conversion === null || q.conversion === void 0;
  }
  function B(q, G) {
    const ee = /* @__PURE__ */ new Set();
    return q.forEach((se) => {
      const de = C(se.params, G);
      let me;
      for (me of de)
        ee.add(me);
    }), ee.has("any") ? ["any"] : Array.from(ee);
  }
  function S(q, G, ee) {
    let se, de;
    const me = q || "unnamed";
    let be = ee, xe;
    for (xe = 0; xe < G.length; xe++) {
      const rr = [];
      if (be.forEach((Fe) => {
        const Er = N(Fe.params, xe), T = A(Er);
        (xe < Fe.params.length || w(Fe.params)) && T(G[xe]) && rr.push(Fe);
      }), rr.length === 0) {
        if (de = B(be, xe), de.length > 0) {
          const Fe = l(G[xe]);
          return se = new TypeError("Unexpected type of argument in function " + me + " (expected: " + de.join(" or ") + ", actual: " + Fe.join(" | ") + ", index: " + xe + ")"), se.data = {
            category: "wrongType",
            fn: me,
            index: xe,
            actual: Fe,
            expected: de
          }, se;
        }
      } else
        be = rr;
    }
    const Ee = be.map(function(rr) {
      return w(rr.params) ? 1 / 0 : rr.params.length;
    });
    if (G.length < Math.min.apply(null, Ee))
      return de = B(be, xe), se = new TypeError("Too few arguments in function " + me + " (expected: " + de.join(" or ") + ", index: " + G.length + ")"), se.data = {
        category: "tooFewArgs",
        fn: me,
        index: G.length,
        expected: de
      }, se;
    const ye = Math.max.apply(null, Ee);
    if (G.length > ye)
      return se = new TypeError("Too many arguments in function " + me + " (expected: " + ye + ", actual: " + G.length + ")"), se.data = {
        category: "tooManyArgs",
        fn: me,
        index: G.length,
        expectedLength: ye
      }, se;
    const er = [];
    for (let rr = 0; rr < G.length; ++rr)
      er.push(l(G[rr]).join("|"));
    return se = new TypeError('Arguments of type "' + er.join(", ") + '" do not match any of the defined signatures of function ' + me + "."), se.data = {
      category: "mismatch",
      actual: er
    }, se;
  }
  function F(q) {
    let G = a.length + 1;
    for (let ee = 0; ee < q.types.length; ee++)
      D(q.types[ee]) && (G = Math.min(G, q.types[ee].typeIndex));
    return G;
  }
  function I(q) {
    let G = i + 1;
    for (let ee = 0; ee < q.types.length; ee++)
      D(q.types[ee]) || (G = Math.min(G, q.types[ee].conversionIndex));
    return G;
  }
  function z(q, G) {
    if (q.hasAny) {
      if (!G.hasAny)
        return 1;
    } else if (G.hasAny)
      return -1;
    if (q.restParam) {
      if (!G.restParam)
        return 1;
    } else if (G.restParam)
      return -1;
    if (q.hasConversion) {
      if (!G.hasConversion)
        return 1;
    } else if (G.hasConversion)
      return -1;
    const ee = F(q) - F(G);
    if (ee < 0)
      return -1;
    if (ee > 0)
      return 1;
    const se = I(q) - I(G);
    return se < 0 ? -1 : se > 0 ? 1 : 0;
  }
  function P(q, G) {
    const ee = q.params, se = G.params, de = ne(ee), me = ne(se), be = w(ee), xe = w(se);
    if (be && de.hasAny) {
      if (!xe || !me.hasAny)
        return 1;
    } else if (xe && me.hasAny)
      return -1;
    let Ee = 0, ye = 0, er;
    for (er of ee)
      er.hasAny && ++Ee, er.hasConversion && ++ye;
    let rr = 0, Fe = 0;
    for (er of se)
      er.hasAny && ++rr, er.hasConversion && ++Fe;
    if (Ee !== rr)
      return Ee - rr;
    if (be && de.hasConversion) {
      if (!xe || !me.hasConversion)
        return 1;
    } else if (xe && me.hasConversion)
      return -1;
    if (ye !== Fe)
      return ye - Fe;
    if (be) {
      if (!xe)
        return 1;
    } else if (xe)
      return -1;
    const Er = (ee.length - se.length) * (be ? -1 : 1);
    if (Er !== 0)
      return Er;
    const T = [];
    let K = 0;
    for (let we = 0; we < ee.length; ++we) {
      const ze = z(ee[we], se[we]);
      T.push(ze), K += ze;
    }
    if (K !== 0)
      return K;
    let ce;
    for (ce of T)
      if (ce !== 0)
        return ce;
    return 0;
  }
  function M(q) {
    if (q.length === 0)
      return [];
    const G = q.map(f);
    q.length > 1 && G.sort((de, me) => de.index - me.index);
    let ee = G[0].conversionsTo;
    if (q.length === 1)
      return ee;
    ee = ee.concat([]);
    const se = new Set(q);
    for (let de = 1; de < G.length; ++de) {
      let me;
      for (me of G[de].conversionsTo)
        se.has(me.from) || (ee.push(me), se.add(me.from));
    }
    return ee;
  }
  function H(q, G) {
    let ee = G;
    if (q.some((de) => de.hasConversion)) {
      const de = w(q), me = q.map(O);
      ee = function() {
        const xe = [], Ee = de ? arguments.length - 1 : arguments.length;
        for (let ye = 0; ye < Ee; ye++)
          xe[ye] = me[ye](arguments[ye]);
        return de && (xe[Ee] = arguments[Ee].map(me[Ee])), G.apply(this, xe);
      };
    }
    let se = ee;
    if (w(q)) {
      const de = q.length - 1;
      se = function() {
        return ee.apply(this, oe(arguments, 0, de).concat([oe(arguments, de)]));
      };
    }
    return se;
  }
  function O(q) {
    let G, ee, se, de;
    const me = [], be = [];
    switch (q.types.forEach(function(xe) {
      xe.conversion && (me.push(f(xe.conversion.from).test), be.push(xe.conversion.convert));
    }), be.length) {
      case 0:
        return function(Ee) {
          return Ee;
        };
      case 1:
        return G = me[0], se = be[0], function(Ee) {
          return G(Ee) ? se(Ee) : Ee;
        };
      case 2:
        return G = me[0], ee = me[1], se = be[0], de = be[1], function(Ee) {
          return G(Ee) ? se(Ee) : ee(Ee) ? de(Ee) : Ee;
        };
      default:
        return function(Ee) {
          for (let ye = 0; ye < be.length; ye++)
            if (me[ye](Ee))
              return be[ye](Ee);
          return Ee;
        };
    }
  }
  function Q(q) {
    function G(ee, se, de) {
      if (se < ee.length) {
        const me = ee[se];
        let be = [];
        if (me.restParam) {
          const xe = me.types.filter(D);
          xe.length < me.types.length && be.push({
            types: xe,
            name: "..." + xe.map((Ee) => Ee.name).join("|"),
            hasAny: xe.some((Ee) => Ee.isAny),
            hasConversion: !1,
            restParam: !0
          }), be.push(me);
        } else
          be = me.types.map(function(xe) {
            return {
              types: [xe],
              name: xe.name,
              hasAny: xe.isAny,
              hasConversion: xe.conversion,
              restParam: !1
            };
          });
        return fe(be, function(xe) {
          return G(ee, se + 1, de.concat([xe]));
        });
      } else
        return [de];
    }
    return G(q, 0, []);
  }
  function k(q, G) {
    const ee = Math.max(q.length, G.length);
    for (let xe = 0; xe < ee; xe++) {
      const Ee = C(q, xe), ye = C(G, xe);
      let er = !1, rr;
      for (rr of ye)
        if (Ee.has(rr)) {
          er = !0;
          break;
        }
      if (!er)
        return !1;
    }
    const se = q.length, de = G.length, me = w(q), be = w(G);
    return me ? be ? se === de : de >= se : be ? se >= de : se === de;
  }
  function L(q) {
    return q.map((G) => ie(G) ? j(G.referToSelf.callback) : Y(G) ? Be(G.referTo.references, G.referTo.callback) : G);
  }
  function R(q, G, ee) {
    const se = [];
    let de;
    for (de of q) {
      let me = ee[de];
      if (typeof me != "number")
        throw new TypeError('No definition for referenced signature "' + de + '"');
      if (me = G[me], typeof me != "function")
        return !1;
      se.push(me);
    }
    return se;
  }
  function X(q, G, ee) {
    const se = L(q), de = new Array(se.length).fill(!1);
    let me = !0;
    for (; me; ) {
      me = !1;
      let be = !0;
      for (let xe = 0; xe < se.length; ++xe) {
        if (de[xe])
          continue;
        const Ee = se[xe];
        if (ie(Ee))
          se[xe] = Ee.referToSelf.callback(ee), se[xe].referToSelf = Ee.referToSelf, de[xe] = !0, be = !1;
        else if (Y(Ee)) {
          const ye = R(Ee.referTo.references, se, G);
          ye ? (se[xe] = Ee.referTo.callback.apply(this, ye), se[xe].referTo = Ee.referTo, de[xe] = !0, be = !1) : me = !0;
        }
      }
      if (be && me)
        throw new SyntaxError("Circular reference detected in resolving typed.referTo");
    }
    return se;
  }
  function ae(q) {
    const G = /\bthis(\(|\.signatures\b)/;
    Object.keys(q).forEach((ee) => {
      const se = q[ee];
      if (G.test(se.toString()))
        throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
    });
  }
  function _(q, G) {
    if (u.createCount++, Object.keys(G).length === 0)
      throw new SyntaxError("No signatures provided");
    u.warnAgainstDeprecatedThis && ae(G);
    const ee = [], se = [], de = {}, me = [];
    let be;
    for (be in G) {
      if (!Object.prototype.hasOwnProperty.call(G, be))
        continue;
      const xr = b(be);
      if (!xr)
        continue;
      ee.forEach(function(Gi) {
        if (k(Gi, xr))
          throw new TypeError('Conflicting signatures "' + x(Gi) + '" and "' + x(xr) + '".');
      }), ee.push(xr);
      const Pt = se.length;
      se.push(G[be]);
      const cN = xr.map(y);
      let _o;
      for (_o of Q(cN)) {
        const Gi = x(_o);
        me.push({
          params: _o,
          name: Gi,
          fn: Pt
        }), _o.every((lN) => !lN.hasConversion) && (de[Gi] = Pt);
      }
    }
    me.sort(P);
    const xe = X(se, de, ji);
    let Ee;
    for (Ee in de)
      Object.prototype.hasOwnProperty.call(de, Ee) && (de[Ee] = xe[de[Ee]]);
    const ye = [], er = /* @__PURE__ */ new Map();
    for (Ee of me)
      er.has(Ee.name) || (Ee.fn = xe[Ee.fn], ye.push(Ee), er.set(Ee.name, Ee));
    const rr = ye[0] && ye[0].params.length <= 2 && !w(ye[0].params), Fe = ye[1] && ye[1].params.length <= 2 && !w(ye[1].params), Er = ye[2] && ye[2].params.length <= 2 && !w(ye[2].params), T = ye[3] && ye[3].params.length <= 2 && !w(ye[3].params), K = ye[4] && ye[4].params.length <= 2 && !w(ye[4].params), ce = ye[5] && ye[5].params.length <= 2 && !w(ye[5].params), we = rr && Fe && Er && T && K && ce;
    for (let xr = 0; xr < ye.length; ++xr)
      ye[xr].test = E(ye[xr].params);
    const ze = rr ? A(ye[0].params[0]) : Yt, ke = Fe ? A(ye[1].params[0]) : Yt, gt = Er ? A(ye[2].params[0]) : Yt, Xi = T ? A(ye[3].params[0]) : Yt, pd = K ? A(ye[4].params[0]) : Yt, Zo = ce ? A(ye[5].params[0]) : Yt, dd = rr ? A(ye[0].params[1]) : Yt, md = Fe ? A(ye[1].params[1]) : Yt, Wo = Er ? A(ye[2].params[1]) : Yt, hd = T ? A(ye[3].params[1]) : Yt, Ko = K ? A(ye[4].params[1]) : Yt, xt = ce ? A(ye[5].params[1]) : Yt;
    for (let xr = 0; xr < ye.length; ++xr)
      ye[xr].implementation = H(ye[xr].params, ye[xr].fn);
    const xn = rr ? ye[0].implementation : Za, Jo = Fe ? ye[1].implementation : Za, gd = Er ? ye[2].implementation : Za, W3 = T ? ye[3].implementation : Za, K3 = K ? ye[4].implementation : Za, J3 = ce ? ye[5].implementation : Za, _3 = rr ? ye[0].params.length : -1, $3 = Fe ? ye[1].params.length : -1, eN = Er ? ye[2].params.length : -1, rN = T ? ye[3].params.length : -1, tN = K ? ye[4].params.length : -1, nN = ce ? ye[5].params.length : -1, aN = we ? 6 : 0, iN = ye.length, oN = ye.map((xr) => xr.test), sN = ye.map((xr) => xr.implementation), uN = function() {
      for (let Pt = aN; Pt < iN; Pt++)
        if (oN[Pt](arguments))
          return sN[Pt].apply(this, arguments);
      return u.onMismatch(q, arguments, ye);
    };
    function ji(xr, Pt) {
      return arguments.length === _3 && ze(xr) && dd(Pt) ? xn.apply(this, arguments) : arguments.length === $3 && ke(xr) && md(Pt) ? Jo.apply(this, arguments) : arguments.length === eN && gt(xr) && Wo(Pt) ? gd.apply(this, arguments) : arguments.length === rN && Xi(xr) && hd(Pt) ? W3.apply(this, arguments) : arguments.length === tN && pd(xr) && Ko(Pt) ? K3.apply(this, arguments) : arguments.length === nN && Zo(xr) && xt(Pt) ? J3.apply(this, arguments) : uN.apply(this, arguments);
    }
    try {
      Object.defineProperty(ji, "name", {
        value: q
      });
    } catch {
    }
    return ji.signatures = de, ji._typedFunctionData = {
      signatures: ye,
      signatureMap: er
    }, ji;
  }
  function re(q, G, ee) {
    throw S(q, G, ee);
  }
  function te(q) {
    return oe(q, 0, q.length - 1);
  }
  function ne(q) {
    return q[q.length - 1];
  }
  function oe(q, G, ee) {
    return Array.prototype.slice.call(q, G, ee);
  }
  function le(q, G) {
    for (let ee = 0; ee < q.length; ee++)
      if (G(q[ee]))
        return q[ee];
  }
  function fe(q, G) {
    return Array.prototype.concat.apply([], q.map(G));
  }
  function ge() {
    const q = te(arguments).map((ee) => x(b(ee))), G = ne(arguments);
    if (typeof G != "function")
      throw new TypeError("Callback function expected as last argument");
    return Be(q, G);
  }
  function Be(q, G) {
    return {
      referTo: {
        references: q,
        callback: G
      }
    };
  }
  function j(q) {
    if (typeof q != "function")
      throw new TypeError("Callback function expected as first argument");
    return {
      referToSelf: {
        callback: q
      }
    };
  }
  function Y(q) {
    return q && typeof q.referTo == "object" && Array.isArray(q.referTo.references) && typeof q.referTo.callback == "function";
  }
  function ie(q) {
    return q && typeof q.referToSelf == "object" && typeof q.referToSelf.callback == "function";
  }
  function V(q, G) {
    if (!q)
      return G;
    if (G && G !== q) {
      const ee = new Error("Function names do not match (expected: " + q + ", actual: " + G + ")");
      throw ee.data = {
        actual: G,
        expected: q
      }, ee;
    }
    return q;
  }
  function J(q) {
    let G;
    for (const ee in q)
      Object.prototype.hasOwnProperty.call(q, ee) && (v(q[ee]) || typeof q[ee].signature == "string") && (G = V(G, q[ee].name));
    return G;
  }
  function $(q, G) {
    let ee;
    for (ee in G)
      if (Object.prototype.hasOwnProperty.call(G, ee)) {
        if (ee in q && G[ee] !== q[ee]) {
          const se = new Error('Signature "' + ee + '" is defined twice');
          throw se.data = {
            signature: ee,
            sourceFunction: G[ee],
            destFunction: q[ee]
          }, se;
        }
        q[ee] = G[ee];
      }
  }
  const pe = u;
  u = function(q) {
    const G = typeof q == "string", ee = G ? 1 : 0;
    let se = G ? q : "";
    const de = {};
    for (let me = ee; me < arguments.length; ++me) {
      const be = arguments[me];
      let xe = {}, Ee;
      if (typeof be == "function" ? (Ee = be.name, typeof be.signature == "string" ? xe[be.signature] = be : v(be) && (xe = be.signatures)) : r(be) && (xe = be, G || (Ee = J(be))), Object.keys(xe).length === 0) {
        const ye = new TypeError("Argument to 'typed' at index " + me + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
        throw ye.data = {
          index: me,
          argument: be
        }, ye;
      }
      G || (se = V(se, Ee)), $(de, xe);
    }
    return _(se || "", de);
  }, u.create = B2, u.createCount = pe.createCount, u.onMismatch = re, u.throwMismatchError = re, u.createError = S, u.clear = o, u.clearConversions = s, u.addTypes = c, u._findType = f, u.referTo = ge, u.referToSelf = j, u.convert = d, u.findSignature = p, u.find = h, u.isTypedFunction = v, u.warnAgainstDeprecatedThis = !0, u.addType = function(q, G) {
    let ee = "any";
    G !== !1 && n.has("Object") && (ee = "Object"), u.addTypes([q], ee);
  };
  function ve(q) {
    if (!q || typeof q.from != "string" || typeof q.to != "string" || typeof q.convert != "function")
      throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
    if (q.to === q.from)
      throw new SyntaxError('Illegal to define conversion from "' + q.from + '" to itself.');
  }
  return u.addConversion = function(q) {
    let G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      override: !1
    };
    ve(q);
    const ee = f(q.to), se = ee.conversionsTo.find((de) => de.from === q.from);
    if (se)
      if (G && G.override)
        u.removeConversion({
          from: se.from,
          to: q.to,
          convert: se.convert
        });
      else
        throw new Error('There is already a conversion from "' + q.from + '" to "' + ee.name + '"');
    ee.conversionsTo.push({
      from: q.from,
      convert: q.convert,
      index: i++
    });
  }, u.addConversions = function(q, G) {
    q.forEach((ee) => u.addConversion(ee, G));
  }, u.removeConversion = function(q) {
    ve(q);
    const G = f(q.to), ee = le(G.conversionsTo, (de) => de.from === q.from);
    if (!ee)
      throw new Error("Attempt to remove nonexistent conversion from " + q.from + " to " + q.to);
    if (ee.convert !== q.convert)
      throw new Error("Conversion to remove does not match existing conversion");
    const se = G.conversionsTo.indexOf(ee);
    G.conversionsTo.splice(se, 1);
  }, u.resolve = function(q, G) {
    if (!v(q))
      throw new TypeError(yx);
    const ee = q._typedFunctionData.signatures;
    for (let se = 0; se < ee.length; ++se)
      if (ee[se].test(G))
        return ee[se];
    return null;
  }, u;
}
const ba = B2();
function Me(r) {
  return typeof r == "boolean" ? !0 : isFinite(r) ? r === Math.round(r) : !1;
}
var _n = Math.sign || function(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}, G6 = Math.log2 || function(e) {
  return Math.log(e) / Math.LN2;
}, V6 = Math.log10 || function(e) {
  return Math.log(e) / Math.LN10;
}, Q6 = Math.log1p || function(r) {
  return Math.log(r + 1);
}, Y6 = Math.cbrt || function(e) {
  if (e === 0)
    return e;
  var t = e < 0, n;
  return t && (e = -e), isFinite(e) ? (n = Math.exp(Math.log(e) / 3), n = (e / (n * n) + 2 * n) / 3) : n = e, t ? -n : n;
}, Z6 = Math.expm1 || function(e) {
  return e >= 2e-4 || e <= -2e-4 ? Math.exp(e) - 1 : e + e * e / 2 + e * e * e / 6;
};
function xm(r, e, t) {
  var n = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, a = n[e], i = "";
  if (t) {
    if (t < 1)
      throw new Error("size must be in greater than 0");
    if (!Me(t))
      throw new Error("size must be an integer");
    if (r > 2 ** (t - 1) - 1 || r < -(2 ** (t - 1)))
      throw new Error("Value must be in range [-2^".concat(t - 1, ", 2^").concat(t - 1, "-1]"));
    if (!Me(r))
      throw new Error("Value must be an integer");
    r < 0 && (r = r + 2 ** t), i = "i".concat(t);
  }
  var u = "";
  return r < 0 && (r = -r, u = "-"), "".concat(u).concat(a).concat(r.toString(e)).concat(i);
}
function wa(r, e) {
  if (typeof e == "function")
    return e(r);
  if (r === 1 / 0)
    return "Infinity";
  if (r === -1 / 0)
    return "-Infinity";
  if (isNaN(r))
    return "NaN";
  var {
    notation: t,
    precision: n,
    wordSize: a
  } = S2(e);
  switch (t) {
    case "fixed":
      return P2(r, n);
    case "exponential":
      return M2(r, n);
    case "engineering":
      return W6(r, n);
    case "bin":
      return xm(r, 2, a);
    case "oct":
      return xm(r, 8, a);
    case "hex":
      return xm(r, 16, a);
    case "auto":
      return K6(r, n, e).replace(/((\.\d*?)(0+))($|e)/, function() {
        var i = arguments[2], u = arguments[4];
        return i !== "." ? i + u : u;
      });
    default:
      throw new Error('Unknown notation "' + t + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function S2(r) {
  var e = "auto", t, n;
  if (r !== void 0)
    if (Xe(r))
      t = r;
    else if (Ue(r))
      t = r.toNumber();
    else if (gi(r))
      r.precision !== void 0 && (t = Ax(r.precision, () => {
        throw new Error('Option "precision" must be a number or BigNumber');
      })), r.wordSize !== void 0 && (n = Ax(r.wordSize, () => {
        throw new Error('Option "wordSize" must be a number or BigNumber');
      })), r.notation && (e = r.notation);
    else
      throw new Error("Unsupported type of options, number, BigNumber, or object expected");
  return {
    notation: e,
    precision: t,
    wordSize: n
  };
}
function uo(r) {
  var e = String(r).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!e)
    throw new SyntaxError("Invalid number " + r);
  var t = e[1], n = e[2], a = parseFloat(e[4] || "0"), i = n.indexOf(".");
  a += i !== -1 ? i - 1 : n.length - 1;
  var u = n.replace(".", "").replace(/^0*/, function(f) {
    return a -= f.length, "";
  }).replace(/0*$/, "").split("").map(function(f) {
    return parseInt(f);
  });
  return u.length === 0 && (u.push(0), a++), {
    sign: t,
    coefficients: u,
    exponent: a
  };
}
function W6(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = uo(r), n = lu(t, e), a = n.exponent, i = n.coefficients, u = a % 3 === 0 ? a : a < 0 ? a - 3 - a % 3 : a - a % 3;
  if (Xe(e))
    for (; e > i.length || a - u + 1 > i.length; )
      i.push(0);
  else
    for (var f = Math.abs(a - u) - (i.length - 1), c = 0; c < f; c++)
      i.push(0);
  for (var o = Math.abs(a - u), s = 1; o > 0; )
    s++, o--;
  var l = i.slice(s).join(""), v = Xe(e) && l.length || l.match(/[1-9]/) ? "." + l : "", p = i.slice(0, s).join("") + v + "e" + (a >= 0 ? "+" : "") + u.toString();
  return n.sign + p;
}
function P2(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = uo(r), n = typeof e == "number" ? lu(t, t.exponent + 1 + e) : t, a = n.coefficients, i = n.exponent + 1, u = i + (e || 0);
  return a.length < u && (a = a.concat(ei(u - a.length))), i < 0 && (a = ei(-i + 1).concat(a), i = 1), i < a.length && a.splice(i, 0, i === 0 ? "0." : "."), n.sign + a.join("");
}
function M2(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var t = uo(r), n = e ? lu(t, e) : t, a = n.coefficients, i = n.exponent;
  a.length < e && (a = a.concat(ei(e - a.length)));
  var u = a.shift();
  return n.sign + u + (a.length > 0 ? "." + a.join("") : "") + "e" + (i >= 0 ? "+" : "") + i;
}
function K6(r, e, t) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var n = bx(t == null ? void 0 : t.lowerExp, -3), a = bx(t == null ? void 0 : t.upperExp, 5), i = uo(r), u = e ? lu(i, e) : i;
  if (u.exponent < n || u.exponent >= a)
    return M2(r, e);
  var f = u.coefficients, c = u.exponent;
  f.length < e && (f = f.concat(ei(e - f.length))), f = f.concat(ei(c - f.length + 1 + (f.length < e ? e - f.length : 0))), f = ei(-c).concat(f);
  var o = c > 0 ? c : 0;
  return o < f.length - 1 && f.splice(o + 1, 0, "."), u.sign + f.join("");
}
function lu(r, e) {
  for (var t = {
    sign: r.sign,
    coefficients: r.coefficients,
    exponent: r.exponent
  }, n = t.coefficients; e <= 0; )
    n.unshift(0), t.exponent++, e++;
  if (n.length > e) {
    var a = n.splice(e, n.length - e);
    if (a[0] >= 5) {
      var i = e - 1;
      for (n[i]++; n[i] === 10; )
        n.pop(), i === 0 && (n.unshift(0), t.exponent++, i++), i--, n[i]++;
    }
  }
  return t;
}
function ei(r) {
  for (var e = [], t = 0; t < r; t++)
    e.push(0);
  return e;
}
function J6(r) {
  return r.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
var _6 = Number.EPSILON || 2220446049250313e-31;
function wt(r, e, t) {
  if (t == null)
    return r === e;
  if (r === e)
    return !0;
  if (isNaN(r) || isNaN(e))
    return !1;
  if (isFinite(r) && isFinite(e)) {
    var n = Math.abs(r - e);
    return n <= _6 ? !0 : n <= Math.max(Math.abs(r), Math.abs(e)) * t;
  }
  return !1;
}
var $6 = Math.acosh || function(r) {
  return Math.log(Math.sqrt(r * r - 1) + r);
}, e9 = Math.asinh || function(r) {
  return Math.log(Math.sqrt(r * r + 1) + r);
}, r9 = Math.atanh || function(r) {
  return Math.log((1 + r) / (1 - r)) / 2;
}, t9 = Math.cosh || function(r) {
  return (Math.exp(r) + Math.exp(-r)) / 2;
}, n9 = Math.sinh || function(r) {
  return (Math.exp(r) - Math.exp(-r)) / 2;
}, a9 = Math.tanh || function(r) {
  var e = Math.exp(2 * r);
  return (e - 1) / (e + 1);
};
function i9(r, e) {
  var t = r > 0 ? !0 : r < 0 ? !1 : 1 / r === 1 / 0, n = e > 0 ? !0 : e < 0 ? !1 : 1 / e === 1 / 0;
  return t ^ n ? -r : r;
}
function Ax(r, e) {
  if (Xe(r))
    return r;
  if (Ue(r))
    return r.toNumber();
  e();
}
function bx(r, e) {
  return Xe(r) ? r : Ue(r) ? r.toNumber() : e;
}
function U(r, e, t, n) {
  function a(i) {
    var u = X6(i, e.map(F2));
    return o9(r, e, i), t(u);
  }
  return a.isFactory = !0, a.fn = r, a.dependencies = e.slice().sort(), n && (a.meta = n), a;
}
function Ji(r) {
  return typeof r == "function" && typeof r.fn == "string" && Array.isArray(r.dependencies);
}
function o9(r, e, t) {
  var n = e.filter((i) => !s9(i)).every((i) => t[i] !== void 0);
  if (!n) {
    var a = e.filter((i) => t[i] === void 0);
    throw new Error('Cannot create function "'.concat(r, '", ') + "some dependencies are missing: ".concat(a.map((i) => '"'.concat(i, '"')).join(", "), "."));
  }
}
function s9(r) {
  return r && r[0] === "?";
}
function F2(r) {
  return r && r[0] === "?" ? r.slice(1) : r;
}
function At(r, e) {
  if (O2(r) && T2(r, e))
    return r[e];
  throw typeof r[e] == "function" && hh(r, e) ? new Error('Cannot access method "' + e + '" as a property') : new Error('No access to property "' + e + '"');
}
function si(r, e, t) {
  if (O2(r) && T2(r, e))
    return r[e] = t, t;
  throw new Error('No access to property "' + e + '"');
}
function u9(r, e) {
  return e in r;
}
function T2(r, e) {
  return !r || typeof r != "object" ? !1 : Pe(l9, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function c9(r, e) {
  if (!hh(r, e))
    throw new Error('No access to method "' + e + '"');
  return r[e];
}
function hh(r, e) {
  return r == null || typeof r[e] != "function" || Pe(r, e) && Object.getPrototypeOf && e in Object.getPrototypeOf(r) ? !1 : Pe(f9, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function O2(r) {
  return typeof r == "object" && r && r.constructor === Object;
}
var l9 = {
  length: !0,
  name: !0
}, f9 = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class fu {
  constructor(e) {
    this.wrappedObject = e, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).values();
  }
  get(e) {
    return At(this.wrappedObject, e);
  }
  set(e, t) {
    return si(this.wrappedObject, e, t), this;
  }
  has(e) {
    return u9(this.wrappedObject, e);
  }
  entries() {
    return R2(this.keys(), (e) => [e, this.get(e)]);
  }
  forEach(e) {
    for (var t of this.keys())
      e(this.get(t), t, this);
  }
  delete(e) {
    delete this.wrappedObject[e];
  }
  clear() {
    for (var e of this.keys())
      this.delete(e);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
class z2 {
  /**
   * @param {Map} a
   * @param {Map} b
   * @param {Set} bKeys
   */
  constructor(e, t, n) {
    this.a = e, this.b = t, this.bKeys = n, this[Symbol.iterator] = this.entries;
  }
  get(e) {
    return this.bKeys.has(e) ? this.b.get(e) : this.a.get(e);
  }
  set(e, t) {
    return this.bKeys.has(e) ? this.b.set(e, t) : this.a.set(e, t), this;
  }
  has(e) {
    return this.b.has(e) || this.a.has(e);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return R2(this.keys(), (e) => [e, this.get(e)]);
  }
  forEach(e) {
    for (var t of this.keys())
      e(this.get(t), t, this);
  }
  delete(e) {
    return this.bKeys.has(e) ? this.b.delete(e) : this.a.delete(e);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
}
function R2(r, e) {
  return {
    next: () => {
      var t = r.next();
      return t.done ? t : {
        value: e(t.value),
        done: !1
      };
    }
  };
}
function $i() {
  return /* @__PURE__ */ new Map();
}
function ri(r) {
  if (!r)
    return $i();
  if (I2(r))
    return r;
  if (gi(r))
    return new fu(r);
  throw new Error("createMap can create maps from objects or Maps");
}
function v9(r) {
  if (r instanceof fu)
    return r.wrappedObject;
  var e = {};
  for (var t of r.keys()) {
    var n = r.get(t);
    si(e, t, n);
  }
  return e;
}
function I2(r) {
  return r ? r instanceof Map || r instanceof fu || typeof r.set == "function" && typeof r.get == "function" && typeof r.keys == "function" && typeof r.has == "function" : !1;
}
var H2 = function() {
  return H2 = ba.create, ba;
}, p9 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], vu = /* @__PURE__ */ U("typed", p9, function(e) {
  var {
    BigNumber: t,
    Complex: n,
    DenseMatrix: a,
    Fraction: i
  } = e, u = H2();
  return u.clear(), u.addTypes([
    {
      name: "number",
      test: Xe
    },
    {
      name: "Complex",
      test: Wt
    },
    {
      name: "BigNumber",
      test: Ue
    },
    {
      name: "Fraction",
      test: na
    },
    {
      name: "Unit",
      test: yt
    },
    // The following type matches a valid variable name, i.e., an alphanumeric
    // string starting with an alphabetic character. It is used (at least)
    // in the definition of the derivative() function, as the argument telling
    // what to differentiate over must (currently) be a variable.
    {
      name: "identifier",
      test: (f) => Wr && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(f)
    },
    {
      name: "string",
      test: Wr
    },
    {
      name: "Chain",
      test: cu
    },
    {
      name: "Array",
      test: ur
    },
    {
      name: "Matrix",
      test: Oe
    },
    {
      name: "DenseMatrix",
      test: oi
    },
    {
      name: "SparseMatrix",
      test: Tn
    },
    {
      name: "Range",
      test: so
    },
    {
      name: "Index",
      test: hi
    },
    {
      name: "boolean",
      test: ah
    },
    {
      name: "ResultSet",
      test: ih
    },
    {
      name: "Help",
      test: uu
    },
    {
      name: "function",
      test: oh
    },
    {
      name: "Date",
      test: sh
    },
    {
      name: "RegExp",
      test: uh
    },
    {
      name: "null",
      test: ch
    },
    {
      name: "undefined",
      test: lh
    },
    {
      name: "AccessorNode",
      test: In
    },
    {
      name: "ArrayNode",
      test: Mt
    },
    {
      name: "AssignmentNode",
      test: fh
    },
    {
      name: "BlockNode",
      test: vh
    },
    {
      name: "ConditionalNode",
      test: ph
    },
    {
      name: "ConstantNode",
      test: ar
    },
    {
      name: "FunctionNode",
      test: An
    },
    {
      name: "FunctionAssignmentNode",
      test: Pa
    },
    {
      name: "IndexNode",
      test: aa
    },
    {
      name: "Node",
      test: vr
    },
    {
      name: "ObjectNode",
      test: xi
    },
    {
      name: "OperatorNode",
      test: zr
    },
    {
      name: "ParenthesisNode",
      test: un
    },
    {
      name: "RangeNode",
      test: dh
    },
    {
      name: "RelationalNode",
      test: mh
    },
    {
      name: "SymbolNode",
      test: Ur
    },
    {
      name: "Map",
      test: I2
    },
    {
      name: "Object",
      test: gi
    }
    // order 'Object' last, it matches on other classes too
  ]), u.addConversions([{
    from: "number",
    to: "BigNumber",
    convert: function(c) {
      if (t || ym(c), J6(c) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + c + "). Use function bignumber(x) to convert to BigNumber.");
      return new t(c);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(c) {
      return n || ss(c), new n(c, 0);
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(c) {
      return n || ss(c), new n(c.toNumber(), 0);
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(c) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(c) {
      return n || ss(c), new n(c.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(c) {
      i || Am(c);
      var o = new i(c);
      if (o.valueOf() !== c)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + c + "). Use function fraction(x) to convert to Fraction.");
      return o;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(c) {
      var o = Number(c);
      if (isNaN(o))
        throw new Error('Cannot convert "' + c + '" to a number');
      return o;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(c) {
      t || ym(c);
      try {
        return new t(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(c) {
      i || Am(c);
      try {
        return new i(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(c) {
      n || ss(c);
      try {
        return new n(c);
      } catch {
        throw new Error('Cannot convert "' + c + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(c) {
      return +c;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(c) {
      return t || ym(c), new t(+c);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(c) {
      return i || Am(c), new i(+c);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(c) {
      return String(c);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(c) {
      return a || d9(), new a(c);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(c) {
      return c.valueOf();
    }
  }]), u.onMismatch = (f, c, o) => {
    var s = u.createError(f, c, o);
    if (["wrongType", "mismatch"].includes(s.data.category) && c.length === 1 && Tt(c[0]) && // check if the function can be unary:
    o.some((v) => !v.params.includes(","))) {
      var l = new TypeError("Function '".concat(f, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(f, ")'."));
      throw l.data = s.data, l;
    }
    throw s;
  }, u.onMismatch = (f, c, o) => {
    var s = u.createError(f, c, o);
    if (["wrongType", "mismatch"].includes(s.data.category) && c.length === 1 && Tt(c[0]) && // check if the function can be unary:
    o.some((v) => !v.params.includes(","))) {
      var l = new TypeError("Function '".concat(f, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(f, ")'."));
      throw l.data = s.data, l;
    }
    throw s;
  }, u;
});
function ym(r) {
  throw new Error("Cannot convert value ".concat(r, " into a BigNumber: no class 'BigNumber' provided"));
}
function ss(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Complex number: no class 'Complex' provided"));
}
function d9() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function Am(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Fraction, no class 'Fraction' provided."));
}
var m9 = "ResultSet", h9 = [], pu = /* @__PURE__ */ U(m9, h9, () => {
  function r(e) {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = e || [];
  }
  return r.prototype.type = "ResultSet", r.prototype.isResultSet = !0, r.prototype.valueOf = function() {
    return this.entries;
  }, r.prototype.toString = function() {
    return "[" + this.entries.join(", ") + "]";
  }, r.prototype.toJSON = function() {
    return {
      mathjs: "ResultSet",
      entries: this.entries
    };
  }, r.fromJSON = function(e) {
    return new r(e.entries);
  }, r;
}, {
  isClass: !0
});
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var _a = 9e15, ia = 1e9, Fm = "0123456789abcdef", Fs = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Ts = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Tm = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -_a,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: _a,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, L2, On, je = !0, du = "[DecimalError] ", ea = du + "Invalid argument: ", q2 = du + "Precision limit exceeded", U2 = du + "crypto unavailable", k2 = "[object Decimal]", lt = Math.floor, jr = Math.pow, g9 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, x9 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, y9 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, X2 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, sn = 1e7, Re = 7, A9 = 9007199254740991, b9 = Fs.length - 1, Om = Ts.length - 1, Ae = { toStringTag: k2 };
Ae.absoluteValue = Ae.abs = function() {
  var r = new this.constructor(this);
  return r.s < 0 && (r.s = 1), Te(r);
};
Ae.ceil = function() {
  return Te(new this.constructor(this), this.e + 1, 2);
};
Ae.clampedTo = Ae.clamp = function(r, e) {
  var t, n = this, a = n.constructor;
  if (r = new a(r), e = new a(e), !r.s || !e.s)
    return new a(NaN);
  if (r.gt(e))
    throw Error(ea + e);
  return t = n.cmp(r), t < 0 ? r : n.cmp(e) > 0 ? e : new a(n);
};
Ae.comparedTo = Ae.cmp = function(r) {
  var e, t, n, a, i = this, u = i.d, f = (r = new i.constructor(r)).d, c = i.s, o = r.s;
  if (!u || !f)
    return !c || !o ? NaN : c !== o ? c : u === f ? 0 : !u ^ c < 0 ? 1 : -1;
  if (!u[0] || !f[0])
    return u[0] ? c : f[0] ? -o : 0;
  if (c !== o)
    return c;
  if (i.e !== r.e)
    return i.e > r.e ^ c < 0 ? 1 : -1;
  for (n = u.length, a = f.length, e = 0, t = n < a ? n : a; e < t; ++e)
    if (u[e] !== f[e])
      return u[e] > f[e] ^ c < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ c < 0 ? 1 : -1;
};
Ae.cosine = Ae.cos = function() {
  var r, e, t = this, n = t.constructor;
  return t.d ? t.d[0] ? (r = n.precision, e = n.rounding, n.precision = r + Math.max(t.e, t.sd()) + Re, n.rounding = 1, t = w9(n, Y2(n, t)), n.precision = r, n.rounding = e, Te(On == 2 || On == 3 ? t.neg() : t, r, e, !0)) : new n(1) : new n(NaN);
};
Ae.cubeRoot = Ae.cbrt = function() {
  var r, e, t, n, a, i, u, f, c, o, s = this, l = s.constructor;
  if (!s.isFinite() || s.isZero())
    return new l(s);
  for (je = !1, i = s.s * jr(s.s * s, 1 / 3), !i || Math.abs(i) == 1 / 0 ? (t = rt(s.d), r = s.e, (i = (r - t.length + 1) % 3) && (t += i == 1 || i == -2 ? "0" : "00"), i = jr(t, 1 / 3), r = lt((r + 1) / 3) - (r % 3 == (r < 0 ? -1 : 2)), i == 1 / 0 ? t = "5e" + r : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + r), n = new l(t), n.s = s.s) : n = new l(i.toString()), u = (r = l.precision) + 3; ; )
    if (f = n, c = f.times(f).times(f), o = c.plus(s), n = Cr(o.plus(s).times(f), o.plus(c), u + 2, 1), rt(f.d).slice(0, u) === (t = rt(n.d)).slice(0, u))
      if (t = t.slice(u - 3, u + 1), t == "9999" || !a && t == "4999") {
        if (!a && (Te(f, r + 1, 0), f.times(f).times(f).eq(s))) {
          n = f;
          break;
        }
        u += 4, a = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (Te(n, r + 1, 1), e = !n.times(n).times(n).eq(s));
        break;
      }
  return je = !0, Te(n, r, l.rounding, e);
};
Ae.decimalPlaces = Ae.dp = function() {
  var r, e = this.d, t = NaN;
  if (e) {
    if (r = e.length - 1, t = (r - lt(this.e / Re)) * Re, r = e[r], r)
      for (; r % 10 == 0; r /= 10)
        t--;
    t < 0 && (t = 0);
  }
  return t;
};
Ae.dividedBy = Ae.div = function(r) {
  return Cr(this, new this.constructor(r));
};
Ae.dividedToIntegerBy = Ae.divToInt = function(r) {
  var e = this, t = e.constructor;
  return Te(Cr(e, new t(r), 0, 1, 1), t.precision, t.rounding);
};
Ae.equals = Ae.eq = function(r) {
  return this.cmp(r) === 0;
};
Ae.floor = function() {
  return Te(new this.constructor(this), this.e + 1, 3);
};
Ae.greaterThan = Ae.gt = function(r) {
  return this.cmp(r) > 0;
};
Ae.greaterThanOrEqualTo = Ae.gte = function(r) {
  var e = this.cmp(r);
  return e == 1 || e === 0;
};
Ae.hyperbolicCosine = Ae.cosh = function() {
  var r, e, t, n, a, i = this, u = i.constructor, f = new u(1);
  if (!i.isFinite())
    return new u(i.s ? 1 / 0 : NaN);
  if (i.isZero())
    return f;
  t = u.precision, n = u.rounding, u.precision = t + Math.max(i.e, i.sd()) + 4, u.rounding = 1, a = i.d.length, a < 32 ? (r = Math.ceil(a / 3), e = (1 / hu(4, r)).toString()) : (r = 16, e = "2.3283064365386962890625e-10"), i = ui(u, 1, i.times(e), new u(1), !0);
  for (var c, o = r, s = new u(8); o--; )
    c = i.times(i), i = f.minus(c.times(s.minus(c.times(s))));
  return Te(i, u.precision = t, u.rounding = n, !0);
};
Ae.hyperbolicSine = Ae.sinh = function() {
  var r, e, t, n, a = this, i = a.constructor;
  if (!a.isFinite() || a.isZero())
    return new i(a);
  if (e = i.precision, t = i.rounding, i.precision = e + Math.max(a.e, a.sd()) + 4, i.rounding = 1, n = a.d.length, n < 3)
    a = ui(i, 2, a, a, !0);
  else {
    r = 1.4 * Math.sqrt(n), r = r > 16 ? 16 : r | 0, a = a.times(1 / hu(5, r)), a = ui(i, 2, a, a, !0);
    for (var u, f = new i(5), c = new i(16), o = new i(20); r--; )
      u = a.times(a), a = a.times(f.plus(u.times(c.times(u).plus(o))));
  }
  return i.precision = e, i.rounding = t, Te(a, e, t, !0);
};
Ae.hyperbolicTangent = Ae.tanh = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 7, n.rounding = 1, Cr(t.sinh(), t.cosh(), n.precision = r, n.rounding = e)) : new n(t.s);
};
Ae.inverseCosine = Ae.acos = function() {
  var r, e = this, t = e.constructor, n = e.abs().cmp(1), a = t.precision, i = t.rounding;
  return n !== -1 ? n === 0 ? e.isNeg() ? on(t, a, i) : new t(0) : new t(NaN) : e.isZero() ? on(t, a + 4, i).times(0.5) : (t.precision = a + 6, t.rounding = 1, e = e.asin(), r = on(t, a + 4, i).times(0.5), t.precision = a, t.rounding = i, r.minus(e));
};
Ae.inverseHyperbolicCosine = Ae.acosh = function() {
  var r, e, t = this, n = t.constructor;
  return t.lte(1) ? new n(t.eq(1) ? 0 : NaN) : t.isFinite() ? (r = n.precision, e = n.rounding, n.precision = r + Math.max(Math.abs(t.e), t.sd()) + 4, n.rounding = 1, je = !1, t = t.times(t).minus(1).sqrt().plus(t), je = !0, n.precision = r, n.rounding = e, t.ln()) : new n(t);
};
Ae.inverseHyperbolicSine = Ae.asinh = function() {
  var r, e, t = this, n = t.constructor;
  return !t.isFinite() || t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 2 * Math.max(Math.abs(t.e), t.sd()) + 6, n.rounding = 1, je = !1, t = t.times(t).plus(1).sqrt().plus(t), je = !0, n.precision = r, n.rounding = e, t.ln());
};
Ae.inverseHyperbolicTangent = Ae.atanh = function() {
  var r, e, t, n, a = this, i = a.constructor;
  return a.isFinite() ? a.e >= 0 ? new i(a.abs().eq(1) ? a.s / 0 : a.isZero() ? a : NaN) : (r = i.precision, e = i.rounding, n = a.sd(), Math.max(n, r) < 2 * -a.e - 1 ? Te(new i(a), r, e, !0) : (i.precision = t = n - a.e, a = Cr(a.plus(1), new i(1).minus(a), t + r, 1), i.precision = r + 4, i.rounding = 1, a = a.ln(), i.precision = r, i.rounding = e, a.times(0.5))) : new i(NaN);
};
Ae.inverseSine = Ae.asin = function() {
  var r, e, t, n, a = this, i = a.constructor;
  return a.isZero() ? new i(a) : (e = a.abs().cmp(1), t = i.precision, n = i.rounding, e !== -1 ? e === 0 ? (r = on(i, t + 4, n).times(0.5), r.s = a.s, r) : new i(NaN) : (i.precision = t + 6, i.rounding = 1, a = a.div(new i(1).minus(a.times(a)).sqrt().plus(1)).atan(), i.precision = t, i.rounding = n, a.times(2)));
};
Ae.inverseTangent = Ae.atan = function() {
  var r, e, t, n, a, i, u, f, c, o = this, s = o.constructor, l = s.precision, v = s.rounding;
  if (o.isFinite()) {
    if (o.isZero())
      return new s(o);
    if (o.abs().eq(1) && l + 4 <= Om)
      return u = on(s, l + 4, v).times(0.25), u.s = o.s, u;
  } else {
    if (!o.s)
      return new s(NaN);
    if (l + 4 <= Om)
      return u = on(s, l + 4, v).times(0.5), u.s = o.s, u;
  }
  for (s.precision = f = l + 10, s.rounding = 1, t = Math.min(28, f / Re + 2 | 0), r = t; r; --r)
    o = o.div(o.times(o).plus(1).sqrt().plus(1));
  for (je = !1, e = Math.ceil(f / Re), n = 1, c = o.times(o), u = new s(o), a = o; r !== -1; )
    if (a = a.times(c), i = u.minus(a.div(n += 2)), a = a.times(c), u = i.plus(a.div(n += 2)), u.d[e] !== void 0)
      for (r = e; u.d[r] === i.d[r] && r--; )
        ;
  return t && (u = u.times(2 << t - 1)), je = !0, Te(u, s.precision = l, s.rounding = v, !0);
};
Ae.isFinite = function() {
  return !!this.d;
};
Ae.isInteger = Ae.isInt = function() {
  return !!this.d && lt(this.e / Re) > this.d.length - 2;
};
Ae.isNaN = function() {
  return !this.s;
};
Ae.isNegative = Ae.isNeg = function() {
  return this.s < 0;
};
Ae.isPositive = Ae.isPos = function() {
  return this.s > 0;
};
Ae.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
Ae.lessThan = Ae.lt = function(r) {
  return this.cmp(r) < 0;
};
Ae.lessThanOrEqualTo = Ae.lte = function(r) {
  return this.cmp(r) < 1;
};
Ae.logarithm = Ae.log = function(r) {
  var e, t, n, a, i, u, f, c, o = this, s = o.constructor, l = s.precision, v = s.rounding, p = 5;
  if (r == null)
    r = new s(10), e = !0;
  else {
    if (r = new s(r), t = r.d, r.s < 0 || !t || !t[0] || r.eq(1))
      return new s(NaN);
    e = r.eq(10);
  }
  if (t = o.d, o.s < 0 || !t || !t[0] || o.eq(1))
    return new s(t && !t[0] ? -1 / 0 : o.s != 1 ? NaN : t ? 0 : 1 / 0);
  if (e)
    if (t.length > 1)
      i = !0;
    else {
      for (a = t[0]; a % 10 === 0; )
        a /= 10;
      i = a !== 1;
    }
  if (je = !1, f = l + p, u = $n(o, f), n = e ? Os(s, f + 10) : $n(r, f), c = Cr(u, n, f, 1), eo(c.d, a = l, v))
    do
      if (f += 10, u = $n(o, f), n = e ? Os(s, f + 10) : $n(r, f), c = Cr(u, n, f, 1), !i) {
        +rt(c.d).slice(a + 1, a + 15) + 1 == 1e14 && (c = Te(c, l + 1, 0));
        break;
      }
    while (eo(c.d, a += 10, v));
  return je = !0, Te(c, l, v);
};
Ae.minus = Ae.sub = function(r) {
  var e, t, n, a, i, u, f, c, o, s, l, v, p = this, h = p.constructor;
  if (r = new h(r), !p.d || !r.d)
    return !p.s || !r.s ? r = new h(NaN) : p.d ? r.s = -r.s : r = new h(r.d || p.s !== r.s ? p : NaN), r;
  if (p.s != r.s)
    return r.s = -r.s, p.plus(r);
  if (o = p.d, v = r.d, f = h.precision, c = h.rounding, !o[0] || !v[0]) {
    if (v[0])
      r.s = -r.s;
    else if (o[0])
      r = new h(p);
    else
      return new h(c === 3 ? -0 : 0);
    return je ? Te(r, f, c) : r;
  }
  if (t = lt(r.e / Re), s = lt(p.e / Re), o = o.slice(), i = s - t, i) {
    for (l = i < 0, l ? (e = o, i = -i, u = v.length) : (e = v, t = s, u = o.length), n = Math.max(Math.ceil(f / Re), u) + 2, i > n && (i = n, e.length = 1), e.reverse(), n = i; n--; )
      e.push(0);
    e.reverse();
  } else {
    for (n = o.length, u = v.length, l = n < u, l && (u = n), n = 0; n < u; n++)
      if (o[n] != v[n]) {
        l = o[n] < v[n];
        break;
      }
    i = 0;
  }
  for (l && (e = o, o = v, v = e, r.s = -r.s), u = o.length, n = v.length - u; n > 0; --n)
    o[u++] = 0;
  for (n = v.length; n > i; ) {
    if (o[--n] < v[n]) {
      for (a = n; a && o[--a] === 0; )
        o[a] = sn - 1;
      --o[a], o[n] += sn;
    }
    o[n] -= v[n];
  }
  for (; o[--u] === 0; )
    o.pop();
  for (; o[0] === 0; o.shift())
    --t;
  return o[0] ? (r.d = o, r.e = mu(o, t), je ? Te(r, f, c) : r) : new h(c === 3 ? -0 : 0);
};
Ae.modulo = Ae.mod = function(r) {
  var e, t = this, n = t.constructor;
  return r = new n(r), !t.d || !r.s || r.d && !r.d[0] ? new n(NaN) : !r.d || t.d && !t.d[0] ? Te(new n(t), n.precision, n.rounding) : (je = !1, n.modulo == 9 ? (e = Cr(t, r.abs(), 0, 3, 1), e.s *= r.s) : e = Cr(t, r, 0, n.modulo, 1), e = e.times(r), je = !0, t.minus(e));
};
Ae.naturalExponential = Ae.exp = function() {
  return zm(this);
};
Ae.naturalLogarithm = Ae.ln = function() {
  return $n(this);
};
Ae.negated = Ae.neg = function() {
  var r = new this.constructor(this);
  return r.s = -r.s, Te(r);
};
Ae.plus = Ae.add = function(r) {
  var e, t, n, a, i, u, f, c, o, s, l = this, v = l.constructor;
  if (r = new v(r), !l.d || !r.d)
    return !l.s || !r.s ? r = new v(NaN) : l.d || (r = new v(r.d || l.s === r.s ? l : NaN)), r;
  if (l.s != r.s)
    return r.s = -r.s, l.minus(r);
  if (o = l.d, s = r.d, f = v.precision, c = v.rounding, !o[0] || !s[0])
    return s[0] || (r = new v(l)), je ? Te(r, f, c) : r;
  if (i = lt(l.e / Re), n = lt(r.e / Re), o = o.slice(), a = i - n, a) {
    for (a < 0 ? (t = o, a = -a, u = s.length) : (t = s, n = i, u = o.length), i = Math.ceil(f / Re), u = i > u ? i + 1 : u + 1, a > u && (a = u, t.length = 1), t.reverse(); a--; )
      t.push(0);
    t.reverse();
  }
  for (u = o.length, a = s.length, u - a < 0 && (a = u, t = s, s = o, o = t), e = 0; a; )
    e = (o[--a] = o[a] + s[a] + e) / sn | 0, o[a] %= sn;
  for (e && (o.unshift(e), ++n), u = o.length; o[--u] == 0; )
    o.pop();
  return r.d = o, r.e = mu(o, n), je ? Te(r, f, c) : r;
};
Ae.precision = Ae.sd = function(r) {
  var e, t = this;
  if (r !== void 0 && r !== !!r && r !== 1 && r !== 0)
    throw Error(ea + r);
  return t.d ? (e = j2(t.d), r && t.e + 1 > e && (e = t.e + 1)) : e = NaN, e;
};
Ae.round = function() {
  var r = this, e = r.constructor;
  return Te(new e(r), r.e + 1, e.rounding);
};
Ae.sine = Ae.sin = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + Math.max(t.e, t.sd()) + Re, n.rounding = 1, t = C9(n, Y2(n, t)), n.precision = r, n.rounding = e, Te(On > 2 ? t.neg() : t, r, e, !0)) : new n(NaN);
};
Ae.squareRoot = Ae.sqrt = function() {
  var r, e, t, n, a, i, u = this, f = u.d, c = u.e, o = u.s, s = u.constructor;
  if (o !== 1 || !f || !f[0])
    return new s(!o || o < 0 && (!f || f[0]) ? NaN : f ? u : 1 / 0);
  for (je = !1, o = Math.sqrt(+u), o == 0 || o == 1 / 0 ? (e = rt(f), (e.length + c) % 2 == 0 && (e += "0"), o = Math.sqrt(e), c = lt((c + 1) / 2) - (c < 0 || c % 2), o == 1 / 0 ? e = "5e" + c : (e = o.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + c), n = new s(e)) : n = new s(o.toString()), t = (c = s.precision) + 3; ; )
    if (i = n, n = i.plus(Cr(u, i, t + 2, 1)).times(0.5), rt(i.d).slice(0, t) === (e = rt(n.d)).slice(0, t))
      if (e = e.slice(t - 3, t + 1), e == "9999" || !a && e == "4999") {
        if (!a && (Te(i, c + 1, 0), i.times(i).eq(u))) {
          n = i;
          break;
        }
        t += 4, a = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (Te(n, c + 1, 1), r = !n.times(n).eq(u));
        break;
      }
  return je = !0, Te(n, c, s.rounding, r);
};
Ae.tangent = Ae.tan = function() {
  var r, e, t = this, n = t.constructor;
  return t.isFinite() ? t.isZero() ? new n(t) : (r = n.precision, e = n.rounding, n.precision = r + 10, n.rounding = 1, t = t.sin(), t.s = 1, t = Cr(t, new n(1).minus(t.times(t)).sqrt(), r + 10, 0), n.precision = r, n.rounding = e, Te(On == 2 || On == 4 ? t.neg() : t, r, e, !0)) : new n(NaN);
};
Ae.times = Ae.mul = function(r) {
  var e, t, n, a, i, u, f, c, o, s = this, l = s.constructor, v = s.d, p = (r = new l(r)).d;
  if (r.s *= s.s, !v || !v[0] || !p || !p[0])
    return new l(!r.s || v && !v[0] && !p || p && !p[0] && !v ? NaN : !v || !p ? r.s / 0 : r.s * 0);
  for (t = lt(s.e / Re) + lt(r.e / Re), c = v.length, o = p.length, c < o && (i = v, v = p, p = i, u = c, c = o, o = u), i = [], u = c + o, n = u; n--; )
    i.push(0);
  for (n = o; --n >= 0; ) {
    for (e = 0, a = c + n; a > n; )
      f = i[a] + p[n] * v[a - n - 1] + e, i[a--] = f % sn | 0, e = f / sn | 0;
    i[a] = (i[a] + e) % sn | 0;
  }
  for (; !i[--u]; )
    i.pop();
  return e ? ++t : i.shift(), r.d = i, r.e = mu(i, t), je ? Te(r, l.precision, l.rounding) : r;
};
Ae.toBinary = function(r, e) {
  return gh(this, 2, r, e);
};
Ae.toDecimalPlaces = Ae.toDP = function(r, e) {
  var t = this, n = t.constructor;
  return t = new n(t), r === void 0 ? t : (Ot(r, 0, ia), e === void 0 ? e = n.rounding : Ot(e, 0, 8), Te(t, r + t.e + 1, e));
};
Ae.toExponential = function(r, e) {
  var t, n = this, a = n.constructor;
  return r === void 0 ? t = bn(n, !0) : (Ot(r, 0, ia), e === void 0 ? e = a.rounding : Ot(e, 0, 8), n = Te(new a(n), r + 1, e), t = bn(n, !0, r + 1)), n.isNeg() && !n.isZero() ? "-" + t : t;
};
Ae.toFixed = function(r, e) {
  var t, n, a = this, i = a.constructor;
  return r === void 0 ? t = bn(a) : (Ot(r, 0, ia), e === void 0 ? e = i.rounding : Ot(e, 0, 8), n = Te(new i(a), r + a.e + 1, e), t = bn(n, !1, r + n.e + 1)), a.isNeg() && !a.isZero() ? "-" + t : t;
};
Ae.toFraction = function(r) {
  var e, t, n, a, i, u, f, c, o, s, l, v, p = this, h = p.d, d = p.constructor;
  if (!h)
    return new d(p);
  if (o = t = new d(1), n = c = new d(0), e = new d(n), i = e.e = j2(h) - p.e - 1, u = i % Re, e.d[0] = jr(10, u < 0 ? Re + u : u), r == null)
    r = i > 0 ? e : o;
  else {
    if (f = new d(r), !f.isInt() || f.lt(o))
      throw Error(ea + f);
    r = f.gt(e) ? i > 0 ? e : o : f;
  }
  for (je = !1, f = new d(rt(h)), s = d.precision, d.precision = i = h.length * Re * 2; l = Cr(f, e, 0, 1, 1), a = t.plus(l.times(n)), a.cmp(r) != 1; )
    t = n, n = a, a = o, o = c.plus(l.times(a)), c = a, a = e, e = f.minus(l.times(a)), f = a;
  return a = Cr(r.minus(t), n, 0, 1, 1), c = c.plus(a.times(o)), t = t.plus(a.times(n)), c.s = o.s = p.s, v = Cr(o, n, i, 1).minus(p).abs().cmp(Cr(c, t, i, 1).minus(p).abs()) < 1 ? [o, n] : [c, t], d.precision = s, je = !0, v;
};
Ae.toHexadecimal = Ae.toHex = function(r, e) {
  return gh(this, 16, r, e);
};
Ae.toNearest = function(r, e) {
  var t = this, n = t.constructor;
  if (t = new n(t), r == null) {
    if (!t.d)
      return t;
    r = new n(1), e = n.rounding;
  } else {
    if (r = new n(r), e === void 0 ? e = n.rounding : Ot(e, 0, 8), !t.d)
      return r.s ? t : r;
    if (!r.d)
      return r.s && (r.s = t.s), r;
  }
  return r.d[0] ? (je = !1, t = Cr(t, r, 0, e, 1).times(r), je = !0, Te(t)) : (r.s = t.s, t = r), t;
};
Ae.toNumber = function() {
  return +this;
};
Ae.toOctal = function(r, e) {
  return gh(this, 8, r, e);
};
Ae.toPower = Ae.pow = function(r) {
  var e, t, n, a, i, u, f = this, c = f.constructor, o = +(r = new c(r));
  if (!f.d || !r.d || !f.d[0] || !r.d[0])
    return new c(jr(+f, o));
  if (f = new c(f), f.eq(1))
    return f;
  if (n = c.precision, i = c.rounding, r.eq(1))
    return Te(f, n, i);
  if (e = lt(r.e / Re), e >= r.d.length - 1 && (t = o < 0 ? -o : o) <= A9)
    return a = G2(c, f, t, n), r.s < 0 ? new c(1).div(a) : Te(a, n, i);
  if (u = f.s, u < 0) {
    if (e < r.d.length - 1)
      return new c(NaN);
    if (r.d[e] & 1 || (u = 1), f.e == 0 && f.d[0] == 1 && f.d.length == 1)
      return f.s = u, f;
  }
  return t = jr(+f, o), e = t == 0 || !isFinite(t) ? lt(o * (Math.log("0." + rt(f.d)) / Math.LN10 + f.e + 1)) : new c(t + "").e, e > c.maxE + 1 || e < c.minE - 1 ? new c(e > 0 ? u / 0 : 0) : (je = !1, c.rounding = f.s = 1, t = Math.min(12, (e + "").length), a = zm(r.times($n(f, n + t)), n), a.d && (a = Te(a, n + 5, 1), eo(a.d, n, i) && (e = n + 10, a = Te(zm(r.times($n(f, e + t)), e), e + 5, 1), +rt(a.d).slice(n + 1, n + 15) + 1 == 1e14 && (a = Te(a, n + 1, 0)))), a.s = u, je = !0, c.rounding = i, Te(a, n, i));
};
Ae.toPrecision = function(r, e) {
  var t, n = this, a = n.constructor;
  return r === void 0 ? t = bn(n, n.e <= a.toExpNeg || n.e >= a.toExpPos) : (Ot(r, 1, ia), e === void 0 ? e = a.rounding : Ot(e, 0, 8), n = Te(new a(n), r, e), t = bn(n, r <= n.e || n.e <= a.toExpNeg, r)), n.isNeg() && !n.isZero() ? "-" + t : t;
};
Ae.toSignificantDigits = Ae.toSD = function(r, e) {
  var t = this, n = t.constructor;
  return r === void 0 ? (r = n.precision, e = n.rounding) : (Ot(r, 1, ia), e === void 0 ? e = n.rounding : Ot(e, 0, 8)), Te(new n(t), r, e);
};
Ae.toString = function() {
  var r = this, e = r.constructor, t = bn(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() && !r.isZero() ? "-" + t : t;
};
Ae.truncated = Ae.trunc = function() {
  return Te(new this.constructor(this), this.e + 1, 1);
};
Ae.valueOf = Ae.toJSON = function() {
  var r = this, e = r.constructor, t = bn(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() ? "-" + t : t;
};
function rt(r) {
  var e, t, n, a = r.length - 1, i = "", u = r[0];
  if (a > 0) {
    for (i += u, e = 1; e < a; e++)
      n = r[e] + "", t = Re - n.length, t && (i += Kn(t)), i += n;
    u = r[e], n = u + "", t = Re - n.length, t && (i += Kn(t));
  } else if (u === 0)
    return "0";
  for (; u % 10 === 0; )
    u /= 10;
  return i + u;
}
function Ot(r, e, t) {
  if (r !== ~~r || r < e || r > t)
    throw Error(ea + r);
}
function eo(r, e, t, n) {
  var a, i, u, f;
  for (i = r[0]; i >= 10; i /= 10)
    --e;
  return --e < 0 ? (e += Re, a = 0) : (a = Math.ceil((e + 1) / Re), e %= Re), i = jr(10, Re - e), f = r[a] % i | 0, n == null ? e < 3 ? (e == 0 ? f = f / 100 | 0 : e == 1 && (f = f / 10 | 0), u = t < 4 && f == 99999 || t > 3 && f == 49999 || f == 5e4 || f == 0) : u = (t < 4 && f + 1 == i || t > 3 && f + 1 == i / 2) && (r[a + 1] / i / 100 | 0) == jr(10, e - 2) - 1 || (f == i / 2 || f == 0) && (r[a + 1] / i / 100 | 0) == 0 : e < 4 ? (e == 0 ? f = f / 1e3 | 0 : e == 1 ? f = f / 100 | 0 : e == 2 && (f = f / 10 | 0), u = (n || t < 4) && f == 9999 || !n && t > 3 && f == 4999) : u = ((n || t < 4) && f + 1 == i || !n && t > 3 && f + 1 == i / 2) && (r[a + 1] / i / 1e3 | 0) == jr(10, e - 3) - 1, u;
}
function Ss(r, e, t) {
  for (var n, a = [0], i, u = 0, f = r.length; u < f; ) {
    for (i = a.length; i--; )
      a[i] *= e;
    for (a[0] += Fm.indexOf(r.charAt(u++)), n = 0; n < a.length; n++)
      a[n] > t - 1 && (a[n + 1] === void 0 && (a[n + 1] = 0), a[n + 1] += a[n] / t | 0, a[n] %= t);
  }
  return a.reverse();
}
function w9(r, e) {
  var t, n, a;
  if (e.isZero())
    return e;
  n = e.d.length, n < 32 ? (t = Math.ceil(n / 3), a = (1 / hu(4, t)).toString()) : (t = 16, a = "2.3283064365386962890625e-10"), r.precision += t, e = ui(r, 1, e.times(a), new r(1));
  for (var i = t; i--; ) {
    var u = e.times(e);
    e = u.times(u).minus(u).times(8).plus(1);
  }
  return r.precision -= t, e;
}
var Cr = function() {
  function r(n, a, i) {
    var u, f = 0, c = n.length;
    for (n = n.slice(); c--; )
      u = n[c] * a + f, n[c] = u % i | 0, f = u / i | 0;
    return f && n.unshift(f), n;
  }
  function e(n, a, i, u) {
    var f, c;
    if (i != u)
      c = i > u ? 1 : -1;
    else
      for (f = c = 0; f < i; f++)
        if (n[f] != a[f]) {
          c = n[f] > a[f] ? 1 : -1;
          break;
        }
    return c;
  }
  function t(n, a, i, u) {
    for (var f = 0; i--; )
      n[i] -= f, f = n[i] < a[i] ? 1 : 0, n[i] = f * u + n[i] - a[i];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, a, i, u, f, c) {
    var o, s, l, v, p, h, d, x, g, y, m, b, w, A, E, N, C, D, B, S, F = n.constructor, I = n.s == a.s ? 1 : -1, z = n.d, P = a.d;
    if (!z || !z[0] || !P || !P[0])
      return new F(
        // Return NaN if either NaN, or both Infinity or 0.
        !n.s || !a.s || (z ? P && z[0] == P[0] : !P) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          z && z[0] == 0 || !P ? I * 0 : I / 0
        )
      );
    for (c ? (p = 1, s = n.e - a.e) : (c = sn, p = Re, s = lt(n.e / p) - lt(a.e / p)), B = P.length, C = z.length, g = new F(I), y = g.d = [], l = 0; P[l] == (z[l] || 0); l++)
      ;
    if (P[l] > (z[l] || 0) && s--, i == null ? (A = i = F.precision, u = F.rounding) : f ? A = i + (n.e - a.e) + 1 : A = i, A < 0)
      y.push(1), h = !0;
    else {
      if (A = A / p + 2 | 0, l = 0, B == 1) {
        for (v = 0, P = P[0], A++; (l < C || v) && A--; l++)
          E = v * c + (z[l] || 0), y[l] = E / P | 0, v = E % P | 0;
        h = v || l < C;
      } else {
        for (v = c / (P[0] + 1) | 0, v > 1 && (P = r(P, v, c), z = r(z, v, c), B = P.length, C = z.length), N = B, m = z.slice(0, B), b = m.length; b < B; )
          m[b++] = 0;
        S = P.slice(), S.unshift(0), D = P[0], P[1] >= c / 2 && ++D;
        do
          v = 0, o = e(P, m, B, b), o < 0 ? (w = m[0], B != b && (w = w * c + (m[1] || 0)), v = w / D | 0, v > 1 ? (v >= c && (v = c - 1), d = r(P, v, c), x = d.length, b = m.length, o = e(d, m, x, b), o == 1 && (v--, t(d, B < x ? S : P, x, c))) : (v == 0 && (o = v = 1), d = P.slice()), x = d.length, x < b && d.unshift(0), t(m, d, b, c), o == -1 && (b = m.length, o = e(P, m, B, b), o < 1 && (v++, t(m, B < b ? S : P, b, c))), b = m.length) : o === 0 && (v++, m = [0]), y[l++] = v, o && m[0] ? m[b++] = z[N] || 0 : (m = [z[N]], b = 1);
        while ((N++ < C || m[0] !== void 0) && A--);
        h = m[0] !== void 0;
      }
      y[0] || y.shift();
    }
    if (p == 1)
      g.e = s, L2 = h;
    else {
      for (l = 1, v = y[0]; v >= 10; v /= 10)
        l++;
      g.e = l + s * p - 1, Te(g, f ? i + g.e + 1 : i, u, h);
    }
    return g;
  };
}();
function Te(r, e, t, n) {
  var a, i, u, f, c, o, s, l, v, p = r.constructor;
  e:
    if (e != null) {
      if (l = r.d, !l)
        return r;
      for (a = 1, f = l[0]; f >= 10; f /= 10)
        a++;
      if (i = e - a, i < 0)
        i += Re, u = e, s = l[v = 0], c = s / jr(10, a - u - 1) % 10 | 0;
      else if (v = Math.ceil((i + 1) / Re), f = l.length, v >= f)
        if (n) {
          for (; f++ <= v; )
            l.push(0);
          s = c = 0, a = 1, i %= Re, u = i - Re + 1;
        } else
          break e;
      else {
        for (s = f = l[v], a = 1; f >= 10; f /= 10)
          a++;
        i %= Re, u = i - Re + a, c = u < 0 ? 0 : s / jr(10, a - u - 1) % 10 | 0;
      }
      if (n = n || e < 0 || l[v + 1] !== void 0 || (u < 0 ? s : s % jr(10, a - u - 1)), o = t < 4 ? (c || n) && (t == 0 || t == (r.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (t == 4 || n || t == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (i > 0 ? u > 0 ? s / jr(10, a - u) : 0 : l[v - 1]) % 10 & 1 || t == (r.s < 0 ? 8 : 7)), e < 1 || !l[0])
        return l.length = 0, o ? (e -= r.e + 1, l[0] = jr(10, (Re - e % Re) % Re), r.e = -e || 0) : l[0] = r.e = 0, r;
      if (i == 0 ? (l.length = v, f = 1, v--) : (l.length = v + 1, f = jr(10, Re - i), l[v] = u > 0 ? (s / jr(10, a - u) % jr(10, u) | 0) * f : 0), o)
        for (; ; )
          if (v == 0) {
            for (i = 1, u = l[0]; u >= 10; u /= 10)
              i++;
            for (u = l[0] += f, f = 1; u >= 10; u /= 10)
              f++;
            i != f && (r.e++, l[0] == sn && (l[0] = 1));
            break;
          } else {
            if (l[v] += f, l[v] != sn)
              break;
            l[v--] = 0, f = 1;
          }
      for (i = l.length; l[--i] === 0; )
        l.pop();
    }
  return je && (r.e > p.maxE ? (r.d = null, r.e = NaN) : r.e < p.minE && (r.e = 0, r.d = [0])), r;
}
function bn(r, e, t) {
  if (!r.isFinite())
    return Q2(r);
  var n, a = r.e, i = rt(r.d), u = i.length;
  return e ? (t && (n = t - u) > 0 ? i = i.charAt(0) + "." + i.slice(1) + Kn(n) : u > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (r.e < 0 ? "e" : "e+") + r.e) : a < 0 ? (i = "0." + Kn(-a - 1) + i, t && (n = t - u) > 0 && (i += Kn(n))) : a >= u ? (i += Kn(a + 1 - u), t && (n = t - a - 1) > 0 && (i = i + "." + Kn(n))) : ((n = a + 1) < u && (i = i.slice(0, n) + "." + i.slice(n)), t && (n = t - u) > 0 && (a + 1 === u && (i += "."), i += Kn(n))), i;
}
function mu(r, e) {
  var t = r[0];
  for (e *= Re; t >= 10; t /= 10)
    e++;
  return e;
}
function Os(r, e, t) {
  if (e > b9)
    throw je = !0, t && (r.precision = t), Error(q2);
  return Te(new r(Fs), e, 1, !0);
}
function on(r, e, t) {
  if (e > Om)
    throw Error(q2);
  return Te(new r(Ts), e, t, !0);
}
function j2(r) {
  var e = r.length - 1, t = e * Re + 1;
  if (e = r[e], e) {
    for (; e % 10 == 0; e /= 10)
      t--;
    for (e = r[0]; e >= 10; e /= 10)
      t++;
  }
  return t;
}
function Kn(r) {
  for (var e = ""; r--; )
    e += "0";
  return e;
}
function G2(r, e, t, n) {
  var a, i = new r(1), u = Math.ceil(n / Re + 4);
  for (je = !1; ; ) {
    if (t % 2 && (i = i.times(e), Dx(i.d, u) && (a = !0)), t = lt(t / 2), t === 0) {
      t = i.d.length - 1, a && i.d[t] === 0 && ++i.d[t];
      break;
    }
    e = e.times(e), Dx(e.d, u);
  }
  return je = !0, i;
}
function wx(r) {
  return r.d[r.d.length - 1] & 1;
}
function V2(r, e, t) {
  for (var n, a = new r(e[0]), i = 0; ++i < e.length; )
    if (n = new r(e[i]), n.s)
      a[t](n) && (a = n);
    else {
      a = n;
      break;
    }
  return a;
}
function zm(r, e) {
  var t, n, a, i, u, f, c, o = 0, s = 0, l = 0, v = r.constructor, p = v.rounding, h = v.precision;
  if (!r.d || !r.d[0] || r.e > 17)
    return new v(r.d ? r.d[0] ? r.s < 0 ? 0 : 1 / 0 : 1 : r.s ? r.s < 0 ? 0 : r : 0 / 0);
  for (e == null ? (je = !1, c = h) : c = e, f = new v(0.03125); r.e > -2; )
    r = r.times(f), l += 5;
  for (n = Math.log(jr(2, l)) / Math.LN10 * 2 + 5 | 0, c += n, t = i = u = new v(1), v.precision = c; ; ) {
    if (i = Te(i.times(r), c, 1), t = t.times(++s), f = u.plus(Cr(i, t, c, 1)), rt(f.d).slice(0, c) === rt(u.d).slice(0, c)) {
      for (a = l; a--; )
        u = Te(u.times(u), c, 1);
      if (e == null)
        if (o < 3 && eo(u.d, c - n, p, o))
          v.precision = c += 10, t = i = f = new v(1), s = 0, o++;
        else
          return Te(u, v.precision = h, p, je = !0);
      else
        return v.precision = h, u;
    }
    u = f;
  }
}
function $n(r, e) {
  var t, n, a, i, u, f, c, o, s, l, v, p = 1, h = 10, d = r, x = d.d, g = d.constructor, y = g.rounding, m = g.precision;
  if (d.s < 0 || !x || !x[0] || !d.e && x[0] == 1 && x.length == 1)
    return new g(x && !x[0] ? -1 / 0 : d.s != 1 ? NaN : x ? 0 : d);
  if (e == null ? (je = !1, s = m) : s = e, g.precision = s += h, t = rt(x), n = t.charAt(0), Math.abs(i = d.e) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && t.charAt(1) > 3; )
      d = d.times(r), t = rt(d.d), n = t.charAt(0), p++;
    i = d.e, n > 1 ? (d = new g("0." + t), i++) : d = new g(n + "." + t.slice(1));
  } else
    return o = Os(g, s + 2, m).times(i + ""), d = $n(new g(n + "." + t.slice(1)), s - h).plus(o), g.precision = m, e == null ? Te(d, m, y, je = !0) : d;
  for (l = d, c = u = d = Cr(d.minus(1), d.plus(1), s, 1), v = Te(d.times(d), s, 1), a = 3; ; ) {
    if (u = Te(u.times(v), s, 1), o = c.plus(Cr(u, new g(a), s, 1)), rt(o.d).slice(0, s) === rt(c.d).slice(0, s))
      if (c = c.times(2), i !== 0 && (c = c.plus(Os(g, s + 2, m).times(i + ""))), c = Cr(c, new g(p), s, 1), e == null)
        if (eo(c.d, s - h, y, f))
          g.precision = s += h, o = u = d = Cr(l.minus(1), l.plus(1), s, 1), v = Te(d.times(d), s, 1), a = f = 1;
        else
          return Te(c, g.precision = m, y, je = !0);
      else
        return g.precision = m, c;
    c = o, a += 2;
  }
}
function Q2(r) {
  return String(r.s * r.s / 0);
}
function Rm(r, e) {
  var t, n, a;
  for ((t = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (n = e.search(/e/i)) > 0 ? (t < 0 && (t = n), t += +e.slice(n + 1), e = e.substring(0, n)) : t < 0 && (t = e.length), n = 0; e.charCodeAt(n) === 48; n++)
    ;
  for (a = e.length; e.charCodeAt(a - 1) === 48; --a)
    ;
  if (e = e.slice(n, a), e) {
    if (a -= n, r.e = t = t - n - 1, r.d = [], n = (t + 1) % Re, t < 0 && (n += Re), n < a) {
      for (n && r.d.push(+e.slice(0, n)), a -= Re; n < a; )
        r.d.push(+e.slice(n, n += Re));
      e = e.slice(n), n = Re - e.length;
    } else
      n -= a;
    for (; n--; )
      e += "0";
    r.d.push(+e), je && (r.e > r.constructor.maxE ? (r.d = null, r.e = NaN) : r.e < r.constructor.minE && (r.e = 0, r.d = [0]));
  } else
    r.e = 0, r.d = [0];
  return r;
}
function D9(r, e) {
  var t, n, a, i, u, f, c, o, s;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), X2.test(e))
      return Rm(r, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (r.s = NaN), r.e = NaN, r.d = null, r;
  if (x9.test(e))
    t = 16, e = e.toLowerCase();
  else if (g9.test(e))
    t = 2;
  else if (y9.test(e))
    t = 8;
  else
    throw Error(ea + e);
  for (i = e.search(/p/i), i > 0 ? (c = +e.slice(i + 1), e = e.substring(2, i)) : e = e.slice(2), i = e.indexOf("."), u = i >= 0, n = r.constructor, u && (e = e.replace(".", ""), f = e.length, i = f - i, a = G2(n, new n(t), i, i * 2)), o = Ss(e, t, sn), s = o.length - 1, i = s; o[i] === 0; --i)
    o.pop();
  return i < 0 ? new n(r.s * 0) : (r.e = mu(o, s), r.d = o, je = !1, u && (r = Cr(r, a, f * 4)), c && (r = r.times(Math.abs(c) < 54 ? jr(2, c) : ra.pow(2, c))), je = !0, r);
}
function C9(r, e) {
  var t, n = e.d.length;
  if (n < 3)
    return e.isZero() ? e : ui(r, 2, e, e);
  t = 1.4 * Math.sqrt(n), t = t > 16 ? 16 : t | 0, e = e.times(1 / hu(5, t)), e = ui(r, 2, e, e);
  for (var a, i = new r(5), u = new r(16), f = new r(20); t--; )
    a = e.times(e), e = e.times(i.plus(a.times(u.times(a).minus(f))));
  return e;
}
function ui(r, e, t, n, a) {
  var i, u, f, c, o = r.precision, s = Math.ceil(o / Re);
  for (je = !1, c = t.times(t), f = new r(n); ; ) {
    if (u = Cr(f.times(c), new r(e++ * e++), o, 1), f = a ? n.plus(u) : n.minus(u), n = Cr(u.times(c), new r(e++ * e++), o, 1), u = f.plus(n), u.d[s] !== void 0) {
      for (i = s; u.d[i] === f.d[i] && i--; )
        ;
      if (i == -1)
        break;
    }
    i = f, f = n, n = u, u = i;
  }
  return je = !0, u.d.length = s + 1, u;
}
function hu(r, e) {
  for (var t = r; --e; )
    t *= r;
  return t;
}
function Y2(r, e) {
  var t, n = e.s < 0, a = on(r, r.precision, 1), i = a.times(0.5);
  if (e = e.abs(), e.lte(i))
    return On = n ? 4 : 1, e;
  if (t = e.divToInt(a), t.isZero())
    On = n ? 3 : 2;
  else {
    if (e = e.minus(t.times(a)), e.lte(i))
      return On = wx(t) ? n ? 2 : 3 : n ? 4 : 1, e;
    On = wx(t) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return e.minus(a).abs();
}
function gh(r, e, t, n) {
  var a, i, u, f, c, o, s, l, v, p = r.constructor, h = t !== void 0;
  if (h ? (Ot(t, 1, ia), n === void 0 ? n = p.rounding : Ot(n, 0, 8)) : (t = p.precision, n = p.rounding), !r.isFinite())
    s = Q2(r);
  else {
    for (s = bn(r), u = s.indexOf("."), h ? (a = 2, e == 16 ? t = t * 4 - 3 : e == 8 && (t = t * 3 - 2)) : a = e, u >= 0 && (s = s.replace(".", ""), v = new p(1), v.e = s.length - u, v.d = Ss(bn(v), 10, a), v.e = v.d.length), l = Ss(s, 10, a), i = c = l.length; l[--c] == 0; )
      l.pop();
    if (!l[0])
      s = h ? "0p+0" : "0";
    else {
      if (u < 0 ? i-- : (r = new p(r), r.d = l, r.e = i, r = Cr(r, v, t, n, 0, a), l = r.d, i = r.e, o = L2), u = l[t], f = a / 2, o = o || l[t + 1] !== void 0, o = n < 4 ? (u !== void 0 || o) && (n === 0 || n === (r.s < 0 ? 3 : 2)) : u > f || u === f && (n === 4 || o || n === 6 && l[t - 1] & 1 || n === (r.s < 0 ? 8 : 7)), l.length = t, o)
        for (; ++l[--t] > a - 1; )
          l[t] = 0, t || (++i, l.unshift(1));
      for (c = l.length; !l[c - 1]; --c)
        ;
      for (u = 0, s = ""; u < c; u++)
        s += Fm.charAt(l[u]);
      if (h) {
        if (c > 1)
          if (e == 16 || e == 8) {
            for (u = e == 16 ? 4 : 3, --c; c % u; c++)
              s += "0";
            for (l = Ss(s, a, e), c = l.length; !l[c - 1]; --c)
              ;
            for (u = 1, s = "1."; u < c; u++)
              s += Fm.charAt(l[u]);
          } else
            s = s.charAt(0) + "." + s.slice(1);
        s = s + (i < 0 ? "p" : "p+") + i;
      } else if (i < 0) {
        for (; ++i; )
          s = "0" + s;
        s = "0." + s;
      } else if (++i > c)
        for (i -= c; i--; )
          s += "0";
      else
        i < c && (s = s.slice(0, i) + "." + s.slice(i));
    }
    s = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + s;
  }
  return r.s < 0 ? "-" + s : s;
}
function Dx(r, e) {
  if (r.length > e)
    return r.length = e, !0;
}
function E9(r) {
  return new this(r).abs();
}
function N9(r) {
  return new this(r).acos();
}
function B9(r) {
  return new this(r).acosh();
}
function S9(r, e) {
  return new this(r).plus(e);
}
function P9(r) {
  return new this(r).asin();
}
function M9(r) {
  return new this(r).asinh();
}
function F9(r) {
  return new this(r).atan();
}
function T9(r) {
  return new this(r).atanh();
}
function O9(r, e) {
  r = new this(r), e = new this(e);
  var t, n = this.precision, a = this.rounding, i = n + 4;
  return !r.s || !e.s ? t = new this(NaN) : !r.d && !e.d ? (t = on(this, i, 1).times(e.s > 0 ? 0.25 : 0.75), t.s = r.s) : !e.d || r.isZero() ? (t = e.s < 0 ? on(this, n, a) : new this(0), t.s = r.s) : !r.d || e.isZero() ? (t = on(this, i, 1).times(0.5), t.s = r.s) : e.s < 0 ? (this.precision = i, this.rounding = 1, t = this.atan(Cr(r, e, i, 1)), e = on(this, i, 1), this.precision = n, this.rounding = a, t = r.s < 0 ? t.minus(e) : t.plus(e)) : t = this.atan(Cr(r, e, i, 1)), t;
}
function z9(r) {
  return new this(r).cbrt();
}
function R9(r) {
  return Te(r = new this(r), r.e + 1, 2);
}
function I9(r, e, t) {
  return new this(r).clamp(e, t);
}
function H9(r) {
  if (!r || typeof r != "object")
    throw Error(du + "Object expected");
  var e, t, n, a = r.defaults === !0, i = [
    "precision",
    1,
    ia,
    "rounding",
    0,
    8,
    "toExpNeg",
    -_a,
    0,
    "toExpPos",
    0,
    _a,
    "maxE",
    0,
    _a,
    "minE",
    -_a,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < i.length; e += 3)
    if (t = i[e], a && (this[t] = Tm[t]), (n = r[t]) !== void 0)
      if (lt(n) === n && n >= i[e + 1] && n <= i[e + 2])
        this[t] = n;
      else
        throw Error(ea + t + ": " + n);
  if (t = "crypto", a && (this[t] = Tm[t]), (n = r[t]) !== void 0)
    if (n === !0 || n === !1 || n === 0 || n === 1)
      if (n)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[t] = !0;
        else
          throw Error(U2);
      else
        this[t] = !1;
    else
      throw Error(ea + t + ": " + n);
  return this;
}
function L9(r) {
  return new this(r).cos();
}
function q9(r) {
  return new this(r).cosh();
}
function Z2(r) {
  var e, t, n;
  function a(i) {
    var u, f, c, o = this;
    if (!(o instanceof a))
      return new a(i);
    if (o.constructor = a, Cx(i)) {
      o.s = i.s, je ? !i.d || i.e > a.maxE ? (o.e = NaN, o.d = null) : i.e < a.minE ? (o.e = 0, o.d = [0]) : (o.e = i.e, o.d = i.d.slice()) : (o.e = i.e, o.d = i.d ? i.d.slice() : i.d);
      return;
    }
    if (c = typeof i, c === "number") {
      if (i === 0) {
        o.s = 1 / i < 0 ? -1 : 1, o.e = 0, o.d = [0];
        return;
      }
      if (i < 0 ? (i = -i, o.s = -1) : o.s = 1, i === ~~i && i < 1e7) {
        for (u = 0, f = i; f >= 10; f /= 10)
          u++;
        je ? u > a.maxE ? (o.e = NaN, o.d = null) : u < a.minE ? (o.e = 0, o.d = [0]) : (o.e = u, o.d = [i]) : (o.e = u, o.d = [i]);
        return;
      } else if (i * 0 !== 0) {
        i || (o.s = NaN), o.e = NaN, o.d = null;
        return;
      }
      return Rm(o, i.toString());
    } else if (c !== "string")
      throw Error(ea + i);
    return (f = i.charCodeAt(0)) === 45 ? (i = i.slice(1), o.s = -1) : (f === 43 && (i = i.slice(1)), o.s = 1), X2.test(i) ? Rm(o, i) : D9(o, i);
  }
  if (a.prototype = Ae, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = H9, a.clone = Z2, a.isDecimal = Cx, a.abs = E9, a.acos = N9, a.acosh = B9, a.add = S9, a.asin = P9, a.asinh = M9, a.atan = F9, a.atanh = T9, a.atan2 = O9, a.cbrt = z9, a.ceil = R9, a.clamp = I9, a.cos = L9, a.cosh = q9, a.div = U9, a.exp = k9, a.floor = X9, a.hypot = j9, a.ln = G9, a.log = V9, a.log10 = Y9, a.log2 = Q9, a.max = Z9, a.min = W9, a.mod = K9, a.mul = J9, a.pow = _9, a.random = $9, a.round = e7, a.sign = r7, a.sin = t7, a.sinh = n7, a.sqrt = a7, a.sub = i7, a.sum = o7, a.tan = s7, a.tanh = u7, a.trunc = c7, r === void 0 && (r = {}), r && r.defaults !== !0)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < n.length; )
      r.hasOwnProperty(t = n[e++]) || (r[t] = this[t]);
  return a.config(r), a;
}
function U9(r, e) {
  return new this(r).div(e);
}
function k9(r) {
  return new this(r).exp();
}
function X9(r) {
  return Te(r = new this(r), r.e + 1, 3);
}
function j9() {
  var r, e, t = new this(0);
  for (je = !1, r = 0; r < arguments.length; )
    if (e = new this(arguments[r++]), e.d)
      t.d && (t = t.plus(e.times(e)));
    else {
      if (e.s)
        return je = !0, new this(1 / 0);
      t = e;
    }
  return je = !0, t.sqrt();
}
function Cx(r) {
  return r instanceof ra || r && r.toStringTag === k2 || !1;
}
function G9(r) {
  return new this(r).ln();
}
function V9(r, e) {
  return new this(r).log(e);
}
function Q9(r) {
  return new this(r).log(2);
}
function Y9(r) {
  return new this(r).log(10);
}
function Z9() {
  return V2(this, arguments, "lt");
}
function W9() {
  return V2(this, arguments, "gt");
}
function K9(r, e) {
  return new this(r).mod(e);
}
function J9(r, e) {
  return new this(r).mul(e);
}
function _9(r, e) {
  return new this(r).pow(e);
}
function $9(r) {
  var e, t, n, a, i = 0, u = new this(1), f = [];
  if (r === void 0 ? r = this.precision : Ot(r, 1, ia), n = Math.ceil(r / Re), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(n)); i < n; )
        a = e[i], a >= 429e7 ? e[i] = crypto.getRandomValues(new Uint32Array(1))[0] : f[i++] = a % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(n *= 4); i < n; )
        a = e[i] + (e[i + 1] << 8) + (e[i + 2] << 16) + ((e[i + 3] & 127) << 24), a >= 214e7 ? crypto.randomBytes(4).copy(e, i) : (f.push(a % 1e7), i += 4);
      i = n / 4;
    } else
      throw Error(U2);
  else
    for (; i < n; )
      f[i++] = Math.random() * 1e7 | 0;
  for (n = f[--i], r %= Re, n && r && (a = jr(10, Re - r), f[i] = (n / a | 0) * a); f[i] === 0; i--)
    f.pop();
  if (i < 0)
    t = 0, f = [0];
  else {
    for (t = -1; f[0] === 0; t -= Re)
      f.shift();
    for (n = 1, a = f[0]; a >= 10; a /= 10)
      n++;
    n < Re && (t -= Re - n);
  }
  return u.e = t, u.d = f, u;
}
function e7(r) {
  return Te(r = new this(r), r.e + 1, this.rounding);
}
function r7(r) {
  return r = new this(r), r.d ? r.d[0] ? r.s : 0 * r.s : r.s || NaN;
}
function t7(r) {
  return new this(r).sin();
}
function n7(r) {
  return new this(r).sinh();
}
function a7(r) {
  return new this(r).sqrt();
}
function i7(r, e) {
  return new this(r).sub(e);
}
function o7() {
  var r = 0, e = arguments, t = new this(e[r]);
  for (je = !1; t.s && ++r < e.length; )
    t = t.plus(e[r]);
  return je = !0, Te(t, this.precision, this.rounding);
}
function s7(r) {
  return new this(r).tan();
}
function u7(r) {
  return new this(r).tanh();
}
function c7(r) {
  return Te(r = new this(r), r.e + 1, 1);
}
Ae[Symbol.for("nodejs.util.inspect.custom")] = Ae.toString;
Ae[Symbol.toStringTag] = "Decimal";
var ra = Ae.constructor = Z2(Tm);
Fs = new ra(Fs);
Ts = new ra(Ts);
var l7 = "BigNumber", f7 = ["?on", "config"], gu = /* @__PURE__ */ U(l7, f7, (r) => {
  var {
    on: e,
    config: t
  } = r, n = ra.clone({
    precision: t.precision,
    modulo: ra.EUCLID
  });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, n.fromJSON = function(a) {
    return new n(a.value);
  }, e && e("config", function(a, i) {
    a.precision !== i.precision && n.config({
      precision: a.precision
    });
  }), n;
}, {
  isClass: !0
}), W2 = { exports: {} };
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(r, e) {
  (function(t) {
    var n = Math.cosh || function(l) {
      return Math.abs(l) < 1e-9 ? 1 - l : (Math.exp(l) + Math.exp(-l)) * 0.5;
    }, a = Math.sinh || function(l) {
      return Math.abs(l) < 1e-9 ? l : (Math.exp(l) - Math.exp(-l)) * 0.5;
    }, i = function(l) {
      var v = Math.PI / 4;
      if (-v > l || l > v)
        return Math.cos(l) - 1;
      var p = l * l;
      return p * (p * (p * (p * (p * (p * (p * (p / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
    }, u = function(l, v) {
      var p = Math.abs(l), h = Math.abs(v);
      return p < 3e3 && h < 3e3 ? Math.sqrt(p * p + h * h) : (p < h ? (p = h, h = l / v) : h = v / l, p * Math.sqrt(1 + h * h));
    }, f = function() {
      throw SyntaxError("Invalid Param");
    };
    function c(l, v) {
      var p = Math.abs(l), h = Math.abs(v);
      return l === 0 ? Math.log(h) : v === 0 ? Math.log(p) : p < 3e3 && h < 3e3 ? Math.log(l * l + v * v) * 0.5 : (l = l / 2, v = v / 2, 0.5 * Math.log(l * l + v * v) + Math.LN2);
    }
    var o = function(l, v) {
      var p = { re: 0, im: 0 };
      if (l == null)
        p.re = p.im = 0;
      else if (v !== void 0)
        p.re = l, p.im = v;
      else
        switch (typeof l) {
          case "object":
            if ("im" in l && "re" in l)
              p.re = l.re, p.im = l.im;
            else if ("abs" in l && "arg" in l) {
              if (!Number.isFinite(l.abs) && Number.isFinite(l.arg))
                return s.INFINITY;
              p.re = l.abs * Math.cos(l.arg), p.im = l.abs * Math.sin(l.arg);
            } else if ("r" in l && "phi" in l) {
              if (!Number.isFinite(l.r) && Number.isFinite(l.phi))
                return s.INFINITY;
              p.re = l.r * Math.cos(l.phi), p.im = l.r * Math.sin(l.phi);
            } else
              l.length === 2 ? (p.re = l[0], p.im = l[1]) : f();
            break;
          case "string":
            p.im = /* void */
            p.re = 0;
            var h = l.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), d = 1, x = 0;
            h === null && f();
            for (var g = 0; g < h.length; g++) {
              var y = h[g];
              y === " " || y === "	" || y === `
` || (y === "+" ? d++ : y === "-" ? x++ : y === "i" || y === "I" ? (d + x === 0 && f(), h[g + 1] !== " " && !isNaN(h[g + 1]) ? (p.im += parseFloat((x % 2 ? "-" : "") + h[g + 1]), g++) : p.im += parseFloat((x % 2 ? "-" : "") + "1"), d = x = 0) : ((d + x === 0 || isNaN(y)) && f(), h[g + 1] === "i" || h[g + 1] === "I" ? (p.im += parseFloat((x % 2 ? "-" : "") + y), g++) : p.re += parseFloat((x % 2 ? "-" : "") + y), d = x = 0));
            }
            d + x > 0 && f();
            break;
          case "number":
            p.im = 0, p.re = l;
            break;
          default:
            f();
        }
      return isNaN(p.re) || isNaN(p.im), p;
    };
    function s(l, v) {
      if (!(this instanceof s))
        return new s(l, v);
      var p = o(l, v);
      this.re = p.re, this.im = p.im;
    }
    s.prototype = {
      re: 0,
      im: 0,
      /**
       * Calculates the sign of a complex number, which is a normalized complex
       *
       * @returns {Complex}
       */
      sign: function() {
        var l = this.abs();
        return new s(
          this.re / l,
          this.im / l
        );
      },
      /**
       * Adds two complex numbers
       *
       * @returns {Complex}
       */
      add: function(l, v) {
        var p = new s(l, v);
        return this.isInfinite() && p.isInfinite() ? s.NAN : this.isInfinite() || p.isInfinite() ? s.INFINITY : new s(
          this.re + p.re,
          this.im + p.im
        );
      },
      /**
       * Subtracts two complex numbers
       *
       * @returns {Complex}
       */
      sub: function(l, v) {
        var p = new s(l, v);
        return this.isInfinite() && p.isInfinite() ? s.NAN : this.isInfinite() || p.isInfinite() ? s.INFINITY : new s(
          this.re - p.re,
          this.im - p.im
        );
      },
      /**
       * Multiplies two complex numbers
       *
       * @returns {Complex}
       */
      mul: function(l, v) {
        var p = new s(l, v);
        return this.isInfinite() && p.isZero() || this.isZero() && p.isInfinite() ? s.NAN : this.isInfinite() || p.isInfinite() ? s.INFINITY : p.im === 0 && this.im === 0 ? new s(this.re * p.re, 0) : new s(
          this.re * p.re - this.im * p.im,
          this.re * p.im + this.im * p.re
        );
      },
      /**
       * Divides two complex numbers
       *
       * @returns {Complex}
       */
      div: function(l, v) {
        var p = new s(l, v);
        if (this.isZero() && p.isZero() || this.isInfinite() && p.isInfinite())
          return s.NAN;
        if (this.isInfinite() || p.isZero())
          return s.INFINITY;
        if (this.isZero() || p.isInfinite())
          return s.ZERO;
        l = this.re, v = this.im;
        var h = p.re, d = p.im, x, g;
        return d === 0 ? new s(l / h, v / h) : Math.abs(h) < Math.abs(d) ? (g = h / d, x = h * g + d, new s(
          (l * g + v) / x,
          (v * g - l) / x
        )) : (g = d / h, x = d * g + h, new s(
          (l + v * g) / x,
          (v - l * g) / x
        ));
      },
      /**
       * Calculate the power of two complex numbers
       *
       * @returns {Complex}
       */
      pow: function(l, v) {
        var p = new s(l, v);
        if (l = this.re, v = this.im, p.isZero())
          return s.ONE;
        if (p.im === 0) {
          if (v === 0 && l > 0)
            return new s(Math.pow(l, p.re), 0);
          if (l === 0)
            switch ((p.re % 4 + 4) % 4) {
              case 0:
                return new s(Math.pow(v, p.re), 0);
              case 1:
                return new s(0, Math.pow(v, p.re));
              case 2:
                return new s(-Math.pow(v, p.re), 0);
              case 3:
                return new s(0, -Math.pow(v, p.re));
            }
        }
        if (l === 0 && v === 0 && p.re > 0 && p.im >= 0)
          return s.ZERO;
        var h = Math.atan2(v, l), d = c(l, v);
        return l = Math.exp(p.re * d - p.im * h), v = p.im * d + p.re * h, new s(
          l * Math.cos(v),
          l * Math.sin(v)
        );
      },
      /**
       * Calculate the complex square root
       *
       * @returns {Complex}
       */
      sqrt: function() {
        var l = this.re, v = this.im, p = this.abs(), h, d;
        if (l >= 0) {
          if (v === 0)
            return new s(Math.sqrt(l), 0);
          h = 0.5 * Math.sqrt(2 * (p + l));
        } else
          h = Math.abs(v) / Math.sqrt(2 * (p - l));
        return l <= 0 ? d = 0.5 * Math.sqrt(2 * (p - l)) : d = Math.abs(v) / Math.sqrt(2 * (p + l)), new s(h, v < 0 ? -d : d);
      },
      /**
       * Calculate the complex exponent
       *
       * @returns {Complex}
       */
      exp: function() {
        var l = Math.exp(this.re);
        return this.im, new s(
          l * Math.cos(this.im),
          l * Math.sin(this.im)
        );
      },
      /**
       * Calculate the complex exponent and subtracts one.
       *
       * This may be more accurate than `Complex(x).exp().sub(1)` if
       * `x` is small.
       *
       * @returns {Complex}
       */
      expm1: function() {
        var l = this.re, v = this.im;
        return new s(
          Math.expm1(l) * Math.cos(v) + i(v),
          Math.exp(l) * Math.sin(v)
        );
      },
      /**
       * Calculate the natural log
       *
       * @returns {Complex}
       */
      log: function() {
        var l = this.re, v = this.im;
        return new s(
          c(l, v),
          Math.atan2(v, l)
        );
      },
      /**
       * Calculate the magnitude of the complex number
       *
       * @returns {number}
       */
      abs: function() {
        return u(this.re, this.im);
      },
      /**
       * Calculate the angle of the complex number
       *
       * @returns {number}
       */
      arg: function() {
        return Math.atan2(this.im, this.re);
      },
      /**
       * Calculate the sine of the complex number
       *
       * @returns {Complex}
       */
      sin: function() {
        var l = this.re, v = this.im;
        return new s(
          Math.sin(l) * n(v),
          Math.cos(l) * a(v)
        );
      },
      /**
       * Calculate the cosine
       *
       * @returns {Complex}
       */
      cos: function() {
        var l = this.re, v = this.im;
        return new s(
          Math.cos(l) * n(v),
          -Math.sin(l) * a(v)
        );
      },
      /**
       * Calculate the tangent
       *
       * @returns {Complex}
       */
      tan: function() {
        var l = 2 * this.re, v = 2 * this.im, p = Math.cos(l) + n(v);
        return new s(
          Math.sin(l) / p,
          a(v) / p
        );
      },
      /**
       * Calculate the cotangent
       *
       * @returns {Complex}
       */
      cot: function() {
        var l = 2 * this.re, v = 2 * this.im, p = Math.cos(l) - n(v);
        return new s(
          -Math.sin(l) / p,
          a(v) / p
        );
      },
      /**
       * Calculate the secant
       *
       * @returns {Complex}
       */
      sec: function() {
        var l = this.re, v = this.im, p = 0.5 * n(2 * v) + 0.5 * Math.cos(2 * l);
        return new s(
          Math.cos(l) * n(v) / p,
          Math.sin(l) * a(v) / p
        );
      },
      /**
       * Calculate the cosecans
       *
       * @returns {Complex}
       */
      csc: function() {
        var l = this.re, v = this.im, p = 0.5 * n(2 * v) - 0.5 * Math.cos(2 * l);
        return new s(
          Math.sin(l) * n(v) / p,
          -Math.cos(l) * a(v) / p
        );
      },
      /**
       * Calculate the complex arcus sinus
       *
       * @returns {Complex}
       */
      asin: function() {
        var l = this.re, v = this.im, p = new s(
          v * v - l * l + 1,
          -2 * l * v
        ).sqrt(), h = new s(
          p.re - v,
          p.im + l
        ).log();
        return new s(h.im, -h.re);
      },
      /**
       * Calculate the complex arcus cosinus
       *
       * @returns {Complex}
       */
      acos: function() {
        var l = this.re, v = this.im, p = new s(
          v * v - l * l + 1,
          -2 * l * v
        ).sqrt(), h = new s(
          p.re - v,
          p.im + l
        ).log();
        return new s(Math.PI / 2 - h.im, h.re);
      },
      /**
       * Calculate the complex arcus tangent
       *
       * @returns {Complex}
       */
      atan: function() {
        var l = this.re, v = this.im;
        if (l === 0) {
          if (v === 1)
            return new s(0, 1 / 0);
          if (v === -1)
            return new s(0, -1 / 0);
        }
        var p = l * l + (1 - v) * (1 - v), h = new s(
          (1 - v * v - l * l) / p,
          -2 * l / p
        ).log();
        return new s(-0.5 * h.im, 0.5 * h.re);
      },
      /**
       * Calculate the complex arcus cotangent
       *
       * @returns {Complex}
       */
      acot: function() {
        var l = this.re, v = this.im;
        if (v === 0)
          return new s(Math.atan2(1, l), 0);
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).atan() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).atan();
      },
      /**
       * Calculate the complex arcus secant
       *
       * @returns {Complex}
       */
      asec: function() {
        var l = this.re, v = this.im;
        if (l === 0 && v === 0)
          return new s(0, 1 / 0);
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).acos() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).acos();
      },
      /**
       * Calculate the complex arcus cosecans
       *
       * @returns {Complex}
       */
      acsc: function() {
        var l = this.re, v = this.im;
        if (l === 0 && v === 0)
          return new s(Math.PI / 2, 1 / 0);
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).asin() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).asin();
      },
      /**
       * Calculate the complex sinh
       *
       * @returns {Complex}
       */
      sinh: function() {
        var l = this.re, v = this.im;
        return new s(
          a(l) * Math.cos(v),
          n(l) * Math.sin(v)
        );
      },
      /**
       * Calculate the complex cosh
       *
       * @returns {Complex}
       */
      cosh: function() {
        var l = this.re, v = this.im;
        return new s(
          n(l) * Math.cos(v),
          a(l) * Math.sin(v)
        );
      },
      /**
       * Calculate the complex tanh
       *
       * @returns {Complex}
       */
      tanh: function() {
        var l = 2 * this.re, v = 2 * this.im, p = n(l) + Math.cos(v);
        return new s(
          a(l) / p,
          Math.sin(v) / p
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      coth: function() {
        var l = 2 * this.re, v = 2 * this.im, p = n(l) - Math.cos(v);
        return new s(
          a(l) / p,
          -Math.sin(v) / p
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      csch: function() {
        var l = this.re, v = this.im, p = Math.cos(2 * v) - n(2 * l);
        return new s(
          -2 * a(l) * Math.cos(v) / p,
          2 * n(l) * Math.sin(v) / p
        );
      },
      /**
       * Calculate the complex sech
       *
       * @returns {Complex}
       */
      sech: function() {
        var l = this.re, v = this.im, p = Math.cos(2 * v) + n(2 * l);
        return new s(
          2 * n(l) * Math.cos(v) / p,
          -2 * a(l) * Math.sin(v) / p
        );
      },
      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      asinh: function() {
        var l = this.im;
        this.im = -this.re, this.re = l;
        var v = this.asin();
        return this.re = -this.im, this.im = l, l = v.re, v.re = -v.im, v.im = l, v;
      },
      /**
       * Calculate the complex acosh
       *
       * @returns {Complex}
       */
      acosh: function() {
        var l = this.acos();
        if (l.im <= 0) {
          var v = l.re;
          l.re = -l.im, l.im = v;
        } else {
          var v = l.im;
          l.im = -l.re, l.re = v;
        }
        return l;
      },
      /**
       * Calculate the complex atanh
       *
       * @returns {Complex}
       */
      atanh: function() {
        var l = this.re, v = this.im, p = l > 1 && v === 0, h = 1 - l, d = 1 + l, x = h * h + v * v, g = x !== 0 ? new s(
          (d * h - v * v) / x,
          (v * h + d * v) / x
        ) : new s(
          l !== -1 ? l / 0 : 0,
          v !== 0 ? v / 0 : 0
        ), y = g.re;
        return g.re = c(g.re, g.im) / 2, g.im = Math.atan2(g.im, y) / 2, p && (g.im = -g.im), g;
      },
      /**
       * Calculate the complex acoth
       *
       * @returns {Complex}
       */
      acoth: function() {
        var l = this.re, v = this.im;
        if (l === 0 && v === 0)
          return new s(0, Math.PI / 2);
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).atanh() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).atanh();
      },
      /**
       * Calculate the complex acsch
       *
       * @returns {Complex}
       */
      acsch: function() {
        var l = this.re, v = this.im;
        if (v === 0)
          return new s(
            l !== 0 ? Math.log(l + Math.sqrt(l * l + 1)) : 1 / 0,
            0
          );
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).asinh() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).asinh();
      },
      /**
       * Calculate the complex asech
       *
       * @returns {Complex}
       */
      asech: function() {
        var l = this.re, v = this.im;
        if (this.isZero())
          return s.INFINITY;
        var p = l * l + v * v;
        return p !== 0 ? new s(
          l / p,
          -v / p
        ).acosh() : new s(
          l !== 0 ? l / 0 : 0,
          v !== 0 ? -v / 0 : 0
        ).acosh();
      },
      /**
       * Calculate the complex inverse 1/z
       *
       * @returns {Complex}
       */
      inverse: function() {
        if (this.isZero())
          return s.INFINITY;
        if (this.isInfinite())
          return s.ZERO;
        var l = this.re, v = this.im, p = l * l + v * v;
        return new s(l / p, -v / p);
      },
      /**
       * Returns the complex conjugate
       *
       * @returns {Complex}
       */
      conjugate: function() {
        return new s(this.re, -this.im);
      },
      /**
       * Gets the negated complex number
       *
       * @returns {Complex}
       */
      neg: function() {
        return new s(-this.re, -this.im);
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      ceil: function(l) {
        return l = Math.pow(10, l || 0), new s(
          Math.ceil(this.re * l) / l,
          Math.ceil(this.im * l) / l
        );
      },
      /**
       * Floors the actual complex number
       *
       * @returns {Complex}
       */
      floor: function(l) {
        return l = Math.pow(10, l || 0), new s(
          Math.floor(this.re * l) / l,
          Math.floor(this.im * l) / l
        );
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      round: function(l) {
        return l = Math.pow(10, l || 0), new s(
          Math.round(this.re * l) / l,
          Math.round(this.im * l) / l
        );
      },
      /**
       * Compares two complex numbers
       *
       * **Note:** new Complex(Infinity).equals(Infinity) === false
       *
       * @returns {boolean}
       */
      equals: function(l, v) {
        var p = new s(l, v);
        return Math.abs(p.re - this.re) <= s.EPSILON && Math.abs(p.im - this.im) <= s.EPSILON;
      },
      /**
       * Clones the actual object
       *
       * @returns {Complex}
       */
      clone: function() {
        return new s(this.re, this.im);
      },
      /**
       * Gets a string of the actual complex number
       *
       * @returns {string}
       */
      toString: function() {
        var l = this.re, v = this.im, p = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(l) < s.EPSILON && (l = 0), Math.abs(v) < s.EPSILON && (v = 0), v === 0 ? p + l : (l !== 0 ? (p += l, p += " ", v < 0 ? (v = -v, p += "-") : p += "+", p += " ") : v < 0 && (v = -v, p += "-"), v !== 1 && (p += v), p + "i"));
      },
      /**
       * Returns the actual number as a vector
       *
       * @returns {Array}
       */
      toVector: function() {
        return [this.re, this.im];
      },
      /**
       * Returns the actual real value of the current object
       *
       * @returns {number|null}
       */
      valueOf: function() {
        return this.im === 0 ? this.re : null;
      },
      /**
       * Determines whether a complex number is not on the Riemann sphere.
       *
       * @returns {boolean}
       */
      isNaN: function() {
        return isNaN(this.re) || isNaN(this.im);
      },
      /**
       * Determines whether or not a complex number is at the zero pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isZero: function() {
        return this.im === 0 && this.re === 0;
      },
      /**
       * Determines whether a complex number is not at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isFinite: function() {
        return isFinite(this.re) && isFinite(this.im);
      },
      /**
       * Determines whether or not a complex number is at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isInfinite: function() {
        return !(this.isNaN() || this.isFinite());
      }
    }, s.ZERO = new s(0, 0), s.ONE = new s(1, 0), s.I = new s(0, 1), s.PI = new s(Math.PI, 0), s.E = new s(Math.E, 0), s.INFINITY = new s(1 / 0, 1 / 0), s.NAN = new s(NaN, NaN), s.EPSILON = 1e-15, Object.defineProperty(s, "__esModule", { value: !0 }), s.default = s, s.Complex = s, r.exports = s;
  })();
})(W2);
var v7 = W2.exports;
const et = /* @__PURE__ */ Ln(v7);
var p7 = "Complex", d7 = [], xu = /* @__PURE__ */ U(p7, d7, () => (Object.defineProperty(et, "name", {
  value: "Complex"
}), et.prototype.constructor = et, et.prototype.type = "Complex", et.prototype.isComplex = !0, et.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, et.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, et.prototype.format = function(r) {
  var e = "", t = this.im, n = this.re, a = wa(this.re, r), i = wa(this.im, r), u = Xe(r) ? r : r ? r.precision : null;
  if (u !== null) {
    var f = Math.pow(10, -u);
    Math.abs(n / t) < f && (n = 0), Math.abs(t / n) < f && (t = 0);
  }
  return t === 0 ? e = a : n === 0 ? t === 1 ? e = "i" : t === -1 ? e = "-i" : e = i + "i" : t < 0 ? t === -1 ? e = a + " - i" : e = a + " - " + i.substring(1) + "i" : t === 1 ? e = a + " + i" : e = a + " + " + i + "i", e;
}, et.fromPolar = function(r) {
  switch (arguments.length) {
    case 1: {
      var e = arguments[0];
      if (typeof e == "object")
        return et(e);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var t = arguments[0], n = arguments[1];
      if (Xe(t)) {
        if (yt(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), Xe(n))
          return new et({
            r: t,
            phi: n
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, et.prototype.valueOf = et.prototype.toString, et.fromJSON = function(r) {
  return new et(r);
}, et.compare = function(r, e) {
  return r.re > e.re ? 1 : r.re < e.re ? -1 : r.im > e.im ? 1 : r.im < e.im ? -1 : 0;
}, et), {
  isClass: !0
}), K2 = { exports: {} };
/**
 * @license Fraction.js v4.3.0 20/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(r, e) {
  (function(t) {
    var n = 2e3, a = {
      s: 1,
      n: 0,
      d: 1
    };
    function i(g, y) {
      if (isNaN(g = parseInt(g, 10)))
        throw d();
      return g * y;
    }
    function u(g, y) {
      if (y === 0)
        throw h();
      var m = Object.create(p.prototype);
      m.s = g < 0 ? -1 : 1, g = g < 0 ? -g : g;
      var b = v(g, y);
      return m.n = g / b, m.d = y / b, m;
    }
    function f(g) {
      for (var y = {}, m = g, b = 2, w = 4; w <= m; ) {
        for (; m % b === 0; )
          m /= b, y[b] = (y[b] || 0) + 1;
        w += 1 + 2 * b++;
      }
      return m !== g ? m > 1 && (y[m] = (y[m] || 0) + 1) : y[g] = (y[g] || 0) + 1, y;
    }
    var c = function(g, y) {
      var m = 0, b = 1, w = 1, A = 0, E = 0, N = 0, C = 1, D = 1, B = 0, S = 1, F = 1, I = 1, z = 1e7, P;
      if (g != null)
        if (y !== void 0) {
          if (m = g, b = y, w = m * b, m % 1 !== 0 || b % 1 !== 0)
            throw x();
        } else
          switch (typeof g) {
            case "object": {
              if ("d" in g && "n" in g)
                m = g.n, b = g.d, "s" in g && (m *= g.s);
              else if (0 in g)
                m = g[0], 1 in g && (b = g[1]);
              else
                throw d();
              w = m * b;
              break;
            }
            case "number": {
              if (g < 0 && (w = g, g = -g), g % 1 === 0)
                m = g;
              else if (g > 0) {
                for (g >= 1 && (D = Math.pow(10, Math.floor(1 + Math.log(g) / Math.LN10)), g /= D); S <= z && I <= z; )
                  if (P = (B + F) / (S + I), g === P) {
                    S + I <= z ? (m = B + F, b = S + I) : I > S ? (m = F, b = I) : (m = B, b = S);
                    break;
                  } else
                    g > P ? (B += F, S += I) : (F += B, I += S), S > z ? (m = F, b = I) : (m = B, b = S);
                m *= D;
              } else
                (isNaN(g) || isNaN(y)) && (b = m = NaN);
              break;
            }
            case "string": {
              if (S = g.match(/\d+|./g), S === null)
                throw d();
              if (S[B] === "-" ? (w = -1, B++) : S[B] === "+" && B++, S.length === B + 1 ? E = i(S[B++], w) : S[B + 1] === "." || S[B] === "." ? (S[B] !== "." && (A = i(S[B++], w)), B++, (B + 1 === S.length || S[B + 1] === "(" && S[B + 3] === ")" || S[B + 1] === "'" && S[B + 3] === "'") && (E = i(S[B], w), C = Math.pow(10, S[B].length), B++), (S[B] === "(" && S[B + 2] === ")" || S[B] === "'" && S[B + 2] === "'") && (N = i(S[B + 1], w), D = Math.pow(10, S[B + 1].length) - 1, B += 3)) : S[B + 1] === "/" || S[B + 1] === ":" ? (E = i(S[B], w), C = i(S[B + 2], 1), B += 3) : S[B + 3] === "/" && S[B + 1] === " " && (A = i(S[B], w), E = i(S[B + 2], w), C = i(S[B + 4], 1), B += 5), S.length <= B) {
                b = C * D, w = /* void */
                m = N + b * A + D * E;
                break;
              }
            }
            default:
              throw d();
          }
      if (b === 0)
        throw h();
      a.s = w < 0 ? -1 : 1, a.n = Math.abs(m), a.d = Math.abs(b);
    };
    function o(g, y, m) {
      for (var b = 1; y > 0; g = g * g % m, y >>= 1)
        y & 1 && (b = b * g % m);
      return b;
    }
    function s(g, y) {
      for (; y % 2 === 0; y /= 2)
        ;
      for (; y % 5 === 0; y /= 5)
        ;
      if (y === 1)
        return 0;
      for (var m = 10 % y, b = 1; m !== 1; b++)
        if (m = m * 10 % y, b > n)
          return 0;
      return b;
    }
    function l(g, y, m) {
      for (var b = 1, w = o(10, m, y), A = 0; A < 300; A++) {
        if (b === w)
          return A;
        b = b * 10 % y, w = w * 10 % y;
      }
      return 0;
    }
    function v(g, y) {
      if (!g)
        return y;
      if (!y)
        return g;
      for (; ; ) {
        if (g %= y, !g)
          return y;
        if (y %= g, !y)
          return g;
      }
    }
    function p(g, y) {
      if (c(g, y), this instanceof p)
        g = v(a.d, a.n), this.s = a.s, this.n = a.n / g, this.d = a.d / g;
      else
        return u(a.s * a.n, a.d);
    }
    var h = function() {
      return new Error("Division by Zero");
    }, d = function() {
      return new Error("Invalid argument");
    }, x = function() {
      return new Error("Parameters must be integer");
    };
    p.prototype = {
      s: 1,
      n: 0,
      d: 1,
      /**
       * Calculates the absolute value
       *
       * Ex: new Fraction(-4).abs() => 4
       **/
      abs: function() {
        return u(this.n, this.d);
      },
      /**
       * Inverts the sign of the current fraction
       *
       * Ex: new Fraction(-4).neg() => 4
       **/
      neg: function() {
        return u(-this.s * this.n, this.d);
      },
      /**
       * Adds two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
       **/
      add: function(g, y) {
        return c(g, y), u(
          this.s * this.n * a.d + a.s * this.d * a.n,
          this.d * a.d
        );
      },
      /**
       * Subtracts two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
       **/
      sub: function(g, y) {
        return c(g, y), u(
          this.s * this.n * a.d - a.s * this.d * a.n,
          this.d * a.d
        );
      },
      /**
       * Multiplies two rational numbers
       *
       * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
       **/
      mul: function(g, y) {
        return c(g, y), u(
          this.s * a.s * this.n * a.n,
          this.d * a.d
        );
      },
      /**
       * Divides two rational numbers
       *
       * Ex: new Fraction("-17.(345)").inverse().div(3)
       **/
      div: function(g, y) {
        return c(g, y), u(
          this.s * a.s * this.n * a.d,
          this.d * a.n
        );
      },
      /**
       * Clones the actual object
       *
       * Ex: new Fraction("-17.(345)").clone()
       **/
      clone: function() {
        return u(this.s * this.n, this.d);
      },
      /**
       * Calculates the modulo of two rational numbers - a more precise fmod
       *
       * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
       **/
      mod: function(g, y) {
        if (isNaN(this.n) || isNaN(this.d))
          return new p(NaN);
        if (g === void 0)
          return u(this.s * this.n % this.d, 1);
        if (c(g, y), a.n === 0 && this.d === 0)
          throw h();
        return u(
          this.s * (a.d * this.n) % (a.n * this.d),
          a.d * this.d
        );
      },
      /**
       * Calculates the fractional gcd of two rational numbers
       *
       * Ex: new Fraction(5,8).gcd(3,7) => 1/56
       */
      gcd: function(g, y) {
        return c(g, y), u(v(a.n, this.n) * v(a.d, this.d), a.d * this.d);
      },
      /**
       * Calculates the fractional lcm of two rational numbers
       *
       * Ex: new Fraction(5,8).lcm(3,7) => 15
       */
      lcm: function(g, y) {
        return c(g, y), a.n === 0 && this.n === 0 ? u(0, 1) : u(a.n * this.n, v(a.n, this.n) * v(a.d, this.d));
      },
      /**
       * Calculates the ceil of a rational number
       *
       * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
       **/
      ceil: function(g) {
        return g = Math.pow(10, g || 0), isNaN(this.n) || isNaN(this.d) ? new p(NaN) : u(Math.ceil(g * this.s * this.n / this.d), g);
      },
      /**
       * Calculates the floor of a rational number
       *
       * Ex: new Fraction('4.(3)').floor() => (4 / 1)
       **/
      floor: function(g) {
        return g = Math.pow(10, g || 0), isNaN(this.n) || isNaN(this.d) ? new p(NaN) : u(Math.floor(g * this.s * this.n / this.d), g);
      },
      /**
       * Rounds a rational numbers
       *
       * Ex: new Fraction('4.(3)').round() => (4 / 1)
       **/
      round: function(g) {
        return g = Math.pow(10, g || 0), isNaN(this.n) || isNaN(this.d) ? new p(NaN) : u(Math.round(g * this.s * this.n / this.d), g);
      },
      /**
       * Gets the inverse of the fraction, means numerator and denominator are exchanged
       *
       * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
       **/
      inverse: function() {
        return u(this.s * this.d, this.n);
      },
      /**
       * Calculates the fraction to some rational exponent, if possible
       *
       * Ex: new Fraction(-1,2).pow(-3) => -8
       */
      pow: function(g, y) {
        if (c(g, y), a.d === 1)
          return a.s < 0 ? u(Math.pow(this.s * this.d, a.n), Math.pow(this.n, a.n)) : u(Math.pow(this.s * this.n, a.n), Math.pow(this.d, a.n));
        if (this.s < 0)
          return null;
        var m = f(this.n), b = f(this.d), w = 1, A = 1;
        for (var E in m)
          if (E !== "1") {
            if (E === "0") {
              w = 0;
              break;
            }
            if (m[E] *= a.n, m[E] % a.d === 0)
              m[E] /= a.d;
            else
              return null;
            w *= Math.pow(E, m[E]);
          }
        for (var E in b)
          if (E !== "1") {
            if (b[E] *= a.n, b[E] % a.d === 0)
              b[E] /= a.d;
            else
              return null;
            A *= Math.pow(E, b[E]);
          }
        return a.s < 0 ? u(A, w) : u(w, A);
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      equals: function(g, y) {
        return c(g, y), this.s * this.n * a.d === a.s * a.n * this.d;
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      compare: function(g, y) {
        c(g, y);
        var m = this.s * this.n * a.d - a.s * a.n * this.d;
        return (0 < m) - (m < 0);
      },
      simplify: function(g) {
        if (isNaN(this.n) || isNaN(this.d))
          return this;
        g = g || 1e-3;
        for (var y = this.abs(), m = y.toContinued(), b = 1; b < m.length; b++) {
          for (var w = u(m[b - 1], 1), A = b - 2; A >= 0; A--)
            w = w.inverse().add(m[A]);
          if (Math.abs(w.sub(y).valueOf()) < g)
            return w.mul(this.s);
        }
        return this;
      },
      /**
       * Check if two rational numbers are divisible
       *
       * Ex: new Fraction(19.6).divisible(1.5);
       */
      divisible: function(g, y) {
        return c(g, y), !(!(a.n * this.d) || this.n * a.d % (a.n * this.d));
      },
      /**
       * Returns a decimal representation of the fraction
       *
       * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
       **/
      valueOf: function() {
        return this.s * this.n / this.d;
      },
      /**
       * Returns a string-fraction representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
       **/
      toFraction: function(g) {
        var y, m = "", b = this.n, w = this.d;
        return this.s < 0 && (m += "-"), w === 1 ? m += b : (g && (y = Math.floor(b / w)) > 0 && (m += y, m += " ", b %= w), m += b, m += "/", m += w), m;
      },
      /**
       * Returns a latex representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
       **/
      toLatex: function(g) {
        var y, m = "", b = this.n, w = this.d;
        return this.s < 0 && (m += "-"), w === 1 ? m += b : (g && (y = Math.floor(b / w)) > 0 && (m += y, b %= w), m += "\\frac{", m += b, m += "}{", m += w, m += "}"), m;
      },
      /**
       * Returns an array of continued fraction elements
       *
       * Ex: new Fraction("7/8").toContinued() => [0,1,7]
       */
      toContinued: function() {
        var g, y = this.n, m = this.d, b = [];
        if (isNaN(y) || isNaN(m))
          return b;
        do
          b.push(Math.floor(y / m)), g = y % m, y = m, m = g;
        while (y !== 1);
        return b;
      },
      /**
       * Creates a string representation of a fraction with all digits
       *
       * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
       **/
      toString: function(g) {
        var y = this.n, m = this.d;
        if (isNaN(y) || isNaN(m))
          return "NaN";
        g = g || 15;
        var b = s(y, m), w = l(y, m, b), A = this.s < 0 ? "-" : "";
        if (A += y / m | 0, y %= m, y *= 10, y && (A += "."), b) {
          for (var E = w; E--; )
            A += y / m | 0, y %= m, y *= 10;
          A += "(";
          for (var E = b; E--; )
            A += y / m | 0, y %= m, y *= 10;
          A += ")";
        } else
          for (var E = g; y && E--; )
            A += y / m | 0, y %= m, y *= 10;
        return A;
      }
    }, Object.defineProperty(p, "__esModule", { value: !0 }), p.default = p, p.Fraction = p, r.exports = p;
  })();
})(K2);
var m7 = K2.exports;
const Mn = /* @__PURE__ */ Ln(m7);
var h7 = "Fraction", g7 = [], yu = /* @__PURE__ */ U(h7, g7, () => (Object.defineProperty(Mn, "name", {
  value: "Fraction"
}), Mn.prototype.constructor = Mn, Mn.prototype.type = "Fraction", Mn.prototype.isFraction = !0, Mn.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: this.s * this.n,
    d: this.d
  };
}, Mn.fromJSON = function(r) {
  return new Mn(r);
}, Mn), {
  isClass: !0
}), x7 = "Range", y7 = [], Au = /* @__PURE__ */ U(x7, y7, () => {
  function r(e, t, n) {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    var a = e != null, i = t != null, u = n != null;
    if (a) {
      if (Ue(e))
        e = e.toNumber();
      else if (typeof e != "number")
        throw new TypeError("Parameter start must be a number");
    }
    if (i) {
      if (Ue(t))
        t = t.toNumber();
      else if (typeof t != "number")
        throw new TypeError("Parameter end must be a number");
    }
    if (u) {
      if (Ue(n))
        n = n.toNumber();
      else if (typeof n != "number")
        throw new TypeError("Parameter step must be a number");
    }
    this.start = a ? parseFloat(e) : 0, this.end = i ? parseFloat(t) : 0, this.step = u ? parseFloat(n) : 1;
  }
  return r.prototype.type = "Range", r.prototype.isRange = !0, r.parse = function(e) {
    if (typeof e != "string")
      return null;
    var t = e.split(":"), n = t.map(function(i) {
      return parseFloat(i);
    }), a = n.some(function(i) {
      return isNaN(i);
    });
    if (a)
      return null;
    switch (n.length) {
      case 2:
        return new r(n[0], n[1]);
      case 3:
        return new r(n[0], n[2], n[1]);
      default:
        return null;
    }
  }, r.prototype.clone = function() {
    return new r(this.start, this.end, this.step);
  }, r.prototype.size = function() {
    var e = 0, t = this.start, n = this.step, a = this.end, i = a - t;
    return _n(n) === _n(i) ? e = Math.ceil(i / n) : i === 0 && (e = 0), isNaN(e) && (e = 0), [e];
  }, r.prototype.min = function() {
    var e = this.size()[0];
    if (e > 0)
      return this.step > 0 ? this.start : this.start + (e - 1) * this.step;
  }, r.prototype.max = function() {
    var e = this.size()[0];
    if (e > 0)
      return this.step > 0 ? this.start + (e - 1) * this.step : this.start;
  }, r.prototype.forEach = function(e) {
    var t = this.start, n = this.step, a = this.end, i = 0;
    if (n > 0)
      for (; t < a; )
        e(t, [i], this), t += n, i++;
    else if (n < 0)
      for (; t > a; )
        e(t, [i], this), t += n, i++;
  }, r.prototype.map = function(e) {
    var t = [];
    return this.forEach(function(n, a, i) {
      t[a[0]] = e(n, a, i);
    }), t;
  }, r.prototype.toArray = function() {
    var e = [];
    return this.forEach(function(t, n) {
      e[n[0]] = t;
    }), e;
  }, r.prototype.valueOf = function() {
    return this.toArray();
  }, r.prototype.format = function(e) {
    var t = wa(this.start, e);
    return this.step !== 1 && (t += ":" + wa(this.step, e)), t += ":" + wa(this.end, e), t;
  }, r.prototype.toString = function() {
    return this.format();
  }, r.prototype.toJSON = function() {
    return {
      mathjs: "Range",
      start: this.start,
      end: this.end,
      step: this.step
    };
  }, r.fromJSON = function(e) {
    return new r(e.start, e.end, e.step);
  }, r;
}, {
  isClass: !0
}), A7 = "Matrix", b7 = [], bu = /* @__PURE__ */ U(A7, b7, () => {
  function r() {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return r.prototype.type = "Matrix", r.prototype.isMatrix = !0, r.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, r.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, r.prototype.create = function(e, t) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, r.prototype.subset = function(e, t, n) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, r.prototype.get = function(e) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, r.prototype.set = function(e, t, n) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, r.prototype.resize = function(e, t) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, r.prototype.reshape = function(e, t) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, r.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, r.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, r.prototype.map = function(e, t) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, r.prototype.forEach = function(e) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, r.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, r.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, r.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, r.prototype.format = function(e) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, r.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, r;
}, {
  isClass: !0
});
function bm(r, e, t) {
  var n = r.constructor, a = new n(2), i = "";
  if (t) {
    if (t < 1)
      throw new Error("size must be in greater than 0");
    if (!Me(t))
      throw new Error("size must be an integer");
    if (r.greaterThan(a.pow(t - 1).sub(1)) || r.lessThan(a.pow(t - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(t - 1, ", 2^").concat(t - 1, "-1]"));
    if (!r.isInteger())
      throw new Error("Value must be an integer");
    r.lessThan(0) && (r = r.add(a.pow(t))), i = "i".concat(t);
  }
  switch (e) {
    case 2:
      return "".concat(r.toBinary()).concat(i);
    case 8:
      return "".concat(r.toOctal()).concat(i);
    case 16:
      return "".concat(r.toHexadecimal()).concat(i);
    default:
      throw new Error("Base ".concat(e, " not supported "));
  }
}
function w7(r, e) {
  if (typeof e == "function")
    return e(r);
  if (!r.isFinite())
    return r.isNaN() ? "NaN" : r.gt(0) ? "Infinity" : "-Infinity";
  var {
    notation: t,
    precision: n,
    wordSize: a
  } = S2(e);
  switch (t) {
    case "fixed":
      return C7(r, n);
    case "exponential":
      return Ex(r, n);
    case "engineering":
      return D7(r, n);
    case "bin":
      return bm(r, 2, a);
    case "oct":
      return bm(r, 8, a);
    case "hex":
      return bm(r, 16, a);
    case "auto": {
      var i = Nx(e == null ? void 0 : e.lowerExp, -3), u = Nx(e == null ? void 0 : e.upperExp, 5);
      if (r.isZero())
        return "0";
      var f, c = r.toSignificantDigits(n), o = c.e;
      return o >= i && o < u ? f = c.toFixed() : f = Ex(r, n), f.replace(/((\.\d*?)(0+))($|e)/, function() {
        var s = arguments[2], l = arguments[4];
        return s !== "." ? s + l : l;
      });
    }
    default:
      throw new Error('Unknown notation "' + t + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function D7(r, e) {
  var t = r.e, n = t % 3 === 0 ? t : t < 0 ? t - 3 - t % 3 : t - t % 3, a = r.mul(Math.pow(10, -n)), i = a.toPrecision(e);
  if (i.includes("e")) {
    var u = r.constructor;
    i = new u(i).toFixed();
  }
  return i + "e" + (t >= 0 ? "+" : "") + n.toString();
}
function Ex(r, e) {
  return e !== void 0 ? r.toExponential(e - 1) : r.toExponential();
}
function C7(r, e) {
  return r.toFixed(e);
}
function Nx(r, e) {
  return Xe(r) ? r : Ue(r) ? r.toNumber() : e;
}
function E7(r, e) {
  var t = r.length - e.length, n = r.length;
  return r.substring(t, n) === e;
}
function Ke(r, e) {
  var t = N7(r, e);
  return e && typeof e == "object" && "truncate" in e && t.length > e.truncate ? t.substring(0, e.truncate - 3) + "..." : t;
}
function N7(r, e) {
  if (typeof r == "number")
    return wa(r, e);
  if (Ue(r))
    return w7(r, e);
  if (B7(r))
    return !e || e.fraction !== "decimal" ? r.s * r.n + "/" + r.d : r.toString();
  if (Array.isArray(r))
    return J2(r, e);
  if (Wr(r))
    return $a(r);
  if (typeof r == "function")
    return r.syntax ? String(r.syntax) : "function";
  if (r && typeof r == "object") {
    if (typeof r.format == "function")
      return r.format(e);
    if (r && r.toString(e) !== {}.toString())
      return r.toString(e);
    var t = Object.keys(r).map((n) => $a(n) + ": " + Ke(r[n], e));
    return "{" + t.join(", ") + "}";
  }
  return String(r);
}
function $a(r) {
  for (var e = String(r), t = "", n = 0; n < e.length; ) {
    var a = e.charAt(n);
    t += a in Bx ? Bx[a] : a, n++;
  }
  return '"' + t + '"';
}
var Bx = {
  '"': '\\"',
  "\\": "\\\\",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
function Zt(r) {
  var e = String(r);
  return e = e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), e;
}
function J2(r, e) {
  if (Array.isArray(r)) {
    for (var t = "[", n = r.length, a = 0; a < n; a++)
      a !== 0 && (t += ", "), t += J2(r[a], e);
    return t += "]", t;
  } else
    return Ke(r, e);
}
function B7(r) {
  return r && typeof r == "object" && typeof r.s == "number" && typeof r.n == "number" && typeof r.d == "number" || !1;
}
function Im(r, e) {
  if (!Wr(r))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + br(r) + ", index: 0)");
  if (!Wr(e))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + br(e) + ", index: 1)");
  return r === e ? 0 : r > e ? 1 : -1;
}
function Ye(r, e, t) {
  if (!(this instanceof Ye))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = r, this.expected = e, this.relation = t, this.message = "Dimension mismatch (" + (Array.isArray(r) ? "[" + r.join(", ") + "]" : r) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = new Error().stack;
}
Ye.prototype = new RangeError();
Ye.prototype.constructor = RangeError;
Ye.prototype.name = "DimensionError";
Ye.prototype.isDimensionError = !0;
function Ut(r, e, t) {
  if (!(this instanceof Ut))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = r, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = t), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
Ut.prototype = new RangeError();
Ut.prototype.constructor = RangeError;
Ut.prototype.name = "IndexError";
Ut.prototype.isIndexError = !0;
function Ve(r) {
  for (var e = []; Array.isArray(r); )
    e.push(r.length), r = r[0];
  return e;
}
function _2(r, e, t) {
  var n, a = r.length;
  if (a !== e[t])
    throw new Ye(a, e[t]);
  if (t < e.length - 1) {
    var i = t + 1;
    for (n = 0; n < a; n++) {
      var u = r[n];
      if (!Array.isArray(u))
        throw new Ye(e.length - 1, e.length, "<");
      _2(r[n], e, i);
    }
  } else
    for (n = 0; n < a; n++)
      if (Array.isArray(r[n]))
        throw new Ye(e.length + 1, e.length, ">");
}
function Sx(r, e) {
  var t = e.length === 0;
  if (t) {
    if (Array.isArray(r))
      throw new Ye(r.length, 0);
  } else
    _2(r, e, 0);
}
function zs(r, e) {
  var t = r.isMatrix ? r._size : Ve(r), n = e._sourceSize;
  n.forEach((a, i) => {
    if (a !== null && a !== t[i])
      throw new Ye(a, t[i]);
  });
}
function yr(r, e) {
  if (r !== void 0) {
    if (!Xe(r) || !Me(r))
      throw new TypeError("Index must be an integer (value: " + r + ")");
    if (r < 0 || typeof e == "number" && r >= e)
      throw new Ut(r, e);
  }
}
function ci(r) {
  for (var e = 0; e < r._dimensions.length; ++e) {
    var t = r._dimensions[e];
    if (t._data && ur(t._data)) {
      if (t._size[0] === 0)
        return !0;
    } else if (t.isRange) {
      if (t.start === t.end)
        return !0;
    } else if (Wr(t) && t.length === 0)
      return !0;
  }
  return !1;
}
function li(r, e, t) {
  if (!Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Error("Resizing to scalar is not supported");
  e.forEach(function(a) {
    if (!Xe(a) || !Me(a) || a < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + Ke(e) + ")");
  }), (Xe(r) || Ue(r)) && (r = [r]);
  var n = t !== void 0 ? t : 0;
  return Hm(r, e, 0, n), r;
}
function Hm(r, e, t, n) {
  var a, i, u = r.length, f = e[t], c = Math.min(u, f);
  if (r.length = f, t < e.length - 1) {
    var o = t + 1;
    for (a = 0; a < c; a++)
      i = r[a], Array.isArray(i) || (i = [i], r[a] = i), Hm(i, e, o, n);
    for (a = c; a < f; a++)
      i = [], r[a] = i, Hm(i, e, o, n);
  } else {
    for (a = 0; a < c; a++)
      for (; Array.isArray(r[a]); )
        r[a] = r[a][0];
    for (a = c; a < f; a++)
      r[a] = n;
  }
}
function xh(r, e) {
  var t = cr(r), n = t.length;
  if (!Array.isArray(r) || !Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Ye(0, n, "!=");
  e = yh(e, n);
  var a = $2(e);
  if (n !== a)
    throw new Ye(a, n, "!=");
  try {
    return S7(t, e);
  } catch (i) {
    throw i instanceof Ye ? new Ye(a, n, "!=") : i;
  }
}
function yh(r, e) {
  var t = $2(r), n = r.slice(), a = -1, i = r.indexOf(a), u = r.indexOf(a, i + 1) >= 0;
  if (u)
    throw new Error("More than one wildcard in sizes");
  var f = i >= 0, c = e % t === 0;
  if (f)
    if (c)
      n[i] = -e / t;
    else
      throw new Error("Could not replace wildcard, since " + e + " is no multiple of " + -t);
  return n;
}
function $2(r) {
  return r.reduce((e, t) => e * t, 1);
}
function S7(r, e) {
  for (var t = r, n, a = e.length - 1; a > 0; a--) {
    var i = e[a];
    n = [];
    for (var u = t.length / i, f = 0; f < u; f++)
      n.push(t.slice(f * i, (f + 1) * i));
    t = n;
  }
  return t;
}
function Rs(r, e) {
  for (var t = e || Ve(r); Array.isArray(r) && r.length === 1; )
    r = r[0], t.shift();
  for (var n = t.length; t[n - 1] === 1; )
    n--;
  return n < t.length && (r = eD(r, n, 0), t.length = n), r;
}
function eD(r, e, t) {
  var n, a;
  if (t < e) {
    var i = t + 1;
    for (n = 0, a = r.length; n < a; n++)
      r[n] = eD(r[n], e, i);
  } else
    for (; Array.isArray(r); )
      r = r[0];
  return r;
}
function rD(r, e, t, n) {
  var a = n || Ve(r);
  if (t)
    for (var i = 0; i < t; i++)
      r = [r], a.unshift(1);
  for (r = tD(r, e, 0); a.length < e; )
    a.push(1);
  return r;
}
function tD(r, e, t) {
  var n, a;
  if (Array.isArray(r)) {
    var i = t + 1;
    for (n = 0, a = r.length; n < a; n++)
      r[n] = tD(r[n], e, i);
  } else
    for (var u = t; u < e; u++)
      r = [r];
  return r;
}
function cr(r) {
  if (!Array.isArray(r))
    return r;
  var e = [];
  return r.forEach(function t(n) {
    Array.isArray(n) ? n.forEach(t) : e.push(n);
  }), e;
}
function Rn(r, e) {
  return Array.prototype.map.call(r, e);
}
function wu(r, e) {
  Array.prototype.forEach.call(r, e);
}
function nD(r, e) {
  if (Ve(r).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(r, e);
}
function Is(r, e) {
  if (Ve(r).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(r, (t) => e.test(t));
}
function Px(r, e) {
  return Array.prototype.join.call(r, e);
}
function fi(r) {
  if (!Array.isArray(r))
    throw new TypeError("Array input expected");
  if (r.length === 0)
    return r;
  var e = [], t = 0;
  e[0] = {
    value: r[0],
    identifier: 0
  };
  for (var n = 1; n < r.length; n++)
    r[n] === r[n - 1] ? t++ : t = 0, e.push({
      value: r[n],
      identifier: t
    });
  return e;
}
function Hs(r) {
  if (!Array.isArray(r))
    throw new TypeError("Array input expected");
  if (r.length === 0)
    return r;
  for (var e = [], t = 0; t < r.length; t++)
    e.push(r[t].value);
  return e;
}
function ro(r, e) {
  for (var t, n = 0, a = 0; a < r.length; a++) {
    var i = r[a], u = Array.isArray(i);
    if (a === 0 && u && (n = i.length), u && i.length !== n)
      return;
    var f = u ? ro(i, e) : e(i);
    if (t === void 0)
      t = f;
    else if (t !== f)
      return "mixed";
  }
  return t;
}
function aD(r, e, t, n) {
  if (n < t) {
    if (r.length !== e.length)
      throw new Ye(r.length, e.length);
    for (var a = [], i = 0; i < r.length; i++)
      a[i] = aD(r[i], e[i], t, n + 1);
    return a;
  } else
    return r.concat(e);
}
function iD() {
  var r = Array.prototype.slice.call(arguments, 0, -1), e = Array.prototype.slice.call(arguments, -1);
  if (r.length === 1)
    return r[0];
  if (r.length > 1)
    return r.slice(1).reduce(function(t, n) {
      return aD(t, n, e, 0);
    }, r[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function P7() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  for (var n = e.map((v) => v.length), a = Math.max(...n), i = new Array(a).fill(null), u = 0; u < e.length; u++)
    for (var f = e[u], c = n[u], o = 0; o < c; o++) {
      var s = a - c + o;
      f[o] > i[s] && (i[s] = f[o]);
    }
  for (var l = 0; l < e.length; l++)
    Ls(e[l], i);
  return i;
}
function Ls(r, e) {
  for (var t = e.length, n = r.length, a = 0; a < n; a++) {
    var i = t - n + a;
    if (r[a] < e[i] && r[a] > 1 || r[a] > e[i])
      throw new Error("shape missmatch: missmatch is found in arg with shape (".concat(r, ") not possible to broadcast dimension ").concat(n, " with size ").concat(r[a], " to size ").concat(e[i]));
  }
}
function Mx(r, e) {
  var t = Ve(r);
  if (Da(t, e))
    return r;
  Ls(t, e);
  var n = P7(t, e), a = n.length, i = [...Array(a - t.length).fill(1), ...t], u = F7(r);
  t.length < a && (u = xh(u, i), t = Ve(u));
  for (var f = 0; f < a; f++)
    t[f] < n[f] && (u = M7(u, n[f], f), t = Ve(u));
  return u;
}
function M7(r, e, t) {
  return iD(...Array(e).fill(r), t);
}
function F7(r) {
  return Lr([], r);
}
function T7(r) {
  var e = 0, t = 1, n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), i = 0, u = function(c) {
    var o = a[c];
    if (o && (delete n[o], delete a[c], --e, t === o)) {
      if (!e) {
        i = 0, t = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(n, ++t); )
        ;
    }
  };
  return r = Math.abs(r), {
    hit: function(c) {
      var o = a[c], s = ++i;
      if (n[s] = c, a[c] = s, !o)
        return ++e, e <= r ? void 0 : (c = n[t], u(c), c);
      if (delete n[o], t === o)
        for (; !Object.prototype.hasOwnProperty.call(n, ++t); )
          ;
    },
    delete: u,
    clear: function() {
      e = i = 0, t = 1, n = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null);
    }
  };
}
function co(r) {
  var {
    hasher: e,
    limit: t
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return t = t ?? Number.POSITIVE_INFINITY, e = e ?? JSON.stringify, function n() {
    typeof n.cache != "object" && (n.cache = {
      values: /* @__PURE__ */ new Map(),
      lru: T7(t || Number.POSITIVE_INFINITY)
    });
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    var u = e(a);
    if (n.cache.values.has(u))
      return n.cache.lru.hit(u), n.cache.values.get(u);
    var f = r.apply(r, a);
    return n.cache.values.set(u, f), n.cache.values.delete(n.cache.lru.hit(u)), f;
  };
}
function oD(r) {
  return Object.keys(r.signatures || {}).reduce(function(e, t) {
    var n = (t.match(/,/g) || []).length + 1;
    return Math.max(e, n);
  }, -1);
}
var O7 = "DenseMatrix", z7 = ["Matrix"], Du = /* @__PURE__ */ U(O7, z7, (r) => {
  var {
    Matrix: e
  } = r;
  function t(s, l) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (l && !Wr(l))
      throw new Error("Invalid datatype: " + l);
    if (Oe(s))
      s.type === "DenseMatrix" ? (this._data = Ie(s._data), this._size = Ie(s._size), this._datatype = l || s._datatype) : (this._data = s.toArray(), this._size = s.size(), this._datatype = l || s._datatype);
    else if (s && ur(s.data) && ur(s.size))
      this._data = s.data, this._size = s.size, Sx(this._data, this._size), this._datatype = l || s.datatype;
    else if (ur(s))
      this._data = o(s), this._size = Ve(this._data), Sx(this._data, this._size), this._datatype = l;
    else {
      if (s)
        throw new TypeError("Unsupported type of data (" + br(s) + ")");
      this._data = [], this._size = [0], this._datatype = l;
    }
  }
  t.prototype = new e(), t.prototype.createDenseMatrix = function(s, l) {
    return new t(s, l);
  }, Object.defineProperty(t, "name", {
    value: "DenseMatrix"
  }), t.prototype.constructor = t, t.prototype.type = "DenseMatrix", t.prototype.isDenseMatrix = !0, t.prototype.getDataType = function() {
    return ro(this._data, br);
  }, t.prototype.storage = function() {
    return "dense";
  }, t.prototype.datatype = function() {
    return this._datatype;
  }, t.prototype.create = function(s, l) {
    return new t(s, l);
  }, t.prototype.subset = function(s, l, v) {
    switch (arguments.length) {
      case 1:
        return n(this, s);
      case 2:
      case 3:
        return i(this, s, l, v);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, t.prototype.get = function(s) {
    if (!ur(s))
      throw new TypeError("Array expected");
    if (s.length !== this._size.length)
      throw new Ye(s.length, this._size.length);
    for (var l = 0; l < s.length; l++)
      yr(s[l], this._size[l]);
    for (var v = this._data, p = 0, h = s.length; p < h; p++) {
      var d = s[p];
      yr(d, v.length), v = v[d];
    }
    return v;
  }, t.prototype.set = function(s, l, v) {
    if (!ur(s))
      throw new TypeError("Array expected");
    if (s.length < this._size.length)
      throw new Ye(s.length, this._size.length, "<");
    var p, h, d, x = s.map(function(y) {
      return y + 1;
    });
    c(this, x, v);
    var g = this._data;
    for (p = 0, h = s.length - 1; p < h; p++)
      d = s[p], yr(d, g.length), g = g[d];
    return d = s[s.length - 1], yr(d, g.length), g[d] = l, this;
  };
  function n(s, l) {
    if (!hi(l))
      throw new TypeError("Invalid index");
    var v = l.isScalar();
    if (v)
      return s.get(l.min());
    var p = l.size();
    if (p.length !== s._size.length)
      throw new Ye(p.length, s._size.length);
    for (var h = l.min(), d = l.max(), x = 0, g = s._size.length; x < g; x++)
      yr(h[x], s._size[x]), yr(d[x], s._size[x]);
    return new t(a(s._data, l, p.length, 0), s._datatype);
  }
  function a(s, l, v, p) {
    var h = p === v - 1, d = l.dimension(p);
    return h ? d.map(function(x) {
      return yr(x, s.length), s[x];
    }).valueOf() : d.map(function(x) {
      yr(x, s.length);
      var g = s[x];
      return a(g, l, v, p + 1);
    }).valueOf();
  }
  function i(s, l, v, p) {
    if (!l || l.isIndex !== !0)
      throw new TypeError("Invalid index");
    var h = l.size(), d = l.isScalar(), x;
    if (Oe(v) ? (x = v.size(), v = v.valueOf()) : x = Ve(v), d) {
      if (x.length !== 0)
        throw new TypeError("Scalar expected");
      s.set(l.min(), v, p);
    } else {
      if (!Da(x, h))
        try {
          x.length === 0 ? v = Mx([v], h) : v = Mx(v, h), x = Ve(v);
        } catch {
        }
      if (h.length < s._size.length)
        throw new Ye(h.length, s._size.length, "<");
      if (x.length < h.length) {
        for (var g = 0, y = 0; h[g] === 1 && x[g] === 1; )
          g++;
        for (; h[g] === 1; )
          y++, g++;
        v = rD(v, h.length, y, x);
      }
      if (!Da(h, x))
        throw new Ye(h, x, ">");
      var m = l.max().map(function(A) {
        return A + 1;
      });
      c(s, m, p);
      var b = h.length, w = 0;
      u(s._data, l, v, b, w);
    }
    return s;
  }
  function u(s, l, v, p, h) {
    var d = h === p - 1, x = l.dimension(h);
    d ? x.forEach(function(g, y) {
      yr(g), s[g] = v[y[0]];
    }) : x.forEach(function(g, y) {
      yr(g), u(s[g], l, v[y[0]], p, h + 1);
    });
  }
  t.prototype.resize = function(s, l, v) {
    if (!Tt(s))
      throw new TypeError("Array or Matrix expected");
    var p = s.valueOf().map((d) => Array.isArray(d) && d.length === 1 ? d[0] : d), h = v ? this.clone() : this;
    return f(h, p, l);
  };
  function f(s, l, v) {
    if (l.length === 0) {
      for (var p = s._data; ur(p); )
        p = p[0];
      return p;
    }
    return s._size = l.slice(0), s._data = li(s._data, s._size, v), s;
  }
  t.prototype.reshape = function(s, l) {
    var v = l ? this.clone() : this;
    v._data = xh(v._data, s);
    var p = v._size.reduce((h, d) => h * d);
    return v._size = yh(s, p), v;
  };
  function c(s, l, v) {
    for (var p = s._size.slice(0), h = !1; p.length < l.length; )
      p.push(0), h = !0;
    for (var d = 0, x = l.length; d < x; d++)
      l[d] > p[d] && (p[d] = l[d], h = !0);
    h && f(s, p, v);
  }
  t.prototype.clone = function() {
    var s = new t({
      data: Ie(this._data),
      size: Ie(this._size),
      datatype: this._datatype
    });
    return s;
  }, t.prototype.size = function() {
    return this._size.slice(0);
  }, t.prototype.map = function(s) {
    var l = this, v = oD(s), p = function x(g, y) {
      return ur(g) ? g.map(function(m, b) {
        return x(m, y.concat(b));
      }) : v === 1 ? s(g) : v === 2 ? s(g, y) : s(g, y, l);
    }, h = p(this._data, []), d = this._datatype !== void 0 ? ro(h, br) : void 0;
    return new t(h, d);
  }, t.prototype.forEach = function(s) {
    var l = this, v = function p(h, d) {
      ur(h) ? h.forEach(function(x, g) {
        p(x, d.concat(g));
      }) : s(h, d, l);
    };
    v(this._data, []);
  }, t.prototype[Symbol.iterator] = function* () {
    var s = function* l(v, p) {
      if (ur(v))
        for (var h = 0; h < v.length; h++)
          yield* l(v[h], p.concat(h));
      else
        yield {
          value: v,
          index: p
        };
    };
    yield* s(this._data, []);
  }, t.prototype.rows = function() {
    var s = [], l = this.size();
    if (l.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var v = this._data;
    for (var p of v)
      s.push(new t([p], this._datatype));
    return s;
  }, t.prototype.columns = function() {
    var s = this, l = [], v = this.size();
    if (v.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var p = this._data, h = function(g) {
      var y = p.map((m) => [m[g]]);
      l.push(new t(y, s._datatype));
    }, d = 0; d < v[1]; d++)
      h(d);
    return l;
  }, t.prototype.toArray = function() {
    return Ie(this._data);
  }, t.prototype.valueOf = function() {
    return this._data;
  }, t.prototype.format = function(s) {
    return Ke(this._data, s);
  }, t.prototype.toString = function() {
    return Ke(this._data);
  }, t.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, t.prototype.diagonal = function(s) {
    if (s) {
      if (Ue(s) && (s = s.toNumber()), !Xe(s) || !Me(s))
        throw new TypeError("The parameter k must be an integer number");
    } else
      s = 0;
    for (var l = s > 0 ? s : 0, v = s < 0 ? -s : 0, p = this._size[0], h = this._size[1], d = Math.min(p - v, h - l), x = [], g = 0; g < d; g++)
      x[g] = this._data[g + v][g + l];
    return new t({
      data: x,
      size: [d],
      datatype: this._datatype
    });
  }, t.diagonal = function(s, l, v, p) {
    if (!ur(s))
      throw new TypeError("Array expected, size parameter");
    if (s.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (s = s.map(function(E) {
      if (Ue(E) && (E = E.toNumber()), !Xe(E) || !Me(E) || E < 1)
        throw new Error("Size values must be positive integers");
      return E;
    }), v) {
      if (Ue(v) && (v = v.toNumber()), !Xe(v) || !Me(v))
        throw new TypeError("The parameter k must be an integer number");
    } else
      v = 0;
    var h = v > 0 ? v : 0, d = v < 0 ? -v : 0, x = s[0], g = s[1], y = Math.min(x - d, g - h), m;
    if (ur(l)) {
      if (l.length !== y)
        throw new Error("Invalid value array length");
      m = function(N) {
        return l[N];
      };
    } else if (Oe(l)) {
      var b = l.size();
      if (b.length !== 1 || b[0] !== y)
        throw new Error("Invalid matrix length");
      m = function(N) {
        return l.get([N]);
      };
    } else
      m = function() {
        return l;
      };
    p || (p = Ue(m(0)) ? m(0).mul(0) : 0);
    var w = [];
    if (s.length > 0) {
      w = li(w, s, p);
      for (var A = 0; A < y; A++)
        w[A + d][A + h] = m(A);
    }
    return new t({
      data: w,
      size: [x, g]
    });
  }, t.fromJSON = function(s) {
    return new t(s);
  }, t.prototype.swapRows = function(s, l) {
    if (!Xe(s) || !Me(s) || !Xe(l) || !Me(l))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return yr(s, this._size[0]), yr(l, this._size[0]), t._swapRows(s, l, this._data), this;
  }, t._swapRows = function(s, l, v) {
    var p = v[s];
    v[s] = v[l], v[l] = p;
  };
  function o(s) {
    return Oe(s) ? o(s.valueOf()) : ur(s) ? s.map(o) : s;
  }
  return t;
}, {
  isClass: !0
}), Fx = "clone", R7 = ["typed"], Cu = /* @__PURE__ */ U(Fx, R7, (r) => {
  var {
    typed: e
  } = r;
  return e(Fx, {
    any: Ie
  });
});
function sD(r) {
  var e = r.length, t = r[0].length, n, a, i = [];
  for (a = 0; a < t; a++) {
    var u = [];
    for (n = 0; n < e; n++)
      u.push(r[n][a]);
    i.push(u);
  }
  return i;
}
function yi(r) {
  for (var e = 0; e < r.length; e++)
    if (Tt(r[e]))
      return !0;
  return !1;
}
function Hn(r, e) {
  Oe(r) && (r = r.valueOf());
  for (var t = 0, n = r.length; t < n; t++) {
    var a = r[t];
    Array.isArray(a) ? Hn(a, e) : e(a);
  }
}
function $e(r, e, t) {
  return r && typeof r.map == "function" ? r.map(function(n) {
    return $e(n, e);
  }) : e(r);
}
function Eu(r, e, t) {
  var n = Array.isArray(r) ? Ve(r) : r.size();
  if (e < 0 || e >= n.length)
    throw new Ut(e, n.length);
  return Oe(r) ? r.create(qs(r.valueOf(), e, t)) : qs(r, e, t);
}
function qs(r, e, t) {
  var n, a, i, u;
  if (e <= 0)
    if (Array.isArray(r[0])) {
      for (u = sD(r), a = [], n = 0; n < u.length; n++)
        a[n] = qs(u[n], e - 1, t);
      return a;
    } else {
      for (i = r[0], n = 1; n < r.length; n++)
        i = t(i, r[n]);
      return i;
    }
  else {
    for (a = [], n = 0; n < r.length; n++)
      a[n] = qs(r[n], e - 1, t);
    return a;
  }
}
function Tx(r, e, t, n, a, i, u, f, c, o, s) {
  var l = r._values, v = r._index, p = r._ptr, h, d, x, g;
  if (n)
    for (d = p[e], x = p[e + 1], h = d; h < x; h++)
      g = v[h], t[g] !== i ? (t[g] = i, u.push(g), o ? (n[g] = c ? f(l[h], s) : f(s, l[h]), a[g] = i) : n[g] = l[h]) : (n[g] = c ? f(l[h], n[g]) : f(n[g], l[h]), a[g] = i);
  else
    for (d = p[e], x = p[e + 1], h = d; h < x; h++)
      g = v[h], t[g] !== i ? (t[g] = i, u.push(g)) : a[g] = i;
}
var Ox = "isInteger", I7 = ["typed"], Nu = /* @__PURE__ */ U(Ox, I7, (r) => {
  var {
    typed: e
  } = r;
  return e(Ox, {
    number: Me,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(n) {
      return n.isInt();
    },
    Fraction: function(n) {
      return n.d === 1 && isFinite(n.n);
    },
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), cn = "number", Ai = "number, number";
function uD(r) {
  return Math.abs(r);
}
uD.signature = cn;
function cD(r, e) {
  return r + e;
}
cD.signature = Ai;
function lD(r, e) {
  return r - e;
}
lD.signature = Ai;
function fD(r, e) {
  return r * e;
}
fD.signature = Ai;
function vD(r) {
  return -r;
}
vD.signature = cn;
function pD(r) {
  return r;
}
pD.signature = cn;
function Zi(r) {
  return Y6(r);
}
Zi.signature = cn;
function dD(r) {
  return r * r * r;
}
dD.signature = cn;
function mD(r) {
  return Math.exp(r);
}
mD.signature = cn;
function hD(r) {
  return Z6(r);
}
hD.signature = cn;
function gD(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Parameters in function lcm must be integer numbers");
  if (r === 0 || e === 0)
    return 0;
  for (var t, n = r * e; e !== 0; )
    t = e, e = r % t, r = t;
  return Math.abs(n / r);
}
gD.signature = Ai;
function H7(r, e) {
  return e ? Math.log(r) / Math.log(e) : Math.log(r);
}
function xD(r) {
  return V6(r);
}
xD.signature = cn;
function yD(r) {
  return G6(r);
}
yD.signature = cn;
function zx(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, t = e < 0;
  if (t && (e = -e), e === 0)
    throw new Error("Root must be non-zero");
  if (r < 0 && Math.abs(e) % 2 !== 1)
    throw new Error("Root must be odd when a is negative.");
  if (r === 0)
    return t ? 1 / 0 : 0;
  if (!isFinite(r))
    return t ? 0 : r;
  var n = Math.pow(Math.abs(r), 1 / e);
  return n = r < 0 ? -n : n, t ? 1 / n : n;
}
function Lm(r) {
  return _n(r);
}
Lm.signature = cn;
function AD(r) {
  return r * r;
}
AD.signature = cn;
function bD(r, e) {
  var t, n, a, i = 0, u = 1, f = 1, c = 0;
  if (!Me(r) || !Me(e))
    throw new Error("Parameters in function xgcd must be integer numbers");
  for (; e; )
    n = Math.floor(r / e), a = r - n * e, t = i, i = u - n * i, u = t, t = f, f = c - n * f, c = t, r = e, e = a;
  var o;
  return r < 0 ? o = [-r, -u, -c] : o = [r, r ? u : 0, c], o;
}
bD.signature = Ai;
function wD(r, e) {
  return r * r < 1 && e === 1 / 0 || r * r > 1 && e === -1 / 0 ? 0 : Math.pow(r, e);
}
wD.signature = Ai;
function Vi(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!Me(e) || e < 0 || e > 15)
    throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(P2(r, e));
}
var L7 = "number", bi = "number, number";
function DD(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function bitAnd");
  return r & e;
}
DD.signature = bi;
function CD(r) {
  if (!Me(r))
    throw new Error("Integer expected in function bitNot");
  return ~r;
}
CD.signature = L7;
function ED(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function bitOr");
  return r | e;
}
ED.signature = bi;
function ND(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function bitXor");
  return r ^ e;
}
ND.signature = bi;
function BD(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function leftShift");
  return r << e;
}
BD.signature = bi;
function SD(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function rightArithShift");
  return r >> e;
}
SD.signature = bi;
function PD(r, e) {
  if (!Me(r) || !Me(e))
    throw new Error("Integers expected in function rightLogShift");
  return r >>> e;
}
PD.signature = bi;
function zn(r, e) {
  if (e < r)
    return 1;
  if (e === r)
    return e;
  var t = e + r >> 1;
  return zn(r, t) * zn(t + 1, e);
}
function MD(r, e) {
  if (!Me(r) || r < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (!Me(e) || e < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (e > r)
    throw new TypeError("k must be less than or equal to n");
  for (var t = r - e, n = 1, a = e < t ? t + 1 : e + 1, i = 2, u = e < t ? e : t, f = a; f <= r; ++f)
    for (n *= f; i <= u && n % i === 0; )
      n /= i, ++i;
  return i <= u && (n /= zn(i, u)), n;
}
MD.signature = "number, number";
var q7 = Math.PI, U7 = 2 * Math.PI, k7 = Math.E, X7 = 1.618033988749895, j7 = "number", Ah = "number, number";
function FD(r) {
  return !r;
}
FD.signature = j7;
function TD(r, e) {
  return !!(r || e);
}
TD.signature = Ah;
function OD(r, e) {
  return !!r != !!e;
}
OD.signature = Ah;
function zD(r, e) {
  return !!(r && e);
}
zD.signature = Ah;
function Us(r) {
  var e;
  if (Me(r))
    return r <= 0 ? isFinite(r) ? 1 / 0 : NaN : r > 171 ? 1 / 0 : zn(1, r - 1);
  if (r < 0.5)
    return Math.PI / (Math.sin(Math.PI * r) * Us(1 - r));
  if (r >= 171.35)
    return 1 / 0;
  if (r > 85) {
    var t = r * r, n = t * r, a = n * r, i = a * r;
    return Math.sqrt(2 * Math.PI / r) * Math.pow(r / Math.E, r) * (1 + 1 / (12 * r) + 1 / (288 * t) - 139 / (51840 * n) - 571 / (2488320 * a) + 163879 / (209018880 * i) + 5246819 / (75246796800 * i * r));
  }
  --r, e = ti[0];
  for (var u = 1; u < ti.length; ++u)
    e += ti[u] / (r + u);
  var f = r + RD + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(f, r + 0.5) * Math.exp(-f) * e;
}
Us.signature = "number";
var RD = 4.7421875, ti = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], ID = 0.9189385332046728, G7 = 5, V7 = 7, Rx = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function ks(r) {
  if (r < 0)
    return NaN;
  if (r === 0)
    return 1 / 0;
  if (!isFinite(r))
    return r;
  if (r < 0.5)
    return Math.log(Math.PI / Math.sin(Math.PI * r)) - ks(1 - r);
  r = r - 1;
  for (var e = r + G7 + 0.5, t = Rx[0], n = V7 - 1; n >= 1; n--)
    t += Rx[n] / (r + n);
  return ID + (r + 0.5) * Math.log(e) - e + Math.log(t);
}
ks.signature = "number";
var pt = "number";
function HD(r) {
  return $6(r);
}
HD.signature = pt;
function LD(r) {
  return Math.atan(1 / r);
}
LD.signature = pt;
function qD(r) {
  return isFinite(r) ? (Math.log((r + 1) / r) + Math.log(r / (r - 1))) / 2 : 0;
}
qD.signature = pt;
function UD(r) {
  return Math.asin(1 / r);
}
UD.signature = pt;
function kD(r) {
  var e = 1 / r;
  return Math.log(e + Math.sqrt(e * e + 1));
}
kD.signature = pt;
function XD(r) {
  return Math.acos(1 / r);
}
XD.signature = pt;
function jD(r) {
  var e = 1 / r, t = Math.sqrt(e * e - 1);
  return Math.log(t + e);
}
jD.signature = pt;
function GD(r) {
  return e9(r);
}
GD.signature = pt;
function VD(r) {
  return r9(r);
}
VD.signature = pt;
function QD(r) {
  return 1 / Math.tan(r);
}
QD.signature = pt;
function YD(r) {
  var e = Math.exp(2 * r);
  return (e + 1) / (e - 1);
}
YD.signature = pt;
function ZD(r) {
  return 1 / Math.sin(r);
}
ZD.signature = pt;
function WD(r) {
  return r === 0 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(r) - Math.exp(-r))) * _n(r);
}
WD.signature = pt;
function KD(r) {
  return 1 / Math.cos(r);
}
KD.signature = pt;
function JD(r) {
  return 2 / (Math.exp(r) + Math.exp(-r));
}
JD.signature = pt;
function _D(r) {
  return n9(r);
}
_D.signature = pt;
var Bu = "number";
function $D(r) {
  return r < 0;
}
$D.signature = Bu;
function e4(r) {
  return r > 0;
}
e4.signature = Bu;
function r4(r) {
  return r === 0;
}
r4.signature = Bu;
function t4(r) {
  return Number.isNaN(r);
}
t4.signature = Bu;
var Ix = "isNegative", Q7 = ["typed"], Su = /* @__PURE__ */ U(Ix, Q7, (r) => {
  var {
    typed: e
  } = r;
  return e(Ix, {
    number: $D,
    BigNumber: function(n) {
      return n.isNeg() && !n.isZero() && !n.isNaN();
    },
    Fraction: function(n) {
      return n.s < 0;
    },
    Unit: e.referToSelf((t) => (n) => e.find(t, n.valueType())(n.value)),
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Hx = "isNumeric", Y7 = ["typed"], Pu = /* @__PURE__ */ U(Hx, Y7, (r) => {
  var {
    typed: e
  } = r;
  return e(Hx, {
    "number | BigNumber | Fraction | boolean": () => !0,
    "Complex | Unit | string | null | undefined | Node": () => !1,
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Lx = "hasNumericValue", Z7 = ["typed", "isNumeric"], Mu = /* @__PURE__ */ U(Lx, Z7, (r) => {
  var {
    typed: e,
    isNumeric: t
  } = r;
  return e(Lx, {
    boolean: () => !0,
    string: function(a) {
      return a.trim().length > 0 && !isNaN(Number(a));
    },
    any: function(a) {
      return t(a);
    }
  });
}), qx = "isPositive", W7 = ["typed"], Fu = /* @__PURE__ */ U(qx, W7, (r) => {
  var {
    typed: e
  } = r;
  return e(qx, {
    number: e4,
    BigNumber: function(n) {
      return !n.isNeg() && !n.isZero() && !n.isNaN();
    },
    Fraction: function(n) {
      return n.s > 0 && n.n > 0;
    },
    Unit: e.referToSelf((t) => (n) => e.find(t, n.valueType())(n.value)),
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Ux = "isZero", K7 = ["typed"], Tu = /* @__PURE__ */ U(Ux, K7, (r) => {
  var {
    typed: e
  } = r;
  return e(Ux, {
    number: r4,
    BigNumber: function(n) {
      return n.isZero();
    },
    Complex: function(n) {
      return n.re === 0 && n.im === 0;
    },
    Fraction: function(n) {
      return n.d === 1 && n.n === 0;
    },
    Unit: e.referToSelf((t) => (n) => e.find(t, n.valueType())(n.value)),
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), kx = "isNaN", J7 = ["typed"], Ou = /* @__PURE__ */ U(kx, J7, (r) => {
  var {
    typed: e
  } = r;
  return e(kx, {
    number: t4,
    BigNumber: function(n) {
      return n.isNaN();
    },
    Fraction: function(n) {
      return !1;
    },
    Complex: function(n) {
      return n.isNaN();
    },
    Unit: function(n) {
      return Number.isNaN(n.value);
    },
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Xx = "typeOf", _7 = ["typed"], zu = /* @__PURE__ */ U(Xx, _7, (r) => {
  var {
    typed: e
  } = r;
  return e(Xx, {
    any: br
  });
});
function Jt(r, e, t) {
  if (t == null)
    return r.eq(e);
  if (r.eq(e))
    return !0;
  if (r.isNaN() || e.isNaN())
    return !1;
  if (r.isFinite() && e.isFinite()) {
    var n = r.minus(e).abs();
    if (n.isZero())
      return !0;
    var a = r.constructor.max(r.abs(), e.abs());
    return n.lte(a.times(t));
  }
  return !1;
}
function $7(r, e, t) {
  return wt(r.re, e.re, t) && wt(r.im, e.im, t);
}
var wi = /* @__PURE__ */ U("compareUnits", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (!n.equalBase(a))
        throw new Error("Cannot compare units with different base");
      return e.find(t, [n.valueType(), a.valueType()])(n.value, a.value);
    })
  };
}), Xs = "equalScalar", eS = ["typed", "config"], Ru = /* @__PURE__ */ U(Xs, eS, (r) => {
  var {
    typed: e,
    config: t
  } = r, n = wi({
    typed: e
  });
  return e(Xs, {
    "boolean, boolean": function(i, u) {
      return i === u;
    },
    "number, number": function(i, u) {
      return wt(i, u, t.epsilon);
    },
    "BigNumber, BigNumber": function(i, u) {
      return i.eq(u) || Jt(i, u, t.epsilon);
    },
    "Fraction, Fraction": function(i, u) {
      return i.equals(u);
    },
    "Complex, Complex": function(i, u) {
      return $7(i, u, t.epsilon);
    }
  }, n);
});
U(Xs, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Xs, {
    "number, number": function(a, i) {
      return wt(a, i, t.epsilon);
    }
  });
});
var rS = "SparseMatrix", tS = ["typed", "equalScalar", "Matrix"], Iu = /* @__PURE__ */ U(rS, tS, (r) => {
  var {
    typed: e,
    equalScalar: t,
    Matrix: n
  } = r;
  function a(d, x) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (x && !Wr(x))
      throw new Error("Invalid datatype: " + x);
    if (Oe(d))
      i(this, d, x);
    else if (d && ur(d.index) && ur(d.ptr) && ur(d.size))
      this._values = d.values, this._index = d.index, this._ptr = d.ptr, this._size = d.size, this._datatype = x || d.datatype;
    else if (ur(d))
      u(this, d, x);
    else {
      if (d)
        throw new TypeError("Unsupported type of data (" + br(d) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = x;
    }
  }
  function i(d, x, g) {
    x.type === "SparseMatrix" ? (d._values = x._values ? Ie(x._values) : void 0, d._index = Ie(x._index), d._ptr = Ie(x._ptr), d._size = Ie(x._size), d._datatype = g || x._datatype) : u(d, x.valueOf(), g || x._datatype);
  }
  function u(d, x, g) {
    d._values = [], d._index = [], d._ptr = [], d._datatype = g;
    var y = x.length, m = 0, b = t, w = 0;
    if (Wr(g) && (b = e.find(t, [g, g]) || t, w = e.convert(0, g)), y > 0) {
      var A = 0;
      do {
        d._ptr.push(d._index.length);
        for (var E = 0; E < y; E++) {
          var N = x[E];
          if (ur(N)) {
            if (A === 0 && m < N.length && (m = N.length), A < N.length) {
              var C = N[A];
              b(C, w) || (d._values.push(C), d._index.push(E));
            }
          } else
            A === 0 && m < 1 && (m = 1), b(N, w) || (d._values.push(N), d._index.push(E));
        }
        A++;
      } while (A < m);
    }
    d._ptr.push(d._index.length), d._size = [y, m];
  }
  a.prototype = new n(), a.prototype.createSparseMatrix = function(d, x) {
    return new a(d, x);
  }, Object.defineProperty(a, "name", {
    value: "SparseMatrix"
  }), a.prototype.constructor = a, a.prototype.type = "SparseMatrix", a.prototype.isSparseMatrix = !0, a.prototype.getDataType = function() {
    return ro(this._values, br);
  }, a.prototype.storage = function() {
    return "sparse";
  }, a.prototype.datatype = function() {
    return this._datatype;
  }, a.prototype.create = function(d, x) {
    return new a(d, x);
  }, a.prototype.density = function() {
    var d = this._size[0], x = this._size[1];
    return d !== 0 && x !== 0 ? this._index.length / (d * x) : 0;
  }, a.prototype.subset = function(d, x, g) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return f(this, d);
      case 2:
      case 3:
        return c(this, d, x, g);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function f(d, x) {
    if (!hi(x))
      throw new TypeError("Invalid index");
    var g = x.isScalar();
    if (g)
      return d.get(x.min());
    var y = x.size();
    if (y.length !== d._size.length)
      throw new Ye(y.length, d._size.length);
    var m, b, w, A, E = x.min(), N = x.max();
    for (m = 0, b = d._size.length; m < b; m++)
      yr(E[m], d._size[m]), yr(N[m], d._size[m]);
    var C = d._values, D = d._index, B = d._ptr, S = x.dimension(0), F = x.dimension(1), I = [], z = [];
    S.forEach(function(O, Q) {
      z[O] = Q[0], I[O] = !0;
    });
    var P = C ? [] : void 0, M = [], H = [];
    return F.forEach(function(O) {
      for (H.push(M.length), w = B[O], A = B[O + 1]; w < A; w++)
        m = D[w], I[m] === !0 && (M.push(z[m]), P && P.push(C[w]));
    }), H.push(M.length), new a({
      values: P,
      index: M,
      ptr: H,
      size: y,
      datatype: d._datatype
    });
  }
  function c(d, x, g, y) {
    if (!x || x.isIndex !== !0)
      throw new TypeError("Invalid index");
    var m = x.size(), b = x.isScalar(), w;
    if (Oe(g) ? (w = g.size(), g = g.toArray()) : w = Ve(g), b) {
      if (w.length !== 0)
        throw new TypeError("Scalar expected");
      d.set(x.min(), g, y);
    } else {
      if (m.length !== 1 && m.length !== 2)
        throw new Ye(m.length, d._size.length, "<");
      if (w.length < m.length) {
        for (var A = 0, E = 0; m[A] === 1 && w[A] === 1; )
          A++;
        for (; m[A] === 1; )
          E++, A++;
        g = rD(g, m.length, E, w);
      }
      if (!Da(m, w))
        throw new Ye(m, w, ">");
      if (m.length === 1) {
        var N = x.dimension(0);
        N.forEach(function(B, S) {
          yr(B), d.set([B, 0], g[S[0]], y);
        });
      } else {
        var C = x.dimension(0), D = x.dimension(1);
        C.forEach(function(B, S) {
          yr(B), D.forEach(function(F, I) {
            yr(F), d.set([B, F], g[S[0]][I[0]], y);
          });
        });
      }
    }
    return d;
  }
  a.prototype.get = function(d) {
    if (!ur(d))
      throw new TypeError("Array expected");
    if (d.length !== this._size.length)
      throw new Ye(d.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var x = d[0], g = d[1];
    yr(x, this._size[0]), yr(g, this._size[1]);
    var y = o(x, this._ptr[g], this._ptr[g + 1], this._index);
    return y < this._ptr[g + 1] && this._index[y] === x ? this._values[y] : 0;
  }, a.prototype.set = function(d, x, g) {
    if (!ur(d))
      throw new TypeError("Array expected");
    if (d.length !== this._size.length)
      throw new Ye(d.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var y = d[0], m = d[1], b = this._size[0], w = this._size[1], A = t, E = 0;
    Wr(this._datatype) && (A = e.find(t, [this._datatype, this._datatype]) || t, E = e.convert(0, this._datatype)), (y > b - 1 || m > w - 1) && (v(this, Math.max(y + 1, b), Math.max(m + 1, w), g), b = this._size[0], w = this._size[1]), yr(y, b), yr(m, w);
    var N = o(y, this._ptr[m], this._ptr[m + 1], this._index);
    return N < this._ptr[m + 1] && this._index[N] === y ? A(x, E) ? s(N, m, this._values, this._index, this._ptr) : this._values[N] = x : A(x, E) || l(N, y, m, x, this._values, this._index, this._ptr), this;
  };
  function o(d, x, g, y) {
    if (g - x === 0)
      return g;
    for (var m = x; m < g; m++)
      if (y[m] === d)
        return m;
    return x;
  }
  function s(d, x, g, y, m) {
    g.splice(d, 1), y.splice(d, 1);
    for (var b = x + 1; b < m.length; b++)
      m[b]--;
  }
  function l(d, x, g, y, m, b, w) {
    m.splice(d, 0, y), b.splice(d, 0, x);
    for (var A = g + 1; A < w.length; A++)
      w[A]++;
  }
  a.prototype.resize = function(d, x, g) {
    if (!Tt(d))
      throw new TypeError("Array or Matrix expected");
    var y = d.valueOf().map((b) => Array.isArray(b) && b.length === 1 ? b[0] : b);
    if (y.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    y.forEach(function(b) {
      if (!Xe(b) || !Me(b) || b < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + Ke(y) + ")");
    });
    var m = g ? this.clone() : this;
    return v(m, y[0], y[1], x);
  };
  function v(d, x, g, y) {
    var m = y || 0, b = t, w = 0;
    Wr(d._datatype) && (b = e.find(t, [d._datatype, d._datatype]) || t, w = e.convert(0, d._datatype), m = e.convert(m, d._datatype));
    var A = !b(m, w), E = d._size[0], N = d._size[1], C, D, B;
    if (g > N) {
      for (D = N; D < g; D++)
        if (d._ptr[D] = d._values.length, A)
          for (C = 0; C < E; C++)
            d._values.push(m), d._index.push(C);
      d._ptr[g] = d._values.length;
    } else
      g < N && (d._ptr.splice(g + 1, N - g), d._values.splice(d._ptr[g], d._values.length), d._index.splice(d._ptr[g], d._index.length));
    if (N = g, x > E) {
      if (A) {
        var S = 0;
        for (D = 0; D < N; D++) {
          d._ptr[D] = d._ptr[D] + S, B = d._ptr[D + 1] + S;
          var F = 0;
          for (C = E; C < x; C++, F++)
            d._values.splice(B + F, 0, m), d._index.splice(B + F, 0, C), S++;
        }
        d._ptr[N] = d._values.length;
      }
    } else if (x < E) {
      var I = 0;
      for (D = 0; D < N; D++) {
        d._ptr[D] = d._ptr[D] - I;
        var z = d._ptr[D], P = d._ptr[D + 1] - I;
        for (B = z; B < P; B++)
          C = d._index[B], C > x - 1 && (d._values.splice(B, 1), d._index.splice(B, 1), I++);
      }
      d._ptr[D] = d._values.length;
    }
    return d._size[0] = x, d._size[1] = g, d;
  }
  a.prototype.reshape = function(d, x) {
    if (!ur(d))
      throw new TypeError("Array expected");
    if (d.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    d.forEach(function(O) {
      if (!Xe(O) || !Me(O) || O <= -2 || O === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + Ke(d) + ")");
    });
    var g = this._size[0] * this._size[1];
    d = yh(d, g);
    var y = d[0] * d[1];
    if (g !== y)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var m = x ? this.clone() : this;
    if (this._size[0] === d[0] && this._size[1] === d[1])
      return m;
    for (var b = [], w = 0; w < m._ptr.length; w++)
      for (var A = 0; A < m._ptr[w + 1] - m._ptr[w]; A++)
        b.push(w);
    for (var E = m._values.slice(), N = m._index.slice(), C = 0; C < m._index.length; C++) {
      var D = N[C], B = b[C], S = D * m._size[1] + B;
      b[C] = S % d[1], N[C] = Math.floor(S / d[1]);
    }
    m._values.length = 0, m._index.length = 0, m._ptr.length = d[1] + 1, m._size = d.slice();
    for (var F = 0; F < m._ptr.length; F++)
      m._ptr[F] = 0;
    for (var I = 0; I < E.length; I++) {
      var z = N[I], P = b[I], M = E[I], H = o(z, m._ptr[P], m._ptr[P + 1], m._index);
      l(H, z, P, M, m._values, m._index, m._ptr);
    }
    return m;
  }, a.prototype.clone = function() {
    var d = new a({
      values: this._values ? Ie(this._values) : void 0,
      index: Ie(this._index),
      ptr: Ie(this._ptr),
      size: Ie(this._size),
      datatype: this._datatype
    });
    return d;
  }, a.prototype.size = function() {
    return this._size.slice(0);
  }, a.prototype.map = function(d, x) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var g = this, y = this._size[0], m = this._size[1], b = oD(d), w = function(E, N, C) {
      return b === 1 ? d(E) : b === 2 ? d(E, [N, C]) : d(E, [N, C], g);
    };
    return p(this, 0, y - 1, 0, m - 1, w, x);
  };
  function p(d, x, g, y, m, b, w) {
    var A = [], E = [], N = [], C = t, D = 0;
    Wr(d._datatype) && (C = e.find(t, [d._datatype, d._datatype]) || t, D = e.convert(0, d._datatype));
    for (var B = function(R, X, ae) {
      R = b(R, X, ae), C(R, D) || (A.push(R), E.push(X));
    }, S = y; S <= m; S++) {
      N.push(A.length);
      var F = d._ptr[S], I = d._ptr[S + 1];
      if (w)
        for (var z = F; z < I; z++) {
          var P = d._index[z];
          P >= x && P <= g && B(d._values[z], P - x, S - y);
        }
      else {
        for (var M = {}, H = F; H < I; H++) {
          var O = d._index[H];
          M[O] = d._values[H];
        }
        for (var Q = x; Q <= g; Q++) {
          var k = Q in M ? M[Q] : 0;
          B(k, Q - x, S - y);
        }
      }
    }
    return N.push(A.length), new a({
      values: A,
      index: E,
      ptr: N,
      size: [g - x + 1, m - y + 1]
    });
  }
  a.prototype.forEach = function(d, x) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var g = this, y = this._size[0], m = this._size[1], b = 0; b < m; b++) {
      var w = this._ptr[b], A = this._ptr[b + 1];
      if (x)
        for (var E = w; E < A; E++) {
          var N = this._index[E];
          d(this._values[E], [N, b], g);
        }
      else {
        for (var C = {}, D = w; D < A; D++) {
          var B = this._index[D];
          C[B] = this._values[D];
        }
        for (var S = 0; S < y; S++) {
          var F = S in C ? C[S] : 0;
          d(F, [S, b], g);
        }
      }
    }
  }, a.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var d = this._size[1], x = 0; x < d; x++)
      for (var g = this._ptr[x], y = this._ptr[x + 1], m = g; m < y; m++) {
        var b = this._index[m];
        yield {
          value: this._values[m],
          index: [b, x]
        };
      }
  }, a.prototype.toArray = function() {
    return h(this._values, this._index, this._ptr, this._size, !0);
  }, a.prototype.valueOf = function() {
    return h(this._values, this._index, this._ptr, this._size, !1);
  };
  function h(d, x, g, y, m) {
    var b = y[0], w = y[1], A = [], E, N;
    for (E = 0; E < b; E++)
      for (A[E] = [], N = 0; N < w; N++)
        A[E][N] = 0;
    for (N = 0; N < w; N++)
      for (var C = g[N], D = g[N + 1], B = C; B < D; B++)
        E = x[B], A[E][N] = d ? m ? Ie(d[B]) : d[B] : 1;
    return A;
  }
  return a.prototype.format = function(d) {
    for (var x = this._size[0], g = this._size[1], y = this.density(), m = "Sparse Matrix [" + Ke(x, d) + " x " + Ke(g, d) + "] density: " + Ke(y, d) + `
`, b = 0; b < g; b++)
      for (var w = this._ptr[b], A = this._ptr[b + 1], E = w; E < A; E++) {
        var N = this._index[E];
        m += `
    (` + Ke(N, d) + ", " + Ke(b, d) + ") ==> " + (this._values ? Ke(this._values[E], d) : "X");
      }
    return m;
  }, a.prototype.toString = function() {
    return Ke(this.toArray());
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, a.prototype.diagonal = function(d) {
    if (d) {
      if (Ue(d) && (d = d.toNumber()), !Xe(d) || !Me(d))
        throw new TypeError("The parameter k must be an integer number");
    } else
      d = 0;
    var x = d > 0 ? d : 0, g = d < 0 ? -d : 0, y = this._size[0], m = this._size[1], b = Math.min(y - g, m - x), w = [], A = [], E = [];
    E[0] = 0;
    for (var N = x; N < m && w.length < b; N++)
      for (var C = this._ptr[N], D = this._ptr[N + 1], B = C; B < D; B++) {
        var S = this._index[B];
        if (S === N - x + g) {
          w.push(this._values[B]), A[w.length - 1] = S - g;
          break;
        }
      }
    return E.push(w.length), new a({
      values: w,
      index: A,
      ptr: E,
      size: [b, 1]
    });
  }, a.fromJSON = function(d) {
    return new a(d);
  }, a.diagonal = function(d, x, g, y, m) {
    if (!ur(d))
      throw new TypeError("Array expected, size parameter");
    if (d.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (d = d.map(function(O) {
      if (Ue(O) && (O = O.toNumber()), !Xe(O) || !Me(O) || O < 1)
        throw new Error("Size values must be positive integers");
      return O;
    }), g) {
      if (Ue(g) && (g = g.toNumber()), !Xe(g) || !Me(g))
        throw new TypeError("The parameter k must be an integer number");
    } else
      g = 0;
    var b = t, w = 0;
    Wr(m) && (b = e.find(t, [m, m]) || t, w = e.convert(0, m));
    var A = g > 0 ? g : 0, E = g < 0 ? -g : 0, N = d[0], C = d[1], D = Math.min(N - E, C - A), B;
    if (ur(x)) {
      if (x.length !== D)
        throw new Error("Invalid value array length");
      B = function(Q) {
        return x[Q];
      };
    } else if (Oe(x)) {
      var S = x.size();
      if (S.length !== 1 || S[0] !== D)
        throw new Error("Invalid matrix length");
      B = function(Q) {
        return x.get([Q]);
      };
    } else
      B = function() {
        return x;
      };
    for (var F = [], I = [], z = [], P = 0; P < C; P++) {
      z.push(F.length);
      var M = P - A;
      if (M >= 0 && M < D) {
        var H = B(M);
        b(H, w) || (I.push(M + E), F.push(H));
      }
    }
    return z.push(F.length), new a({
      values: F,
      index: I,
      ptr: z,
      size: [N, C]
    });
  }, a.prototype.swapRows = function(d, x) {
    if (!Xe(d) || !Me(d) || !Xe(x) || !Me(x))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return yr(d, this._size[0]), yr(x, this._size[0]), a._swapRows(d, x, this._size[1], this._values, this._index, this._ptr), this;
  }, a._forEachRow = function(d, x, g, y, m) {
    for (var b = y[d], w = y[d + 1], A = b; A < w; A++)
      m(g[A], x[A]);
  }, a._swapRows = function(d, x, g, y, m, b) {
    for (var w = 0; w < g; w++) {
      var A = b[w], E = b[w + 1], N = o(d, A, E, m), C = o(x, A, E, m);
      if (N < E && C < E && m[N] === d && m[C] === x) {
        if (y) {
          var D = y[N];
          y[N] = y[C], y[C] = D;
        }
        continue;
      }
      if (N < E && m[N] === d && (C >= E || m[C] !== x)) {
        var B = y ? y[N] : void 0;
        m.splice(C, 0, x), y && y.splice(C, 0, B), m.splice(C <= N ? N + 1 : N, 1), y && y.splice(C <= N ? N + 1 : N, 1);
        continue;
      }
      if (C < E && m[C] === x && (N >= E || m[N] !== d)) {
        var S = y ? y[C] : void 0;
        m.splice(N, 0, d), y && y.splice(N, 0, S), m.splice(N <= C ? C + 1 : C, 1), y && y.splice(N <= C ? C + 1 : C, 1);
      }
    }
  }, a;
}, {
  isClass: !0
}), nS = "number", aS = ["typed"];
function iS(r) {
  var e = r.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (e) {
    var t = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[e[1]], n = e[2], a = e[3];
    return {
      input: r,
      radix: t,
      integerPart: n,
      fractionalPart: a
    };
  } else
    return null;
}
function oS(r) {
  for (var e = parseInt(r.integerPart, r.radix), t = 0, n = 0; n < r.fractionalPart.length; n++) {
    var a = parseInt(r.fractionalPart[n], r.radix);
    t += a / Math.pow(r.radix, n + 1);
  }
  var i = e + t;
  if (isNaN(i))
    throw new SyntaxError('String "' + r.input + '" is not a valid number');
  return i;
}
var Hu = /* @__PURE__ */ U(nS, aS, (r) => {
  var {
    typed: e
  } = r, t = e("number", {
    "": function() {
      return 0;
    },
    number: function(a) {
      return a;
    },
    string: function(a) {
      if (a === "NaN")
        return NaN;
      var i = iS(a);
      if (i)
        return oS(i);
      var u = 0, f = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      f && (u = Number(f[2]), a = f[1]);
      var c = Number(a);
      if (isNaN(c))
        throw new SyntaxError('String "' + a + '" is not a valid number');
      if (f) {
        if (c > 2 ** u - 1)
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        c >= 2 ** (u - 1) && (c = c - 2 ** u);
      }
      return c;
    },
    BigNumber: function(a) {
      return a.toNumber();
    },
    Fraction: function(a) {
      return a.valueOf();
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    null: function(a) {
      return 0;
    },
    "Unit, string | Unit": function(a, i) {
      return a.toNumber(i);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
  return t.fromJSON = function(n) {
    return parseFloat(n.value);
  }, t;
}), jx = "string", sS = ["typed"], Lu = /* @__PURE__ */ U(jx, sS, (r) => {
  var {
    typed: e
  } = r;
  return e(jx, {
    "": function() {
      return "";
    },
    number: wa,
    null: function(n) {
      return "null";
    },
    boolean: function(n) {
      return n + "";
    },
    string: function(n) {
      return n;
    },
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t)),
    any: function(n) {
      return String(n);
    }
  });
}), Gx = "boolean", uS = ["typed"], qu = /* @__PURE__ */ U(Gx, uS, (r) => {
  var {
    typed: e
  } = r;
  return e(Gx, {
    "": function() {
      return !1;
    },
    boolean: function(n) {
      return n;
    },
    number: function(n) {
      return !!n;
    },
    null: function(n) {
      return !1;
    },
    BigNumber: function(n) {
      return !n.isZero();
    },
    string: function(n) {
      var a = n.toLowerCase();
      if (a === "true")
        return !0;
      if (a === "false")
        return !1;
      var i = Number(n);
      if (n !== "" && !isNaN(i))
        return !!i;
      throw new Error('Cannot convert "' + n + '" to a boolean');
    },
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), cS = "bignumber", lS = ["typed", "BigNumber"], Uu = /* @__PURE__ */ U(cS, lS, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e("bignumber", {
    "": function() {
      return new t(0);
    },
    number: function(a) {
      return new t(a + "");
    },
    string: function(a) {
      var i = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (i) {
        var u = i[2], f = t(i[1]), c = new t(2).pow(Number(u));
        if (f.gt(c.sub(1)))
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        var o = new t(2).pow(Number(u) - 1);
        return f.gte(o) ? f.sub(c) : f;
      }
      return new t(a);
    },
    BigNumber: function(a) {
      return a;
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    Fraction: function(a) {
      return new t(a.n).div(a.d).times(a.s);
    },
    null: function(a) {
      return new t(0);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
}), fS = "complex", vS = ["typed", "Complex"], ku = /* @__PURE__ */ U(fS, vS, (r) => {
  var {
    typed: e,
    Complex: t
  } = r;
  return e("complex", {
    "": function() {
      return t.ZERO;
    },
    number: function(a) {
      return new t(a, 0);
    },
    "number, number": function(a, i) {
      return new t(a, i);
    },
    // TODO: this signature should be redundant
    "BigNumber, BigNumber": function(a, i) {
      return new t(a.toNumber(), i.toNumber());
    },
    Fraction: function(a) {
      return new t(a.valueOf(), 0);
    },
    Complex: function(a) {
      return a.clone();
    },
    string: function(a) {
      return t(a);
    },
    null: function(a) {
      return t(0);
    },
    Object: function(a) {
      if ("re" in a && "im" in a)
        return new t(a.re, a.im);
      if ("r" in a && "phi" in a || "abs" in a && "arg" in a)
        return new t(a);
      throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
}), pS = "fraction", dS = ["typed", "Fraction"], Xu = /* @__PURE__ */ U(pS, dS, (r) => {
  var {
    typed: e,
    Fraction: t
  } = r;
  return e("fraction", {
    number: function(a) {
      if (!isFinite(a) || isNaN(a))
        throw new Error(a + " cannot be represented as a fraction");
      return new t(a);
    },
    string: function(a) {
      return new t(a);
    },
    "number, number": function(a, i) {
      return new t(a, i);
    },
    null: function(a) {
      return new t(0);
    },
    BigNumber: function(a) {
      return new t(a.toString());
    },
    Fraction: function(a) {
      return a;
    },
    Unit: e.referToSelf((n) => (a) => {
      var i = a.clone();
      return i.value = n(a.value), i;
    }),
    Object: function(a) {
      return new t(a);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
}), Vx = "matrix", mS = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], ju = /* @__PURE__ */ U(Vx, mS, (r) => {
  var {
    typed: e,
    Matrix: t,
    DenseMatrix: n,
    SparseMatrix: a
  } = r;
  return e(Vx, {
    "": function() {
      return i([]);
    },
    string: function(f) {
      return i([], f);
    },
    "string, string": function(f, c) {
      return i([], f, c);
    },
    Array: function(f) {
      return i(f);
    },
    Matrix: function(f) {
      return i(f, f.storage());
    },
    "Array | Matrix, string": i,
    "Array | Matrix, string, string": i
  });
  function i(u, f, c) {
    if (f === "dense" || f === "default" || f === void 0)
      return new n(u, c);
    if (f === "sparse")
      return new a(u, c);
    throw new TypeError("Unknown matrix type " + JSON.stringify(f) + ".");
  }
}), Qx = "matrixFromFunction", hS = ["typed", "matrix", "isZero"], Gu = /* @__PURE__ */ U(Qx, hS, (r) => {
  var {
    typed: e,
    matrix: t,
    isZero: n
  } = r;
  return e(Qx, {
    "Array | Matrix, function, string, string": function(u, f, c, o) {
      return a(u, f, c, o);
    },
    "Array | Matrix, function, string": function(u, f, c) {
      return a(u, f, c);
    },
    "Matrix, function": function(u, f) {
      return a(u, f, "dense");
    },
    "Array, function": function(u, f) {
      return a(u, f, "dense").toArray();
    },
    "Array | Matrix, string, function": function(u, f, c) {
      return a(u, c, f);
    },
    "Array | Matrix, string, string, function": function(u, f, c, o) {
      return a(u, o, f, c);
    }
  });
  function a(i, u, f, c) {
    var o;
    return c !== void 0 ? o = t(f, c) : o = t(f), o.resize(i), o.forEach(function(s, l) {
      var v = u(l);
      n(v) || o.set(l, v);
    }), o;
  }
}), Yx = "matrixFromRows", gS = ["typed", "matrix", "flatten", "size"], Vu = /* @__PURE__ */ U(Yx, gS, (r) => {
  var {
    typed: e,
    matrix: t,
    flatten: n,
    size: a
  } = r;
  return e(Yx, {
    "...Array": function(c) {
      return i(c);
    },
    "...Matrix": function(c) {
      return t(i(c.map((o) => o.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function i(f) {
    if (f.length === 0)
      throw new TypeError("At least one row is needed to construct a matrix.");
    var c = u(f[0]), o = [];
    for (var s of f) {
      var l = u(s);
      if (l !== c)
        throw new TypeError("The vectors had different length: " + (c | 0) + " ≠ " + (l | 0));
      o.push(n(s));
    }
    return o;
  }
  function u(f) {
    var c = a(f);
    if (c.length === 1)
      return c[0];
    if (c.length === 2) {
      if (c[0] === 1)
        return c[1];
      if (c[1] === 1)
        return c[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), Zx = "matrixFromColumns", xS = ["typed", "matrix", "flatten", "size"], Qu = /* @__PURE__ */ U(Zx, xS, (r) => {
  var {
    typed: e,
    matrix: t,
    flatten: n,
    size: a
  } = r;
  return e(Zx, {
    "...Array": function(c) {
      return i(c);
    },
    "...Matrix": function(c) {
      return t(i(c.map((o) => o.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function i(f) {
    if (f.length === 0)
      throw new TypeError("At least one column is needed to construct a matrix.");
    for (var c = u(f[0]), o = [], s = 0; s < c; s++)
      o[s] = [];
    for (var l of f) {
      var v = u(l);
      if (v !== c)
        throw new TypeError("The vectors had different length: " + (c | 0) + " ≠ " + (v | 0));
      for (var p = n(l), h = 0; h < c; h++)
        o[h].push(p[h]);
    }
    return o;
  }
  function u(f) {
    var c = a(f);
    if (c.length === 1)
      return c[0];
    if (c.length === 2) {
      if (c[0] === 1)
        return c[1];
      if (c[1] === 1)
        return c[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), Wx = "splitUnit", yS = ["typed"], Yu = /* @__PURE__ */ U(Wx, yS, (r) => {
  var {
    typed: e
  } = r;
  return e(Wx, {
    "Unit, Array": function(n, a) {
      return n.splitUnit(a);
    }
  });
}), Kx = "unaryMinus", AS = ["typed"], Zu = /* @__PURE__ */ U(Kx, AS, (r) => {
  var {
    typed: e
  } = r;
  return e(Kx, {
    number: vD,
    "Complex | BigNumber | Fraction": (t) => t.neg(),
    Unit: e.referToSelf((t) => (n) => {
      var a = n.clone();
      return a.value = e.find(t, a.valueType())(n.value), a;
    }),
    // deep map collection, skip zeros since unaryMinus(0) = 0
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
    // TODO: add support for string
  });
}), Jx = "unaryPlus", bS = ["typed", "config", "BigNumber"], Wu = /* @__PURE__ */ U(Jx, bS, (r) => {
  var {
    typed: e,
    config: t,
    BigNumber: n
  } = r;
  return e(Jx, {
    number: pD,
    Complex: function(i) {
      return i;
    },
    BigNumber: function(i) {
      return i;
    },
    Fraction: function(i) {
      return i;
    },
    Unit: function(i) {
      return i.clone();
    },
    // deep map collection, skip zeros since unaryPlus(0) = 0
    "Array | Matrix": e.referToSelf((a) => (i) => $e(i, a)),
    "boolean | string": function(i) {
      return t.number === "BigNumber" ? new n(+i) : +i;
    }
  });
}), _x = "abs", wS = ["typed"], Ku = /* @__PURE__ */ U(_x, wS, (r) => {
  var {
    typed: e
  } = r;
  return e(_x, {
    number: uD,
    "Complex | BigNumber | Fraction | Unit": (t) => t.abs(),
    // deep map collection, skip zeros since abs(0) = 0
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), $x = "apply", DS = ["typed", "isInteger"], Di = /* @__PURE__ */ U($x, DS, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r;
  return e($x, {
    "Array | Matrix, number | BigNumber, function": function(a, i, u) {
      if (!t(i))
        throw new TypeError("Integer number expected for dimension");
      var f = Array.isArray(a) ? Ve(a) : a.size();
      if (i < 0 || i >= f.length)
        throw new Ut(i, f.length);
      return Oe(a) ? a.create(js(a.valueOf(), i, u)) : js(a, i, u);
    }
  });
});
function js(r, e, t) {
  var n, a, i;
  if (e <= 0)
    if (Array.isArray(r[0])) {
      for (i = CS(r), a = [], n = 0; n < i.length; n++)
        a[n] = js(i[n], e - 1, t);
      return a;
    } else
      return t(r);
  else {
    for (a = [], n = 0; n < r.length; n++)
      a[n] = js(r[n], e - 1, t);
    return a;
  }
}
function CS(r) {
  var e = r.length, t = r[0].length, n, a, i = [];
  for (a = 0; a < t; a++) {
    var u = [];
    for (n = 0; n < e; n++)
      u.push(r[n][a]);
    i.push(u);
  }
  return i;
}
var ey = "addScalar", ES = ["typed"], Ju = /* @__PURE__ */ U(ey, ES, (r) => {
  var {
    typed: e
  } = r;
  return e(ey, {
    "number, number": cD,
    "Complex, Complex": function(n, a) {
      return n.add(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.plus(a);
    },
    "Fraction, Fraction": function(n, a) {
      return n.add(a);
    },
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(a))
        throw new Error("Units do not match");
      var i = n.clone();
      return i.value = e.find(t, [i.valueType(), a.valueType()])(i.value, a.value), i.fixPrefix = !1, i;
    })
  });
}), ry = "subtractScalar", NS = ["typed"], _u = /* @__PURE__ */ U(ry, NS, (r) => {
  var {
    typed: e
  } = r;
  return e(ry, {
    "number, number": lD,
    "Complex, Complex": function(n, a) {
      return n.sub(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.minus(a);
    },
    "Fraction, Fraction": function(n, a) {
      return n.sub(a);
    },
    "Unit, Unit": e.referToSelf((t) => (n, a) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(a))
        throw new Error("Units do not match");
      var i = n.clone();
      return i.value = e.find(t, [i.valueType(), a.valueType()])(i.value, a.value), i.fixPrefix = !1, i;
    })
  });
}), ty = "cbrt", BS = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], $u = /* @__PURE__ */ U(ty, BS, (r) => {
  var {
    config: e,
    typed: t,
    isNegative: n,
    unaryMinus: a,
    matrix: i,
    Complex: u,
    BigNumber: f,
    Fraction: c
  } = r;
  return t(ty, {
    number: Zi,
    // note: signature 'number, boolean' is also supported,
    //       created by typed as it knows how to convert number to Complex
    Complex: o,
    "Complex, boolean": o,
    BigNumber: function(v) {
      return v.cbrt();
    },
    Unit: s
  });
  function o(l, v) {
    var p = l.arg() / 3, h = l.abs(), d = new u(Zi(h), 0).mul(new u(0, p).exp());
    if (v) {
      var x = [d, new u(Zi(h), 0).mul(new u(0, p + Math.PI * 2 / 3).exp()), new u(Zi(h), 0).mul(new u(0, p - Math.PI * 2 / 3).exp())];
      return e.matrix === "Array" ? x : i(x);
    } else
      return d;
  }
  function s(l) {
    if (l.value && Wt(l.value)) {
      var v = l.clone();
      return v.value = 1, v = v.pow(1 / 3), v.value = o(l.value), v;
    } else {
      var p = n(l.value);
      p && (l.value = a(l.value));
      var h;
      Ue(l.value) ? h = new f(1).div(3) : na(l.value) ? h = new c(1, 3) : h = 1 / 3;
      var d = l.pow(h);
      return p && (d.value = a(d.value)), d;
    }
  }
}), SS = "matAlgo11xS0s", PS = ["typed", "equalScalar"], at = /* @__PURE__ */ U(SS, PS, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u, f) {
    var c = a._values, o = a._index, s = a._ptr, l = a._size, v = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = l[0], h = l[1], d, x = t, g = 0, y = u;
    typeof v == "string" && (d = v, x = e.find(t, [d, d]), g = e.convert(0, d), i = e.convert(i, d), y = e.find(u, [d, d]));
    for (var m = [], b = [], w = [], A = 0; A < h; A++) {
      w[A] = b.length;
      for (var E = s[A], N = s[A + 1], C = E; C < N; C++) {
        var D = o[C], B = f ? y(i, c[C]) : y(c[C], i);
        x(B, g) || (b.push(D), m.push(B));
      }
    }
    return w[h] = b.length, a.createSparseMatrix({
      values: m,
      index: b,
      ptr: w,
      size: [p, h],
      datatype: d
    });
  };
}), MS = "matAlgo12xSfs", FS = ["typed", "DenseMatrix"], Qr = /* @__PURE__ */ U(MS, FS, (r) => {
  var {
    typed: e,
    DenseMatrix: t
  } = r;
  return function(a, i, u, f) {
    var c = a._values, o = a._index, s = a._ptr, l = a._size, v = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = l[0], h = l[1], d, x = u;
    typeof v == "string" && (d = v, i = e.convert(i, d), x = e.find(u, [d, d]));
    for (var g = [], y = [], m = [], b = 0; b < h; b++) {
      for (var w = b + 1, A = s[b], E = s[b + 1], N = A; N < E; N++) {
        var C = o[N];
        y[C] = c[N], m[C] = w;
      }
      for (var D = 0; D < p; D++)
        b === 0 && (g[D] = []), m[D] === w ? g[D][b] = f ? x(i, y[D]) : x(y[D], i) : g[D][b] = f ? x(i, 0) : x(0, i);
    }
    return new t({
      data: g,
      size: [p, h],
      datatype: d
    });
  };
}), TS = "matAlgo14xDs", OS = ["typed"], ln = /* @__PURE__ */ U(TS, OS, (r) => {
  var {
    typed: e
  } = r;
  return function(a, i, u, f) {
    var c = a._data, o = a._size, s = a._datatype, l, v = u;
    typeof s == "string" && (l = s, i = e.convert(i, l), v = e.find(u, [l, l]));
    var p = o.length > 0 ? t(v, 0, o, o[0], c, i, f) : [];
    return a.createDenseMatrix({
      data: p,
      size: Ie(o),
      datatype: l
    });
  };
  function t(n, a, i, u, f, c, o) {
    var s = [];
    if (a === i.length - 1)
      for (var l = 0; l < u; l++)
        s[l] = o ? n(c, f[l]) : n(f[l], c);
    else
      for (var v = 0; v < u; v++)
        s[v] = t(n, a + 1, i, i[a + 1], f[v], c, o);
    return s;
  }
}), qm = "ceil", zS = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], RS = /* @__PURE__ */ U(qm, ["typed", "config", "round"], (r) => {
  var {
    typed: e,
    config: t,
    round: n
  } = r;
  return e(qm, {
    number: function(i) {
      return wt(i, n(i), t.epsilon) ? n(i) : Math.ceil(i);
    },
    "number, number": function(i, u) {
      if (wt(i, n(i, u), t.epsilon))
        return n(i, u);
      var [f, c] = "".concat(i, "e").split("e"), o = Math.ceil(Number("".concat(f, "e").concat(Number(c) + u)));
      return [f, c] = "".concat(o, "e").split("e"), Number("".concat(f, "e").concat(Number(c) - u));
    }
  });
}), ec = /* @__PURE__ */ U(qm, zS, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: u,
    DenseMatrix: f
  } = r, c = at({
    typed: e,
    equalScalar: i
  }), o = Qr({
    typed: e,
    DenseMatrix: f
  }), s = ln({
    typed: e
  }), l = RS({
    typed: e,
    config: t,
    round: n
  });
  return e("ceil", {
    number: l.signatures.number,
    "number,number": l.signatures["number,number"],
    Complex: function(p) {
      return p.ceil();
    },
    "Complex, number": function(p, h) {
      return p.ceil(h);
    },
    "Complex, BigNumber": function(p, h) {
      return p.ceil(h.toNumber());
    },
    BigNumber: function(p) {
      return Jt(p, n(p), t.epsilon) ? n(p) : p.ceil();
    },
    "BigNumber, BigNumber": function(p, h) {
      return Jt(p, n(p, h), t.epsilon) ? n(p, h) : p.toDecimalPlaces(h.toNumber(), ra.ROUND_CEIL);
    },
    Fraction: function(p) {
      return p.ceil();
    },
    "Fraction, number": function(p, h) {
      return p.ceil(h);
    },
    "Fraction, BigNumber": function(p, h) {
      return p.ceil(h.toNumber());
    },
    "Array | Matrix": e.referToSelf((v) => (p) => $e(p, v)),
    "Array, number | BigNumber": e.referToSelf((v) => (p, h) => $e(p, (d) => v(d, h))),
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => c(p, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => s(p, h, v, !1)),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((v) => (p, h) => s(a(h), p, v, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((v) => (p, h) => i(p, 0) ? u(h.size(), h.storage()) : h.storage() === "dense" ? s(h, p, v, !0) : o(h, p, v, !0))
  });
}), ny = "cube", IS = ["typed"], rc = /* @__PURE__ */ U(ny, IS, (r) => {
  var {
    typed: e
  } = r;
  return e(ny, {
    number: dD,
    Complex: function(n) {
      return n.mul(n).mul(n);
    },
    BigNumber: function(n) {
      return n.times(n).times(n);
    },
    Fraction: function(n) {
      return n.pow(3);
    },
    Unit: function(n) {
      return n.pow(3);
    }
  });
}), ay = "exp", HS = ["typed"], tc = /* @__PURE__ */ U(ay, HS, (r) => {
  var {
    typed: e
  } = r;
  return e(ay, {
    number: mD,
    Complex: function(n) {
      return n.exp();
    },
    BigNumber: function(n) {
      return n.exp();
    }
  });
}), iy = "expm1", LS = ["typed", "Complex"], nc = /* @__PURE__ */ U(iy, LS, (r) => {
  var {
    typed: e,
    Complex: t
  } = r;
  return e(iy, {
    number: hD,
    Complex: function(a) {
      var i = Math.exp(a.re);
      return new t(i * Math.cos(a.im) - 1, i * Math.sin(a.im));
    },
    BigNumber: function(a) {
      return a.exp().minus(1);
    }
  });
}), Um = "fix", qS = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], US = /* @__PURE__ */ U(Um, ["typed", "ceil", "floor"], (r) => {
  var {
    typed: e,
    ceil: t,
    floor: n
  } = r;
  return e(Um, {
    number: function(i) {
      return i > 0 ? n(i) : t(i);
    },
    "number, number": function(i, u) {
      return i > 0 ? n(i, u) : t(i, u);
    }
  });
}), ac = /* @__PURE__ */ U(Um, qS, (r) => {
  var {
    typed: e,
    Complex: t,
    matrix: n,
    ceil: a,
    floor: i,
    equalScalar: u,
    zeros: f,
    DenseMatrix: c
  } = r, o = Qr({
    typed: e,
    DenseMatrix: c
  }), s = ln({
    typed: e
  }), l = US({
    typed: e,
    ceil: a,
    floor: i
  });
  return e("fix", {
    number: l.signatures.number,
    "number, number | BigNumber": l.signatures["number,number"],
    Complex: function(p) {
      return new t(p.re > 0 ? Math.floor(p.re) : Math.ceil(p.re), p.im > 0 ? Math.floor(p.im) : Math.ceil(p.im));
    },
    "Complex, number": function(p, h) {
      return new t(p.re > 0 ? i(p.re, h) : a(p.re, h), p.im > 0 ? i(p.im, h) : a(p.im, h));
    },
    "Complex, BigNumber": function(p, h) {
      var d = h.toNumber();
      return new t(p.re > 0 ? i(p.re, d) : a(p.re, d), p.im > 0 ? i(p.im, d) : a(p.im, d));
    },
    BigNumber: function(p) {
      return p.isNegative() ? a(p) : i(p);
    },
    "BigNumber, number | BigNumber": function(p, h) {
      return p.isNegative() ? a(p, h) : i(p, h);
    },
    Fraction: function(p) {
      return p.s < 0 ? p.ceil() : p.floor();
    },
    "Fraction, number | BigNumber": function(p, h) {
      return p.s < 0 ? a(p, h) : i(p, h);
    },
    "Array | Matrix": e.referToSelf((v) => (p) => $e(p, v)),
    "Array | Matrix, number | BigNumber": e.referToSelf((v) => (p, h) => $e(p, (d) => v(d, h))),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((v) => (p, h) => s(n(h), p, v, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((v) => (p, h) => u(p, 0) ? f(h.size(), h.storage()) : h.storage() === "dense" ? s(h, p, v, !0) : o(h, p, v, !0))
  });
}), km = "floor", kS = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], XS = /* @__PURE__ */ U(km, ["typed", "config", "round"], (r) => {
  var {
    typed: e,
    config: t,
    round: n
  } = r;
  return e(km, {
    number: function(i) {
      return wt(i, n(i), t.epsilon) ? n(i) : Math.floor(i);
    },
    "number, number": function(i, u) {
      if (wt(i, n(i, u), t.epsilon))
        return n(i, u);
      var [f, c] = "".concat(i, "e").split("e"), o = Math.floor(Number("".concat(f, "e").concat(Number(c) + u)));
      return [f, c] = "".concat(o, "e").split("e"), Number("".concat(f, "e").concat(Number(c) - u));
    }
  });
}), lo = /* @__PURE__ */ U(km, kS, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: u,
    DenseMatrix: f
  } = r, c = at({
    typed: e,
    equalScalar: i
  }), o = Qr({
    typed: e,
    DenseMatrix: f
  }), s = ln({
    typed: e
  }), l = XS({
    typed: e,
    config: t,
    round: n
  });
  return e("floor", {
    number: l.signatures.number,
    "number,number": l.signatures["number,number"],
    Complex: function(p) {
      return p.floor();
    },
    "Complex, number": function(p, h) {
      return p.floor(h);
    },
    "Complex, BigNumber": function(p, h) {
      return p.floor(h.toNumber());
    },
    BigNumber: function(p) {
      return Jt(p, n(p), t.epsilon) ? n(p) : p.floor();
    },
    "BigNumber, BigNumber": function(p, h) {
      return Jt(p, n(p, h), t.epsilon) ? n(p, h) : p.toDecimalPlaces(h.toNumber(), ra.ROUND_FLOOR);
    },
    Fraction: function(p) {
      return p.floor();
    },
    "Fraction, number": function(p, h) {
      return p.floor(h);
    },
    "Fraction, BigNumber": function(p, h) {
      return p.floor(h.toNumber());
    },
    "Array | Matrix": e.referToSelf((v) => (p) => $e(p, v)),
    "Array, number | BigNumber": e.referToSelf((v) => (p, h) => $e(p, (d) => v(d, h))),
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => c(p, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => s(p, h, v, !1)),
    "number | Complex | Fraction | BigNumber, Array": e.referToSelf((v) => (p, h) => s(a(h), p, v, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": e.referToSelf((v) => (p, h) => i(p, 0) ? u(h.size(), h.storage()) : h.storage() === "dense" ? s(h, p, v, !0) : o(h, p, v, !0))
  });
}), jS = "matAlgo02xDS0", GS = ["typed", "equalScalar"], fn = /* @__PURE__ */ U(jS, GS, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u, f) {
    var c = a._data, o = a._size, s = a._datatype || a.getDataType(), l = i._values, v = i._index, p = i._ptr, h = i._size, d = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (o.length !== h.length)
      throw new Ye(o.length, h.length);
    if (o[0] !== h[0] || o[1] !== h[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + h + ")");
    if (!l)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var x = o[0], g = o[1], y, m = t, b = 0, w = u;
    typeof s == "string" && s === d && s !== "mixed" && (y = s, m = e.find(t, [y, y]), b = e.convert(0, y), w = e.find(u, [y, y]));
    for (var A = [], E = [], N = [], C = 0; C < g; C++) {
      N[C] = E.length;
      for (var D = p[C], B = p[C + 1], S = D; S < B; S++) {
        var F = v[S], I = f ? w(l[S], c[F][C]) : w(c[F][C], l[S]);
        m(I, b) || (E.push(F), A.push(I));
      }
    }
    return N[g] = E.length, i.createSparseMatrix({
      values: A,
      index: E,
      ptr: N,
      size: [x, g],
      datatype: s === a._datatype && d === i._datatype ? y : void 0
    });
  };
}), VS = "matAlgo03xDSf", QS = ["typed"], Ct = /* @__PURE__ */ U(VS, QS, (r) => {
  var {
    typed: e
  } = r;
  return function(n, a, i, u) {
    var f = n._data, c = n._size, o = n._datatype || n.getDataType(), s = a._values, l = a._index, v = a._ptr, p = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (c.length !== p.length)
      throw new Ye(c.length, p.length);
    if (c[0] !== p[0] || c[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + p + ")");
    if (!s)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var d = c[0], x = c[1], g, y = 0, m = i;
    typeof o == "string" && o === h && o !== "mixed" && (g = o, y = e.convert(0, g), m = e.find(i, [g, g]));
    for (var b = [], w = 0; w < d; w++)
      b[w] = [];
    for (var A = [], E = [], N = 0; N < x; N++) {
      for (var C = N + 1, D = v[N], B = v[N + 1], S = D; S < B; S++) {
        var F = l[S];
        A[F] = u ? m(s[S], f[F][N]) : m(f[F][N], s[S]), E[F] = C;
      }
      for (var I = 0; I < d; I++)
        E[I] === C ? b[I][N] = A[I] : b[I][N] = u ? m(y, f[I][N]) : m(f[I][N], y);
    }
    return n.createDenseMatrix({
      data: b,
      size: [d, x],
      datatype: o === n._datatype && h === a._datatype ? g : void 0
    });
  };
}), YS = "matAlgo05xSfSf", ZS = ["typed", "equalScalar"], ic = /* @__PURE__ */ U(YS, ZS, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u) {
    var f = a._values, c = a._index, o = a._ptr, s = a._size, l = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), v = i._values, p = i._index, h = i._ptr, d = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (s.length !== d.length)
      throw new Ye(s.length, d.length);
    if (s[0] !== d[0] || s[1] !== d[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + d + ")");
    var g = s[0], y = s[1], m, b = t, w = 0, A = u;
    typeof l == "string" && l === x && l !== "mixed" && (m = l, b = e.find(t, [m, m]), w = e.convert(0, m), A = e.find(u, [m, m]));
    var E = f && v ? [] : void 0, N = [], C = [], D = E ? [] : void 0, B = E ? [] : void 0, S = [], F = [], I, z, P, M;
    for (z = 0; z < y; z++) {
      C[z] = N.length;
      var H = z + 1;
      for (P = o[z], M = o[z + 1]; P < M; P++)
        I = c[P], N.push(I), S[I] = H, D && (D[I] = f[P]);
      for (P = h[z], M = h[z + 1]; P < M; P++)
        I = p[P], S[I] !== H && N.push(I), F[I] = H, B && (B[I] = v[P]);
      if (E)
        for (P = C[z]; P < N.length; ) {
          I = N[P];
          var O = S[I], Q = F[I];
          if (O === H || Q === H) {
            var k = O === H ? D[I] : w, L = Q === H ? B[I] : w, R = A(k, L);
            b(R, w) ? N.splice(P, 1) : (E.push(R), P++);
          }
        }
    }
    return C[y] = N.length, a.createSparseMatrix({
      values: E,
      index: N,
      ptr: C,
      size: [g, y],
      datatype: l === a._datatype && x === i._datatype ? m : void 0
    });
  };
}), WS = "matAlgo13xDD", KS = ["typed"], JS = /* @__PURE__ */ U(WS, KS, (r) => {
  var {
    typed: e
  } = r;
  return function(a, i, u) {
    var f = a._data, c = a._size, o = a._datatype, s = i._data, l = i._size, v = i._datatype, p = [];
    if (c.length !== l.length)
      throw new Ye(c.length, l.length);
    for (var h = 0; h < c.length; h++) {
      if (c[h] !== l[h])
        throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + l + ")");
      p[h] = c[h];
    }
    var d, x = u;
    typeof o == "string" && o === v && (d = o, x = e.find(u, [d, d]));
    var g = p.length > 0 ? t(x, 0, p, p[0], f, s) : [];
    return a.createDenseMatrix({
      data: g,
      size: p,
      datatype: d
    });
  };
  function t(n, a, i, u, f, c) {
    var o = [];
    if (a === i.length - 1)
      for (var s = 0; s < u; s++)
        o[s] = n(f[s], c[s]);
    else
      for (var l = 0; l < u; l++)
        o[l] = t(n, a + 1, i, i[a + 1], f[l], c[l]);
    return o;
  }
}), _S = "broadcast", $S = ["concat"], eP = /* @__PURE__ */ U(_S, $S, (r) => {
  var {
    concat: e
  } = r;
  return function(a, i) {
    var u = Math.max(a._size.length, i._size.length);
    if (a._size.length === i._size.length && a._size.every((h, d) => h === i._size[d]))
      return [a, i];
    for (var f = t(a._size, u, 0), c = t(i._size, u, 0), o = [], s = 0; s < u; s++)
      o[s] = Math.max(f[s], c[s]);
    Ls(f, o), Ls(c, o);
    var l = a.clone(), v = i.clone();
    l._size.length < u ? l.reshape(t(l._size, u, 1)) : v._size.length < u && v.reshape(t(v._size, u, 1));
    for (var p = 0; p < u; p++)
      l._size[p] < o[p] && (l = n(l, o[p], p)), v._size[p] < o[p] && (v = n(v, o[p], p));
    return [l, v];
  };
  function t(a, i, u) {
    return [...Array(i - a.length).fill(u), ...a];
  }
  function n(a, i, u) {
    return e(...Array(i).fill(a), u);
  }
}), rP = "matrixAlgorithmSuite", tP = ["typed", "matrix", "concat"], Dr = /* @__PURE__ */ U(rP, tP, (r) => {
  var {
    typed: e,
    matrix: t,
    concat: n
  } = r, a = JS({
    typed: e
  }), i = ln({
    typed: e
  }), u = eP({
    concat: n
  });
  return function(c) {
    var o = c.elop, s = c.SD || c.DS, l;
    o ? (l = {
      "DenseMatrix, DenseMatrix": (d, x) => a(...u(d, x), o),
      "Array, Array": (d, x) => a(...u(t(d), t(x)), o).valueOf(),
      "Array, DenseMatrix": (d, x) => a(...u(t(d), x), o),
      "DenseMatrix, Array": (d, x) => a(...u(d, t(x)), o)
    }, c.SS && (l["SparseMatrix, SparseMatrix"] = (d, x) => c.SS(...u(d, x), o, !1)), c.DS && (l["DenseMatrix, SparseMatrix"] = (d, x) => c.DS(...u(d, x), o, !1), l["Array, SparseMatrix"] = (d, x) => c.DS(...u(t(d), x), o, !1)), s && (l["SparseMatrix, DenseMatrix"] = (d, x) => s(...u(x, d), o, !0), l["SparseMatrix, Array"] = (d, x) => s(...u(t(x), d), o, !0))) : (l = {
      "DenseMatrix, DenseMatrix": e.referToSelf((d) => (x, g) => a(...u(x, g), d)),
      "Array, Array": e.referToSelf((d) => (x, g) => a(...u(t(x), t(g)), d).valueOf()),
      "Array, DenseMatrix": e.referToSelf((d) => (x, g) => a(...u(t(x), g), d)),
      "DenseMatrix, Array": e.referToSelf((d) => (x, g) => a(...u(x, t(g)), d))
    }, c.SS && (l["SparseMatrix, SparseMatrix"] = e.referToSelf((d) => (x, g) => c.SS(...u(x, g), d, !1))), c.DS && (l["DenseMatrix, SparseMatrix"] = e.referToSelf((d) => (x, g) => c.DS(...u(x, g), d, !1)), l["Array, SparseMatrix"] = e.referToSelf((d) => (x, g) => c.DS(...u(t(x), g), d, !1))), s && (l["SparseMatrix, DenseMatrix"] = e.referToSelf((d) => (x, g) => s(...u(g, x), d, !0)), l["SparseMatrix, Array"] = e.referToSelf((d) => (x, g) => s(...u(t(g), x), d, !0))));
    var v = c.scalar || "any", p = c.Ds || c.Ss;
    p && (o ? (l["DenseMatrix," + v] = (d, x) => i(d, x, o, !1), l[v + ", DenseMatrix"] = (d, x) => i(x, d, o, !0), l["Array," + v] = (d, x) => i(t(d), x, o, !1).valueOf(), l[v + ", Array"] = (d, x) => i(t(x), d, o, !0).valueOf()) : (l["DenseMatrix," + v] = e.referToSelf((d) => (x, g) => i(x, g, d, !1)), l[v + ", DenseMatrix"] = e.referToSelf((d) => (x, g) => i(g, x, d, !0)), l["Array," + v] = e.referToSelf((d) => (x, g) => i(t(x), g, d, !1).valueOf()), l[v + ", Array"] = e.referToSelf((d) => (x, g) => i(t(g), x, d, !0).valueOf())));
    var h = c.sS !== void 0 ? c.sS : c.Ss;
    return o ? (c.Ss && (l["SparseMatrix," + v] = (d, x) => c.Ss(d, x, o, !1)), h && (l[v + ", SparseMatrix"] = (d, x) => h(x, d, o, !0))) : (c.Ss && (l["SparseMatrix," + v] = e.referToSelf((d) => (x, g) => c.Ss(x, g, d, !1))), h && (l[v + ", SparseMatrix"] = e.referToSelf((d) => (x, g) => h(g, x, d, !0)))), o && o.signatures && C2(l, o.signatures), l;
  };
}), oy = "mod", nP = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], fo = /* @__PURE__ */ U(oy, nP, (r) => {
  var {
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: u,
    DenseMatrix: f,
    concat: c
  } = r, o = lo({
    typed: e,
    config: t,
    round: n,
    matrix: a,
    equalScalar: i,
    zeros: u,
    DenseMatrix: f
  }), s = fn({
    typed: e,
    equalScalar: i
  }), l = Ct({
    typed: e
  }), v = ic({
    typed: e,
    equalScalar: i
  }), p = at({
    typed: e,
    equalScalar: i
  }), h = Qr({
    typed: e,
    DenseMatrix: f
  }), d = Dr({
    typed: e,
    matrix: a,
    concat: c
  });
  return e(oy, {
    "number, number": x,
    "BigNumber, BigNumber": function(y, m) {
      return m.isZero() ? y : y.sub(m.mul(o(y.div(m))));
    },
    "Fraction, Fraction": function(y, m) {
      return m.equals(0) ? y : y.sub(m.mul(o(y.div(m))));
    }
  }, d({
    SS: v,
    DS: l,
    SD: s,
    Ss: p,
    sS: h
  }));
  function x(g, y) {
    return y === 0 ? g : g - y * o(g / y);
  }
}), aP = "matAlgo01xDSid", iP = ["typed"], oa = /* @__PURE__ */ U(aP, iP, (r) => {
  var {
    typed: e
  } = r;
  return function(n, a, i, u) {
    var f = n._data, c = n._size, o = n._datatype || n.getDataType(), s = a._values, l = a._index, v = a._ptr, p = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (c.length !== p.length)
      throw new Ye(c.length, p.length);
    if (c[0] !== p[0] || c[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + p + ")");
    if (!s)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var d = c[0], x = c[1], g = typeof o == "string" && o !== "mixed" && o === h ? o : void 0, y = g ? e.find(i, [g, g]) : i, m, b, w = [];
    for (m = 0; m < d; m++)
      w[m] = [];
    var A = [], E = [];
    for (b = 0; b < x; b++) {
      for (var N = b + 1, C = v[b], D = v[b + 1], B = C; B < D; B++)
        m = l[B], A[m] = u ? y(s[B], f[m][b]) : y(f[m][b], s[B]), E[m] = N;
      for (m = 0; m < d; m++)
        E[m] === N ? w[m][b] = A[m] : w[m][b] = f[m][b];
    }
    return n.createDenseMatrix({
      data: w,
      size: [d, x],
      datatype: o === n._datatype && h === a._datatype ? g : void 0
    });
  };
}), oP = "matAlgo04xSidSid", sP = ["typed", "equalScalar"], bh = /* @__PURE__ */ U(oP, sP, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u) {
    var f = a._values, c = a._index, o = a._ptr, s = a._size, l = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), v = i._values, p = i._index, h = i._ptr, d = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (s.length !== d.length)
      throw new Ye(s.length, d.length);
    if (s[0] !== d[0] || s[1] !== d[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + d + ")");
    var g = s[0], y = s[1], m, b = t, w = 0, A = u;
    typeof l == "string" && l === x && l !== "mixed" && (m = l, b = e.find(t, [m, m]), w = e.convert(0, m), A = e.find(u, [m, m]));
    var E = f && v ? [] : void 0, N = [], C = [], D = f && v ? [] : void 0, B = f && v ? [] : void 0, S = [], F = [], I, z, P, M, H;
    for (z = 0; z < y; z++) {
      C[z] = N.length;
      var O = z + 1;
      for (M = o[z], H = o[z + 1], P = M; P < H; P++)
        I = c[P], N.push(I), S[I] = O, D && (D[I] = f[P]);
      for (M = h[z], H = h[z + 1], P = M; P < H; P++)
        if (I = p[P], S[I] === O) {
          if (D) {
            var Q = A(D[I], v[P]);
            b(Q, w) ? S[I] = null : D[I] = Q;
          }
        } else
          N.push(I), F[I] = O, B && (B[I] = v[P]);
      if (D && B)
        for (P = C[z]; P < N.length; )
          I = N[P], S[I] === O ? (E[P] = D[I], P++) : F[I] === O ? (E[P] = B[I], P++) : N.splice(P, 1);
    }
    return C[y] = N.length, a.createSparseMatrix({
      values: E,
      index: N,
      ptr: C,
      size: [g, y],
      datatype: l === a._datatype && x === i._datatype ? m : void 0
    });
  };
}), uP = "matAlgo10xSids", cP = ["typed", "DenseMatrix"], Ma = /* @__PURE__ */ U(uP, cP, (r) => {
  var {
    typed: e,
    DenseMatrix: t
  } = r;
  return function(a, i, u, f) {
    var c = a._values, o = a._index, s = a._ptr, l = a._size, v = a._datatype;
    if (!c)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var p = l[0], h = l[1], d, x = u;
    typeof v == "string" && (d = v, i = e.convert(i, d), x = e.find(u, [d, d]));
    for (var g = [], y = [], m = [], b = 0; b < h; b++) {
      for (var w = b + 1, A = s[b], E = s[b + 1], N = A; N < E; N++) {
        var C = o[N];
        y[C] = c[N], m[C] = w;
      }
      for (var D = 0; D < p; D++)
        b === 0 && (g[D] = []), m[D] === w ? g[D][b] = f ? x(i, y[D]) : x(y[D], i) : g[D][b] = i;
    }
    return new t({
      data: g,
      size: [p, h],
      datatype: d
    });
  };
});
function wn(r, e, t, n) {
  if (!(this instanceof wn))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = r, this.count = e, this.min = t, this.max = n, this.message = "Wrong number of arguments in function " + r + " (" + e + " provided, " + t + (n != null ? "-" + n : "") + " expected)", this.stack = new Error().stack;
}
wn.prototype = new Error();
wn.prototype.constructor = Error;
wn.prototype.name = "ArgumentsError";
wn.prototype.isArgumentsError = !0;
var sy = "gcd", lP = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], wm = "number | BigNumber | Fraction | Matrix | Array", fP = "".concat(wm, ", ").concat(wm, ", ...").concat(wm);
function uy(r) {
  return !r.some((e) => Array.isArray(e));
}
var oc = /* @__PURE__ */ U(sy, lP, (r) => {
  var {
    typed: e,
    matrix: t,
    config: n,
    round: a,
    equalScalar: i,
    zeros: u,
    BigNumber: f,
    DenseMatrix: c,
    concat: o
  } = r, s = fo({
    typed: e,
    config: n,
    round: a,
    matrix: t,
    equalScalar: i,
    zeros: u,
    DenseMatrix: c,
    concat: o
  }), l = oa({
    typed: e
  }), v = bh({
    typed: e,
    equalScalar: i
  }), p = Ma({
    typed: e,
    DenseMatrix: c
  }), h = Dr({
    typed: e,
    matrix: t,
    concat: o
  });
  return e(sy, {
    "number, number": d,
    "BigNumber, BigNumber": x,
    "Fraction, Fraction": (g, y) => g.gcd(y)
  }, h({
    SS: v,
    DS: l,
    Ss: p
  }), {
    [fP]: e.referToSelf((g) => (y, m, b) => {
      for (var w = g(y, m), A = 0; A < b.length; A++)
        w = g(w, b[A]);
      return w;
    }),
    Array: e.referToSelf((g) => (y) => {
      if (y.length === 1 && Array.isArray(y[0]) && uy(y[0]))
        return g(...y[0]);
      if (uy(y))
        return g(...y);
      throw new wn("gcd() supports only 1d matrices!");
    }),
    Matrix: e.referToSelf((g) => (y) => g(y.toArray()))
  });
  function d(g, y) {
    if (!Me(g) || !Me(y))
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var m; y !== 0; )
      m = s(g, y), g = y, y = m;
    return g < 0 ? -g : g;
  }
  function x(g, y) {
    if (!g.isInt() || !y.isInt())
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var m = new f(0); !y.isZero(); ) {
      var b = s(g, y);
      g = y, y = b;
    }
    return g.lt(m) ? g.neg() : g;
  }
}), vP = "matAlgo06xS0S0", pP = ["typed", "equalScalar"], sc = /* @__PURE__ */ U(vP, pP, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u) {
    var f = a._values, c = a._size, o = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), s = i._values, l = i._size, v = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (c.length !== l.length)
      throw new Ye(c.length, l.length);
    if (c[0] !== l[0] || c[1] !== l[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + l + ")");
    var p = c[0], h = c[1], d, x = t, g = 0, y = u;
    typeof o == "string" && o === v && o !== "mixed" && (d = o, x = e.find(t, [d, d]), g = e.convert(0, d), y = e.find(u, [d, d]));
    for (var m = f && s ? [] : void 0, b = [], w = [], A = m ? [] : void 0, E = [], N = [], C = 0; C < h; C++) {
      w[C] = b.length;
      var D = C + 1;
      if (Tx(a, C, E, A, N, D, b, y), Tx(i, C, E, A, N, D, b, y), A)
        for (var B = w[C]; B < b.length; ) {
          var S = b[B];
          if (N[S] === D) {
            var F = A[S];
            x(F, g) ? b.splice(B, 1) : (m.push(F), B++);
          } else
            b.splice(B, 1);
        }
      else
        for (var I = w[C]; I < b.length; ) {
          var z = b[I];
          N[z] !== D ? b.splice(I, 1) : I++;
        }
    }
    return w[h] = b.length, a.createSparseMatrix({
      values: m,
      index: b,
      ptr: w,
      size: [p, h],
      datatype: o === a._datatype && v === i._datatype ? d : void 0
    });
  };
}), cy = "lcm", dP = ["typed", "matrix", "equalScalar", "concat"], uc = /* @__PURE__ */ U(cy, dP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    concat: a
  } = r, i = fn({
    typed: e,
    equalScalar: n
  }), u = sc({
    typed: e,
    equalScalar: n
  }), f = at({
    typed: e,
    equalScalar: n
  }), c = Dr({
    typed: e,
    matrix: t,
    concat: a
  }), o = "number | BigNumber | Fraction | Matrix | Array", s = {};
  return s["".concat(o, ", ").concat(o, ", ...").concat(o)] = e.referToSelf((v) => (p, h, d) => {
    for (var x = v(p, h), g = 0; g < d.length; g++)
      x = v(x, d[g]);
    return x;
  }), e(cy, {
    "number, number": gD,
    "BigNumber, BigNumber": l,
    "Fraction, Fraction": (v, p) => v.lcm(p)
  }, c({
    SS: u,
    DS: i,
    Ss: f
  }), s);
  function l(v, p) {
    if (!v.isInt() || !p.isInt())
      throw new Error("Parameters in function lcm must be integer numbers");
    if (v.isZero())
      return v;
    if (p.isZero())
      return p;
    for (var h = v.times(p); !p.isZero(); ) {
      var d = p;
      p = v.mod(d), v = d;
    }
    return h.div(v).abs();
  }
}), ly = "log10", mP = ["typed", "config", "Complex"], cc = /* @__PURE__ */ U(ly, mP, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(ly, {
    number: function(i) {
      return i >= 0 || t.predictable ? xD(i) : new n(i, 0).log().div(Math.LN10);
    },
    Complex: function(i) {
      return new n(i).log().div(Math.LN10);
    },
    BigNumber: function(i) {
      return !i.isNegative() || t.predictable ? i.log() : new n(i.toNumber(), 0).log().div(Math.LN10);
    },
    "Array | Matrix": e.referToSelf((a) => (i) => $e(i, a))
  });
}), fy = "log2", hP = ["typed", "config", "Complex"], lc = /* @__PURE__ */ U(fy, hP, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(fy, {
    number: function(u) {
      return u >= 0 || t.predictable ? yD(u) : a(new n(u, 0));
    },
    Complex: a,
    BigNumber: function(u) {
      return !u.isNegative() || t.predictable ? u.log(2) : a(new n(u.toNumber(), 0));
    },
    "Array | Matrix": e.referToSelf((i) => (u) => $e(u, i))
  });
  function a(i) {
    var u = Math.sqrt(i.re * i.re + i.im * i.im);
    return new n(Math.log2 ? Math.log2(u) : Math.log(u) / Math.LN2, Math.atan2(i.im, i.re) / Math.LN2);
  }
}), gP = "multiplyScalar", xP = ["typed"], fc = /* @__PURE__ */ U(gP, xP, (r) => {
  var {
    typed: e
  } = r;
  return e("multiplyScalar", {
    "number, number": fD,
    "Complex, Complex": function(n, a) {
      return n.mul(a);
    },
    "BigNumber, BigNumber": function(n, a) {
      return n.times(a);
    },
    "Fraction, Fraction": function(n, a) {
      return n.mul(a);
    },
    "number | Fraction | BigNumber | Complex, Unit": (t, n) => n.multiply(t),
    "Unit, number | Fraction | BigNumber | Complex | Unit": (t, n) => t.multiply(n)
  });
}), vy = "multiply", yP = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], vc = /* @__PURE__ */ U(vy, yP, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    multiplyScalar: a,
    equalScalar: i,
    dot: u
  } = r, f = at({
    typed: e,
    equalScalar: i
  }), c = ln({
    typed: e
  });
  function o(w, A) {
    switch (w.length) {
      case 1:
        switch (A.length) {
          case 1:
            if (w[0] !== A[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (w[0] !== A[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + w[0] + ") must match Matrix rows (" + A[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + A.length + " dimensions)");
        }
        break;
      case 2:
        switch (A.length) {
          case 1:
            if (w[1] !== A[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + w[1] + ") must match Vector length (" + A[0] + ")");
            break;
          case 2:
            if (w[1] !== A[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + w[1] + ") must match Matrix B rows (" + A[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + A.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + w.length + " dimensions)");
    }
  }
  function s(w, A, E) {
    if (E === 0)
      throw new Error("Cannot multiply two empty vectors");
    return u(w, A);
  }
  function l(w, A) {
    if (A.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return v(w, A);
  }
  function v(w, A) {
    var E = w._data, N = w._size, C = w._datatype || w.getDataType(), D = A._data, B = A._size, S = A._datatype || A.getDataType(), F = N[0], I = B[1], z, P = n, M = a;
    C && S && C === S && typeof C == "string" && C !== "mixed" && (z = C, P = e.find(n, [z, z]), M = e.find(a, [z, z]));
    for (var H = [], O = 0; O < I; O++) {
      for (var Q = M(E[0], D[0][O]), k = 1; k < F; k++)
        Q = P(Q, M(E[k], D[k][O]));
      H[O] = Q;
    }
    return w.createDenseMatrix({
      data: H,
      size: [I],
      datatype: C === w._datatype && S === A._datatype ? z : void 0
    });
  }
  var p = e("_multiplyMatrixVector", {
    "DenseMatrix, any": d,
    "SparseMatrix, any": y
  }), h = e("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": x,
    "DenseMatrix, SparseMatrix": g,
    "SparseMatrix, DenseMatrix": m,
    "SparseMatrix, SparseMatrix": b
  });
  function d(w, A) {
    var E = w._data, N = w._size, C = w._datatype || w.getDataType(), D = A._data, B = A._datatype || A.getDataType(), S = N[0], F = N[1], I, z = n, P = a;
    C && B && C === B && typeof C == "string" && C !== "mixed" && (I = C, z = e.find(n, [I, I]), P = e.find(a, [I, I]));
    for (var M = [], H = 0; H < S; H++) {
      for (var O = E[H], Q = P(O[0], D[0]), k = 1; k < F; k++)
        Q = z(Q, P(O[k], D[k]));
      M[H] = Q;
    }
    return w.createDenseMatrix({
      data: M,
      size: [S],
      datatype: C === w._datatype && B === A._datatype ? I : void 0
    });
  }
  function x(w, A) {
    var E = w._data, N = w._size, C = w._datatype || w.getDataType(), D = A._data, B = A._size, S = A._datatype || A.getDataType(), F = N[0], I = N[1], z = B[1], P, M = n, H = a;
    C && S && C === S && typeof C == "string" && C !== "mixed" && C !== "mixed" && (P = C, M = e.find(n, [P, P]), H = e.find(a, [P, P]));
    for (var O = [], Q = 0; Q < F; Q++) {
      var k = E[Q];
      O[Q] = [];
      for (var L = 0; L < z; L++) {
        for (var R = H(k[0], D[0][L]), X = 1; X < I; X++)
          R = M(R, H(k[X], D[X][L]));
        O[Q][L] = R;
      }
    }
    return w.createDenseMatrix({
      data: O,
      size: [F, z],
      datatype: C === w._datatype && S === A._datatype ? P : void 0
    });
  }
  function g(w, A) {
    var E = w._data, N = w._size, C = w._datatype || w.getDataType(), D = A._values, B = A._index, S = A._ptr, F = A._size, I = A._datatype || A._data === void 0 ? A._datatype : A.getDataType();
    if (!D)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var z = N[0], P = F[1], M, H = n, O = a, Q = i, k = 0;
    C && I && C === I && typeof C == "string" && C !== "mixed" && (M = C, H = e.find(n, [M, M]), O = e.find(a, [M, M]), Q = e.find(i, [M, M]), k = e.convert(0, M));
    for (var L = [], R = [], X = [], ae = A.createSparseMatrix({
      values: L,
      index: R,
      ptr: X,
      size: [z, P],
      datatype: C === w._datatype && I === A._datatype ? M : void 0
    }), _ = 0; _ < P; _++) {
      X[_] = R.length;
      var re = S[_], te = S[_ + 1];
      if (te > re)
        for (var ne = 0, oe = 0; oe < z; oe++) {
          for (var le = oe + 1, fe = void 0, ge = re; ge < te; ge++) {
            var Be = B[ge];
            ne !== le ? (fe = O(E[oe][Be], D[ge]), ne = le) : fe = H(fe, O(E[oe][Be], D[ge]));
          }
          ne === le && !Q(fe, k) && (R.push(oe), L.push(fe));
        }
    }
    return X[P] = R.length, ae;
  }
  function y(w, A) {
    var E = w._values, N = w._index, C = w._ptr, D = w._datatype || w._data === void 0 ? w._datatype : w.getDataType();
    if (!E)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var B = A._data, S = A._datatype || A.getDataType(), F = w._size[0], I = A._size[0], z = [], P = [], M = [], H, O = n, Q = a, k = i, L = 0;
    D && S && D === S && typeof D == "string" && D !== "mixed" && (H = D, O = e.find(n, [H, H]), Q = e.find(a, [H, H]), k = e.find(i, [H, H]), L = e.convert(0, H));
    var R = [], X = [];
    M[0] = 0;
    for (var ae = 0; ae < I; ae++) {
      var _ = B[ae];
      if (!k(_, L))
        for (var re = C[ae], te = C[ae + 1], ne = re; ne < te; ne++) {
          var oe = N[ne];
          X[oe] ? R[oe] = O(R[oe], Q(_, E[ne])) : (X[oe] = !0, P.push(oe), R[oe] = Q(_, E[ne]));
        }
    }
    for (var le = P.length, fe = 0; fe < le; fe++) {
      var ge = P[fe];
      z[fe] = R[ge];
    }
    return M[1] = P.length, w.createSparseMatrix({
      values: z,
      index: P,
      ptr: M,
      size: [F, 1],
      datatype: D === w._datatype && S === A._datatype ? H : void 0
    });
  }
  function m(w, A) {
    var E = w._values, N = w._index, C = w._ptr, D = w._datatype || w._data === void 0 ? w._datatype : w.getDataType();
    if (!E)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var B = A._data, S = A._datatype || A.getDataType(), F = w._size[0], I = A._size[0], z = A._size[1], P, M = n, H = a, O = i, Q = 0;
    D && S && D === S && typeof D == "string" && D !== "mixed" && (P = D, M = e.find(n, [P, P]), H = e.find(a, [P, P]), O = e.find(i, [P, P]), Q = e.convert(0, P));
    for (var k = [], L = [], R = [], X = w.createSparseMatrix({
      values: k,
      index: L,
      ptr: R,
      size: [F, z],
      datatype: D === w._datatype && S === A._datatype ? P : void 0
    }), ae = [], _ = [], re = 0; re < z; re++) {
      R[re] = L.length;
      for (var te = re + 1, ne = 0; ne < I; ne++) {
        var oe = B[ne][re];
        if (!O(oe, Q))
          for (var le = C[ne], fe = C[ne + 1], ge = le; ge < fe; ge++) {
            var Be = N[ge];
            _[Be] !== te ? (_[Be] = te, L.push(Be), ae[Be] = H(oe, E[ge])) : ae[Be] = M(ae[Be], H(oe, E[ge]));
          }
      }
      for (var j = R[re], Y = L.length, ie = j; ie < Y; ie++) {
        var V = L[ie];
        k[ie] = ae[V];
      }
    }
    return R[z] = L.length, X;
  }
  function b(w, A) {
    var E = w._values, N = w._index, C = w._ptr, D = w._datatype || w._data === void 0 ? w._datatype : w.getDataType(), B = A._values, S = A._index, F = A._ptr, I = A._datatype || A._data === void 0 ? A._datatype : A.getDataType(), z = w._size[0], P = A._size[1], M = E && B, H, O = n, Q = a;
    D && I && D === I && typeof D == "string" && D !== "mixed" && (H = D, O = e.find(n, [H, H]), Q = e.find(a, [H, H]));
    for (var k = M ? [] : void 0, L = [], R = [], X = w.createSparseMatrix({
      values: k,
      index: L,
      ptr: R,
      size: [z, P],
      datatype: D === w._datatype && I === A._datatype ? H : void 0
    }), ae = M ? [] : void 0, _ = [], re, te, ne, oe, le, fe, ge, Be, j = 0; j < P; j++) {
      R[j] = L.length;
      var Y = j + 1;
      for (le = F[j], fe = F[j + 1], oe = le; oe < fe; oe++)
        if (Be = S[oe], M)
          for (te = C[Be], ne = C[Be + 1], re = te; re < ne; re++)
            ge = N[re], _[ge] !== Y ? (_[ge] = Y, L.push(ge), ae[ge] = Q(B[oe], E[re])) : ae[ge] = O(ae[ge], Q(B[oe], E[re]));
        else
          for (te = C[Be], ne = C[Be + 1], re = te; re < ne; re++)
            ge = N[re], _[ge] !== Y && (_[ge] = Y, L.push(ge));
      if (M)
        for (var ie = R[j], V = L.length, J = ie; J < V; J++) {
          var $ = L[J];
          k[J] = ae[$];
        }
    }
    return R[P] = L.length, X;
  }
  return e(vy, a, {
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": e.referTo("Matrix, Matrix", (w) => (A, E) => {
      o(Ve(A), Ve(E));
      var N = w(t(A), t(E));
      return Oe(N) ? N.valueOf() : N;
    }),
    "Matrix, Matrix": function(A, E) {
      var N = A.size(), C = E.size();
      return o(N, C), N.length === 1 ? C.length === 1 ? s(A, E, N[0]) : l(A, E) : C.length === 1 ? p(A, E) : h(A, E);
    },
    "Matrix, Array": e.referTo("Matrix,Matrix", (w) => (A, E) => w(A, t(E))),
    "Array, Matrix": e.referToSelf((w) => (A, E) => w(t(A, E.storage()), E)),
    "SparseMatrix, any": function(A, E) {
      return f(A, E, a, !1);
    },
    "DenseMatrix, any": function(A, E) {
      return c(A, E, a, !1);
    },
    "any, SparseMatrix": function(A, E) {
      return f(E, A, a, !0);
    },
    "any, DenseMatrix": function(A, E) {
      return c(E, A, a, !0);
    },
    "Array, any": function(A, E) {
      return c(t(A), E, a, !1).valueOf();
    },
    "any, Array": function(A, E) {
      return c(t(E), A, a, !0).valueOf();
    },
    "any, any": a,
    "any, any, ...any": e.referToSelf((w) => (A, E, N) => {
      for (var C = w(A, E), D = 0; D < N.length; D++)
        C = w(C, N[D]);
      return C;
    })
  });
}), py = "nthRoot", AP = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], pc = /* @__PURE__ */ U(py, AP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    BigNumber: a,
    concat: i
  } = r, u = oa({
    typed: e
  }), f = fn({
    typed: e,
    equalScalar: n
  }), c = sc({
    typed: e,
    equalScalar: n
  }), o = at({
    typed: e,
    equalScalar: n
  }), s = Dr({
    typed: e,
    matrix: t,
    concat: i
  });
  function l() {
    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return e(py, {
    number: zx,
    "number, number": zx,
    BigNumber: (p) => v(p, new a(2)),
    "BigNumber, BigNumber": v,
    Complex: l,
    "Complex, number": l,
    Array: e.referTo("DenseMatrix,number", (p) => (h) => p(t(h), 2).valueOf()),
    DenseMatrix: e.referTo("DenseMatrix,number", (p) => (h) => p(h, 2)),
    SparseMatrix: e.referTo("SparseMatrix,number", (p) => (h) => p(h, 2)),
    "SparseMatrix, SparseMatrix": e.referToSelf((p) => (h, d) => {
      if (d.density() === 1)
        return c(h, d, p);
      throw new Error("Root must be non-zero");
    }),
    "DenseMatrix, SparseMatrix": e.referToSelf((p) => (h, d) => {
      if (d.density() === 1)
        return u(h, d, p, !1);
      throw new Error("Root must be non-zero");
    }),
    "Array, SparseMatrix": e.referTo("DenseMatrix,SparseMatrix", (p) => (h, d) => p(t(h), d)),
    "number | BigNumber, SparseMatrix": e.referToSelf((p) => (h, d) => {
      if (d.density() === 1)
        return o(d, h, p, !0);
      throw new Error("Root must be non-zero");
    })
  }, s({
    scalar: "number | BigNumber",
    SD: f,
    Ss: o,
    sS: !1
  }));
  function v(p, h) {
    var d = a.precision, x = a.clone({
      precision: d + 2
    }), g = new a(0), y = new x(1), m = h.isNegative();
    if (m && (h = h.neg()), h.isZero())
      throw new Error("Root must be non-zero");
    if (p.isNegative() && !h.abs().mod(2).equals(1))
      throw new Error("Root must be odd when a is negative.");
    if (p.isZero())
      return m ? new x(1 / 0) : 0;
    if (!p.isFinite())
      return m ? g : p;
    var b = p.abs().pow(y.div(h));
    return b = p.isNeg() ? b.neg() : b, new a((m ? y.div(b) : b).toPrecision(d));
  }
}), dy = "sign", bP = ["typed", "BigNumber", "Fraction", "complex"], dc = /* @__PURE__ */ U(dy, bP, (r) => {
  var {
    typed: e,
    BigNumber: t,
    complex: n,
    Fraction: a
  } = r;
  return e(dy, {
    number: Lm,
    Complex: function(u) {
      return u.im === 0 ? n(Lm(u.re)) : u.sign();
    },
    BigNumber: function(u) {
      return new t(u.cmp(0));
    },
    Fraction: function(u) {
      return new a(u.s, 1);
    },
    // deep map collection, skip zeros since sign(0) = 0
    "Array | Matrix": e.referToSelf((i) => (u) => $e(u, i)),
    Unit: e.referToSelf((i) => (u) => {
      if (!u._isDerived() && u.units[0].unit.offset !== 0)
        throw new TypeError("sign is ambiguous for units with offset");
      return e.find(i, u.valueType())(u.value);
    })
  });
}), wP = "sqrt", DP = ["config", "typed", "Complex"], mc = /* @__PURE__ */ U(wP, DP, (r) => {
  var {
    config: e,
    typed: t,
    Complex: n
  } = r;
  return t("sqrt", {
    number: a,
    Complex: function(u) {
      return u.sqrt();
    },
    BigNumber: function(u) {
      return !u.isNegative() || e.predictable ? u.sqrt() : a(u.toNumber());
    },
    Unit: function(u) {
      return u.pow(0.5);
    }
  });
  function a(i) {
    return isNaN(i) ? NaN : i >= 0 || e.predictable ? Math.sqrt(i) : new n(i, 0).sqrt();
  }
}), my = "square", CP = ["typed"], hc = /* @__PURE__ */ U(my, CP, (r) => {
  var {
    typed: e
  } = r;
  return e(my, {
    number: AD,
    Complex: function(n) {
      return n.mul(n);
    },
    BigNumber: function(n) {
      return n.times(n);
    },
    Fraction: function(n) {
      return n.mul(n);
    },
    Unit: function(n) {
      return n.pow(2);
    }
  });
}), hy = "subtract", EP = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], gc = /* @__PURE__ */ U(hy, EP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    subtractScalar: a,
    unaryMinus: i,
    DenseMatrix: u,
    concat: f
  } = r, c = oa({
    typed: e
  }), o = Ct({
    typed: e
  }), s = ic({
    typed: e,
    equalScalar: n
  }), l = Ma({
    typed: e,
    DenseMatrix: u
  }), v = Qr({
    typed: e,
    DenseMatrix: u
  }), p = Dr({
    typed: e,
    matrix: t,
    concat: f
  });
  return e(hy, {
    "any, any": a
  }, p({
    elop: a,
    SS: s,
    DS: c,
    SD: o,
    Ss: v,
    sS: l
  }));
}), gy = "xgcd", NP = ["typed", "config", "matrix", "BigNumber"], xc = /* @__PURE__ */ U(gy, NP, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e(gy, {
    "number, number": function(f, c) {
      var o = bD(f, c);
      return t.matrix === "Array" ? o : n(o);
    },
    "BigNumber, BigNumber": i
    // TODO: implement support for Fraction
  });
  function i(u, f) {
    var c, o, s, l = new a(0), v = new a(1), p = l, h = v, d = v, x = l;
    if (!u.isInt() || !f.isInt())
      throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !f.isZero(); )
      o = u.div(f).floor(), s = u.mod(f), c = p, p = h.minus(o.times(p)), h = c, c = d, d = x.minus(o.times(d)), x = c, u = f, f = s;
    var g;
    return u.lt(l) ? g = [u.neg(), h.neg(), x.neg()] : g = [u, u.isZero() ? 0 : h, x], t.matrix === "Array" ? g : n(g);
  }
}), xy = "invmod", BP = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], yc = /* @__PURE__ */ U(xy, BP, (r) => {
  var {
    typed: e,
    config: t,
    BigNumber: n,
    xgcd: a,
    equal: i,
    smaller: u,
    mod: f,
    add: c,
    isInteger: o
  } = r;
  return e(xy, {
    "number, number": s,
    "BigNumber, BigNumber": s
  });
  function s(l, v) {
    if (!o(l) || !o(v))
      throw new Error("Parameters in function invmod must be integer numbers");
    if (l = f(l, v), i(v, 0))
      throw new Error("Divisor must be non zero");
    var p = a(l, v);
    p = p.valueOf();
    var [h, d] = p;
    return i(h, n(1)) ? (d = f(d, v), u(d, n(0)) && (d = c(d, v)), d) : NaN;
  }
}), SP = "matAlgo09xS0Sf", PP = ["typed", "equalScalar"], n4 = /* @__PURE__ */ U(SP, PP, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u) {
    var f = a._values, c = a._index, o = a._ptr, s = a._size, l = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), v = i._values, p = i._index, h = i._ptr, d = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (s.length !== d.length)
      throw new Ye(s.length, d.length);
    if (s[0] !== d[0] || s[1] !== d[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + d + ")");
    var g = s[0], y = s[1], m, b = t, w = 0, A = u;
    typeof l == "string" && l === x && l !== "mixed" && (m = l, b = e.find(t, [m, m]), w = e.convert(0, m), A = e.find(u, [m, m]));
    var E = f && v ? [] : void 0, N = [], C = [], D = E ? [] : void 0, B = [], S, F, I, z, P;
    for (F = 0; F < y; F++) {
      C[F] = N.length;
      var M = F + 1;
      if (D)
        for (z = h[F], P = h[F + 1], I = z; I < P; I++)
          S = p[I], B[S] = M, D[S] = v[I];
      for (z = o[F], P = o[F + 1], I = z; I < P; I++)
        if (S = c[I], D) {
          var H = B[S] === M ? D[S] : w, O = A(f[I], H);
          b(O, w) || (N.push(S), E.push(O));
        } else
          N.push(S);
    }
    return C[y] = N.length, a.createSparseMatrix({
      values: E,
      index: N,
      ptr: C,
      size: [g, y],
      datatype: l === a._datatype && x === i._datatype ? m : void 0
    });
  };
}), yy = "dotMultiply", MP = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], Ac = /* @__PURE__ */ U(yy, MP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    multiplyScalar: a,
    concat: i
  } = r, u = fn({
    typed: e,
    equalScalar: n
  }), f = n4({
    typed: e,
    equalScalar: n
  }), c = at({
    typed: e,
    equalScalar: n
  }), o = Dr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(yy, o({
    elop: a,
    SS: f,
    DS: u,
    Ss: c
  }));
});
function FP(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitAnd");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  if (r.isZero() || e.eq(-1) || r.eq(e))
    return r;
  if (e.isZero() || r.eq(-1))
    return e;
  if (!r.isFinite() || !e.isFinite()) {
    if (!r.isFinite() && !e.isFinite())
      return r.isNegative() === e.isNegative() ? r : new t(0);
    if (!r.isFinite())
      return e.isNegative() ? r : r.isNegative() ? new t(0) : e;
    if (!e.isFinite())
      return r.isNegative() ? e : e.isNegative() ? new t(0) : r;
  }
  return wh(r, e, function(n, a) {
    return n & a;
  });
}
function to(r) {
  if (r.isFinite() && !r.isInteger())
    throw new Error("Integer expected in function bitNot");
  var e = r.constructor, t = e.precision;
  e.config({
    precision: 1e9
  });
  var n = r.plus(new e(1));
  return n.s = -n.s || null, e.config({
    precision: t
  }), n;
}
function TP(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitOr");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  var n = new t(-1);
  return r.isZero() || e.eq(n) || r.eq(e) ? e : e.isZero() || r.eq(n) ? r : !r.isFinite() || !e.isFinite() ? !r.isFinite() && !r.isNegative() && e.isNegative() || r.isNegative() && !e.isNegative() && !e.isFinite() ? n : r.isNegative() && e.isNegative() ? r.isFinite() ? r : e : r.isFinite() ? e : r : wh(r, e, function(a, i) {
    return a | i;
  });
}
function wh(r, e, t) {
  var n = r.constructor, a, i, u = +(r.s < 0), f = +(e.s < 0);
  if (u) {
    a = us(to(r));
    for (var c = 0; c < a.length; ++c)
      a[c] ^= 1;
  } else
    a = us(r);
  if (f) {
    i = us(to(e));
    for (var o = 0; o < i.length; ++o)
      i[o] ^= 1;
  } else
    i = us(e);
  var s, l, v;
  a.length <= i.length ? (s = a, l = i, v = u) : (s = i, l = a, v = f);
  var p = s.length, h = l.length, d = t(u, f) ^ 1, x = new n(d ^ 1), g = new n(1), y = new n(2), m = n.precision;
  for (n.config({
    precision: 1e9
  }); p > 0; )
    t(s[--p], l[--h]) === d && (x = x.plus(g)), g = g.times(y);
  for (; h > 0; )
    t(v, l[--h]) === d && (x = x.plus(g)), g = g.times(y);
  return n.config({
    precision: m
  }), d === 0 && (x.s = -x.s), x;
}
function us(r) {
  for (var e = r.d, t = e[0] + "", n = 1; n < e.length; ++n) {
    for (var a = e[n] + "", i = 7 - a.length; i--; )
      a = "0" + a;
    t += a;
  }
  for (var u = t.length; t.charAt(u) === "0"; )
    u--;
  var f = r.e, c = t.slice(0, u + 1 || 1), o = c.length;
  if (f > 0)
    if (++f > o)
      for (f -= o; f--; )
        c += "0";
    else
      f < o && (c = c.slice(0, f) + "." + c.slice(f));
  for (var s = [0], l = 0; l < c.length; ) {
    for (var v = s.length; v--; )
      s[v] *= 10;
    s[0] += parseInt(c.charAt(l++));
    for (var p = 0; p < s.length; ++p)
      s[p] > 1 && ((s[p + 1] === null || s[p + 1] === void 0) && (s[p + 1] = 0), s[p + 1] += s[p] >> 1, s[p] &= 1);
  }
  return s.reverse();
}
function OP(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function bitXor");
  var t = r.constructor;
  if (r.isNaN() || e.isNaN())
    return new t(NaN);
  if (r.isZero())
    return e;
  if (e.isZero())
    return r;
  if (r.eq(e))
    return new t(0);
  var n = new t(-1);
  return r.eq(n) ? to(e) : e.eq(n) ? to(r) : !r.isFinite() || !e.isFinite() ? !r.isFinite() && !e.isFinite() ? n : new t(r.isNegative() === e.isNegative() ? 1 / 0 : -1 / 0) : wh(r, e, function(a, i) {
    return a ^ i;
  });
}
function zP(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function leftShift");
  var t = r.constructor;
  return r.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new t(NaN) : r.isZero() || e.isZero() ? r : !r.isFinite() && !e.isFinite() ? new t(NaN) : e.lt(55) ? r.times(Math.pow(2, e.toNumber()) + "") : r.times(new t(2).pow(e));
}
function RP(r, e) {
  if (r.isFinite() && !r.isInteger() || e.isFinite() && !e.isInteger())
    throw new Error("Integers expected in function rightArithShift");
  var t = r.constructor;
  return r.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new t(NaN) : r.isZero() || e.isZero() ? r : e.isFinite() ? e.lt(55) ? r.div(Math.pow(2, e.toNumber()) + "").floor() : r.div(new t(2).pow(e)).floor() : r.isNegative() ? new t(-1) : r.isFinite() ? new t(0) : new t(NaN);
}
var Ay = "bitAnd", IP = ["typed", "matrix", "equalScalar", "concat"], vo = /* @__PURE__ */ U(Ay, IP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    concat: a
  } = r, i = fn({
    typed: e,
    equalScalar: n
  }), u = sc({
    typed: e,
    equalScalar: n
  }), f = at({
    typed: e,
    equalScalar: n
  }), c = Dr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(Ay, {
    "number, number": DD,
    "BigNumber, BigNumber": FP
  }, c({
    SS: u,
    DS: i,
    Ss: f
  }));
}), by = "bitNot", HP = ["typed"], bc = /* @__PURE__ */ U(by, HP, (r) => {
  var {
    typed: e
  } = r;
  return e(by, {
    number: CD,
    BigNumber: to,
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), wy = "bitOr", LP = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], po = /* @__PURE__ */ U(wy, LP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, u = oa({
    typed: e
  }), f = bh({
    typed: e,
    equalScalar: n
  }), c = Ma({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(wy, {
    "number, number": ED,
    "BigNumber, BigNumber": TP
  }, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), qP = "matAlgo07xSSf", UP = ["typed", "DenseMatrix"], Dn = /* @__PURE__ */ U(qP, UP, (r) => {
  var {
    typed: e,
    DenseMatrix: t
  } = r;
  return function(i, u, f) {
    var c = i._size, o = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), s = u._size, l = u._datatype || u._data === void 0 ? u._datatype : u.getDataType();
    if (c.length !== s.length)
      throw new Ye(c.length, s.length);
    if (c[0] !== s[0] || c[1] !== s[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + s + ")");
    var v = c[0], p = c[1], h, d = 0, x = f;
    typeof o == "string" && o === l && o !== "mixed" && (h = o, d = e.convert(0, h), x = e.find(f, [h, h]));
    var g, y, m = [];
    for (g = 0; g < v; g++)
      m[g] = [];
    var b = [], w = [], A = [], E = [];
    for (y = 0; y < p; y++) {
      var N = y + 1;
      for (n(i, y, A, b, N), n(u, y, E, w, N), g = 0; g < v; g++) {
        var C = A[g] === N ? b[g] : d, D = E[g] === N ? w[g] : d;
        m[g][y] = x(C, D);
      }
    }
    return new t({
      data: m,
      size: [v, p],
      datatype: o === i._datatype && l === u._datatype ? h : void 0
    });
  };
  function n(a, i, u, f, c) {
    for (var o = a._values, s = a._index, l = a._ptr, v = l[i], p = l[i + 1]; v < p; v++) {
      var h = s[v];
      u[h] = c, f[h] = o[v];
    }
  }
}), Dy = "bitXor", kP = ["typed", "matrix", "DenseMatrix", "concat"], wc = /* @__PURE__ */ U(Dy, kP, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    concat: a
  } = r, i = Ct({
    typed: e
  }), u = Dn({
    typed: e,
    DenseMatrix: n
  }), f = Qr({
    typed: e,
    DenseMatrix: n
  }), c = Dr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(Dy, {
    "number, number": ND,
    "BigNumber, BigNumber": OP
  }, c({
    SS: u,
    DS: i,
    Ss: f
  }));
}), Cy = "arg", XP = ["typed"], Dc = /* @__PURE__ */ U(Cy, XP, (r) => {
  var {
    typed: e
  } = r;
  return e(Cy, {
    number: function(n) {
      return Math.atan2(0, n);
    },
    BigNumber: function(n) {
      return n.constructor.atan2(0, n);
    },
    Complex: function(n) {
      return n.arg();
    },
    // TODO: implement BigNumber support for function arg
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Ey = "conj", jP = ["typed"], Cc = /* @__PURE__ */ U(Ey, jP, (r) => {
  var {
    typed: e
  } = r;
  return e(Ey, {
    "number | BigNumber | Fraction": (t) => t,
    Complex: (t) => t.conjugate(),
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Ny = "im", GP = ["typed"], Ec = /* @__PURE__ */ U(Ny, GP, (r) => {
  var {
    typed: e
  } = r;
  return e(Ny, {
    number: () => 0,
    "BigNumber | Fraction": (t) => t.mul(0),
    Complex: (t) => t.im,
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), By = "re", VP = ["typed"], Nc = /* @__PURE__ */ U(By, VP, (r) => {
  var {
    typed: e
  } = r;
  return e(By, {
    "number | BigNumber | Fraction": (t) => t,
    Complex: (t) => t.re,
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Sy = "not", QP = ["typed"], Bc = /* @__PURE__ */ U(Sy, QP, (r) => {
  var {
    typed: e
  } = r;
  return e(Sy, {
    "null | undefined": () => !0,
    number: FD,
    Complex: function(n) {
      return n.re === 0 && n.im === 0;
    },
    BigNumber: function(n) {
      return n.isZero() || n.isNaN();
    },
    Unit: e.referToSelf((t) => (n) => e.find(t, n.valueType())(n.value)),
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), Py = "or", YP = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], mo = /* @__PURE__ */ U(Py, YP, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = ic({
    typed: e,
    equalScalar: n
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(Py, {
    "number, number": TD,
    "Complex, Complex": function(l, v) {
      return l.re !== 0 || l.im !== 0 || v.re !== 0 || v.im !== 0;
    },
    "BigNumber, BigNumber": function(l, v) {
      return !l.isZero() && !l.isNaN() || !v.isZero() && !v.isNaN();
    },
    "Unit, Unit": e.referToSelf((s) => (l, v) => s(l.value || 0, v.value || 0))
  }, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), My = "xor", ZP = ["typed", "matrix", "DenseMatrix", "concat"], Sc = /* @__PURE__ */ U(My, ZP, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    concat: a
  } = r, i = Ct({
    typed: e
  }), u = Dn({
    typed: e,
    DenseMatrix: n
  }), f = Qr({
    typed: e,
    DenseMatrix: n
  }), c = Dr({
    typed: e,
    matrix: t,
    concat: a
  });
  return e(My, {
    "number, number": OD,
    "Complex, Complex": function(s, l) {
      return (s.re !== 0 || s.im !== 0) != (l.re !== 0 || l.im !== 0);
    },
    "BigNumber, BigNumber": function(s, l) {
      return (!s.isZero() && !s.isNaN()) != (!l.isZero() && !l.isNaN());
    },
    "Unit, Unit": e.referToSelf((o) => (s, l) => o(s.value || 0, l.value || 0))
  }, c({
    SS: u,
    DS: i,
    Ss: f
  }));
}), Fy = "concat", WP = ["typed", "matrix", "isInteger"], ho = /* @__PURE__ */ U(Fy, WP, (r) => {
  var {
    typed: e,
    matrix: t,
    isInteger: n
  } = r;
  return e(Fy, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(i) {
      var u, f = i.length, c = -1, o, s = !1, l = [];
      for (u = 0; u < f; u++) {
        var v = i[u];
        if (Oe(v) && (s = !0), Xe(v) || Ue(v)) {
          if (u !== f - 1)
            throw new Error("Dimension must be specified as last argument");
          if (o = c, c = v.valueOf(), !n(c))
            throw new TypeError("Integer number expected for dimension");
          if (c < 0 || u > 0 && c > o)
            throw new Ut(c, o + 1);
        } else {
          var p = Ie(v).valueOf(), h = Ve(p);
          if (l[u] = p, o = c, c = h.length - 1, u > 0 && c !== o)
            throw new Ye(o + 1, c + 1);
        }
      }
      if (l.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var d = l.shift(); l.length; )
        d = iD(d, l.shift(), c);
      return s ? t(d) : d;
    },
    "...string": function(i) {
      return i.join("");
    }
  });
}), Ty = "column", KP = ["typed", "Index", "matrix", "range"], go = /* @__PURE__ */ U(Ty, KP, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r;
  return e(Ty, {
    "Matrix, number": i,
    "Array, number": function(f, c) {
      return i(n(Ie(f)), c).valueOf();
    }
  });
  function i(u, f) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    yr(f, u.size()[1]);
    var c = a(0, u.size()[0]), o = new t(c, f), s = u.subset(o);
    return Oe(s) ? s : n([[s]]);
  }
}), Oy = "count", JP = ["typed", "size", "prod"], Pc = /* @__PURE__ */ U(Oy, JP, (r) => {
  var {
    typed: e,
    size: t,
    prod: n
  } = r;
  return e(Oy, {
    string: function(i) {
      return i.length;
    },
    "Matrix | Array": function(i) {
      return n(t(i));
    }
  });
}), zy = "cross", _P = ["typed", "matrix", "subtract", "multiply"], Mc = /* @__PURE__ */ U(zy, _P, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    multiply: a
  } = r;
  return e(zy, {
    "Matrix, Matrix": function(f, c) {
      return t(i(f.toArray(), c.toArray()));
    },
    "Matrix, Array": function(f, c) {
      return t(i(f.toArray(), c));
    },
    "Array, Matrix": function(f, c) {
      return t(i(f, c.toArray()));
    },
    "Array, Array": i
  });
  function i(u, f) {
    var c = Math.max(Ve(u).length, Ve(f).length);
    u = Rs(u), f = Rs(f);
    var o = Ve(u), s = Ve(f);
    if (o.length !== 1 || s.length !== 1 || o[0] !== 3 || s[0] !== 3)
      throw new RangeError("Vectors with length 3 expected (Size A = [" + o.join(", ") + "], B = [" + s.join(", ") + "])");
    var l = [n(a(u[1], f[2]), a(u[2], f[1])), n(a(u[2], f[0]), a(u[0], f[2])), n(a(u[0], f[1]), a(u[1], f[0]))];
    return c > 1 ? [l] : l;
  }
}), Ry = "diag", $P = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], Fc = /* @__PURE__ */ U(Ry, $P, (r) => {
  var {
    typed: e,
    matrix: t,
    DenseMatrix: n,
    SparseMatrix: a
  } = r;
  return e(Ry, {
    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
    Array: function(o) {
      return i(o, 0, Ve(o), null);
    },
    "Array, number": function(o, s) {
      return i(o, s, Ve(o), null);
    },
    "Array, BigNumber": function(o, s) {
      return i(o, s.toNumber(), Ve(o), null);
    },
    "Array, string": function(o, s) {
      return i(o, 0, Ve(o), s);
    },
    "Array, number, string": function(o, s, l) {
      return i(o, s, Ve(o), l);
    },
    "Array, BigNumber, string": function(o, s, l) {
      return i(o, s.toNumber(), Ve(o), l);
    },
    Matrix: function(o) {
      return i(o, 0, o.size(), o.storage());
    },
    "Matrix, number": function(o, s) {
      return i(o, s, o.size(), o.storage());
    },
    "Matrix, BigNumber": function(o, s) {
      return i(o, s.toNumber(), o.size(), o.storage());
    },
    "Matrix, string": function(o, s) {
      return i(o, 0, o.size(), s);
    },
    "Matrix, number, string": function(o, s, l) {
      return i(o, s, o.size(), l);
    },
    "Matrix, BigNumber, string": function(o, s, l) {
      return i(o, s.toNumber(), o.size(), l);
    }
  });
  function i(c, o, s, l) {
    if (!Me(o))
      throw new TypeError("Second parameter in function diag must be an integer");
    var v = o > 0 ? o : 0, p = o < 0 ? -o : 0;
    switch (s.length) {
      case 1:
        return u(c, o, l, s[0], p, v);
      case 2:
        return f(c, o, l, s, p, v);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
  function u(c, o, s, l, v, p) {
    var h = [l + v, l + p];
    if (s && s !== "sparse" && s !== "dense")
      throw new TypeError("Unknown matrix type ".concat(s, '"'));
    var d = s === "sparse" ? a.diagonal(h, c, o) : n.diagonal(h, c, o);
    return s !== null ? d : d.valueOf();
  }
  function f(c, o, s, l, v, p) {
    if (Oe(c)) {
      var h = c.diagonal(o);
      return s !== null ? s !== h.storage() ? t(h, s) : h : h.valueOf();
    }
    for (var d = Math.min(l[0] - v, l[1] - p), x = [], g = 0; g < d; g++)
      x[g] = c[g + v][g + p];
    return s !== null ? t(x) : x;
  }
});
function Ci(r, e, t, n, a) {
  if (ba.isTypedFunction(r)) {
    var i = [e, t, n], u = ba.resolve(r, i);
    if (u)
      return l(u.implementation, i);
    var f = [e, t], c = ba.resolve(r, f);
    if (c)
      return l(c.implementation, f);
    var o = [e], s = ba.resolve(r, o);
    return s ? l(s.implementation, o) : l(r, i);
  } else
    return r(e, t, n);
  function l(v, p) {
    try {
      return v.apply(v, p);
    } catch (x) {
      var h;
      if (x instanceof TypeError && ((h = x.data) === null || h === void 0 ? void 0 : h.category) === "wrongType") {
        var d = [];
        throw d.push("value: ".concat(br(e))), p.length >= 2 && d.push("index: ".concat(br(t))), p.length >= 3 && d.push("array: ".concat(br(n))), new TypeError("Function ".concat(a, " cannot apply callback arguments ") + "".concat(r.name, "(").concat(d.join(", "), ") at index ").concat(JSON.stringify(t)));
      } else
        throw new TypeError("Function ".concat(a, " cannot apply callback arguments ") + "to function ".concat(r.name, ": ").concat(x.message));
    }
  }
}
var eM = "filter", rM = ["typed"], Tc = /* @__PURE__ */ U(eM, rM, (r) => {
  var {
    typed: e
  } = r;
  return e("filter", {
    "Array, function": Iy,
    "Matrix, function": function(n, a) {
      return n.create(Iy(n.toArray(), a));
    },
    "Array, RegExp": Is,
    "Matrix, RegExp": function(n, a) {
      return n.create(Is(n.toArray(), a));
    }
  });
});
function Iy(r, e) {
  return nD(r, function(t, n, a) {
    return Ci(e, t, [n], a, "filter");
  });
}
var Hy = "flatten", tM = ["typed", "matrix"], Oc = /* @__PURE__ */ U(Hy, tM, (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return e(Hy, {
    Array: function(a) {
      return cr(a);
    },
    Matrix: function(a) {
      var i = cr(a.toArray());
      return t(i);
    }
  });
}), Ly = "forEach", nM = ["typed"], zc = /* @__PURE__ */ U(Ly, nM, (r) => {
  var {
    typed: e
  } = r;
  return e(Ly, {
    "Array, function": aM,
    "Matrix, function": function(n, a) {
      n.forEach(a);
    }
  });
});
function aM(r, e) {
  var t = function n(a, i) {
    if (Array.isArray(a))
      wu(a, function(u, f) {
        n(u, i.concat(f));
      });
    else
      return Ci(e, a, i, r, "forEach");
  };
  t(r, []);
}
var qy = "getMatrixDataType", iM = ["typed"], Rc = /* @__PURE__ */ U(qy, iM, (r) => {
  var {
    typed: e
  } = r;
  return e(qy, {
    Array: function(n) {
      return ro(n, br);
    },
    Matrix: function(n) {
      return n.getDataType();
    }
  });
}), Uy = "identity", oM = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], Ic = /* @__PURE__ */ U(Uy, oM, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a,
    DenseMatrix: i,
    SparseMatrix: u
  } = r;
  return e(Uy, {
    "": function() {
      return t.matrix === "Matrix" ? n([]) : [];
    },
    string: function(s) {
      return n(s);
    },
    "number | BigNumber": function(s) {
      return c(s, s, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(s, l) {
      return c(s, s, l);
    },
    "number | BigNumber, number | BigNumber": function(s, l) {
      return c(s, l, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(s, l, v) {
      return c(s, l, v);
    },
    Array: function(s) {
      return f(s);
    },
    "Array, string": function(s, l) {
      return f(s, l);
    },
    Matrix: function(s) {
      return f(s.valueOf(), s.storage());
    },
    "Matrix, string": function(s, l) {
      return f(s.valueOf(), l);
    }
  });
  function f(o, s) {
    switch (o.length) {
      case 0:
        return s ? n(s) : [];
      case 1:
        return c(o[0], o[0], s);
      case 2:
        return c(o[0], o[1], s);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function c(o, s, l) {
    var v = Ue(o) || Ue(s) ? a : null;
    if (Ue(o) && (o = o.toNumber()), Ue(s) && (s = s.toNumber()), !Me(o) || o < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!Me(s) || s < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var p = v ? new a(1) : 1, h = v ? new v(0) : 0, d = [o, s];
    if (l) {
      if (l === "sparse")
        return u.diagonal(d, p, 0, h);
      if (l === "dense")
        return i.diagonal(d, p, 0, h);
      throw new TypeError('Unknown matrix type "'.concat(l, '"'));
    }
    for (var x = li([], d, h), g = o < s ? o : s, y = 0; y < g; y++)
      x[y][y] = p;
    return x;
  }
}), ky = "kron", sM = ["typed", "matrix", "multiplyScalar"], Hc = /* @__PURE__ */ U(ky, sM, (r) => {
  var {
    typed: e,
    matrix: t,
    multiplyScalar: n
  } = r;
  return e(ky, {
    "Matrix, Matrix": function(u, f) {
      return t(a(u.toArray(), f.toArray()));
    },
    "Matrix, Array": function(u, f) {
      return t(a(u.toArray(), f));
    },
    "Array, Matrix": function(u, f) {
      return t(a(u, f.toArray()));
    },
    "Array, Array": a
  });
  function a(i, u) {
    if (Ve(i).length === 1 && (i = [i]), Ve(u).length === 1 && (u = [u]), Ve(i).length > 2 || Ve(u).length > 2)
      throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(i.length) + ", y = " + JSON.stringify(u.length) + ")");
    var f = [], c = [];
    return i.map(function(o) {
      return u.map(function(s) {
        return c = [], f.push(c), o.map(function(l) {
          return s.map(function(v) {
            return c.push(n(l, v));
          });
        });
      });
    }) && f;
  }
}), Xy = "map", uM = ["typed"], Lc = /* @__PURE__ */ U(Xy, uM, (r) => {
  var {
    typed: e
  } = r;
  return e(Xy, {
    "Array, function": cM,
    "Matrix, function": function(n, a) {
      return n.map(a);
    }
  });
});
function cM(r, e) {
  var t = function n(a, i) {
    return Array.isArray(a) ? a.map(function(u, f) {
      return n(u, i.concat(f));
    }) : Ci(e, a, i, r, "map");
  };
  return t(r, []);
}
var jy = "diff", lM = ["typed", "matrix", "subtract", "number"], xo = /* @__PURE__ */ U(jy, lM, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    number: a
  } = r;
  return e(jy, {
    "Array | Matrix": function(s) {
      return Oe(s) ? t(u(s.toArray())) : u(s);
    },
    "Array | Matrix, number": function(s, l) {
      if (!Me(l))
        throw new RangeError("Dimension must be a whole number");
      return Oe(s) ? t(i(s.toArray(), l)) : i(s, l);
    },
    "Array, BigNumber": e.referTo("Array,number", (o) => (s, l) => o(s, a(l))),
    "Matrix, BigNumber": e.referTo("Matrix,number", (o) => (s, l) => o(s, a(l)))
  });
  function i(o, s) {
    if (Oe(o) && (o = o.toArray()), !Array.isArray(o))
      throw RangeError("Array/Matrix does not have that many dimensions");
    if (s > 0) {
      var l = [];
      return o.forEach((v) => {
        l.push(i(v, s - 1));
      }), l;
    } else {
      if (s === 0)
        return u(o);
      throw RangeError("Cannot have negative dimension");
    }
  }
  function u(o) {
    for (var s = [], l = o.length, v = 1; v < l; v++)
      s.push(f(o[v - 1], o[v]));
    return s;
  }
  function f(o, s) {
    Oe(o) && (o = o.toArray()), Oe(s) && (s = s.toArray());
    var l = Array.isArray(o), v = Array.isArray(s);
    if (l && v)
      return c(o, s);
    if (!l && !v)
      return n(s, o);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
  function c(o, s) {
    if (o.length !== s.length)
      throw RangeError("Not all sub-arrays have the same length");
    for (var l = [], v = o.length, p = 0; p < v; p++)
      l.push(f(o[p], s[p]));
    return l;
  }
}), fM = "ones", vM = ["typed", "config", "matrix", "BigNumber"], qc = /* @__PURE__ */ U(fM, vM, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e("ones", {
    "": function() {
      return t.matrix === "Array" ? i([]) : i([], "default");
    },
    // math.ones(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(o) {
      var s = o[o.length - 1];
      if (typeof s == "string") {
        var l = o.pop();
        return i(o, l);
      } else
        return t.matrix === "Array" ? i(o) : i(o, "default");
    },
    Array: i,
    Matrix: function(o) {
      var s = o.storage();
      return i(o.valueOf(), s);
    },
    "Array | Matrix, string": function(o, s) {
      return i(o.valueOf(), s);
    }
  });
  function i(c, o) {
    var s = u(c), l = s ? new a(1) : 1;
    if (f(c), o) {
      var v = n(o);
      return c.length > 0 ? v.resize(c, l) : v;
    } else {
      var p = [];
      return c.length > 0 ? li(p, c, l) : p;
    }
  }
  function u(c) {
    var o = !1;
    return c.forEach(function(s, l, v) {
      Ue(s) && (o = !0, v[l] = s.toNumber());
    }), o;
  }
  function f(c) {
    c.forEach(function(o) {
      if (typeof o != "number" || !Me(o) || o < 0)
        throw new Error("Parameters in function ones must be positive integers");
    });
  }
});
function Dh() {
  throw new Error('No "bignumber" implementation available');
}
function a4() {
  throw new Error('No "fraction" implementation available');
}
function i4() {
  throw new Error('No "matrix" implementation available');
}
var Gy = "range", pM = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], yo = /* @__PURE__ */ U(Gy, pM, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    smaller: i,
    smallerEq: u,
    larger: f,
    largerEq: c,
    add: o,
    isPositive: s
  } = r;
  return e(Gy, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    // TODO: a number or boolean should not be converted to string here
    string: v,
    "string, boolean": v,
    "number, number": function(x, g) {
      return l(p(x, g, 1, !1));
    },
    "number, number, number": function(x, g, y) {
      return l(p(x, g, y, !1));
    },
    "number, number, boolean": function(x, g, y) {
      return l(p(x, g, 1, y));
    },
    "number, number, number, boolean": function(x, g, y, m) {
      return l(p(x, g, y, m));
    },
    "BigNumber, BigNumber": function(x, g) {
      var y = x.constructor;
      return l(p(x, g, new y(1), !1));
    },
    "BigNumber, BigNumber, BigNumber": function(x, g, y) {
      return l(p(x, g, y, !1));
    },
    "BigNumber, BigNumber, boolean": function(x, g, y) {
      var m = x.constructor;
      return l(p(x, g, new m(1), y));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(x, g, y, m) {
      return l(p(x, g, y, m));
    },
    "Unit, Unit, Unit": function(x, g, y) {
      return l(p(x, g, y, !1));
    },
    "Unit, Unit, Unit, boolean": function(x, g, y, m) {
      return l(p(x, g, y, m));
    }
  });
  function l(d) {
    return t.matrix === "Matrix" ? n ? n(d) : i4() : d;
  }
  function v(d, x) {
    var g = h(d);
    if (!g)
      throw new SyntaxError('String "' + d + '" is no valid range');
    return t.number === "BigNumber" ? (a === void 0 && Dh(), l(p(a(g.start), a(g.end), a(g.step)))) : l(p(g.start, g.end, g.step, x));
  }
  function p(d, x, g, y) {
    for (var m = [], b = s(g) ? y ? u : i : y ? c : f, w = d; b(w, x); )
      m.push(w), w = o(w, g);
    return m;
  }
  function h(d) {
    var x = d.split(":"), g = x.map(function(m) {
      return Number(m);
    }), y = g.some(function(m) {
      return isNaN(m);
    });
    if (y)
      return null;
    switch (g.length) {
      case 2:
        return {
          start: g[0],
          end: g[1],
          step: 1
        };
      case 3:
        return {
          start: g[0],
          end: g[2],
          step: g[1]
        };
      default:
        return null;
    }
  }
}), Vy = "reshape", dM = ["typed", "isInteger", "matrix"], Uc = /* @__PURE__ */ U(Vy, dM, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r;
  return e(Vy, {
    "Matrix, Array": function(a, i) {
      return a.reshape(i, !0);
    },
    "Array, Array": function(a, i) {
      return i.forEach(function(u) {
        if (!t(u))
          throw new TypeError("Invalid size for dimension: " + u);
      }), xh(a, i);
    }
  });
}), mM = "resize", hM = ["config", "matrix"], kc = /* @__PURE__ */ U(mM, hM, (r) => {
  var {
    config: e,
    matrix: t
  } = r;
  return function(i, u, f) {
    if (arguments.length !== 2 && arguments.length !== 3)
      throw new wn("resize", arguments.length, 2, 3);
    if (Oe(u) && (u = u.valueOf()), Ue(u[0]) && (u = u.map(function(s) {
      return Ue(s) ? s.toNumber() : s;
    })), Oe(i))
      return i.resize(u, f, !0);
    if (typeof i == "string")
      return n(i, u, f);
    var c = Array.isArray(i) ? !1 : e.matrix !== "Array";
    if (u.length === 0) {
      for (; Array.isArray(i); )
        i = i[0];
      return Ie(i);
    } else {
      Array.isArray(i) || (i = [i]), i = Ie(i);
      var o = li(i, u, f);
      return c ? t(o) : o;
    }
  };
  function n(a, i, u) {
    if (u !== void 0) {
      if (typeof u != "string" || u.length !== 1)
        throw new TypeError("Single character expected as defaultValue");
    } else
      u = " ";
    if (i.length !== 1)
      throw new Ye(i.length, 1);
    var f = i[0];
    if (typeof f != "number" || !Me(f))
      throw new TypeError("Invalid size, must contain positive integers (size: " + Ke(i) + ")");
    if (a.length > f)
      return a.substring(0, f);
    if (a.length < f) {
      for (var c = a, o = 0, s = f - a.length; o < s; o++)
        c += u;
      return c;
    } else
      return a;
  }
}), Qy = "rotate", gM = ["typed", "multiply", "rotationMatrix"], Xc = /* @__PURE__ */ U(Qy, gM, (r) => {
  var {
    typed: e,
    multiply: t,
    rotationMatrix: n
  } = r;
  return e(Qy, {
    "Array , number | BigNumber | Complex | Unit": function(u, f) {
      a(u, 2);
      var c = t(n(f), u);
      return c.toArray();
    },
    "Matrix , number | BigNumber | Complex | Unit": function(u, f) {
      return a(u, 2), t(n(f), u);
    },
    "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(u, f, c) {
      a(u, 3);
      var o = t(n(f, c), u);
      return o;
    },
    "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(u, f, c) {
      return a(u, 3), t(n(f, c), u);
    }
  });
  function a(i, u) {
    var f = Array.isArray(i) ? Ve(i) : i.size();
    if (f.length > 2)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
    if (f.length === 2 && f[1] !== 1)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
    if (f[0] !== u)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
  }
}), Yy = "rotationMatrix", xM = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], jc = /* @__PURE__ */ U(Yy, xM, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    addScalar: a,
    unaryMinus: i,
    norm: u,
    BigNumber: f,
    matrix: c,
    DenseMatrix: o,
    SparseMatrix: s,
    cos: l,
    sin: v
  } = r;
  return e(Yy, {
    "": function() {
      return t.matrix === "Matrix" ? c([]) : [];
    },
    string: function(m) {
      return c(m);
    },
    "number | BigNumber | Complex | Unit": function(m) {
      return p(m, t.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber | Complex | Unit, string": function(m, b) {
      return p(m, b);
    },
    "number | BigNumber | Complex | Unit, Array": function(m, b) {
      var w = c(b);
      return h(w), g(m, w, void 0);
    },
    "number | BigNumber | Complex | Unit, Matrix": function(m, b) {
      h(b);
      var w = b.storage() || (t.matrix === "Matrix" ? "dense" : void 0);
      return g(m, b, w);
    },
    "number | BigNumber | Complex | Unit, Array, string": function(m, b, w) {
      var A = c(b);
      return h(A), g(m, A, w);
    },
    "number | BigNumber | Complex | Unit, Matrix, string": function(m, b, w) {
      return h(b), g(m, b, w);
    }
  });
  function p(y, m) {
    var b = Ue(y), w = b ? new f(-1) : -1, A = l(y), E = v(y), N = [[A, n(w, E)], [E, A]];
    return x(N, m);
  }
  function h(y) {
    var m = y.size();
    if (m.length < 1 || m[0] !== 3)
      throw new RangeError("Vector must be of dimensions 1x3");
  }
  function d(y) {
    return y.reduce((m, b) => n(m, b));
  }
  function x(y, m) {
    if (m) {
      if (m === "sparse")
        return new s(y);
      if (m === "dense")
        return new o(y);
      throw new TypeError('Unknown matrix type "'.concat(m, '"'));
    }
    return y;
  }
  function g(y, m, b) {
    var w = u(m);
    if (w === 0)
      throw new RangeError("Rotation around zero vector");
    var A = Ue(y) ? f : null, E = A ? new A(1) : 1, N = A ? new A(-1) : -1, C = A ? new A(m.get([0]) / w) : m.get([0]) / w, D = A ? new A(m.get([1]) / w) : m.get([1]) / w, B = A ? new A(m.get([2]) / w) : m.get([2]) / w, S = l(y), F = a(E, i(S)), I = v(y), z = a(S, d([C, C, F])), P = a(d([C, D, F]), d([N, B, I])), M = a(d([C, B, F]), d([D, I])), H = a(d([C, D, F]), d([B, I])), O = a(S, d([D, D, F])), Q = a(d([D, B, F]), d([N, C, I])), k = a(d([C, B, F]), d([N, D, I])), L = a(d([D, B, F]), d([C, I])), R = a(S, d([B, B, F])), X = [[z, P, M], [H, O, Q], [k, L, R]];
    return x(X, b);
  }
}), Zy = "row", yM = ["typed", "Index", "matrix", "range"], Ao = /* @__PURE__ */ U(Zy, yM, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r;
  return e(Zy, {
    "Matrix, number": i,
    "Array, number": function(f, c) {
      return i(n(Ie(f)), c).valueOf();
    }
  });
  function i(u, f) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    yr(f, u.size()[0]);
    var c = a(0, u.size()[1]), o = new t(f, c), s = u.subset(o);
    return Oe(s) ? s : n([[s]]);
  }
}), Wy = "size", AM = ["typed", "config", "?matrix"], Gc = /* @__PURE__ */ U(Wy, AM, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n
  } = r;
  return e(Wy, {
    Matrix: function(i) {
      return i.create(i.size());
    },
    Array: Ve,
    string: function(i) {
      return t.matrix === "Array" ? [i.length] : n([i.length]);
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(i) {
      return t.matrix === "Array" ? [] : n ? n([]) : i4();
    }
  });
}), Ky = "squeeze", bM = ["typed", "matrix"], Vc = /* @__PURE__ */ U(Ky, bM, (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return e(Ky, {
    Array: function(a) {
      return Rs(Ie(a));
    },
    Matrix: function(a) {
      var i = Rs(a.toArray());
      return Array.isArray(i) ? t(i) : i;
    },
    any: function(a) {
      return Ie(a);
    }
  });
}), Jy = "subset", wM = ["typed", "matrix", "zeros", "add"], bo = /* @__PURE__ */ U(Jy, wM, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r;
  return e(Jy, {
    // get subset
    "Matrix, Index": function(f, c) {
      return ci(c) ? t() : (zs(f, c), f.subset(c));
    },
    "Array, Index": e.referTo("Matrix, Index", function(u) {
      return function(f, c) {
        var o = u(t(f), c);
        return c.isScalar() ? o : o.valueOf();
      };
    }),
    "Object, Index": CM,
    "string, Index": DM,
    // set subset
    "Matrix, Index, any, any": function(f, c, o, s) {
      return ci(c) ? f : (zs(f, c), f.clone().subset(c, i(o, c), s));
    },
    "Array, Index, any, any": e.referTo("Matrix, Index, any, any", function(u) {
      return function(f, c, o, s) {
        var l = u(t(f), c, o, s);
        return l.isMatrix ? l.valueOf() : l;
      };
    }),
    "Array, Index, any": e.referTo("Matrix, Index, any, any", function(u) {
      return function(f, c, o) {
        return u(t(f), c, o, void 0).valueOf();
      };
    }),
    "Matrix, Index, any": e.referTo("Matrix, Index, any, any", function(u) {
      return function(f, c, o) {
        return u(f, c, o, void 0);
      };
    }),
    "string, Index, string": _y,
    "string, Index, string, string": _y,
    "Object, Index, any": EM
  });
  function i(u, f) {
    if (typeof u == "string")
      throw new Error("can't boradcast a string");
    if (f._isScalar)
      return u;
    var c = f.size();
    if (c.every((o) => o > 0))
      try {
        return a(u, n(c));
      } catch {
        return u;
      }
    else
      return u;
  }
});
function DM(r, e) {
  if (!hi(e))
    throw new TypeError("Index expected");
  if (ci(e))
    return "";
  if (zs(Array.from(r), e), e.size().length !== 1)
    throw new Ye(e.size().length, 1);
  var t = r.length;
  yr(e.min()[0], t), yr(e.max()[0], t);
  var n = e.dimension(0), a = "";
  return n.forEach(function(i) {
    a += r.charAt(i);
  }), a;
}
function _y(r, e, t, n) {
  if (!e || e.isIndex !== !0)
    throw new TypeError("Index expected");
  if (ci(e))
    return r;
  if (zs(Array.from(r), e), e.size().length !== 1)
    throw new Ye(e.size().length, 1);
  if (n !== void 0) {
    if (typeof n != "string" || n.length !== 1)
      throw new TypeError("Single character expected as defaultValue");
  } else
    n = " ";
  var a = e.dimension(0), i = a.size()[0];
  if (i !== t.length)
    throw new Ye(a.size()[0], t.length);
  var u = r.length;
  yr(e.min()[0]), yr(e.max()[0]);
  for (var f = [], c = 0; c < u; c++)
    f[c] = r.charAt(c);
  if (a.forEach(function(l, v) {
    f[l] = t.charAt(v[0]);
  }), f.length > u)
    for (var o = u - 1, s = f.length; o < s; o++)
      f[o] || (f[o] = n);
  return f.join("");
}
function CM(r, e) {
  if (!ci(e)) {
    if (e.size().length !== 1)
      throw new Ye(e.size(), 1);
    var t = e.dimension(0);
    if (typeof t != "string")
      throw new TypeError("String expected as index to retrieve an object property");
    return At(r, t);
  }
}
function EM(r, e, t) {
  if (ci(e))
    return r;
  if (e.size().length !== 1)
    throw new Ye(e.size(), 1);
  var n = e.dimension(0);
  if (typeof n != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  var a = Ie(r);
  return si(a, n, t), a;
}
var $y = "transpose", NM = ["typed", "matrix"], Qc = /* @__PURE__ */ U($y, NM, (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return e($y, {
    Array: (u) => n(t(u)).valueOf(),
    Matrix: n,
    any: Ie
    // scalars
  });
  function n(u) {
    var f = u.size(), c;
    switch (f.length) {
      case 1:
        c = u.clone();
        break;
      case 2:
        {
          var o = f[0], s = f[1];
          if (s === 0)
            throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + Ke(f) + ")");
          switch (u.storage()) {
            case "dense":
              c = a(u, o, s);
              break;
            case "sparse":
              c = i(u, o, s);
              break;
          }
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + Ke(f) + ")");
    }
    return c;
  }
  function a(u, f, c) {
    for (var o = u._data, s = [], l, v = 0; v < c; v++) {
      l = s[v] = [];
      for (var p = 0; p < f; p++)
        l[p] = Ie(o[p][v]);
    }
    return u.createDenseMatrix({
      data: s,
      size: [c, f],
      datatype: u._datatype
    });
  }
  function i(u, f, c) {
    for (var o = u._values, s = u._index, l = u._ptr, v = o ? [] : void 0, p = [], h = [], d = [], x = 0; x < f; x++)
      d[x] = 0;
    var g, y, m;
    for (g = 0, y = s.length; g < y; g++)
      d[s[g]]++;
    for (var b = 0, w = 0; w < f; w++)
      h.push(b), b += d[w], d[w] = h[w];
    for (h.push(b), m = 0; m < c; m++)
      for (var A = l[m], E = l[m + 1], N = A; N < E; N++) {
        var C = d[s[N]]++;
        p[C] = m, o && (v[C] = Ie(o[N]));
      }
    return u.createSparseMatrix({
      values: v,
      index: p,
      ptr: h,
      size: [c, f],
      datatype: u._datatype
    });
  }
}), eA = "ctranspose", BM = ["typed", "transpose", "conj"], Yc = /* @__PURE__ */ U(eA, BM, (r) => {
  var {
    typed: e,
    transpose: t,
    conj: n
  } = r;
  return e(eA, {
    any: function(i) {
      return n(t(i));
    }
  });
}), rA = "zeros", SM = ["typed", "config", "matrix", "BigNumber"], Zc = /* @__PURE__ */ U(rA, SM, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    BigNumber: a
  } = r;
  return e(rA, {
    "": function() {
      return t.matrix === "Array" ? i([]) : i([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(o) {
      var s = o[o.length - 1];
      if (typeof s == "string") {
        var l = o.pop();
        return i(o, l);
      } else
        return t.matrix === "Array" ? i(o) : i(o, "default");
    },
    Array: i,
    Matrix: function(o) {
      var s = o.storage();
      return i(o.valueOf(), s);
    },
    "Array | Matrix, string": function(o, s) {
      return i(o.valueOf(), s);
    }
  });
  function i(c, o) {
    var s = u(c), l = s ? new a(0) : 0;
    if (f(c), o) {
      var v = n(o);
      return c.length > 0 ? v.resize(c, l) : v;
    } else {
      var p = [];
      return c.length > 0 ? li(p, c, l) : p;
    }
  }
  function u(c) {
    var o = !1;
    return c.forEach(function(s, l, v) {
      Ue(s) && (o = !0, v[l] = s.toNumber());
    }), o;
  }
  function f(c) {
    c.forEach(function(o) {
      if (typeof o != "number" || !Me(o) || o < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
}), tA = "fft", PM = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], Wc = /* @__PURE__ */ U(tA, PM, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    exp: u,
    tau: f,
    i: c,
    dotDivide: o,
    conj: s,
    pow: l,
    ceil: v,
    log2: p
  } = r;
  return e(tA, {
    Array: h,
    Matrix: function(m) {
      return m.create(h(m.toArray()));
    }
  });
  function h(y) {
    var m = Ve(y);
    return m.length === 1 ? g(y, m[0]) : d(y.map((b) => h(b, m.slice(1))), 0);
  }
  function d(y, m) {
    var b = Ve(y);
    if (m !== 0)
      return new Array(b[0]).fill(0).map((A, E) => d(y[E], m - 1));
    if (b.length === 1)
      return g(y);
    function w(A) {
      var E = Ve(A);
      return new Array(E[1]).fill(0).map((N, C) => new Array(E[0]).fill(0).map((D, B) => A[B][C]));
    }
    return w(d(w(y), 1));
  }
  function x(y) {
    for (var m = y.length, b = u(i(a(-1, a(c, f)), m)), w = [], A = 1 - m; A < m; A++)
      w.push(l(b, i(l(A, 2), 2)));
    for (var E = l(2, v(p(m + m - 1))), N = [...new Array(m).fill(0).map((P, M) => a(y[M], w[m - 1 + M])), ...new Array(E - m).fill(0)], C = [...new Array(m + m - 1).fill(0).map((P, M) => i(1, w[M])), ...new Array(E - (m + m - 1)).fill(0)], D = g(N), B = g(C), S = new Array(E).fill(0).map((P, M) => a(D[M], B[M])), F = o(s(h(s(S))), E), I = [], z = m - 1; z < m + m - 1; z++)
      I.push(a(F[z], w[z]));
    return I;
  }
  function g(y) {
    var m = y.length;
    if (m === 1)
      return [y[0]];
    if (m % 2 === 0) {
      for (var b = [...g(y.filter((N, C) => C % 2 === 0)), ...g(y.filter((N, C) => C % 2 === 1))], w = 0; w < m / 2; w++) {
        var A = b[w], E = a(b[w + m / 2], u(a(a(f, c), i(-w, m))));
        b[w] = n(A, E), b[w + m / 2] = n(A, a(-1, E));
      }
      return b;
    } else
      return x(y);
  }
}), nA = "ifft", MM = ["typed", "fft", "dotDivide", "conj"], Kc = /* @__PURE__ */ U(nA, MM, (r) => {
  var {
    typed: e,
    fft: t,
    dotDivide: n,
    conj: a
  } = r;
  return e(nA, {
    "Array | Matrix": function(u) {
      var f = Oe(u) ? u.size() : Ve(u);
      return n(a(t(a(u))), f.reduce((c, o) => c * o, 1));
    }
  });
});
function no(r) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, no(r);
}
function FM(r, e) {
  if (no(r) != "object" || !r)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e || "default");
    if (no(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function TM(r) {
  var e = FM(r, "string");
  return no(e) == "symbol" ? e : e + "";
}
function Gr(r, e, t) {
  return (e = TM(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function aA(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function OM(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? aA(Object(t), !0).forEach(function(n) {
      Gr(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : aA(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var zM = "solveODE", RM = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], Jc = /* @__PURE__ */ U(zM, RM, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    max: u,
    map: f,
    abs: c,
    isPositive: o,
    isNegative: s,
    larger: l,
    smaller: v,
    matrix: p,
    bignumber: h,
    unaryMinus: d
  } = r;
  function x(N) {
    return function(C, D, B, S) {
      var F = !(D.length === 2 && (D.every(A) || D.every(yt)));
      if (F)
        throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var I = D[0], z = D[1], P = l(z, I), M = S.firstStep;
      if (M !== void 0 && !o(M))
        throw new Error('"firstStep" must be positive');
      var H = S.maxStep;
      if (H !== void 0 && !o(H))
        throw new Error('"maxStep" must be positive');
      var O = S.minStep;
      if (O && s(O))
        throw new Error('"minStep" must be positive or zero');
      var Q = [I, z, M, O, H].filter((q) => q !== void 0);
      if (!(Q.every(A) || Q.every(yt)))
        throw new Error('Inconsistent type of "t" dependant variables');
      for (var k = 1, L = S.tol ? S.tol : 1e-4, R = S.minDelta ? S.minDelta : 0.2, X = S.maxDelta ? S.maxDelta : 5, ae = S.maxIter ? S.maxIter : 1e4, _ = [I, z, ...B, H, O].some(Ue), [re, te, ne, oe] = _ ? [h(N.a), h(N.c), h(N.b), h(N.bp)] : [N.a, N.c, N.b, N.bp], le = M ? P ? M : d(M) : i(n(z, I), k), fe = [I], ge = [B], Be = n(ne, oe), j = 0, Y = 0, ie = b(P), V = w(P); ie(fe[j], z); ) {
        var J = [];
        le = V(fe[j], z, le), J.push(C(fe[j], ge[j]));
        for (var $ = 1; $ < te.length; ++$)
          J.push(C(t(fe[j], a(te[$], le)), t(ge[j], a(le, re[$], J))));
        var pe = u(c(f(a(Be, J), (q) => yt(q) ? q.value : q)));
        pe < L && L / pe > 1 / 4 && (fe.push(t(fe[j], le)), ge.push(t(ge[j], a(le, ne, J))), j++);
        var ve = 0.84 * (L / pe) ** (1 / 5);
        if (v(ve, R) ? ve = R : l(ve, X) && (ve = X), ve = _ ? h(ve) : ve, le = a(le, ve), H && l(c(le), H) ? le = P ? H : d(H) : O && v(c(le), O) && (le = P ? O : d(O)), Y++, Y > ae)
          throw new Error("Maximum number of iterations reached, try changing options");
      }
      return {
        t: fe,
        y: ge
      };
    };
  }
  function g(N, C, D, B) {
    var S = [[], [0.5], [0, 0.75], [0.2222222222222222, 0.3333333333333333, 0.4444444444444444]], F = [null, 1 / 2, 3 / 4, 1], I = [2 / 9, 1 / 3, 4 / 9, 0], z = [7 / 24, 1 / 4, 1 / 3, 1 / 8], P = {
      a: S,
      c: F,
      b: I,
      bp: z
    };
    return x(P)(N, C, D, B);
  }
  function y(N, C, D, B) {
    var S = [[], [0.2], [0.075, 0.225], [0.9777777777777777, -3.7333333333333334, 3.5555555555555554], [2.9525986892242035, -11.595793324188385, 9.822892851699436, -0.2908093278463649], [2.8462752525252526, -10.757575757575758, 8.906422717743473, 0.2784090909090909, -0.2735313036020583], [0.09114583333333333, 0, 0.44923629829290207, 0.6510416666666666, -0.322376179245283, 0.13095238095238096]], F = [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], I = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], z = [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40], P = {
      a: S,
      c: F,
      b: I,
      bp: z
    };
    return x(P)(N, C, D, B);
  }
  function m(N, C, D, B) {
    var S = B.method ? B.method : "RK45", F = {
      RK23: g,
      RK45: y
    };
    if (S.toUpperCase() in F) {
      var I = OM({}, B);
      return delete I.method, F[S.toUpperCase()](N, C, D, I);
    } else {
      var z = Object.keys(F).map((M) => '"'.concat(M, '"')), P = "".concat(z.slice(0, -1).join(", "), " and ").concat(z.slice(-1));
      throw new Error('Unavailable method "'.concat(S, '". Available methods are ').concat(P));
    }
  }
  function b(N) {
    return N ? v : l;
  }
  function w(N) {
    var C = N ? l : v;
    return function(D, B, S) {
      var F = t(D, S);
      return C(F, B) ? n(B, D) : S;
    };
  }
  function A(N) {
    return Ue(N) || Xe(N);
  }
  function E(N, C, D, B) {
    var S = m(N, C.toArray(), D.toArray(), B);
    return {
      t: p(S.t),
      y: p(S.y)
    };
  }
  return e("solveODE", {
    "function, Array, Array, Object": m,
    "function, Matrix, Matrix, Object": E,
    "function, Array, Array": (N, C, D) => m(N, C, D, {}),
    "function, Matrix, Matrix": (N, C, D) => E(N, C, D, {}),
    "function, Array, number | BigNumber | Unit": (N, C, D) => {
      var B = m(N, C, [D], {});
      return {
        t: B.t,
        y: B.y.map((S) => S[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit": (N, C, D) => {
      var B = m(N, C.toArray(), [D], {});
      return {
        t: p(B.t),
        y: p(B.y.map((S) => S[0]))
      };
    },
    "function, Array, number | BigNumber | Unit, Object": (N, C, D, B) => {
      var S = m(N, C, [D], B);
      return {
        t: S.t,
        y: S.y.map((F) => F[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit, Object": (N, C, D, B) => {
      var S = m(N, C.toArray(), [D], B);
      return {
        t: p(S.t),
        y: p(S.y.map((F) => F[0]))
      };
    }
  });
}), IM = "erf", HM = ["typed"], _c = /* @__PURE__ */ U(IM, HM, (r) => {
  var {
    typed: e
  } = r;
  return e("name", {
    number: function(u) {
      var f = Math.abs(u);
      return f >= UM ? _n(u) : f <= LM ? _n(u) * t(f) : f <= 4 ? _n(u) * (1 - n(f)) : _n(u) * (1 - a(f));
    },
    "Array | Matrix": e.referToSelf((i) => (u) => $e(u, i))
    // TODO: For complex numbers, use the approximation for the Faddeeva function
    //  from "More Efficient Computation of the Complex Error Function" (AMS)
  });
  function t(i) {
    var u = i * i, f = Fn[0][4] * u, c = u, o;
    for (o = 0; o < 3; o += 1)
      f = (f + Fn[0][o]) * u, c = (c + Wa[0][o]) * u;
    return i * (f + Fn[0][3]) / (c + Wa[0][3]);
  }
  function n(i) {
    var u = Fn[1][8] * i, f = i, c;
    for (c = 0; c < 7; c += 1)
      u = (u + Fn[1][c]) * i, f = (f + Wa[1][c]) * i;
    var o = (u + Fn[1][7]) / (f + Wa[1][7]), s = parseInt(i * 16) / 16, l = (i - s) * (i + s);
    return Math.exp(-s * s) * Math.exp(-l) * o;
  }
  function a(i) {
    var u = 1 / (i * i), f = Fn[2][5] * u, c = u, o;
    for (o = 0; o < 4; o += 1)
      f = (f + Fn[2][o]) * u, c = (c + Wa[2][o]) * u;
    var s = u * (f + Fn[2][4]) / (c + Wa[2][4]);
    s = (qM - s) / i, u = parseInt(i * 16) / 16;
    var l = (i - u) * (i + u);
    return Math.exp(-u * u) * Math.exp(-l) * s;
  }
}), LM = 0.46875, qM = 0.5641895835477563, Fn = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Wa = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], UM = Math.pow(2, 53), iA = "zeta", kM = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], $c = /* @__PURE__ */ U(iA, kM, (r) => {
  var {
    typed: e,
    config: t,
    multiply: n,
    pow: a,
    divide: i,
    factorial: u,
    equal: f,
    smallerEq: c,
    isNegative: o,
    gamma: s,
    sin: l,
    subtract: v,
    add: p,
    Complex: h,
    BigNumber: d,
    pi: x
  } = r;
  return e(iA, {
    number: (A) => g(A, (E) => E, () => 20),
    BigNumber: (A) => g(A, (E) => new d(E), () => Math.abs(Math.log10(t.epsilon))),
    Complex: y
  });
  function g(A, E, N) {
    return f(A, 0) ? E(-0.5) : f(A, 1) ? E(NaN) : isFinite(A) ? m(A, E, N, (C) => C) : o(A) ? E(NaN) : E(1);
  }
  function y(A) {
    return A.re === 0 && A.im === 0 ? new h(-0.5) : A.re === 1 ? new h(NaN, NaN) : A.re === 1 / 0 && A.im === 0 ? new h(1) : A.im === 1 / 0 || A.re === -1 / 0 ? new h(NaN, NaN) : m(A, (E) => E, (E) => Math.round(1.3 * 15 + 0.9 * Math.abs(E.im)), (E) => E.re);
  }
  function m(A, E, N, C) {
    var D = N(A);
    if (C(A) > -(D - 1) / 2)
      return w(A, E(D), E);
    var B = n(a(2, A), a(E(x), v(A, 1)));
    return B = n(B, l(n(i(E(x), 2), A))), B = n(B, s(v(1, A))), n(B, m(v(1, A), E, N, C));
  }
  function b(A, E) {
    for (var N = A, C = A; c(C, E); C = p(C, 1)) {
      var D = i(n(u(p(E, v(C, 1))), a(4, C)), n(u(v(E, C)), u(n(2, C))));
      N = p(N, D);
    }
    return n(E, N);
  }
  function w(A, E, N) {
    for (var C = i(1, n(b(N(0), E), v(1, a(2, v(1, A))))), D = N(0), B = N(1); c(B, E); B = p(B, 1))
      D = p(D, i(n((-1) ** (B - 1), b(B, E)), a(B, A)));
    return n(C, D);
  }
}), oA = "mode", XM = ["typed", "isNaN", "isNumeric"], el = /* @__PURE__ */ U(oA, XM, (r) => {
  var {
    typed: e,
    isNaN: t,
    isNumeric: n
  } = r;
  return e(oA, {
    "Array | Matrix": a,
    "...": function(u) {
      return a(u);
    }
  });
  function a(i) {
    i = cr(i.valueOf());
    var u = i.length;
    if (u === 0)
      throw new Error("Cannot calculate mode of an empty array");
    for (var f = {}, c = [], o = 0, s = 0; s < i.length; s++) {
      var l = i[s];
      if (n(l) && t(l))
        throw new Error("Cannot calculate mode of an array containing NaN values");
      l in f || (f[l] = 0), f[l]++, f[l] === o ? c.push(l) : f[l] > o && (o = f[l], c = [l]);
    }
    return c;
  }
});
function Dt(r, e, t) {
  var n;
  return String(r).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + br(t) + ", value: " + JSON.stringify(t) + ")" : " (type: " + r.data.actual + ")", new TypeError("Cannot calculate " + e + ", unexpected type of argument" + n)) : String(r).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + br(t) + ", value: " + JSON.stringify(t) + ")" : "", new TypeError("Cannot calculate " + e + ", no ordering relation is defined for complex numbers" + n)) : r;
}
var sA = "prod", jM = ["typed", "config", "multiplyScalar", "numeric"], rl = /* @__PURE__ */ U(sA, jM, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    numeric: a
  } = r;
  return e(sA, {
    // prod([a, b, c, d, ...])
    "Array | Matrix": i,
    // prod([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(f, c) {
      throw new Error("prod(A, dim) is not yet supported");
    },
    // prod(a, b, c, d, ...)
    "...": function(f) {
      return i(f);
    }
  });
  function i(u) {
    var f;
    if (Hn(u, function(c) {
      try {
        f = f === void 0 ? c : n(f, c);
      } catch (o) {
        throw Dt(o, "prod", c);
      }
    }), typeof f == "string" && (f = a(f, t.number)), f === void 0)
      throw new Error("Cannot calculate prod of an empty array");
    return f;
  }
}), uA = "format", GM = ["typed"], tl = /* @__PURE__ */ U(uA, GM, (r) => {
  var {
    typed: e
  } = r;
  return e(uA, {
    any: Ke,
    "any, Object | function | number | BigNumber": Ke
  });
}), cA = "bin", VM = ["typed", "format"], nl = U(cA, VM, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(cA, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "bin"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "bin",
        wordSize: i
      });
    }
  });
}), lA = "oct", QM = ["typed", "format"], al = U(lA, QM, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(lA, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "oct"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "oct",
        wordSize: i
      });
    }
  });
}), fA = "hex", YM = ["typed", "format"], il = U(fA, YM, (r) => {
  var {
    typed: e,
    format: t
  } = r;
  return e(fA, {
    "number | BigNumber": function(a) {
      return t(a, {
        notation: "hex"
      });
    },
    "number | BigNumber, number | BigNumber": function(a, i) {
      return t(a, {
        notation: "hex",
        wordSize: i
      });
    }
  });
}), o4 = /\$([\w.]+)/g, vA = "print", ZM = ["typed"], wo = /* @__PURE__ */ U(vA, ZM, (r) => {
  var {
    typed: e
  } = r;
  return e(vA, {
    // note: Matrix will be converted automatically to an Array
    "string, Object | Array": pA,
    "string, Object | Array, number | Object": pA
  });
});
function pA(r, e, t) {
  return r.replace(o4, function(n, a) {
    var i = a.split("."), u = e[i.shift()];
    for (u !== void 0 && u.isMatrix && (u = u.toArray()); i.length && u !== void 0; ) {
      var f = i.shift();
      u = f ? u[f] : u + ".";
    }
    return u !== void 0 ? Wr(u) ? u : Ke(u, t) : n;
  });
}
var dA = "to", WM = ["typed", "matrix", "concat"], ol = /* @__PURE__ */ U(dA, WM, (r) => {
  var {
    typed: e,
    matrix: t,
    concat: n
  } = r, a = Dr({
    typed: e,
    matrix: t,
    concat: n
  });
  return e(dA, {
    "Unit, Unit | string": (i, u) => i.to(u)
  }, a({
    Ds: !0
  }));
}), mA = "isPrime", KM = ["typed"], sl = /* @__PURE__ */ U(mA, KM, (r) => {
  var {
    typed: e
  } = r;
  return e(mA, {
    number: function(n) {
      if (n * 0 !== 0)
        return !1;
      if (n <= 3)
        return n > 1;
      if (n % 2 === 0 || n % 3 === 0)
        return !1;
      for (var a = 5; a * a <= n; a += 6)
        if (n % a === 0 || n % (a + 2) === 0)
          return !1;
      return !0;
    },
    BigNumber: function(n) {
      if (n.toNumber() * 0 !== 0)
        return !1;
      if (n.lte(3))
        return n.gt(1);
      if (n.mod(2).eq(0) || n.mod(3).eq(0))
        return !1;
      if (n.lt(Math.pow(2, 32))) {
        for (var a = n.toNumber(), i = 5; i * i <= a; i += 6)
          if (a % i === 0 || a % (i + 2) === 0)
            return !1;
        return !0;
      }
      function u(y, m, b) {
        for (var w = 1; !m.eq(0); )
          m.mod(2).eq(0) ? (m = m.div(2), y = y.mul(y).mod(b)) : (m = m.sub(1), w = y.mul(w).mod(b));
        return w;
      }
      var f = n.constructor.clone({
        precision: n.toFixed(0).length * 2
      });
      n = new f(n);
      for (var c = 0, o = n.sub(1); o.mod(2).eq(0); )
        o = o.div(2), c += 1;
      var s = null;
      if (n.lt("3317044064679887385961981"))
        s = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((y) => y < n);
      else {
        var l = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
        s = [];
        for (var v = 2; v <= l; v += 1)
          s.push(l);
      }
      for (var p = 0; p < s.length; p += 1) {
        var h = s[p], d = u(n.sub(n).add(h), o, n);
        if (!d.eq(1)) {
          for (var x = 0, g = d; !g.eq(n.sub(1)); x += 1, g = g.mul(g).mod(n))
            if (x === c - 1)
              return !1;
        }
      }
      return !0;
    },
    "Array | Matrix": e.referToSelf((t) => (n) => $e(n, t))
  });
}), JM = "numeric", _M = ["number", "?bignumber", "?fraction"], ul = /* @__PURE__ */ U(JM, _M, (r) => {
  var {
    number: e,
    bignumber: t,
    fraction: n
  } = r, a = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, i = {
    number: (u) => e(u),
    BigNumber: t ? (u) => t(u) : Dh,
    Fraction: n ? (u) => n(u) : a4
  };
  return function(f) {
    var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number", o = arguments.length > 2 ? arguments[2] : void 0;
    if (o !== void 0)
      throw new SyntaxError("numeric() takes one or two arguments");
    var s = br(f);
    if (!(s in a))
      throw new TypeError("Cannot convert " + f + ' of type "' + s + '"; valid input types are ' + Object.keys(a).join(", "));
    if (!(c in i))
      throw new TypeError("Cannot convert " + f + ' to type "' + c + '"; valid output types are ' + Object.keys(i).join(", "));
    return c === s ? f : i[c](f);
  };
}), hA = "divideScalar", $M = ["typed", "numeric"], cl = /* @__PURE__ */ U(hA, $M, (r) => {
  var {
    typed: e,
    numeric: t
  } = r;
  return e(hA, {
    "number, number": function(a, i) {
      return a / i;
    },
    "Complex, Complex": function(a, i) {
      return a.div(i);
    },
    "BigNumber, BigNumber": function(a, i) {
      return a.div(i);
    },
    "Fraction, Fraction": function(a, i) {
      return a.div(i);
    },
    "Unit, number | Complex | Fraction | BigNumber | Unit": (n, a) => n.divide(a),
    "number | Fraction | Complex | BigNumber, Unit": (n, a) => a.divideInto(n)
  });
}), gA = "pow", eF = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], ll = /* @__PURE__ */ U(gA, eF, (r) => {
  var {
    typed: e,
    config: t,
    identity: n,
    multiply: a,
    matrix: i,
    inv: u,
    number: f,
    fraction: c,
    Complex: o
  } = r;
  return e(gA, {
    "number, number": s,
    "Complex, Complex": function(h, d) {
      return h.pow(d);
    },
    "BigNumber, BigNumber": function(h, d) {
      return d.isInteger() || h >= 0 || t.predictable ? h.pow(d) : new o(h.toNumber(), 0).pow(d.toNumber(), 0);
    },
    "Fraction, Fraction": function(h, d) {
      var x = h.pow(d);
      if (x != null)
        return x;
      if (t.predictable)
        throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
      return s(h.valueOf(), d.valueOf());
    },
    "Array, number": l,
    "Array, BigNumber": function(h, d) {
      return l(h, d.toNumber());
    },
    "Matrix, number": v,
    "Matrix, BigNumber": function(h, d) {
      return v(h, d.toNumber());
    },
    "Unit, number | BigNumber": function(h, d) {
      return h.pow(d);
    }
  });
  function s(p, h) {
    if (t.predictable && !Me(h) && p < 0)
      try {
        var d = c(h), x = f(d);
        if ((h === x || Math.abs((h - x) / h) < 1e-14) && d.d % 2 === 1)
          return (d.n % 2 === 0 ? 1 : -1) * Math.pow(-p, h);
      } catch {
      }
    return t.predictable && (p < -1 && h === 1 / 0 || p > -1 && p < 0 && h === -1 / 0) ? NaN : Me(h) || p >= 0 || t.predictable ? wD(p, h) : p * p < 1 && h === 1 / 0 || p * p > 1 && h === -1 / 0 ? 0 : new o(p, 0).pow(h, 0);
  }
  function l(p, h) {
    if (!Me(h))
      throw new TypeError("For A^b, b must be an integer (value is " + h + ")");
    var d = Ve(p);
    if (d.length !== 2)
      throw new Error("For A^b, A must be 2 dimensional (A has " + d.length + " dimensions)");
    if (d[0] !== d[1])
      throw new Error("For A^b, A must be square (size is " + d[0] + "x" + d[1] + ")");
    if (h < 0)
      try {
        return l(u(p), -h);
      } catch (y) {
        throw y.message === "Cannot calculate inverse, determinant is zero" ? new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + h + ")") : y;
      }
    for (var x = n(d[0]).valueOf(), g = p; h >= 1; )
      (h & 1) === 1 && (x = a(g, x)), h >>= 1, g = a(g, g);
    return x;
  }
  function v(p, h) {
    return i(l(p.valueOf(), h));
  }
}), Ka = "Number of decimals in function round must be an integer", xA = "round", rF = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], fl = /* @__PURE__ */ U(xA, rF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    equalScalar: a,
    zeros: i,
    BigNumber: u,
    DenseMatrix: f
  } = r, c = at({
    typed: e,
    equalScalar: a
  }), o = Qr({
    typed: e,
    DenseMatrix: f
  }), s = ln({
    typed: e
  });
  function l(v) {
    return Math.abs(uo(v).exponent);
  }
  return e(xA, {
    number: function(p) {
      var h = Vi(p, l(t.epsilon)), d = wt(p, h, t.epsilon) ? h : p;
      return Vi(d);
    },
    "number, number": function(p, h) {
      var d = l(t.epsilon);
      if (h >= d)
        return Vi(p, h);
      var x = Vi(p, d), g = wt(p, x, t.epsilon) ? x : p;
      return Vi(g, h);
    },
    "number, BigNumber": function(p, h) {
      if (!h.isInteger())
        throw new TypeError(Ka);
      return new u(p).toDecimalPlaces(h.toNumber());
    },
    Complex: function(p) {
      return p.round();
    },
    "Complex, number": function(p, h) {
      if (h % 1)
        throw new TypeError(Ka);
      return p.round(h);
    },
    "Complex, BigNumber": function(p, h) {
      if (!h.isInteger())
        throw new TypeError(Ka);
      var d = h.toNumber();
      return p.round(d);
    },
    BigNumber: function(p) {
      var h = new u(p).toDecimalPlaces(l(t.epsilon)), d = Jt(p, h, t.epsilon) ? h : p;
      return d.toDecimalPlaces(0);
    },
    "BigNumber, BigNumber": function(p, h) {
      if (!h.isInteger())
        throw new TypeError(Ka);
      var d = l(t.epsilon);
      if (h >= d)
        return p.toDecimalPlaces(h.toNumber());
      var x = p.toDecimalPlaces(d), g = Jt(p, x, t.epsilon) ? x : p;
      return g.toDecimalPlaces(h.toNumber());
    },
    Fraction: function(p) {
      return p.round();
    },
    "Fraction, number": function(p, h) {
      if (h % 1)
        throw new TypeError(Ka);
      return p.round(h);
    },
    "Fraction, BigNumber": function(p, h) {
      if (!h.isInteger())
        throw new TypeError(Ka);
      return p.round(h.toNumber());
    },
    "Unit, number, Unit": e.referToSelf((v) => function(p, h, d) {
      var x = p.toNumeric(d);
      return d.multiply(v(x, h));
    }),
    "Unit, BigNumber, Unit": e.referToSelf((v) => (p, h, d) => v(p, h.toNumber(), d)),
    "Unit, Unit": e.referToSelf((v) => (p, h) => v(p, 0, h)),
    "Array | Matrix, number, Unit": e.referToSelf((v) => (p, h, d) => $e(p, (x) => v(x, h, d))),
    "Array | Matrix, BigNumber, Unit": e.referToSelf((v) => (p, h, d) => v(p, h.toNumber(), d)),
    "Array | Matrix, Unit": e.referToSelf((v) => (p, h) => v(p, 0, h)),
    "Array | Matrix": e.referToSelf((v) => (p) => $e(p, v)),
    "SparseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => c(p, h, v, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((v) => (p, h) => s(p, h, v, !1)),
    "Array, number | BigNumber": e.referToSelf((v) => (p, h) => s(n(p), h, v, !1).valueOf()),
    "number | Complex | BigNumber | Fraction, SparseMatrix": e.referToSelf((v) => (p, h) => a(p, 0) ? i(h.size(), h.storage()) : o(h, p, v, !0)),
    "number | Complex | BigNumber | Fraction, DenseMatrix": e.referToSelf((v) => (p, h) => a(p, 0) ? i(h.size(), h.storage()) : s(h, p, v, !0)),
    "number | Complex | BigNumber | Fraction, Array": e.referToSelf((v) => (p, h) => s(n(h), p, v, !0).valueOf())
  });
}), yA = "log", tF = ["config", "typed", "divideScalar", "Complex"], vl = /* @__PURE__ */ U(yA, tF, (r) => {
  var {
    typed: e,
    config: t,
    divideScalar: n,
    Complex: a
  } = r;
  return e(yA, {
    number: function(u) {
      return u >= 0 || t.predictable ? H7(u) : new a(u, 0).log();
    },
    Complex: function(u) {
      return u.log();
    },
    BigNumber: function(u) {
      return !u.isNegative() || t.predictable ? u.ln() : new a(u.toNumber(), 0).log();
    },
    "any, any": e.referToSelf((i) => (u, f) => n(i(u), i(f)))
  });
}), AA = "log1p", nF = ["typed", "config", "divideScalar", "log", "Complex"], pl = /* @__PURE__ */ U(AA, nF, (r) => {
  var {
    typed: e,
    config: t,
    divideScalar: n,
    log: a,
    Complex: i
  } = r;
  return e(AA, {
    number: function(c) {
      return c >= -1 || t.predictable ? Q6(c) : u(new i(c, 0));
    },
    Complex: u,
    BigNumber: function(c) {
      var o = c.plus(1);
      return !o.isNegative() || t.predictable ? o.ln() : u(new i(c.toNumber(), 0));
    },
    "Array | Matrix": e.referToSelf((f) => (c) => $e(c, f)),
    "any, any": e.referToSelf((f) => (c, o) => n(f(c), a(o)))
  });
  function u(f) {
    var c = f.re + 1;
    return new i(Math.log(Math.sqrt(c * c + f.im * f.im)), Math.atan2(f.im, c));
  }
}), bA = "nthRoots", aF = ["config", "typed", "divideScalar", "Complex"], dl = /* @__PURE__ */ U(bA, aF, (r) => {
  var {
    typed: e,
    config: t,
    divideScalar: n,
    Complex: a
  } = r, i = [function(c) {
    return new a(c, 0);
  }, function(c) {
    return new a(0, c);
  }, function(c) {
    return new a(-c, 0);
  }, function(c) {
    return new a(0, -c);
  }];
  function u(f, c) {
    if (c < 0)
      throw new Error("Root must be greater than zero");
    if (c === 0)
      throw new Error("Root must be non-zero");
    if (c % 1 !== 0)
      throw new Error("Root must be an integer");
    if (f === 0 || f.abs() === 0)
      return [new a(0, 0)];
    var o = typeof f == "number", s;
    (o || f.re === 0 || f.im === 0) && (o ? s = 2 * +(f < 0) : f.im === 0 ? s = 2 * +(f.re < 0) : s = 2 * +(f.im < 0) + 1);
    for (var l = f.arg(), v = f.abs(), p = [], h = Math.pow(v, 1 / c), d = 0; d < c; d++) {
      var x = (s + 4 * d) / c;
      if (x === Math.round(x)) {
        p.push(i[x % 4](h));
        continue;
      }
      p.push(new a({
        r: h,
        phi: (l + 2 * Math.PI * d) / c
      }));
    }
    return p;
  }
  return e(bA, {
    Complex: function(c) {
      return u(c, 2);
    },
    "Complex, number": u
  });
}), wA = "dotPow", iF = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat"], ml = /* @__PURE__ */ U(wA, iF, (r) => {
  var {
    typed: e,
    equalScalar: t,
    matrix: n,
    pow: a,
    DenseMatrix: i,
    concat: u
  } = r, f = Ct({
    typed: e
  }), c = Dn({
    typed: e,
    DenseMatrix: i
  }), o = at({
    typed: e,
    equalScalar: t
  }), s = Qr({
    typed: e,
    DenseMatrix: i
  }), l = Dr({
    typed: e,
    matrix: n,
    concat: u
  }), v = {};
  for (var p in a.signatures)
    Object.prototype.hasOwnProperty.call(a.signatures, p) && !p.includes("Matrix") && !p.includes("Array") && (v[p] = a.signatures[p]);
  var h = e(v);
  return e(wA, l({
    elop: h,
    SS: c,
    DS: f,
    Ss: o,
    sS: s
  }));
}), DA = "dotDivide", oF = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat"], hl = /* @__PURE__ */ U(DA, oF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    divideScalar: a,
    DenseMatrix: i,
    concat: u
  } = r, f = fn({
    typed: e,
    equalScalar: n
  }), c = Ct({
    typed: e
  }), o = Dn({
    typed: e,
    DenseMatrix: i
  }), s = at({
    typed: e,
    equalScalar: n
  }), l = Qr({
    typed: e,
    DenseMatrix: i
  }), v = Dr({
    typed: e,
    matrix: t,
    concat: u
  });
  return e(DA, v({
    elop: a,
    SS: o,
    DS: c,
    SD: f,
    Ss: s,
    sS: l
  }));
});
function Do(r) {
  var {
    DenseMatrix: e
  } = r;
  return function(n, a, i) {
    var u = n.size();
    if (u.length !== 2)
      throw new RangeError("Matrix must be two dimensional (size: " + Ke(u) + ")");
    var f = u[0], c = u[1];
    if (f !== c)
      throw new RangeError("Matrix must be square (size: " + Ke(u) + ")");
    var o = [];
    if (Oe(a)) {
      var s = a.size(), l = a._data;
      if (s.length === 1) {
        if (s[0] !== f)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var v = 0; v < f; v++)
          o[v] = [l[v]];
        return new e({
          data: o,
          size: [f, 1],
          datatype: a._datatype
        });
      }
      if (s.length === 2) {
        if (s[0] !== f || s[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (oi(a)) {
          if (i) {
            o = [];
            for (var p = 0; p < f; p++)
              o[p] = [l[p][0]];
            return new e({
              data: o,
              size: [f, 1],
              datatype: a._datatype
            });
          }
          return a;
        }
        if (Tn(a)) {
          for (var h = 0; h < f; h++)
            o[h] = [0];
          for (var d = a._values, x = a._index, g = a._ptr, y = g[1], m = g[0]; m < y; m++) {
            var b = x[m];
            o[b][0] = d[m];
          }
          return new e({
            data: o,
            size: [f, 1],
            datatype: a._datatype
          });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (ur(a)) {
      var w = Ve(a);
      if (w.length === 1) {
        if (w[0] !== f)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var A = 0; A < f; A++)
          o[A] = [a[A]];
        return new e({
          data: o,
          size: [f, 1]
        });
      }
      if (w.length === 2) {
        if (w[0] !== f || w[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var E = 0; E < f; E++)
          o[E] = [a[E][0]];
        return new e({
          data: o,
          size: [f, 1]
        });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var CA = "lsolve", sF = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], gl = /* @__PURE__ */ U(CA, sF, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: u,
    DenseMatrix: f
  } = r, c = Do({
    DenseMatrix: f
  });
  return e(CA, {
    "SparseMatrix, Array | Matrix": function(v, p) {
      return s(v, p);
    },
    "DenseMatrix, Array | Matrix": function(v, p) {
      return o(v, p);
    },
    "Array, Array | Matrix": function(v, p) {
      var h = t(v), d = o(h, p);
      return d.valueOf();
    }
  });
  function o(l, v) {
    v = c(l, v, !0);
    for (var p = v._data, h = l._size[0], d = l._size[1], x = [], g = l._data, y = 0; y < d; y++) {
      var m = p[y][0] || 0, b = void 0;
      if (u(m, 0))
        b = 0;
      else {
        var w = g[y][y];
        if (u(w, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        b = n(m, w);
        for (var A = y + 1; A < h; A++)
          p[A] = [i(p[A][0] || 0, a(b, g[A][y]))];
      }
      x[y] = [b];
    }
    return new f({
      data: x,
      size: [h, 1]
    });
  }
  function s(l, v) {
    v = c(l, v, !0);
    for (var p = v._data, h = l._size[0], d = l._size[1], x = l._values, g = l._index, y = l._ptr, m = [], b = 0; b < d; b++) {
      var w = p[b][0] || 0;
      if (u(w, 0))
        m[b] = [0];
      else {
        for (var A = 0, E = [], N = [], C = y[b], D = y[b + 1], B = C; B < D; B++) {
          var S = g[B];
          S === b ? A = x[B] : S > b && (E.push(x[B]), N.push(S));
        }
        if (u(A, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var F = n(w, A), I = 0, z = N.length; I < z; I++) {
          var P = N[I];
          p[P] = [i(p[P][0] || 0, a(F, E[I]))];
        }
        m[b] = [F];
      }
    }
    return new f({
      data: m,
      size: [h, 1]
    });
  }
}), EA = "usolve", uF = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], xl = /* @__PURE__ */ U(EA, uF, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: u,
    DenseMatrix: f
  } = r, c = Do({
    DenseMatrix: f
  });
  return e(EA, {
    "SparseMatrix, Array | Matrix": function(v, p) {
      return s(v, p);
    },
    "DenseMatrix, Array | Matrix": function(v, p) {
      return o(v, p);
    },
    "Array, Array | Matrix": function(v, p) {
      var h = t(v), d = o(h, p);
      return d.valueOf();
    }
  });
  function o(l, v) {
    v = c(l, v, !0);
    for (var p = v._data, h = l._size[0], d = l._size[1], x = [], g = l._data, y = d - 1; y >= 0; y--) {
      var m = p[y][0] || 0, b = void 0;
      if (u(m, 0))
        b = 0;
      else {
        var w = g[y][y];
        if (u(w, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        b = n(m, w);
        for (var A = y - 1; A >= 0; A--)
          p[A] = [i(p[A][0] || 0, a(b, g[A][y]))];
      }
      x[y] = [b];
    }
    return new f({
      data: x,
      size: [h, 1]
    });
  }
  function s(l, v) {
    v = c(l, v, !0);
    for (var p = v._data, h = l._size[0], d = l._size[1], x = l._values, g = l._index, y = l._ptr, m = [], b = d - 1; b >= 0; b--) {
      var w = p[b][0] || 0;
      if (u(w, 0))
        m[b] = [0];
      else {
        for (var A = 0, E = [], N = [], C = y[b], D = y[b + 1], B = D - 1; B >= C; B--) {
          var S = g[B];
          S === b ? A = x[B] : S < b && (E.push(x[B]), N.push(S));
        }
        if (u(A, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var F = n(w, A), I = 0, z = N.length; I < z; I++) {
          var P = N[I];
          p[P] = [i(p[P][0], a(F, E[I]))];
        }
        m[b] = [F];
      }
    }
    return new f({
      data: m,
      size: [h, 1]
    });
  }
}), NA = "lsolveAll", cF = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], yl = /* @__PURE__ */ U(NA, cF, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: u,
    DenseMatrix: f
  } = r, c = Do({
    DenseMatrix: f
  });
  return e(NA, {
    "SparseMatrix, Array | Matrix": function(v, p) {
      return s(v, p);
    },
    "DenseMatrix, Array | Matrix": function(v, p) {
      return o(v, p);
    },
    "Array, Array | Matrix": function(v, p) {
      var h = t(v), d = o(h, p);
      return d.map((x) => x.valueOf());
    }
  });
  function o(l, v) {
    for (var p = [c(l, v, !0)._data.map((N) => N[0])], h = l._data, d = l._size[0], x = l._size[1], g = 0; g < x; g++)
      for (var y = p.length, m = 0; m < y; m++) {
        var b = p[m];
        if (u(h[g][g], 0))
          if (u(b[g], 0)) {
            if (m === 0) {
              var A = [...b];
              A[g] = 1;
              for (var E = g + 1; E < x; E++)
                A[E] = i(A[E], h[E][g]);
              p.push(A);
            }
          } else {
            if (m === 0)
              return [];
            p.splice(m, 1), m -= 1, y -= 1;
          }
        else {
          b[g] = n(b[g], h[g][g]);
          for (var w = g + 1; w < x; w++)
            b[w] = i(b[w], a(b[g], h[w][g]));
        }
      }
    return p.map((N) => new f({
      data: N.map((C) => [C]),
      size: [d, 1]
    }));
  }
  function s(l, v) {
    for (var p = [c(l, v, !0)._data.map((k) => k[0])], h = l._size[0], d = l._size[1], x = l._values, g = l._index, y = l._ptr, m = 0; m < d; m++)
      for (var b = p.length, w = 0; w < b; w++) {
        for (var A = p[w], E = [], N = [], C = y[m], D = y[m + 1], B = 0, S = C; S < D; S++) {
          var F = g[S];
          F === m ? B = x[S] : F > m && (E.push(x[S]), N.push(F));
        }
        if (u(B, 0))
          if (u(A[m], 0)) {
            if (w === 0) {
              var M = [...A];
              M[m] = 1;
              for (var H = 0, O = N.length; H < O; H++) {
                var Q = N[H];
                M[Q] = i(M[Q], E[H]);
              }
              p.push(M);
            }
          } else {
            if (w === 0)
              return [];
            p.splice(w, 1), w -= 1, b -= 1;
          }
        else {
          A[m] = n(A[m], B);
          for (var I = 0, z = N.length; I < z; I++) {
            var P = N[I];
            A[P] = i(A[P], a(A[m], E[I]));
          }
        }
      }
    return p.map((k) => new f({
      data: k.map((L) => [L]),
      size: [h, 1]
    }));
  }
}), BA = "usolveAll", lF = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], Al = /* @__PURE__ */ U(BA, lF, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    multiplyScalar: a,
    subtractScalar: i,
    equalScalar: u,
    DenseMatrix: f
  } = r, c = Do({
    DenseMatrix: f
  });
  return e(BA, {
    "SparseMatrix, Array | Matrix": function(v, p) {
      return s(v, p);
    },
    "DenseMatrix, Array | Matrix": function(v, p) {
      return o(v, p);
    },
    "Array, Array | Matrix": function(v, p) {
      var h = t(v), d = o(h, p);
      return d.map((x) => x.valueOf());
    }
  });
  function o(l, v) {
    for (var p = [c(l, v, !0)._data.map((N) => N[0])], h = l._data, d = l._size[0], x = l._size[1], g = x - 1; g >= 0; g--)
      for (var y = p.length, m = 0; m < y; m++) {
        var b = p[m];
        if (u(h[g][g], 0))
          if (u(b[g], 0)) {
            if (m === 0) {
              var A = [...b];
              A[g] = 1;
              for (var E = g - 1; E >= 0; E--)
                A[E] = i(A[E], h[E][g]);
              p.push(A);
            }
          } else {
            if (m === 0)
              return [];
            p.splice(m, 1), m -= 1, y -= 1;
          }
        else {
          b[g] = n(b[g], h[g][g]);
          for (var w = g - 1; w >= 0; w--)
            b[w] = i(b[w], a(b[g], h[w][g]));
        }
      }
    return p.map((N) => new f({
      data: N.map((C) => [C]),
      size: [d, 1]
    }));
  }
  function s(l, v) {
    for (var p = [c(l, v, !0)._data.map((k) => k[0])], h = l._size[0], d = l._size[1], x = l._values, g = l._index, y = l._ptr, m = d - 1; m >= 0; m--)
      for (var b = p.length, w = 0; w < b; w++) {
        for (var A = p[w], E = [], N = [], C = y[m], D = y[m + 1], B = 0, S = D - 1; S >= C; S--) {
          var F = g[S];
          F === m ? B = x[S] : F < m && (E.push(x[S]), N.push(F));
        }
        if (u(B, 0))
          if (u(A[m], 0)) {
            if (w === 0) {
              var M = [...A];
              M[m] = 1;
              for (var H = 0, O = N.length; H < O; H++) {
                var Q = N[H];
                M[Q] = i(M[Q], E[H]);
              }
              p.push(M);
            }
          } else {
            if (w === 0)
              return [];
            p.splice(w, 1), w -= 1, b -= 1;
          }
        else {
          A[m] = n(A[m], B);
          for (var I = 0, z = N.length; I < z; I++) {
            var P = N[I];
            A[P] = i(A[P], a(A[m], E[I]));
          }
        }
      }
    return p.map((k) => new f({
      data: k.map((L) => [L]),
      size: [h, 1]
    }));
  }
}), fF = "matAlgo08xS0Sid", vF = ["typed", "equalScalar"], Ch = /* @__PURE__ */ U(fF, vF, (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return function(a, i, u) {
    var f = a._values, c = a._index, o = a._ptr, s = a._size, l = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), v = i._values, p = i._index, h = i._ptr, d = i._size, x = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (s.length !== d.length)
      throw new Ye(s.length, d.length);
    if (s[0] !== d[0] || s[1] !== d[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + d + ")");
    if (!f || !v)
      throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var g = s[0], y = s[1], m, b = t, w = 0, A = u;
    typeof l == "string" && l === x && l !== "mixed" && (m = l, b = e.find(t, [m, m]), w = e.convert(0, m), A = e.find(u, [m, m]));
    for (var E = [], N = [], C = [], D = [], B = [], S, F, I, z, P = 0; P < y; P++) {
      C[P] = N.length;
      var M = P + 1;
      for (F = o[P], I = o[P + 1], S = F; S < I; S++)
        z = c[S], B[z] = M, D[z] = f[S], N.push(z);
      for (F = h[P], I = h[P + 1], S = F; S < I; S++)
        z = p[S], B[z] === M && (D[z] = A(D[z], v[S]));
      for (S = C[P]; S < N.length; ) {
        z = N[S];
        var H = D[z];
        b(H, w) ? N.splice(S, 1) : (E.push(H), S++);
      }
    }
    return C[y] = N.length, a.createSparseMatrix({
      values: E,
      index: N,
      ptr: C,
      size: [g, y],
      datatype: l === a._datatype && x === i._datatype ? m : void 0
    });
  };
}), Eh = /* @__PURE__ */ U("useMatrixForArrayScalar", ["typed", "matrix"], (r) => {
  var {
    typed: e,
    matrix: t
  } = r;
  return {
    "Array, number": e.referTo("DenseMatrix, number", (n) => (a, i) => n(t(a), i).valueOf()),
    "Array, BigNumber": e.referTo("DenseMatrix, BigNumber", (n) => (a, i) => n(t(a), i).valueOf()),
    "number, Array": e.referTo("number, DenseMatrix", (n) => (a, i) => n(a, t(i)).valueOf()),
    "BigNumber, Array": e.referTo("BigNumber, DenseMatrix", (n) => (a, i) => n(a, t(i)).valueOf())
  };
}), SA = "leftShift", pF = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], bl = /* @__PURE__ */ U(SA, pF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: u
  } = r, f = oa({
    typed: e
  }), c = fn({
    typed: e,
    equalScalar: n
  }), o = Ch({
    typed: e,
    equalScalar: n
  }), s = Ma({
    typed: e,
    DenseMatrix: i
  }), l = at({
    typed: e,
    equalScalar: n
  }), v = ln({
    typed: e
  }), p = Dr({
    typed: e,
    matrix: t,
    concat: u
  }), h = Eh({
    typed: e,
    matrix: t
  });
  return e(SA, {
    "number, number": BD,
    "BigNumber, BigNumber": zP,
    "SparseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : l(x, g, d, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : v(x, g, d, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : s(g, x, d, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : v(g, x, d, !0))
  }, h, p({
    SS: o,
    DS: f,
    SD: c
  }));
}), PA = "rightArithShift", dF = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], wl = /* @__PURE__ */ U(PA, dF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: u
  } = r, f = oa({
    typed: e
  }), c = fn({
    typed: e,
    equalScalar: n
  }), o = Ch({
    typed: e,
    equalScalar: n
  }), s = Ma({
    typed: e,
    DenseMatrix: i
  }), l = at({
    typed: e,
    equalScalar: n
  }), v = ln({
    typed: e
  }), p = Dr({
    typed: e,
    matrix: t,
    concat: u
  }), h = Eh({
    typed: e,
    matrix: t
  });
  return e(PA, {
    "number, number": SD,
    "BigNumber, BigNumber": RP,
    "SparseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : l(x, g, d, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : v(x, g, d, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : s(g, x, d, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : v(g, x, d, !0))
  }, h, p({
    SS: o,
    DS: f,
    SD: c
  }));
}), MA = "rightLogShift", mF = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], Dl = /* @__PURE__ */ U(MA, mF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    DenseMatrix: i,
    concat: u
  } = r, f = oa({
    typed: e
  }), c = fn({
    typed: e,
    equalScalar: n
  }), o = Ch({
    typed: e,
    equalScalar: n
  }), s = Ma({
    typed: e,
    DenseMatrix: i
  }), l = at({
    typed: e,
    equalScalar: n
  }), v = ln({
    typed: e
  }), p = Dr({
    typed: e,
    matrix: t,
    concat: u
  }), h = Eh({
    typed: e,
    matrix: t
  });
  return e(MA, {
    "number, number": PD,
    // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
    "SparseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : l(x, g, d, !1)),
    "DenseMatrix, number | BigNumber": e.referToSelf((d) => (x, g) => n(g, 0) ? x.clone() : v(x, g, d, !1)),
    "number | BigNumber, SparseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : s(g, x, d, !0)),
    "number | BigNumber, DenseMatrix": e.referToSelf((d) => (x, g) => n(x, 0) ? a(g.size(), g.storage()) : v(g, x, d, !0))
  }, h, p({
    SS: o,
    DS: f,
    SD: c
  }));
}), FA = "and", hF = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], Co = /* @__PURE__ */ U(FA, hF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: u
  } = r, f = fn({
    typed: e,
    equalScalar: n
  }), c = sc({
    typed: e,
    equalScalar: n
  }), o = at({
    typed: e,
    equalScalar: n
  }), s = ln({
    typed: e
  }), l = Dr({
    typed: e,
    matrix: t,
    concat: u
  });
  return e(FA, {
    "number, number": zD,
    "Complex, Complex": function(p, h) {
      return (p.re !== 0 || p.im !== 0) && (h.re !== 0 || h.im !== 0);
    },
    "BigNumber, BigNumber": function(p, h) {
      return !p.isZero() && !h.isZero() && !p.isNaN() && !h.isNaN();
    },
    "Unit, Unit": e.referToSelf((v) => (p, h) => v(p.value || 0, h.value || 0)),
    "SparseMatrix, any": e.referToSelf((v) => (p, h) => i(h) ? a(p.size(), p.storage()) : o(p, h, v, !1)),
    "DenseMatrix, any": e.referToSelf((v) => (p, h) => i(h) ? a(p.size(), p.storage()) : s(p, h, v, !1)),
    "any, SparseMatrix": e.referToSelf((v) => (p, h) => i(p) ? a(p.size(), p.storage()) : o(h, p, v, !0)),
    "any, DenseMatrix": e.referToSelf((v) => (p, h) => i(p) ? a(p.size(), p.storage()) : s(h, p, v, !0)),
    "Array, any": e.referToSelf((v) => (p, h) => v(t(p), h).valueOf()),
    "any, Array": e.referToSelf((v) => (p, h) => v(p, t(h)).valueOf())
  }, l({
    SS: c,
    DS: f
  }));
}), Gs = "compare", gF = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], Cl = /* @__PURE__ */ U(Gs, gF, (r) => {
  var {
    typed: e,
    config: t,
    equalScalar: n,
    matrix: a,
    BigNumber: i,
    Fraction: u,
    DenseMatrix: f,
    concat: c
  } = r, o = Ct({
    typed: e
  }), s = ic({
    typed: e,
    equalScalar: n
  }), l = Qr({
    typed: e,
    DenseMatrix: f
  }), v = Dr({
    typed: e,
    matrix: a,
    concat: c
  }), p = wi({
    typed: e
  });
  return e(Gs, xF({
    typed: e,
    config: t
  }), {
    "boolean, boolean": function(d, x) {
      return d === x ? 0 : d > x ? 1 : -1;
    },
    "BigNumber, BigNumber": function(d, x) {
      return Jt(d, x, t.epsilon) ? new i(0) : new i(d.cmp(x));
    },
    "Fraction, Fraction": function(d, x) {
      return new u(d.compare(x));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, p, v({
    SS: s,
    DS: o,
    Ss: l
  }));
}), xF = /* @__PURE__ */ U(Gs, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Gs, {
    "number, number": function(a, i) {
      return wt(a, i, t.epsilon) ? 0 : a > i ? 1 : -1;
    }
  });
}), yF = function r(e, t) {
  var n = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a = /(^[ ]*|[ ]*$)/g, i = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, u = /^0x[0-9a-f]+$/i, f = /^0/, c = function(m) {
    return r.insensitive && ("" + m).toLowerCase() || "" + m;
  }, o = c(e).replace(a, "") || "", s = c(t).replace(a, "") || "", l = o.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), v = s.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), p = parseInt(o.match(u), 16) || l.length !== 1 && o.match(i) && Date.parse(o), h = parseInt(s.match(u), 16) || p && s.match(i) && Date.parse(s) || null, d, x;
  if (h) {
    if (p < h)
      return -1;
    if (p > h)
      return 1;
  }
  for (var g = 0, y = Math.max(l.length, v.length); g < y; g++) {
    if (d = !(l[g] || "").match(f) && parseFloat(l[g]) || l[g] || 0, x = !(v[g] || "").match(f) && parseFloat(v[g]) || v[g] || 0, isNaN(d) !== isNaN(x))
      return isNaN(d) ? 1 : -1;
    if (typeof d != typeof x && (d += "", x += ""), d < x)
      return -1;
    if (d > x)
      return 1;
  }
  return 0;
};
const Ja = /* @__PURE__ */ Ln(yF);
var TA = "compareNatural", AF = ["typed", "compare"], El = /* @__PURE__ */ U(TA, AF, (r) => {
  var {
    typed: e,
    compare: t
  } = r, n = t.signatures["boolean,boolean"];
  return e(TA, {
    "any, any": a
  });
  function a(c, o) {
    var s = br(c), l = br(o), v;
    if ((s === "number" || s === "BigNumber" || s === "Fraction") && (l === "number" || l === "BigNumber" || l === "Fraction"))
      return v = t(c, o), v.toString() !== "0" ? v > 0 ? 1 : -1 : Ja(s, l);
    var p = ["Array", "DenseMatrix", "SparseMatrix"];
    if (p.includes(s) || p.includes(l))
      return v = i(a, c, o), v !== 0 ? v : Ja(s, l);
    if (s !== l)
      return Ja(s, l);
    if (s === "Complex")
      return bF(c, o);
    if (s === "Unit")
      return c.equalBase(o) ? a(c.value, o.value) : u(a, c.formatUnits(), o.formatUnits());
    if (s === "boolean")
      return n(c, o);
    if (s === "string")
      return Ja(c, o);
    if (s === "Object")
      return f(a, c, o);
    if (s === "null" || s === "undefined")
      return 0;
    throw new TypeError('Unsupported type of value "' + s + '"');
  }
  function i(c, o, s) {
    return Tn(o) && Tn(s) ? u(c, o.toJSON().values, s.toJSON().values) : Tn(o) ? i(c, o.toArray(), s) : Tn(s) ? i(c, o, s.toArray()) : oi(o) ? i(c, o.toJSON().data, s) : oi(s) ? i(c, o, s.toJSON().data) : Array.isArray(o) ? Array.isArray(s) ? u(c, o, s) : i(c, o, [s]) : i(c, [o], s);
  }
  function u(c, o, s) {
    for (var l = 0, v = Math.min(o.length, s.length); l < v; l++) {
      var p = c(o[l], s[l]);
      if (p !== 0)
        return p;
    }
    return o.length > s.length ? 1 : o.length < s.length ? -1 : 0;
  }
  function f(c, o, s) {
    var l = Object.keys(o), v = Object.keys(s);
    l.sort(Ja), v.sort(Ja);
    var p = u(c, l, v);
    if (p !== 0)
      return p;
    for (var h = 0; h < l.length; h++) {
      var d = c(o[l[h]], s[v[h]]);
      if (d !== 0)
        return d;
    }
    return 0;
  }
});
function bF(r, e) {
  return r.re > e.re ? 1 : r.re < e.re ? -1 : r.im > e.im ? 1 : r.im < e.im ? -1 : 0;
}
var OA = "compareText", wF = ["typed", "matrix", "concat"];
Im.signature = "any, any";
var Nl = /* @__PURE__ */ U(OA, wF, (r) => {
  var {
    typed: e,
    matrix: t,
    concat: n
  } = r, a = Dr({
    typed: e,
    matrix: t,
    concat: n
  });
  return e(OA, Im, a({
    elop: Im,
    Ds: !0
  }));
}), Vs = "equal", DF = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Bl = /* @__PURE__ */ U(Vs, DF, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = Dn({
    typed: e,
    DenseMatrix: a
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: t,
    concat: i
  });
  return e(Vs, CF({
    typed: e,
    equalScalar: n
  }), o({
    elop: n,
    SS: f,
    DS: u,
    Ss: c
  }));
}), CF = U(Vs, ["typed", "equalScalar"], (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return e(Vs, {
    "any, any": function(a, i) {
      return a === null ? i === null : i === null ? a === null : a === void 0 ? i === void 0 : i === void 0 ? a === void 0 : t(a, i);
    }
  });
}), zA = "equalText", EF = ["typed", "compareText", "isZero"], Sl = /* @__PURE__ */ U(zA, EF, (r) => {
  var {
    typed: e,
    compareText: t,
    isZero: n
  } = r;
  return e(zA, {
    "any, any": function(i, u) {
      return n(t(i, u));
    }
  });
}), Qs = "smaller", NF = ["typed", "config", "matrix", "DenseMatrix", "concat"], Pl = /* @__PURE__ */ U(Qs, NF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = Dn({
    typed: e,
    DenseMatrix: a
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: n,
    concat: i
  }), s = wi({
    typed: e
  });
  return e(Qs, BF({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (l, v) => l < v,
    "BigNumber, BigNumber": function(v, p) {
      return v.lt(p) && !Jt(v, p, t.epsilon);
    },
    "Fraction, Fraction": (l, v) => l.compare(v) === -1,
    "Complex, Complex": function(v, p) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, s, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), BF = /* @__PURE__ */ U(Qs, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Qs, {
    "number, number": function(a, i) {
      return a < i && !wt(a, i, t.epsilon);
    }
  });
}), Ys = "smallerEq", SF = ["typed", "config", "matrix", "DenseMatrix", "concat"], Ml = /* @__PURE__ */ U(Ys, SF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = Dn({
    typed: e,
    DenseMatrix: a
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: n,
    concat: i
  }), s = wi({
    typed: e
  });
  return e(Ys, PF({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (l, v) => l <= v,
    "BigNumber, BigNumber": function(v, p) {
      return v.lte(p) || Jt(v, p, t.epsilon);
    },
    "Fraction, Fraction": (l, v) => l.compare(v) !== 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, s, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), PF = /* @__PURE__ */ U(Ys, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Ys, {
    "number, number": function(a, i) {
      return a <= i || wt(a, i, t.epsilon);
    }
  });
}), Zs = "larger", MF = ["typed", "config", "matrix", "DenseMatrix", "concat"], Fl = /* @__PURE__ */ U(Zs, MF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = Dn({
    typed: e,
    DenseMatrix: a
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: n,
    concat: i
  }), s = wi({
    typed: e
  });
  return e(Zs, FF({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (l, v) => l > v,
    "BigNumber, BigNumber": function(v, p) {
      return v.gt(p) && !Jt(v, p, t.epsilon);
    },
    "Fraction, Fraction": (l, v) => l.compare(v) === 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, s, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), FF = /* @__PURE__ */ U(Zs, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Zs, {
    "number, number": function(a, i) {
      return a > i && !wt(a, i, t.epsilon);
    }
  });
}), Ws = "largerEq", TF = ["typed", "config", "matrix", "DenseMatrix", "concat"], Tl = /* @__PURE__ */ U(Ws, TF, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    DenseMatrix: a,
    concat: i
  } = r, u = Ct({
    typed: e
  }), f = Dn({
    typed: e,
    DenseMatrix: a
  }), c = Qr({
    typed: e,
    DenseMatrix: a
  }), o = Dr({
    typed: e,
    matrix: n,
    concat: i
  }), s = wi({
    typed: e
  });
  return e(Ws, OF({
    typed: e,
    config: t
  }), {
    "boolean, boolean": (l, v) => l >= v,
    "BigNumber, BigNumber": function(v, p) {
      return v.gte(p) || Jt(v, p, t.epsilon);
    },
    "Fraction, Fraction": (l, v) => l.compare(v) !== -1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, s, o({
    SS: f,
    DS: u,
    Ss: c
  }));
}), OF = /* @__PURE__ */ U(Ws, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: t
  } = r;
  return e(Ws, {
    "number, number": function(a, i) {
      return a >= i || wt(a, i, t.epsilon);
    }
  });
}), RA = "deepEqual", zF = ["typed", "equal"], Ol = /* @__PURE__ */ U(RA, zF, (r) => {
  var {
    typed: e,
    equal: t
  } = r;
  return e(RA, {
    "any, any": function(i, u) {
      return n(i.valueOf(), u.valueOf());
    }
  });
  function n(a, i) {
    if (Array.isArray(a))
      if (Array.isArray(i)) {
        var u = a.length;
        if (u !== i.length)
          return !1;
        for (var f = 0; f < u; f++)
          if (!n(a[f], i[f]))
            return !1;
        return !0;
      } else
        return !1;
    else
      return Array.isArray(i) ? !1 : t(a, i);
  }
}), Ks = "unequal", RF = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat"], zl = /* @__PURE__ */ U(Ks, RF, (r) => {
  var {
    typed: e,
    config: t,
    equalScalar: n,
    matrix: a,
    DenseMatrix: i,
    concat: u
  } = r, f = Ct({
    typed: e
  }), c = Dn({
    typed: e,
    DenseMatrix: i
  }), o = Qr({
    typed: e,
    DenseMatrix: i
  }), s = Dr({
    typed: e,
    matrix: a,
    concat: u
  });
  return e(Ks, IF({
    typed: e,
    equalScalar: n
  }), s({
    elop: l,
    SS: c,
    DS: f,
    Ss: o
  }));
  function l(v, p) {
    return !n(v, p);
  }
}), IF = U(Ks, ["typed", "equalScalar"], (r) => {
  var {
    typed: e,
    equalScalar: t
  } = r;
  return e(Ks, {
    "any, any": function(a, i) {
      return a === null ? i !== null : i === null ? a !== null : a === void 0 ? i !== void 0 : i === void 0 ? a !== void 0 : !t(a, i);
    }
  });
}), IA = "partitionSelect", HF = ["typed", "isNumeric", "isNaN", "compare"], Rl = /* @__PURE__ */ U(IA, HF, (r) => {
  var {
    typed: e,
    isNumeric: t,
    isNaN: n,
    compare: a
  } = r, i = a, u = (o, s) => -a(o, s);
  return e(IA, {
    "Array | Matrix, number": function(s, l) {
      return f(s, l, i);
    },
    "Array | Matrix, number, string": function(s, l, v) {
      if (v === "asc")
        return f(s, l, i);
      if (v === "desc")
        return f(s, l, u);
      throw new Error('Compare string must be "asc" or "desc"');
    },
    "Array | Matrix, number, function": f
  });
  function f(o, s, l) {
    if (!Me(s) || s < 0)
      throw new Error("k must be a non-negative integer");
    if (Oe(o)) {
      var v = o.size();
      if (v.length > 1)
        throw new Error("Only one dimensional matrices supported");
      return c(o.valueOf(), s, l);
    }
    if (Array.isArray(o))
      return c(o, s, l);
  }
  function c(o, s, l) {
    if (s >= o.length)
      throw new Error("k out of bounds");
    for (var v = 0; v < o.length; v++)
      if (t(o[v]) && n(o[v]))
        return o[v];
    for (var p = 0, h = o.length - 1; p < h; ) {
      for (var d = p, x = h, g = o[Math.floor(Math.random() * (h - p + 1)) + p]; d < x; )
        if (l(o[d], g) >= 0) {
          var y = o[x];
          o[x] = o[d], o[d] = y, --x;
        } else
          ++d;
      l(o[d], g) > 0 && --d, s <= d ? h = d : p = d + 1;
    }
    return o[s];
  }
}), HA = "sort", LF = ["typed", "matrix", "compare", "compareNatural"], Il = /* @__PURE__ */ U(HA, LF, (r) => {
  var {
    typed: e,
    matrix: t,
    compare: n,
    compareNatural: a
  } = r, i = n, u = (s, l) => -n(s, l);
  return e(HA, {
    Array: function(l) {
      return c(l), l.sort(i);
    },
    Matrix: function(l) {
      return o(l), t(l.toArray().sort(i), l.storage());
    },
    "Array, function": function(l, v) {
      return c(l), l.sort(v);
    },
    "Matrix, function": function(l, v) {
      return o(l), t(l.toArray().sort(v), l.storage());
    },
    "Array, string": function(l, v) {
      return c(l), l.sort(f(v));
    },
    "Matrix, string": function(l, v) {
      return o(l), t(l.toArray().sort(f(v)), l.storage());
    }
  });
  function f(s) {
    if (s === "asc")
      return i;
    if (s === "desc")
      return u;
    if (s === "natural")
      return a;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function c(s) {
    if (Ve(s).length !== 1)
      throw new Error("One dimensional array expected");
  }
  function o(s) {
    if (s.size().length !== 1)
      throw new Error("One dimensional matrix expected");
  }
}), LA = "max", qF = ["typed", "config", "numeric", "larger"], Eo = /* @__PURE__ */ U(LA, qF, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    larger: a
  } = r;
  return e(LA, {
    // max([a, b, c, d, ...])
    "Array | Matrix": u,
    // max([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(c, o) {
      return Eu(c, o.valueOf(), i);
    },
    // max(a, b, c, d, ...)
    "...": function(c) {
      if (yi(c))
        throw new TypeError("Scalar values expected in function max");
      return u(c);
    }
  });
  function i(f, c) {
    try {
      return a(f, c) ? f : c;
    } catch (o) {
      throw Dt(o, "max", c);
    }
  }
  function u(f) {
    var c;
    if (Hn(f, function(o) {
      try {
        isNaN(o) && typeof o == "number" ? c = NaN : (c === void 0 || a(o, c)) && (c = o);
      } catch (s) {
        throw Dt(s, "max", o);
      }
    }), c === void 0)
      throw new Error("Cannot calculate max of an empty array");
    return typeof c == "string" && (c = n(c, t.number)), c;
  }
}), qA = "min", UF = ["typed", "config", "numeric", "smaller"], No = /* @__PURE__ */ U(qA, UF, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    smaller: a
  } = r;
  return e(qA, {
    // min([a, b, c, d, ...])
    "Array | Matrix": u,
    // min([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(c, o) {
      return Eu(c, o.valueOf(), i);
    },
    // min(a, b, c, d, ...)
    "...": function(c) {
      if (yi(c))
        throw new TypeError("Scalar values expected in function min");
      return u(c);
    }
  });
  function i(f, c) {
    try {
      return a(f, c) ? f : c;
    } catch (o) {
      throw Dt(o, "min", c);
    }
  }
  function u(f) {
    var c;
    if (Hn(f, function(o) {
      try {
        isNaN(o) && typeof o == "number" ? c = NaN : (c === void 0 || a(o, c)) && (c = o);
      } catch (s) {
        throw Dt(s, "min", o);
      }
    }), c === void 0)
      throw new Error("Cannot calculate min of an empty array");
    return typeof c == "string" && (c = n(c, t.number)), c;
  }
}), kF = "ImmutableDenseMatrix", XF = ["smaller", "DenseMatrix"], Hl = /* @__PURE__ */ U(kF, XF, (r) => {
  var {
    smaller: e,
    DenseMatrix: t
  } = r;
  function n(a, i) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (i && !Wr(i))
      throw new Error("Invalid datatype: " + i);
    if (Oe(a) || ur(a)) {
      var u = new t(a, i);
      this._data = u._data, this._size = u._size, this._datatype = u._datatype, this._min = null, this._max = null;
    } else if (a && ur(a.data) && ur(a.size))
      this._data = a.data, this._size = a.size, this._datatype = a.datatype, this._min = typeof a.min < "u" ? a.min : null, this._max = typeof a.max < "u" ? a.max : null;
    else {
      if (a)
        throw new TypeError("Unsupported type of data (" + br(a) + ")");
      this._data = [], this._size = [0], this._datatype = i, this._min = null, this._max = null;
    }
  }
  return n.prototype = new t(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = !0, n.prototype.subset = function(a) {
    switch (arguments.length) {
      case 1: {
        var i = t.prototype.subset.call(this, a);
        return Oe(i) ? new n({
          data: i._data,
          size: i._size,
          datatype: i._datatype
        }) : i;
      }
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({
      data: Ie(this._data),
      size: Ie(this._size),
      datatype: this._datatype
    });
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.fromJSON = function(a) {
    return new n(a);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (this._min === null) {
      var a = null;
      this.forEach(function(i) {
        (a === null || e(i, a)) && (a = i);
      }), this._min = a !== null ? a : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (this._max === null) {
      var a = null;
      this.forEach(function(i) {
        (a === null || e(a, i)) && (a = i);
      }), this._max = a !== null ? a : void 0;
    }
    return this._max;
  }, n;
}, {
  isClass: !0
}), jF = "Index", GF = ["ImmutableDenseMatrix", "getMatrixDataType"], Ll = /* @__PURE__ */ U(jF, GF, (r) => {
  var {
    ImmutableDenseMatrix: e,
    getMatrixDataType: t
  } = r;
  function n(i) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var u = 0, f = arguments.length; u < f; u++) {
      var c = arguments[u], o = ur(c), s = Oe(c), l = null;
      if (so(c))
        this._dimensions.push(c), this._isScalar = !1;
      else if (o || s) {
        var v = void 0;
        t(c) === "boolean" ? (o && (v = a(UA(c).valueOf())), s && (v = a(UA(c._data).valueOf())), l = c.valueOf().length) : v = a(c.valueOf()), this._dimensions.push(v);
        var p = v.size();
        (p.length !== 1 || p[0] !== 1 || l !== null) && (this._isScalar = !1);
      } else if (typeof c == "number")
        this._dimensions.push(a([c]));
      else if (typeof c == "string")
        this._dimensions.push(c);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      this._sourceSize.push(l);
    }
  }
  n.prototype.type = "Index", n.prototype.isIndex = !0;
  function a(i) {
    for (var u = 0, f = i.length; u < f; u++)
      if (typeof i[u] != "number" || !Me(i[u]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new e(i);
  }
  return n.prototype.clone = function() {
    var i = new n();
    return i._dimensions = Ie(this._dimensions), i._isScalar = this._isScalar, i._sourceSize = this._sourceSize, i;
  }, n.create = function(i) {
    var u = new n();
    return n.apply(u, i), u;
  }, n.prototype.size = function() {
    for (var i = [], u = 0, f = this._dimensions.length; u < f; u++) {
      var c = this._dimensions[u];
      i[u] = typeof c == "string" ? 1 : c.size()[0];
    }
    return i;
  }, n.prototype.max = function() {
    for (var i = [], u = 0, f = this._dimensions.length; u < f; u++) {
      var c = this._dimensions[u];
      i[u] = typeof c == "string" ? c : c.max();
    }
    return i;
  }, n.prototype.min = function() {
    for (var i = [], u = 0, f = this._dimensions.length; u < f; u++) {
      var c = this._dimensions[u];
      i[u] = typeof c == "string" ? c : c.min();
    }
    return i;
  }, n.prototype.forEach = function(i) {
    for (var u = 0, f = this._dimensions.length; u < f; u++)
      i(this._dimensions[u], u, this);
  }, n.prototype.dimension = function(i) {
    return this._dimensions[i] || null;
  }, n.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var i = [], u = 0, f = this._dimensions.length; u < f; u++) {
      var c = this._dimensions[u];
      i.push(typeof c == "string" ? c : c.toArray());
    }
    return i;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var i = [], u = 0, f = this._dimensions.length; u < f; u++) {
      var c = this._dimensions[u];
      typeof c == "string" ? i.push(JSON.stringify(c)) : i.push(c.toString());
    }
    return "[" + i.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, n.fromJSON = function(i) {
    return n.create(i.dimensions);
  }, n;
}, {
  isClass: !0
});
function UA(r) {
  var e = [];
  return r.forEach((t, n) => {
    t && e.push(n);
  }), e;
}
var VF = "FibonacciHeap", QF = ["smaller", "larger"], ql = /* @__PURE__ */ U(VF, QF, (r) => {
  var {
    smaller: e,
    larger: t
  } = r, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function a() {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  a.prototype.type = "FibonacciHeap", a.prototype.isFibonacciHeap = !0, a.prototype.insert = function(s, l) {
    var v = {
      key: s,
      value: l,
      degree: 0
    };
    if (this._minimum) {
      var p = this._minimum;
      v.left = p, v.right = p.right, p.right = v, v.right.left = v, e(s, p.key) && (this._minimum = v);
    } else
      v.left = v, v.right = v, this._minimum = v;
    return this._size++, v;
  }, a.prototype.size = function() {
    return this._size;
  }, a.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, a.prototype.isEmpty = function() {
    return this._size === 0;
  }, a.prototype.extractMinimum = function() {
    var s = this._minimum;
    if (s === null)
      return s;
    for (var l = this._minimum, v = s.degree, p = s.child; v > 0; ) {
      var h = p.right;
      p.left.right = p.right, p.right.left = p.left, p.left = l, p.right = l.right, l.right = p, p.right.left = p, p.parent = null, p = h, v--;
    }
    return s.left.right = s.right, s.right.left = s.left, s === s.right ? l = null : (l = s.right, l = o(l, this._size)), this._size--, this._minimum = l, s;
  }, a.prototype.remove = function(s) {
    this._minimum = i(this._minimum, s, -1), this.extractMinimum();
  };
  function i(s, l, v) {
    l.key = v;
    var p = l.parent;
    return p && e(l.key, p.key) && (u(s, l, p), f(s, p)), e(l.key, s.key) && (s = l), s;
  }
  function u(s, l, v) {
    l.left.right = l.right, l.right.left = l.left, v.degree--, v.child === l && (v.child = l.right), v.degree === 0 && (v.child = null), l.left = s, l.right = s.right, s.right = l, l.right.left = l, l.parent = null, l.mark = !1;
  }
  function f(s, l) {
    var v = l.parent;
    v && (l.mark ? (u(s, l, v), f(v)) : l.mark = !0);
  }
  var c = function(l, v) {
    l.left.right = l.right, l.right.left = l.left, l.parent = v, v.child ? (l.left = v.child, l.right = v.child.right, v.child.right = l, l.right.left = l) : (v.child = l, l.right = l, l.left = l), v.degree++, l.mark = !1;
  };
  function o(s, l) {
    var v = Math.floor(Math.log(l) * n) + 1, p = new Array(v), h = 0, d = s;
    if (d)
      for (h++, d = d.right; d !== s; )
        h++, d = d.right;
    for (var x; h > 0; ) {
      for (var g = d.degree, y = d.right; x = p[g], !!x; ) {
        if (t(d.key, x.key)) {
          var m = x;
          x = d, d = m;
        }
        c(x, d), p[g] = null, g++;
      }
      p[g] = d, d = y, h--;
    }
    s = null;
    for (var b = 0; b < v; b++)
      x = p[b], x && (s ? (x.left.right = x.right, x.right.left = x.left, x.left = s, x.right = s.right, s.right = x, x.right.left = x, e(x.key, s.key) && (s = x)) : s = x);
    return s;
  }
  return a;
}, {
  isClass: !0
}), YF = "Spa", ZF = ["addScalar", "equalScalar", "FibonacciHeap"], Ul = /* @__PURE__ */ U(YF, ZF, (r) => {
  var {
    addScalar: e,
    equalScalar: t,
    FibonacciHeap: n
  } = r;
  function a() {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new n();
  }
  return a.prototype.type = "Spa", a.prototype.isSpa = !0, a.prototype.set = function(i, u) {
    if (this._values[i])
      this._values[i].value = u;
    else {
      var f = this._heap.insert(i, u);
      this._values[i] = f;
    }
  }, a.prototype.get = function(i) {
    var u = this._values[i];
    return u ? u.value : 0;
  }, a.prototype.accumulate = function(i, u) {
    var f = this._values[i];
    f ? f.value = e(f.value, u) : (f = this._heap.insert(i, u), this._values[i] = f);
  }, a.prototype.forEach = function(i, u, f) {
    var c = this._heap, o = this._values, s = [], l = c.extractMinimum();
    for (l && s.push(l); l && l.key <= u; )
      l.key >= i && (t(l.value, 0) || f(l.key, l.value, this)), l = c.extractMinimum(), l && s.push(l);
    for (var v = 0; v < s.length; v++) {
      var p = s[v];
      l = c.insert(p.key, p.value), o[l.key] = l;
    }
  }, a.prototype.swap = function(i, u) {
    var f = this._values[i], c = this._values[u];
    if (!f && c)
      f = this._heap.insert(i, c.value), this._heap.remove(c), this._values[i] = f, this._values[u] = void 0;
    else if (f && !c)
      c = this._heap.insert(u, f.value), this._heap.remove(f), this._values[u] = c, this._values[i] = void 0;
    else if (f && c) {
      var o = f.value;
      f.value = c.value, c.value = o;
    }
  }, a;
}, {
  isClass: !0
}), WF = co(function(r) {
  return new r(1).exp();
}, {
  hasher: kl
}), KF = co(function(r) {
  return new r(1).plus(new r(5).sqrt()).div(2);
}, {
  hasher: kl
}), Nh = co(function(r) {
  return r.acos(-1);
}, {
  hasher: kl
}), JF = co(function(r) {
  return Nh(r).times(2);
}, {
  hasher: kl
});
function kl(r) {
  return r[0].precision;
}
function kA(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Dm(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kA(Object(t), !0).forEach(function(n) {
      Gr(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : kA(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var _F = "Unit", $F = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], Xl = /* @__PURE__ */ U(_F, $F, (r) => {
  var {
    on: e,
    config: t,
    addScalar: n,
    subtractScalar: a,
    multiplyScalar: i,
    divideScalar: u,
    pow: f,
    abs: c,
    fix: o,
    round: s,
    equal: l,
    isNumeric: v,
    format: p,
    number: h,
    Complex: d,
    BigNumber: x,
    Fraction: g
  } = r, y = h;
  function m(j, Y) {
    if (!(this instanceof m))
      throw new Error("Constructor must be called with the new operator");
    if (!(j == null || v(j) || Wt(j)))
      throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = !1, this.skipAutomaticSimplification = !0, Y === void 0)
      this.units = [], this.dimensions = H.map((V) => 0);
    else if (typeof Y == "string") {
      var ie = m.parse(Y);
      this.units = ie.units, this.dimensions = ie.dimensions;
    } else if (yt(Y) && Y.value === null)
      this.fixPrefix = Y.fixPrefix, this.skipAutomaticSimplification = Y.skipAutomaticSimplification, this.dimensions = Y.dimensions.slice(0), this.units = Y.units.map((V) => Lr({}, V));
    else
      throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
    this.value = this._normalize(j);
  }
  Object.defineProperty(m, "name", {
    value: "Unit"
  }), m.prototype.constructor = m, m.prototype.type = "Unit", m.prototype.isUnit = !0;
  var b, w, A;
  function E() {
    for (; A === " " || A === "	"; )
      D();
  }
  function N(j) {
    return j >= "0" && j <= "9" || j === ".";
  }
  function C(j) {
    return j >= "0" && j <= "9";
  }
  function D() {
    w++, A = b.charAt(w);
  }
  function B(j) {
    w = j, A = b.charAt(w);
  }
  function S() {
    var j = "", Y = w;
    if (A === "+" ? D() : A === "-" && (j += A, D()), !N(A))
      return B(Y), null;
    if (A === ".") {
      if (j += A, D(), !C(A))
        return B(Y), null;
    } else {
      for (; C(A); )
        j += A, D();
      A === "." && (j += A, D());
    }
    for (; C(A); )
      j += A, D();
    if (A === "E" || A === "e") {
      var ie = "", V = w;
      if (ie += A, D(), (A === "+" || A === "-") && (ie += A, D()), !C(A))
        return B(V), j;
      for (j = j + ie; C(A); )
        j += A, D();
    }
    return j;
  }
  function F() {
    for (var j = ""; C(A) || m.isValidAlpha(A); )
      j += A, D();
    var Y = j.charAt(0);
    return m.isValidAlpha(Y) ? j : null;
  }
  function I(j) {
    return A === j ? (D(), j) : null;
  }
  m.parse = function(j, Y) {
    if (Y = Y || {}, b = j, w = -1, A = "", typeof b != "string")
      throw new TypeError("Invalid argument in Unit.parse, string expected");
    var ie = new m();
    ie.units = [];
    var V = 1, J = !1;
    D(), E();
    var $ = S(), pe = null;
    if ($) {
      if (t.number === "BigNumber")
        pe = new x($);
      else if (t.number === "Fraction")
        try {
          pe = new g($);
        } catch {
          pe = parseFloat($);
        }
      else
        pe = parseFloat($);
      E(), I("*") ? (V = 1, J = !0) : I("/") && (V = -1, J = !0);
    }
    for (var ve = [], q = 1; ; ) {
      for (E(); A === "("; )
        ve.push(V), q *= V, V = 1, D(), E();
      var G = void 0;
      if (A) {
        var ee = A;
        if (G = F(), G === null)
          throw new SyntaxError('Unexpected "' + ee + '" in "' + b + '" at index ' + w.toString());
      } else
        break;
      var se = z(G);
      if (se === null)
        throw new SyntaxError('Unit "' + G + '" not found.');
      var de = V * q;
      if (E(), I("^")) {
        E();
        var me = S();
        if (me === null)
          throw new SyntaxError('In "' + j + '", "^" must be followed by a floating-point number');
        de *= me;
      }
      ie.units.push({
        unit: se.unit,
        prefix: se.prefix,
        power: de
      });
      for (var be = 0; be < H.length; be++)
        ie.dimensions[be] += (se.unit.dimensions[be] || 0) * de;
      for (E(); A === ")"; ) {
        if (ve.length === 0)
          throw new SyntaxError('Unmatched ")" in "' + b + '" at index ' + w.toString());
        q /= ve.pop(), D(), E();
      }
      if (J = !1, I("*") ? (V = 1, J = !0) : I("/") ? (V = -1, J = !0) : V = 1, se.unit.base) {
        var xe = se.unit.base.key;
        _.auto[xe] = {
          unit: se.unit,
          prefix: se.prefix
        };
      }
    }
    if (E(), A)
      throw new SyntaxError('Could not parse: "' + j + '"');
    if (J)
      throw new SyntaxError('Trailing characters: "' + j + '"');
    if (ve.length !== 0)
      throw new SyntaxError('Unmatched "(" in "' + b + '"');
    if (ie.units.length === 0 && !Y.allowNoUnits)
      throw new SyntaxError('"' + j + '" contains no units');
    return ie.value = pe !== void 0 ? ie._normalize(pe) : null, ie;
  }, m.prototype.clone = function() {
    var j = new m();
    j.fixPrefix = this.fixPrefix, j.skipAutomaticSimplification = this.skipAutomaticSimplification, j.value = Ie(this.value), j.dimensions = this.dimensions.slice(0), j.units = [];
    for (var Y = 0; Y < this.units.length; Y++) {
      j.units[Y] = {};
      for (var ie in this.units[Y])
        Pe(this.units[Y], ie) && (j.units[Y][ie] = this.units[Y][ie]);
    }
    return j;
  }, m.prototype.valueType = function() {
    return br(this.value);
  }, m.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, m.prototype._normalize = function(j) {
    if (j == null || this.units.length === 0)
      return j;
    for (var Y = j, ie = m._getNumberConverter(br(j)), V = 0; V < this.units.length; V++) {
      var J = ie(this.units[V].unit.value), $ = ie(this.units[V].prefix.value), pe = ie(this.units[V].power);
      Y = i(Y, f(i(J, $), pe));
    }
    return Y;
  }, m.prototype._denormalize = function(j, Y) {
    if (j == null || this.units.length === 0)
      return j;
    for (var ie = j, V = m._getNumberConverter(br(j)), J = 0; J < this.units.length; J++) {
      var $ = V(this.units[J].unit.value), pe = V(this.units[J].prefix.value), ve = V(this.units[J].power);
      ie = u(ie, f(i($, pe), ve));
    }
    return ie;
  };
  var z = co((j) => {
    if (Pe(R, j)) {
      var Y = R[j], ie = Y.prefixes[""];
      return {
        unit: Y,
        prefix: ie
      };
    }
    for (var V in R)
      if (Pe(R, V) && E7(j, V)) {
        var J = R[V], $ = j.length - V.length, pe = j.substring(0, $), ve = Pe(J.prefixes, pe) ? J.prefixes[pe] : void 0;
        if (ve !== void 0)
          return {
            unit: J,
            prefix: ve
          };
      }
    return null;
  }, {
    hasher: (j) => j[0],
    limit: 100
  });
  m.isValuelessUnit = function(j) {
    return z(j) !== null;
  }, m.prototype.hasBase = function(j) {
    if (typeof j == "string" && (j = O[j]), !j)
      return !1;
    for (var Y = 0; Y < H.length; Y++)
      if (Math.abs((this.dimensions[Y] || 0) - (j.dimensions[Y] || 0)) > 1e-12)
        return !1;
    return !0;
  }, m.prototype.equalBase = function(j) {
    for (var Y = 0; Y < H.length; Y++)
      if (Math.abs((this.dimensions[Y] || 0) - (j.dimensions[Y] || 0)) > 1e-12)
        return !1;
    return !0;
  }, m.prototype.equals = function(j) {
    return this.equalBase(j) && l(this.value, j.value);
  }, m.prototype.multiply = function(j) {
    for (var Y = this.clone(), ie = yt(j) ? j : new m(j), V = 0; V < H.length; V++)
      Y.dimensions[V] = (this.dimensions[V] || 0) + (ie.dimensions[V] || 0);
    for (var J = 0; J < ie.units.length; J++) {
      var $ = Dm({}, ie.units[J]);
      Y.units.push($);
    }
    if (this.value !== null || ie.value !== null) {
      var pe = this.value === null ? this._normalize(1) : this.value, ve = ie.value === null ? ie._normalize(1) : ie.value;
      Y.value = i(pe, ve);
    } else
      Y.value = null;
    return yt(j) && (Y.skipAutomaticSimplification = !1), P(Y);
  }, m.prototype.divideInto = function(j) {
    return new m(j).divide(this);
  }, m.prototype.divide = function(j) {
    for (var Y = this.clone(), ie = yt(j) ? j : new m(j), V = 0; V < H.length; V++)
      Y.dimensions[V] = (this.dimensions[V] || 0) - (ie.dimensions[V] || 0);
    for (var J = 0; J < ie.units.length; J++) {
      var $ = Dm(Dm({}, ie.units[J]), {}, {
        power: -ie.units[J].power
      });
      Y.units.push($);
    }
    if (this.value !== null || ie.value !== null) {
      var pe = this.value === null ? this._normalize(1) : this.value, ve = ie.value === null ? ie._normalize(1) : ie.value;
      Y.value = u(pe, ve);
    } else
      Y.value = null;
    return yt(j) && (Y.skipAutomaticSimplification = !1), P(Y);
  }, m.prototype.pow = function(j) {
    for (var Y = this.clone(), ie = 0; ie < H.length; ie++)
      Y.dimensions[ie] = (this.dimensions[ie] || 0) * j;
    for (var V = 0; V < Y.units.length; V++)
      Y.units[V].power *= j;
    return Y.value !== null ? Y.value = f(Y.value, j) : Y.value = null, Y.skipAutomaticSimplification = !1, P(Y);
  };
  function P(j) {
    return j.equalBase(O.NONE) && j.value !== null && !t.predictable ? j.value : j;
  }
  m.prototype.abs = function() {
    var j = this.clone();
    if (j.value !== null)
      if (j._isDerived() || j.units.length === 0 || j.units[0].unit.offset === 0)
        j.value = c(j.value);
      else {
        var Y = j._numberConverter(), ie = Y(j.units[0].unit.value), V = Y(j.units[0].unit.offset), J = i(ie, V);
        j.value = a(c(n(j.value, J)), J);
      }
    for (var $ in j.units)
      (j.units[$].unit.name === "VA" || j.units[$].unit.name === "VAR") && (j.units[$].unit = R.W);
    return j;
  }, m.prototype.to = function(j) {
    var Y = this.value === null ? this._normalize(1) : this.value, ie;
    if (typeof j == "string")
      ie = m.parse(j);
    else if (yt(j))
      ie = j.clone();
    else
      throw new Error("String or Unit expected as parameter");
    if (!this.equalBase(ie))
      throw new Error("Units do not match ('".concat(ie.toString(), "' != '").concat(this.toString(), "')"));
    if (ie.value !== null)
      throw new Error("Cannot convert to a unit with a value");
    if (this.value === null || this._isDerived() || this.units.length === 0 || ie.units.length === 0 || this.units[0].unit.offset === ie.units[0].unit.offset)
      ie.value = Ie(Y);
    else {
      var V = m._getNumberConverter(br(Y)), J = this.units[0].unit.value, $ = this.units[0].unit.offset, pe = i(J, $), ve = ie.units[0].unit.value, q = ie.units[0].unit.offset, G = i(ve, q);
      ie.value = n(Y, V(a(pe, G)));
    }
    return ie.fixPrefix = !0, ie.skipAutomaticSimplification = !0, ie;
  }, m.prototype.toNumber = function(j) {
    return y(this.toNumeric(j));
  }, m.prototype.toNumeric = function(j) {
    var Y;
    return j ? Y = this.to(j) : Y = this.clone(), Y._isDerived() || Y.units.length === 0 ? Y._denormalize(Y.value) : Y._denormalize(Y.value, Y.units[0].prefix.value);
  }, m.prototype.toString = function() {
    return this.format();
  }, m.prototype.toJSON = function() {
    return {
      mathjs: "Unit",
      value: this._denormalize(this.value),
      unit: this.units.length > 0 ? this.formatUnits() : null,
      fixPrefix: this.fixPrefix
    };
  }, m.fromJSON = function(j) {
    var Y, ie = new m(j.value, (Y = j.unit) !== null && Y !== void 0 ? Y : void 0);
    return ie.fixPrefix = j.fixPrefix || !1, ie;
  }, m.prototype.valueOf = m.prototype.toString, m.prototype.simplify = function() {
    var j = this.clone(), Y = [], ie;
    for (var V in re)
      if (Pe(re, V) && j.hasBase(O[V])) {
        ie = V;
        break;
      }
    if (ie === "NONE")
      j.units = [];
    else {
      var J;
      if (ie && Pe(re, ie) && (J = re[ie]), J)
        j.units = [{
          unit: J.unit,
          prefix: J.prefix,
          power: 1
        }];
      else {
        for (var $ = !1, pe = 0; pe < H.length; pe++) {
          var ve = H[pe];
          Math.abs(j.dimensions[pe] || 0) > 1e-12 && (Pe(re, ve) ? Y.push({
            unit: re[ve].unit,
            prefix: re[ve].prefix,
            power: j.dimensions[pe] || 0
          }) : $ = !0);
        }
        Y.length < j.units.length && !$ && (j.units = Y);
      }
    }
    return j;
  }, m.prototype.toSI = function() {
    for (var j = this.clone(), Y = [], ie = 0; ie < H.length; ie++) {
      var V = H[ie];
      if (Math.abs(j.dimensions[ie] || 0) > 1e-12)
        if (Pe(_.si, V))
          Y.push({
            unit: _.si[V].unit,
            prefix: _.si[V].prefix,
            power: j.dimensions[ie] || 0
          });
        else
          throw new Error("Cannot express custom unit " + V + " in SI units");
    }
    return j.units = Y, j.fixPrefix = !0, j.skipAutomaticSimplification = !0, this.value !== null ? (j.value = null, this.to(j)) : j;
  }, m.prototype.formatUnits = function() {
    for (var j = "", Y = "", ie = 0, V = 0, J = 0; J < this.units.length; J++)
      this.units[J].power > 0 ? (ie++, j += " " + this.units[J].prefix.name + this.units[J].unit.name, Math.abs(this.units[J].power - 1) > 1e-15 && (j += "^" + this.units[J].power)) : this.units[J].power < 0 && V++;
    if (V > 0)
      for (var $ = 0; $ < this.units.length; $++)
        this.units[$].power < 0 && (ie > 0 ? (Y += " " + this.units[$].prefix.name + this.units[$].unit.name, Math.abs(this.units[$].power + 1) > 1e-15 && (Y += "^" + -this.units[$].power)) : (Y += " " + this.units[$].prefix.name + this.units[$].unit.name, Y += "^" + this.units[$].power));
    j = j.substr(1), Y = Y.substr(1), ie > 1 && V > 0 && (j = "(" + j + ")"), V > 1 && ie > 0 && (Y = "(" + Y + ")");
    var pe = j;
    return ie > 0 && V > 0 && (pe += " / "), pe += Y, pe;
  }, m.prototype.format = function(j) {
    var Y = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(), ie = !1;
    typeof Y.value < "u" && Y.value !== null && Wt(Y.value) && (ie = Math.abs(Y.value.re) < 1e-14);
    for (var V in Y.units)
      Pe(Y.units, V) && Y.units[V].unit && (Y.units[V].unit.name === "VA" && ie ? Y.units[V].unit = R.VAR : Y.units[V].unit.name === "VAR" && !ie && (Y.units[V].unit = R.VA));
    Y.units.length === 1 && !Y.fixPrefix && Math.abs(Y.units[0].power - Math.round(Y.units[0].power)) < 1e-14 && (Y.units[0].prefix = Y._bestPrefix());
    var J = Y._denormalize(Y.value), $ = Y.value !== null ? p(J, j || {}) : "", pe = Y.formatUnits();
    return Y.value && Wt(Y.value) && ($ = "(" + $ + ")"), pe.length > 0 && $.length > 0 && ($ += " "), $ += pe, $;
  }, m.prototype._bestPrefix = function() {
    if (this.units.length !== 1)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var j = this.value !== null ? c(this.value) : 0, Y = c(this.units[0].unit.value), ie = this.units[0].prefix;
    if (j === 0)
      return ie;
    var V = this.units[0].power, J = Math.log(j / Math.pow(ie.value * Y, V)) / Math.LN10 - 1.2;
    if (J > -2.200001 && J < 1.800001)
      return ie;
    J = Math.abs(J);
    var $ = this.units[0].unit.prefixes;
    for (var pe in $)
      if (Pe($, pe)) {
        var ve = $[pe];
        if (ve.scientific) {
          var q = Math.abs(Math.log(j / Math.pow(ve.value * Y, V)) / Math.LN10 - 1.2);
          (q < J || q === J && ve.name.length < ie.name.length) && (ie = ve, J = q);
        }
      }
    return ie;
  }, m.prototype.splitUnit = function(j) {
    for (var Y = this.clone(), ie = [], V = 0; V < j.length && (Y = Y.to(j[V]), V !== j.length - 1); V++) {
      var J = Y.toNumeric(), $ = s(J), pe = void 0, ve = l($, J);
      ve ? pe = $ : pe = o(Y.toNumeric());
      var q = new m(pe, j[V].toString());
      ie.push(q), Y = a(Y, q);
    }
    for (var G = 0, ee = 0; ee < ie.length; ee++)
      G = n(G, ie[ee].value);
    return l(G, this.value) && (Y.value = 0), ie.push(Y), ie;
  };
  var M = {
    NONE: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      }
    },
    SHORT: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 10,
        scientific: !1
      },
      h: {
        name: "h",
        value: 100,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e27,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e30,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.1,
        scientific: !1
      },
      c: {
        name: "c",
        value: 0.01,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-3,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-6,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-9,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-12,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-15,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-18,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-21,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-24,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-27,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-30,
        scientific: !0
      }
    },
    LONG: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      deca: {
        name: "deca",
        value: 10,
        scientific: !1
      },
      hecto: {
        name: "hecto",
        value: 100,
        scientific: !1
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      },
      ronna: {
        name: "ronna",
        value: 1e27,
        scientific: !0
      },
      quetta: {
        name: "quetta",
        value: 1e30,
        scientific: !0
      },
      deci: {
        name: "deci",
        value: 0.1,
        scientific: !1
      },
      centi: {
        name: "centi",
        value: 0.01,
        scientific: !1
      },
      milli: {
        name: "milli",
        value: 1e-3,
        scientific: !0
      },
      micro: {
        name: "micro",
        value: 1e-6,
        scientific: !0
      },
      nano: {
        name: "nano",
        value: 1e-9,
        scientific: !0
      },
      pico: {
        name: "pico",
        value: 1e-12,
        scientific: !0
      },
      femto: {
        name: "femto",
        value: 1e-15,
        scientific: !0
      },
      atto: {
        name: "atto",
        value: 1e-18,
        scientific: !0
      },
      zepto: {
        name: "zepto",
        value: 1e-21,
        scientific: !0
      },
      yocto: {
        name: "yocto",
        value: 1e-24,
        scientific: !0
      },
      ronto: {
        name: "ronto",
        value: 1e-27,
        scientific: !0
      },
      quecto: {
        name: "quecto",
        value: 1e-30,
        scientific: !0
      }
    },
    SQUARED: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 100,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e4,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e6,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e12,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e18,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e24,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e30,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e36,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e42,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e48,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e54,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e60,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.01,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-4,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-6,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-12,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-18,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-24,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-30,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-36,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-42,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-48,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-54,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-60,
        scientific: !0
      }
    },
    CUBIC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 1e3,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e6,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e9,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e18,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e27,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e36,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e45,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e54,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e63,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e72,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e81,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e90,
        scientific: !0
      },
      d: {
        name: "d",
        value: 1e-3,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-6,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-9,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-18,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-27,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-36,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-45,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-54,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-63,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-72,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-81,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-90,
        scientific: !0
      }
    },
    BINARY_SHORT_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_SHORT_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      Ki: {
        name: "Ki",
        value: 1024,
        scientific: !0
      },
      Mi: {
        name: "Mi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      Gi: {
        name: "Gi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      Ti: {
        name: "Ti",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      Pi: {
        name: "Pi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      Ei: {
        name: "Ei",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      Zi: {
        name: "Zi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      Yi: {
        name: "Yi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BINARY_LONG_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_LONG_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kibi: {
        name: "kibi",
        value: 1024,
        scientific: !0
      },
      mebi: {
        name: "mebi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      gibi: {
        name: "gibi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      tebi: {
        name: "tebi",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      pebi: {
        name: "pebi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      exi: {
        name: "exi",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      zebi: {
        name: "zebi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      yobi: {
        name: "yobi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BTU: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      MM: {
        name: "MM",
        value: 1e6,
        scientific: !0
      }
    }
  };
  M.SHORTLONG = Lr({}, M.SHORT, M.LONG), M.BINARY_SHORT = Lr({}, M.BINARY_SHORT_SI, M.BINARY_SHORT_IEC), M.BINARY_LONG = Lr({}, M.BINARY_LONG_SI, M.BINARY_LONG_IEC);
  var H = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], O = {
    NONE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    MASS: {
      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    LENGTH: {
      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
    },
    TIME: {
      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    CURRENT: {
      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    TEMPERATURE: {
      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
    },
    LUMINOUS_INTENSITY: {
      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
    },
    AMOUNT_OF_SUBSTANCE: {
      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
    },
    FORCE: {
      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
    },
    SURFACE: {
      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
    },
    VOLUME: {
      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
    },
    ENERGY: {
      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
    },
    POWER: {
      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
    },
    PRESSURE: {
      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CHARGE: {
      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CAPACITANCE: {
      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_POTENTIAL: {
      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_RESISTANCE: {
      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_INDUCTANCE: {
      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CONDUCTANCE: {
      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX: {
      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX_DENSITY: {
      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
    },
    FREQUENCY: {
      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
    },
    ANGLE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
    },
    BIT: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
    }
  };
  for (var Q in O)
    Pe(O, Q) && (O[Q].key = Q);
  var k = {}, L = {
    name: "",
    base: k,
    value: 1,
    offset: 0,
    dimensions: H.map((j) => 0)
  }, R = {
    // length
    meter: {
      name: "meter",
      base: O.LENGTH,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    inch: {
      name: "inch",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.0254,
      offset: 0
    },
    foot: {
      name: "foot",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.3048,
      offset: 0
    },
    yard: {
      name: "yard",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.9144,
      offset: 0
    },
    mile: {
      name: "mile",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 1609.344,
      offset: 0
    },
    link: {
      name: "link",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.201168,
      offset: 0
    },
    rod: {
      name: "rod",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 5.0292,
      offset: 0
    },
    chain: {
      name: "chain",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 20.1168,
      offset: 0
    },
    angstrom: {
      name: "angstrom",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 1e-10,
      offset: 0
    },
    m: {
      name: "m",
      base: O.LENGTH,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    in: {
      name: "in",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.0254,
      offset: 0
    },
    ft: {
      name: "ft",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.3048,
      offset: 0
    },
    yd: {
      name: "yd",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.9144,
      offset: 0
    },
    mi: {
      name: "mi",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 1609.344,
      offset: 0
    },
    li: {
      name: "li",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 0.201168,
      offset: 0
    },
    rd: {
      name: "rd",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 5.02921,
      offset: 0
    },
    ch: {
      name: "ch",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 20.1168,
      offset: 0
    },
    mil: {
      name: "mil",
      base: O.LENGTH,
      prefixes: M.NONE,
      value: 254e-7,
      offset: 0
    },
    // 1/1000 inch
    // Surface
    m2: {
      name: "m2",
      base: O.SURFACE,
      prefixes: M.SQUARED,
      value: 1,
      offset: 0
    },
    sqin: {
      name: "sqin",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 64516e-8,
      offset: 0
    },
    // 645.16 mm2
    sqft: {
      name: "sqft",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 0.09290304,
      offset: 0
    },
    // 0.09290304 m2
    sqyd: {
      name: "sqyd",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 0.83612736,
      offset: 0
    },
    // 0.83612736 m2
    sqmi: {
      name: "sqmi",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 2589988110336e-6,
      offset: 0
    },
    // 2.589988110336 km2
    sqrd: {
      name: "sqrd",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 25.29295,
      offset: 0
    },
    // 25.29295 m2
    sqch: {
      name: "sqch",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 404.6873,
      offset: 0
    },
    // 404.6873 m2
    sqmil: {
      name: "sqmil",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 64516e-14,
      offset: 0
    },
    // 6.4516 * 10^-10 m2
    acre: {
      name: "acre",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 4046.86,
      offset: 0
    },
    // 4046.86 m2
    hectare: {
      name: "hectare",
      base: O.SURFACE,
      prefixes: M.NONE,
      value: 1e4,
      offset: 0
    },
    // 10000 m2
    // Volume
    m3: {
      name: "m3",
      base: O.VOLUME,
      prefixes: M.CUBIC,
      value: 1,
      offset: 0
    },
    L: {
      name: "L",
      base: O.VOLUME,
      prefixes: M.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    l: {
      name: "l",
      base: O.VOLUME,
      prefixes: M.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    litre: {
      name: "litre",
      base: O.VOLUME,
      prefixes: M.LONG,
      value: 1e-3,
      offset: 0
    },
    cuin: {
      name: "cuin",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 16387064e-12,
      offset: 0
    },
    // 1.6387064e-5 m3
    cuft: {
      name: "cuft",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.028316846592,
      offset: 0
    },
    // 28.316 846 592 L
    cuyd: {
      name: "cuyd",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.764554857984,
      offset: 0
    },
    // 764.554 857 984 L
    teaspoon: {
      name: "teaspoon",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 5e-6,
      offset: 0
    },
    // 5 mL
    tablespoon: {
      name: "tablespoon",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 15e-6,
      offset: 0
    },
    // 15 mL
    // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
    drop: {
      name: "drop",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    gtt: {
      name: "gtt",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    // Liquid volume
    minim: {
      name: "minim",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 6161152e-14,
      offset: 0
    },
    // 0.06161152 mL
    fluiddram: {
      name: "fluiddram",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    fluidounce: {
      name: "fluidounce",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gill: {
      name: "gill",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cc: {
      name: "cc",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 1e-6,
      offset: 0
    },
    // 1e-6 L
    cup: {
      name: "cup",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pint: {
      name: "pint",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    quart: {
      name: "quart",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gallon: {
      name: "gallon",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    beerbarrel: {
      name: "beerbarrel",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    oilbarrel: {
      name: "oilbarrel",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    hogshead: {
      name: "hogshead",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.238481,
      offset: 0
    },
    // 238.4810 L
    // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
    fldr: {
      name: "fldr",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    floz: {
      name: "floz",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gi: {
      name: "gi",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cp: {
      name: "cp",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pt: {
      name: "pt",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    qt: {
      name: "qt",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gal: {
      name: "gal",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    bbl: {
      name: "bbl",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    obl: {
      name: "obl",
      base: O.VOLUME,
      prefixes: M.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
    // Mass
    g: {
      name: "g",
      base: O.MASS,
      prefixes: M.SHORT,
      value: 1e-3,
      offset: 0
    },
    gram: {
      name: "gram",
      base: O.MASS,
      prefixes: M.LONG,
      value: 1e-3,
      offset: 0
    },
    ton: {
      name: "ton",
      base: O.MASS,
      prefixes: M.SHORT,
      value: 907.18474,
      offset: 0
    },
    t: {
      name: "t",
      base: O.MASS,
      prefixes: M.SHORT,
      value: 1e3,
      offset: 0
    },
    tonne: {
      name: "tonne",
      base: O.MASS,
      prefixes: M.LONG,
      value: 1e3,
      offset: 0
    },
    grain: {
      name: "grain",
      base: O.MASS,
      prefixes: M.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dram: {
      name: "dram",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    ounce: {
      name: "ounce",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.028349523125,
      offset: 0
    },
    poundmass: {
      name: "poundmass",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.45359237,
      offset: 0
    },
    hundredweight: {
      name: "hundredweight",
      base: O.MASS,
      prefixes: M.NONE,
      value: 45.359237,
      offset: 0
    },
    stick: {
      name: "stick",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.115,
      offset: 0
    },
    stone: {
      name: "stone",
      base: O.MASS,
      prefixes: M.NONE,
      value: 6.35029318,
      offset: 0
    },
    gr: {
      name: "gr",
      base: O.MASS,
      prefixes: M.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dr: {
      name: "dr",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    oz: {
      name: "oz",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.028349523125,
      offset: 0
    },
    lbm: {
      name: "lbm",
      base: O.MASS,
      prefixes: M.NONE,
      value: 0.45359237,
      offset: 0
    },
    cwt: {
      name: "cwt",
      base: O.MASS,
      prefixes: M.NONE,
      value: 45.359237,
      offset: 0
    },
    // Time
    s: {
      name: "s",
      base: O.TIME,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    min: {
      name: "min",
      base: O.TIME,
      prefixes: M.NONE,
      value: 60,
      offset: 0
    },
    h: {
      name: "h",
      base: O.TIME,
      prefixes: M.NONE,
      value: 3600,
      offset: 0
    },
    second: {
      name: "second",
      base: O.TIME,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    sec: {
      name: "sec",
      base: O.TIME,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    minute: {
      name: "minute",
      base: O.TIME,
      prefixes: M.NONE,
      value: 60,
      offset: 0
    },
    hour: {
      name: "hour",
      base: O.TIME,
      prefixes: M.NONE,
      value: 3600,
      offset: 0
    },
    day: {
      name: "day",
      base: O.TIME,
      prefixes: M.NONE,
      value: 86400,
      offset: 0
    },
    week: {
      name: "week",
      base: O.TIME,
      prefixes: M.NONE,
      value: 7 * 86400,
      offset: 0
    },
    month: {
      name: "month",
      base: O.TIME,
      prefixes: M.NONE,
      value: 2629800,
      // 1/12th of Julian year
      offset: 0
    },
    year: {
      name: "year",
      base: O.TIME,
      prefixes: M.NONE,
      value: 31557600,
      // Julian year
      offset: 0
    },
    decade: {
      name: "decade",
      base: O.TIME,
      prefixes: M.NONE,
      value: 315576e3,
      // Julian decade
      offset: 0
    },
    century: {
      name: "century",
      base: O.TIME,
      prefixes: M.NONE,
      value: 315576e4,
      // Julian century
      offset: 0
    },
    millennium: {
      name: "millennium",
      base: O.TIME,
      prefixes: M.NONE,
      value: 315576e5,
      // Julian millennium
      offset: 0
    },
    // Frequency
    hertz: {
      name: "Hertz",
      base: O.FREQUENCY,
      prefixes: M.LONG,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    Hz: {
      name: "Hz",
      base: O.FREQUENCY,
      prefixes: M.SHORT,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    // Angle
    rad: {
      name: "rad",
      base: O.ANGLE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    radian: {
      name: "radian",
      base: O.ANGLE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
    deg: {
      name: "deg",
      base: O.ANGLE,
      prefixes: M.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    degree: {
      name: "degree",
      base: O.ANGLE,
      prefixes: M.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
    grad: {
      name: "grad",
      base: O.ANGLE,
      prefixes: M.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    gradian: {
      name: "gradian",
      base: O.ANGLE,
      prefixes: M.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
    cycle: {
      name: "cycle",
      base: O.ANGLE,
      prefixes: M.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
    arcsec: {
      name: "arcsec",
      base: O.ANGLE,
      prefixes: M.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
    arcmin: {
      name: "arcmin",
      base: O.ANGLE,
      prefixes: M.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // Electric current
    A: {
      name: "A",
      base: O.CURRENT,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    ampere: {
      name: "ampere",
      base: O.CURRENT,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    // Temperature
    // K(C) = °C + 273.15
    // K(F) = (°F + 459.67) * (5 / 9)
    // K(R) = °R * (5 / 9)
    K: {
      name: "K",
      base: O.TEMPERATURE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    degC: {
      name: "degC",
      base: O.TEMPERATURE,
      prefixes: M.SHORT,
      value: 1,
      offset: 273.15
    },
    degF: {
      name: "degF",
      base: O.TEMPERATURE,
      prefixes: M.SHORT,
      value: new g(5, 9),
      offset: 459.67
    },
    degR: {
      name: "degR",
      base: O.TEMPERATURE,
      prefixes: M.SHORT,
      value: new g(5, 9),
      offset: 0
    },
    kelvin: {
      name: "kelvin",
      base: O.TEMPERATURE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    celsius: {
      name: "celsius",
      base: O.TEMPERATURE,
      prefixes: M.LONG,
      value: 1,
      offset: 273.15
    },
    fahrenheit: {
      name: "fahrenheit",
      base: O.TEMPERATURE,
      prefixes: M.LONG,
      value: new g(5, 9),
      offset: 459.67
    },
    rankine: {
      name: "rankine",
      base: O.TEMPERATURE,
      prefixes: M.LONG,
      value: new g(5, 9),
      offset: 0
    },
    // amount of substance
    mol: {
      name: "mol",
      base: O.AMOUNT_OF_SUBSTANCE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    mole: {
      name: "mole",
      base: O.AMOUNT_OF_SUBSTANCE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    // luminous intensity
    cd: {
      name: "cd",
      base: O.LUMINOUS_INTENSITY,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    candela: {
      name: "candela",
      base: O.LUMINOUS_INTENSITY,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    // TODO: units STERADIAN
    // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // Force
    N: {
      name: "N",
      base: O.FORCE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    newton: {
      name: "newton",
      base: O.FORCE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    dyn: {
      name: "dyn",
      base: O.FORCE,
      prefixes: M.SHORT,
      value: 1e-5,
      offset: 0
    },
    dyne: {
      name: "dyne",
      base: O.FORCE,
      prefixes: M.LONG,
      value: 1e-5,
      offset: 0
    },
    lbf: {
      name: "lbf",
      base: O.FORCE,
      prefixes: M.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    poundforce: {
      name: "poundforce",
      base: O.FORCE,
      prefixes: M.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    kip: {
      name: "kip",
      base: O.FORCE,
      prefixes: M.LONG,
      value: 4448.2216,
      offset: 0
    },
    kilogramforce: {
      name: "kilogramforce",
      base: O.FORCE,
      prefixes: M.NONE,
      value: 9.80665,
      offset: 0
    },
    // Energy
    J: {
      name: "J",
      base: O.ENERGY,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    joule: {
      name: "joule",
      base: O.ENERGY,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    erg: {
      name: "erg",
      base: O.ENERGY,
      prefixes: M.SHORTLONG,
      // Both kiloerg and kerg are acceptable
      value: 1e-7,
      offset: 0
    },
    Wh: {
      name: "Wh",
      base: O.ENERGY,
      prefixes: M.SHORT,
      value: 3600,
      offset: 0
    },
    BTU: {
      name: "BTU",
      base: O.ENERGY,
      prefixes: M.BTU,
      value: 1055.05585262,
      offset: 0
    },
    eV: {
      name: "eV",
      base: O.ENERGY,
      prefixes: M.SHORT,
      value: 1602176565e-28,
      offset: 0
    },
    electronvolt: {
      name: "electronvolt",
      base: O.ENERGY,
      prefixes: M.LONG,
      value: 1602176565e-28,
      offset: 0
    },
    // Power
    W: {
      name: "W",
      base: O.POWER,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    watt: {
      name: "watt",
      base: O.POWER,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    hp: {
      name: "hp",
      base: O.POWER,
      prefixes: M.NONE,
      value: 745.6998715386,
      offset: 0
    },
    // Electrical power units
    VAR: {
      name: "VAR",
      base: O.POWER,
      prefixes: M.SHORT,
      value: d.I,
      offset: 0
    },
    VA: {
      name: "VA",
      base: O.POWER,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Pressure
    Pa: {
      name: "Pa",
      base: O.PRESSURE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    psi: {
      name: "psi",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 6894.75729276459,
      offset: 0
    },
    atm: {
      name: "atm",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 101325,
      offset: 0
    },
    bar: {
      name: "bar",
      base: O.PRESSURE,
      prefixes: M.SHORTLONG,
      value: 1e5,
      offset: 0
    },
    torr: {
      name: "torr",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 133.322,
      offset: 0
    },
    mmHg: {
      name: "mmHg",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 133.322,
      offset: 0
    },
    mmH2O: {
      name: "mmH2O",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 9.80665,
      offset: 0
    },
    cmH2O: {
      name: "cmH2O",
      base: O.PRESSURE,
      prefixes: M.NONE,
      value: 98.0665,
      offset: 0
    },
    // Electric charge
    coulomb: {
      name: "coulomb",
      base: O.ELECTRIC_CHARGE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    C: {
      name: "C",
      base: O.ELECTRIC_CHARGE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Electric capacitance
    farad: {
      name: "farad",
      base: O.ELECTRIC_CAPACITANCE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    F: {
      name: "F",
      base: O.ELECTRIC_CAPACITANCE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Electric potential
    volt: {
      name: "volt",
      base: O.ELECTRIC_POTENTIAL,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    V: {
      name: "V",
      base: O.ELECTRIC_POTENTIAL,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Electric resistance
    ohm: {
      name: "ohm",
      base: O.ELECTRIC_RESISTANCE,
      prefixes: M.SHORTLONG,
      // Both Mohm and megaohm are acceptable
      value: 1,
      offset: 0
    },
    /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */
    // Electric inductance
    henry: {
      name: "henry",
      base: O.ELECTRIC_INDUCTANCE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    H: {
      name: "H",
      base: O.ELECTRIC_INDUCTANCE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Electric conductance
    siemens: {
      name: "siemens",
      base: O.ELECTRIC_CONDUCTANCE,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    S: {
      name: "S",
      base: O.ELECTRIC_CONDUCTANCE,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux
    weber: {
      name: "weber",
      base: O.MAGNETIC_FLUX,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    Wb: {
      name: "Wb",
      base: O.MAGNETIC_FLUX,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux density
    tesla: {
      name: "tesla",
      base: O.MAGNETIC_FLUX_DENSITY,
      prefixes: M.LONG,
      value: 1,
      offset: 0
    },
    T: {
      name: "T",
      base: O.MAGNETIC_FLUX_DENSITY,
      prefixes: M.SHORT,
      value: 1,
      offset: 0
    },
    // Binary
    b: {
      name: "b",
      base: O.BIT,
      prefixes: M.BINARY_SHORT,
      value: 1,
      offset: 0
    },
    bits: {
      name: "bits",
      base: O.BIT,
      prefixes: M.BINARY_LONG,
      value: 1,
      offset: 0
    },
    B: {
      name: "B",
      base: O.BIT,
      prefixes: M.BINARY_SHORT,
      value: 8,
      offset: 0
    },
    bytes: {
      name: "bytes",
      base: O.BIT,
      prefixes: M.BINARY_LONG,
      value: 8,
      offset: 0
    }
  }, X = {
    meters: "meter",
    inches: "inch",
    feet: "foot",
    yards: "yard",
    miles: "mile",
    links: "link",
    rods: "rod",
    chains: "chain",
    angstroms: "angstrom",
    lt: "l",
    litres: "litre",
    liter: "litre",
    liters: "litre",
    teaspoons: "teaspoon",
    tablespoons: "tablespoon",
    minims: "minim",
    fluiddrams: "fluiddram",
    fluidounces: "fluidounce",
    gills: "gill",
    cups: "cup",
    pints: "pint",
    quarts: "quart",
    gallons: "gallon",
    beerbarrels: "beerbarrel",
    oilbarrels: "oilbarrel",
    hogsheads: "hogshead",
    gtts: "gtt",
    grams: "gram",
    tons: "ton",
    tonnes: "tonne",
    grains: "grain",
    drams: "dram",
    ounces: "ounce",
    poundmasses: "poundmass",
    hundredweights: "hundredweight",
    sticks: "stick",
    lb: "lbm",
    lbs: "lbm",
    kips: "kip",
    kgf: "kilogramforce",
    acres: "acre",
    hectares: "hectare",
    sqfeet: "sqft",
    sqyard: "sqyd",
    sqmile: "sqmi",
    sqmiles: "sqmi",
    mmhg: "mmHg",
    mmh2o: "mmH2O",
    cmh2o: "cmH2O",
    seconds: "second",
    secs: "second",
    minutes: "minute",
    mins: "minute",
    hours: "hour",
    hr: "hour",
    hrs: "hour",
    days: "day",
    weeks: "week",
    months: "month",
    years: "year",
    decades: "decade",
    centuries: "century",
    millennia: "millennium",
    hertz: "hertz",
    radians: "radian",
    degrees: "degree",
    gradians: "gradian",
    cycles: "cycle",
    arcsecond: "arcsec",
    arcseconds: "arcsec",
    arcminute: "arcmin",
    arcminutes: "arcmin",
    BTUs: "BTU",
    watts: "watt",
    joules: "joule",
    amperes: "ampere",
    amps: "ampere",
    amp: "ampere",
    coulombs: "coulomb",
    volts: "volt",
    ohms: "ohm",
    farads: "farad",
    webers: "weber",
    teslas: "tesla",
    electronvolts: "electronvolt",
    moles: "mole",
    bit: "bits",
    byte: "bytes"
  };
  function ae(j) {
    if (j.number === "BigNumber") {
      var Y = Nh(x);
      R.rad.value = new x(1), R.deg.value = Y.div(180), R.grad.value = Y.div(200), R.cycle.value = Y.times(2), R.arcsec.value = Y.div(648e3), R.arcmin.value = Y.div(10800);
    } else
      R.rad.value = 1, R.deg.value = Math.PI / 180, R.grad.value = Math.PI / 200, R.cycle.value = Math.PI * 2, R.arcsec.value = Math.PI / 648e3, R.arcmin.value = Math.PI / 10800;
    R.radian.value = R.rad.value, R.degree.value = R.deg.value, R.gradian.value = R.grad.value;
  }
  ae(t), e && e("config", function(j, Y) {
    j.number !== Y.number && ae(j);
  });
  var _ = {
    si: {
      // Base units
      NONE: {
        unit: L,
        prefix: M.NONE[""]
      },
      LENGTH: {
        unit: R.m,
        prefix: M.SHORT[""]
      },
      MASS: {
        unit: R.g,
        prefix: M.SHORT.k
      },
      TIME: {
        unit: R.s,
        prefix: M.SHORT[""]
      },
      CURRENT: {
        unit: R.A,
        prefix: M.SHORT[""]
      },
      TEMPERATURE: {
        unit: R.K,
        prefix: M.SHORT[""]
      },
      LUMINOUS_INTENSITY: {
        unit: R.cd,
        prefix: M.SHORT[""]
      },
      AMOUNT_OF_SUBSTANCE: {
        unit: R.mol,
        prefix: M.SHORT[""]
      },
      ANGLE: {
        unit: R.rad,
        prefix: M.SHORT[""]
      },
      BIT: {
        unit: R.bits,
        prefix: M.SHORT[""]
      },
      // Derived units
      FORCE: {
        unit: R.N,
        prefix: M.SHORT[""]
      },
      ENERGY: {
        unit: R.J,
        prefix: M.SHORT[""]
      },
      POWER: {
        unit: R.W,
        prefix: M.SHORT[""]
      },
      PRESSURE: {
        unit: R.Pa,
        prefix: M.SHORT[""]
      },
      ELECTRIC_CHARGE: {
        unit: R.C,
        prefix: M.SHORT[""]
      },
      ELECTRIC_CAPACITANCE: {
        unit: R.F,
        prefix: M.SHORT[""]
      },
      ELECTRIC_POTENTIAL: {
        unit: R.V,
        prefix: M.SHORT[""]
      },
      ELECTRIC_RESISTANCE: {
        unit: R.ohm,
        prefix: M.SHORT[""]
      },
      ELECTRIC_INDUCTANCE: {
        unit: R.H,
        prefix: M.SHORT[""]
      },
      ELECTRIC_CONDUCTANCE: {
        unit: R.S,
        prefix: M.SHORT[""]
      },
      MAGNETIC_FLUX: {
        unit: R.Wb,
        prefix: M.SHORT[""]
      },
      MAGNETIC_FLUX_DENSITY: {
        unit: R.T,
        prefix: M.SHORT[""]
      },
      FREQUENCY: {
        unit: R.Hz,
        prefix: M.SHORT[""]
      }
    }
  };
  _.cgs = JSON.parse(JSON.stringify(_.si)), _.cgs.LENGTH = {
    unit: R.m,
    prefix: M.SHORT.c
  }, _.cgs.MASS = {
    unit: R.g,
    prefix: M.SHORT[""]
  }, _.cgs.FORCE = {
    unit: R.dyn,
    prefix: M.SHORT[""]
  }, _.cgs.ENERGY = {
    unit: R.erg,
    prefix: M.NONE[""]
  }, _.us = JSON.parse(JSON.stringify(_.si)), _.us.LENGTH = {
    unit: R.ft,
    prefix: M.NONE[""]
  }, _.us.MASS = {
    unit: R.lbm,
    prefix: M.NONE[""]
  }, _.us.TEMPERATURE = {
    unit: R.degF,
    prefix: M.NONE[""]
  }, _.us.FORCE = {
    unit: R.lbf,
    prefix: M.NONE[""]
  }, _.us.ENERGY = {
    unit: R.BTU,
    prefix: M.BTU[""]
  }, _.us.POWER = {
    unit: R.hp,
    prefix: M.NONE[""]
  }, _.us.PRESSURE = {
    unit: R.psi,
    prefix: M.NONE[""]
  }, _.auto = JSON.parse(JSON.stringify(_.si));
  var re = _.auto;
  m.setUnitSystem = function(j) {
    if (Pe(_, j))
      re = _[j];
    else
      throw new Error("Unit system " + j + " does not exist. Choices are: " + Object.keys(_).join(", "));
  }, m.getUnitSystem = function() {
    for (var j in _)
      if (Pe(_, j) && _[j] === re)
        return j;
  }, m.typeConverters = {
    BigNumber: function(Y) {
      return Y != null && Y.isFraction ? new x(Y.n).div(Y.d).times(Y.s) : new x(Y + "");
    },
    Fraction: function(Y) {
      return new g(Y);
    },
    Complex: function(Y) {
      return Y;
    },
    number: function(Y) {
      return Y != null && Y.isFraction ? h(Y) : Y;
    }
  }, m.prototype._numberConverter = function() {
    var j = m.typeConverters[this.valueType()];
    if (j)
      return j;
    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, m._getNumberConverter = function(j) {
    if (!m.typeConverters[j])
      throw new TypeError('Unsupported type "' + j + '"');
    return m.typeConverters[j];
  };
  for (var te in R)
    if (Pe(R, te)) {
      var ne = R[te];
      ne.dimensions = ne.base.dimensions;
    }
  for (var oe in X)
    if (Pe(X, oe)) {
      var le = R[X[oe]], fe = {};
      for (var ge in le)
        Pe(le, ge) && (fe[ge] = le[ge]);
      fe.name = oe, R[oe] = fe;
    }
  m.isValidAlpha = function(Y) {
    return /^[a-zA-Z]$/.test(Y);
  };
  function Be(j) {
    for (var Y = 0; Y < j.length; Y++) {
      if (A = j.charAt(Y), Y === 0 && !m.isValidAlpha(A))
        throw new Error('Invalid unit name (must begin with alpha character): "' + j + '"');
      if (Y > 0 && !(m.isValidAlpha(A) || C(A)))
        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + j + '"');
    }
  }
  return m.createUnit = function(j, Y) {
    if (typeof j != "object")
      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (Y && Y.override) {
      for (var ie in j)
        if (Pe(j, ie) && m.deleteUnit(ie), j[ie].aliases)
          for (var V = 0; V < j[ie].aliases.length; V++)
            m.deleteUnit(j[ie].aliases[V]);
    }
    var J;
    for (var $ in j)
      Pe(j, $) && (J = m.createUnitSingle($, j[$]));
    return J;
  }, m.createUnitSingle = function(j, Y) {
    if ((typeof Y > "u" || Y === null) && (Y = {}), typeof j != "string")
      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (Pe(R, j))
      throw new Error('Cannot create unit "' + j + '": a unit with that name already exists');
    Be(j);
    var ie = null, V = [], J = 0, $, pe, ve;
    if (Y && Y.type === "Unit")
      ie = Y.clone();
    else if (typeof Y == "string")
      Y !== "" && ($ = Y);
    else if (typeof Y == "object")
      $ = Y.definition, pe = Y.prefixes, J = Y.offset, ve = Y.baseName, Y.aliases && (V = Y.aliases.valueOf());
    else
      throw new TypeError('Cannot create unit "' + j + '" from "' + Y.toString() + '": expecting "string" or "Unit" or "Object"');
    if (V) {
      for (var q = 0; q < V.length; q++)
        if (Pe(R, V[q]))
          throw new Error('Cannot create alias "' + V[q] + '": a unit with that name already exists');
    }
    if ($ && typeof $ == "string" && !ie)
      try {
        ie = m.parse($, {
          allowNoUnits: !0
        });
      } catch (T) {
        throw T.message = 'Could not create unit "' + j + '" from "' + $ + '": ' + T.message, T;
      }
    else
      $ && $.type === "Unit" && (ie = $.clone());
    V = V || [], J = J || 0, pe && pe.toUpperCase ? pe = M[pe.toUpperCase()] || M.NONE : pe = M.NONE;
    var G = {};
    if (ie) {
      G = {
        name: j,
        value: ie.value,
        dimensions: ie.dimensions.slice(0),
        prefixes: pe,
        offset: J
      };
      var me = !1;
      for (var be in O)
        if (Pe(O, be)) {
          for (var xe = !0, Ee = 0; Ee < H.length; Ee++)
            if (Math.abs((G.dimensions[Ee] || 0) - (O[be].dimensions[Ee] || 0)) > 1e-12) {
              xe = !1;
              break;
            }
          if (xe) {
            me = !0, G.base = O[be];
            break;
          }
        }
      if (!me) {
        ve = ve || j + "_STUFF";
        var ye = {
          dimensions: ie.dimensions.slice(0)
        };
        ye.key = ve, O[ve] = ye, re[ve] = {
          unit: G,
          prefix: M.NONE[""]
        }, G.base = O[ve];
      }
    } else {
      if (ve = ve || j + "_STUFF", H.indexOf(ve) >= 0)
        throw new Error('Cannot create new base unit "' + j + '": a base unit with that name already exists (and cannot be overridden)');
      H.push(ve);
      for (var ee in O)
        Pe(O, ee) && (O[ee].dimensions[H.length - 1] = 0);
      for (var se = {
        dimensions: []
      }, de = 0; de < H.length; de++)
        se.dimensions[de] = 0;
      se.dimensions[H.length - 1] = 1, se.key = ve, O[ve] = se, G = {
        name: j,
        value: 1,
        dimensions: O[ve].dimensions.slice(0),
        prefixes: pe,
        offset: J,
        base: O[ve]
      }, re[ve] = {
        unit: G,
        prefix: M.NONE[""]
      };
    }
    m.UNITS[j] = G;
    for (var er = 0; er < V.length; er++) {
      var rr = V[er], Fe = {};
      for (var Er in G)
        Pe(G, Er) && (Fe[Er] = G[Er]);
      Fe.name = rr, m.UNITS[rr] = Fe;
    }
    return delete z.cache, new m(null, j);
  }, m.deleteUnit = function(j) {
    delete m.UNITS[j], delete z.cache;
  }, m.PREFIXES = M, m.BASE_DIMENSIONS = H, m.BASE_UNITS = O, m.UNIT_SYSTEMS = _, m.UNITS = R, m;
}, {
  isClass: !0
}), XA = "unit", eT = ["typed", "Unit"], jl = /* @__PURE__ */ U(XA, eT, (r) => {
  var {
    typed: e,
    Unit: t
  } = r;
  return e(XA, {
    Unit: function(a) {
      return a.clone();
    },
    string: function(a) {
      return t.isValuelessUnit(a) ? new t(null, a) : t.parse(a, {
        allowNoUnits: !0
      });
    },
    "number | BigNumber | Fraction | Complex, string | Unit": function(a, i) {
      return new t(a, i);
    },
    "number | BigNumber | Fraction": function(a) {
      return new t(a);
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
}), jA = "sparse", rT = ["typed", "SparseMatrix"], Gl = /* @__PURE__ */ U(jA, rT, (r) => {
  var {
    typed: e,
    SparseMatrix: t
  } = r;
  return e(jA, {
    "": function() {
      return new t([]);
    },
    string: function(a) {
      return new t([], a);
    },
    "Array | Matrix": function(a) {
      return new t(a);
    },
    "Array | Matrix, string": function(a, i) {
      return new t(a, i);
    }
  });
}), GA = "createUnit", tT = ["typed", "Unit"], Vl = /* @__PURE__ */ U(GA, tT, (r) => {
  var {
    typed: e,
    Unit: t
  } = r;
  return e(GA, {
    // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
    "Object, Object": function(a, i) {
      return t.createUnit(a, i);
    },
    // Same as above but without the options.
    Object: function(a) {
      return t.createUnit(a, {});
    },
    // Shortcut method for creating one unit.
    "string, Unit | string | Object, Object": function(a, i, u) {
      var f = {};
      return f[a] = i, t.createUnit(f, u);
    },
    // Same as above but without the options.
    "string, Unit | string | Object": function(a, i) {
      var u = {};
      return u[a] = i, t.createUnit(u, {});
    },
    // Without a definition, creates a base unit.
    string: function(a) {
      var i = {};
      return i[a] = {}, t.createUnit(i, {});
    }
  });
}), VA = "acos", nT = ["typed", "config", "Complex"], Ql = /* @__PURE__ */ U(VA, nT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(VA, {
    number: function(i) {
      return i >= -1 && i <= 1 || t.predictable ? Math.acos(i) : new n(i, 0).acos();
    },
    Complex: function(i) {
      return i.acos();
    },
    BigNumber: function(i) {
      return i.acos();
    }
  });
}), QA = "acosh", aT = ["typed", "config", "Complex"], Yl = /* @__PURE__ */ U(QA, aT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(QA, {
    number: function(i) {
      return i >= 1 || t.predictable ? HD(i) : i <= -1 ? new n(Math.log(Math.sqrt(i * i - 1) - i), Math.PI) : new n(i, 0).acosh();
    },
    Complex: function(i) {
      return i.acosh();
    },
    BigNumber: function(i) {
      return i.acosh();
    }
  });
}), YA = "acot", iT = ["typed", "BigNumber"], Zl = /* @__PURE__ */ U(YA, iT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(YA, {
    number: LD,
    Complex: function(a) {
      return a.acot();
    },
    BigNumber: function(a) {
      return new t(1).div(a).atan();
    }
  });
}), ZA = "acoth", oT = ["typed", "config", "Complex", "BigNumber"], Wl = /* @__PURE__ */ U(ZA, oT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(ZA, {
    number: function(u) {
      return u >= 1 || u <= -1 || t.predictable ? qD(u) : new n(u, 0).acoth();
    },
    Complex: function(u) {
      return u.acoth();
    },
    BigNumber: function(u) {
      return new a(1).div(u).atanh();
    }
  });
}), WA = "acsc", sT = ["typed", "config", "Complex", "BigNumber"], Kl = /* @__PURE__ */ U(WA, sT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(WA, {
    number: function(u) {
      return u <= -1 || u >= 1 || t.predictable ? UD(u) : new n(u, 0).acsc();
    },
    Complex: function(u) {
      return u.acsc();
    },
    BigNumber: function(u) {
      return new a(1).div(u).asin();
    }
  });
}), KA = "acsch", uT = ["typed", "BigNumber"], Jl = /* @__PURE__ */ U(KA, uT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(KA, {
    number: kD,
    Complex: function(a) {
      return a.acsch();
    },
    BigNumber: function(a) {
      return new t(1).div(a).asinh();
    }
  });
}), JA = "asec", cT = ["typed", "config", "Complex", "BigNumber"], _l = /* @__PURE__ */ U(JA, cT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(JA, {
    number: function(u) {
      return u <= -1 || u >= 1 || t.predictable ? XD(u) : new n(u, 0).asec();
    },
    Complex: function(u) {
      return u.asec();
    },
    BigNumber: function(u) {
      return new a(1).div(u).acos();
    }
  });
}), _A = "asech", lT = ["typed", "config", "Complex", "BigNumber"], $l = /* @__PURE__ */ U(_A, lT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n,
    BigNumber: a
  } = r;
  return e(_A, {
    number: function(u) {
      if (u <= 1 && u >= -1 || t.predictable) {
        var f = 1 / u;
        if (f > 0 || t.predictable)
          return jD(u);
        var c = Math.sqrt(f * f - 1);
        return new n(Math.log(c - f), Math.PI);
      }
      return new n(u, 0).asech();
    },
    Complex: function(u) {
      return u.asech();
    },
    BigNumber: function(u) {
      return new a(1).div(u).acosh();
    }
  });
}), $A = "asin", fT = ["typed", "config", "Complex"], ef = /* @__PURE__ */ U($A, fT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e($A, {
    number: function(i) {
      return i >= -1 && i <= 1 || t.predictable ? Math.asin(i) : new n(i, 0).asin();
    },
    Complex: function(i) {
      return i.asin();
    },
    BigNumber: function(i) {
      return i.asin();
    }
  });
}), vT = "asinh", pT = ["typed"], rf = /* @__PURE__ */ U(vT, pT, (r) => {
  var {
    typed: e
  } = r;
  return e("asinh", {
    number: GD,
    Complex: function(n) {
      return n.asinh();
    },
    BigNumber: function(n) {
      return n.asinh();
    }
  });
}), dT = "atan", mT = ["typed"], tf = /* @__PURE__ */ U(dT, mT, (r) => {
  var {
    typed: e
  } = r;
  return e("atan", {
    number: function(n) {
      return Math.atan(n);
    },
    Complex: function(n) {
      return n.atan();
    },
    BigNumber: function(n) {
      return n.atan();
    }
  });
}), eb = "atan2", hT = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], nf = /* @__PURE__ */ U(eb, hT, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    BigNumber: a,
    DenseMatrix: i,
    concat: u
  } = r, f = fn({
    typed: e,
    equalScalar: n
  }), c = Ct({
    typed: e
  }), o = n4({
    typed: e,
    equalScalar: n
  }), s = at({
    typed: e,
    equalScalar: n
  }), l = Qr({
    typed: e,
    DenseMatrix: i
  }), v = Dr({
    typed: e,
    matrix: t,
    concat: u
  });
  return e(eb, {
    "number, number": Math.atan2,
    // Complex numbers doesn't seem to have a reasonable implementation of
    // atan2(). Even Matlab removed the support, after they only calculated
    // the atan only on base of the real part of the numbers and ignored
    // the imaginary.
    "BigNumber, BigNumber": (p, h) => a.atan2(p, h)
  }, v({
    scalar: "number | BigNumber",
    SS: o,
    DS: c,
    SD: f,
    Ss: s,
    sS: l
  }));
}), rb = "atanh", gT = ["typed", "config", "Complex"], af = /* @__PURE__ */ U(rb, gT, (r) => {
  var {
    typed: e,
    config: t,
    Complex: n
  } = r;
  return e(rb, {
    number: function(i) {
      return i <= 1 && i >= -1 || t.predictable ? VD(i) : new n(i, 0).atanh();
    },
    Complex: function(i) {
      return i.atanh();
    },
    BigNumber: function(i) {
      return i.atanh();
    }
  });
}), Ei = /* @__PURE__ */ U("trigUnit", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    Unit: e.referToSelf((t) => (n) => {
      if (!n.hasBase(n.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cot is no angle");
      return e.find(t, n.valueType())(n.value);
    })
  };
}), tb = "cos", xT = ["typed"], of = /* @__PURE__ */ U(tb, xT, (r) => {
  var {
    typed: e
  } = r, t = Ei({
    typed: e
  });
  return e(tb, {
    number: Math.cos,
    "Complex | BigNumber": (n) => n.cos()
  }, t);
}), nb = "cosh", yT = ["typed"], sf = /* @__PURE__ */ U(nb, yT, (r) => {
  var {
    typed: e
  } = r;
  return e(nb, {
    number: t9,
    "Complex | BigNumber": (t) => t.cosh()
  });
}), ab = "cot", AT = ["typed", "BigNumber"], uf = /* @__PURE__ */ U(ab, AT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = Ei({
    typed: e
  });
  return e(ab, {
    number: QD,
    Complex: (a) => a.cot(),
    BigNumber: (a) => new t(1).div(a.tan())
  }, n);
}), ib = "coth", bT = ["typed", "BigNumber"], cf = /* @__PURE__ */ U(ib, bT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(ib, {
    number: YD,
    Complex: (n) => n.coth(),
    BigNumber: (n) => new t(1).div(n.tanh())
  });
}), ob = "csc", wT = ["typed", "BigNumber"], lf = /* @__PURE__ */ U(ob, wT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = Ei({
    typed: e
  });
  return e(ob, {
    number: ZD,
    Complex: (a) => a.csc(),
    BigNumber: (a) => new t(1).div(a.sin())
  }, n);
}), sb = "csch", DT = ["typed", "BigNumber"], ff = /* @__PURE__ */ U(sb, DT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(sb, {
    number: WD,
    Complex: (n) => n.csch(),
    BigNumber: (n) => new t(1).div(n.sinh())
  });
}), ub = "sec", CT = ["typed", "BigNumber"], vf = /* @__PURE__ */ U(ub, CT, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r, n = Ei({
    typed: e
  });
  return e(ub, {
    number: KD,
    Complex: (a) => a.sec(),
    BigNumber: (a) => new t(1).div(a.cos())
  }, n);
}), cb = "sech", ET = ["typed", "BigNumber"], pf = /* @__PURE__ */ U(cb, ET, (r) => {
  var {
    typed: e,
    BigNumber: t
  } = r;
  return e(cb, {
    number: JD,
    Complex: (n) => n.sech(),
    BigNumber: (n) => new t(1).div(n.cosh())
  });
}), lb = "sin", NT = ["typed"], df = /* @__PURE__ */ U(lb, NT, (r) => {
  var {
    typed: e
  } = r, t = Ei({
    typed: e
  });
  return e(lb, {
    number: Math.sin,
    "Complex | BigNumber": (n) => n.sin()
  }, t);
}), fb = "sinh", BT = ["typed"], mf = /* @__PURE__ */ U(fb, BT, (r) => {
  var {
    typed: e
  } = r;
  return e(fb, {
    number: _D,
    "Complex | BigNumber": (t) => t.sinh()
  });
}), vb = "tan", ST = ["typed"], hf = /* @__PURE__ */ U(vb, ST, (r) => {
  var {
    typed: e
  } = r, t = Ei({
    typed: e
  });
  return e(vb, {
    number: Math.tan,
    "Complex | BigNumber": (n) => n.tan()
  }, t);
}), PT = "tanh", MT = ["typed"], gf = /* @__PURE__ */ U(PT, MT, (r) => {
  var {
    typed: e
  } = r;
  return e("tanh", {
    number: a9,
    "Complex | BigNumber": (t) => t.tanh()
  });
}), pb = "setCartesian", FT = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], xf = /* @__PURE__ */ U(pb, FT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: u
  } = r;
  return e(pb, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var s = [];
      if (n(t(c), new i(0)) !== 0 && n(t(o), new i(0)) !== 0) {
        var l = cr(Array.isArray(c) ? c : c.toArray()).sort(a), v = cr(Array.isArray(o) ? o : o.toArray()).sort(a);
        s = [];
        for (var p = 0; p < l.length; p++)
          for (var h = 0; h < v.length; h++)
            s.push([l[p], v[h]]);
      }
      return Array.isArray(c) && Array.isArray(o) ? s : new u(s);
    }
  });
}), db = "setDifference", TT = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], yf = /* @__PURE__ */ U(db, TT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: u
  } = r;
  return e(db, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var s;
      if (n(t(c), new i(0)) === 0)
        s = [];
      else {
        if (n(t(o), new i(0)) === 0)
          return cr(c.toArray());
        var l = fi(cr(Array.isArray(c) ? c : c.toArray()).sort(a)), v = fi(cr(Array.isArray(o) ? o : o.toArray()).sort(a));
        s = [];
        for (var p, h = 0; h < l.length; h++) {
          p = !1;
          for (var d = 0; d < v.length; d++)
            if (a(l[h].value, v[d].value) === 0 && l[h].identifier === v[d].identifier) {
              p = !0;
              break;
            }
          p || s.push(l[h]);
        }
      }
      return Array.isArray(c) && Array.isArray(o) ? Hs(s) : new u(Hs(s));
    }
  });
}), mb = "setDistinct", OT = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], Af = /* @__PURE__ */ U(mb, OT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: u
  } = r;
  return e(mb, {
    "Array | Matrix": function(c) {
      var o;
      if (n(t(c), new i(0)) === 0)
        o = [];
      else {
        var s = cr(Array.isArray(c) ? c : c.toArray()).sort(a);
        o = [], o.push(s[0]);
        for (var l = 1; l < s.length; l++)
          a(s[l], s[l - 1]) !== 0 && o.push(s[l]);
      }
      return Array.isArray(c) ? o : new u(o);
    }
  });
}), hb = "setIntersect", zT = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], bf = /* @__PURE__ */ U(hb, zT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i,
    DenseMatrix: u
  } = r;
  return e(hb, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      var s;
      if (n(t(c), new i(0)) === 0 || n(t(o), new i(0)) === 0)
        s = [];
      else {
        var l = fi(cr(Array.isArray(c) ? c : c.toArray()).sort(a)), v = fi(cr(Array.isArray(o) ? o : o.toArray()).sort(a));
        s = [];
        for (var p = 0; p < l.length; p++)
          for (var h = 0; h < v.length; h++)
            if (a(l[p].value, v[h].value) === 0 && l[p].identifier === v[h].identifier) {
              s.push(l[p]);
              break;
            }
      }
      return Array.isArray(c) && Array.isArray(o) ? Hs(s) : new u(Hs(s));
    }
  });
}), gb = "setIsSubset", RT = ["typed", "size", "subset", "compareNatural", "Index"], wf = /* @__PURE__ */ U(gb, RT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(gb, {
    "Array | Matrix, Array | Matrix": function(f, c) {
      if (n(t(f), new i(0)) === 0)
        return !0;
      if (n(t(c), new i(0)) === 0)
        return !1;
      for (var o = fi(cr(Array.isArray(f) ? f : f.toArray()).sort(a)), s = fi(cr(Array.isArray(c) ? c : c.toArray()).sort(a)), l, v = 0; v < o.length; v++) {
        l = !1;
        for (var p = 0; p < s.length; p++)
          if (a(o[v].value, s[p].value) === 0 && o[v].identifier === s[p].identifier) {
            l = !0;
            break;
          }
        if (l === !1)
          return !1;
      }
      return !0;
    }
  });
}), xb = "setMultiplicity", IT = ["typed", "size", "subset", "compareNatural", "Index"], Df = /* @__PURE__ */ U(xb, IT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(xb, {
    "number | BigNumber | Fraction | Complex, Array | Matrix": function(f, c) {
      if (n(t(c), new i(0)) === 0)
        return 0;
      for (var o = cr(Array.isArray(c) ? c : c.toArray()), s = 0, l = 0; l < o.length; l++)
        a(o[l], f) === 0 && s++;
      return s;
    }
  });
}), yb = "setPowerset", HT = ["typed", "size", "subset", "compareNatural", "Index"], Cf = /* @__PURE__ */ U(yb, HT, (r) => {
  var {
    typed: e,
    size: t,
    subset: n,
    compareNatural: a,
    Index: i
  } = r;
  return e(yb, {
    "Array | Matrix": function(o) {
      if (n(t(o), new i(0)) === 0)
        return [];
      for (var s = cr(Array.isArray(o) ? o : o.toArray()).sort(a), l = [], v = 0; v.toString(2).length <= s.length; )
        l.push(u(s, v.toString(2).split("").reverse())), v++;
      return f(l);
    }
  });
  function u(c, o) {
    for (var s = [], l = 0; l < o.length; l++)
      o[l] === "1" && s.push(c[l]);
    return s;
  }
  function f(c) {
    for (var o = [], s = c.length - 1; s > 0; s--)
      for (var l = 0; l < s; l++)
        c[l].length > c[l + 1].length && (o = c[l], c[l] = c[l + 1], c[l + 1] = o);
    return c;
  }
}), Ab = "setSize", LT = ["typed", "compareNatural"], Ef = /* @__PURE__ */ U(Ab, LT, (r) => {
  var {
    typed: e,
    compareNatural: t
  } = r;
  return e(Ab, {
    "Array | Matrix": function(a) {
      return Array.isArray(a) ? cr(a).length : cr(a.toArray()).length;
    },
    "Array | Matrix, boolean": function(a, i) {
      if (i === !1 || a.length === 0)
        return Array.isArray(a) ? cr(a).length : cr(a.toArray()).length;
      for (var u = cr(Array.isArray(a) ? a : a.toArray()).sort(t), f = 1, c = 1; c < u.length; c++)
        t(u[c], u[c - 1]) !== 0 && f++;
      return f;
    }
  });
}), bb = "setSymDifference", qT = ["typed", "size", "concat", "subset", "setDifference", "Index"], Nf = /* @__PURE__ */ U(bb, qT, (r) => {
  var {
    typed: e,
    size: t,
    concat: n,
    subset: a,
    setDifference: i,
    Index: u
  } = r;
  return e(bb, {
    "Array | Matrix, Array | Matrix": function(c, o) {
      if (a(t(c), new u(0)) === 0)
        return cr(o);
      if (a(t(o), new u(0)) === 0)
        return cr(c);
      var s = cr(c), l = cr(o);
      return n(i(s, l), i(l, s));
    }
  });
}), wb = "setUnion", UT = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], Bf = /* @__PURE__ */ U(wb, UT, (r) => {
  var {
    typed: e,
    size: t,
    concat: n,
    subset: a,
    setIntersect: i,
    setSymDifference: u,
    Index: f
  } = r;
  return e(wb, {
    "Array | Matrix, Array | Matrix": function(o, s) {
      if (a(t(o), new f(0)) === 0)
        return cr(s);
      if (a(t(s), new f(0)) === 0)
        return cr(o);
      var l = cr(o), v = cr(s);
      return n(u(l, v), i(l, v));
    }
  });
}), Db = "add", kT = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], Sf = /* @__PURE__ */ U(Db, kT, (r) => {
  var {
    typed: e,
    matrix: t,
    addScalar: n,
    equalScalar: a,
    DenseMatrix: i,
    SparseMatrix: u,
    concat: f
  } = r, c = oa({
    typed: e
  }), o = bh({
    typed: e,
    equalScalar: a
  }), s = Ma({
    typed: e,
    DenseMatrix: i
  }), l = Dr({
    typed: e,
    matrix: t,
    concat: f
  });
  return e(Db, {
    "any, any": n,
    "any, any, ...any": e.referToSelf((v) => (p, h, d) => {
      for (var x = v(p, h), g = 0; g < d.length; g++)
        x = v(x, d[g]);
      return x;
    })
  }, l({
    elop: n,
    DS: c,
    SS: o,
    Ss: s
  }));
}), Cb = "hypot", XT = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], Pf = /* @__PURE__ */ U(Cb, XT, (r) => {
  var {
    typed: e,
    abs: t,
    addScalar: n,
    divideScalar: a,
    multiplyScalar: i,
    sqrt: u,
    smaller: f,
    isPositive: c
  } = r;
  return e(Cb, {
    "... number | BigNumber": o,
    Array: o,
    Matrix: (s) => o(cr(s.toArray()))
  });
  function o(s) {
    for (var l = 0, v = 0, p = 0; p < s.length; p++) {
      if (Wt(s[p]))
        throw new TypeError("Unexpected type of argument to hypot");
      var h = t(s[p]);
      f(v, h) ? (l = i(l, i(a(v, h), a(v, h))), l = n(l, 1), v = h) : l = n(l, c(h) ? i(a(h, v), a(h, v)) : h);
    }
    return i(v, u(l));
  }
}), Eb = "norm", jT = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], Mf = /* @__PURE__ */ U(Eb, jT, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    pow: a,
    conj: i,
    sqrt: u,
    multiply: f,
    equalScalar: c,
    larger: o,
    smaller: s,
    matrix: l,
    ctranspose: v,
    eigs: p
  } = r;
  return e(Eb, {
    number: Math.abs,
    Complex: function(N) {
      return N.abs();
    },
    BigNumber: function(N) {
      return N.abs();
    },
    boolean: function(N) {
      return Math.abs(N);
    },
    Array: function(N) {
      return A(l(N), 2);
    },
    Matrix: function(N) {
      return A(N, 2);
    },
    "Array, number | BigNumber | string": function(N, C) {
      return A(l(N), C);
    },
    "Matrix, number | BigNumber | string": function(N, C) {
      return A(N, C);
    }
  });
  function h(E) {
    var N = 0;
    return E.forEach(function(C) {
      var D = t(C);
      o(D, N) && (N = D);
    }, !0), N;
  }
  function d(E) {
    var N;
    return E.forEach(function(C) {
      var D = t(C);
      (!N || s(D, N)) && (N = D);
    }, !0), N || 0;
  }
  function x(E, N) {
    if (N === Number.POSITIVE_INFINITY || N === "inf")
      return h(E);
    if (N === Number.NEGATIVE_INFINITY || N === "-inf")
      return d(E);
    if (N === "fro")
      return A(E, 2);
    if (typeof N == "number" && !isNaN(N)) {
      if (!c(N, 0)) {
        var C = 0;
        return E.forEach(function(D) {
          C = n(a(t(D), N), C);
        }, !0), a(C, 1 / N);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function g(E) {
    var N = 0;
    return E.forEach(function(C, D) {
      N = n(N, f(C, i(C)));
    }), t(u(N));
  }
  function y(E) {
    var N = [], C = 0;
    return E.forEach(function(D, B) {
      var S = B[1], F = n(N[S] || 0, t(D));
      o(F, C) && (C = F), N[S] = F;
    }, !0), C;
  }
  function m(E) {
    var N = E.size();
    if (N[0] !== N[1])
      throw new RangeError("Invalid matrix dimensions");
    var C = v(E), D = f(C, E), B = p(D).values.toArray(), S = B[B.length - 1];
    return t(u(S));
  }
  function b(E) {
    var N = [], C = 0;
    return E.forEach(function(D, B) {
      var S = B[0], F = n(N[S] || 0, t(D));
      o(F, C) && (C = F), N[S] = F;
    }, !0), C;
  }
  function w(E, N) {
    if (N === 1)
      return y(E);
    if (N === Number.POSITIVE_INFINITY || N === "inf")
      return b(E);
    if (N === "fro")
      return g(E);
    if (N === 2)
      return m(E);
    throw new Error("Unsupported parameter value " + N);
  }
  function A(E, N) {
    var C = E.size();
    if (C.length === 1)
      return x(E, N);
    if (C.length === 2) {
      if (C[0] && C[1])
        return w(E, N);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
}), Nb = "dot", GT = ["typed", "addScalar", "multiplyScalar", "conj", "size"], Ff = /* @__PURE__ */ U(Nb, GT, (r) => {
  var {
    typed: e,
    addScalar: t,
    multiplyScalar: n,
    conj: a,
    size: i
  } = r;
  return e(Nb, {
    "Array | DenseMatrix, Array | DenseMatrix": f,
    "SparseMatrix, SparseMatrix": c
  });
  function u(s, l) {
    var v = o(s), p = o(l), h, d;
    if (v.length === 1)
      h = v[0];
    else if (v.length === 2 && v[1] === 1)
      h = v[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + v.join(", ") + ")");
    if (p.length === 1)
      d = p[0];
    else if (p.length === 2 && p[1] === 1)
      d = p[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + p.join(", ") + ")");
    if (h !== d)
      throw new RangeError("Vectors must have equal length (" + h + " != " + d + ")");
    if (h === 0)
      throw new RangeError("Cannot calculate the dot product of empty vectors");
    return h;
  }
  function f(s, l) {
    var v = u(s, l), p = Oe(s) ? s._data : s, h = Oe(s) ? s._datatype || s.getDataType() : void 0, d = Oe(l) ? l._data : l, x = Oe(l) ? l._datatype || l.getDataType() : void 0, g = o(s).length === 2, y = o(l).length === 2, m = t, b = n;
    if (h && x && h === x && typeof h == "string" && h !== "mixed") {
      var w = h;
      m = e.find(t, [w, w]), b = e.find(n, [w, w]);
    }
    if (!g && !y) {
      for (var A = b(a(p[0]), d[0]), E = 1; E < v; E++)
        A = m(A, b(a(p[E]), d[E]));
      return A;
    }
    if (!g && y) {
      for (var N = b(a(p[0]), d[0][0]), C = 1; C < v; C++)
        N = m(N, b(a(p[C]), d[C][0]));
      return N;
    }
    if (g && !y) {
      for (var D = b(a(p[0][0]), d[0]), B = 1; B < v; B++)
        D = m(D, b(a(p[B][0]), d[B]));
      return D;
    }
    if (g && y) {
      for (var S = b(a(p[0][0]), d[0][0]), F = 1; F < v; F++)
        S = m(S, b(a(p[F][0]), d[F][0]));
      return S;
    }
  }
  function c(s, l) {
    u(s, l);
    for (var v = s._index, p = s._values, h = l._index, d = l._values, x = 0, g = t, y = n, m = 0, b = 0; m < v.length && b < h.length; ) {
      var w = v[m], A = h[b];
      if (w < A) {
        m++;
        continue;
      }
      if (w > A) {
        b++;
        continue;
      }
      w === A && (x = g(x, y(p[m], d[b])), m++, b++);
    }
    return x;
  }
  function o(s) {
    return Oe(s) ? s.size() : i(s);
  }
}), VT = "trace", QT = ["typed", "matrix", "add"], Tf = /* @__PURE__ */ U(VT, QT, (r) => {
  var {
    typed: e,
    matrix: t,
    add: n
  } = r;
  return e("trace", {
    Array: function(f) {
      return a(t(f));
    },
    SparseMatrix: i,
    DenseMatrix: a,
    any: Ie
  });
  function a(u) {
    var f = u._size, c = u._data;
    switch (f.length) {
      case 1:
        if (f[0] === 1)
          return Ie(c[0]);
        throw new RangeError("Matrix must be square (size: " + Ke(f) + ")");
      case 2: {
        var o = f[0], s = f[1];
        if (o === s) {
          for (var l = 0, v = 0; v < o; v++)
            l = n(l, c[v][v]);
          return l;
        } else
          throw new RangeError("Matrix must be square (size: " + Ke(f) + ")");
      }
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + Ke(f) + ")");
    }
  }
  function i(u) {
    var f = u._values, c = u._index, o = u._ptr, s = u._size, l = s[0], v = s[1];
    if (l === v) {
      var p = 0;
      if (f.length > 0)
        for (var h = 0; h < v; h++)
          for (var d = o[h], x = o[h + 1], g = d; g < x; g++) {
            var y = c[g];
            if (y === h) {
              p = n(p, f[g]);
              break;
            }
            if (y > h)
              break;
          }
      return p;
    }
    throw new RangeError("Matrix must be square (size: " + Ke(s) + ")");
  }
}), Bb = "index", YT = ["typed", "Index"], Of = /* @__PURE__ */ U(Bb, YT, (r) => {
  var {
    typed: e,
    Index: t
  } = r;
  return e(Bb, {
    "...number | string | BigNumber | Range | Array | Matrix": function(a) {
      var i = a.map(function(f) {
        return Ue(f) ? f.toNumber() : ur(f) || Oe(f) ? f.map(function(c) {
          return Ue(c) ? c.toNumber() : c;
        }) : f;
      }), u = new t();
      return t.apply(u, i), u;
    }
  });
}), s4 = /* @__PURE__ */ new Set(["end"]), ZT = "Node", WT = ["mathWithTransform"], zf = /* @__PURE__ */ U(ZT, WT, (r) => {
  var {
    mathWithTransform: e
  } = r;
  function t(a) {
    for (var i of [...s4])
      if (a.has(i))
        throw new Error('Scope contains an illegal symbol, "' + i + '" is a reserved keyword');
  }
  class n {
    get type() {
      return "Node";
    }
    get isNode() {
      return !0;
    }
    /**
     * Evaluate the node
     * @param {Object} [scope]  Scope to read/write variables
     * @return {*}              Returns the result
     */
    evaluate(i) {
      return this.compile().evaluate(i);
    }
    /**
     * Compile the node into an optimized, evauatable JavaScript function
     * @return {{evaluate: function([Object])}} object
     *                Returns an object with a function 'evaluate',
     *                which can be invoked as expr.evaluate([scope: Object]),
     *                where scope is an optional object with
     *                variables.
     */
    compile() {
      var i = this._compile(e, {}), u = {}, f = null;
      function c(o) {
        var s = ri(o);
        return t(s), i(s, u, f);
      }
      return {
        evaluate: c
      };
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      throw new Error("Method _compile must be implemented by type " + this.type);
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      throw new Error("Cannot run forEach on a Node interface");
    }
    /**
     * Create a new Node whose children are the results of calling the
     * provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(i) {
      throw new Error("Cannot run map on a Node interface");
    }
    /**
     * Validate whether an object is a Node, for use with map
     * @param {Node} node
     * @returns {Node} Returns the input if it's a node, else throws an Error
     * @protected
     */
    _ifNode(i) {
      if (!vr(i))
        throw new TypeError("Callback function must return a Node");
      return i;
    }
    /**
     * Recursively traverse all nodes in a node tree. Executes given callback for
     * this node and each of its child nodes.
     * @param {function(node: Node, path: string, parent: Node)} callback
     *          A callback called for every node in the node tree.
     */
    traverse(i) {
      i(this, null, null);
      function u(f, c) {
        f.forEach(function(o, s, l) {
          c(o, s, l), u(o, c);
        });
      }
      u(this, i);
    }
    /**
     * Recursively transform a node tree via a transform function.
     *
     * For example, to replace all nodes of type SymbolNode having name 'x' with
     * a ConstantNode with value 2:
     *
     *     const res = Node.transform(function (node, path, parent) {
     *       if (node && node.isSymbolNode) && (node.name === 'x')) {
     *         return new ConstantNode(2)
     *       }
     *       else {
     *         return node
     *       }
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *          A mapping function accepting a node, and returning
     *          a replacement for the node or the original node. The "signature"
     *          of the callback must be:
     *          callback(node: Node, index: string, parent: Node) : Node
     * @return {Node} Returns the original node or its replacement
     */
    transform(i) {
      function u(f, c, o) {
        var s = i(f, c, o);
        return s !== f ? s : f.map(u);
      }
      return u(this, null, null);
    }
    /**
     * Find any node in the node tree matching given filter function. For
     * example, to find all nodes of type SymbolNode having name 'x':
     *
     *     const results = Node.filter(function (node) {
     *       return (node && node.isSymbolNode) && (node.name === 'x')
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *            A test function returning true when a node matches, and false
     *            otherwise. Function signature:
     *            callback(node: Node, index: string, parent: Node) : boolean
     * @return {Node[]} nodes
     *            An array with nodes matching given filter criteria
     */
    filter(i) {
      var u = [];
      return this.traverse(function(f, c, o) {
        i(f, c, o) && u.push(f);
      }), u;
    }
    /**
     * Create a shallow clone of this node
     * @return {Node}
     */
    clone() {
      throw new Error("Cannot clone a Node interface");
    }
    /**
     * Create a deep clone of this node
     * @return {Node}
     */
    cloneDeep() {
      return this.map(function(i) {
        return i.cloneDeep();
      });
    }
    /**
     * Deep compare this node with another node.
     * @param {Node} other
     * @return {boolean} Returns true when both nodes are of the same type and
     *                   contain the same values (as do their childs)
     */
    equals(i) {
      return i ? this.type === i.type && Da(this, i) : !1;
    }
    /**
     * Get string representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toString(i) {
      var u = this._getCustomString(i);
      return typeof u < "u" ? u : this._toString(i);
    }
    /**
     * Internal function to generate the string output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toString() {
      throw new Error("_toString not implemented for " + this.type);
    }
    /**
     * Get a JSON representation of the node
     * Both .toJSON() and the static .fromJSON(json) should be implemented by all
     * implementations of Node
     * @returns {Object}
     */
    toJSON() {
      throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    /**
     * Get HTML representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)" or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toHTML(i) {
      var u = this._getCustomString(i);
      return typeof u < "u" ? u : this._toHTML(i);
    }
    /**
     * Internal function to generate the HTML output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toHTML() {
      throw new Error("_toHTML not implemented for " + this.type);
    }
    /**
     * Get LaTeX representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toTex(i) {
      var u = this._getCustomString(i);
      return typeof u < "u" ? u : this._toTex(i);
    }
    /**
     * Internal function to generate the LaTeX output.
     * This has to be implemented by every Node
     *
     * @param {Object} [options]
     * @throws {Error}
     */
    _toTex(i) {
      throw new Error("_toTex not implemented for " + this.type);
    }
    /**
     * Helper used by `to...` functions.
     */
    _getCustomString(i) {
      if (i && typeof i == "object")
        switch (typeof i.handler) {
          case "object":
          case "undefined":
            return;
          case "function":
            return i.handler(this, i);
          default:
            throw new TypeError("Object or function expected as callback");
        }
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type;
    }
    /**
     * Get the content of the current Node.
     * @return {Node} node
     **/
    getContent() {
      return this;
    }
  }
  return n;
}, {
  isClass: !0,
  isNode: !0
});
function Et(r) {
  return r && r.isIndexError ? new Ut(r.index + 1, r.min + 1, r.max !== void 0 ? r.max + 1 : void 0) : r;
}
function u4(r) {
  var {
    subset: e
  } = r;
  return function(n, a) {
    try {
      if (Array.isArray(n))
        return e(n, a);
      if (n && typeof n.subset == "function")
        return n.subset(a);
      if (typeof n == "string")
        return e(n, a);
      if (typeof n == "object") {
        if (!a.isObjectProperty())
          throw new TypeError("Cannot apply a numeric index as object property");
        return At(n, a.getObjectProperty());
      } else
        throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (i) {
      throw Et(i);
    }
  };
}
var cs = "AccessorNode", KT = ["subset", "Node"], Rf = /* @__PURE__ */ U(cs, KT, (r) => {
  var {
    subset: e,
    Node: t
  } = r, n = u4({
    subset: e
  });
  function a(u) {
    return !(In(u) || Mt(u) || ar(u) || An(u) || xi(u) || un(u) || Ur(u));
  }
  class i extends t {
    /**
     * @constructor AccessorNode
     * @extends {Node}
     * Access an object property or get a matrix subset
     *
     * @param {Node} object                 The object from which to retrieve
     *                                      a property or subset.
     * @param {IndexNode} index             IndexNode containing ranges
     */
    constructor(f, c) {
      if (super(), !vr(f))
        throw new TypeError('Node expected for parameter "object"');
      if (!aa(c))
        throw new TypeError('IndexNode expected for parameter "index"');
      this.object = f, this.index = c;
    }
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return cs;
    }
    get isAccessorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(f, c) {
      var o = this.object._compile(f, c), s = this.index._compile(f, c);
      if (this.index.isObjectProperty()) {
        var l = this.index.getObjectProperty();
        return function(p, h, d) {
          return At(o(p, h, d), l);
        };
      } else
        return function(p, h, d) {
          var x = o(p, h, d), g = s(p, h, x);
          return n(x, g);
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(f) {
      f(this.object, "object", this), f(this.index, "index", this);
    }
    /**
     * Create a new AccessorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AccessorNode} Returns a transformed copy of the node
     */
    map(f) {
      return new i(this._ifNode(f(this.object, "object", this)), this._ifNode(f(this.index, "index", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AccessorNode}
     */
    clone() {
      return new i(this.object, this.index);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(f) {
      var c = this.object.toString(f);
      return a(this.object) && (c = "(" + c + ")"), c + this.index.toString(f);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(f) {
      var c = this.object.toHTML(f);
      return a(this.object) && (c = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c + this.index.toHTML(f);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(f) {
      var c = this.object.toTex(f);
      return a(this.object) && (c = "\\left(' + object + '\\right)"), c + this.index.toTex(f);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: cs,
        object: this.object,
        index: this.index
      };
    }
    /**
     * Instantiate an AccessorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AccessorNode", object: ..., index: ...}`,
     *     where mathjs is optional
     * @returns {AccessorNode}
     */
    static fromJSON(f) {
      return new i(f.object, f.index);
    }
  }
  return Gr(i, "name", cs), i;
}, {
  isClass: !0,
  isNode: !0
}), ls = "ArrayNode", JT = ["Node"], If = /* @__PURE__ */ U(ls, JT, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ArrayNode
     * @extends {Node}
     * Holds an 1-dimensional array with items
     * @param {Node[]} [items]   1 dimensional array with items
     */
    constructor(a) {
      if (super(), this.items = a || [], !Array.isArray(this.items) || !this.items.every(vr))
        throw new TypeError("Array containing Nodes expected");
    }
    get type() {
      return ls;
    }
    get isArrayNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var u = Rn(this.items, function(o) {
        return o._compile(a, i);
      }), f = a.config.matrix !== "Array";
      if (f) {
        var c = a.matrix;
        return function(s, l, v) {
          return c(Rn(u, function(p) {
            return p(s, l, v);
          }));
        };
      } else
        return function(s, l, v) {
          return Rn(u, function(p) {
            return p(s, l, v);
          });
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      for (var i = 0; i < this.items.length; i++) {
        var u = this.items[i];
        a(u, "items[" + i + "]", this);
      }
    }
    /**
     * Create a new ArrayNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ArrayNode} Returns a transformed copy of the node
     */
    map(a) {
      for (var i = [], u = 0; u < this.items.length; u++)
        i[u] = this._ifNode(a(this.items[u], "items[" + u + "]", this));
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ArrayNode}
     */
    clone() {
      return new t(this.items.slice(0));
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      var i = this.items.map(function(u) {
        return u.toString(a);
      });
      return "[" + i.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ls,
        items: this.items
      };
    }
    /**
     * Instantiate an ArrayNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ArrayNode", items: [...]}`,
     *                       where mathjs is optional
     * @returns {ArrayNode}
     */
    static fromJSON(a) {
      return new t(a.items);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      var i = this.items.map(function(u) {
        return u.toHTML(a);
      });
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + i.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      function i(u, f) {
        var c = u.some(Mt) && !u.every(Mt), o = f || c, s = o ? "&" : "\\\\", l = u.map(function(v) {
          return v.items ? i(v.items, !f) : v.toTex(a);
        }).join(s);
        return c || !o || o && !f ? "\\begin{bmatrix}" + l + "\\end{bmatrix}" : l;
      }
      return i(this.items, !1);
    }
  }
  return Gr(t, "name", ls), t;
}, {
  isClass: !0,
  isNode: !0
});
function _T(r) {
  var {
    subset: e,
    matrix: t
  } = r;
  return function(a, i, u) {
    try {
      if (Array.isArray(a)) {
        var f = t(a).subset(i, u).valueOf();
        return f.forEach((c, o) => {
          a[o] = c;
        }), a;
      } else {
        if (a && typeof a.subset == "function")
          return a.subset(i, u);
        if (typeof a == "string")
          return e(a, i, u);
        if (typeof a == "object") {
          if (!i.isObjectProperty())
            throw TypeError("Cannot apply a numeric index as object property");
          return si(a, i.getObjectProperty(), u), a;
        } else
          throw new TypeError("Cannot apply index: unsupported type of object");
      }
    } catch (c) {
      throw Et(c);
    }
  };
}
var an = [{
  // assignment
  AssignmentNode: {},
  FunctionAssignmentNode: {}
}, {
  // conditional expression
  ConditionalNode: {
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // conditionals don't need parentheses in LaTeX because
    // they are 2 dimensional
  }
}, {
  // logical or
  "OperatorNode:or": {
    op: "or",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical xor
  "OperatorNode:xor": {
    op: "xor",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical and
  "OperatorNode:and": {
    op: "and",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise or
  "OperatorNode:bitOr": {
    op: "|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise xor
  "OperatorNode:bitXor": {
    op: "^|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise and
  "OperatorNode:bitAnd": {
    op: "&",
    associativity: "left",
    associativeWith: []
  }
}, {
  // relational operators
  "OperatorNode:equal": {
    op: "==",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:unequal": {
    op: "!=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smaller": {
    op: "<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:larger": {
    op: ">",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smallerEq": {
    op: "<=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:largerEq": {
    op: ">=",
    associativity: "left",
    associativeWith: []
  },
  RelationalNode: {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitshift operators
  "OperatorNode:leftShift": {
    op: "<<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightArithShift": {
    op: ">>",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightLogShift": {
    op: ">>>",
    associativity: "left",
    associativeWith: []
  }
}, {
  // unit conversion
  "OperatorNode:to": {
    op: "to",
    associativity: "left",
    associativeWith: []
  }
}, {
  // range
  RangeNode: {}
}, {
  // addition, subtraction
  "OperatorNode:add": {
    op: "+",
    associativity: "left",
    associativeWith: ["OperatorNode:add", "OperatorNode:subtract"]
  },
  "OperatorNode:subtract": {
    op: "-",
    associativity: "left",
    associativeWith: []
  }
}, {
  // multiply, divide, modulus
  "OperatorNode:multiply": {
    op: "*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  },
  "OperatorNode:divide": {
    op: "/",
    associativity: "left",
    associativeWith: [],
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // fractions don't require parentheses because
    // they're 2 dimensional, so parens aren't needed
    // in LaTeX
  },
  "OperatorNode:dotMultiply": {
    op: ".*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"]
  },
  "OperatorNode:dotDivide": {
    op: "./",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:mod": {
    op: "mod",
    associativity: "left",
    associativeWith: []
  }
}, {
  // Repeat multiplication for implicit multiplication
  "OperatorNode:multiply": {
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  }
}, {
  // unary prefix operators
  "OperatorNode:unaryPlus": {
    op: "+",
    associativity: "right"
  },
  "OperatorNode:unaryMinus": {
    op: "-",
    associativity: "right"
  },
  "OperatorNode:bitNot": {
    op: "~",
    associativity: "right"
  },
  "OperatorNode:not": {
    op: "not",
    associativity: "right"
  }
}, {
  // exponentiation
  "OperatorNode:pow": {
    op: "^",
    associativity: "right",
    associativeWith: [],
    latexRightParens: !1
    // the exponent doesn't need parentheses in
    // LaTeX because it's 2 dimensional
    // (it's on top)
  },
  "OperatorNode:dotPow": {
    op: ".^",
    associativity: "right",
    associativeWith: []
  }
}, {
  // factorial
  "OperatorNode:factorial": {
    op: "!",
    associativity: "left"
  }
}, {
  // matrix transpose
  "OperatorNode:ctranspose": {
    op: "'",
    associativity: "left"
  }
}];
function fs(r, e) {
  if (!e || e !== "auto")
    return r;
  for (var t = r; un(t); )
    t = t.content;
  return t;
}
function Ar(r, e, t, n) {
  var a = r;
  e !== "keep" && (a = r.getContent());
  for (var i = a.getIdentifier(), u = null, f = 0; f < an.length; f++)
    if (i in an[f]) {
      u = f;
      break;
    }
  if (i === "OperatorNode:multiply" && a.implicit && t !== "show") {
    var c = fs(a.args[0], e);
    !(ar(c) && n && n.getIdentifier() === "OperatorNode:divide" && Sm(fs(n.args[0], e))) && !(c.getIdentifier() === "OperatorNode:divide" && Sm(fs(c.args[0], e)) && ar(fs(c.args[1]))) && (u += 1);
  }
  return u;
}
function Qi(r, e) {
  var t = r;
  e !== "keep" && (t = r.getContent());
  var n = t.getIdentifier(), a = Ar(t, e);
  if (a === null)
    return null;
  var i = an[a][n];
  if (Pe(i, "associativity")) {
    if (i.associativity === "left")
      return "left";
    if (i.associativity === "right")
      return "right";
    throw Error("'" + n + "' has the invalid associativity '" + i.associativity + "'.");
  }
  return null;
}
function Cm(r, e, t) {
  var n = t !== "keep" ? r.getContent() : r, a = t !== "keep" ? r.getContent() : e, i = n.getIdentifier(), u = a.getIdentifier(), f = Ar(n, t);
  if (f === null)
    return null;
  var c = an[f][i];
  if (Pe(c, "associativeWith") && c.associativeWith instanceof Array) {
    for (var o = 0; o < c.associativeWith.length; o++)
      if (c.associativeWith[o] === u)
        return !0;
    return !1;
  }
  return null;
}
function $T(r) {
  var e = "OperatorNode:" + r;
  for (var t of an)
    if (e in t)
      return t[e].op;
  return null;
}
var vs = "AssignmentNode", eO = [
  "subset",
  "?matrix",
  // FIXME: should not be needed at all, should be handled by subset
  "Node"
], Hf = /* @__PURE__ */ U(vs, eO, (r) => {
  var {
    subset: e,
    matrix: t,
    Node: n
  } = r, a = u4({
    subset: e
  }), i = _T({
    subset: e,
    matrix: t
  });
  function u(c, o, s) {
    o || (o = "keep");
    var l = Ar(c, o, s), v = Ar(c.value, o, s);
    return o === "all" || v !== null && v <= l;
  }
  class f extends n {
    /**
     * @constructor AssignmentNode
     * @extends {Node}
     *
     * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
     * replace a subset of a matrix like `A[2,2]=42`.
     *
     * Syntax:
     *
     *     new AssignmentNode(symbol, value)
     *     new AssignmentNode(object, index, value)
     *
     * Usage:
     *
     *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))  // a=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode('b'),
     *                       new ConstantNode(2))   // a.b=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode(1, 2),
     *                       new ConstantNode(3))  // a[1,2]=3
     *
     * @param {SymbolNode | AccessorNode} object
     *     Object on which to assign a value
     * @param {IndexNode} [index=null]
     *     Index, property name or matrix index. Optional. If not provided
     *     and `object` is a SymbolNode, the property is assigned to the
     *     global scope.
     * @param {Node} value
     *     The value to be assigned
     */
    constructor(o, s, l) {
      if (super(), this.object = o, this.index = l ? s : null, this.value = l || s, !Ur(o) && !In(o))
        throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      if (Ur(o) && o.name === "end")
        throw new Error('Cannot assign to symbol "end"');
      if (this.index && !aa(this.index))
        throw new TypeError('IndexNode expected as "index"');
      if (!vr(this.value))
        throw new TypeError('Node expected as "value"');
    }
    // class name for typing purposes:
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return vs;
    }
    get isAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(o, s) {
      var l = this.object._compile(o, s), v = this.index ? this.index._compile(o, s) : null, p = this.value._compile(o, s), h = this.object.name;
      if (this.index)
        if (this.index.isObjectProperty()) {
          var d = this.index.getObjectProperty();
          return function(b, w, A) {
            var E = l(b, w, A), N = p(b, w, A);
            return si(E, d, N), N;
          };
        } else {
          if (Ur(this.object))
            return function(b, w, A) {
              var E = l(b, w, A), N = p(b, w, A), C = v(b, w, E);
              return b.set(h, i(E, C, N)), N;
            };
          var x = this.object.object._compile(o, s);
          if (this.object.index.isObjectProperty()) {
            var g = this.object.index.getObjectProperty();
            return function(b, w, A) {
              var E = x(b, w, A), N = At(E, g), C = v(b, w, N), D = p(b, w, A);
              return si(E, g, i(N, C, D)), D;
            };
          } else {
            var y = this.object.index._compile(o, s);
            return function(b, w, A) {
              var E = x(b, w, A), N = y(b, w, E), C = a(E, N), D = v(b, w, C), B = p(b, w, A);
              return i(E, N, i(C, D, B)), B;
            };
          }
        }
      else {
        if (!Ur(this.object))
          throw new TypeError("SymbolNode expected as object");
        return function(b, w, A) {
          var E = p(b, w, A);
          return b.set(h, E), E;
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(o) {
      o(this.object, "object", this), this.index && o(this.index, "index", this), o(this.value, "value", this);
    }
    /**
     * Create a new AssignmentNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AssignmentNode} Returns a transformed copy of the node
     */
    map(o) {
      var s = this._ifNode(o(this.object, "object", this)), l = this.index ? this._ifNode(o(this.index, "index", this)) : null, v = this._ifNode(o(this.value, "value", this));
      return new f(s, l, v);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AssignmentNode}
     */
    clone() {
      return new f(this.object, this.index, this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(o) {
      var s = this.object.toString(o), l = this.index ? this.index.toString(o) : "", v = this.value.toString(o);
      return u(this, o && o.parenthesis, o && o.implicit) && (v = "(" + v + ")"), s + l + " = " + v;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: vs,
        object: this.object,
        index: this.index,
        value: this.value
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
     *     where mathjs is optional
     * @returns {AssignmentNode}
     */
    static fromJSON(o) {
      return new f(o.object, o.index, o.value);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(o) {
      var s = this.object.toHTML(o), l = this.index ? this.index.toHTML(o) : "", v = this.value.toHTML(o);
      return u(this, o && o.parenthesis, o && o.implicit) && (v = '<span class="math-paranthesis math-round-parenthesis">(</span>' + v + '<span class="math-paranthesis math-round-parenthesis">)</span>'), s + l + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + v;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(o) {
      var s = this.object.toTex(o), l = this.index ? this.index.toTex(o) : "", v = this.value.toTex(o);
      return u(this, o && o.parenthesis, o && o.implicit) && (v = "\\left(".concat(v, "\\right)")), s + l + "=" + v;
    }
  }
  return Gr(f, "name", vs), f;
}, {
  isClass: !0,
  isNode: !0
}), ps = "BlockNode", rO = ["ResultSet", "Node"], Lf = /* @__PURE__ */ U(ps, rO, (r) => {
  var {
    ResultSet: e,
    Node: t
  } = r;
  class n extends t {
    /**
     * @constructor BlockNode
     * @extends {Node}
     * Holds a set with blocks
     * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
     *            An array with blocks, where a block is constructed as an
     *            Object with properties block, which is a Node, and visible,
     *            which is a boolean. The property visible is optional and
     *            is true by default
     */
    constructor(i) {
      if (super(), !Array.isArray(i))
        throw new Error("Array expected");
      this.blocks = i.map(function(u) {
        var f = u && u.node, c = u && u.visible !== void 0 ? u.visible : !0;
        if (!vr(f))
          throw new TypeError('Property "node" must be a Node');
        if (typeof c != "boolean")
          throw new TypeError('Property "visible" must be a boolean');
        return {
          node: f,
          visible: c
        };
      });
    }
    get type() {
      return ps;
    }
    get isBlockNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      var f = Rn(this.blocks, function(c) {
        return {
          evaluate: c.node._compile(i, u),
          visible: c.visible
        };
      });
      return function(o, s, l) {
        var v = [];
        return wu(f, function(h) {
          var d = h.evaluate(o, s, l);
          h.visible && v.push(d);
        }), new e(v);
      };
    }
    /**
     * Execute a callback for each of the child blocks of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var u = 0; u < this.blocks.length; u++)
        i(this.blocks[u].node, "blocks[" + u + "].node", this);
    }
    /**
     * Create a new BlockNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {BlockNode} Returns a transformed copy of the node
     */
    map(i) {
      for (var u = [], f = 0; f < this.blocks.length; f++) {
        var c = this.blocks[f], o = this._ifNode(i(c.node, "blocks[" + f + "].node", this));
        u[f] = {
          node: o,
          visible: c.visible
        };
      }
      return new n(u);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {BlockNode}
     */
    clone() {
      var i = this.blocks.map(function(u) {
        return {
          node: u.node,
          visible: u.visible
        };
      });
      return new n(i);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(i) {
      return this.blocks.map(function(u) {
        return u.node.toString(i) + (u.visible ? "" : ";");
      }).join(`
`);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ps,
        blocks: this.blocks
      };
    }
    /**
     * Instantiate an BlockNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
     *     where mathjs is optional
     * @returns {BlockNode}
     */
    static fromJSON(i) {
      return new n(i.blocks);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(i) {
      return this.blocks.map(function(u) {
        return u.node.toHTML(i) + (u.visible ? "" : '<span class="math-separator">;</span>');
      }).join('<span class="math-separator"><br /></span>');
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      return this.blocks.map(function(u) {
        return u.node.toTex(i) + (u.visible ? "" : ";");
      }).join(`\\;\\;
`);
    }
  }
  return Gr(n, "name", ps), n;
}, {
  isClass: !0,
  isNode: !0
}), ds = "ConditionalNode", tO = ["Node"], qf = /* @__PURE__ */ U(ds, tO, (r) => {
  var {
    Node: e
  } = r;
  function t(a) {
    if (typeof a == "number" || typeof a == "boolean" || typeof a == "string")
      return !!a;
    if (a) {
      if (Ue(a))
        return !a.isZero();
      if (Wt(a))
        return !!(a.re || a.im);
      if (yt(a))
        return !!a.value;
    }
    if (a == null)
      return !1;
    throw new TypeError('Unsupported type of condition "' + br(a) + '"');
  }
  class n extends e {
    /**
     * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
     *
     * @param {Node} condition   Condition, must result in a boolean
     * @param {Node} trueExpr    Expression evaluated when condition is true
     * @param {Node} falseExpr   Expression evaluated when condition is true
     *
     * @constructor ConditionalNode
     * @extends {Node}
     */
    constructor(i, u, f) {
      if (super(), !vr(i))
        throw new TypeError("Parameter condition must be a Node");
      if (!vr(u))
        throw new TypeError("Parameter trueExpr must be a Node");
      if (!vr(f))
        throw new TypeError("Parameter falseExpr must be a Node");
      this.condition = i, this.trueExpr = u, this.falseExpr = f;
    }
    get type() {
      return ds;
    }
    get isConditionalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      var f = this.condition._compile(i, u), c = this.trueExpr._compile(i, u), o = this.falseExpr._compile(i, u);
      return function(l, v, p) {
        return t(f(l, v, p)) ? c(l, v, p) : o(l, v, p);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      i(this.condition, "condition", this), i(this.trueExpr, "trueExpr", this), i(this.falseExpr, "falseExpr", this);
    }
    /**
     * Create a new ConditionalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ConditionalNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this._ifNode(i(this.condition, "condition", this)), this._ifNode(i(this.trueExpr, "trueExpr", this)), this._ifNode(i(this.falseExpr, "falseExpr", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConditionalNode}
     */
    clone() {
      return new n(this.condition, this.trueExpr, this.falseExpr);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      var u = i && i.parenthesis ? i.parenthesis : "keep", f = Ar(this, u, i && i.implicit), c = this.condition.toString(i), o = Ar(this.condition, u, i && i.implicit);
      (u === "all" || this.condition.type === "OperatorNode" || o !== null && o <= f) && (c = "(" + c + ")");
      var s = this.trueExpr.toString(i), l = Ar(this.trueExpr, u, i && i.implicit);
      (u === "all" || this.trueExpr.type === "OperatorNode" || l !== null && l <= f) && (s = "(" + s + ")");
      var v = this.falseExpr.toString(i), p = Ar(this.falseExpr, u, i && i.implicit);
      return (u === "all" || this.falseExpr.type === "OperatorNode" || p !== null && p <= f) && (v = "(" + v + ")"), c + " ? " + s + " : " + v;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ds,
        condition: this.condition,
        trueExpr: this.trueExpr,
        falseExpr: this.falseExpr
      };
    }
    /**
     * Instantiate an ConditionalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "ConditionalNode",
     *      "condition": ...,
     *      "trueExpr": ...,
     *      "falseExpr": ...}
     *     ```
     *     where mathjs is optional
     * @returns {ConditionalNode}
     */
    static fromJSON(i) {
      return new n(i.condition, i.trueExpr, i.falseExpr);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      var u = i && i.parenthesis ? i.parenthesis : "keep", f = Ar(this, u, i && i.implicit), c = this.condition.toHTML(i), o = Ar(this.condition, u, i && i.implicit);
      (u === "all" || this.condition.type === "OperatorNode" || o !== null && o <= f) && (c = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var s = this.trueExpr.toHTML(i), l = Ar(this.trueExpr, u, i && i.implicit);
      (u === "all" || this.trueExpr.type === "OperatorNode" || l !== null && l <= f) && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var v = this.falseExpr.toHTML(i), p = Ar(this.falseExpr, u, i && i.implicit);
      return (u === "all" || this.falseExpr.type === "OperatorNode" || p !== null && p <= f) && (v = '<span class="math-parenthesis math-round-parenthesis">(</span>' + v + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c + '<span class="math-operator math-conditional-operator">?</span>' + s + '<span class="math-operator math-conditional-operator">:</span>' + v;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      return "\\begin{cases} {" + this.trueExpr.toTex(i) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(i) + "}\\\\{" + this.falseExpr.toTex(i) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return Gr(n, "name", ds), n;
}, {
  isClass: !0,
  isNode: !0
}), Xm = Object.assign || function(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
  }
  return r;
}, nO = {
  "{": "\\{",
  "}": "\\}",
  "\\": "\\textbackslash{}",
  "#": "\\#",
  $: "\\$",
  "%": "\\%",
  "&": "\\&",
  "^": "\\textasciicircum{}",
  _: "\\_",
  "~": "\\textasciitilde{}"
}, aO = {
  "–": "\\--",
  "—": "\\---",
  " ": "~",
  "	": "\\qquad{}",
  "\r\n": "\\newline{}",
  "\n": "\\newline{}"
}, iO = function(e, t) {
  return Xm({}, e, t);
}, oO = function(r) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.preserveFormatting, n = t === void 0 ? !1 : t, a = e.escapeMapFn, i = a === void 0 ? iO : a, u = String(r), f = "", c = i(Xm({}, nO), n ? Xm({}, aO) : {}), o = Object.keys(c), s = function() {
    var v = !1;
    o.forEach(function(p, h) {
      v || u.length >= p.length && u.slice(0, p.length) === p && (f += c[o[h]], u = u.slice(p.length, u.length), v = !0);
    }), v || (f += u.slice(0, 1), u = u.slice(1, u.length));
  }; u; )
    s();
  return f;
};
const sO = /* @__PURE__ */ Ln(oO);
var jm = {
  // GREEK LETTERS
  Alpha: "A",
  alpha: "\\alpha",
  Beta: "B",
  beta: "\\beta",
  Gamma: "\\Gamma",
  gamma: "\\gamma",
  Delta: "\\Delta",
  delta: "\\delta",
  Epsilon: "E",
  epsilon: "\\epsilon",
  varepsilon: "\\varepsilon",
  Zeta: "Z",
  zeta: "\\zeta",
  Eta: "H",
  eta: "\\eta",
  Theta: "\\Theta",
  theta: "\\theta",
  vartheta: "\\vartheta",
  Iota: "I",
  iota: "\\iota",
  Kappa: "K",
  kappa: "\\kappa",
  varkappa: "\\varkappa",
  Lambda: "\\Lambda",
  lambda: "\\lambda",
  Mu: "M",
  mu: "\\mu",
  Nu: "N",
  nu: "\\nu",
  Xi: "\\Xi",
  xi: "\\xi",
  Omicron: "O",
  omicron: "o",
  Pi: "\\Pi",
  pi: "\\pi",
  varpi: "\\varpi",
  Rho: "P",
  rho: "\\rho",
  varrho: "\\varrho",
  Sigma: "\\Sigma",
  sigma: "\\sigma",
  varsigma: "\\varsigma",
  Tau: "T",
  tau: "\\tau",
  Upsilon: "\\Upsilon",
  upsilon: "\\upsilon",
  Phi: "\\Phi",
  phi: "\\phi",
  varphi: "\\varphi",
  Chi: "X",
  chi: "\\chi",
  Psi: "\\Psi",
  psi: "\\psi",
  Omega: "\\Omega",
  omega: "\\omega",
  // logic
  true: "\\mathrm{True}",
  false: "\\mathrm{False}",
  // other
  i: "i",
  // TODO use \i ??
  inf: "\\infty",
  Inf: "\\infty",
  infinity: "\\infty",
  Infinity: "\\infty",
  oo: "\\infty",
  lim: "\\lim",
  undefined: "\\mathbf{?}"
}, sr = {
  transpose: "^\\top",
  ctranspose: "^H",
  factorial: "!",
  pow: "^",
  dotPow: ".^\\wedge",
  // TODO find ideal solution
  unaryPlus: "+",
  unaryMinus: "-",
  bitNot: "\\~",
  // TODO find ideal solution
  not: "\\neg",
  multiply: "\\cdot",
  divide: "\\frac",
  // TODO how to handle that properly?
  dotMultiply: ".\\cdot",
  // TODO find ideal solution
  dotDivide: ".:",
  // TODO find ideal solution
  mod: "\\mod",
  add: "+",
  subtract: "-",
  to: "\\rightarrow",
  leftShift: "<<",
  rightArithShift: ">>",
  rightLogShift: ">>>",
  equal: "=",
  unequal: "\\neq",
  smaller: "<",
  larger: ">",
  smallerEq: "\\leq",
  largerEq: "\\geq",
  bitAnd: "\\&",
  bitXor: "\\underline{|}",
  bitOr: "|",
  and: "\\wedge",
  xor: "\\veebar",
  or: "\\vee"
}, Sb = {
  // arithmetic
  abs: {
    1: "\\left|${args[0]}\\right|"
  },
  add: {
    2: "\\left(${args[0]}".concat(sr.add, "${args[1]}\\right)")
  },
  cbrt: {
    1: "\\sqrt[3]{${args[0]}}"
  },
  ceil: {
    1: "\\left\\lceil${args[0]}\\right\\rceil"
  },
  cube: {
    1: "\\left(${args[0]}\\right)^3"
  },
  divide: {
    2: "\\frac{${args[0]}}{${args[1]}}"
  },
  dotDivide: {
    2: "\\left(${args[0]}".concat(sr.dotDivide, "${args[1]}\\right)")
  },
  dotMultiply: {
    2: "\\left(${args[0]}".concat(sr.dotMultiply, "${args[1]}\\right)")
  },
  dotPow: {
    2: "\\left(${args[0]}".concat(sr.dotPow, "${args[1]}\\right)")
  },
  exp: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  expm1: "\\left(e".concat(sr.pow, "{${args[0]}}-1\\right)"),
  fix: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  floor: {
    1: "\\left\\lfloor${args[0]}\\right\\rfloor"
  },
  gcd: "\\gcd\\left(${args}\\right)",
  hypot: "\\hypot\\left(${args}\\right)",
  log: {
    1: "\\ln\\left(${args[0]}\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
  },
  log10: {
    1: "\\log_{10}\\left(${args[0]}\\right)"
  },
  log1p: {
    1: "\\ln\\left(${args[0]}+1\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
  },
  log2: "\\log_{2}\\left(${args[0]}\\right)",
  mod: {
    2: "\\left(${args[0]}".concat(sr.mod, "${args[1]}\\right)")
  },
  multiply: {
    2: "\\left(${args[0]}".concat(sr.multiply, "${args[1]}\\right)")
  },
  norm: {
    1: "\\left\\|${args[0]}\\right\\|",
    2: void 0
    // use default template
  },
  nthRoot: {
    2: "\\sqrt[${args[1]}]{${args[0]}}"
  },
  nthRoots: {
    2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
  },
  pow: {
    2: "\\left(${args[0]}\\right)".concat(sr.pow, "{${args[1]}}")
  },
  round: {
    1: "\\left\\lfloor${args[0]}\\right\\rceil",
    2: void 0
    // use default template
  },
  sign: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  sqrt: {
    1: "\\sqrt{${args[0]}}"
  },
  square: {
    1: "\\left(${args[0]}\\right)^2"
  },
  subtract: {
    2: "\\left(${args[0]}".concat(sr.subtract, "${args[1]}\\right)")
  },
  unaryMinus: {
    1: "".concat(sr.unaryMinus, "\\left(${args[0]}\\right)")
  },
  unaryPlus: {
    1: "".concat(sr.unaryPlus, "\\left(${args[0]}\\right)")
  },
  // bitwise
  bitAnd: {
    2: "\\left(${args[0]}".concat(sr.bitAnd, "${args[1]}\\right)")
  },
  bitNot: {
    1: sr.bitNot + "\\left(${args[0]}\\right)"
  },
  bitOr: {
    2: "\\left(${args[0]}".concat(sr.bitOr, "${args[1]}\\right)")
  },
  bitXor: {
    2: "\\left(${args[0]}".concat(sr.bitXor, "${args[1]}\\right)")
  },
  leftShift: {
    2: "\\left(${args[0]}".concat(sr.leftShift, "${args[1]}\\right)")
  },
  rightArithShift: {
    2: "\\left(${args[0]}".concat(sr.rightArithShift, "${args[1]}\\right)")
  },
  rightLogShift: {
    2: "\\left(${args[0]}".concat(sr.rightLogShift, "${args[1]}\\right)")
  },
  // combinatorics
  bellNumbers: {
    1: "\\mathrm{B}_{${args[0]}}"
  },
  catalan: {
    1: "\\mathrm{C}_{${args[0]}}"
  },
  stirlingS2: {
    2: "\\mathrm{S}\\left(${args}\\right)"
  },
  // complex
  arg: {
    1: "\\arg\\left(${args[0]}\\right)"
  },
  conj: {
    1: "\\left(${args[0]}\\right)^*"
  },
  im: {
    1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  re: {
    1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  // logical
  and: {
    2: "\\left(${args[0]}".concat(sr.and, "${args[1]}\\right)")
  },
  not: {
    1: sr.not + "\\left(${args[0]}\\right)"
  },
  or: {
    2: "\\left(${args[0]}".concat(sr.or, "${args[1]}\\right)")
  },
  xor: {
    2: "\\left(${args[0]}".concat(sr.xor, "${args[1]}\\right)")
  },
  // matrix
  cross: {
    2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
  },
  ctranspose: {
    1: "\\left(${args[0]}\\right)".concat(sr.ctranspose)
  },
  det: {
    1: "\\det\\left(${args[0]}\\right)"
  },
  dot: {
    2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
  },
  expm: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  inv: {
    1: "\\left(${args[0]}\\right)^{-1}"
  },
  pinv: {
    1: "\\left(${args[0]}\\right)^{+}"
  },
  sqrtm: {
    1: "{${args[0]}}".concat(sr.pow, "{\\frac{1}{2}}")
  },
  trace: {
    1: "\\mathrm{tr}\\left(${args[0]}\\right)"
  },
  transpose: {
    1: "\\left(${args[0]}\\right)".concat(sr.transpose)
  },
  // probability
  combinations: {
    2: "\\binom{${args[0]}}{${args[1]}}"
  },
  combinationsWithRep: {
    2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
  },
  factorial: {
    1: "\\left(${args[0]}\\right)".concat(sr.factorial)
  },
  gamma: {
    1: "\\Gamma\\left(${args[0]}\\right)"
  },
  lgamma: {
    1: "\\ln\\Gamma\\left(${args[0]}\\right)"
  },
  // relational
  equal: {
    2: "\\left(${args[0]}".concat(sr.equal, "${args[1]}\\right)")
  },
  larger: {
    2: "\\left(${args[0]}".concat(sr.larger, "${args[1]}\\right)")
  },
  largerEq: {
    2: "\\left(${args[0]}".concat(sr.largerEq, "${args[1]}\\right)")
  },
  smaller: {
    2: "\\left(${args[0]}".concat(sr.smaller, "${args[1]}\\right)")
  },
  smallerEq: {
    2: "\\left(${args[0]}".concat(sr.smallerEq, "${args[1]}\\right)")
  },
  unequal: {
    2: "\\left(${args[0]}".concat(sr.unequal, "${args[1]}\\right)")
  },
  // special
  erf: {
    1: "erf\\left(${args[0]}\\right)"
  },
  // statistics
  max: "\\max\\left(${args}\\right)",
  min: "\\min\\left(${args}\\right)",
  variance: "\\mathrm{Var}\\left(${args}\\right)",
  // trigonometry
  acos: {
    1: "\\cos^{-1}\\left(${args[0]}\\right)"
  },
  acosh: {
    1: "\\cosh^{-1}\\left(${args[0]}\\right)"
  },
  acot: {
    1: "\\cot^{-1}\\left(${args[0]}\\right)"
  },
  acoth: {
    1: "\\coth^{-1}\\left(${args[0]}\\right)"
  },
  acsc: {
    1: "\\csc^{-1}\\left(${args[0]}\\right)"
  },
  acsch: {
    1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
  },
  asec: {
    1: "\\sec^{-1}\\left(${args[0]}\\right)"
  },
  asech: {
    1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
  },
  asin: {
    1: "\\sin^{-1}\\left(${args[0]}\\right)"
  },
  asinh: {
    1: "\\sinh^{-1}\\left(${args[0]}\\right)"
  },
  atan: {
    1: "\\tan^{-1}\\left(${args[0]}\\right)"
  },
  atan2: {
    2: "\\mathrm{atan2}\\left(${args}\\right)"
  },
  atanh: {
    1: "\\tanh^{-1}\\left(${args[0]}\\right)"
  },
  cos: {
    1: "\\cos\\left(${args[0]}\\right)"
  },
  cosh: {
    1: "\\cosh\\left(${args[0]}\\right)"
  },
  cot: {
    1: "\\cot\\left(${args[0]}\\right)"
  },
  coth: {
    1: "\\coth\\left(${args[0]}\\right)"
  },
  csc: {
    1: "\\csc\\left(${args[0]}\\right)"
  },
  csch: {
    1: "\\mathrm{csch}\\left(${args[0]}\\right)"
  },
  sec: {
    1: "\\sec\\left(${args[0]}\\right)"
  },
  sech: {
    1: "\\mathrm{sech}\\left(${args[0]}\\right)"
  },
  sin: {
    1: "\\sin\\left(${args[0]}\\right)"
  },
  sinh: {
    1: "\\sinh\\left(${args[0]}\\right)"
  },
  tan: {
    1: "\\tan\\left(${args[0]}\\right)"
  },
  tanh: {
    1: "\\tanh\\left(${args[0]}\\right)"
  },
  // unit
  to: {
    2: "\\left(${args[0]}".concat(sr.to, "${args[1]}\\right)")
  },
  // utils
  numeric: function(e, t) {
    return e.args[0].toTex();
  },
  // type
  number: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  },
  string: {
    0: '\\mathtt{""}',
    1: "\\mathrm{string}\\left(${args[0]}\\right)"
  },
  bignumber: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  complex: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)+".concat(jm.i, "\\cdot\\left(${args[1]}\\right)\\right)")
  },
  matrix: {
    0: "\\begin{bmatrix}\\end{bmatrix}",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(${args[0]}\\right)"
  },
  sparse: {
    0: "\\begin{bsparse}\\end{bsparse}",
    1: "\\left(${args[0]}\\right)"
  },
  unit: {
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  }
}, uO = "\\mathrm{${name}}\\left(${args}\\right)", Pb = {
  deg: "^\\circ"
};
function Gm(r) {
  return sO(r, {
    preserveFormatting: !0
  });
}
function c4(r, e) {
  return e = typeof e > "u" ? !1 : e, e ? Pe(Pb, r) ? Pb[r] : "\\mathrm{" + Gm(r) + "}" : Pe(jm, r) ? jm[r] : Gm(r);
}
var ms = "ConstantNode", cO = ["Node"], Uf = /* @__PURE__ */ U(ms, cO, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * A ConstantNode holds a constant value like a number or string.
     *
     * Usage:
     *
     *     new ConstantNode(2.3)
     *     new ConstantNode('hello')
     *
     * @param {*} value    Value can be any type (number, BigNumber, string, ...)
     * @constructor ConstantNode
     * @extends {Node}
     */
    constructor(a) {
      super(), this.value = a;
    }
    get type() {
      return ms;
    }
    get isConstantNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var u = this.value;
      return function() {
        return u;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
    }
    /**
     * Create a new ConstantNode with children produced by the given callback.
     * Trivial because there are no children.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ConstantNode} Returns a clone of the node
     */
    map(a) {
      return this.clone();
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConstantNode}
     */
    clone() {
      return new t(this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(a) {
      return Ke(this.value, a);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(a) {
      var i = this._toString(a);
      switch (br(this.value)) {
        case "number":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + i + "</span>";
        case "string":
          return '<span class="math-string">' + i + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + i + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + i + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + i + "</span>";
        default:
          return '<span class="math-symbol">' + i + "</span>";
      }
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ms,
        value: this.value
      };
    }
    /**
     * Instantiate a ConstantNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", value: 2.3}`,
     *                       where mathjs is optional
     * @returns {ConstantNode}
     */
    static fromJSON(a) {
      return new t(a.value);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      var i = this._toString(a), u = br(this.value);
      switch (u) {
        case "string":
          return "\\mathtt{" + Gm(i) + "}";
        case "number":
        case "BigNumber": {
          var f = u === "BigNumber" ? this.value.isFinite() : isFinite(this.value);
          if (!f)
            return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var c = i.toLowerCase().indexOf("e");
          return c !== -1 ? i.substring(0, c) + "\\cdot10^{" + i.substring(c + 1) + "}" : i;
        }
        case "Fraction":
          return this.value.toLatex();
        default:
          return i;
      }
    }
  }
  return Gr(t, "name", ms), t;
}, {
  isClass: !0,
  isNode: !0
}), hs = "FunctionAssignmentNode", lO = ["typed", "Node"], kf = /* @__PURE__ */ U(hs, lO, (r) => {
  var {
    typed: e,
    Node: t
  } = r;
  function n(i, u, f) {
    var c = Ar(i, u, f), o = Ar(i.expr, u, f);
    return u === "all" || o !== null && o <= c;
  }
  class a extends t {
    /**
     * @constructor FunctionAssignmentNode
     * @extends {Node}
     * Function assignment
     *
     * @param {string} name           Function name
     * @param {string[] | Array.<{name: string, type: string}>} params
     *                                Array with function parameter names, or an
     *                                array with objects containing the name
     *                                and type of the parameter
     * @param {Node} expr             The function expression
     */
    constructor(u, f, c) {
      if (super(), typeof u != "string")
        throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(f))
        throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!vr(c))
        throw new TypeError('Node expected for parameter "expr"');
      if (s4.has(u))
        throw new Error('Illegal function name, "' + u + '" is a reserved keyword');
      var o = /* @__PURE__ */ new Set();
      for (var s of f) {
        var l = typeof s == "string" ? s : s.name;
        if (o.has(l))
          throw new Error('Duplicate parameter name "'.concat(l, '"'));
        o.add(l);
      }
      this.name = u, this.params = f.map(function(v) {
        return v && v.name || v;
      }), this.types = f.map(function(v) {
        return v && v.type || "any";
      }), this.expr = c;
    }
    get type() {
      return hs;
    }
    get isFunctionAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(u, f) {
      var c = Object.create(f);
      wu(this.params, function(h) {
        c[h] = !0;
      });
      var o = this.expr._compile(u, c), s = this.name, l = this.params, v = Px(this.types, ","), p = s + "(" + Px(this.params, ", ") + ")";
      return function(d, x, g) {
        var y = {};
        y[v] = function() {
          for (var b = Object.create(x), w = 0; w < l.length; w++)
            b[l[w]] = arguments[w];
          return o(d, b, g);
        };
        var m = e(s, y);
        return m.syntax = p, d.set(s, m), m;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(u) {
      u(this.expr, "expr", this);
    }
    /**
     * Create a new FunctionAssignmentNode whose children are the results of
     * calling the provided callback function for each child of the original
     * node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
     */
    map(u) {
      var f = this._ifNode(u(this.expr, "expr", this));
      return new a(this.name, this.params.slice(0), f);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionAssignmentNode}
     */
    clone() {
      return new a(this.name, this.params.slice(0), this.expr);
    }
    /**
     * get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(u) {
      var f = u && u.parenthesis ? u.parenthesis : "keep", c = this.expr.toString(u);
      return n(this, f, u && u.implicit) && (c = "(" + c + ")"), this.name + "(" + this.params.join(", ") + ") = " + c;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      var u = this.types;
      return {
        mathjs: hs,
        name: this.name,
        params: this.params.map(function(f, c) {
          return {
            name: f,
            type: u[c]
          };
        }),
        expr: this.expr
      };
    }
    /**
     * Instantiate an FunctionAssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "FunctionAssignmentNode",
     *      name: ..., params: ..., expr: ...}
     *     ```
     *     where mathjs is optional
     * @returns {FunctionAssignmentNode}
     */
    static fromJSON(u) {
      return new a(u.name, u.params, u.expr);
    }
    /**
     * get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(u) {
      for (var f = u && u.parenthesis ? u.parenthesis : "keep", c = [], o = 0; o < this.params.length; o++)
        c.push('<span class="math-symbol math-parameter">' + Zt(this.params[o]) + "</span>");
      var s = this.expr.toHTML(u);
      return n(this, f, u && u.implicit) && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + Zt(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + c.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + s;
    }
    /**
     * get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(u) {
      var f = u && u.parenthesis ? u.parenthesis : "keep", c = this.expr.toTex(u);
      return n(this, f, u && u.implicit) && (c = "\\left(".concat(c, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(c4).join(",") + "\\right)=" + c;
    }
  }
  return Gr(a, "name", hs), a;
}, {
  isClass: !0,
  isNode: !0
}), gs = "IndexNode", fO = ["Node", "size"], Xf = /* @__PURE__ */ U(gs, fO, (r) => {
  var {
    Node: e,
    size: t
  } = r;
  class n extends e {
    /**
     * @constructor IndexNode
     * @extends Node
     *
     * Describes a subset of a matrix or an object property.
     * Cannot be used on its own, needs to be used within an AccessorNode or
     * AssignmentNode.
     *
     * @param {Node[]} dimensions
     * @param {boolean} [dotNotation=false]
     *     Optional property describing whether this index was written using dot
     *     notation like `a.b`, or using bracket notation like `a["b"]`
     *     (which is the default). This property is used for string conversion.
     */
    constructor(i, u) {
      if (super(), this.dimensions = i, this.dotNotation = u || !1, !Array.isArray(i) || !i.every(vr))
        throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty())
        throw new Error("dotNotation only applicable for object properties");
    }
    get type() {
      return gs;
    }
    get isIndexNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      var f = Rn(this.dimensions, function(o, s) {
        var l = o.filter((h) => h.isSymbolNode && h.name === "end").length > 0;
        if (l) {
          var v = Object.create(u);
          v.end = !0;
          var p = o._compile(i, v);
          return function(d, x, g) {
            if (!Oe(g) && !ur(g) && !Wr(g))
              throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + br(g));
            var y = t(g).valueOf(), m = Object.create(x);
            return m.end = y[s], p(d, m, g);
          };
        } else
          return o._compile(i, u);
      }), c = At(i, "index");
      return function(s, l, v) {
        var p = Rn(f, function(h) {
          return h(s, l, v);
        });
        return c(...p);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var u = 0; u < this.dimensions.length; u++)
        i(this.dimensions[u], "dimensions[" + u + "]", this);
    }
    /**
     * Create a new IndexNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {IndexNode} Returns a transformed copy of the node
     */
    map(i) {
      for (var u = [], f = 0; f < this.dimensions.length; f++)
        u[f] = this._ifNode(i(this.dimensions[f], "dimensions[" + f + "]", this));
      return new n(u, this.dotNotation);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {IndexNode}
     */
    clone() {
      return new n(this.dimensions.slice(0), this.dotNotation);
    }
    /**
     * Test whether this IndexNode contains a single property name
     * @return {boolean}
     */
    isObjectProperty() {
      return this.dimensions.length === 1 && ar(this.dimensions[0]) && typeof this.dimensions[0].value == "string";
    }
    /**
     * Returns the property name if IndexNode contains a property.
     * If not, returns null.
     * @return {string | null}
     */
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: gs,
        dimensions: this.dimensions,
        dotNotation: this.dotNotation
      };
    }
    /**
     * Instantiate an IndexNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
     *     where mathjs is optional
     * @returns {IndexNode}
     */
    static fromJSON(i) {
      return new n(i.dimensions, i.dotNotation);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      for (var u = [], f = 0; f < this.dimensions.length; f++)
        u[f] = this.dimensions[f].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + Zt(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + u.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var u = this.dimensions.map(function(f) {
        return f.toTex(i);
      });
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + u.join(",") + "}";
    }
  }
  return Gr(n, "name", gs), n;
}, {
  isClass: !0,
  isNode: !0
}), xs = "ObjectNode", vO = ["Node"], jf = /* @__PURE__ */ U(xs, vO, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ObjectNode
     * @extends {Node}
     * Holds an object with keys/values
     * @param {Object.<string, Node>} [properties]   object with key/value pairs
     */
    constructor(a) {
      if (super(), this.properties = a || {}, a && (typeof a != "object" || !Object.keys(a).every(function(i) {
        return vr(a[i]);
      })))
        throw new TypeError("Object containing Nodes expected");
    }
    get type() {
      return xs;
    }
    get isObjectNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      var u = {};
      for (var f in this.properties)
        if (Pe(this.properties, f)) {
          var c = $a(f), o = JSON.parse(c), s = At(this.properties, f);
          u[o] = s._compile(a, i);
        }
      return function(v, p, h) {
        var d = {};
        for (var x in u)
          Pe(u, x) && (d[x] = u[x](v, p, h));
        return d;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      for (var i in this.properties)
        Pe(this.properties, i) && a(this.properties[i], "properties[" + $a(i) + "]", this);
    }
    /**
     * Create a new ObjectNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ObjectNode} Returns a transformed copy of the node
     */
    map(a) {
      var i = {};
      for (var u in this.properties)
        Pe(this.properties, u) && (i[u] = this._ifNode(a(this.properties[u], "properties[" + $a(u) + "]", this)));
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ObjectNode}
     */
    clone() {
      var a = {};
      for (var i in this.properties)
        Pe(this.properties, i) && (a[i] = this.properties[i]);
      return new t(a);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      var i = [];
      for (var u in this.properties)
        Pe(this.properties, u) && i.push($a(u) + ": " + this.properties[u].toString(a));
      return "{" + i.join(", ") + "}";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: xs,
        properties: this.properties
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
     *                       where mathjs is optional
     * @returns {ObjectNode}
     */
    static fromJSON(a) {
      return new t(a.properties);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      var i = [];
      for (var u in this.properties)
        Pe(this.properties, u) && i.push('<span class="math-symbol math-property">' + Zt(u) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[u].toHTML(a));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + i.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(a) {
      var i = [];
      for (var u in this.properties)
        Pe(this.properties, u) && i.push("\\mathbf{" + u + ":} & " + this.properties[u].toTex(a) + "\\\\");
      var f = "\\left\\{\\begin{array}{ll}" + i.join(`
`) + "\\end{array}\\right\\}";
      return f;
    }
  }
  return Gr(t, "name", xs), t;
}, {
  isClass: !0,
  isNode: !0
});
function Wi(r, e) {
  return new z2(r, new fu(e), new Set(Object.keys(e)));
}
var ys = "OperatorNode", pO = ["Node"], Gf = /* @__PURE__ */ U(ys, pO, (r) => {
  var {
    Node: e
  } = r;
  function t(i, u) {
    var f = i;
    if (u === "auto")
      for (; un(f); )
        f = f.content;
    return ar(f) ? !0 : zr(f) ? t(f.args[0], u) : !1;
  }
  function n(i, u, f, c, o) {
    var s = Ar(i, u, f), l = Qi(i, u);
    if (u === "all" || c.length > 2 && i.getIdentifier() !== "OperatorNode:add" && i.getIdentifier() !== "OperatorNode:multiply")
      return c.map(function(D) {
        switch (D.getContent().type) {
          case "ArrayNode":
          case "ConstantNode":
          case "SymbolNode":
          case "ParenthesisNode":
            return !1;
          default:
            return !0;
        }
      });
    var v;
    switch (c.length) {
      case 0:
        v = [];
        break;
      case 1:
        {
          var p = Ar(c[0], u, f, i);
          if (o && p !== null) {
            var h, d;
            if (u === "keep" ? (h = c[0].getIdentifier(), d = i.getIdentifier()) : (h = c[0].getContent().getIdentifier(), d = i.getContent().getIdentifier()), an[s][d].latexLeftParens === !1) {
              v = [!1];
              break;
            }
            if (an[p][h].latexParens === !1) {
              v = [!1];
              break;
            }
          }
          if (p === null) {
            v = [!1];
            break;
          }
          if (p <= s) {
            v = [!0];
            break;
          }
          v = [!1];
        }
        break;
      case 2:
        {
          var x, g = Ar(c[0], u, f, i), y = Cm(i, c[0], u);
          g === null ? x = !1 : g === s && l === "right" && !y || g < s ? x = !0 : x = !1;
          var m, b = Ar(c[1], u, f, i), w = Cm(i, c[1], u);
          if (b === null ? m = !1 : b === s && l === "left" && !w || b < s ? m = !0 : m = !1, o) {
            var A, E, N;
            u === "keep" ? (A = i.getIdentifier(), E = i.args[0].getIdentifier(), N = i.args[1].getIdentifier()) : (A = i.getContent().getIdentifier(), E = i.args[0].getContent().getIdentifier(), N = i.args[1].getContent().getIdentifier()), g !== null && (an[s][A].latexLeftParens === !1 && (x = !1), an[g][E].latexParens === !1 && (x = !1)), b !== null && (an[s][A].latexRightParens === !1 && (m = !1), an[b][N].latexParens === !1 && (m = !1));
          }
          v = [x, m];
        }
        break;
      default:
        (i.getIdentifier() === "OperatorNode:add" || i.getIdentifier() === "OperatorNode:multiply") && (v = c.map(function(D) {
          var B = Ar(D, u, f, i), S = Cm(i, D, u), F = Qi(D, u);
          return B === null ? !1 : s === B && l === F && !S ? !0 : B < s;
        }));
        break;
    }
    if (c.length >= 2 && i.getIdentifier() === "OperatorNode:multiply" && i.implicit && u !== "all" && f === "hide")
      for (var C = 1; C < v.length; ++C)
        t(c[C], u) && !v[C - 1] && (u !== "keep" || !un(c[C - 1])) && (v[C] = !0);
    return v;
  }
  class a extends e {
    /**
     * @constructor OperatorNode
     * @extends {Node}
     * An operator with two arguments, like 2+3
     *
     * @param {string} op           Operator name, for example '+'
     * @param {string} fn           Function name, for example 'add'
     * @param {Node[]} args         Operator arguments
     * @param {boolean} [implicit]  Is this an implicit multiplication?
     * @param {boolean} [isPercentage] Is this an percentage Operation?
     */
    constructor(u, f, c, o, s) {
      if (super(), typeof u != "string")
        throw new TypeError('string expected for parameter "op"');
      if (typeof f != "string")
        throw new TypeError('string expected for parameter "fn"');
      if (!Array.isArray(c) || !c.every(vr))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = o === !0, this.isPercentage = s === !0, this.op = u, this.fn = f, this.args = c || [];
    }
    get type() {
      return ys;
    }
    get isOperatorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(u, f) {
      if (typeof this.fn != "string" || !hh(u, this.fn))
        throw u[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
      var c = At(u, this.fn), o = Rn(this.args, function(h) {
        return h._compile(u, f);
      });
      if (typeof c == "function" && c.rawArgs === !0) {
        var s = this.args;
        return function(d, x, g) {
          return c(s, u, Wi(d, x));
        };
      } else if (o.length === 1) {
        var l = o[0];
        return function(d, x, g) {
          return c(l(d, x, g));
        };
      } else if (o.length === 2) {
        var v = o[0], p = o[1];
        return function(d, x, g) {
          return c(v(d, x, g), p(d, x, g));
        };
      } else
        return function(d, x, g) {
          return c.apply(null, Rn(o, function(y) {
            return y(d, x, g);
          }));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(u) {
      for (var f = 0; f < this.args.length; f++)
        u(this.args[f], "args[" + f + "]", this);
    }
    /**
     * Create a new OperatorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(u) {
      for (var f = [], c = 0; c < this.args.length; c++)
        f[c] = this._ifNode(u(this.args[c], "args[" + c + "]", this));
      return new a(this.op, this.fn, f, this.implicit, this.isPercentage);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {OperatorNode}
     */
    clone() {
      return new a(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    /**
     * Check whether this is an unary OperatorNode:
     * has exactly one argument, like `-a`.
     * @return {boolean}
     *     Returns true when an unary operator node, false otherwise.
     */
    isUnary() {
      return this.args.length === 1;
    }
    /**
     * Check whether this is a binary OperatorNode:
     * has exactly two arguments, like `a + b`.
     * @return {boolean}
     *     Returns true when a binary operator node, false otherwise.
     */
    isBinary() {
      return this.args.length === 2;
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(u) {
      var f = u && u.parenthesis ? u.parenthesis : "keep", c = u && u.implicit ? u.implicit : "hide", o = this.args, s = n(this, f, c, o, !1);
      if (o.length === 1) {
        var l = Qi(this, f), v = o[0].toString(u);
        s[0] && (v = "(" + v + ")");
        var p = /[a-zA-Z]+/.test(this.op);
        return l === "right" ? this.op + (p ? " " : "") + v : l === "left" ? v + (p ? " " : "") + this.op : v + this.op;
      } else if (o.length === 2) {
        var h = o[0].toString(u), d = o[1].toString(u);
        return s[0] && (h = "(" + h + ")"), s[1] && (d = "(" + d + ")"), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? h + " " + d : h + " " + this.op + " " + d;
      } else if (o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var x = o.map(function(g, y) {
          return g = g.toString(u), s[y] && (g = "(" + g + ")"), g;
        });
        return this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? x.join(" ") : x.join(" " + this.op + " ");
      } else
        return this.fn + "(" + this.args.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ys,
        op: this.op,
        fn: this.fn,
        args: this.args,
        implicit: this.implicit,
        isPercentage: this.isPercentage
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "OperatorNode",
     *      "op": "+", "fn": "add", "args": [...],
     *      "implicit": false,
     *      "isPercentage":false}
     *     ```
     *     where mathjs is optional
     * @returns {OperatorNode}
     */
    static fromJSON(u) {
      return new a(u.op, u.fn, u.args, u.implicit, u.isPercentage);
    }
    /**
     * Get HTML representation.
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(u) {
      var f = u && u.parenthesis ? u.parenthesis : "keep", c = u && u.implicit ? u.implicit : "hide", o = this.args, s = n(this, f, c, o, !1);
      if (o.length === 1) {
        var l = Qi(this, f), v = o[0].toHTML(u);
        return s[0] && (v = '<span class="math-parenthesis math-round-parenthesis">(</span>' + v + '<span class="math-parenthesis math-round-parenthesis">)</span>'), l === "right" ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + Zt(this.op) + "</span>" + v : v + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + Zt(this.op) + "</span>";
      } else if (o.length === 2) {
        var p = o[0].toHTML(u), h = o[1].toHTML(u);
        return s[0] && (p = '<span class="math-parenthesis math-round-parenthesis">(</span>' + p + '<span class="math-parenthesis math-round-parenthesis">)</span>'), s[1] && (h = '<span class="math-parenthesis math-round-parenthesis">(</span>' + h + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? p + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + h : p + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Zt(this.op) + "</span>" + h;
      } else {
        var d = o.map(function(x, g) {
          return x = x.toHTML(u), s[g] && (x = '<span class="math-parenthesis math-round-parenthesis">(</span>' + x + '<span class="math-parenthesis math-round-parenthesis">)</span>'), x;
        });
        return o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply") ? this.implicit && this.getIdentifier() === "OperatorNode:multiply" && c === "hide" ? d.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : d.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Zt(this.op) + "</span>") : '<span class="math-function">' + Zt(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + d.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(u) {
      var f = u && u.parenthesis ? u.parenthesis : "keep", c = u && u.implicit ? u.implicit : "hide", o = this.args, s = n(this, f, c, o, !0), l = sr[this.fn];
      if (l = typeof l > "u" ? this.op : l, o.length === 1) {
        var v = Qi(this, f), p = o[0].toTex(u);
        return s[0] && (p = "\\left(".concat(p, "\\right)")), v === "right" ? l + p : p + l;
      } else if (o.length === 2) {
        var h = o[0], d = h.toTex(u);
        s[0] && (d = "\\left(".concat(d, "\\right)"));
        var x = o[1], g = x.toTex(u);
        s[1] && (g = "\\left(".concat(g, "\\right)"));
        var y;
        switch (f === "keep" ? y = h.getIdentifier() : y = h.getContent().getIdentifier(), this.getIdentifier()) {
          case "OperatorNode:divide":
            return l + "{" + d + "}{" + g + "}";
          case "OperatorNode:pow":
            switch (d = "{" + d + "}", g = "{" + g + "}", y) {
              case "ConditionalNode":
              case "OperatorNode:divide":
                d = "\\left(".concat(d, "\\right)");
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && c === "hide")
              return d + "~" + g;
        }
        return d + l + g;
      } else if (o.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var m = o.map(function(b, w) {
          return b = b.toTex(u), s[w] && (b = "\\left(".concat(b, "\\right)")), b;
        });
        return this.getIdentifier() === "OperatorNode:multiply" && this.implicit && c === "hide" ? m.join("~") : m.join(l);
      } else
        return "\\mathrm{" + this.fn + "}\\left(" + o.map(function(b) {
          return b.toTex(u);
        }).join(",") + "\\right)";
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return Gr(a, "name", ys), a;
}, {
  isClass: !0,
  isNode: !0
}), As = "ParenthesisNode", dO = ["Node"], Vf = /* @__PURE__ */ U(As, dO, (r) => {
  var {
    Node: e
  } = r;
  class t extends e {
    /**
     * @constructor ParenthesisNode
     * @extends {Node}
     * A parenthesis node describes manual parenthesis from the user input
     * @param {Node} content
     * @extends {Node}
     */
    constructor(a) {
      if (super(), !vr(a))
        throw new TypeError('Node expected for parameter "content"');
      this.content = a;
    }
    get type() {
      return As;
    }
    get isParenthesisNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(a, i) {
      return this.content._compile(a, i);
    }
    /**
     * Get the content of the current Node.
     * @return {Node} content
     * @override
     **/
    getContent() {
      return this.content.getContent();
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(a) {
      a(this.content, "content", this);
    }
    /**
     * Create a new ParenthesisNode whose child is the result of calling
     * the provided callback function on the child of this node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ParenthesisNode} Returns a clone of the node
     */
    map(a) {
      var i = a(this.content, "content", this);
      return new t(i);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ParenthesisNode}
     */
    clone() {
      return new t(this.content);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "(" + this.content.toString(a) + ")" : this.content.toString(a);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: As,
        content: this.content
      };
    }
    /**
     * Instantiate an ParenthesisNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
     *                       where mathjs is optional
     * @returns {ParenthesisNode}
     */
    static fromJSON(a) {
      return new t(a.content);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(a) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(a);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(a) {
      return !a || a && !a.parenthesis || a && a.parenthesis === "keep" ? "\\left(".concat(this.content.toTex(a), "\\right)") : this.content.toTex(a);
    }
  }
  return Gr(t, "name", As), t;
}, {
  isClass: !0,
  isNode: !0
}), bs = "RangeNode", mO = ["Node"], Qf = /* @__PURE__ */ U(bs, mO, (r) => {
  var {
    Node: e
  } = r;
  function t(a, i, u) {
    var f = Ar(a, i, u), c = {}, o = Ar(a.start, i, u);
    if (c.start = o !== null && o <= f || i === "all", a.step) {
      var s = Ar(a.step, i, u);
      c.step = s !== null && s <= f || i === "all";
    }
    var l = Ar(a.end, i, u);
    return c.end = l !== null && l <= f || i === "all", c;
  }
  class n extends e {
    /**
     * @constructor RangeNode
     * @extends {Node}
     * create a range
     * @param {Node} start  included lower-bound
     * @param {Node} end    included upper-bound
     * @param {Node} [step] optional step
     */
    constructor(i, u, f) {
      if (super(), !vr(i))
        throw new TypeError("Node expected");
      if (!vr(u))
        throw new TypeError("Node expected");
      if (f && !vr(f))
        throw new TypeError("Node expected");
      if (arguments.length > 3)
        throw new Error("Too many arguments");
      this.start = i, this.end = u, this.step = f || null;
    }
    get type() {
      return bs;
    }
    get isRangeNode() {
      return !0;
    }
    /**
     * Check whether the RangeNode needs the `end` symbol to be defined.
     * This end is the size of the Matrix in current dimension.
     * @return {boolean}
     */
    needsEnd() {
      var i = this.filter(function(u) {
        return Ur(u) && u.name === "end";
      });
      return i.length > 0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      var f = i.range, c = this.start._compile(i, u), o = this.end._compile(i, u);
      if (this.step) {
        var s = this.step._compile(i, u);
        return function(v, p, h) {
          return f(c(v, p, h), o(v, p, h), s(v, p, h));
        };
      } else
        return function(v, p, h) {
          return f(c(v, p, h), o(v, p, h));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      i(this.start, "start", this), i(this.end, "end", this), this.step && i(this.step, "step", this);
    }
    /**
     * Create a new RangeNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RangeNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this._ifNode(i(this.start, "start", this)), this._ifNode(i(this.end, "end", this)), this.step && this._ifNode(i(this.step, "step", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RangeNode}
     */
    clone() {
      return new n(this.start, this.end, this.step && this.step);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      var u = i && i.parenthesis ? i.parenthesis : "keep", f = t(this, u, i && i.implicit), c, o = this.start.toString(i);
      if (f.start && (o = "(" + o + ")"), c = o, this.step) {
        var s = this.step.toString(i);
        f.step && (s = "(" + s + ")"), c += ":" + s;
      }
      var l = this.end.toString(i);
      return f.end && (l = "(" + l + ")"), c += ":" + l, c;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: bs,
        start: this.start,
        end: this.end,
        step: this.step
      };
    }
    /**
     * Instantiate an RangeNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
     *     where mathjs is optional
     * @returns {RangeNode}
     */
    static fromJSON(i) {
      return new n(i.start, i.end, i.step);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      var u = i && i.parenthesis ? i.parenthesis : "keep", f = t(this, u, i && i.implicit), c, o = this.start.toHTML(i);
      if (f.start && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c = o, this.step) {
        var s = this.step.toHTML(i);
        f.step && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c += '<span class="math-operator math-range-operator">:</span>' + s;
      }
      var l = this.end.toHTML(i);
      return f.end && (l = '<span class="math-parenthesis math-round-parenthesis">(</span>' + l + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c += '<span class="math-operator math-range-operator">:</span>' + l, c;
    }
    /**
     * Get LaTeX representation
     * @params {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var u = i && i.parenthesis ? i.parenthesis : "keep", f = t(this, u, i && i.implicit), c = this.start.toTex(i);
      if (f.start && (c = "\\left(".concat(c, "\\right)")), this.step) {
        var o = this.step.toTex(i);
        f.step && (o = "\\left(".concat(o, "\\right)")), c += ":" + o;
      }
      var s = this.end.toTex(i);
      return f.end && (s = "\\left(".concat(s, "\\right)")), c += ":" + s, c;
    }
  }
  return Gr(n, "name", bs), n;
}, {
  isClass: !0,
  isNode: !0
}), ws = "RelationalNode", hO = ["Node"], Yf = /* @__PURE__ */ U(ws, hO, (r) => {
  var {
    Node: e
  } = r, t = {
    equal: "==",
    unequal: "!=",
    smaller: "<",
    larger: ">",
    smallerEq: "<=",
    largerEq: ">="
  };
  class n extends e {
    /**
     * A node representing a chained conditional expression, such as 'x > y > z'
     *
     * @param {String[]} conditionals
     *     An array of conditional operators used to compare the parameters
     * @param {Node[]} params
     *     The parameters that will be compared
     *
     * @constructor RelationalNode
     * @extends {Node}
     */
    constructor(i, u) {
      if (super(), !Array.isArray(i))
        throw new TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(u))
        throw new TypeError("Parameter params must be an array");
      if (i.length !== u.length - 1)
        throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = i, this.params = u;
    }
    get type() {
      return ws;
    }
    get isRelationalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, u) {
      var f = this, c = this.params.map((o) => o._compile(i, u));
      return function(s, l, v) {
        for (var p, h = c[0](s, l, v), d = 0; d < f.conditionals.length; d++) {
          p = h, h = c[d + 1](s, l, v);
          var x = At(i, f.conditionals[d]);
          if (!x(p, h))
            return !1;
        }
        return !0;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      this.params.forEach((u, f) => i(u, "params[" + f + "]", this), this);
    }
    /**
     * Create a new RelationalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RelationalNode} Returns a transformed copy of the node
     */
    map(i) {
      return new n(this.conditionals.slice(), this.params.map((u, f) => this._ifNode(i(u, "params[" + f + "]", this)), this));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RelationalNode}
     */
    clone() {
      return new n(this.conditionals, this.params);
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      for (var u = i && i.parenthesis ? i.parenthesis : "keep", f = Ar(this, u, i && i.implicit), c = this.params.map(function(l, v) {
        var p = Ar(l, u, i && i.implicit);
        return u === "all" || p !== null && p <= f ? "(" + l.toString(i) + ")" : l.toString(i);
      }), o = c[0], s = 0; s < this.conditionals.length; s++)
        o += " " + t[this.conditionals[s]], o += " " + c[s + 1];
      return o;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ws,
        conditionals: this.conditionals,
        params: this.params
      };
    }
    /**
     * Instantiate a RelationalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RelationalNode", "conditionals": ..., "params": ...}`,
     *     where mathjs is optional
     * @returns {RelationalNode}
     */
    static fromJSON(i) {
      return new n(i.conditionals, i.params);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      for (var u = i && i.parenthesis ? i.parenthesis : "keep", f = Ar(this, u, i && i.implicit), c = this.params.map(function(l, v) {
        var p = Ar(l, u, i && i.implicit);
        return u === "all" || p !== null && p <= f ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + l.toHTML(i) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : l.toHTML(i);
      }), o = c[0], s = 0; s < this.conditionals.length; s++)
        o += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + Zt(t[this.conditionals[s]]) + "</span>" + c[s + 1];
      return o;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      for (var u = i && i.parenthesis ? i.parenthesis : "keep", f = Ar(this, u, i && i.implicit), c = this.params.map(function(l, v) {
        var p = Ar(l, u, i && i.implicit);
        return u === "all" || p !== null && p <= f ? "\\left(" + l.toTex(i) + "\right)" : l.toTex(i);
      }), o = c[0], s = 0; s < this.conditionals.length; s++)
        o += sr[this.conditionals[s]] + c[s + 1];
      return o;
    }
  }
  return Gr(n, "name", ws), n;
}, {
  isClass: !0,
  isNode: !0
}), gO = "SymbolNode", xO = ["math", "?Unit", "Node"], Zf = /* @__PURE__ */ U(gO, xO, (r) => {
  var {
    math: e,
    Unit: t,
    Node: n
  } = r;
  function a(u) {
    return t ? t.isValuelessUnit(u) : !1;
  }
  class i extends n {
    /**
     * @constructor SymbolNode
     * @extends {Node}
     * A symbol node can hold and resolve a symbol
     * @param {string} name
     * @extends {Node}
     */
    constructor(f) {
      if (super(), typeof f != "string")
        throw new TypeError('String expected for parameter "name"');
      this.name = f;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(f, c) {
      var o = this.name;
      if (c[o] === !0)
        return function(l, v, p) {
          return At(v, o);
        };
      if (o in f)
        return function(l, v, p) {
          return l.has(o) ? l.get(o) : At(f, o);
        };
      var s = a(o);
      return function(l, v, p) {
        return l.has(o) ? l.get(o) : s ? new t(null, o) : i.onUndefinedSymbol(o);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(f) {
    }
    /**
     * Create a new SymbolNode with children produced by the given callback.
     * Trivial since a SymbolNode has no children
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {SymbolNode} Returns a clone of the node
     */
    map(f) {
      return this.clone();
    }
    /**
     * Throws an error 'Undefined symbol {name}'
     * @param {string} name
     */
    static onUndefinedSymbol(f) {
      throw new Error("Undefined symbol " + f);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {SymbolNode}
     */
    clone() {
      return new i(this.name);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(f) {
      return this.name;
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(f) {
      var c = Zt(this.name);
      return c === "true" || c === "false" ? '<span class="math-symbol math-boolean">' + c + "</span>" : c === "i" ? '<span class="math-symbol math-imaginary-symbol">' + c + "</span>" : c === "Infinity" ? '<span class="math-symbol math-infinity-symbol">' + c + "</span>" : c === "NaN" ? '<span class="math-symbol math-nan-symbol">' + c + "</span>" : c === "null" ? '<span class="math-symbol math-null-symbol">' + c + "</span>" : c === "undefined" ? '<span class="math-symbol math-undefined-symbol">' + c + "</span>" : '<span class="math-symbol">' + c + "</span>";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: "SymbolNode",
        name: this.name
      };
    }
    /**
     * Instantiate a SymbolNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", name: "x"}`,
     *                       where mathjs is optional
     * @returns {SymbolNode}
     */
    static fromJSON(f) {
      return new i(f.name);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(f) {
      var c = !1;
      typeof e[this.name] > "u" && a(this.name) && (c = !0);
      var o = c4(this.name, c);
      return o[0] === "\\" ? o : " " + o;
    }
  }
  return i;
}, {
  isClass: !0,
  isNode: !0
}), Ds = "FunctionNode", yO = ["math", "Node", "SymbolNode"], Wf = /* @__PURE__ */ U(Ds, yO, (r) => {
  var e, {
    math: t,
    Node: n,
    SymbolNode: a
  } = r, i = (c) => Ke(c, {
    truncate: 78
  });
  function u(c, o, s) {
    for (var l = "", v = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, p = 0, h; (h = v.exec(c)) !== null; )
      if (l += c.substring(p, h.index), p = h.index, h[0] === "$$")
        l += "$", p++;
      else {
        p += h[0].length;
        var d = o[h[1]];
        if (!d)
          throw new ReferenceError("Template: Property " + h[1] + " does not exist.");
        if (h[2] === void 0)
          switch (typeof d) {
            case "string":
              l += d;
              break;
            case "object":
              if (vr(d))
                l += d.toTex(s);
              else if (Array.isArray(d))
                l += d.map(function(x, g) {
                  if (vr(x))
                    return x.toTex(s);
                  throw new TypeError("Template: " + h[1] + "[" + g + "] is not a Node.");
                }).join(",");
              else
                throw new TypeError("Template: " + h[1] + " has to be a Node, String or array of Nodes");
              break;
            default:
              throw new TypeError("Template: " + h[1] + " has to be a Node, String or array of Nodes");
          }
        else if (vr(d[h[2]] && d[h[2]]))
          l += d[h[2]].toTex(s);
        else
          throw new TypeError("Template: " + h[1] + "[" + h[2] + "] is not a Node.");
      }
    return l += c.slice(p), l;
  }
  class f extends n {
    /**
     * @constructor FunctionNode
     * @extends {./Node}
     * invoke a list with arguments on a node
     * @param {./Node | string} fn
     *     Item resolving to a function on which to invoke
     *     the arguments, typically a SymboNode or AccessorNode
     * @param {./Node[]} args
     */
    constructor(o, s) {
      if (super(), typeof o == "string" && (o = new a(o)), !vr(o))
        throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(s) || !s.every(vr))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.fn = o, this.args = s || [];
    }
    // readonly property name
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return Ds;
    }
    get isFunctionNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(o, s) {
      var l = this.args.map((N) => N._compile(o, s));
      if (Ur(this.fn)) {
        var v = this.fn.name;
        if (s[v]) {
          var g = this.args;
          return function(C, D, B) {
            var S = At(D, v);
            if (typeof S != "function")
              throw new TypeError("Argument '".concat(v, "' was not a function; received: ").concat(i(S)));
            if (S.rawArgs)
              return S(g, o, Wi(C, D));
            var F = l.map((I) => I(C, D, B));
            return S.apply(S, F);
          };
        } else {
          var p = v in o ? At(o, v) : void 0, h = typeof p == "function" && p.rawArgs === !0, d = (N) => {
            var C;
            if (N.has(v))
              C = N.get(v);
            else if (v in o)
              C = At(o, v);
            else
              return f.onUndefinedFunction(v);
            if (typeof C == "function")
              return C;
            throw new TypeError("'".concat(v, `' is not a function; its value is:
  `).concat(i(C)));
          };
          if (h) {
            var x = this.args;
            return function(C, D, B) {
              var S = d(C);
              return S(x, o, Wi(C, D));
            };
          } else
            switch (l.length) {
              case 0:
                return function(C, D, B) {
                  var S = d(C);
                  return S();
                };
              case 1:
                return function(C, D, B) {
                  var S = d(C), F = l[0];
                  return S(F(C, D, B));
                };
              case 2:
                return function(C, D, B) {
                  var S = d(C), F = l[0], I = l[1];
                  return S(F(C, D, B), I(C, D, B));
                };
              default:
                return function(C, D, B) {
                  var S = d(C), F = l.map((I) => I(C, D, B));
                  return S(...F);
                };
            }
        }
      } else if (In(this.fn) && aa(this.fn.index) && this.fn.index.isObjectProperty()) {
        var y = this.fn.object._compile(o, s), m = this.fn.index.getObjectProperty(), b = this.args;
        return function(C, D, B) {
          var S = y(C, D, B), F = c9(S, m);
          if (F != null && F.rawArgs)
            return F(b, o, Wi(C, D));
          var I = l.map((z) => z(C, D, B));
          return F.apply(S, I);
        };
      } else {
        var w = this.fn.toString(), A = this.fn._compile(o, s), E = this.args;
        return function(C, D, B) {
          var S = A(C, D, B);
          if (typeof S != "function")
            throw new TypeError("Expression '".concat(w, "' did not evaluate to a function; value is:") + `
  `.concat(i(S)));
          if (S.rawArgs)
            return S(E, o, Wi(C, D));
          var F = l.map((I) => I(C, D, B));
          return S.apply(S, F);
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(o) {
      o(this.fn, "fn", this);
      for (var s = 0; s < this.args.length; s++)
        o(this.args[s], "args[" + s + "]", this);
    }
    /**
     * Create a new FunctionNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionNode} Returns a transformed copy of the node
     */
    map(o) {
      for (var s = this._ifNode(o(this.fn, "fn", this)), l = [], v = 0; v < this.args.length; v++)
        l[v] = this._ifNode(o(this.args[v], "args[" + v + "]", this));
      return new f(s, l);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionNode}
     */
    clone() {
      return new f(this.fn, this.args.slice(0));
    }
    /**
     * Throws an error 'Undefined function {name}'
     * @param {string} name
     */
    /**
     * Get string representation. (wrapper function)
     * This overrides parts of Node's toString function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toString
     * function.
     *
     * @param {Object} options
     * @return {string} str
     * @override
     */
    toString(o) {
      var s, l = this.fn.toString(o);
      return o && typeof o.handler == "object" && Pe(o.handler, l) && (s = o.handler[l](this, o)), typeof s < "u" ? s : super.toString(o);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(o) {
      var s = this.args.map(function(v) {
        return v.toString(o);
      }), l = Pa(this.fn) ? "(" + this.fn.toString(o) + ")" : this.fn.toString(o);
      return l + "(" + s.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Ds,
        fn: this.fn,
        args: this.args
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionNode}
     */
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(o) {
      var s = this.args.map(function(l) {
        return l.toHTML(o);
      });
      return '<span class="math-function">' + Zt(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + s.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    /**
     * Get LaTeX representation. (wrapper function)
     * This overrides parts of Node's toTex function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toTex
     * function.
     *
     * @param {Object} options
     * @return {string}
     */
    toTex(o) {
      var s;
      return o && typeof o.handler == "object" && Pe(o.handler, this.name) && (s = o.handler[this.name](this, o)), typeof s < "u" ? s : super.toTex(o);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(o) {
      var s = this.args.map(function(p) {
        return p.toTex(o);
      }), l;
      Sb[this.name] && (l = Sb[this.name]), t[this.name] && (typeof t[this.name].toTex == "function" || typeof t[this.name].toTex == "object" || typeof t[this.name].toTex == "string") && (l = t[this.name].toTex);
      var v;
      switch (typeof l) {
        case "function":
          v = l(this, o);
          break;
        case "string":
          v = u(l, this, o);
          break;
        case "object":
          switch (typeof l[s.length]) {
            case "function":
              v = l[s.length](this, o);
              break;
            case "string":
              v = u(l[s.length], this, o);
              break;
          }
      }
      return typeof v < "u" ? v : u(uO, this, o);
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return e = f, Gr(f, "name", Ds), Gr(f, "onUndefinedFunction", function(c) {
    throw new Error("Undefined function " + c);
  }), Gr(f, "fromJSON", function(c) {
    return new e(c.fn, c.args);
  }), f;
}, {
  isClass: !0,
  isNode: !0
}), Mb = "parse", AO = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], Kf = /* @__PURE__ */ U(Mb, AO, (r) => {
  var {
    typed: e,
    numeric: t,
    config: n,
    AccessorNode: a,
    ArrayNode: i,
    AssignmentNode: u,
    BlockNode: f,
    ConditionalNode: c,
    ConstantNode: o,
    FunctionAssignmentNode: s,
    FunctionNode: l,
    IndexNode: v,
    ObjectNode: p,
    OperatorNode: h,
    ParenthesisNode: d,
    RangeNode: x,
    RelationalNode: g,
    SymbolNode: y
  } = r, m = e(Mb, {
    string: function(K) {
      return k(K, {});
    },
    "Array | Matrix": function(K) {
      return b(K, {});
    },
    "string, Object": function(K, ce) {
      var we = ce.nodes !== void 0 ? ce.nodes : {};
      return k(K, we);
    },
    "Array | Matrix, Object": b
  });
  function b(T) {
    var K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ce = K.nodes !== void 0 ? K.nodes : {};
    return $e(T, function(we) {
      if (typeof we != "string")
        throw new TypeError("String expected");
      return k(we, ce);
    });
  }
  var w = {
    NULL: 0,
    DELIMITER: 1,
    NUMBER: 2,
    SYMBOL: 3,
    UNKNOWN: 4
  }, A = {
    ",": !0,
    "(": !0,
    ")": !0,
    "[": !0,
    "]": !0,
    "{": !0,
    "}": !0,
    '"': !0,
    "'": !0,
    ";": !0,
    "+": !0,
    "-": !0,
    "*": !0,
    ".*": !0,
    "/": !0,
    "./": !0,
    "%": !0,
    "^": !0,
    ".^": !0,
    "~": !0,
    "!": !0,
    "&": !0,
    "|": !0,
    "^|": !0,
    "=": !0,
    ":": !0,
    "?": !0,
    "==": !0,
    "!=": !0,
    "<": !0,
    ">": !0,
    "<=": !0,
    ">=": !0,
    "<<": !0,
    ">>": !0,
    ">>>": !0
  }, E = {
    mod: !0,
    to: !0,
    in: !0,
    and: !0,
    xor: !0,
    or: !0,
    not: !0
  }, N = {
    true: !0,
    false: !1,
    null: null,
    undefined: void 0
  }, C = ["NaN", "Infinity"], D = {
    '"': '"',
    "'": "'",
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
    // note that \u is handled separately in parseStringToken()
  };
  function B() {
    return {
      extraNodes: {},
      // current extra nodes, must be careful not to mutate
      expression: "",
      // current expression
      comment: "",
      // last parsed comment
      index: 0,
      // current index in expr
      token: "",
      // current token
      tokenType: w.NULL,
      // type of the token
      nestingLevel: 0,
      // level of nesting inside parameters, used to ignore newline characters
      conditionalLevel: null
      // when a conditional is being parsed, the level of the conditional is stored here
    };
  }
  function S(T, K) {
    return T.expression.substr(T.index, K);
  }
  function F(T) {
    return S(T, 1);
  }
  function I(T) {
    T.index++;
  }
  function z(T) {
    return T.expression.charAt(T.index - 1);
  }
  function P(T) {
    return T.expression.charAt(T.index + 1);
  }
  function M(T) {
    for (T.tokenType = w.NULL, T.token = "", T.comment = ""; ; ) {
      if (F(T) === "#")
        for (; F(T) !== `
` && F(T) !== ""; )
          T.comment += F(T), I(T);
      if (m.isWhitespace(F(T), T.nestingLevel))
        I(T);
      else
        break;
    }
    if (F(T) === "") {
      T.tokenType = w.DELIMITER;
      return;
    }
    if (F(T) === `
` && !T.nestingLevel) {
      T.tokenType = w.DELIMITER, T.token = F(T), I(T);
      return;
    }
    var K = F(T), ce = S(T, 2), we = S(T, 3);
    if (we.length === 3 && A[we]) {
      T.tokenType = w.DELIMITER, T.token = we, I(T), I(T), I(T);
      return;
    }
    if (ce.length === 2 && A[ce]) {
      T.tokenType = w.DELIMITER, T.token = ce, I(T), I(T);
      return;
    }
    if (A[K]) {
      T.tokenType = w.DELIMITER, T.token = K, I(T);
      return;
    }
    if (m.isDigitDot(K)) {
      T.tokenType = w.NUMBER;
      var ze = S(T, 2);
      if (ze === "0b" || ze === "0o" || ze === "0x") {
        for (T.token += F(T), I(T), T.token += F(T), I(T); m.isHexDigit(F(T)); )
          T.token += F(T), I(T);
        if (F(T) === ".")
          for (T.token += ".", I(T); m.isHexDigit(F(T)); )
            T.token += F(T), I(T);
        else if (F(T) === "i")
          for (T.token += "i", I(T); m.isDigit(F(T)); )
            T.token += F(T), I(T);
        return;
      }
      if (F(T) === ".") {
        if (T.token += F(T), I(T), !m.isDigit(F(T))) {
          T.tokenType = w.DELIMITER;
          return;
        }
      } else {
        for (; m.isDigit(F(T)); )
          T.token += F(T), I(T);
        m.isDecimalMark(F(T), P(T)) && (T.token += F(T), I(T));
      }
      for (; m.isDigit(F(T)); )
        T.token += F(T), I(T);
      if (F(T) === "E" || F(T) === "e") {
        if (m.isDigit(P(T)) || P(T) === "-" || P(T) === "+") {
          if (T.token += F(T), I(T), (F(T) === "+" || F(T) === "-") && (T.token += F(T), I(T)), !m.isDigit(F(T)))
            throw Fe(T, 'Digit expected, got "' + F(T) + '"');
          for (; m.isDigit(F(T)); )
            T.token += F(T), I(T);
          if (m.isDecimalMark(F(T), P(T)))
            throw Fe(T, 'Digit expected, got "' + F(T) + '"');
        } else if (P(T) === ".")
          throw I(T), Fe(T, 'Digit expected, got "' + F(T) + '"');
      }
      return;
    }
    if (m.isAlpha(F(T), z(T), P(T))) {
      for (; m.isAlpha(F(T), z(T), P(T)) || m.isDigit(F(T)); )
        T.token += F(T), I(T);
      Pe(E, T.token) ? T.tokenType = w.DELIMITER : T.tokenType = w.SYMBOL;
      return;
    }
    for (T.tokenType = w.UNKNOWN; F(T) !== ""; )
      T.token += F(T), I(T);
    throw Fe(T, 'Syntax error in part "' + T.token + '"');
  }
  function H(T) {
    do
      M(T);
    while (T.token === `
`);
  }
  function O(T) {
    T.nestingLevel++;
  }
  function Q(T) {
    T.nestingLevel--;
  }
  m.isAlpha = function(K, ce, we) {
    return m.isValidLatinOrGreek(K) || m.isValidMathSymbol(K, we) || m.isValidMathSymbol(ce, K);
  }, m.isValidLatinOrGreek = function(K) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(K);
  }, m.isValidMathSymbol = function(K, ce) {
    return /^[\uD835]$/.test(K) && /^[\uDC00-\uDFFF]$/.test(ce) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(ce);
  }, m.isWhitespace = function(K, ce) {
    return K === " " || K === "	" || K === `
` && ce > 0;
  }, m.isDecimalMark = function(K, ce) {
    return K === "." && ce !== "/" && ce !== "*" && ce !== "^";
  }, m.isDigitDot = function(K) {
    return K >= "0" && K <= "9" || K === ".";
  }, m.isDigit = function(K) {
    return K >= "0" && K <= "9";
  }, m.isHexDigit = function(K) {
    return K >= "0" && K <= "9" || K >= "a" && K <= "f" || K >= "A" && K <= "F";
  };
  function k(T, K) {
    var ce = B();
    Lr(ce, {
      expression: T,
      extraNodes: K
    }), M(ce);
    var we = L(ce);
    if (ce.token !== "")
      throw ce.tokenType === w.DELIMITER ? Er(ce, "Unexpected operator " + ce.token) : Fe(ce, 'Unexpected part "' + ce.token + '"');
    return we;
  }
  function L(T) {
    var K, ce = [], we;
    for (T.token !== "" && T.token !== `
` && T.token !== ";" && (K = R(T), T.comment && (K.comment = T.comment)); T.token === `
` || T.token === ";"; )
      ce.length === 0 && K && (we = T.token !== ";", ce.push({
        node: K,
        visible: we
      })), M(T), T.token !== `
` && T.token !== ";" && T.token !== "" && (K = R(T), T.comment && (K.comment = T.comment), we = T.token !== ";", ce.push({
        node: K,
        visible: we
      }));
    return ce.length > 0 ? new f(ce) : (K || (K = new o(void 0), T.comment && (K.comment = T.comment)), K);
  }
  function R(T) {
    var K, ce, we, ze, ke = X(T);
    if (T.token === "=") {
      if (Ur(ke))
        return K = ke.name, H(T), we = R(T), new u(new y(K), we);
      if (In(ke))
        return H(T), we = R(T), new u(ke.object, ke.index, we);
      if (An(ke) && Ur(ke.fn) && (ze = !0, ce = [], K = ke.name, ke.args.forEach(function(gt, Xi) {
        Ur(gt) ? ce[Xi] = gt.name : ze = !1;
      }), ze))
        return H(T), we = R(T), new s(K, ce, we);
      throw Fe(T, "Invalid left hand side of assignment operator =");
    }
    return ke;
  }
  function X(T) {
    for (var K = ae(T); T.token === "?"; ) {
      var ce = T.conditionalLevel;
      T.conditionalLevel = T.nestingLevel, H(T);
      var we = K, ze = R(T);
      if (T.token !== ":")
        throw Fe(T, "False part of conditional expression expected");
      T.conditionalLevel = null, H(T);
      var ke = R(T);
      K = new c(we, ze, ke), T.conditionalLevel = ce;
    }
    return K;
  }
  function ae(T) {
    for (var K = _(T); T.token === "or"; )
      H(T), K = new h("or", "or", [K, _(T)]);
    return K;
  }
  function _(T) {
    for (var K = re(T); T.token === "xor"; )
      H(T), K = new h("xor", "xor", [K, re(T)]);
    return K;
  }
  function re(T) {
    for (var K = te(T); T.token === "and"; )
      H(T), K = new h("and", "and", [K, te(T)]);
    return K;
  }
  function te(T) {
    for (var K = ne(T); T.token === "|"; )
      H(T), K = new h("|", "bitOr", [K, ne(T)]);
    return K;
  }
  function ne(T) {
    for (var K = oe(T); T.token === "^|"; )
      H(T), K = new h("^|", "bitXor", [K, oe(T)]);
    return K;
  }
  function oe(T) {
    for (var K = le(T); T.token === "&"; )
      H(T), K = new h("&", "bitAnd", [K, le(T)]);
    return K;
  }
  function le(T) {
    for (var K = [fe(T)], ce = [], we = {
      "==": "equal",
      "!=": "unequal",
      "<": "smaller",
      ">": "larger",
      "<=": "smallerEq",
      ">=": "largerEq"
    }; Pe(we, T.token); ) {
      var ze = {
        name: T.token,
        fn: we[T.token]
      };
      ce.push(ze), H(T), K.push(fe(T));
    }
    return K.length === 1 ? K[0] : K.length === 2 ? new h(ce[0].name, ce[0].fn, K) : new g(ce.map((ke) => ke.fn), K);
  }
  function fe(T) {
    var K, ce, we, ze;
    K = ge(T);
    for (var ke = {
      "<<": "leftShift",
      ">>": "rightArithShift",
      ">>>": "rightLogShift"
    }; Pe(ke, T.token); )
      ce = T.token, we = ke[ce], H(T), ze = [K, ge(T)], K = new h(ce, we, ze);
    return K;
  }
  function ge(T) {
    var K, ce, we, ze;
    K = Be(T);
    for (var ke = {
      to: "to",
      in: "to"
      // alias of 'to'
    }; Pe(ke, T.token); )
      ce = T.token, we = ke[ce], H(T), ce === "in" && T.token === "" ? K = new h("*", "multiply", [K, new y("in")], !0) : (ze = [K, Be(T)], K = new h(ce, we, ze));
    return K;
  }
  function Be(T) {
    var K, ce = [];
    if (T.token === ":" ? K = new o(1) : K = j(T), T.token === ":" && T.conditionalLevel !== T.nestingLevel) {
      for (ce.push(K); T.token === ":" && ce.length < 3; )
        H(T), T.token === ")" || T.token === "]" || T.token === "," || T.token === "" ? ce.push(new y("end")) : ce.push(j(T));
      ce.length === 3 ? K = new x(ce[0], ce[2], ce[1]) : K = new x(ce[0], ce[1]);
    }
    return K;
  }
  function j(T) {
    var K, ce, we, ze;
    K = Y(T);
    for (var ke = {
      "+": "add",
      "-": "subtract"
    }; Pe(ke, T.token); ) {
      ce = T.token, we = ke[ce], H(T);
      var gt = Y(T);
      gt.isPercentage ? ze = [K, new h("*", "multiply", [K, gt])] : ze = [K, gt], K = new h(ce, we, ze);
    }
    return K;
  }
  function Y(T) {
    var K, ce, we, ze;
    K = ie(T), ce = K;
    for (var ke = {
      "*": "multiply",
      ".*": "dotMultiply",
      "/": "divide",
      "./": "dotDivide"
    }; Pe(ke, T.token); )
      we = T.token, ze = ke[we], H(T), ce = ie(T), K = new h(we, ze, [K, ce]);
    return K;
  }
  function ie(T) {
    var K, ce;
    for (K = V(T), ce = K; T.tokenType === w.SYMBOL || T.token === "in" && ar(K) || T.tokenType === w.NUMBER && !ar(ce) && (!zr(ce) || ce.op === "!") || T.token === "("; )
      ce = V(T), K = new h(
        "*",
        "multiply",
        [K, ce],
        !0
        /* implicit */
      );
    return K;
  }
  function V(T) {
    for (var K = J(T), ce = K, we = []; T.token === "/" && Sm(ce); )
      if (we.push(Lr({}, T)), H(T), T.tokenType === w.NUMBER)
        if (we.push(Lr({}, T)), H(T), T.tokenType === w.SYMBOL || T.token === "(")
          Lr(T, we.pop()), we.pop(), ce = J(T), K = new h("/", "divide", [K, ce]);
        else {
          we.pop(), Lr(T, we.pop());
          break;
        }
      else {
        Lr(T, we.pop());
        break;
      }
    return K;
  }
  function J(T) {
    var K, ce, we, ze;
    K = $(T);
    for (var ke = {
      "%": "mod",
      mod: "mod"
    }; Pe(ke, T.token); )
      ce = T.token, we = ke[ce], H(T), ce === "%" && T.tokenType === w.DELIMITER && T.token !== "(" ? K = new h("/", "divide", [K, new o(100)], !1, !0) : (ze = [K, $(T)], K = new h(ce, we, ze));
    return K;
  }
  function $(T) {
    var K, ce, we, ze = {
      "-": "unaryMinus",
      "+": "unaryPlus",
      "~": "bitNot",
      not: "not"
    };
    return Pe(ze, T.token) ? (we = ze[T.token], K = T.token, H(T), ce = [$(T)], new h(K, we, ce)) : pe(T);
  }
  function pe(T) {
    var K, ce, we, ze;
    return K = ve(T), (T.token === "^" || T.token === ".^") && (ce = T.token, we = ce === "^" ? "pow" : "dotPow", H(T), ze = [K, $(T)], K = new h(ce, we, ze)), K;
  }
  function ve(T) {
    var K, ce, we, ze;
    K = q(T);
    for (var ke = {
      "!": "factorial",
      "'": "ctranspose"
    }; Pe(ke, T.token); )
      ce = T.token, we = ke[ce], M(T), ze = [K], K = new h(ce, we, ze), K = ee(T, K);
    return K;
  }
  function q(T) {
    var K = [];
    if (T.tokenType === w.SYMBOL && Pe(T.extraNodes, T.token)) {
      var ce = T.extraNodes[T.token];
      if (M(T), T.token === "(") {
        if (K = [], O(T), M(T), T.token !== ")")
          for (K.push(R(T)); T.token === ","; )
            M(T), K.push(R(T));
        if (T.token !== ")")
          throw Fe(T, "Parenthesis ) expected");
        Q(T), M(T);
      }
      return new ce(K);
    }
    return G(T);
  }
  function G(T) {
    var K, ce;
    return T.tokenType === w.SYMBOL || T.tokenType === w.DELIMITER && T.token in E ? (ce = T.token, M(T), Pe(N, ce) ? K = new o(N[ce]) : C.includes(ce) ? K = new o(t(ce, "number")) : K = new y(ce), K = ee(T, K), K) : se(T);
  }
  function ee(T, K, ce) {
    for (var we; (T.token === "(" || T.token === "[" || T.token === ".") && (!ce || ce.includes(T.token)); )
      if (we = [], T.token === "(")
        if (Ur(K) || In(K)) {
          if (O(T), M(T), T.token !== ")")
            for (we.push(R(T)); T.token === ","; )
              M(T), we.push(R(T));
          if (T.token !== ")")
            throw Fe(T, "Parenthesis ) expected");
          Q(T), M(T), K = new l(K, we);
        } else
          return K;
      else if (T.token === "[") {
        if (O(T), M(T), T.token !== "]")
          for (we.push(R(T)); T.token === ","; )
            M(T), we.push(R(T));
        if (T.token !== "]")
          throw Fe(T, "Parenthesis ] expected");
        Q(T), M(T), K = new a(K, new v(we));
      } else {
        M(T);
        var ze = T.tokenType === w.SYMBOL || T.tokenType === w.DELIMITER && T.token in E;
        if (!ze)
          throw Fe(T, "Property name expected after dot");
        we.push(new o(T.token)), M(T);
        var ke = !0;
        K = new a(K, new v(we, ke));
      }
    return K;
  }
  function se(T) {
    var K, ce;
    return T.token === '"' || T.token === "'" ? (ce = de(T, T.token), K = new o(ce), K = ee(T, K), K) : me(T);
  }
  function de(T, K) {
    for (var ce = ""; F(T) !== "" && F(T) !== K; )
      if (F(T) === "\\") {
        I(T);
        var we = F(T), ze = D[we];
        if (ze !== void 0)
          ce += ze, T.index += 1;
        else if (we === "u") {
          var ke = T.expression.slice(T.index + 1, T.index + 5);
          if (/^[0-9A-Fa-f]{4}$/.test(ke))
            ce += String.fromCharCode(parseInt(ke, 16)), T.index += 5;
          else
            throw Fe(T, "Invalid unicode character \\u".concat(ke));
        } else
          throw Fe(T, "Bad escape character \\".concat(we));
      } else
        ce += F(T), I(T);
    if (M(T), T.token !== K)
      throw Fe(T, "End of string ".concat(K, " expected"));
    return M(T), ce;
  }
  function me(T) {
    var K, ce, we, ze;
    if (T.token === "[") {
      if (O(T), M(T), T.token !== "]") {
        var ke = be(T);
        if (T.token === ";") {
          for (we = 1, ce = [ke]; T.token === ";"; )
            M(T), T.token !== "]" && (ce[we] = be(T), we++);
          if (T.token !== "]")
            throw Fe(T, "End of matrix ] expected");
          Q(T), M(T), ze = ce[0].items.length;
          for (var gt = 1; gt < we; gt++)
            if (ce[gt].items.length !== ze)
              throw Er(T, "Column dimensions mismatch (" + ce[gt].items.length + " !== " + ze + ")");
          K = new i(ce);
        } else {
          if (T.token !== "]")
            throw Fe(T, "End of matrix ] expected");
          Q(T), M(T), K = ke;
        }
      } else
        Q(T), M(T), K = new i([]);
      return ee(T, K);
    }
    return xe(T);
  }
  function be(T) {
    for (var K = [R(T)], ce = 1; T.token === ","; )
      M(T), T.token !== "]" && T.token !== ";" && (K[ce] = R(T), ce++);
    return new i(K);
  }
  function xe(T) {
    if (T.token === "{") {
      O(T);
      var K, ce = {};
      do
        if (M(T), T.token !== "}") {
          if (T.token === '"' || T.token === "'")
            K = de(T, T.token);
          else if (T.tokenType === w.SYMBOL || T.tokenType === w.DELIMITER && T.token in E)
            K = T.token, M(T);
          else
            throw Fe(T, "Symbol or string expected as object key");
          if (T.token !== ":")
            throw Fe(T, "Colon : expected after object key");
          M(T), ce[K] = R(T);
        }
      while (T.token === ",");
      if (T.token !== "}")
        throw Fe(T, "Comma , or bracket } expected after object value");
      Q(T), M(T);
      var we = new p(ce);
      return we = ee(T, we), we;
    }
    return Ee(T);
  }
  function Ee(T) {
    var K;
    return T.tokenType === w.NUMBER ? (K = T.token, M(T), new o(t(K, n.number))) : ye(T);
  }
  function ye(T) {
    var K;
    if (T.token === "(") {
      if (O(T), M(T), K = R(T), T.token !== ")")
        throw Fe(T, "Parenthesis ) expected");
      return Q(T), M(T), K = new d(K), K = ee(T, K), K;
    }
    return er(T);
  }
  function er(T) {
    throw T.token === "" ? Fe(T, "Unexpected end of expression") : Fe(T, "Value expected");
  }
  function rr(T) {
    return T.index - T.token.length + 1;
  }
  function Fe(T, K) {
    var ce = rr(T), we = new SyntaxError(K + " (char " + ce + ")");
    return we.char = ce, we;
  }
  function Er(T, K) {
    var ce = rr(T), we = new SyntaxError(K + " (char " + ce + ")");
    return we.char = ce, we;
  }
  return e.addConversion({
    from: "string",
    to: "Node",
    convert: m
  }), m;
}), Fb = "compile", bO = ["typed", "parse"], Jf = /* @__PURE__ */ U(Fb, bO, (r) => {
  var {
    typed: e,
    parse: t
  } = r;
  return e(Fb, {
    string: function(a) {
      return t(a).compile();
    },
    "Array | Matrix": function(a) {
      return $e(a, function(i) {
        return t(i).compile();
      });
    }
  });
}), Tb = "evaluate", wO = ["typed", "parse"], _f = /* @__PURE__ */ U(Tb, wO, (r) => {
  var {
    typed: e,
    parse: t
  } = r;
  return e(Tb, {
    string: function(a) {
      var i = $i();
      return t(a).compile().evaluate(i);
    },
    "string, Map | Object": function(a, i) {
      return t(a).compile().evaluate(i);
    },
    "Array | Matrix": function(a) {
      var i = $i();
      return $e(a, function(u) {
        return t(u).compile().evaluate(i);
      });
    },
    "Array | Matrix, Map | Object": function(a, i) {
      return $e(a, function(u) {
        return t(u).compile().evaluate(i);
      });
    }
  });
}), DO = "Parser", CO = ["evaluate"], $f = /* @__PURE__ */ U(DO, CO, (r) => {
  var {
    evaluate: e
  } = r;
  function t() {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", {
      value: $i(),
      writable: !1
    });
  }
  return t.prototype.type = "Parser", t.prototype.isParser = !0, t.prototype.evaluate = function(n) {
    return e(n, this.scope);
  }, t.prototype.get = function(n) {
    if (this.scope.has(n))
      return this.scope.get(n);
  }, t.prototype.getAll = function() {
    return v9(this.scope);
  }, t.prototype.getAllAsMap = function() {
    return this.scope;
  }, t.prototype.set = function(n, a) {
    return this.scope.set(n, a), a;
  }, t.prototype.remove = function(n) {
    this.scope.delete(n);
  }, t.prototype.clear = function() {
    this.scope.clear();
  }, t;
}, {
  isClass: !0
}), Ob = "parser", EO = ["typed", "Parser"], e0 = /* @__PURE__ */ U(Ob, EO, (r) => {
  var {
    typed: e,
    Parser: t
  } = r;
  return e(Ob, {
    "": function() {
      return new t();
    }
  });
}), zb = "lup", NO = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], r0 = /* @__PURE__ */ U(zb, NO, (r) => {
  var {
    typed: e,
    matrix: t,
    abs: n,
    addScalar: a,
    divideScalar: i,
    multiplyScalar: u,
    subtractScalar: f,
    larger: c,
    equalScalar: o,
    unaryMinus: s,
    DenseMatrix: l,
    SparseMatrix: v,
    Spa: p
  } = r;
  return e(zb, {
    DenseMatrix: function(g) {
      return h(g);
    },
    SparseMatrix: function(g) {
      return d(g);
    },
    Array: function(g) {
      var y = t(g), m = h(y);
      return {
        L: m.L.valueOf(),
        U: m.U.valueOf(),
        p: m.p
      };
    }
  });
  function h(x) {
    var g = x._size[0], y = x._size[1], m = Math.min(g, y), b = Ie(x._data), w = [], A = [g, m], E = [], N = [m, y], C, D, B, S = [];
    for (C = 0; C < g; C++)
      S[C] = C;
    for (D = 0; D < y; D++) {
      if (D > 0)
        for (C = 0; C < g; C++) {
          var F = Math.min(C, D), I = 0;
          for (B = 0; B < F; B++)
            I = a(I, u(b[C][B], b[B][D]));
          b[C][D] = f(b[C][D], I);
        }
      var z = D, P = 0, M = 0;
      for (C = D; C < g; C++) {
        var H = b[C][D], O = n(H);
        c(O, P) && (z = C, P = O, M = H);
      }
      if (D !== z && (S[D] = [S[z], S[z] = S[D]][0], l._swapRows(D, z, b)), D < g)
        for (C = D + 1; C < g; C++) {
          var Q = b[C][D];
          o(Q, 0) || (b[C][D] = i(b[C][D], M));
        }
    }
    for (D = 0; D < y; D++)
      for (C = 0; C < g; C++) {
        if (D === 0 && (C < y && (E[C] = []), w[C] = []), C < D) {
          C < y && (E[C][D] = b[C][D]), D < g && (w[C][D] = 0);
          continue;
        }
        if (C === D) {
          C < y && (E[C][D] = b[C][D]), D < g && (w[C][D] = 1);
          continue;
        }
        C < y && (E[C][D] = 0), D < g && (w[C][D] = b[C][D]);
      }
    var k = new l({
      data: w,
      size: A
    }), L = new l({
      data: E,
      size: N
    }), R = [];
    for (C = 0, m = S.length; C < m; C++)
      R[S[C]] = C;
    return {
      L: k,
      U: L,
      p: R,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
  function d(x) {
    var g = x._size[0], y = x._size[1], m = Math.min(g, y), b = x._values, w = x._index, A = x._ptr, E = [], N = [], C = [], D = [g, m], B = [], S = [], F = [], I = [m, y], z, P, M, H = [], O = [];
    for (z = 0; z < g; z++)
      H[z] = z, O[z] = z;
    var Q = function(R, X) {
      var ae = O[R], _ = O[X];
      H[ae] = X, H[_] = R, O[R] = _, O[X] = ae;
    }, k = function() {
      var R = new p();
      P < g && (C.push(E.length), E.push(1), N.push(P)), F.push(B.length);
      var X = A[P], ae = A[P + 1];
      for (M = X; M < ae; M++)
        z = w[M], R.set(H[z], b[M]);
      P > 0 && R.forEach(0, P - 1, function(ne, oe) {
        v._forEachRow(ne, E, N, C, function(le, fe) {
          le > ne && R.accumulate(le, s(u(fe, oe)));
        });
      });
      var _ = P, re = R.get(P), te = n(re);
      R.forEach(P + 1, g - 1, function(ne, oe) {
        var le = n(oe);
        c(le, te) && (_ = ne, te = le, re = oe);
      }), P !== _ && (v._swapRows(P, _, D[1], E, N, C), v._swapRows(P, _, I[1], B, S, F), R.swap(P, _), Q(P, _)), R.forEach(0, g - 1, function(ne, oe) {
        ne <= P ? (B.push(oe), S.push(ne)) : (oe = i(oe, re), o(oe, 0) || (E.push(oe), N.push(ne)));
      });
    };
    for (P = 0; P < y; P++)
      k();
    return F.push(B.length), C.push(E.length), {
      L: new v({
        values: E,
        index: N,
        ptr: C,
        size: D
      }),
      U: new v({
        values: B,
        index: S,
        ptr: F,
        size: I
      }),
      p: H,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
}), Rb = "qr", BO = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], t0 = /* @__PURE__ */ U(Rb, BO, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    identity: a,
    isZero: i,
    equal: u,
    sign: f,
    sqrt: c,
    conj: o,
    unaryMinus: s,
    addScalar: l,
    divideScalar: v,
    multiplyScalar: p,
    subtractScalar: h,
    complex: d
  } = r;
  return Lr(e(Rb, {
    DenseMatrix: function(b) {
      return g(b);
    },
    SparseMatrix: function(b) {
      return y();
    },
    Array: function(b) {
      var w = t(b), A = g(w);
      return {
        Q: A.Q.valueOf(),
        R: A.R.valueOf()
      };
    }
  }), {
    _denseQRimpl: x
  });
  function x(m) {
    var b = m._size[0], w = m._size[1], A = a([b], "dense"), E = A._data, N = m.clone(), C = N._data, D, B, S, F = n([b], "");
    for (S = 0; S < Math.min(w, b); ++S) {
      var I = C[S][S], z = s(u(I, 0) ? 1 : f(I)), P = o(z), M = 0;
      for (D = S; D < b; D++)
        M = l(M, p(C[D][S], o(C[D][S])));
      var H = p(z, c(M));
      if (!i(H)) {
        var O = h(I, H);
        for (F[S] = 1, D = S + 1; D < b; D++)
          F[D] = v(C[D][S], O);
        var Q = s(o(v(O, H))), k = void 0;
        for (B = S; B < w; B++) {
          for (k = 0, D = S; D < b; D++)
            k = l(k, p(o(F[D]), C[D][B]));
          for (k = p(k, Q), D = S; D < b; D++)
            C[D][B] = p(h(C[D][B], p(F[D], k)), P);
        }
        for (D = 0; D < b; D++) {
          for (k = 0, B = S; B < b; B++)
            k = l(k, p(E[D][B], F[B]));
          for (k = p(k, Q), B = S; B < b; ++B)
            E[D][B] = v(h(E[D][B], p(k, o(F[B]))), P);
        }
      }
    }
    return {
      Q: A,
      R: N,
      toString: function() {
        return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
      }
    };
  }
  function g(m) {
    var b = x(m), w = b.R._data;
    if (m._data.length > 0)
      for (var A = w[0][0].type === "Complex" ? d(0) : 0, E = 0; E < w.length; ++E)
        for (var N = 0; N < E && N < (w[0] || []).length; ++N)
          w[E][N] = A;
    return b;
  }
  function y(m) {
    throw new Error("qr not implemented for sparse matrices yet");
  }
});
function SO(r, e, t, n) {
  for (var a = r._values, i = r._index, u = r._ptr, f = r._size, c = r._datatype, o = f[0], s = f[1], l = n && r._values ? [] : null, v = [], p = [], h = 0, d = 0; d < s; d++) {
    p[d] = h;
    for (var x = t ? t[d] : d, g = u[x], y = u[x + 1], m = g; m < y; m++) {
      var b = e ? e[i[m]] : i[m];
      v[h] = b, l && (l[h] = a[m]), h++;
    }
  }
  return p[s] = h, r.createSparseMatrix({
    values: l,
    index: v,
    ptr: p,
    size: [o, s],
    datatype: c
  });
}
function l4(r, e, t, n, a, i, u) {
  var f = 0;
  for (t[u] = r; f >= 0; ) {
    var c = t[u + f], o = t[n + c];
    o === -1 ? (f--, i[e++] = c) : (t[n + c] = t[a + o], ++f, t[u + f] = o);
  }
  return e;
}
function PO(r, e) {
  if (!r)
    return null;
  var t = 0, n, a = [], i = [], u = 0, f = e, c = 2 * e;
  for (n = 0; n < e; n++)
    i[u + n] = -1;
  for (n = e - 1; n >= 0; n--)
    r[n] !== -1 && (i[f + n] = i[u + r[n]], i[u + r[n]] = n);
  for (n = 0; n < e; n++)
    r[n] === -1 && (t = l4(n, t, i, u, f, a, c));
  return a;
}
function MO(r, e) {
  if (!r)
    return null;
  var t = r._index, n = r._ptr, a = r._size, i = a[0], u = a[1], f = [], c = [], o = 0, s = u, l, v;
  if (e)
    for (l = 0; l < i; l++)
      c[s + l] = -1;
  for (var p = 0; p < u; p++) {
    f[p] = -1, c[o + p] = -1;
    for (var h = n[p], d = n[p + 1], x = h; x < d; x++) {
      var g = t[x];
      for (l = e ? c[s + g] : g; l !== -1 && l < p; l = v)
        v = c[o + l], c[o + l] = p, v === -1 && (f[l] = p);
      e && (c[s + g] = p);
    }
  }
  return f;
}
function FO(r, e, t) {
  for (var n = r._values, a = r._index, i = r._ptr, u = r._size, f = u[1], c = 0, o = 0; o < f; o++) {
    var s = i[o];
    for (i[o] = c; s < i[o + 1]; s++)
      e(a[s], o, n ? n[s] : 1, t) && (a[c] = a[s], n && (n[c] = n[s]), c++);
  }
  return i[f] = c, a.splice(c, a.length - c), n && n.splice(c, n.length - c), c;
}
function Jn(r) {
  return -r - 2;
}
var TO = "csAmd", OO = ["add", "multiply", "transpose"], zO = /* @__PURE__ */ U(TO, OO, (r) => {
  var {
    add: e,
    multiply: t,
    transpose: n
  } = r;
  return function(s, l) {
    if (!l || s <= 0 || s > 3)
      return null;
    var v = l._size, p = v[0], h = v[1], d = 0, x = Math.max(16, 10 * Math.sqrt(h));
    x = Math.min(h - 2, x);
    var g = a(s, l, p, h, x);
    FO(g, c, null);
    for (var y = g._index, m = g._ptr, b = m[h], w = [], A = [], E = 0, N = h + 1, C = 2 * (h + 1), D = 3 * (h + 1), B = 4 * (h + 1), S = 5 * (h + 1), F = 6 * (h + 1), I = 7 * (h + 1), z = w, P = i(h, m, A, E, D, z, C, I, N, F, B, S), M = u(h, m, A, S, B, F, x, N, D, z, C), H = 0, O, Q, k, L, R, X, ae, _, re, te, ne, oe, le, fe, ge, Be; M < h; ) {
      for (k = -1; H < h && (k = A[D + H]) === -1; H++)
        ;
      A[C + k] !== -1 && (z[A[C + k]] = -1), A[D + H] = A[C + k];
      var j = A[B + k], Y = A[N + k];
      M += Y;
      var ie = 0;
      A[N + k] = -Y;
      var V = m[k], J = j === 0 ? V : b, $ = J;
      for (L = 1; L <= j + 1; L++) {
        for (L > j ? (X = k, ae = V, _ = A[E + k] - j) : (X = y[V++], ae = m[X], _ = A[E + X]), R = 1; R <= _; R++)
          O = y[ae++], !((re = A[N + O]) <= 0) && (ie += re, A[N + O] = -re, y[$++] = O, A[C + O] !== -1 && (z[A[C + O]] = z[O]), z[O] !== -1 ? A[C + z[O]] = A[C + O] : A[D + A[S + O]] = A[C + O]);
        X !== k && (m[X] = Jn(k), A[F + X] = 0);
      }
      for (j !== 0 && (b = $), A[S + k] = ie, m[k] = J, A[E + k] = $ - J, A[B + k] = -2, P = f(P, d, A, F, h), te = J; te < $; te++)
        if (O = y[te], !((ne = A[B + O]) <= 0)) {
          re = -A[N + O];
          var pe = P - re;
          for (V = m[O], oe = m[O] + ne - 1; V <= oe; V++)
            X = y[V], A[F + X] >= P ? A[F + X] -= re : A[F + X] !== 0 && (A[F + X] = A[S + X] + pe);
        }
      for (te = J; te < $; te++) {
        for (O = y[te], oe = m[O], le = oe + A[B + O] - 1, fe = oe, ge = 0, Be = 0, V = oe; V <= le; V++)
          if (X = y[V], A[F + X] !== 0) {
            var ve = A[F + X] - P;
            ve > 0 ? (Be += ve, y[fe++] = X, ge += X) : (m[X] = Jn(k), A[F + X] = 0);
          }
        A[B + O] = fe - oe + 1;
        var q = fe, G = oe + A[E + O];
        for (V = le + 1; V < G; V++) {
          Q = y[V];
          var ee = A[N + Q];
          ee <= 0 || (Be += ee, y[fe++] = Q, ge += Q);
        }
        Be === 0 ? (m[O] = Jn(k), re = -A[N + O], ie -= re, Y += re, M += re, A[N + O] = 0, A[B + O] = -1) : (A[S + O] = Math.min(A[S + O], Be), y[fe] = y[q], y[q] = y[oe], y[oe] = k, A[E + O] = fe - oe + 1, ge = (ge < 0 ? -ge : ge) % h, A[C + O] = A[I + ge], A[I + ge] = O, z[O] = ge);
      }
      for (A[S + k] = ie, d = Math.max(d, ie), P = f(P + d, d, A, F, h), te = J; te < $; te++)
        if (O = y[te], !(A[N + O] >= 0))
          for (ge = z[O], O = A[I + ge], A[I + ge] = -1; O !== -1 && A[C + O] !== -1; O = A[C + O], P++) {
            for (_ = A[E + O], ne = A[B + O], V = m[O] + 1; V <= m[O] + _ - 1; V++)
              A[F + y[V]] = P;
            var se = O;
            for (Q = A[C + O]; Q !== -1; ) {
              var de = A[E + Q] === _ && A[B + Q] === ne;
              for (V = m[Q] + 1; de && V <= m[Q] + _ - 1; V++)
                A[F + y[V]] !== P && (de = 0);
              de ? (m[Q] = Jn(O), A[N + O] += A[N + Q], A[N + Q] = 0, A[B + Q] = -1, Q = A[C + Q], A[C + se] = Q) : (se = Q, Q = A[C + Q]);
            }
          }
      for (V = J, te = J; te < $; te++)
        O = y[te], !((re = -A[N + O]) <= 0) && (A[N + O] = re, Be = A[S + O] + ie - re, Be = Math.min(Be, h - M - re), A[D + Be] !== -1 && (z[A[D + Be]] = O), A[C + O] = A[D + Be], z[O] = -1, A[D + Be] = O, H = Math.min(H, Be), A[S + O] = Be, y[V++] = O);
      A[N + k] = Y, (A[E + k] = V - J) === 0 && (m[k] = -1, A[F + k] = 0), j !== 0 && (b = V);
    }
    for (O = 0; O < h; O++)
      m[O] = Jn(m[O]);
    for (Q = 0; Q <= h; Q++)
      A[D + Q] = -1;
    for (Q = h; Q >= 0; Q--)
      A[N + Q] > 0 || (A[C + Q] = A[D + m[Q]], A[D + m[Q]] = Q);
    for (X = h; X >= 0; X--)
      A[N + X] <= 0 || m[X] !== -1 && (A[C + X] = A[D + m[X]], A[D + m[X]] = X);
    for (k = 0, O = 0; O <= h; O++)
      m[O] === -1 && (k = l4(O, k, A, D, C, w, F));
    return w.splice(w.length - 1, 1), w;
  };
  function a(o, s, l, v, p) {
    var h = n(s);
    if (o === 1 && v === l)
      return e(s, h);
    if (o === 2) {
      for (var d = h._index, x = h._ptr, g = 0, y = 0; y < l; y++) {
        var m = x[y];
        if (x[y] = g, !(x[y + 1] - m > p))
          for (var b = x[y + 1]; m < b; m++)
            d[g++] = d[m];
      }
      return x[l] = g, s = n(h), t(h, s);
    }
    return t(h, s);
  }
  function i(o, s, l, v, p, h, d, x, g, y, m, b) {
    for (var w = 0; w < o; w++)
      l[v + w] = s[w + 1] - s[w];
    l[v + o] = 0;
    for (var A = 0; A <= o; A++)
      l[p + A] = -1, h[A] = -1, l[d + A] = -1, l[x + A] = -1, l[g + A] = 1, l[y + A] = 1, l[m + A] = 0, l[b + A] = l[v + A];
    var E = f(0, 0, l, y, o);
    return l[m + o] = -2, s[o] = -1, l[y + o] = 0, E;
  }
  function u(o, s, l, v, p, h, d, x, g, y, m) {
    for (var b = 0, w = 0; w < o; w++) {
      var A = l[v + w];
      if (A === 0)
        l[p + w] = -2, b++, s[w] = -1, l[h + w] = 0;
      else if (A > d)
        l[x + w] = 0, l[p + w] = -1, b++, s[w] = Jn(o), l[x + o]++;
      else {
        var E = l[g + A];
        E !== -1 && (y[E] = w), l[m + w] = l[g + A], l[g + A] = w;
      }
    }
    return b;
  }
  function f(o, s, l, v, p) {
    if (o < 2 || o + s < 0) {
      for (var h = 0; h < p; h++)
        l[v + h] !== 0 && (l[v + h] = 1);
      o = 2;
    }
    return o;
  }
  function c(o, s) {
    return o !== s;
  }
});
function RO(r, e, t, n, a, i, u) {
  var f, c, o = 0, s;
  if (r <= e || t[n + e] <= t[a + r])
    return -1;
  t[a + r] = t[n + e];
  var l = t[i + r];
  if (t[i + r] = e, l === -1)
    o = 1, s = r;
  else {
    for (o = 2, s = l; s !== t[u + s]; s = t[u + s])
      ;
    for (f = l; f !== s; f = c)
      c = t[u + f], t[u + f] = s;
  }
  return {
    jleaf: o,
    q: s
  };
}
var IO = "csCounts", HO = ["transpose"], LO = /* @__PURE__ */ U(IO, HO, (r) => {
  var {
    transpose: e
  } = r;
  return function(t, n, a, i) {
    if (!t || !n || !a)
      return null;
    var u = t._size, f = u[0], c = u[1], o, s, l, v, p, h, d, x = 4 * c + (i ? c + f + 1 : 0), g = [], y = 0, m = c, b = 2 * c, w = 3 * c, A = 4 * c, E = 5 * c + 1;
    for (l = 0; l < x; l++)
      g[l] = -1;
    var N = [], C = e(t), D = C._index, B = C._ptr;
    for (l = 0; l < c; l++)
      for (s = a[l], N[s] = g[w + s] === -1 ? 1 : 0; s !== -1 && g[w + s] === -1; s = n[s])
        g[w + s] = l;
    if (i) {
      for (l = 0; l < c; l++)
        g[a[l]] = l;
      for (o = 0; o < f; o++) {
        for (l = c, h = B[o], d = B[o + 1], p = h; p < d; p++)
          l = Math.min(l, g[D[p]]);
        g[E + o] = g[A + l], g[A + l] = o;
      }
    }
    for (o = 0; o < c; o++)
      g[y + o] = o;
    for (l = 0; l < c; l++) {
      for (s = a[l], n[s] !== -1 && N[n[s]]--, v = i ? g[A + l] : s; v !== -1; v = i ? g[E + v] : -1)
        for (p = B[v]; p < B[v + 1]; p++) {
          o = D[p];
          var S = RO(o, s, g, w, m, b, y);
          S.jleaf >= 1 && N[s]++, S.jleaf === 2 && N[S.q]--;
        }
      n[s] !== -1 && (g[y + s] = n[s]);
    }
    for (s = 0; s < c; s++)
      n[s] !== -1 && (N[n[s]] += N[s]);
    return N;
  };
}), qO = "csSqr", UO = ["add", "multiply", "transpose"], kO = /* @__PURE__ */ U(qO, UO, (r) => {
  var {
    add: e,
    multiply: t,
    transpose: n
  } = r, a = zO({
    add: e,
    multiply: t,
    transpose: n
  }), i = LO({
    transpose: n
  });
  return function(c, o, s) {
    var l = o._ptr, v = o._size, p = v[1], h, d = {};
    if (d.q = a(c, o), c && !d.q)
      return null;
    if (s) {
      var x = c ? SO(o, null, d.q, 0) : o;
      d.parent = MO(x, 1);
      var g = PO(d.parent, p);
      if (d.cp = i(x, d.parent, g, 1), x && d.parent && d.cp && u(x, d))
        for (d.unz = 0, h = 0; h < p; h++)
          d.unz += d.cp[h];
    } else
      d.unz = 4 * l[p] + p, d.lnz = d.unz;
    return d;
  };
  function u(f, c) {
    var o = f._ptr, s = f._index, l = f._size, v = l[0], p = l[1];
    c.pinv = [], c.leftmost = [];
    var h = c.parent, d = c.pinv, x = c.leftmost, g = [], y = 0, m = v, b = v + p, w = v + 2 * p, A, E, N, C, D;
    for (E = 0; E < p; E++)
      g[m + E] = -1, g[b + E] = -1, g[w + E] = 0;
    for (A = 0; A < v; A++)
      x[A] = -1;
    for (E = p - 1; E >= 0; E--)
      for (C = o[E], D = o[E + 1], N = C; N < D; N++)
        x[s[N]] = E;
    for (A = v - 1; A >= 0; A--)
      d[A] = -1, E = x[A], E !== -1 && (g[w + E]++ === 0 && (g[b + E] = A), g[y + A] = g[m + E], g[m + E] = A);
    for (c.lnz = 0, c.m2 = v, E = 0; E < p; E++)
      if (A = g[m + E], c.lnz++, A < 0 && (A = c.m2++), d[A] = E, !(--w[E] <= 0)) {
        c.lnz += g[w + E];
        var B = h[E];
        B !== -1 && (g[w + B] === 0 && (g[b + B] = g[b + E]), g[y + g[b + E]] = g[m + B], g[m + B] = g[y + A], g[w + B] += g[w + E]);
      }
    for (A = 0; A < v; A++)
      d[A] < 0 && (d[A] = E++);
    return !0;
  }
});
function Vm(r, e) {
  return r[e] < 0;
}
function f4(r, e) {
  r[e] = Jn(r[e]);
}
function Ib(r) {
  return r < 0 ? Jn(r) : r;
}
function XO(r, e, t, n, a) {
  var i = e._index, u = e._ptr, f = e._size, c = f[1], o, s, l, v = 0;
  for (n[0] = r; v >= 0; ) {
    r = n[v];
    var p = a ? a[r] : r;
    Vm(u, r) || (f4(u, r), n[c + v] = p < 0 ? 0 : Ib(u[p]));
    var h = 1;
    for (s = n[c + v], l = p < 0 ? 0 : Ib(u[p + 1]); s < l; s++)
      if (o = i[s], !Vm(u, o)) {
        n[c + v] = s, n[++v] = o, h = 0;
        break;
      }
    h && (v--, n[--t] = r);
  }
  return t;
}
function jO(r, e, t, n, a) {
  var i = r._ptr, u = r._size, f = e._index, c = e._ptr, o = u[1], s, l, v, p = o;
  for (l = c[t], v = c[t + 1], s = l; s < v; s++) {
    var h = f[s];
    Vm(i, h) || (p = XO(h, r, p, n, a));
  }
  for (s = p; s < o; s++)
    f4(i, n[s]);
  return p;
}
var GO = "csSpsolve", VO = ["divideScalar", "multiply", "subtract"], QO = /* @__PURE__ */ U(GO, VO, (r) => {
  var {
    divideScalar: e,
    multiply: t,
    subtract: n
  } = r;
  return function(i, u, f, c, o, s, l) {
    var v = i._values, p = i._index, h = i._ptr, d = i._size, x = d[1], g = u._values, y = u._index, m = u._ptr, b, w, A, E, N = jO(i, u, f, c, s);
    for (b = N; b < x; b++)
      o[c[b]] = 0;
    for (w = m[f], A = m[f + 1], b = w; b < A; b++)
      o[y[b]] = g[b];
    for (var C = N; C < x; C++) {
      var D = c[C], B = s ? s[D] : D;
      if (!(B < 0))
        for (w = h[B], A = h[B + 1], o[D] = e(o[D], v[l ? w : A - 1]), b = l ? w + 1 : w, E = l ? A : A - 1; b < E; b++) {
          var S = p[b];
          o[S] = n(o[S], t(v[b], o[D]));
        }
    }
    return N;
  };
}), YO = "csLu", ZO = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], WO = /* @__PURE__ */ U(YO, ZO, (r) => {
  var {
    abs: e,
    divideScalar: t,
    multiply: n,
    subtract: a,
    larger: i,
    largerEq: u,
    SparseMatrix: f
  } = r, c = QO({
    divideScalar: t,
    multiply: n,
    subtract: a
  });
  return function(s, l, v) {
    if (!s)
      return null;
    var p = s._size, h = p[1], d, x = 100, g = 100;
    l && (d = l.q, x = l.lnz || x, g = l.unz || g);
    var y = [], m = [], b = [], w = new f({
      values: y,
      index: m,
      ptr: b,
      size: [h, h]
    }), A = [], E = [], N = [], C = new f({
      values: A,
      index: E,
      ptr: N,
      size: [h, h]
    }), D = [], B, S, F = [], I = [];
    for (B = 0; B < h; B++)
      F[B] = 0, D[B] = -1, b[B + 1] = 0;
    x = 0, g = 0;
    for (var z = 0; z < h; z++) {
      b[z] = x, N[z] = g;
      var P = d ? d[z] : z, M = c(w, s, P, I, F, D, 1), H = -1, O = -1;
      for (S = M; S < h; S++)
        if (B = I[S], D[B] < 0) {
          var Q = e(F[B]);
          i(Q, O) && (O = Q, H = B);
        } else
          E[g] = D[B], A[g++] = F[B];
      if (H === -1 || O <= 0)
        return null;
      D[P] < 0 && u(e(F[P]), n(O, v)) && (H = P);
      var k = F[H];
      for (E[g] = z, A[g++] = k, D[H] = z, m[x] = H, y[x++] = 1, S = M; S < h; S++)
        B = I[S], D[B] < 0 && (m[x] = B, y[x++] = t(F[B], k)), F[B] = 0;
    }
    for (b[h] = x, N[h] = g, S = 0; S < x; S++)
      m[S] = D[m[S]];
    return y.splice(x, y.length - x), m.splice(x, m.length - x), A.splice(g, A.length - g), E.splice(g, E.length - g), {
      L: w,
      U: C,
      pinv: D
    };
  };
}), Hb = "slu", KO = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], n0 = /* @__PURE__ */ U(Hb, KO, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    multiply: a,
    transpose: i,
    divideScalar: u,
    subtract: f,
    larger: c,
    largerEq: o,
    SparseMatrix: s
  } = r, l = kO({
    add: n,
    multiply: a,
    transpose: i
  }), v = WO({
    abs: t,
    divideScalar: u,
    multiply: a,
    subtract: f,
    larger: c,
    largerEq: o,
    SparseMatrix: s
  });
  return e(Hb, {
    "SparseMatrix, number, number": function(h, d, x) {
      if (!Me(d) || d < 0 || d > 3)
        throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
      if (x < 0 || x > 1)
        throw new Error("Partial pivoting threshold must be a number from 0 to 1");
      var g = l(d, h, !1), y = v(h, g, x);
      return {
        L: y.L,
        U: y.U,
        p: y.pinv,
        q: g.q,
        toString: function() {
          return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : "") + `
`;
        }
      };
    }
  });
});
function Lb(r, e) {
  var t, n = e.length, a = [];
  if (r)
    for (t = 0; t < n; t++)
      a[r[t]] = e[t];
  else
    for (t = 0; t < n; t++)
      a[t] = e[t];
  return a;
}
var qb = "lusolve", JO = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], a0 = /* @__PURE__ */ U(qb, JO, (r) => {
  var {
    typed: e,
    matrix: t,
    lup: n,
    slu: a,
    usolve: i,
    lsolve: u,
    DenseMatrix: f
  } = r, c = Do({
    DenseMatrix: f
  });
  return e(qb, {
    "Array, Array | Matrix": function(v, p) {
      v = t(v);
      var h = n(v), d = s(h.L, h.U, h.p, null, p);
      return d.valueOf();
    },
    "DenseMatrix, Array | Matrix": function(v, p) {
      var h = n(v);
      return s(h.L, h.U, h.p, null, p);
    },
    "SparseMatrix, Array | Matrix": function(v, p) {
      var h = n(v);
      return s(h.L, h.U, h.p, null, p);
    },
    "SparseMatrix, Array | Matrix, number, number": function(v, p, h, d) {
      var x = a(v, h, d);
      return s(x.L, x.U, x.p, x.q, p);
    },
    "Object, Array | Matrix": function(v, p) {
      return s(v.L, v.U, v.p, v.q, p);
    }
  });
  function o(l) {
    if (Oe(l))
      return l;
    if (ur(l))
      return t(l);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function s(l, v, p, h, d) {
    l = o(l), v = o(v), p && (d = c(l, d, !0), d._data = Lb(p, d._data));
    var x = u(l, d), g = i(v, x);
    return h && (g._data = Lb(h, g._data)), g;
  }
}), Ub = "polynomialRoot", _O = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], i0 = /* @__PURE__ */ U(Ub, _O, (r) => {
  var {
    typed: e,
    isZero: t,
    equalScalar: n,
    add: a,
    subtract: i,
    multiply: u,
    divide: f,
    sqrt: c,
    unaryMinus: o,
    cbrt: s,
    typeOf: l,
    im: v,
    re: p
  } = r;
  return e(Ub, {
    "number|Complex, ...number|Complex": (h, d) => {
      for (var x = [h, ...d]; x.length > 0 && t(x[x.length - 1]); )
        x.pop();
      if (x.length < 2)
        throw new RangeError("Polynomial [".concat(h, ", ").concat(d, "] must have a non-zero non-constant coefficient"));
      switch (x.length) {
        case 2:
          return [o(f(x[0], x[1]))];
        case 3: {
          var [g, y, m] = x, b = u(2, m), w = u(y, y), A = u(4, m, g);
          if (n(w, A))
            return [f(o(y), b)];
          var E = c(i(w, A));
          return [f(i(E, y), b), f(i(o(E), y), b)];
        }
        case 4: {
          var [N, C, D, B] = x, S = o(u(3, B)), F = u(D, D), I = u(3, B, C), z = a(u(2, D, D, D), u(27, B, B, N)), P = u(9, B, D, C);
          if (n(F, I) && n(z, P))
            return [f(D, S)];
          var M = i(F, I), H = i(z, P), O = a(u(18, B, D, C, N), u(D, D, C, C)), Q = a(u(4, D, D, D, N), u(4, B, C, C, C), u(27, B, B, N, N));
          if (n(O, Q))
            return [
              f(i(u(4, B, D, C), a(u(9, B, B, N), u(D, D, D))), u(B, M)),
              // simple root
              f(i(u(9, B, N), u(D, C)), u(2, M))
              // double root
            ];
          var k;
          n(F, I) ? k = H : k = f(a(H, c(i(u(H, H), u(4, M, M, M)))), 2);
          var L = !0, R = s(k, L).toArray().map((X) => f(a(D, X, f(M, X)), S));
          return R.map((X) => l(X) === "Complex" && n(p(X), p(X) + v(X)) ? p(X) : X);
        }
        default:
          throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(x));
      }
    }
  });
}), $O = "Help", ez = ["evaluate"], o0 = /* @__PURE__ */ U($O, ez, (r) => {
  var {
    evaluate: e
  } = r;
  function t(n) {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!n)
      throw new Error('Argument "doc" missing');
    this.doc = n;
  }
  return t.prototype.type = "Help", t.prototype.isHelp = !0, t.prototype.toString = function() {
    var n = this.doc || {}, a = `
`;
    if (n.name && (a += "Name: " + n.name + `

`), n.category && (a += "Category: " + n.category + `

`), n.description && (a += `Description:
    ` + n.description + `

`), n.syntax && (a += `Syntax:
    ` + n.syntax.join(`
    `) + `

`), n.examples) {
      a += `Examples:
`;
      for (var i = !1, u = e("config()"), f = {
        config: (l) => (i = !0, e("config(newConfig)", {
          newConfig: l
        }))
      }, c = 0; c < n.examples.length; c++) {
        var o = n.examples[c];
        a += "    " + o + `
`;
        var s = void 0;
        try {
          s = e(o, f);
        } catch (l) {
          s = l;
        }
        s !== void 0 && !uu(s) && (a += "        " + Ke(s, {
          precision: 14
        }) + `
`);
      }
      a += `
`, i && e("config(originalConfig)", {
        originalConfig: u
      });
    }
    return n.mayThrow && n.mayThrow.length && (a += "Throws: " + n.mayThrow.join(", ") + `

`), n.seealso && n.seealso.length && (a += "See also: " + n.seealso.join(", ") + `
`), a;
  }, t.prototype.toJSON = function() {
    var n = Ie(this.doc);
    return n.mathjs = "Help", n;
  }, t.fromJSON = function(n) {
    var a = {};
    return Object.keys(n).filter((i) => i !== "mathjs").forEach((i) => {
      a[i] = n[i];
    }), new t(a);
  }, t.prototype.valueOf = t.prototype.toString, t;
}, {
  isClass: !0
}), rz = "Chain", tz = ["?on", "math", "typed"], s0 = /* @__PURE__ */ U(rz, tz, (r) => {
  var {
    on: e,
    math: t,
    typed: n
  } = r;
  function a(o) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    cu(o) ? this.value = o.value : this.value = o;
  }
  a.prototype.type = "Chain", a.prototype.isChain = !0, a.prototype.done = function() {
    return this.value;
  }, a.prototype.valueOf = function() {
    return this.value;
  }, a.prototype.toString = function() {
    return Ke(this.value);
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "Chain",
      value: this.value
    };
  }, a.fromJSON = function(o) {
    return new a(o.value);
  };
  function i(o, s) {
    typeof s == "function" && (a.prototype[o] = f(s));
  }
  function u(o, s) {
    Bs(a.prototype, o, function() {
      var v = s();
      if (typeof v == "function")
        return f(v);
    });
  }
  function f(o) {
    return function() {
      if (arguments.length === 0)
        return new a(o(this.value));
      for (var s = [this.value], l = 0; l < arguments.length; l++)
        s[l + 1] = arguments[l];
      if (n.isTypedFunction(o)) {
        var v = n.resolve(o, s);
        if (v.params.length === 1)
          throw new Error("chain function " + o.name + " cannot match rest parameter between chain value and additional arguments.");
        return new a(v.implementation.apply(o, s));
      }
      return new a(o.apply(o, s));
    };
  }
  a.createProxy = function(o, s) {
    if (typeof o == "string")
      i(o, s);
    else {
      var l = function(h) {
        Pe(o, h) && c[h] === void 0 && u(h, () => o[h]);
      };
      for (var v in o)
        l(v);
    }
  };
  var c = {
    expression: !0,
    docs: !0,
    type: !0,
    classes: !0,
    json: !0,
    error: !0,
    isChain: !0
    // conflicts with the property isChain of a Chain instance
  };
  return a.createProxy(t), e && e("import", function(o, s, l) {
    l || u(o, s);
  }), a;
}, {
  isClass: !0
}), kb = {
  name: "e",
  category: "Constants",
  syntax: ["e"],
  description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
  examples: ["e", "e ^ 2", "exp(2)", "log(e)"],
  seealso: ["exp"]
}, nz = {
  name: "false",
  category: "Constants",
  syntax: ["false"],
  description: "Boolean value false",
  examples: ["false"],
  seealso: ["true"]
}, az = {
  name: "i",
  category: "Constants",
  syntax: ["i"],
  description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
  examples: ["i", "i * i", "sqrt(-1)"],
  seealso: []
}, iz = {
  name: "Infinity",
  category: "Constants",
  syntax: ["Infinity"],
  description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
  examples: ["Infinity", "1 / 0"],
  seealso: []
}, oz = {
  name: "LN10",
  category: "Constants",
  syntax: ["LN10"],
  description: "Returns the natural logarithm of 10, approximately equal to 2.302",
  examples: ["LN10", "log(10)"],
  seealso: []
}, sz = {
  name: "LN2",
  category: "Constants",
  syntax: ["LN2"],
  description: "Returns the natural logarithm of 2, approximately equal to 0.693",
  examples: ["LN2", "log(2)"],
  seealso: []
}, uz = {
  name: "LOG10E",
  category: "Constants",
  syntax: ["LOG10E"],
  description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
  examples: ["LOG10E", "log(e, 10)"],
  seealso: []
}, cz = {
  name: "LOG2E",
  category: "Constants",
  syntax: ["LOG2E"],
  description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
  examples: ["LOG2E", "log(e, 2)"],
  seealso: []
}, lz = {
  name: "NaN",
  category: "Constants",
  syntax: ["NaN"],
  description: "Not a number",
  examples: ["NaN", "0 / 0"],
  seealso: []
}, fz = {
  name: "null",
  category: "Constants",
  syntax: ["null"],
  description: "Value null",
  examples: ["null"],
  seealso: ["true", "false"]
}, vz = {
  name: "phi",
  category: "Constants",
  syntax: ["phi"],
  description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
  examples: ["phi"],
  seealso: []
}, Xb = {
  name: "pi",
  category: "Constants",
  syntax: ["pi"],
  description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
  examples: ["pi", "sin(pi/2)"],
  seealso: ["tau"]
}, pz = {
  name: "SQRT1_2",
  category: "Constants",
  syntax: ["SQRT1_2"],
  description: "Returns the square root of 1/2, approximately equal to 0.707",
  examples: ["SQRT1_2", "sqrt(1/2)"],
  seealso: []
}, dz = {
  name: "SQRT2",
  category: "Constants",
  syntax: ["SQRT2"],
  description: "Returns the square root of 2, approximately equal to 1.414",
  examples: ["SQRT2", "sqrt(2)"],
  seealso: []
}, mz = {
  name: "tau",
  category: "Constants",
  syntax: ["tau"],
  description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
  examples: ["tau", "2 * pi"],
  seealso: ["pi"]
}, hz = {
  name: "true",
  category: "Constants",
  syntax: ["true"],
  description: "Boolean value true",
  examples: ["true"],
  seealso: ["false"]
}, gz = {
  name: "version",
  category: "Constants",
  syntax: ["version"],
  description: "A string with the version number of math.js",
  examples: ["version"],
  seealso: []
}, xz = {
  name: "bignumber",
  category: "Construction",
  syntax: ["bignumber(x)"],
  description: "Create a big number from a number or string.",
  examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"],
  seealso: ["boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
}, yz = {
  name: "boolean",
  category: "Construction",
  syntax: ["x", "boolean(x)"],
  description: "Convert a string or number into a boolean.",
  examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"],
  seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"]
}, Az = {
  name: "complex",
  category: "Construction",
  syntax: ["complex()", "complex(re, im)", "complex(string)"],
  description: "Create a complex number.",
  examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'],
  seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"]
}, bz = {
  name: "createUnit",
  category: "Construction",
  syntax: ["createUnit(definitions)", "createUnit(name, definition)"],
  description: "Create a user-defined unit and register it with the Unit type.",
  examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'],
  seealso: ["unit", "splitUnit"]
}, wz = {
  name: "fraction",
  category: "Construction",
  syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"],
  description: "Create a fraction from a number or from integer numerator and denominator.",
  examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"]
}, Dz = {
  name: "index",
  category: "Construction",
  syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"],
  description: "Create an index to get or replace a subset of a matrix",
  examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"],
  seealso: ["bignumber", "boolean", "complex", "matrix,", "number", "range", "string", "unit"]
}, Cz = {
  name: "matrix",
  category: "Construction",
  syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"],
  description: "Create a matrix.",
  examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"]
}, Ez = {
  name: "number",
  category: "Construction",
  syntax: ["x", "number(x)", "number(unit, valuelessUnit)"],
  description: "Create a number or convert a string or boolean into a number.",
  examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'],
  seealso: ["bignumber", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
}, Nz = {
  name: "sparse",
  category: "Construction",
  syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'],
  description: "Create a sparse matrix.",
  examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"]
}, Bz = {
  name: "splitUnit",
  category: "Construction",
  syntax: ["splitUnit(unit: Unit, parts: Unit[])"],
  description: "Split a unit in an array of units whose sum is equal to the original unit.",
  examples: ['splitUnit(1 m, ["feet", "inch"])'],
  seealso: ["unit", "createUnit"]
}, Sz = {
  name: "string",
  category: "Construction",
  syntax: ['"text"', "string(x)"],
  description: "Create a string or convert a value to a string",
  examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"]
}, Pz = {
  name: "unit",
  category: "Construction",
  syntax: ["value unit", "unit(value, unit)", "unit(string)"],
  description: "Create a unit.",
  examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"]
}, Mz = {
  name: "config",
  category: "Core",
  syntax: ["config()", "config(options)"],
  description: "Get configuration or change configuration.",
  examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"],
  seealso: []
}, Fz = {
  name: "import",
  category: "Core",
  syntax: ["import(functions)", "import(functions, options)"],
  description: "Import functions or constants from an object.",
  examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"],
  seealso: []
}, Tz = {
  name: "typed",
  category: "Core",
  syntax: ["typed(signatures)", "typed(name, signatures)"],
  description: "Create a typed function.",
  examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'],
  seealso: []
}, Oz = {
  name: "derivative",
  category: "Algebra",
  syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"],
  description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
  examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"],
  seealso: ["simplify", "parse", "evaluate"]
}, zz = {
  name: "leafCount",
  category: "Algebra",
  syntax: ["leafCount(expr)"],
  description: "Computes the number of leaves in the parse tree of the given expression",
  examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'],
  seealso: ["simplify"]
}, Rz = {
  name: "lsolve",
  category: "Algebra",
  syntax: ["x=lsolve(L, b)"],
  description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, Iz = {
  name: "lsolveAll",
  category: "Algebra",
  syntax: ["x=lsolveAll(L, b)"],
  description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, Hz = {
  name: "lup",
  category: "Algebra",
  syntax: ["lup(m)"],
  description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
  examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"]
}, Lz = {
  name: "lusolve",
  category: "Algebra",
  syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"],
  description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"],
  seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"]
}, qz = {
  name: "polynomialRoot",
  category: "Algebra",
  syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"],
  description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",
  examples: ["a = polynomialRoot(-6, 11, -6, 1)"],
  seealso: ["cbrt", "sqrt"]
}, Uz = {
  name: "qr",
  category: "Algebra",
  syntax: ["qr(A)"],
  description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
  examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],
  seealso: ["lup", "slu", "matrix"]
}, kz = {
  name: "rationalize",
  category: "Algebra",
  syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"],
  description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
  examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'],
  seealso: ["simplify"]
}, Xz = {
  name: "resolve",
  category: "Algebra",
  syntax: ["resolve(node, scope)"],
  description: "Recursively substitute variables in an expression tree.",
  examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'],
  seealso: ["simplify", "evaluate"],
  mayThrow: ["ReferenceError"]
}, jz = {
  name: "simplify",
  category: "Algebra",
  syntax: ["simplify(expr)", "simplify(expr, rules)"],
  description: "Simplify an expression tree.",
  examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"],
  seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"]
}, Gz = {
  name: "simplifyConstant",
  category: "Algebra",
  syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"],
  description: "Replace constant subexpressions of node with their values.",
  examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'],
  seealso: ["simplify", "simplifyCore", "evaluate"]
}, Vz = {
  name: "simplifyCore",
  category: "Algebra",
  syntax: ["simplifyCore(node)"],
  description: "Perform simple one-pass simplifications on an expression tree.",
  examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'],
  seealso: ["simplify", "simplifyConstant", "evaluate"]
}, Qz = {
  name: "slu",
  category: "Algebra",
  syntax: ["slu(A, order, threshold)"],
  description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
  examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"]
}, Yz = {
  name: "symbolicEqual",
  category: "Algebra",
  syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"],
  description: "Returns true if the difference of the expressions simplifies to 0",
  examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'],
  seealso: ["simplify", "evaluate"]
}, Zz = {
  name: "usolve",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, Wz = {
  name: "usolveAll",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, Kz = {
  name: "abs",
  category: "Arithmetic",
  syntax: ["abs(x)"],
  description: "Compute the absolute value.",
  examples: ["abs(3.5)", "abs(-4.2)"],
  seealso: ["sign"]
}, Jz = {
  name: "add",
  category: "Operators",
  syntax: ["x + y", "add(x, y)"],
  description: "Add two values.",
  examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'],
  seealso: ["subtract"]
}, _z = {
  name: "cbrt",
  category: "Arithmetic",
  syntax: ["cbrt(x)", "cbrt(x, allRoots)"],
  description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
  examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"],
  seealso: ["square", "sqrt", "cube", "multiply"]
}, $z = {
  name: "ceil",
  category: "Arithmetic",
  syntax: ["ceil(x)"],
  description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
  examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)"],
  seealso: ["floor", "fix", "round"]
}, eR = {
  name: "cube",
  category: "Arithmetic",
  syntax: ["cube(x)"],
  description: "Compute the cube of a value. The cube of x is x * x * x.",
  examples: ["cube(2)", "2^3", "2 * 2 * 2"],
  seealso: ["multiply", "square", "pow"]
}, rR = {
  name: "divide",
  category: "Operators",
  syntax: ["x / y", "divide(x, y)"],
  description: "Divide two values.",
  examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"],
  seealso: ["multiply"]
}, tR = {
  name: "dotDivide",
  category: "Operators",
  syntax: ["x ./ y", "dotDivide(x, y)"],
  description: "Divide two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"],
  seealso: ["multiply", "dotMultiply", "divide"]
}, nR = {
  name: "dotMultiply",
  category: "Operators",
  syntax: ["x .* y", "dotMultiply(x, y)"],
  description: "Multiply two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"],
  seealso: ["multiply", "divide", "dotDivide"]
}, aR = {
  name: "dotPow",
  category: "Operators",
  syntax: ["x .^ y", "dotPow(x, y)"],
  description: "Calculates the power of x to y element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"],
  seealso: ["pow"]
}, iR = {
  name: "exp",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Calculate the exponent of a value.",
  examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],
  seealso: ["expm", "expm1", "pow", "log"]
}, oR = {
  name: "expm",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
  examples: ["expm([[0,2],[0,0]])"],
  seealso: ["exp"]
}, sR = {
  name: "expm1",
  category: "Arithmetic",
  syntax: ["expm1(x)"],
  description: "Calculate the value of subtracting 1 from the exponential value.",
  examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"],
  seealso: ["exp", "pow", "log"]
}, uR = {
  name: "fix",
  category: "Arithmetic",
  syntax: ["fix(x)"],
  description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
  examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)"],
  seealso: ["ceil", "floor", "round"]
}, cR = {
  name: "floor",
  category: "Arithmetic",
  syntax: ["floor(x)"],
  description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
  examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)"],
  seealso: ["ceil", "fix", "round"]
}, lR = {
  name: "gcd",
  category: "Arithmetic",
  syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"],
  description: "Compute the greatest common divisor.",
  examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"],
  seealso: ["lcm", "xgcd"]
}, fR = {
  name: "hypot",
  category: "Arithmetic",
  syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"],
  description: "Calculate the hypotenusa of a list with values. ",
  examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"],
  seealso: ["abs", "norm"]
}, vR = {
  name: "invmod",
  category: "Arithmetic",
  syntax: ["invmod(a, b)"],
  description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)",
  examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"],
  seealso: ["gcd", "xgcd"]
}, pR = {
  name: "lcm",
  category: "Arithmetic",
  syntax: ["lcm(x, y)"],
  description: "Compute the least common multiple.",
  examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"],
  seealso: ["gcd"]
}, dR = {
  name: "log",
  category: "Arithmetic",
  syntax: ["log(x)", "log(x, base)"],
  description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
  examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"],
  seealso: ["exp", "log1p", "log2", "log10"]
}, mR = {
  name: "log10",
  category: "Arithmetic",
  syntax: ["log10(x)"],
  description: "Compute the 10-base logarithm of a value.",
  examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"],
  seealso: ["exp", "log"]
}, hR = {
  name: "log1p",
  category: "Arithmetic",
  syntax: ["log1p(x)", "log1p(x, base)"],
  description: "Calculate the logarithm of a `value+1`",
  examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"],
  seealso: ["exp", "log", "log2", "log10"]
}, gR = {
  name: "log2",
  category: "Arithmetic",
  syntax: ["log2(x)"],
  description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
  examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"],
  seealso: ["exp", "log1p", "log", "log10"]
}, xR = {
  name: "mod",
  category: "Operators",
  syntax: ["x % y", "x mod y", "mod(x, y)"],
  description: "Calculates the modulus, the remainder of an integer division.",
  examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"],
  seealso: ["divide"]
}, yR = {
  name: "multiply",
  category: "Operators",
  syntax: ["x * y", "multiply(x, y)"],
  description: "multiply two values.",
  examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"],
  seealso: ["divide"]
}, AR = {
  name: "norm",
  category: "Arithmetic",
  syntax: ["norm(x)", "norm(x, p)"],
  description: "Calculate the norm of a number, vector or matrix.",
  examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")']
}, bR = {
  name: "nthRoot",
  category: "Arithmetic",
  syntax: ["nthRoot(a)", "nthRoot(a, root)"],
  description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
  examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"],
  seealso: ["nthRoots", "pow", "sqrt"]
}, wR = {
  name: "nthRoots",
  category: "Arithmetic",
  syntax: ["nthRoots(A)", "nthRoots(A, root)"],
  description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
  examples: ["nthRoots(1)", "nthRoots(1, 3)"],
  seealso: ["sqrt", "pow", "nthRoot"]
}, DR = {
  name: "pow",
  category: "Operators",
  syntax: ["x ^ y", "pow(x, y)"],
  description: "Calculates the power of x to y, x^y.",
  examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"],
  seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"]
}, CR = {
  name: "round",
  category: "Arithmetic",
  syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"],
  description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
  examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"],
  seealso: ["ceil", "floor", "fix"]
}, ER = {
  name: "sign",
  category: "Arithmetic",
  syntax: ["sign(x)"],
  description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
  examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"],
  seealso: ["abs"]
}, NR = {
  name: "sqrt",
  category: "Arithmetic",
  syntax: ["sqrt(x)"],
  description: "Compute the square root value. If x = y * y, then y is the square root of x.",
  examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"],
  seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"]
}, BR = {
  name: "sqrtm",
  category: "Arithmetic",
  syntax: ["sqrtm(x)"],
  description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
  examples: ["sqrtm([[33, 24], [48, 57]])"],
  seealso: ["sqrt", "abs", "square", "multiply"]
}, SR = {
  name: "sylvester",
  category: "Algebra",
  syntax: ["sylvester(A,B,C)"],
  description: "Solves the real-valued Sylvester equation AX+XB=C for X",
  examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"],
  seealso: ["schur", "lyap"]
}, PR = {
  name: "schur",
  category: "Algebra",
  syntax: ["schur(A)"],
  description: "Performs a real Schur decomposition of the real matrix A = UTU'",
  examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"],
  seealso: ["lyap", "sylvester"]
}, MR = {
  name: "lyap",
  category: "Algebra",
  syntax: ["lyap(A,Q)"],
  description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P",
  examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"],
  seealso: ["schur", "sylvester"]
}, FR = {
  name: "square",
  category: "Arithmetic",
  syntax: ["square(x)"],
  description: "Compute the square of a value. The square of x is x * x.",
  examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"],
  seealso: ["multiply", "pow", "sqrt", "cube"]
}, TR = {
  name: "subtract",
  category: "Operators",
  syntax: ["x - y", "subtract(x, y)"],
  description: "subtract two values.",
  examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"],
  seealso: ["add"]
}, OR = {
  name: "unaryMinus",
  category: "Operators",
  syntax: ["-x", "unaryMinus(x)"],
  description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
  examples: ["-4.5", "-(-5.6)", '-"22"'],
  seealso: ["add", "subtract", "unaryPlus"]
}, zR = {
  name: "unaryPlus",
  category: "Operators",
  syntax: ["+x", "unaryPlus(x)"],
  description: "Converts booleans and strings to numbers.",
  examples: ["+true", '+"2"'],
  seealso: ["add", "subtract", "unaryMinus"]
}, RR = {
  name: "xgcd",
  category: "Arithmetic",
  syntax: ["xgcd(a, b)"],
  description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
  examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"],
  seealso: ["gcd", "lcm"]
}, IR = {
  name: "bitAnd",
  category: "Bitwise",
  syntax: ["x & y", "bitAnd(x, y)"],
  description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
  examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"],
  seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, HR = {
  name: "bitNot",
  category: "Bitwise",
  syntax: ["~x", "bitNot(x)"],
  description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
  examples: ["~1", "~2", "bitNot([2, -3, 4])"],
  seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, LR = {
  name: "bitOr",
  category: "Bitwise",
  syntax: ["x | y", "bitOr(x, y)"],
  description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
  examples: ["5 | 3", "bitOr([1, 2, 3], 4)"],
  seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, qR = {
  name: "bitXor",
  category: "Bitwise",
  syntax: ["bitXor(x, y)"],
  description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
  examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"],
  seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"]
}, UR = {
  name: "leftShift",
  category: "Bitwise",
  syntax: ["x << y", "leftShift(x, y)"],
  description: "Bitwise left logical shift of a value x by y number of bits.",
  examples: ["4 << 1", "8 >> 1"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"]
}, kR = {
  name: "rightArithShift",
  category: "Bitwise",
  syntax: ["x >> y", "rightArithShift(x, y)"],
  description: "Bitwise right arithmetic shift of a value x by y number of bits.",
  examples: ["8 >> 1", "4 << 1", "-12 >> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"]
}, XR = {
  name: "rightLogShift",
  category: "Bitwise",
  syntax: ["x >>> y", "rightLogShift(x, y)"],
  description: "Bitwise right logical shift of a value x by y number of bits.",
  examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"]
}, jR = {
  name: "bellNumbers",
  category: "Combinatorics",
  syntax: ["bellNumbers(n)"],
  description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["bellNumbers(3)", "bellNumbers(8)"],
  seealso: ["stirlingS2"]
}, GR = {
  name: "catalan",
  category: "Combinatorics",
  syntax: ["catalan(n)"],
  description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["catalan(3)", "catalan(8)"],
  seealso: ["bellNumbers"]
}, VR = {
  name: "composition",
  category: "Combinatorics",
  syntax: ["composition(n, k)"],
  description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
  examples: ["composition(5, 3)"],
  seealso: ["combinations"]
}, QR = {
  name: "stirlingS2",
  category: "Combinatorics",
  syntax: ["stirlingS2(n, k)"],
  description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
  examples: ["stirlingS2(5, 3)"],
  seealso: ["bellNumbers"]
}, YR = {
  name: "arg",
  category: "Complex",
  syntax: ["arg(x)"],
  description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
  examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"],
  seealso: ["re", "im", "conj", "abs"]
}, ZR = {
  name: "conj",
  category: "Complex",
  syntax: ["conj(x)"],
  description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
  examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"],
  seealso: ["re", "im", "abs", "arg"]
}, WR = {
  name: "im",
  category: "Complex",
  syntax: ["im(x)"],
  description: "Get the imaginary part of a complex number.",
  examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"],
  seealso: ["re", "conj", "abs", "arg"]
}, KR = {
  name: "re",
  category: "Complex",
  syntax: ["re(x)"],
  description: "Get the real part of a complex number.",
  examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"],
  seealso: ["im", "conj", "abs", "arg"]
}, JR = {
  name: "evaluate",
  category: "Expression",
  syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"],
  description: "Evaluate an expression or an array with expressions.",
  examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'],
  seealso: []
}, _R = {
  name: "help",
  category: "Expression",
  syntax: ["help(object)", "help(string)"],
  description: "Display documentation on a function or data type.",
  examples: ["help(sqrt)", 'help("complex")'],
  seealso: []
}, $R = {
  name: "distance",
  category: "Geometry",
  syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"],
  description: "Calculates the Euclidean distance between two points.",
  examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"],
  seealso: []
}, eI = {
  name: "intersect",
  category: "Geometry",
  syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"],
  description: "Computes the intersection point of lines and/or planes.",
  examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],
  seealso: []
}, rI = {
  name: "and",
  category: "Logical",
  syntax: ["x and y", "and(x, y)"],
  description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
  examples: ["true and false", "true and true", "2 and 4"],
  seealso: ["not", "or", "xor"]
}, tI = {
  name: "not",
  category: "Logical",
  syntax: ["not x", "not(x)"],
  description: "Logical not. Flips the boolean value of given argument.",
  examples: ["not true", "not false", "not 2", "not 0"],
  seealso: ["and", "or", "xor"]
}, nI = {
  name: "or",
  category: "Logical",
  syntax: ["x or y", "or(x, y)"],
  description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
  examples: ["true or false", "false or false", "0 or 4"],
  seealso: ["not", "and", "xor"]
}, aI = {
  name: "xor",
  category: "Logical",
  syntax: ["x xor y", "xor(x, y)"],
  description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
  examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"],
  seealso: ["not", "and", "or"]
}, iI = {
  name: "column",
  category: "Matrix",
  syntax: ["column(x, index)"],
  description: "Return a column from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"],
  seealso: ["row", "matrixFromColumns"]
}, oI = {
  name: "concat",
  category: "Matrix",
  syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"],
  description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
  examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"],
  seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, sI = {
  name: "count",
  category: "Matrix",
  syntax: ["count(x)"],
  description: "Count the number of elements of a matrix, array or string.",
  examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'],
  seealso: ["size"]
}, uI = {
  name: "cross",
  category: "Matrix",
  syntax: ["cross(A, B)"],
  description: "Calculate the cross product for two vectors in three dimensional space.",
  examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"],
  seealso: ["multiply", "dot"]
}, cI = {
  name: "ctranspose",
  category: "Matrix",
  syntax: ["x'", "ctranspose(x)"],
  description: "Complex Conjugate and Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, lI = {
  name: "det",
  category: "Matrix",
  syntax: ["det(x)"],
  description: "Calculate the determinant of a matrix",
  examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],
  seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, fI = {
  name: "diag",
  category: "Matrix",
  syntax: ["diag(x)", "diag(x, k)"],
  description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
  examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"],
  seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, vI = {
  name: "diff",
  category: "Matrix",
  syntax: ["diff(arr)", "diff(arr, dim)"],
  description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"],
  examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"],
  seealso: ["subtract", "partitionSelect"]
}, pI = {
  name: "dot",
  category: "Matrix",
  syntax: ["dot(A, B)", "A * B"],
  description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
  examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"],
  seealso: ["multiply", "cross"]
}, dI = {
  name: "eigs",
  category: "Matrix",
  syntax: ["eigs(x)"],
  description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix",
  examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"],
  seealso: ["inv"]
}, mI = {
  name: "filter",
  category: "Matrix",
  syntax: ["filter(x, test)"],
  description: "Filter items in a matrix.",
  examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"],
  seealso: ["sort", "map", "forEach"]
}, hI = {
  name: "flatten",
  category: "Matrix",
  syntax: ["flatten(x)"],
  description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"],
  seealso: ["concat", "resize", "size", "squeeze"]
}, gI = {
  name: "forEach",
  category: "Matrix",
  syntax: ["forEach(x, callback)"],
  description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
  examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"],
  seealso: ["map", "sort", "filter"]
}, xI = {
  name: "getMatrixDataType",
  category: "Matrix",
  syntax: ["getMatrixDataType(x)"],
  description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
  examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"],
  seealso: ["matrix", "sparse", "typeOf"]
}, yI = {
  name: "identity",
  category: "Matrix",
  syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"],
  description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
  examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"],
  seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, AI = {
  name: "inv",
  category: "Matrix",
  syntax: ["inv(x)"],
  description: "Calculate the inverse of a matrix",
  examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"],
  seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, bI = {
  name: "pinv",
  category: "Matrix",
  syntax: ["pinv(x)"],
  description: "Calculate the Moore–Penrose inverse of a matrix",
  examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"],
  seealso: ["inv"]
}, wI = {
  name: "kron",
  category: "Matrix",
  syntax: ["kron(x, y)"],
  description: "Calculates the kronecker product of 2 matrices or vectors.",
  examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"],
  seealso: ["multiply", "dot", "cross"]
}, DI = {
  name: "map",
  category: "Matrix",
  syntax: ["map(x, callback)"],
  description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
  examples: ["map([1, 2, 3], square)"],
  seealso: ["filter", "forEach"]
}, CI = {
  name: "matrixFromColumns",
  category: "Matrix",
  syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual columns.",
  examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"]
}, EI = {
  name: "matrixFromFunction",
  category: "Matrix",
  syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"],
  description: "Create a matrix by evaluating a generating function at each index.",
  examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"],
  seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"]
}, NI = {
  name: "matrixFromRows",
  category: "Matrix",
  syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual rows.",
  examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"]
}, BI = {
  name: "ones",
  category: "Matrix",
  syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"],
  description: "Create a matrix containing ones.",
  examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, SI = {
  name: "partitionSelect",
  category: "Matrix",
  syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"],
  description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
  examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"],
  seealso: ["sort"]
}, PI = {
  name: "range",
  category: "Type",
  syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"],
  description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
  examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, MI = {
  name: "reshape",
  category: "Matrix",
  syntax: ["reshape(x, sizes)"],
  description: "Reshape a multi dimensional array to fit the specified dimensions.",
  examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"],
  seealso: ["size", "squeeze", "resize"]
}, FI = {
  name: "resize",
  category: "Matrix",
  syntax: ["resize(x, size)", "resize(x, size, defaultValue)"],
  description: "Resize a matrix.",
  examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'],
  seealso: ["size", "subset", "squeeze", "reshape"]
}, TI = {
  name: "rotate",
  category: "Matrix",
  syntax: ["rotate(w, theta)", "rotate(w, theta, v)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'],
  seealso: ["matrix", "rotationMatrix"]
}, OI = {
  name: "rotationMatrix",
  category: "Matrix",
  syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'],
  seealso: ["cos", "sin"]
}, zI = {
  name: "row",
  category: "Matrix",
  syntax: ["row(x, index)"],
  description: "Return a row from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"],
  seealso: ["column", "matrixFromRows"]
}, RI = {
  name: "size",
  category: "Matrix",
  syntax: ["size(x)"],
  description: "Calculate the size of a matrix.",
  examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"],
  seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"]
}, II = {
  name: "sort",
  category: "Matrix",
  syntax: ["sort(x)", "sort(x, compare)"],
  description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
  examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'],
  seealso: ["map", "filter", "forEach"]
}, HI = {
  name: "squeeze",
  category: "Matrix",
  syntax: ["squeeze(x)"],
  description: "Remove inner and outer singleton dimensions from a matrix.",
  examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"]
}, LI = {
  name: "subset",
  category: "Matrix",
  syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"],
  description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
  examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"]
}, qI = {
  name: "trace",
  category: "Matrix",
  syntax: ["trace(A)"],
  description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
  examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"]
}, UI = {
  name: "transpose",
  category: "Matrix",
  syntax: ["x'", "transpose(x)"],
  description: "Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, kI = {
  name: "zeros",
  category: "Matrix",
  syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"],
  description: "Create a matrix containing zeros.",
  examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"]
}, XI = {
  name: "fft",
  category: "Matrix",
  syntax: ["fft(x)"],
  description: "Calculate N-dimensional fourier transform",
  examples: ["fft([[1, 0], [1, 0]])"],
  seealso: ["ifft"]
}, jI = {
  name: "ifft",
  category: "Matrix",
  syntax: ["ifft(x)"],
  description: "Calculate N-dimensional inverse fourier transform",
  examples: ["ifft([[2, 2], [0, 0]])"],
  seealso: ["fft"]
}, GI = {
  name: "combinations",
  category: "Probability",
  syntax: ["combinations(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time",
  examples: ["combinations(7, 5)"],
  seealso: ["combinationsWithRep", "permutations", "factorial"]
}, VI = {
  name: "combinationsWithRep",
  category: "Probability",
  syntax: ["combinationsWithRep(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time with replacements.",
  examples: ["combinationsWithRep(7, 5)"],
  seealso: ["combinations", "permutations", "factorial"]
}, QI = {
  name: "factorial",
  category: "Probability",
  syntax: ["n!", "factorial(n)"],
  description: "Compute the factorial of a value",
  examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"],
  seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"]
}, YI = {
  name: "gamma",
  category: "Probability",
  syntax: ["gamma(n)"],
  description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
  examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"],
  seealso: ["factorial"]
}, ZI = {
  name: "lgamma",
  category: "Probability",
  syntax: ["lgamma(n)"],
  description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
  examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"],
  seealso: ["gamma"]
}, WI = {
  name: "kldivergence",
  category: "Probability",
  syntax: ["kldivergence(x, y)"],
  description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
  examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],
  seealso: []
}, KI = {
  name: "multinomial",
  category: "Probability",
  syntax: ["multinomial(A)"],
  description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
  examples: ["multinomial([1, 2, 1])"],
  seealso: ["combinations", "factorial"]
}, JI = {
  name: "permutations",
  category: "Probability",
  syntax: ["permutations(n)", "permutations(n, k)"],
  description: "Compute the number of permutations of n items taken k at a time",
  examples: ["permutations(5)", "permutations(5, 3)"],
  seealso: ["combinations", "combinationsWithRep", "factorial"]
}, _I = {
  name: "pickRandom",
  category: "Probability",
  syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"],
  description: "Pick a random entry from a given array.",
  examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],
  seealso: ["random", "randomInt"]
}, $I = {
  name: "random",
  category: "Probability",
  syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"],
  description: "Return a random number.",
  examples: ["random()", "random(10, 20)", "random([2, 3])"],
  seealso: ["pickRandom", "randomInt"]
}, eH = {
  name: "randomInt",
  category: "Probability",
  syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"],
  description: "Return a random integer number",
  examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"],
  seealso: ["pickRandom", "random"]
}, rH = {
  name: "compare",
  category: "Relational",
  syntax: ["compare(x, y)"],
  description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"]
}, tH = {
  name: "compareNatural",
  category: "Relational",
  syntax: ["compareNatural(x, y)"],
  description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"]
}, nH = {
  name: "compareText",
  category: "Relational",
  syntax: ["compareText(x, y)"],
  description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural"]
}, aH = {
  name: "deepEqual",
  category: "Relational",
  syntax: ["deepEqual(x, y)"],
  description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
  examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"],
  seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"]
}, iH = {
  name: "equal",
  category: "Relational",
  syntax: ["x == y", "equal(x, y)"],
  description: "Check equality of two values. Returns true if the values are equal, and false if not.",
  examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"],
  seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"]
}, oH = {
  name: "equalText",
  category: "Relational",
  syntax: ["equalText(x, y)"],
  description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
  examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural", "compareText", "equal"]
}, sH = {
  name: "larger",
  category: "Relational",
  syntax: ["x > y", "larger(x, y)"],
  description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
  examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"]
}, uH = {
  name: "largerEq",
  category: "Relational",
  syntax: ["x >= y", "largerEq(x, y)"],
  description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
  examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"],
  seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"]
}, cH = {
  name: "smaller",
  category: "Relational",
  syntax: ["x < y", "smaller(x, y)"],
  description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"],
  seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"]
}, lH = {
  name: "smallerEq",
  category: "Relational",
  syntax: ["x <= y", "smallerEq(x, y)"],
  description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"],
  seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"]
}, fH = {
  name: "unequal",
  category: "Relational",
  syntax: ["x != y", "unequal(x, y)"],
  description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
  examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"],
  seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
}, vH = {
  name: "setCartesian",
  category: "Set",
  syntax: ["setCartesian(set1, set2)"],
  description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
  examples: ["setCartesian([1, 2], [3, 4])"],
  seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"]
}, pH = {
  name: "setDifference",
  category: "Set",
  syntax: ["setDifference(set1, set2)"],
  description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setSymDifference"]
}, dH = {
  name: "setDistinct",
  category: "Set",
  syntax: ["setDistinct(set)"],
  description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setDistinct([1, 1, 1, 2, 2, 3])"],
  seealso: ["setMultiplicity"]
}, mH = {
  name: "setIntersect",
  category: "Set",
  syntax: ["setIntersect(set1, set2)"],
  description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setDifference"]
}, hH = {
  name: "setIsSubset",
  category: "Set",
  syntax: ["setIsSubset(set1, set2)"],
  description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, gH = {
  name: "setMultiplicity",
  category: "Set",
  syntax: ["setMultiplicity(element, set)"],
  description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"],
  seealso: ["setDistinct", "setSize"]
}, xH = {
  name: "setPowerset",
  category: "Set",
  syntax: ["setPowerset(set)"],
  description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setPowerset([1, 2, 3])"],
  seealso: ["setCartesian"]
}, yH = {
  name: "setSize",
  category: "Set",
  syntax: ["setSize(set)", "setSize(set, unique)"],
  description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
  examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, AH = {
  name: "setSymDifference",
  category: "Set",
  syntax: ["setSymDifference(set1, set2)"],
  description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, bH = {
  name: "setUnion",
  category: "Set",
  syntax: ["setUnion(set1, set2)"],
  description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setIntersect", "setDifference"]
}, wH = {
  name: "zpk2tf",
  category: "Signal",
  syntax: ["zpk2tf(z, p, k)"],
  description: "Compute the transfer function of a zero-pole-gain model.",
  examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"],
  seealso: []
}, DH = {
  name: "freqz",
  category: "Signal",
  syntax: ["freqz(b, a)", "freqz(b, a, w)"],
  description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.",
  examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"],
  seealso: []
}, CH = {
  name: "erf",
  category: "Special",
  syntax: ["erf(x)"],
  description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
  examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"],
  seealso: []
}, EH = {
  name: "zeta",
  category: "Special",
  syntax: ["zeta(s)"],
  description: "Compute the Riemann Zeta Function using an infinite series and Riemanns Functional Equation for the entire complex plane",
  examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"],
  seealso: []
}, NH = {
  name: "mad",
  category: "Statistics",
  syntax: ["mad(a, b, c, ...)", "mad(A)"],
  description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
  examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"],
  seealso: ["mean", "median", "std", "abs"]
}, BH = {
  name: "max",
  category: "Statistics",
  syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"],
  description: "Compute the maximum value of a list of values.",
  examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"]
}, SH = {
  name: "mean",
  category: "Statistics",
  syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"],
  description: "Compute the arithmetic mean of a list of values.",
  examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"],
  seealso: ["max", "median", "min", "prod", "std", "sum", "variance"]
}, PH = {
  name: "median",
  category: "Statistics",
  syntax: ["median(a, b, c, ...)", "median(A)"],
  description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
  examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"],
  seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"]
}, MH = {
  name: "min",
  category: "Statistics",
  syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"],
  description: "Compute the minimum value of a list of values.",
  examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"]
}, FH = {
  name: "mode",
  category: "Statistics",
  syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"],
  description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
  examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"],
  seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"]
}, TH = {
  name: "prod",
  category: "Statistics",
  syntax: ["prod(a, b, c, ...)", "prod(A)"],
  description: "Compute the product of all values.",
  examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"],
  seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"]
}, OH = {
  name: "quantileSeq",
  category: "Statistics",
  syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"],
  description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`,
  examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"],
  seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"]
}, zH = {
  name: "std",
  category: "Statistics",
  syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"],
  description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"]
}, RH = {
  name: "cumsum",
  category: "Statistics",
  syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"],
  description: "Compute the cumulative sum of all values.",
  examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
}, IH = {
  name: "sum",
  category: "Statistics",
  syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"],
  description: "Compute the sum of all values.",
  examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
}, HH = {
  name: "variance",
  category: "Statistics",
  syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"],
  description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, LH = {
  name: "corr",
  category: "Statistics",
  syntax: ["corr(A,B)"],
  description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",
  examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, qH = {
  name: "acos",
  category: "Trigonometry",
  syntax: ["acos(x)"],
  description: "Compute the inverse cosine of a value in radians.",
  examples: ["acos(0.5)", "acos(cos(2.3))"],
  seealso: ["cos", "atan", "asin"]
}, UH = {
  name: "acosh",
  category: "Trigonometry",
  syntax: ["acosh(x)"],
  description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
  examples: ["acosh(1.5)"],
  seealso: ["cosh", "asinh", "atanh"]
}, kH = {
  name: "acot",
  category: "Trigonometry",
  syntax: ["acot(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"],
  seealso: ["cot", "atan"]
}, XH = {
  name: "acoth",
  category: "Trigonometry",
  syntax: ["acoth(x)"],
  description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
  examples: ["acoth(2)", "acoth(0.5)"],
  seealso: ["acsch", "asech"]
}, jH = {
  name: "acsc",
  category: "Trigonometry",
  syntax: ["acsc(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"],
  seealso: ["csc", "asin", "asec"]
}, GH = {
  name: "acsch",
  category: "Trigonometry",
  syntax: ["acsch(x)"],
  description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
  examples: ["acsch(0.5)"],
  seealso: ["asech", "acoth"]
}, VH = {
  name: "asec",
  category: "Trigonometry",
  syntax: ["asec(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"],
  seealso: ["acos", "acot", "acsc"]
}, QH = {
  name: "asech",
  category: "Trigonometry",
  syntax: ["asech(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asech(0.5)"],
  seealso: ["acsch", "acoth"]
}, YH = {
  name: "asin",
  category: "Trigonometry",
  syntax: ["asin(x)"],
  description: "Compute the inverse sine of a value in radians.",
  examples: ["asin(0.5)", "asin(sin(0.5))"],
  seealso: ["sin", "acos", "atan"]
}, ZH = {
  name: "asinh",
  category: "Trigonometry",
  syntax: ["asinh(x)"],
  description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
  examples: ["asinh(0.5)"],
  seealso: ["acosh", "atanh"]
}, WH = {
  name: "atan",
  category: "Trigonometry",
  syntax: ["atan(x)"],
  description: "Compute the inverse tangent of a value in radians.",
  examples: ["atan(0.5)", "atan(tan(0.5))"],
  seealso: ["tan", "acos", "asin"]
}, KH = {
  name: "atan2",
  category: "Trigonometry",
  syntax: ["atan2(y, x)"],
  description: "Computes the principal value of the arc tangent of y/x in radians.",
  examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"],
  seealso: ["sin", "cos", "tan"]
}, JH = {
  name: "atanh",
  category: "Trigonometry",
  syntax: ["atanh(x)"],
  description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
  examples: ["atanh(0.5)"],
  seealso: ["acosh", "asinh"]
}, _H = {
  name: "cos",
  category: "Trigonometry",
  syntax: ["cos(x)"],
  description: "Compute the cosine of x in radians.",
  examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["acos", "sin", "tan"]
}, $H = {
  name: "cosh",
  category: "Trigonometry",
  syntax: ["cosh(x)"],
  description: "Compute the hyperbolic cosine of x in radians.",
  examples: ["cosh(0.5)"],
  seealso: ["sinh", "tanh", "coth"]
}, eL = {
  name: "cot",
  category: "Trigonometry",
  syntax: ["cot(x)"],
  description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
  examples: ["cot(2)", "1 / tan(2)"],
  seealso: ["sec", "csc", "tan"]
}, rL = {
  name: "coth",
  category: "Trigonometry",
  syntax: ["coth(x)"],
  description: "Compute the hyperbolic cotangent of x in radians.",
  examples: ["coth(2)", "1 / tanh(2)"],
  seealso: ["sech", "csch", "tanh"]
}, tL = {
  name: "csc",
  category: "Trigonometry",
  syntax: ["csc(x)"],
  description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
  examples: ["csc(2)", "1 / sin(2)"],
  seealso: ["sec", "cot", "sin"]
}, nL = {
  name: "csch",
  category: "Trigonometry",
  syntax: ["csch(x)"],
  description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
  examples: ["csch(2)", "1 / sinh(2)"],
  seealso: ["sech", "coth", "sinh"]
}, aL = {
  name: "sec",
  category: "Trigonometry",
  syntax: ["sec(x)"],
  description: "Compute the secant of x in radians. Defined as 1/cos(x)",
  examples: ["sec(2)", "1 / cos(2)"],
  seealso: ["cot", "csc", "cos"]
}, iL = {
  name: "sech",
  category: "Trigonometry",
  syntax: ["sech(x)"],
  description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
  examples: ["sech(2)", "1 / cosh(2)"],
  seealso: ["coth", "csch", "cosh"]
}, oL = {
  name: "sin",
  category: "Trigonometry",
  syntax: ["sin(x)"],
  description: "Compute the sine of x in radians.",
  examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["asin", "cos", "tan"]
}, sL = {
  name: "sinh",
  category: "Trigonometry",
  syntax: ["sinh(x)"],
  description: "Compute the hyperbolic sine of x in radians.",
  examples: ["sinh(0.5)"],
  seealso: ["cosh", "tanh"]
}, uL = {
  name: "tan",
  category: "Trigonometry",
  syntax: ["tan(x)"],
  description: "Compute the tangent of x in radians.",
  examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"],
  seealso: ["atan", "sin", "cos"]
}, cL = {
  name: "tanh",
  category: "Trigonometry",
  syntax: ["tanh(x)"],
  description: "Compute the hyperbolic tangent of x in radians.",
  examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"],
  seealso: ["sinh", "cosh"]
}, lL = {
  name: "to",
  category: "Units",
  syntax: ["x to unit", "to(x, unit)"],
  description: "Change the unit of a value.",
  examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"],
  seealso: []
}, fL = {
  name: "bin",
  category: "Utils",
  syntax: ["bin(value)"],
  description: "Format a number as binary",
  examples: ["bin(2)"],
  seealso: ["oct", "hex"]
}, vL = {
  name: "clone",
  category: "Utils",
  syntax: ["clone(x)"],
  description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
  examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'],
  seealso: []
}, pL = {
  name: "format",
  category: "Utils",
  syntax: ["format(value)", "format(value, precision)"],
  description: "Format a value of any type as string.",
  examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"],
  seealso: ["print"]
}, dL = {
  name: "hasNumericValue",
  category: "Utils",
  syntax: ["hasNumericValue(x)"],
  description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
  examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"]
}, mL = {
  name: "hex",
  category: "Utils",
  syntax: ["hex(value)"],
  description: "Format a number as hexadecimal",
  examples: ["hex(240)"],
  seealso: ["bin", "oct"]
}, hL = {
  name: "isInteger",
  category: "Utils",
  syntax: ["isInteger(x)"],
  description: "Test whether a value is an integer number.",
  examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, gL = {
  name: "isNaN",
  category: "Utils",
  syntax: ["isNaN(x)"],
  description: "Test whether a value is NaN (not a number)",
  examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, xL = {
  name: "isNegative",
  category: "Utils",
  syntax: ["isNegative(x)"],
  description: "Test whether a value is negative: smaller than zero.",
  examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isPositive", "isZero"]
}, yL = {
  name: "isNumeric",
  category: "Utils",
  syntax: ["isNumeric(x)"],
  description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
  examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue"]
}, AL = {
  name: "isPositive",
  category: "Utils",
  syntax: ["isPositive(x)"],
  description: "Test whether a value is positive: larger than zero.",
  examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, bL = {
  name: "isPrime",
  category: "Utils",
  syntax: ["isPrime(x)"],
  description: "Test whether a value is prime: has no divisors other than itself and one.",
  examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, wL = {
  name: "isZero",
  category: "Utils",
  syntax: ["isZero(x)"],
  description: "Test whether a value is zero.",
  examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"]
}, DL = {
  name: "numeric",
  category: "Utils",
  syntax: ["numeric(x)"],
  description: "Convert a numeric input to a specific numeric type: number, BigNumber, or Fraction.",
  examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'],
  seealso: ["number", "fraction", "bignumber", "string", "format"]
}, CL = {
  name: "oct",
  category: "Utils",
  syntax: ["oct(value)"],
  description: "Format a number as octal",
  examples: ["oct(56)"],
  seealso: ["bin", "hex"]
}, EL = {
  name: "print",
  category: "Utils",
  syntax: ["print(template, values)", "print(template, values, precision)"],
  description: "Interpolate values into a string template.",
  examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'],
  seealso: ["format"]
}, NL = {
  name: "typeOf",
  category: "Utils",
  syntax: ["typeOf(x)"],
  description: "Get the type of a variable.",
  examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'],
  seealso: ["getMatrixDataType"]
}, BL = {
  name: "solveODE",
  category: "Numeric",
  syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"],
  description: "Numerical Integration of Ordinary Differential Equations.",
  examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'],
  seealso: ["derivative", "simplifyCore"]
}, v4 = {
  // construction functions
  bignumber: xz,
  boolean: yz,
  complex: Az,
  createUnit: bz,
  fraction: wz,
  index: Dz,
  matrix: Cz,
  number: Ez,
  sparse: Nz,
  splitUnit: Bz,
  string: Sz,
  unit: Pz,
  // constants
  e: kb,
  E: kb,
  false: nz,
  i: az,
  Infinity: iz,
  LN2: sz,
  LN10: oz,
  LOG2E: cz,
  LOG10E: uz,
  NaN: lz,
  null: fz,
  pi: Xb,
  PI: Xb,
  phi: vz,
  SQRT1_2: pz,
  SQRT2: dz,
  tau: mz,
  true: hz,
  version: gz,
  // physical constants
  // TODO: more detailed docs for physical constants
  speedOfLight: {
    description: "Speed of light in vacuum",
    examples: ["speedOfLight"]
  },
  gravitationConstant: {
    description: "Newtonian constant of gravitation",
    examples: ["gravitationConstant"]
  },
  planckConstant: {
    description: "Planck constant",
    examples: ["planckConstant"]
  },
  reducedPlanckConstant: {
    description: "Reduced Planck constant",
    examples: ["reducedPlanckConstant"]
  },
  magneticConstant: {
    description: "Magnetic constant (vacuum permeability)",
    examples: ["magneticConstant"]
  },
  electricConstant: {
    description: "Electric constant (vacuum permeability)",
    examples: ["electricConstant"]
  },
  vacuumImpedance: {
    description: "Characteristic impedance of vacuum",
    examples: ["vacuumImpedance"]
  },
  coulomb: {
    description: "Coulomb's constant",
    examples: ["coulomb"]
  },
  elementaryCharge: {
    description: "Elementary charge",
    examples: ["elementaryCharge"]
  },
  bohrMagneton: {
    description: "Borh magneton",
    examples: ["bohrMagneton"]
  },
  conductanceQuantum: {
    description: "Conductance quantum",
    examples: ["conductanceQuantum"]
  },
  inverseConductanceQuantum: {
    description: "Inverse conductance quantum",
    examples: ["inverseConductanceQuantum"]
  },
  // josephson: {description: 'Josephson constant', examples: ['josephson']},
  magneticFluxQuantum: {
    description: "Magnetic flux quantum",
    examples: ["magneticFluxQuantum"]
  },
  nuclearMagneton: {
    description: "Nuclear magneton",
    examples: ["nuclearMagneton"]
  },
  klitzing: {
    description: "Von Klitzing constant",
    examples: ["klitzing"]
  },
  bohrRadius: {
    description: "Borh radius",
    examples: ["bohrRadius"]
  },
  classicalElectronRadius: {
    description: "Classical electron radius",
    examples: ["classicalElectronRadius"]
  },
  electronMass: {
    description: "Electron mass",
    examples: ["electronMass"]
  },
  fermiCoupling: {
    description: "Fermi coupling constant",
    examples: ["fermiCoupling"]
  },
  fineStructure: {
    description: "Fine-structure constant",
    examples: ["fineStructure"]
  },
  hartreeEnergy: {
    description: "Hartree energy",
    examples: ["hartreeEnergy"]
  },
  protonMass: {
    description: "Proton mass",
    examples: ["protonMass"]
  },
  deuteronMass: {
    description: "Deuteron Mass",
    examples: ["deuteronMass"]
  },
  neutronMass: {
    description: "Neutron mass",
    examples: ["neutronMass"]
  },
  quantumOfCirculation: {
    description: "Quantum of circulation",
    examples: ["quantumOfCirculation"]
  },
  rydberg: {
    description: "Rydberg constant",
    examples: ["rydberg"]
  },
  thomsonCrossSection: {
    description: "Thomson cross section",
    examples: ["thomsonCrossSection"]
  },
  weakMixingAngle: {
    description: "Weak mixing angle",
    examples: ["weakMixingAngle"]
  },
  efimovFactor: {
    description: "Efimov factor",
    examples: ["efimovFactor"]
  },
  atomicMass: {
    description: "Atomic mass constant",
    examples: ["atomicMass"]
  },
  avogadro: {
    description: "Avogadro's number",
    examples: ["avogadro"]
  },
  boltzmann: {
    description: "Boltzmann constant",
    examples: ["boltzmann"]
  },
  faraday: {
    description: "Faraday constant",
    examples: ["faraday"]
  },
  firstRadiation: {
    description: "First radiation constant",
    examples: ["firstRadiation"]
  },
  loschmidt: {
    description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
    examples: ["loschmidt"]
  },
  gasConstant: {
    description: "Gas constant",
    examples: ["gasConstant"]
  },
  molarPlanckConstant: {
    description: "Molar Planck constant",
    examples: ["molarPlanckConstant"]
  },
  molarVolume: {
    description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
    examples: ["molarVolume"]
  },
  sackurTetrode: {
    description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
    examples: ["sackurTetrode"]
  },
  secondRadiation: {
    description: "Second radiation constant",
    examples: ["secondRadiation"]
  },
  stefanBoltzmann: {
    description: "Stefan-Boltzmann constant",
    examples: ["stefanBoltzmann"]
  },
  wienDisplacement: {
    description: "Wien displacement law constant",
    examples: ["wienDisplacement"]
  },
  // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
  molarMass: {
    description: "Molar mass constant",
    examples: ["molarMass"]
  },
  molarMassC12: {
    description: "Molar mass constant of carbon-12",
    examples: ["molarMassC12"]
  },
  gravity: {
    description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
    examples: ["gravity"]
  },
  planckLength: {
    description: "Planck length",
    examples: ["planckLength"]
  },
  planckMass: {
    description: "Planck mass",
    examples: ["planckMass"]
  },
  planckTime: {
    description: "Planck time",
    examples: ["planckTime"]
  },
  planckCharge: {
    description: "Planck charge",
    examples: ["planckCharge"]
  },
  planckTemperature: {
    description: "Planck temperature",
    examples: ["planckTemperature"]
  },
  // functions - algebra
  derivative: Oz,
  lsolve: Rz,
  lsolveAll: Iz,
  lup: Hz,
  lusolve: Lz,
  leafCount: zz,
  polynomialRoot: qz,
  resolve: Xz,
  simplify: jz,
  simplifyConstant: Gz,
  simplifyCore: Vz,
  symbolicEqual: Yz,
  rationalize: kz,
  slu: Qz,
  usolve: Zz,
  usolveAll: Wz,
  qr: Uz,
  // functions - arithmetic
  abs: Kz,
  add: Jz,
  cbrt: _z,
  ceil: $z,
  cube: eR,
  divide: rR,
  dotDivide: tR,
  dotMultiply: nR,
  dotPow: aR,
  exp: iR,
  expm: oR,
  expm1: sR,
  fix: uR,
  floor: cR,
  gcd: lR,
  hypot: fR,
  lcm: pR,
  log: dR,
  log2: gR,
  log1p: hR,
  log10: mR,
  mod: xR,
  multiply: yR,
  norm: AR,
  nthRoot: bR,
  nthRoots: wR,
  pow: DR,
  round: CR,
  sign: ER,
  sqrt: NR,
  sqrtm: BR,
  square: FR,
  subtract: TR,
  unaryMinus: OR,
  unaryPlus: zR,
  xgcd: RR,
  invmod: vR,
  // functions - bitwise
  bitAnd: IR,
  bitNot: HR,
  bitOr: LR,
  bitXor: qR,
  leftShift: UR,
  rightArithShift: kR,
  rightLogShift: XR,
  // functions - combinatorics
  bellNumbers: jR,
  catalan: GR,
  composition: VR,
  stirlingS2: QR,
  // functions - core
  config: Mz,
  import: Fz,
  typed: Tz,
  // functions - complex
  arg: YR,
  conj: ZR,
  re: KR,
  im: WR,
  // functions - expression
  evaluate: JR,
  help: _R,
  // functions - geometry
  distance: $R,
  intersect: eI,
  // functions - logical
  and: rI,
  not: tI,
  or: nI,
  xor: aI,
  // functions - matrix
  concat: oI,
  count: sI,
  cross: uI,
  column: iI,
  ctranspose: cI,
  det: lI,
  diag: fI,
  diff: vI,
  dot: pI,
  getMatrixDataType: xI,
  identity: yI,
  filter: mI,
  flatten: hI,
  forEach: gI,
  inv: AI,
  pinv: bI,
  eigs: dI,
  kron: wI,
  matrixFromFunction: EI,
  matrixFromRows: NI,
  matrixFromColumns: CI,
  map: DI,
  ones: BI,
  partitionSelect: SI,
  range: PI,
  resize: FI,
  reshape: MI,
  rotate: TI,
  rotationMatrix: OI,
  row: zI,
  size: RI,
  sort: II,
  squeeze: HI,
  subset: LI,
  trace: qI,
  transpose: UI,
  zeros: kI,
  fft: XI,
  ifft: jI,
  sylvester: SR,
  schur: PR,
  lyap: MR,
  // functions - numeric
  solveODE: BL,
  // functions - probability
  combinations: GI,
  combinationsWithRep: VI,
  // distribution: distributionDocs,
  factorial: QI,
  gamma: YI,
  kldivergence: WI,
  lgamma: ZI,
  multinomial: KI,
  permutations: JI,
  pickRandom: _I,
  random: $I,
  randomInt: eH,
  // functions - relational
  compare: rH,
  compareNatural: tH,
  compareText: nH,
  deepEqual: aH,
  equal: iH,
  equalText: oH,
  larger: sH,
  largerEq: uH,
  smaller: cH,
  smallerEq: lH,
  unequal: fH,
  // functions - set
  setCartesian: vH,
  setDifference: pH,
  setDistinct: dH,
  setIntersect: mH,
  setIsSubset: hH,
  setMultiplicity: gH,
  setPowerset: xH,
  setSize: yH,
  setSymDifference: AH,
  setUnion: bH,
  // functions - signal
  zpk2tf: wH,
  freqz: DH,
  // functions - special
  erf: CH,
  zeta: EH,
  // functions - statistics
  cumsum: RH,
  mad: NH,
  max: BH,
  mean: SH,
  median: PH,
  min: MH,
  mode: FH,
  prod: TH,
  quantileSeq: OH,
  std: zH,
  sum: IH,
  variance: HH,
  corr: LH,
  // functions - trigonometry
  acos: qH,
  acosh: UH,
  acot: kH,
  acoth: XH,
  acsc: jH,
  acsch: GH,
  asec: VH,
  asech: QH,
  asin: YH,
  asinh: ZH,
  atan: WH,
  atanh: JH,
  atan2: KH,
  cos: _H,
  cosh: $H,
  cot: eL,
  coth: rL,
  csc: tL,
  csch: nL,
  sec: aL,
  sech: iL,
  sin: oL,
  sinh: sL,
  tan: uL,
  tanh: cL,
  // functions - units
  to: lL,
  // functions - utils
  clone: vL,
  format: pL,
  bin: fL,
  oct: CL,
  hex: mL,
  isNaN: gL,
  isInteger: hL,
  isNegative: xL,
  isNumeric: yL,
  hasNumericValue: dL,
  isPositive: AL,
  isPrime: bL,
  isZero: wL,
  print: EL,
  typeOf: NL,
  numeric: DL
}, jb = "help", SL = ["typed", "mathWithTransform", "Help"], u0 = /* @__PURE__ */ U(jb, SL, (r) => {
  var {
    typed: e,
    mathWithTransform: t,
    Help: n
  } = r;
  return e(jb, {
    any: function(i) {
      var u, f = i;
      if (typeof i != "string") {
        for (u in t)
          if (Pe(t, u) && i === t[u]) {
            f = u;
            break;
          }
      }
      var c = At(v4, f);
      if (!c) {
        var o = typeof f == "function" ? f.name : f;
        throw new Error('No documentation found on "' + o + '"');
      }
      return new n(c);
    }
  });
}), Gb = "chain", PL = ["typed", "Chain"], c0 = /* @__PURE__ */ U(Gb, PL, (r) => {
  var {
    typed: e,
    Chain: t
  } = r;
  return e(Gb, {
    "": function() {
      return new t();
    },
    any: function(a) {
      return new t(a);
    }
  });
}), Vb = "det", ML = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], l0 = /* @__PURE__ */ U(Vb, ML, (r) => {
  var {
    typed: e,
    matrix: t,
    subtractScalar: n,
    multiply: a,
    divideScalar: i,
    isZero: u,
    unaryMinus: f
  } = r;
  return e(Vb, {
    any: function(s) {
      return Ie(s);
    },
    "Array | Matrix": function(s) {
      var l;
      switch (Oe(s) ? l = s.size() : Array.isArray(s) ? (s = t(s), l = s.size()) : l = [], l.length) {
        case 0:
          return Ie(s);
        case 1:
          if (l[0] === 1)
            return Ie(s.valueOf()[0]);
          if (l[0] === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + Ke(l) + ")");
        case 2: {
          var v = l[0], p = l[1];
          if (v === p)
            return c(s.clone().valueOf(), v);
          if (p === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + Ke(l) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ke(l) + ")");
      }
    }
  });
  function c(o, s, l) {
    if (s === 1)
      return Ie(o[0][0]);
    if (s === 2)
      return n(a(o[0][0], o[1][1]), a(o[1][0], o[0][1]));
    for (var v = !1, p = new Array(s).fill(0).map((E, N) => N), h = 0; h < s; h++) {
      var d = p[h];
      if (u(o[d][h])) {
        var x = void 0;
        for (x = h + 1; x < s; x++)
          if (!u(o[p[x]][h])) {
            d = p[x], p[x] = p[h], p[h] = d, v = !v;
            break;
          }
        if (x === s)
          return o[d][h];
      }
      for (var g = o[d][h], y = h === 0 ? 1 : o[p[h - 1]][h - 1], m = h + 1; m < s; m++)
        for (var b = p[m], w = h + 1; w < s; w++)
          o[b][w] = i(n(a(o[b][w], g), a(o[b][h], o[d][w])), y);
    }
    var A = o[p[s - 1]][s - 1];
    return v ? f(A) : A;
  }
}), Qb = "inv", FL = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], f0 = /* @__PURE__ */ U(Qb, FL, (r) => {
  var {
    typed: e,
    matrix: t,
    divideScalar: n,
    addScalar: a,
    multiply: i,
    unaryMinus: u,
    det: f,
    identity: c,
    abs: o
  } = r;
  return e(Qb, {
    "Array | Matrix": function(v) {
      var p = Oe(v) ? v.size() : Ve(v);
      switch (p.length) {
        case 1:
          if (p[0] === 1)
            return Oe(v) ? t([n(1, v.valueOf()[0])]) : [n(1, v[0])];
          throw new RangeError("Matrix must be square (size: " + Ke(p) + ")");
        case 2: {
          var h = p[0], d = p[1];
          if (h === d)
            return Oe(v) ? t(s(v.valueOf(), h, d), v.storage()) : s(v, h, d);
          throw new RangeError("Matrix must be square (size: " + Ke(p) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ke(p) + ")");
      }
    },
    any: function(v) {
      return n(1, v);
    }
  });
  function s(l, v, p) {
    var h, d, x, g, y;
    if (v === 1) {
      if (g = l[0][0], g === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, g)]];
    } else if (v === 2) {
      var m = f(l);
      if (m === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(l[1][1], m), n(u(l[0][1]), m)], [n(u(l[1][0]), m), n(l[0][0], m)]];
    } else {
      var b = l.concat();
      for (h = 0; h < v; h++)
        b[h] = b[h].concat();
      for (var w = c(v).valueOf(), A = 0; A < p; A++) {
        var E = o(b[A][A]), N = A;
        for (h = A + 1; h < v; )
          o(b[h][A]) > E && (E = o(b[h][A]), N = h), h++;
        if (E === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        h = N, h !== A && (y = b[A], b[A] = b[h], b[h] = y, y = w[A], w[A] = w[h], w[h] = y);
        var C = b[A], D = w[A];
        for (h = 0; h < v; h++) {
          var B = b[h], S = w[h];
          if (h !== A) {
            if (B[A] !== 0) {
              for (x = n(u(B[A]), C[A]), d = A; d < p; d++)
                B[d] = a(B[d], i(x, C[d]));
              for (d = 0; d < p; d++)
                S[d] = a(S[d], i(x, D[d]));
            }
          } else {
            for (x = C[A], d = A; d < p; d++)
              B[d] = n(B[d], x);
            for (d = 0; d < p; d++)
              S[d] = n(S[d], x);
          }
        }
      }
      return w;
    }
  }
}), Yb = "pinv", TL = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], v0 = /* @__PURE__ */ U(Yb, TL, (r) => {
  var {
    typed: e,
    matrix: t,
    inv: n,
    deepEqual: a,
    equal: i,
    dotDivide: u,
    dot: f,
    ctranspose: c,
    divideScalar: o,
    multiply: s,
    add: l,
    Complex: v
  } = r;
  return e(Yb, {
    "Array | Matrix": function(m) {
      var b = Oe(m) ? m.size() : Ve(m);
      switch (b.length) {
        case 1:
          return g(m) ? c(m) : b[0] === 1 ? n(m) : u(c(m), f(m, m));
        case 2: {
          if (g(m))
            return c(m);
          var w = b[0], A = b[1];
          if (w === A)
            try {
              return n(m);
            } catch (E) {
              if (!(E instanceof Error && E.message.match(/Cannot calculate inverse, determinant is zero/)))
                throw E;
            }
          return Oe(m) ? t(p(m.valueOf(), w, A), m.storage()) : p(m, w, A);
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ke(b) + ")");
      }
    },
    any: function(m) {
      return i(m, 0) ? Ie(m) : o(1, m);
    }
  });
  function p(y, m, b) {
    var {
      C: w,
      F: A
    } = d(y, m, b), E = s(n(s(c(w), w)), c(w)), N = s(c(A), n(s(A, c(A))));
    return s(N, E);
  }
  function h(y, m, b) {
    for (var w = Ie(y), A = 0, E = 0; E < m; E++) {
      if (b <= A)
        return w;
      for (var N = E; x(w[N][A]); )
        if (N++, m === N && (N = E, A++, b === A))
          return w;
      [w[N], w[E]] = [w[E], w[N]];
      for (var C = w[E][A], D = 0; D < b; D++)
        w[E][D] = u(w[E][D], C);
      for (var B = 0; B < m; B++)
        if (B !== E) {
          C = w[B][A];
          for (var S = 0; S < b; S++)
            w[B][S] = l(w[B][S], s(-1, s(C, w[E][S])));
        }
      A++;
    }
    return w;
  }
  function d(y, m, b) {
    var w = h(y, m, b), A = y.map((N, C) => N.filter((D, B) => B < m && !x(f(w[B], w[B])))), E = w.filter((N, C) => !x(f(w[C], w[C])));
    return {
      C: A,
      F: E
    };
  }
  function x(y) {
    return i(l(y, v(1, 1)), l(0, v(1, 1)));
  }
  function g(y) {
    return a(l(y, v(1, 1)), l(s(y, 0), v(1, 1)));
  }
});
function OL(r) {
  var {
    addScalar: e,
    subtract: t,
    flatten: n,
    multiply: a,
    multiplyScalar: i,
    divideScalar: u,
    sqrt: f,
    abs: c,
    bignumber: o,
    diag: s,
    size: l,
    reshape: v,
    inv: p,
    qr: h,
    usolve: d,
    usolveAll: x,
    equal: g,
    complex: y,
    larger: m,
    smaller: b,
    matrixFromColumns: w,
    dot: A
  } = r;
  function E(L, R, X, ae) {
    var _ = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, re = N(L, R, X, ae, _);
    C(L, R, X, ae, _, re);
    var {
      values: te,
      C: ne
    } = D(L, R, X, ae, _);
    if (_) {
      var oe = B(L, R, ne, re, te, X, ae);
      return {
        values: te,
        eigenvectors: oe
      };
    }
    return {
      values: te
    };
  }
  function N(L, R, X, ae, _) {
    var re = ae === "BigNumber", te = ae === "Complex", ne = re ? o(0) : 0, oe = re ? o(1) : te ? y(1) : 1, le = re ? o(1) : 1, fe = re ? o(10) : 2, ge = i(fe, fe), Be;
    _ && (Be = Array(R).fill(oe));
    for (var j = !1; !j; ) {
      j = !0;
      for (var Y = 0; Y < R; Y++) {
        for (var ie = ne, V = ne, J = 0; J < R; J++)
          Y !== J && (ie = e(ie, c(L[J][Y])), V = e(V, c(L[Y][J])));
        if (!g(ie, 0) && !g(V, 0)) {
          for (var $ = le, pe = ie, ve = u(V, fe), q = i(V, fe); b(pe, ve); )
            pe = i(pe, ge), $ = i($, fe);
          for (; m(pe, q); )
            pe = u(pe, ge), $ = u($, fe);
          var G = b(u(e(pe, V), $), i(e(ie, V), 0.95));
          if (G) {
            j = !1;
            for (var ee = u(1, $), se = 0; se < R; se++)
              Y !== se && (L[Y][se] = i(L[Y][se], ee), L[se][Y] = i(L[se][Y], $));
            _ && (Be[Y] = i(Be[Y], ee));
          }
        }
      }
    }
    return _ ? s(Be) : null;
  }
  function C(L, R, X, ae, _, re) {
    var te = ae === "BigNumber", ne = ae === "Complex", oe = te ? o(0) : ne ? y(0) : 0;
    te && (X = o(X));
    for (var le = 0; le < R - 2; le++) {
      for (var fe = 0, ge = oe, Be = le + 1; Be < R; Be++) {
        var j = L[Be][le];
        b(c(ge), c(j)) && (ge = j, fe = Be);
      }
      if (!b(c(ge), X)) {
        if (fe !== le + 1) {
          var Y = L[fe];
          L[fe] = L[le + 1], L[le + 1] = Y;
          for (var ie = 0; ie < R; ie++) {
            var V = L[ie][fe];
            L[ie][fe] = L[ie][le + 1], L[ie][le + 1] = V;
          }
          if (_) {
            var J = re[fe];
            re[fe] = re[le + 1], re[le + 1] = J;
          }
        }
        for (var $ = le + 2; $ < R; $++) {
          var pe = u(L[$][le], ge);
          if (pe !== 0) {
            for (var ve = 0; ve < R; ve++)
              L[$][ve] = t(L[$][ve], i(pe, L[le + 1][ve]));
            for (var q = 0; q < R; q++)
              L[q][le + 1] = e(L[q][le + 1], i(pe, L[q][$]));
            if (_)
              for (var G = 0; G < R; G++)
                re[$][G] = t(re[$][G], i(pe, re[le + 1][G]));
          }
        }
      }
    }
    return re;
  }
  function D(L, R, X, ae, _) {
    var re = ae === "BigNumber", te = ae === "Complex", ne = re ? o(1) : te ? y(1) : 1;
    re && (X = o(X));
    for (var oe = Ie(L), le = [], fe = R, ge = [], Be = _ ? s(Array(R).fill(ne)) : void 0, j = _ ? s(Array(fe).fill(ne)) : void 0, Y = 0; Y <= 100; ) {
      Y += 1;
      for (var ie = oe[fe - 1][fe - 1], V = 0; V < fe; V++)
        oe[V][V] = t(oe[V][V], ie);
      var {
        Q: J,
        R: $
      } = h(oe);
      oe = a($, J);
      for (var pe = 0; pe < fe; pe++)
        oe[pe][pe] = e(oe[pe][pe], ie);
      if (_ && (j = a(j, J)), fe === 1 || b(c(oe[fe - 1][fe - 2]), X)) {
        Y = 0, le.push(oe[fe - 1][fe - 1]), _ && (ge.unshift([[1]]), I(j, R), Be = a(Be, j), fe > 1 && (j = s(Array(fe - 1).fill(ne)))), fe -= 1, oe.pop();
        for (var ve = 0; ve < fe; ve++)
          oe[ve].pop();
      } else if (fe === 2 || b(c(oe[fe - 2][fe - 3]), X)) {
        Y = 0;
        var q = S(oe[fe - 2][fe - 2], oe[fe - 2][fe - 1], oe[fe - 1][fe - 2], oe[fe - 1][fe - 1]);
        le.push(...q), _ && (ge.unshift(F(oe[fe - 2][fe - 2], oe[fe - 2][fe - 1], oe[fe - 1][fe - 2], oe[fe - 1][fe - 1], q[0], q[1], X, ae)), I(j, R), Be = a(Be, j), fe > 2 && (j = s(Array(fe - 2).fill(ne)))), fe -= 2, oe.pop(), oe.pop();
        for (var G = 0; G < fe; G++)
          oe[G].pop(), oe[G].pop();
      }
      if (fe === 0)
        break;
    }
    if (le.sort((de, me) => +t(c(de), c(me))), Y > 100) {
      var ee = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + le.join(", "));
      throw ee.values = le, ee.vectors = [], ee;
    }
    var se = _ ? a(Be, z(ge, R)) : void 0;
    return {
      values: le,
      C: se
    };
  }
  function B(L, R, X, ae, _, re, te) {
    var ne = p(X), oe = a(ne, L, X), le = te === "BigNumber", fe = te === "Complex", ge = le ? o(0) : fe ? y(0) : 0, Be = le ? o(1) : fe ? y(1) : 1, j = [], Y = [];
    for (var ie of _) {
      var V = P(j, ie, g);
      V === -1 ? (j.push(ie), Y.push(1)) : Y[V] += 1;
    }
    for (var J = [], $ = j.length, pe = Array(R).fill(ge), ve = s(Array(R).fill(Be)), q = function() {
      var se = j[G], de = t(oe, a(se, ve)), me = x(de, pe);
      for (me.shift(); me.length < Y[G]; ) {
        var be = M(de, R, me, re, te);
        if (be === null)
          break;
        me.push(be);
      }
      var xe = a(p(ae), X);
      me = me.map((Ee) => a(xe, Ee)), J.push(...me.map((Ee) => ({
        value: se,
        vector: n(Ee)
      })));
    }, G = 0; G < $; G++)
      q();
    return J;
  }
  function S(L, R, X, ae) {
    var _ = e(L, ae), re = t(i(L, ae), i(R, X)), te = i(_, 0.5), ne = i(f(t(i(_, _), i(4, re))), 0.5);
    return [e(te, ne), t(te, ne)];
  }
  function F(L, R, X, ae, _, re, te, ne) {
    var oe = ne === "BigNumber", le = ne === "Complex", fe = oe ? o(0) : le ? y(0) : 0, ge = oe ? o(1) : le ? y(1) : 1;
    if (b(c(X), te))
      return [[ge, fe], [fe, ge]];
    if (m(c(t(_, re)), te))
      return [[t(_, ae), t(re, ae)], [X, X]];
    var Be = t(L, _), j = t(ae, _);
    return b(c(R), te) && b(c(j), te) ? [[Be, ge], [X, fe]] : [[R, fe], [j, ge]];
  }
  function I(L, R) {
    for (var X = 0; X < L.length; X++)
      L[X].push(...Array(R - L[X].length).fill(0));
    for (var ae = L.length; ae < R; ae++)
      L.push(Array(R).fill(0)), L[ae][ae] = 1;
    return L;
  }
  function z(L, R) {
    for (var X = [], ae = 0; ae < R; ae++)
      X[ae] = Array(R).fill(0);
    var _ = 0;
    for (var re of L) {
      for (var te = re.length, ne = 0; ne < te; ne++)
        for (var oe = 0; oe < te; oe++)
          X[_ + ne][_ + oe] = re[ne][oe];
      _ += te;
    }
    return X;
  }
  function P(L, R, X) {
    for (var ae = 0; ae < L.length; ae++)
      if (X(L[ae], R))
        return ae;
    return -1;
  }
  function M(L, R, X, ae, _) {
    for (var re = _ === "BigNumber" ? o(1e3) : 1e3, te, ne = 0; ne < 5; ++ne) {
      te = H(R, X, _);
      try {
        te = d(L, te);
      } catch {
        continue;
      }
      if (m(Q(te), re))
        break;
    }
    if (ne >= 5)
      return null;
    for (ne = 0; ; ) {
      var oe = d(L, te);
      if (b(Q(O(te, [oe])), ae))
        break;
      if (++ne >= 10)
        return null;
      te = k(oe);
    }
    return te;
  }
  function H(L, R, X) {
    var ae = X === "BigNumber", _ = X === "Complex", re = Array(L).fill(0).map((te) => 2 * Math.random() - 1);
    return ae && (re = re.map((te) => o(te))), _ && (re = re.map((te) => y(te))), re = O(re, R), k(re, X);
  }
  function O(L, R) {
    var X = l(L);
    for (var ae of R)
      ae = v(ae, X), L = t(L, a(u(A(ae, L), A(ae, ae)), ae));
    return L;
  }
  function Q(L) {
    return c(f(A(L, L)));
  }
  function k(L, R) {
    var X = R === "BigNumber", ae = R === "Complex", _ = X ? o(1) : ae ? y(1) : 1;
    return a(u(_, Q(L)), L);
  }
  return E;
}
function zL(r) {
  var {
    config: e,
    addScalar: t,
    subtract: n,
    abs: a,
    atan: i,
    cos: u,
    sin: f,
    multiplyScalar: c,
    inv: o,
    bignumber: s,
    multiply: l,
    add: v
  } = r;
  function p(C, D) {
    var B = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.epsilon, S = arguments.length > 3 ? arguments[3] : void 0, F = arguments.length > 4 ? arguments[4] : void 0;
    if (S === "number")
      return h(C, B, F);
    if (S === "BigNumber")
      return d(C, B, F);
    throw TypeError("Unsupported data type: " + S);
  }
  function h(C, D, B) {
    var S = C.length, F = Math.abs(D / S), I, z;
    if (B) {
      z = new Array(S);
      for (var P = 0; P < S; P++)
        z[P] = Array(S).fill(0), z[P][P] = 1;
    }
    for (var M = A(C); Math.abs(M[1]) >= Math.abs(F); ) {
      var H = M[0][0], O = M[0][1];
      I = x(C[H][H], C[O][O], C[H][O]), C = w(C, I, H, O), B && (z = y(z, I, H, O)), M = A(C);
    }
    for (var Q = Array(S).fill(0), k = 0; k < S; k++)
      Q[k] = C[k][k];
    return N(Ie(Q), z, B);
  }
  function d(C, D, B) {
    var S = C.length, F = a(D / S), I, z;
    if (B) {
      z = new Array(S);
      for (var P = 0; P < S; P++)
        z[P] = Array(S).fill(0), z[P][P] = 1;
    }
    for (var M = E(C); a(M[1]) >= a(F); ) {
      var H = M[0][0], O = M[0][1];
      I = g(C[H][H], C[O][O], C[H][O]), C = b(C, I, H, O), B && (z = m(z, I, H, O)), M = E(C);
    }
    for (var Q = Array(S).fill(0), k = 0; k < S; k++)
      Q[k] = C[k][k];
    return N(Ie(Q), z, B);
  }
  function x(C, D, B) {
    var S = D - C;
    return Math.abs(S) <= e.epsilon ? Math.PI / 4 : 0.5 * Math.atan(2 * B / (D - C));
  }
  function g(C, D, B) {
    var S = n(D, C);
    return a(S) <= e.epsilon ? s(-1).acos().div(4) : c(0.5, i(l(2, B, o(S))));
  }
  function y(C, D, B, S) {
    for (var F = C.length, I = Math.cos(D), z = Math.sin(D), P = Array(F).fill(0), M = Array(F).fill(0), H = 0; H < F; H++)
      P[H] = I * C[H][B] - z * C[H][S], M[H] = z * C[H][B] + I * C[H][S];
    for (var O = 0; O < F; O++)
      C[O][B] = P[O], C[O][S] = M[O];
    return C;
  }
  function m(C, D, B, S) {
    for (var F = C.length, I = u(D), z = f(D), P = Array(F).fill(s(0)), M = Array(F).fill(s(0)), H = 0; H < F; H++)
      P[H] = n(c(I, C[H][B]), c(z, C[H][S])), M[H] = t(c(z, C[H][B]), c(I, C[H][S]));
    for (var O = 0; O < F; O++)
      C[O][B] = P[O], C[O][S] = M[O];
    return C;
  }
  function b(C, D, B, S) {
    for (var F = C.length, I = s(u(D)), z = s(f(D)), P = c(I, I), M = c(z, z), H = Array(F).fill(s(0)), O = Array(F).fill(s(0)), Q = l(s(2), I, z, C[B][S]), k = t(n(c(P, C[B][B]), Q), c(M, C[S][S])), L = v(c(M, C[B][B]), Q, c(P, C[S][S])), R = 0; R < F; R++)
      H[R] = n(c(I, C[B][R]), c(z, C[S][R])), O[R] = t(c(z, C[B][R]), c(I, C[S][R]));
    C[B][B] = k, C[S][S] = L, C[B][S] = s(0), C[S][B] = s(0);
    for (var X = 0; X < F; X++)
      X !== B && X !== S && (C[B][X] = H[X], C[X][B] = H[X], C[S][X] = O[X], C[X][S] = O[X]);
    return C;
  }
  function w(C, D, B, S) {
    for (var F = C.length, I = Math.cos(D), z = Math.sin(D), P = I * I, M = z * z, H = Array(F).fill(0), O = Array(F).fill(0), Q = P * C[B][B] - 2 * I * z * C[B][S] + M * C[S][S], k = M * C[B][B] + 2 * I * z * C[B][S] + P * C[S][S], L = 0; L < F; L++)
      H[L] = I * C[B][L] - z * C[S][L], O[L] = z * C[B][L] + I * C[S][L];
    C[B][B] = Q, C[S][S] = k, C[B][S] = 0, C[S][B] = 0;
    for (var R = 0; R < F; R++)
      R !== B && R !== S && (C[B][R] = H[R], C[R][B] = H[R], C[S][R] = O[R], C[R][S] = O[R]);
    return C;
  }
  function A(C) {
    for (var D = C.length, B = 0, S = [0, 1], F = 0; F < D; F++)
      for (var I = F + 1; I < D; I++)
        Math.abs(B) < Math.abs(C[F][I]) && (B = Math.abs(C[F][I]), S = [F, I]);
    return [S, B];
  }
  function E(C) {
    for (var D = C.length, B = 0, S = [0, 1], F = 0; F < D; F++)
      for (var I = F + 1; I < D; I++)
        a(B) < a(C[F][I]) && (B = a(C[F][I]), S = [F, I]);
    return [S, B];
  }
  function N(C, D, B) {
    var S = C.length, F = Array(S), I;
    if (B) {
      I = Array(S);
      for (var z = 0; z < S; z++)
        I[z] = Array(S);
    }
    for (var P = 0; P < S; P++) {
      for (var M = 0, H = C[0], O = 0; O < C.length; O++)
        a(C[O]) < a(H) && (M = O, H = C[M]);
      if (F[P] = C.splice(M, 1)[0], B)
        for (var Q = 0; Q < S; Q++)
          I[P][Q] = D[Q][M], D[Q].splice(M, 1);
    }
    if (!B)
      return {
        values: F
      };
    var k = I.map((L, R) => ({
      value: F[R],
      vector: L
    }));
    return {
      values: F,
      eigenvectors: k
    };
  }
  return p;
}
var RL = "eigs", IL = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], p0 = /* @__PURE__ */ U(RL, IL, (r) => {
  var {
    config: e,
    typed: t,
    matrix: n,
    addScalar: a,
    subtract: i,
    equal: u,
    abs: f,
    atan: c,
    cos: o,
    sin: s,
    multiplyScalar: l,
    divideScalar: v,
    inv: p,
    bignumber: h,
    multiply: d,
    add: x,
    larger: g,
    column: y,
    flatten: m,
    number: b,
    complex: w,
    sqrt: A,
    diag: E,
    size: N,
    reshape: C,
    qr: D,
    usolve: B,
    usolveAll: S,
    im: F,
    re: I,
    smaller: z,
    matrixFromColumns: P,
    dot: M
  } = r, H = zL({
    config: e,
    addScalar: a,
    subtract: i,
    column: y,
    flatten: m,
    equal: u,
    abs: f,
    atan: c,
    cos: o,
    sin: s,
    multiplyScalar: l,
    inv: p,
    bignumber: h,
    complex: w,
    multiply: d,
    add: x
  }), O = OL({
    config: e,
    addScalar: a,
    subtract: i,
    multiply: d,
    multiplyScalar: l,
    flatten: m,
    divideScalar: v,
    sqrt: A,
    abs: f,
    bignumber: h,
    diag: E,
    size: N,
    reshape: C,
    qr: D,
    inv: p,
    usolve: B,
    usolveAll: S,
    equal: u,
    complex: w,
    larger: g,
    smaller: z,
    matrixFromColumns: P,
    dot: M
  });
  return t("eigs", {
    // The conversion to matrix in the first two implementations,
    // just to convert back to an array right away in
    // computeValuesAndVectors, is unfortunate, and should perhaps be
    // streamlined. It is done because the Matrix object carries some
    // type information about its entries, and so constructing the matrix
    // is a roundabout way of doing type detection.
    Array: function(re) {
      return Q(n(re));
    },
    "Array, number|BigNumber": function(re, te) {
      return Q(n(re), {
        precision: te
      });
    },
    "Array, Object"(_, re) {
      return Q(n(_), re);
    },
    Matrix: function(re) {
      return Q(re, {
        matricize: !0
      });
    },
    "Matrix, number|BigNumber": function(re, te) {
      return Q(re, {
        precision: te,
        matricize: !0
      });
    },
    "Matrix, Object": function(re, te) {
      var ne = {
        matricize: !0
      };
      return Lr(ne, te), Q(re, ne);
    }
  });
  function Q(_) {
    var re, te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = "eigenvectors" in te ? te.eigenvectors : !0, oe = (re = te.precision) !== null && re !== void 0 ? re : e.epsilon, le = k(_, oe, ne);
    return te.matricize && (le.values = n(le.values), ne && (le.eigenvectors = le.eigenvectors.map((fe) => {
      var {
        value: ge,
        vector: Be
      } = fe;
      return {
        value: ge,
        vector: n(Be)
      };
    }))), ne && Object.defineProperty(le, "vectors", {
      enumerable: !1,
      // to make sure that the eigenvectors can still be
      // converted to string.
      get: () => {
        throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
      }
    }), le;
  }
  function k(_, re, te) {
    var ne = _.toArray(), oe = _.size();
    if (oe.length !== 2 || oe[0] !== oe[1])
      throw new RangeError("Matrix must be square (size: ".concat(Ke(oe), ")"));
    var le = oe[0];
    if (R(ne, le, re) && (X(ne, le), L(ne, le, re))) {
      var fe = ae(_, ne, le);
      return H(ne, le, re, fe, te);
    }
    var ge = ae(_, ne, le);
    return O(ne, le, re, ge, te);
  }
  function L(_, re, te) {
    for (var ne = 0; ne < re; ne++)
      for (var oe = ne; oe < re; oe++)
        if (g(h(f(i(_[ne][oe], _[oe][ne]))), te))
          return !1;
    return !0;
  }
  function R(_, re, te) {
    for (var ne = 0; ne < re; ne++)
      for (var oe = 0; oe < re; oe++)
        if (g(h(f(F(_[ne][oe]))), te))
          return !1;
    return !0;
  }
  function X(_, re) {
    for (var te = 0; te < re; te++)
      for (var ne = 0; ne < re; ne++)
        _[te][ne] = I(_[te][ne]);
  }
  function ae(_, re, te) {
    var ne = _.datatype();
    if (ne === "number" || ne === "BigNumber" || ne === "Complex")
      return ne;
    for (var oe = !1, le = !1, fe = !1, ge = 0; ge < te; ge++)
      for (var Be = 0; Be < te; Be++) {
        var j = re[ge][Be];
        if (Xe(j) || na(j))
          oe = !0;
        else if (Ue(j))
          le = !0;
        else if (Wt(j))
          fe = !0;
        else
          throw TypeError("Unsupported type in Matrix: " + br(j));
      }
    if (le && fe && console.warn("Complex BigNumbers not supported, this operation will lose precission."), fe) {
      for (var Y = 0; Y < te; Y++)
        for (var ie = 0; ie < te; ie++)
          re[Y][ie] = w(re[Y][ie]);
      return "Complex";
    }
    if (le) {
      for (var V = 0; V < te; V++)
        for (var J = 0; J < te; J++)
          re[V][J] = h(re[V][J]);
      return "BigNumber";
    }
    if (oe) {
      for (var $ = 0; $ < te; $++)
        for (var pe = 0; pe < te; pe++)
          re[$][pe] = b(re[$][pe]);
      return "number";
    } else
      throw TypeError("Matrix contains unsupported types only.");
  }
}), Zb = "expm", HL = ["typed", "abs", "add", "identity", "inv", "multiply"], d0 = /* @__PURE__ */ U(Zb, HL, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    identity: a,
    inv: i,
    multiply: u
  } = r;
  return e(Zb, {
    Matrix: function(l) {
      var v = l.size();
      if (v.length !== 2 || v[0] !== v[1])
        throw new RangeError("Matrix must be square (size: " + Ke(v) + ")");
      for (var p = v[0], h = 1e-15, d = f(l), x = c(d, h), g = x.q, y = x.j, m = u(l, Math.pow(2, -y)), b = a(p), w = a(p), A = 1, E = m, N = -1, C = 1; C <= g; C++)
        C > 1 && (E = u(E, m), N = -N), A = A * (g - C + 1) / ((2 * g - C + 1) * C), b = n(b, u(A, E)), w = n(w, u(A * N, E));
      for (var D = u(i(w), b), B = 0; B < y; B++)
        D = u(D, D);
      return Tn(l) ? l.createSparseMatrix(D) : D;
    }
  });
  function f(s) {
    for (var l = s.size()[0], v = 0, p = 0; p < l; p++) {
      for (var h = 0, d = 0; d < l; d++)
        h += t(s.get([p, d]));
      v = Math.max(h, v);
    }
    return v;
  }
  function c(s, l) {
    for (var v = 30, p = 0; p < v; p++)
      for (var h = 0; h <= p; h++) {
        var d = p - h;
        if (o(s, h, d) < l)
          return {
            q: h,
            j: d
          };
      }
    throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
  }
  function o(s, l, v) {
    for (var p = 1, h = 2; h <= l; h++)
      p *= h;
    for (var d = p, x = l + 1; x <= 2 * l; x++)
      d *= x;
    var g = d * (2 * l + 1);
    return 8 * Math.pow(s / Math.pow(2, v), 2 * l) * p * p / (d * g);
  }
}), Wb = "sqrtm", LL = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], m0 = /* @__PURE__ */ U(Wb, LL, (r) => {
  var {
    typed: e,
    abs: t,
    add: n,
    multiply: a,
    map: i,
    sqrt: u,
    subtract: f,
    inv: c,
    size: o,
    max: s,
    identity: l
  } = r, v = 1e3, p = 1e-6;
  function h(d) {
    var x, g = 0, y = d, m = l(o(d));
    do {
      var b = y;
      if (y = a(0.5, n(b, c(m))), m = a(0.5, n(m, c(b))), x = s(t(f(y, b))), x > p && ++g > v)
        throw new Error("computing square root of matrix: iterative method could not converge");
    } while (x > p);
    return y;
  }
  return e(Wb, {
    "Array | Matrix": function(x) {
      var g = Oe(x) ? x.size() : Ve(x);
      switch (g.length) {
        case 1:
          if (g[0] === 1)
            return i(x, u);
          throw new RangeError("Matrix must be square (size: " + Ke(g) + ")");
        case 2: {
          var y = g[0], m = g[1];
          if (y === m)
            return h(x);
          throw new RangeError("Matrix must be square (size: " + Ke(g) + ")");
        }
        default:
          throw new RangeError("Matrix must be at most two dimensional (size: " + Ke(g) + ")");
      }
    }
  });
}), Kb = "sylvester", qL = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], h0 = /* @__PURE__ */ U(Kb, qL, (r) => {
  var {
    typed: e,
    schur: t,
    matrixFromColumns: n,
    matrix: a,
    multiply: i,
    range: u,
    concat: f,
    transpose: c,
    index: o,
    subset: s,
    add: l,
    subtract: v,
    identity: p,
    lusolve: h,
    abs: d
  } = r;
  return e(Kb, {
    "Matrix, Matrix, Matrix": x,
    "Array, Matrix, Matrix": function(y, m, b) {
      return x(a(y), m, b);
    },
    "Array, Array, Matrix": function(y, m, b) {
      return x(a(y), a(m), b);
    },
    "Array, Matrix, Array": function(y, m, b) {
      return x(a(y), m, a(b));
    },
    "Matrix, Array, Matrix": function(y, m, b) {
      return x(y, a(m), b);
    },
    "Matrix, Array, Array": function(y, m, b) {
      return x(y, a(m), a(b));
    },
    "Matrix, Matrix, Array": function(y, m, b) {
      return x(y, m, a(b));
    },
    "Array, Array, Array": function(y, m, b) {
      return x(a(y), a(m), a(b)).toArray();
    }
  });
  function x(g, y, m) {
    for (var b = y.size()[0], w = g.size()[0], A = t(g), E = A.T, N = A.U, C = t(i(-1, y)), D = C.T, B = C.U, S = i(i(c(N), m), B), F = u(0, w), I = [], z = (fe, ge) => f(fe, ge, 1), P = (fe, ge) => f(fe, ge, 0), M = 0; M < b; M++)
      if (M < b - 1 && d(s(D, o(M + 1, M))) > 1e-5) {
        for (var H = P(s(S, o(F, M)), s(S, o(F, M + 1))), O = 0; O < M; O++)
          H = l(H, P(i(I[O], s(D, o(O, M))), i(I[O], s(D, o(O, M + 1)))));
        var Q = i(p(w), i(-1, s(D, o(M, M)))), k = i(p(w), i(-1, s(D, o(M + 1, M)))), L = i(p(w), i(-1, s(D, o(M, M + 1)))), R = i(p(w), i(-1, s(D, o(M + 1, M + 1)))), X = P(z(l(E, Q), k), z(L, l(E, R))), ae = h(X, H);
        I[M] = ae.subset(o(u(0, w), 0)), I[M + 1] = ae.subset(o(u(w, 2 * w), 0)), M++;
      } else {
        for (var _ = s(S, o(F, M)), re = 0; re < M; re++)
          _ = l(_, i(I[re], s(D, o(re, M))));
        var te = s(D, o(M, M)), ne = v(E, i(te, p(w)));
        I[M] = h(ne, _);
      }
    var oe = a(n(...I)), le = i(N, i(oe, c(B)));
    return le;
  }
}), Jb = "schur", UL = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], g0 = /* @__PURE__ */ U(Jb, UL, (r) => {
  var {
    typed: e,
    matrix: t,
    identity: n,
    multiply: a,
    qr: i,
    norm: u,
    subtract: f
  } = r;
  return e(Jb, {
    Array: function(s) {
      var l = c(t(s));
      return {
        U: l.U.valueOf(),
        T: l.T.valueOf()
      };
    },
    Matrix: function(s) {
      return c(s);
    }
  });
  function c(o) {
    var s = o.size()[0], l = o, v = n(s), p = 0, h;
    do {
      h = l;
      var d = i(l), x = d.Q, g = d.R;
      if (l = a(g, x), v = a(v, x), p++ > 100)
        break;
    } while (u(f(l, h)) > 1e-4);
    return {
      U: v,
      T: l
    };
  }
}), _b = "lyap", kL = ["typed", "matrix", "sylvester", "multiply", "transpose"], x0 = /* @__PURE__ */ U(_b, kL, (r) => {
  var {
    typed: e,
    matrix: t,
    sylvester: n,
    multiply: a,
    transpose: i
  } = r;
  return e(_b, {
    "Matrix, Matrix": function(f, c) {
      return n(f, i(f), a(-1, c));
    },
    "Array, Matrix": function(f, c) {
      return n(t(f), i(t(f)), a(-1, c));
    },
    "Matrix, Array": function(f, c) {
      return n(f, i(t(f)), t(a(-1, c)));
    },
    "Array, Array": function(f, c) {
      return n(t(f), i(t(f)), t(a(-1, c))).toArray();
    }
  });
}), XL = "divide", jL = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], y0 = /* @__PURE__ */ U(XL, jL, (r) => {
  var {
    typed: e,
    matrix: t,
    multiply: n,
    equalScalar: a,
    divideScalar: i,
    inv: u
  } = r, f = at({
    typed: e,
    equalScalar: a
  }), c = ln({
    typed: e
  });
  return e("divide", C2({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(s, l) {
      return n(s, u(l));
    },
    "DenseMatrix, any": function(s, l) {
      return c(s, l, i, !1);
    },
    "SparseMatrix, any": function(s, l) {
      return f(s, l, i, !1);
    },
    "Array, any": function(s, l) {
      return c(t(s), l, i, !1).valueOf();
    },
    "any, Array | Matrix": function(s, l) {
      return n(s, u(l));
    }
  }, i.signatures));
}), $b = "distance", GL = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], A0 = /* @__PURE__ */ U($b, GL, (r) => {
  var {
    typed: e,
    addScalar: t,
    subtractScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    deepEqual: u,
    sqrt: f,
    abs: c
  } = r;
  return e($b, {
    "Array, Array, Array": function(w, A, E) {
      if (w.length === 2 && A.length === 2 && E.length === 2) {
        if (!s(w))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!s(A))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
        if (!s(E))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
        if (u(A, E))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        var N = n(E[1], A[1]), C = n(A[0], E[0]), D = n(a(E[0], A[1]), a(A[0], E[1]));
        return x(w[0], w[1], N, C, D);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object, Object": function(w, A, E) {
      if (Object.keys(w).length === 2 && Object.keys(A).length === 2 && Object.keys(E).length === 2) {
        if (!s(w))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!s(A))
          throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
        if (!s(E))
          throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
        if (u(h(A), h(E)))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        if ("pointX" in w && "pointY" in w && "lineOnePtX" in A && "lineOnePtY" in A && "lineTwoPtX" in E && "lineTwoPtY" in E) {
          var N = n(E.lineTwoPtY, A.lineOnePtY), C = n(A.lineOnePtX, E.lineTwoPtX), D = n(a(E.lineTwoPtX, A.lineOnePtY), a(A.lineOnePtX, E.lineTwoPtY));
          return x(w.pointX, w.pointY, N, C, D);
        } else
          throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Array, Array": function(w, A) {
      if (w.length === 2 && A.length === 3) {
        if (!s(w))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!l(A))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        return x(w[0], w[1], A[0], A[1], A[2]);
      } else if (w.length === 3 && A.length === 6) {
        if (!l(w))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!p(A))
          throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
        return g(w[0], w[1], w[2], A[0], A[1], A[2], A[3], A[4], A[5]);
      } else if (w.length === A.length && w.length > 0) {
        if (!v(w))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        if (!v(A))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        return y(w, A);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object": function(w, A) {
      if (Object.keys(w).length === 2 && Object.keys(A).length === 3) {
        if (!s(w))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!l(A))
          throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
        if ("pointX" in w && "pointY" in w && "xCoeffLine" in A && "yCoeffLine" in A && "constant" in A)
          return x(w.pointX, w.pointY, A.xCoeffLine, A.yCoeffLine, A.constant);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(w).length === 3 && Object.keys(A).length === 6) {
        if (!l(w))
          throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
        if (!p(A))
          throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
        if ("pointX" in w && "pointY" in w && "x0" in A && "y0" in A && "z0" in A && "a" in A && "b" in A && "c" in A)
          return g(w.pointX, w.pointY, w.pointZ, A.x0, A.y0, A.z0, A.a, A.b, A.c);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(w).length === 2 && Object.keys(A).length === 2) {
        if (!s(w))
          throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
        if (!s(A))
          throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
        if ("pointOneX" in w && "pointOneY" in w && "pointTwoX" in A && "pointTwoY" in A)
          return y([w.pointOneX, w.pointOneY], [A.pointTwoX, A.pointTwoY]);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(w).length === 3 && Object.keys(A).length === 3) {
        if (!l(w))
          throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
        if (!l(A))
          throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
        if ("pointOneX" in w && "pointOneY" in w && "pointOneZ" in w && "pointTwoX" in A && "pointTwoY" in A && "pointTwoZ" in A)
          return y([w.pointOneX, w.pointOneY, w.pointOneZ], [A.pointTwoX, A.pointTwoY, A.pointTwoZ]);
        throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    Array: function(w) {
      if (!d(w))
        throw new TypeError("Incorrect array format entered for pairwise distance calculation");
      return m(w);
    }
  });
  function o(b) {
    return typeof b == "number" || Ue(b);
  }
  function s(b) {
    return b.constructor !== Array && (b = h(b)), o(b[0]) && o(b[1]);
  }
  function l(b) {
    return b.constructor !== Array && (b = h(b)), o(b[0]) && o(b[1]) && o(b[2]);
  }
  function v(b) {
    return Array.isArray(b) || (b = h(b)), b.every(o);
  }
  function p(b) {
    return b.constructor !== Array && (b = h(b)), o(b[0]) && o(b[1]) && o(b[2]) && o(b[3]) && o(b[4]) && o(b[5]);
  }
  function h(b) {
    for (var w = Object.keys(b), A = [], E = 0; E < w.length; E++)
      A.push(b[w[E]]);
    return A;
  }
  function d(b) {
    if (b[0].length === 2 && o(b[0][0]) && o(b[0][1])) {
      if (b.some((w) => w.length !== 2 || !o(w[0]) || !o(w[1])))
        return !1;
    } else if (b[0].length === 3 && o(b[0][0]) && o(b[0][1]) && o(b[0][2])) {
      if (b.some((w) => w.length !== 3 || !o(w[0]) || !o(w[1]) || !o(w[2])))
        return !1;
    } else
      return !1;
    return !0;
  }
  function x(b, w, A, E, N) {
    var C = c(t(t(a(A, b), a(E, w)), N)), D = f(t(a(A, A), a(E, E)));
    return i(C, D);
  }
  function g(b, w, A, E, N, C, D, B, S) {
    var F = [n(a(n(N, w), S), a(n(C, A), B)), n(a(n(C, A), D), a(n(E, b), S)), n(a(n(E, b), B), a(n(N, w), D))];
    F = f(t(t(a(F[0], F[0]), a(F[1], F[1])), a(F[2], F[2])));
    var I = f(t(t(a(D, D), a(B, B)), a(S, S)));
    return i(F, I);
  }
  function y(b, w) {
    for (var A = b.length, E = 0, N = 0, C = 0; C < A; C++)
      N = n(b[C], w[C]), E = t(a(N, N), E);
    return f(E);
  }
  function m(b) {
    for (var w = [], A = [], E = [], N = 0; N < b.length - 1; N++)
      for (var C = N + 1; C < b.length; C++)
        b[0].length === 2 ? (A = [b[N][0], b[N][1]], E = [b[C][0], b[C][1]]) : b[0].length === 3 && (A = [b[N][0], b[N][1], b[N][2]], E = [b[C][0], b[C][1], b[C][2]]), w.push(y(A, E));
    return w;
  }
}), VL = "intersect", QL = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], b0 = /* @__PURE__ */ U(VL, QL, (r) => {
  var {
    typed: e,
    config: t,
    abs: n,
    add: a,
    addScalar: i,
    matrix: u,
    multiply: f,
    multiplyScalar: c,
    divideScalar: o,
    subtract: s,
    smaller: l,
    equalScalar: v,
    flatten: p,
    isZero: h,
    isNumeric: d
  } = r;
  return e("intersect", {
    "Array, Array, Array": x,
    "Array, Array, Array, Array": g,
    "Matrix, Matrix, Matrix": function(B, S, F) {
      var I = x(B.valueOf(), S.valueOf(), F.valueOf());
      return I === null ? null : u(I);
    },
    "Matrix, Matrix, Matrix, Matrix": function(B, S, F, I) {
      var z = g(B.valueOf(), S.valueOf(), F.valueOf(), I.valueOf());
      return z === null ? null : u(z);
    }
  });
  function x(D, B, S) {
    if (D = y(D), B = y(B), S = y(S), !b(D))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!b(B))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!w(S))
      throw new TypeError("Array with 4 numbers expected as third argument");
    return C(D[0], D[1], D[2], B[0], B[1], B[2], S[0], S[1], S[2], S[3]);
  }
  function g(D, B, S, F) {
    if (D = y(D), B = y(B), S = y(S), F = y(F), D.length === 2) {
      if (!m(D))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!m(B))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!m(S))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!m(F))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return A(D, B, S, F);
    } else if (D.length === 3) {
      if (!b(D))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!b(B))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!b(S))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!b(F))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return N(D[0], D[1], D[2], B[0], B[1], B[2], S[0], S[1], S[2], F[0], F[1], F[2]);
    } else
      throw new TypeError("Arrays with two or thee dimensional points expected");
  }
  function y(D) {
    return D.length === 1 ? D[0] : D.length > 1 && Array.isArray(D[0]) && D.every((B) => Array.isArray(B) && B.length === 1) ? p(D) : D;
  }
  function m(D) {
    return D.length === 2 && d(D[0]) && d(D[1]);
  }
  function b(D) {
    return D.length === 3 && d(D[0]) && d(D[1]) && d(D[2]);
  }
  function w(D) {
    return D.length === 4 && d(D[0]) && d(D[1]) && d(D[2]) && d(D[3]);
  }
  function A(D, B, S, F) {
    var I = D, z = S, P = s(I, B), M = s(z, F), H = s(c(P[0], M[1]), c(M[0], P[1]));
    if (h(H) || l(n(H), t.epsilon))
      return null;
    var O = c(M[0], I[1]), Q = c(M[1], I[0]), k = c(M[0], z[1]), L = c(M[1], z[0]), R = o(i(s(s(O, Q), k), L), H);
    return a(f(P, R), I);
  }
  function E(D, B, S, F, I, z, P, M, H, O, Q, k) {
    var L = c(s(D, B), s(S, F)), R = c(s(I, z), s(P, M)), X = c(s(H, O), s(Q, k));
    return i(i(L, R), X);
  }
  function N(D, B, S, F, I, z, P, M, H, O, Q, k) {
    var L = E(D, P, O, P, B, M, Q, M, S, H, k, H), R = E(O, P, F, D, Q, M, I, B, k, H, z, S), X = E(D, P, F, D, B, M, I, B, S, H, z, S), ae = E(O, P, O, P, Q, M, Q, M, k, H, k, H), _ = E(F, D, F, D, I, B, I, B, z, S, z, S), re = s(c(L, R), c(X, ae)), te = s(c(_, ae), c(R, R));
    if (h(te))
      return null;
    var ne = o(re, te), oe = o(i(L, c(ne, R)), ae), le = i(D, c(ne, s(F, D))), fe = i(B, c(ne, s(I, B))), ge = i(S, c(ne, s(z, S))), Be = i(P, c(oe, s(O, P))), j = i(M, c(oe, s(Q, M))), Y = i(H, c(oe, s(k, H)));
    return v(le, Be) && v(fe, j) && v(ge, Y) ? [le, fe, ge] : null;
  }
  function C(D, B, S, F, I, z, P, M, H, O) {
    var Q = c(D, P), k = c(F, P), L = c(B, M), R = c(I, M), X = c(S, H), ae = c(z, H), _ = s(s(s(O, Q), L), X), re = s(s(s(i(i(k, R), ae), Q), L), X), te = o(_, re), ne = i(D, c(te, s(F, D))), oe = i(B, c(te, s(I, B))), le = i(S, c(te, s(z, S)));
    return [ne, oe, le];
  }
}), ew = "sum", YL = ["typed", "config", "add", "numeric"], Bo = /* @__PURE__ */ U(ew, YL, (r) => {
  var {
    typed: e,
    config: t,
    add: n,
    numeric: a
  } = r;
  return e(ew, {
    // sum([a, b, c, d, ...])
    "Array | Matrix": i,
    // sum([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": u,
    // sum(a, b, c, d, ...)
    "...": function(c) {
      if (yi(c))
        throw new TypeError("Scalar values expected in function sum");
      return i(c);
    }
  });
  function i(f) {
    var c;
    return Hn(f, function(o) {
      try {
        c = c === void 0 ? o : n(c, o);
      } catch (s) {
        throw Dt(s, "sum", o);
      }
    }), c === void 0 && (c = a(0, t.number)), typeof c == "string" && (c = a(c, t.number)), c;
  }
  function u(f, c) {
    try {
      var o = Eu(f, c, n);
      return o;
    } catch (s) {
      throw Dt(s, "sum");
    }
  }
}), Cs = "cumsum", ZL = ["typed", "add", "unaryPlus"], So = /* @__PURE__ */ U(Cs, ZL, (r) => {
  var {
    typed: e,
    add: t,
    unaryPlus: n
  } = r;
  return e(Cs, {
    // sum([a, b, c, d, ...])
    Array: a,
    Matrix: function(o) {
      return o.create(a(o.valueOf()));
    },
    // sum([a, b, c, d, ...], dim)
    "Array, number | BigNumber": u,
    "Matrix, number | BigNumber": function(o, s) {
      return o.create(u(o.valueOf(), s));
    },
    // cumsum(a, b, c, d, ...)
    "...": function(o) {
      if (yi(o))
        throw new TypeError("All values expected to be scalar in function cumsum");
      return a(o);
    }
  });
  function a(c) {
    try {
      return i(c);
    } catch (o) {
      throw Dt(o, Cs);
    }
  }
  function i(c) {
    if (c.length === 0)
      return [];
    for (var o = [n(c[0])], s = 1; s < c.length; ++s)
      o.push(t(o[s - 1], c[s]));
    return o;
  }
  function u(c, o) {
    var s = Ve(c);
    if (o < 0 || o >= s.length)
      throw new Ut(o, s.length);
    try {
      return f(c, o);
    } catch (l) {
      throw Dt(l, Cs);
    }
  }
  function f(c, o) {
    var s, l, v;
    if (o <= 0) {
      var p = c[0][0];
      if (Array.isArray(p)) {
        for (v = sD(c), l = [], s = 0; s < v.length; s++)
          l[s] = f(v[s], o - 1);
        return l;
      } else
        return i(c);
    } else {
      for (l = [], s = 0; s < c.length; s++)
        l[s] = f(c[s], o - 1);
      return l;
    }
  }
}), rw = "mean", WL = ["typed", "add", "divide"], Po = /* @__PURE__ */ U(rw, WL, (r) => {
  var {
    typed: e,
    add: t,
    divide: n
  } = r;
  return e(rw, {
    // mean([a, b, c, d, ...])
    "Array | Matrix": i,
    // mean([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": a,
    // mean(a, b, c, d, ...)
    "...": function(f) {
      if (yi(f))
        throw new TypeError("Scalar values expected in function mean");
      return i(f);
    }
  });
  function a(u, f) {
    try {
      var c = Eu(u, f, t), o = Array.isArray(u) ? Ve(u) : u.size();
      return n(c, o[f]);
    } catch (s) {
      throw Dt(s, "mean");
    }
  }
  function i(u) {
    var f, c = 0;
    if (Hn(u, function(o) {
      try {
        f = f === void 0 ? o : t(f, o), c++;
      } catch (s) {
        throw Dt(s, "mean", o);
      }
    }), c === 0)
      throw new Error("Cannot calculate the mean of an empty array");
    return n(f, c);
  }
}), tw = "median", KL = ["typed", "add", "divide", "compare", "partitionSelect"], w0 = /* @__PURE__ */ U(tw, KL, (r) => {
  var {
    typed: e,
    add: t,
    divide: n,
    compare: a,
    partitionSelect: i
  } = r;
  function u(o) {
    try {
      o = cr(o.valueOf());
      var s = o.length;
      if (s === 0)
        throw new Error("Cannot calculate median of an empty array");
      if (s % 2 === 0) {
        for (var l = s / 2 - 1, v = i(o, l + 1), p = o[l], h = 0; h < l; ++h)
          a(o[h], p) > 0 && (p = o[h]);
        return c(p, v);
      } else {
        var d = i(o, (s - 1) / 2);
        return f(d);
      }
    } catch (x) {
      throw Dt(x, "median");
    }
  }
  var f = e({
    "number | BigNumber | Complex | Unit": function(s) {
      return s;
    }
  }), c = e({
    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(s, l) {
      return n(t(s, l), 2);
    }
  });
  return e(tw, {
    // median([a, b, c, d, ...])
    "Array | Matrix": u,
    // median([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(s, l) {
      throw new Error("median(A, dim) is not yet supported");
    },
    // median(a, b, c, d, ...)
    "...": function(s) {
      if (yi(s))
        throw new TypeError("Scalar values expected in function median");
      return u(s);
    }
  });
}), nw = "mad", JL = ["typed", "abs", "map", "median", "subtract"], D0 = /* @__PURE__ */ U(nw, JL, (r) => {
  var {
    typed: e,
    abs: t,
    map: n,
    median: a,
    subtract: i
  } = r;
  return e(nw, {
    // mad([a, b, c, d, ...])
    "Array | Matrix": u,
    // mad(a, b, c, d, ...)
    "...": function(c) {
      return u(c);
    }
  });
  function u(f) {
    if (f = cr(f.valueOf()), f.length === 0)
      throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var c = a(f);
      return a(n(f, function(o) {
        return t(i(o, c));
      }));
    } catch (o) {
      throw o instanceof TypeError && o.message.includes("median") ? new TypeError(o.message.replace("median", "mad")) : Dt(o, "mad");
    }
  }
}), Em = "unbiased", aw = "variance", _L = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], Mo = /* @__PURE__ */ U(aw, _L, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    apply: u,
    isNaN: f
  } = r;
  return e(aw, {
    // variance([a, b, c, d, ...])
    "Array | Matrix": function(l) {
      return c(l, Em);
    },
    // variance([a, b, c, d, ...], normalization)
    "Array | Matrix, string": c,
    // variance([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": function(l, v) {
      return o(l, v, Em);
    },
    // variance([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": o,
    // variance(a, b, c, d, ...)
    "...": function(l) {
      return c(l, Em);
    }
  });
  function c(s, l) {
    var v, p = 0;
    if (s.length === 0)
      throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (Hn(s, function(x) {
      try {
        v = v === void 0 ? x : t(v, x), p++;
      } catch (g) {
        throw Dt(g, "variance", x);
      }
    }), p === 0)
      throw new Error("Cannot calculate variance of an empty array");
    var h = i(v, p);
    if (v = void 0, Hn(s, function(x) {
      var g = n(x, h);
      v = v === void 0 ? a(g, g) : t(v, a(g, g));
    }), f(v))
      return v;
    switch (l) {
      case "uncorrected":
        return i(v, p);
      case "biased":
        return i(v, p + 1);
      case "unbiased": {
        var d = Ue(v) ? v.mul(0) : 0;
        return p === 1 ? d : i(v, p - 1);
      }
      default:
        throw new Error('Unknown normalization "' + l + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function o(s, l, v) {
    try {
      if (s.length === 0)
        throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return u(s, l, (p) => c(p, v));
    } catch (p) {
      throw Dt(p, "variance");
    }
  }
}), iw = "quantileSeq", $L = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger"], Fo = /* @__PURE__ */ U(iw, $L, (r) => {
  var {
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: u,
    partitionSelect: f,
    compare: c,
    isInteger: o,
    smaller: s,
    smallerEq: l,
    larger: v
  } = r, p = Di({
    typed: e,
    isInteger: o
  });
  return e(iw, {
    "Array | Matrix, number | BigNumber": (y, m) => d(y, m, !1),
    "Array | Matrix, number | BigNumber, number": (y, m, b) => h(y, m, !1, b, d),
    "Array | Matrix, number | BigNumber, boolean": d,
    "Array | Matrix, number | BigNumber, boolean, number": (y, m, b, w) => h(y, m, b, w, d),
    "Array | Matrix, Array | Matrix": (y, m) => x(y, m, !1),
    "Array | Matrix, Array | Matrix, number": (y, m, b) => h(y, m, !1, b, x),
    "Array | Matrix, Array | Matrix, boolean": x,
    "Array | Matrix, Array | Matrix, boolean, number": (y, m, b, w) => h(y, m, b, w, x)
  });
  function h(y, m, b, w, A) {
    return p(y, w, (E) => A(E, m, b));
  }
  function d(y, m, b) {
    var w, A = y.valueOf();
    if (s(m, 0))
      throw new Error("N/prob must be non-negative");
    if (l(m, 1))
      return Xe(m) ? g(A, m, b) : t(g(A, m, b));
    if (v(m, 1)) {
      if (!o(m))
        throw new Error("N must be a positive integer");
      if (v(m, 4294967295))
        throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var E = n(m, 1);
      w = [];
      for (var N = 0; s(N, m); N++) {
        var C = i(N + 1, E);
        w.push(g(A, C, b));
      }
      return Xe(m) ? w : t(w);
    }
  }
  function x(y, m, b) {
    for (var w = y.valueOf(), A = m.valueOf(), E = [], N = 0; N < A.length; ++N)
      E.push(g(w, A[N], b));
    return E;
  }
  function g(y, m, b) {
    var w = cr(y), A = w.length;
    if (A === 0)
      throw new Error("Cannot calculate quantile of an empty sequence");
    var E = Xe(m) ? m * (A - 1) : m.times(A - 1), N = Xe(m) ? Math.floor(E) : E.floor().toNumber(), C = Xe(m) ? E % 1 : E.minus(N);
    if (o(E))
      return b ? w[E] : f(w, Xe(m) ? E : E.valueOf());
    var D, B;
    if (b)
      D = w[N], B = w[N + 1];
    else {
      B = f(w, N + 1), D = w[N];
      for (var S = 0; S < N; ++S)
        c(w[S], D) > 0 && (D = w[S]);
    }
    return n(u(D, a(1, C)), u(B, C));
  }
}), ow = "std", eq = ["typed", "map", "sqrt", "variance"], To = /* @__PURE__ */ U(ow, eq, (r) => {
  var {
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  } = r;
  return e(ow, {
    // std([a, b, c, d, ...])
    "Array | Matrix": i,
    // std([a, b, c, d, ...], normalization)
    "Array | Matrix, string": i,
    // std([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": i,
    // std([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": i,
    // std(a, b, c, d, ...)
    "...": function(f) {
      return i(f);
    }
  });
  function i(u, f) {
    if (u.length === 0)
      throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var c = a.apply(null, arguments);
      return Tt(c) ? t(c, n) : n(c);
    } catch (o) {
      throw o instanceof TypeError && o.message.includes(" variance") ? new TypeError(o.message.replace(" variance", " std")) : o;
    }
  }
}), sw = "corr", rq = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], C0 = /* @__PURE__ */ U(sw, rq, (r) => {
  var {
    typed: e,
    matrix: t,
    sqrt: n,
    sum: a,
    add: i,
    subtract: u,
    multiply: f,
    pow: c,
    divide: o
  } = r;
  return e(sw, {
    "Array, Array": function(p, h) {
      return s(p, h);
    },
    "Matrix, Matrix": function(p, h) {
      var d = s(p.toArray(), h.toArray());
      return Array.isArray(d) ? t(d) : d;
    }
  });
  function s(v, p) {
    var h = [];
    if (Array.isArray(v[0]) && Array.isArray(p[0])) {
      if (v.length !== p.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var d = 0; d < v.length; d++) {
        if (v[d].length !== p[d].length)
          throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        h.push(l(v[d], p[d]));
      }
      return h;
    } else {
      if (v.length !== p.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
      return l(v, p);
    }
  }
  function l(v, p) {
    var h = v.length, d = a(v), x = a(p), g = v.reduce((A, E, N) => i(A, f(E, p[N])), 0), y = a(v.map((A) => c(A, 2))), m = a(p.map((A) => c(A, 2))), b = u(f(h, g), f(d, x)), w = n(f(u(f(h, y), c(d, 2)), u(f(h, m), c(x, 2))));
    return o(b, w);
  }
}), uw = "combinations", tq = ["typed"], E0 = /* @__PURE__ */ U(uw, tq, (r) => {
  var {
    typed: e
  } = r;
  return e(uw, {
    "number, number": MD,
    "BigNumber, BigNumber": function(n, a) {
      var i = n.constructor, u, f, c = n.minus(a), o = new i(1);
      if (!cw(n) || !cw(a))
        throw new TypeError("Positive integer value expected in function combinations");
      if (a.gt(n))
        throw new TypeError("k must be less than n in function combinations");
      if (u = o, a.lt(c))
        for (f = o; f.lte(c); f = f.plus(o))
          u = u.times(a.plus(f)).dividedBy(f);
      else
        for (f = o; f.lte(a); f = f.plus(o))
          u = u.times(c.plus(f)).dividedBy(f);
      return u;
    }
    // TODO: implement support for collection in combinations
  });
});
function cw(r) {
  return r.isInteger() && r.gte(0);
}
var lw = "combinationsWithRep", nq = ["typed"], N0 = /* @__PURE__ */ U(lw, nq, (r) => {
  var {
    typed: e
  } = r;
  return e(lw, {
    "number, number": function(n, a) {
      if (!Me(n) || n < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (!Me(a) || a < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n < 1)
        throw new TypeError("k must be less than or equal to n + k - 1");
      if (a < n - 1) {
        var i = zn(n, n + a - 1);
        return i / zn(1, a);
      }
      var u = zn(a + 1, n + a - 1);
      return u / zn(1, n - 1);
    },
    "BigNumber, BigNumber": function(n, a) {
      var i = n.constructor, u, f, c = new i(1), o = n.minus(c);
      if (!fw(n) || !fw(a))
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n.lt(c))
        throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
      if (u = c, a.lt(o))
        for (f = c; f.lte(o); f = f.plus(c))
          u = u.times(a.plus(f)).dividedBy(f);
      else
        for (f = c; f.lte(a); f = f.plus(c))
          u = u.times(o.plus(f)).dividedBy(f);
      return u;
    }
  });
});
function fw(r) {
  return r.isInteger() && r.gte(0);
}
var vw = "gamma", aq = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], B0 = /* @__PURE__ */ U(vw, aq, (r) => {
  var {
    typed: e,
    config: t,
    multiplyScalar: n,
    pow: a,
    BigNumber: i,
    Complex: u
  } = r;
  function f(o) {
    if (o.im === 0)
      return Us(o.re);
    if (o.re < 0.5) {
      var s = new u(1 - o.re, -o.im), l = new u(Math.PI * o.re, Math.PI * o.im);
      return new u(Math.PI).div(l.sin()).div(f(s));
    }
    o = new u(o.re - 1, o.im);
    for (var v = new u(ti[0], 0), p = 1; p < ti.length; ++p) {
      var h = new u(ti[p], 0);
      v = v.add(h.div(o.add(p)));
    }
    var d = new u(o.re + RD + 0.5, o.im), x = Math.sqrt(2 * Math.PI), g = d.pow(o.add(0.5)), y = d.neg().exp();
    return v.mul(x).mul(g).mul(y);
  }
  return e(vw, {
    number: Us,
    Complex: f,
    BigNumber: function(s) {
      if (s.isInteger())
        return s.isNegative() || s.isZero() ? new i(1 / 0) : c(s.minus(1));
      if (!s.isFinite())
        return new i(s.isNegative() ? NaN : 1 / 0);
      throw new Error("Integer BigNumber expected");
    }
  });
  function c(o) {
    if (o < 8)
      return new i([1, 1, 2, 6, 24, 120, 720, 5040][o]);
    var s = t.precision + (Math.log(o.toNumber()) | 0), l = i.clone({
      precision: s
    });
    if (o % 2 === 1)
      return o.times(c(new i(o - 1)));
    for (var v = o, p = new l(o), h = o.toNumber(); v > 2; )
      v -= 2, h += v, p = p.times(h);
    return new i(p.toPrecision(i.precision));
  }
}), pw = "lgamma", iq = ["Complex", "typed"], S0 = /* @__PURE__ */ U(pw, iq, (r) => {
  var {
    Complex: e,
    typed: t
  } = r, n = 7, a = 7, i = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return t(pw, {
    number: ks,
    Complex: u,
    BigNumber: function() {
      throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
    }
  });
  function u(o) {
    var s = 6.283185307179586, l = 1.1447298858494002, v = 0.1;
    if (o.isNaN())
      return new e(NaN, NaN);
    if (o.im === 0)
      return new e(ks(o.re), 0);
    if (o.re >= n || Math.abs(o.im) >= a)
      return f(o);
    if (o.re <= v) {
      var p = i9(s, o.im) * Math.floor(0.5 * o.re + 0.25), h = o.mul(Math.PI).sin().log(), d = u(new e(1 - o.re, -o.im));
      return new e(l, p).sub(h).sub(d);
    } else
      return o.im >= 0 ? c(o) : c(o.conjugate()).conjugate();
  }
  function f(o) {
    for (var s = o.sub(0.5).mul(o.log()).sub(o).add(ID), l = new e(1, 0).div(o), v = l.div(o), p = i[0], h = i[1], d = 2 * v.re, x = v.re * v.re + v.im * v.im, g = 2; g < 8; g++) {
      var y = h;
      h = -x * p + i[g], p = d * p + y;
    }
    var m = l.mul(v.mul(p).add(h));
    return s.add(m);
  }
  function c(o) {
    var s = 0, l = 0, v = o;
    for (o = o.add(1); o.re <= n; ) {
      v = v.mul(o);
      var p = v.im < 0 ? 1 : 0;
      p !== 0 && l === 0 && s++, l = p, o = o.add(1);
    }
    return f(o).sub(v.log()).sub(new e(0, s * 2 * Math.PI * 1));
  }
}), dw = "factorial", oq = ["typed", "gamma"], P0 = /* @__PURE__ */ U(dw, oq, (r) => {
  var {
    typed: e,
    gamma: t
  } = r;
  return e(dw, {
    number: function(a) {
      if (a < 0)
        throw new Error("Value must be non-negative");
      return t(a + 1);
    },
    BigNumber: function(a) {
      if (a.isNegative())
        throw new Error("Value must be non-negative");
      return t(a.plus(1));
    },
    "Array | Matrix": e.referToSelf((n) => (a) => $e(a, n))
  });
}), mw = "kldivergence", sq = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], M0 = /* @__PURE__ */ U(mw, sq, (r) => {
  var {
    typed: e,
    matrix: t,
    divide: n,
    sum: a,
    multiply: i,
    map: u,
    dotDivide: f,
    log: c,
    isNumeric: o
  } = r;
  return e(mw, {
    "Array, Array": function(v, p) {
      return s(t(v), t(p));
    },
    "Matrix, Array": function(v, p) {
      return s(v, t(p));
    },
    "Array, Matrix": function(v, p) {
      return s(t(v), p);
    },
    "Matrix, Matrix": function(v, p) {
      return s(v, p);
    }
  });
  function s(l, v) {
    var p = v.size().length, h = l.size().length;
    if (p > 1)
      throw new Error("first object must be one dimensional");
    if (h > 1)
      throw new Error("second object must be one dimensional");
    if (p !== h)
      throw new Error("Length of two vectors must be equal");
    var d = a(l);
    if (d === 0)
      throw new Error("Sum of elements in first object must be non zero");
    var x = a(v);
    if (x === 0)
      throw new Error("Sum of elements in second object must be non zero");
    var g = n(l, a(l)), y = n(v, a(v)), m = a(i(g, u(f(g, y), (b) => c(b))));
    return o(m) ? m : Number.NaN;
  }
}), hw = "multinomial", uq = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], F0 = /* @__PURE__ */ U(hw, uq, (r) => {
  var {
    typed: e,
    add: t,
    divide: n,
    multiply: a,
    factorial: i,
    isInteger: u,
    isPositive: f
  } = r;
  return e(hw, {
    "Array | Matrix": function(o) {
      var s = 0, l = 1;
      return Hn(o, function(v) {
        if (!u(v) || !f(v))
          throw new TypeError("Positive integer value expected in function multinomial");
        s = t(s, v), l = a(l, i(v));
      }), n(i(s), l);
    }
  });
}), gw = "permutations", cq = ["typed", "factorial"], T0 = /* @__PURE__ */ U(gw, cq, (r) => {
  var {
    typed: e,
    factorial: t
  } = r;
  return e(gw, {
    "number | BigNumber": t,
    "number, number": function(a, i) {
      if (!Me(a) || a < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (!Me(i) || i < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (i > a)
        throw new TypeError("second argument k must be less than or equal to first argument n");
      return zn(a - i + 1, a);
    },
    "BigNumber, BigNumber": function(a, i) {
      var u, f;
      if (!xw(a) || !xw(i))
        throw new TypeError("Positive integer value expected in function permutations");
      if (i.gt(a))
        throw new TypeError("second argument k must be less than or equal to first argument n");
      var c = a.mul(0).add(1);
      for (u = c, f = a.minus(i).plus(1); f.lte(a); f = f.plus(1))
        u = u.times(f);
      return u;
    }
    // TODO: implement support for collection in permutations
  });
});
function xw(r) {
  return r.isInteger() && r.gte(0);
}
var Bh = { exports: {} };
Bh.exports;
(function(r) {
  (function(e, t, n) {
    function a(c) {
      var o = this, s = f();
      o.next = function() {
        var l = 2091639 * o.s0 + o.c * 23283064365386963e-26;
        return o.s0 = o.s1, o.s1 = o.s2, o.s2 = l - (o.c = l | 0);
      }, o.c = 1, o.s0 = s(" "), o.s1 = s(" "), o.s2 = s(" "), o.s0 -= s(c), o.s0 < 0 && (o.s0 += 1), o.s1 -= s(c), o.s1 < 0 && (o.s1 += 1), o.s2 -= s(c), o.s2 < 0 && (o.s2 += 1), s = null;
    }
    function i(c, o) {
      return o.c = c.c, o.s0 = c.s0, o.s1 = c.s1, o.s2 = c.s2, o;
    }
    function u(c, o) {
      var s = new a(c), l = o && o.state, v = s.next;
      return v.int32 = function() {
        return s.next() * 4294967296 | 0;
      }, v.double = function() {
        return v() + (v() * 2097152 | 0) * 11102230246251565e-32;
      }, v.quick = v, l && (typeof l == "object" && i(l, s), v.state = function() {
        return i(s, {});
      }), v;
    }
    function f() {
      var c = 4022871197, o = function(s) {
        s = String(s);
        for (var l = 0; l < s.length; l++) {
          c += s.charCodeAt(l);
          var v = 0.02519603282416938 * c;
          c = v >>> 0, v -= c, v *= c, c = v >>> 0, v -= c, c += v * 4294967296;
        }
        return (c >>> 0) * 23283064365386963e-26;
      };
      return o;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.alea = u;
  })(
    qe,
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Bh);
var lq = Bh.exports, Sh = { exports: {} };
Sh.exports;
(function(r) {
  (function(e, t, n) {
    function a(f) {
      var c = this, o = "";
      c.x = 0, c.y = 0, c.z = 0, c.w = 0, c.next = function() {
        var l = c.x ^ c.x << 11;
        return c.x = c.y, c.y = c.z, c.z = c.w, c.w ^= c.w >>> 19 ^ l ^ l >>> 8;
      }, f === (f | 0) ? c.x = f : o += f;
      for (var s = 0; s < o.length + 64; s++)
        c.x ^= o.charCodeAt(s) | 0, c.next();
    }
    function i(f, c) {
      return c.x = f.x, c.y = f.y, c.z = f.z, c.w = f.w, c;
    }
    function u(f, c) {
      var o = new a(f), s = c && c.state, l = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return l.double = function() {
        do
          var v = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, h = (v + p) / (1 << 21);
        while (h === 0);
        return h;
      }, l.int32 = o.next, l.quick = l, s && (typeof s == "object" && i(s, o), l.state = function() {
        return i(o, {});
      }), l;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xor128 = u;
  })(
    qe,
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Sh);
var fq = Sh.exports, Ph = { exports: {} };
Ph.exports;
(function(r) {
  (function(e, t, n) {
    function a(f) {
      var c = this, o = "";
      c.next = function() {
        var l = c.x ^ c.x >>> 2;
        return c.x = c.y, c.y = c.z, c.z = c.w, c.w = c.v, (c.d = c.d + 362437 | 0) + (c.v = c.v ^ c.v << 4 ^ (l ^ l << 1)) | 0;
      }, c.x = 0, c.y = 0, c.z = 0, c.w = 0, c.v = 0, f === (f | 0) ? c.x = f : o += f;
      for (var s = 0; s < o.length + 64; s++)
        c.x ^= o.charCodeAt(s) | 0, s == o.length && (c.d = c.x << 10 ^ c.x >>> 4), c.next();
    }
    function i(f, c) {
      return c.x = f.x, c.y = f.y, c.z = f.z, c.w = f.w, c.v = f.v, c.d = f.d, c;
    }
    function u(f, c) {
      var o = new a(f), s = c && c.state, l = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return l.double = function() {
        do
          var v = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, h = (v + p) / (1 << 21);
        while (h === 0);
        return h;
      }, l.int32 = o.next, l.quick = l, s && (typeof s == "object" && i(s, o), l.state = function() {
        return i(o, {});
      }), l;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xorwow = u;
  })(
    qe,
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Ph);
var vq = Ph.exports, Mh = { exports: {} };
Mh.exports;
(function(r) {
  (function(e, t, n) {
    function a(f) {
      var c = this;
      c.next = function() {
        var s = c.x, l = c.i, v, p;
        return v = s[l], v ^= v >>> 7, p = v ^ v << 24, v = s[l + 1 & 7], p ^= v ^ v >>> 10, v = s[l + 3 & 7], p ^= v ^ v >>> 3, v = s[l + 4 & 7], p ^= v ^ v << 7, v = s[l + 7 & 7], v = v ^ v << 13, p ^= v ^ v << 9, s[l] = p, c.i = l + 1 & 7, p;
      };
      function o(s, l) {
        var v, p = [];
        if (l === (l | 0))
          p[0] = l;
        else
          for (l = "" + l, v = 0; v < l.length; ++v)
            p[v & 7] = p[v & 7] << 15 ^ l.charCodeAt(v) + p[v + 1 & 7] << 13;
        for (; p.length < 8; )
          p.push(0);
        for (v = 0; v < 8 && p[v] === 0; ++v)
          ;
        for (v == 8 ? p[7] = -1 : p[v], s.x = p, s.i = 0, v = 256; v > 0; --v)
          s.next();
      }
      o(c, f);
    }
    function i(f, c) {
      return c.x = f.x.slice(), c.i = f.i, c;
    }
    function u(f, c) {
      f == null && (f = +/* @__PURE__ */ new Date());
      var o = new a(f), s = c && c.state, l = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return l.double = function() {
        do
          var v = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, h = (v + p) / (1 << 21);
        while (h === 0);
        return h;
      }, l.int32 = o.next, l.quick = l, s && (s.x && i(s, o), l.state = function() {
        return i(o, {});
      }), l;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xorshift7 = u;
  })(
    qe,
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Mh);
var pq = Mh.exports, Fh = { exports: {} };
Fh.exports;
(function(r) {
  (function(e, t, n) {
    function a(f) {
      var c = this;
      c.next = function() {
        var s = c.w, l = c.X, v = c.i, p, h;
        return c.w = s = s + 1640531527 | 0, h = l[v + 34 & 127], p = l[v = v + 1 & 127], h ^= h << 13, p ^= p << 17, h ^= h >>> 15, p ^= p >>> 12, h = l[v] = h ^ p, c.i = v, h + (s ^ s >>> 16) | 0;
      };
      function o(s, l) {
        var v, p, h, d, x, g = [], y = 128;
        for (l === (l | 0) ? (p = l, l = null) : (l = l + "\0", p = 0, y = Math.max(y, l.length)), h = 0, d = -32; d < y; ++d)
          l && (p ^= l.charCodeAt((d + 32) % l.length)), d === 0 && (x = p), p ^= p << 10, p ^= p >>> 15, p ^= p << 4, p ^= p >>> 13, d >= 0 && (x = x + 1640531527 | 0, v = g[d & 127] ^= p + x, h = v == 0 ? h + 1 : 0);
        for (h >= 128 && (g[(l && l.length || 0) & 127] = -1), h = 127, d = 4 * 128; d > 0; --d)
          p = g[h + 34 & 127], v = g[h = h + 1 & 127], p ^= p << 13, v ^= v << 17, p ^= p >>> 15, v ^= v >>> 12, g[h] = p ^ v;
        s.w = x, s.X = g, s.i = h;
      }
      o(c, f);
    }
    function i(f, c) {
      return c.i = f.i, c.w = f.w, c.X = f.X.slice(), c;
    }
    function u(f, c) {
      f == null && (f = +/* @__PURE__ */ new Date());
      var o = new a(f), s = c && c.state, l = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return l.double = function() {
        do
          var v = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, h = (v + p) / (1 << 21);
        while (h === 0);
        return h;
      }, l.int32 = o.next, l.quick = l, s && (s.X && i(s, o), l.state = function() {
        return i(o, {});
      }), l;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xor4096 = u;
  })(
    qe,
    // window object or global
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Fh);
var dq = Fh.exports, Th = { exports: {} };
Th.exports;
(function(r) {
  (function(e, t, n) {
    function a(f) {
      var c = this, o = "";
      c.next = function() {
        var l = c.b, v = c.c, p = c.d, h = c.a;
        return l = l << 25 ^ l >>> 7 ^ v, v = v - p | 0, p = p << 24 ^ p >>> 8 ^ h, h = h - l | 0, c.b = l = l << 20 ^ l >>> 12 ^ v, c.c = v = v - p | 0, c.d = p << 16 ^ v >>> 16 ^ h, c.a = h - l | 0;
      }, c.a = 0, c.b = 0, c.c = -1640531527, c.d = 1367130551, f === Math.floor(f) ? (c.a = f / 4294967296 | 0, c.b = f | 0) : o += f;
      for (var s = 0; s < o.length + 20; s++)
        c.b ^= o.charCodeAt(s) | 0, c.next();
    }
    function i(f, c) {
      return c.a = f.a, c.b = f.b, c.c = f.c, c.d = f.d, c;
    }
    function u(f, c) {
      var o = new a(f), s = c && c.state, l = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return l.double = function() {
        do
          var v = o.next() >>> 11, p = (o.next() >>> 0) / 4294967296, h = (v + p) / (1 << 21);
        while (h === 0);
        return h;
      }, l.int32 = o.next, l.quick = l, s && (typeof s == "object" && i(s, o), l.state = function() {
        return i(o, {});
      }), l;
    }
    t && t.exports ? t.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.tychei = u;
  })(
    qe,
    r,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Th);
var mq = Th.exports, p4 = { exports: {} };
(function(r) {
  (function(e, t, n) {
    var a = 256, i = 6, u = 52, f = "random", c = n.pow(a, i), o = n.pow(2, u), s = o * 2, l = a - 1, v;
    function p(b, w, A) {
      var E = [];
      w = w == !0 ? { entropy: !0 } : w || {};
      var N = g(x(
        w.entropy ? [b, m(t)] : b ?? y(),
        3
      ), E), C = new h(E), D = function() {
        for (var B = C.g(i), S = c, F = 0; B < o; )
          B = (B + F) * a, S *= a, F = C.g(1);
        for (; B >= s; )
          B /= 2, S /= 2, F >>>= 1;
        return (B + F) / S;
      };
      return D.int32 = function() {
        return C.g(4) | 0;
      }, D.quick = function() {
        return C.g(4) / 4294967296;
      }, D.double = D, g(m(C.S), t), (w.pass || A || function(B, S, F, I) {
        return I && (I.S && d(I, C), B.state = function() {
          return d(C, {});
        }), F ? (n[f] = B, S) : B;
      })(
        D,
        N,
        "global" in w ? w.global : this == n,
        w.state
      );
    }
    function h(b) {
      var w, A = b.length, E = this, N = 0, C = E.i = E.j = 0, D = E.S = [];
      for (A || (b = [A++]); N < a; )
        D[N] = N++;
      for (N = 0; N < a; N++)
        D[N] = D[C = l & C + b[N % A] + (w = D[N])], D[C] = w;
      (E.g = function(B) {
        for (var S, F = 0, I = E.i, z = E.j, P = E.S; B--; )
          S = P[I = l & I + 1], F = F * a + P[l & (P[I] = P[z = l & z + S]) + (P[z] = S)];
        return E.i = I, E.j = z, F;
      })(a);
    }
    function d(b, w) {
      return w.i = b.i, w.j = b.j, w.S = b.S.slice(), w;
    }
    function x(b, w) {
      var A = [], E = typeof b, N;
      if (w && E == "object")
        for (N in b)
          try {
            A.push(x(b[N], w - 1));
          } catch {
          }
      return A.length ? A : E == "string" ? b : b + "\0";
    }
    function g(b, w) {
      for (var A = b + "", E, N = 0; N < A.length; )
        w[l & N] = l & (E ^= w[l & N] * 19) + A.charCodeAt(N++);
      return m(w);
    }
    function y() {
      try {
        var b;
        return v && (b = v.randomBytes) ? b = b(a) : (b = new Uint8Array(a), (e.crypto || e.msCrypto).getRandomValues(b)), m(b);
      } catch {
        var w = e.navigator, A = w && w.plugins;
        return [+/* @__PURE__ */ new Date(), e, A, e.screen, m(t)];
      }
    }
    function m(b) {
      return String.fromCharCode.apply(0, b);
    }
    if (g(n.random(), t), r.exports) {
      r.exports = p;
      try {
        v = Qw;
      } catch {
      }
    } else
      n["seed" + f] = p;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : qe,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(p4);
var hq = p4.exports, gq = lq, xq = fq, yq = vq, Aq = pq, bq = dq, wq = mq, Fa = hq;
Fa.alea = gq;
Fa.xor128 = xq;
Fa.xorwow = yq;
Fa.xorshift7 = Aq;
Fa.xor4096 = bq;
Fa.tychei = wq;
var Dq = Fa;
const d4 = /* @__PURE__ */ Ln(Dq);
var Cq = /* @__PURE__ */ d4(Date.now());
function vi(r) {
  var e;
  function t(a) {
    e = a === null ? Cq : d4(String(a));
  }
  t(r);
  function n() {
    return e();
  }
  return n;
}
var yw = "pickRandom", Eq = ["typed", "config", "?on"], O0 = /* @__PURE__ */ U(yw, Eq, (r) => {
  var {
    typed: e,
    config: t,
    on: n
  } = r, a = vi(t.randomSeed);
  return n && n("config", function(u, f) {
    u.randomSeed !== f.randomSeed && (a = vi(u.randomSeed));
  }), e(yw, {
    "Array | Matrix": function(f) {
      return i(f, {});
    },
    "Array | Matrix, Object": function(f, c) {
      return i(f, c);
    },
    "Array | Matrix, number": function(f, c) {
      return i(f, {
        number: c
      });
    },
    "Array | Matrix, Array | Matrix": function(f, c) {
      return i(f, {
        weights: c
      });
    },
    "Array | Matrix, Array | Matrix, number": function(f, c, o) {
      return i(f, {
        number: o,
        weights: c
      });
    },
    "Array | Matrix, number, Array | Matrix": function(f, c, o) {
      return i(f, {
        number: c,
        weights: o
      });
    }
  });
  function i(u, f) {
    var {
      number: c,
      weights: o,
      elementWise: s = !0
    } = f, l = typeof c > "u";
    l && (c = 1);
    var v = Oe(u) ? u.create : Oe(o) ? o.create : null;
    u = u.valueOf(), o && (o = o.valueOf()), s === !0 && (u = cr(u), o = cr(o));
    var p = 0;
    if (typeof o < "u") {
      if (o.length !== u.length)
        throw new Error("Weights must have the same length as possibles");
      for (var h = 0, d = o.length; h < d; h++) {
        if (!Xe(o[h]) || o[h] < 0)
          throw new Error("Weights must be an array of positive numbers");
        p += o[h];
      }
    }
    for (var x = u.length, g = [], y; g.length < c; ) {
      if (typeof o > "u")
        y = u[Math.floor(a() * x)];
      else
        for (var m = a() * p, b = 0, w = u.length; b < w; b++)
          if (m -= o[b], m < 0) {
            y = u[b];
            break;
          }
      g.push(y);
    }
    return l ? g[0] : v ? v(g) : g;
  }
});
function Oh(r, e) {
  var t = [];
  if (r = r.slice(0), r.length > 1)
    for (var n = 0, a = r.shift(); n < a; n++)
      t.push(Oh(r, e));
  else
    for (var i = 0, u = r.shift(); i < u; i++)
      t.push(e());
  return t;
}
var Aw = "random", Nq = ["typed", "config", "?on"], z0 = /* @__PURE__ */ U(Aw, Nq, (r) => {
  var {
    typed: e,
    config: t,
    on: n
  } = r, a = vi(t.randomSeed);
  return n && n("config", function(f, c) {
    f.randomSeed !== c.randomSeed && (a = vi(f.randomSeed));
  }), e(Aw, {
    "": () => u(0, 1),
    number: (f) => u(0, f),
    "number, number": (f, c) => u(f, c),
    "Array | Matrix": (f) => i(f, 0, 1),
    "Array | Matrix, number": (f, c) => i(f, 0, c),
    "Array | Matrix, number, number": (f, c, o) => i(f, c, o)
  });
  function i(f, c, o) {
    var s = Oh(f.valueOf(), () => u(c, o));
    return Oe(f) ? f.create(s) : s;
  }
  function u(f, c) {
    return f + a() * (c - f);
  }
}), bw = "randomInt", Bq = ["typed", "config", "?on"], R0 = /* @__PURE__ */ U(bw, Bq, (r) => {
  var {
    typed: e,
    config: t,
    on: n
  } = r, a = vi(t.randomSeed);
  return n && n("config", function(f, c) {
    f.randomSeed !== c.randomSeed && (a = vi(f.randomSeed));
  }), e(bw, {
    "": () => u(0, 1),
    number: (f) => u(0, f),
    "number, number": (f, c) => u(f, c),
    "Array | Matrix": (f) => i(f, 0, 1),
    "Array | Matrix, number": (f, c) => i(f, 0, c),
    "Array | Matrix, number, number": (f, c, o) => i(f, c, o)
  });
  function i(f, c, o) {
    var s = Oh(f.valueOf(), () => u(c, o));
    return Oe(f) ? f.create(s) : s;
  }
  function u(f, c) {
    return Math.floor(f + a() * (c - f));
  }
}), ww = "stirlingS2", Sq = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], I0 = /* @__PURE__ */ U(ww, Sq, (r) => {
  var {
    typed: e,
    addScalar: t,
    subtractScalar: n,
    multiplyScalar: a,
    divideScalar: i,
    pow: u,
    factorial: f,
    combinations: c,
    isNegative: o,
    isInteger: s,
    number: l,
    bignumber: v,
    larger: p
  } = r, h = [], d = [];
  return e(ww, {
    "number | BigNumber, number | BigNumber": function(g, y) {
      if (!s(g) || o(g) || !s(y) || o(y))
        throw new TypeError("Non-negative integer value expected in function stirlingS2");
      if (p(y, g))
        throw new TypeError("k must be less than or equal to n in function stirlingS2");
      var m = !(Xe(g) && Xe(y)), b = m ? d : h, w = m ? v : l, A = l(g), E = l(y);
      if (b[A] && b[A].length > E)
        return b[A][E];
      for (var N = 0; N <= A; ++N)
        if (b[N] || (b[N] = [w(N === 0 ? 1 : 0)]), N !== 0)
          for (var C = b[N], D = b[N - 1], B = C.length; B <= N && B <= E; ++B)
            B === N ? C[B] = 1 : C[B] = t(a(w(B), D[B]), D[B - 1]);
      return b[A][E];
    }
  });
}), Dw = "bellNumbers", Pq = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], H0 = /* @__PURE__ */ U(Dw, Pq, (r) => {
  var {
    typed: e,
    addScalar: t,
    isNegative: n,
    isInteger: a,
    stirlingS2: i
  } = r;
  return e(Dw, {
    "number | BigNumber": function(f) {
      if (!a(f) || n(f))
        throw new TypeError("Non-negative integer value expected in function bellNumbers");
      for (var c = 0, o = 0; o <= f; o++)
        c = t(c, i(f, o));
      return c;
    }
  });
}), Cw = "catalan", Mq = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], L0 = /* @__PURE__ */ U(Cw, Mq, (r) => {
  var {
    typed: e,
    addScalar: t,
    divideScalar: n,
    multiplyScalar: a,
    combinations: i,
    isNegative: u,
    isInteger: f
  } = r;
  return e(Cw, {
    "number | BigNumber": function(o) {
      if (!f(o) || u(o))
        throw new TypeError("Non-negative integer value expected in function catalan");
      return n(i(a(o, 2), o), t(o, 1));
    }
  });
}), Ew = "composition", Fq = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], q0 = /* @__PURE__ */ U(Ew, Fq, (r) => {
  var {
    typed: e,
    addScalar: t,
    combinations: n,
    isPositive: a,
    isNegative: i,
    isInteger: u,
    larger: f
  } = r;
  return e(Ew, {
    "number | BigNumber, number | BigNumber": function(o, s) {
      if (!u(o) || !a(o) || !u(s) || !a(s))
        throw new TypeError("Positive integer value expected in function composition");
      if (f(s, o))
        throw new TypeError("k must be less than or equal to n in function composition");
      return n(t(o, -1), t(s, -1));
    }
  });
}), Nw = "leafCount", Tq = ["parse", "typed"], U0 = /* @__PURE__ */ U(Nw, Tq, (r) => {
  var {
    parse: e,
    typed: t
  } = r;
  function n(a) {
    var i = 0;
    return a.forEach((u) => {
      i += n(u);
    }), i || 1;
  }
  return t(Nw, {
    Node: function(i) {
      return n(i);
    }
  });
});
function Bw(r) {
  return ar(r) || zr(r) && r.isUnary() && ar(r.args[0]);
}
function Js(r) {
  return !!(ar(r) || (An(r) || zr(r)) && r.args.every(Js) || un(r) && Js(r.content));
}
function Sw(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Nm(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sw(Object(t), !0).forEach(function(n) {
      Gr(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Sw(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
var Oq = "simplifyUtil", zq = ["FunctionNode", "OperatorNode", "SymbolNode"], zh = /* @__PURE__ */ U(Oq, zq, (r) => {
  var {
    FunctionNode: e,
    OperatorNode: t,
    SymbolNode: n
  } = r, a = !0, i = !1, u = "defaultF", f = {
    /*      */
    add: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /**/
    unaryPlus: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /* */
    subtract: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    },
    /* */
    multiply: {
      trivial: a,
      total: a,
      commutative: a,
      associative: a
    },
    /*   */
    divide: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    },
    /*    */
    paren: {
      trivial: a,
      total: a,
      commutative: a,
      associative: i
    },
    /* */
    defaultF: {
      trivial: i,
      total: a,
      commutative: i,
      associative: i
    }
  }, c = {
    divide: {
      total: i
    },
    log: {
      total: i
    }
  }, o = {
    subtract: {
      total: i
    },
    abs: {
      trivial: a
    },
    log: {
      total: a
    }
  };
  function s(m, b) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : f, A = u;
    if (typeof m == "string" ? A = m : zr(m) ? A = m.fn.toString() : An(m) ? A = m.name : un(m) && (A = "paren"), Pe(w, A)) {
      var E = w[A];
      if (Pe(E, b))
        return E[b];
      if (Pe(f, A))
        return f[A][b];
    }
    if (Pe(w, u)) {
      var N = w[u];
      return Pe(N, b) ? N[b] : f[u][b];
    }
    if (Pe(f, A)) {
      var C = f[A];
      if (Pe(C, b))
        return C[b];
    }
    return f[u][b];
  }
  function l(m) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : f;
    return s(m, "commutative", b);
  }
  function v(m) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : f;
    return s(m, "associative", b);
  }
  function p(m, b) {
    var w = Nm({}, m);
    for (var A in b)
      Pe(m, A) ? w[A] = Nm(Nm({}, b[A]), m[A]) : w[A] = b[A];
    return w;
  }
  function h(m, b) {
    if (!m.args || m.args.length === 0)
      return m;
    m.args = d(m, b);
    for (var w = 0; w < m.args.length; w++)
      h(m.args[w], b);
  }
  function d(m, b) {
    var w, A = [], E = function N(C) {
      for (var D = 0; D < C.args.length; D++) {
        var B = C.args[D];
        zr(B) && w === B.op ? N(B) : A.push(B);
      }
    };
    return v(m, b) ? (w = m.op, E(m), A) : m.args;
  }
  function x(m, b) {
    if (!(!m.args || m.args.length === 0)) {
      for (var w = y(m), A = m.args.length, E = 0; E < A; E++)
        x(m.args[E], b);
      if (A > 2 && v(m, b)) {
        for (var N = m.args.pop(); m.args.length > 0; )
          N = w([m.args.pop(), N]);
        m.args = N.args;
      }
    }
  }
  function g(m, b) {
    if (!(!m.args || m.args.length === 0)) {
      for (var w = y(m), A = m.args.length, E = 0; E < A; E++)
        g(m.args[E], b);
      if (A > 2 && v(m, b)) {
        for (var N = m.args.shift(); m.args.length > 0; )
          N = w([N, m.args.shift()]);
        m.args = N.args;
      }
    }
  }
  function y(m) {
    return zr(m) ? function(b) {
      try {
        return new t(m.op, m.fn, b, m.implicit);
      } catch (w) {
        return console.error(w), [];
      }
    } : function(b) {
      return new e(new n(m.name), b);
    };
  }
  return {
    createMakeNodeFunction: y,
    hasProperty: s,
    isCommutative: l,
    isAssociative: v,
    mergeContext: p,
    flatten: h,
    allChildren: d,
    unflattenr: x,
    unflattenl: g,
    defaultContext: f,
    realContext: c,
    positiveContext: o
  };
}), Rq = "simplify", Iq = ["config", "typed", "parse", "add", "subtract", "multiply", "divide", "pow", "isZero", "equal", "resolve", "simplifyConstant", "simplifyCore", "?fraction", "?bignumber", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], k0 = /* @__PURE__ */ U(Rq, Iq, (r) => {
  var {
    config: e,
    typed: t,
    parse: n,
    add: a,
    subtract: i,
    multiply: u,
    divide: f,
    pow: c,
    isZero: o,
    equal: s,
    resolve: l,
    simplifyConstant: v,
    simplifyCore: p,
    fraction: h,
    bignumber: d,
    mathWithTransform: x,
    matrix: g,
    AccessorNode: y,
    ArrayNode: m,
    ConstantNode: b,
    FunctionNode: w,
    IndexNode: A,
    ObjectNode: E,
    OperatorNode: N,
    ParenthesisNode: C,
    SymbolNode: D
  } = r, {
    hasProperty: B,
    isCommutative: S,
    isAssociative: F,
    mergeContext: I,
    flatten: z,
    unflattenr: P,
    unflattenl: M,
    createMakeNodeFunction: H,
    defaultContext: O,
    realContext: Q,
    positiveContext: k
  } = zh({
    FunctionNode: w,
    OperatorNode: N,
    SymbolNode: D
  });
  t.addConversion({
    from: "Object",
    to: "Map",
    convert: ri
  });
  var L = t("simplify", {
    Node: ne,
    "Node, Map": (V, J) => ne(V, !1, J),
    "Node, Map, Object": (V, J, $) => ne(V, !1, J, $),
    "Node, Array": ne,
    "Node, Array, Map": ne,
    "Node, Array, Map, Object": ne
  });
  t.removeConversion({
    from: "Object",
    to: "Map",
    convert: ri
  }), L.defaultContext = O, L.realContext = Q, L.positiveContext = k;
  function R(V) {
    return V.transform(function(J, $, pe) {
      return un(J) ? R(J.content) : J;
    });
  }
  var X = {
    true: !0,
    false: !0,
    e: !0,
    i: !0,
    Infinity: !0,
    LN2: !0,
    LN10: !0,
    LOG2E: !0,
    LOG10E: !0,
    NaN: !0,
    phi: !0,
    pi: !0,
    SQRT1_2: !0,
    SQRT2: !0,
    tau: !0
    // null: false,
    // undefined: false,
    // version: false,
  };
  L.rules = [
    p,
    // { l: 'n+0', r: 'n' },     // simplifyCore
    // { l: 'n^0', r: '1' },     // simplifyCore
    // { l: '0*n', r: '0' },     // simplifyCore
    // { l: 'n/n', r: '1'},      // simplifyCore
    // { l: 'n^1', r: 'n' },     // simplifyCore
    // { l: '+n1', r:'n1' },     // simplifyCore
    // { l: 'n--n1', r:'n+n1' }, // simplifyCore
    {
      l: "log(e)",
      r: "1"
    },
    // temporary rules
    // Note initially we tend constants to the right because like-term
    // collection prefers the left, and we would rather collect nonconstants
    {
      s: "n-n1 -> n+-n1",
      // temporarily replace 'subtract' so we can further flatten the 'add' operator
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n-n -> 0",
      // partial alternative when we can't always subtract
      assuming: {
        subtract: {
          total: !1
        }
      }
    },
    {
      s: "-(cl*v) -> v * (-cl)",
      // make non-constant terms positive
      assuming: {
        multiply: {
          commutative: !0
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(cl*v) -> (-cl) * v",
      // non-commutative version, part 1
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(v*cl) -> v * (-cl)",
      // non-commutative version, part 2
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      l: "-(n1/n2)",
      r: "-n1/n2"
    },
    {
      l: "-v",
      r: "v * (-1)"
    },
    // finish making non-constant terms positive
    {
      l: "(n1 + n2)*(-1)",
      r: "n1*(-1) + n2*(-1)",
      repeat: !0
    },
    // expand negations to achieve as much sign cancellation as possible
    {
      l: "n/n1^n2",
      r: "n*n1^-n2"
    },
    // temporarily replace 'divide' so we can further flatten the 'multiply' operator
    {
      l: "n/n1",
      r: "n*n1^-1"
    },
    {
      s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    // expand nested exponentiation
    {
      s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // 1/(1/n) = n needs 1/n to exist
    },
    // collect like factors; into a sum, only do this for nonconstants
    {
      l: " vd   * ( vd   * n1 + n2)",
      r: "vd^2       * n1 +  vd   * n2"
    },
    {
      s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
      // v*1/v = v^(1+-1) needs 1/v
    },
    {
      s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      l: "n*n",
      r: "n^2"
    },
    {
      s: "n * n^n1 -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // n*1/n = n^(-1+1) needs 1/n
    },
    {
      s: "n^n1 * n^n2 -> n^(n1+n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // ditto for n^2*1/n^2
    },
    // Unfortunately, to deal with more complicated cancellations, it
    // becomes necessary to simplify constants twice per pass. It's not
    // terribly expensive compared to matching rules, so this should not
    // pose a performance problem.
    v,
    // First: before collecting like terms
    // collect like terms
    {
      s: "n+n -> 2*n",
      assuming: {
        add: {
          total: !0
        }
      }
      // 2 = 1 + 1 needs to exist
    },
    {
      l: "n+-n",
      r: "0"
    },
    {
      l: "vd*n + vd",
      r: "vd*(n+1)"
    },
    // NOTE: leftmost position is special:
    {
      l: "n3*n1 + n3*n2",
      r: "n3*(n1+n2)"
    },
    // All sub-monomials tried there.
    {
      l: "n3^(-n4)*n1 +   n3  * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
    },
    {
      l: "n3^(-n4)*n1 + n3^n5 * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
    },
    // noncommutative additional cases (term collection & factoring)
    {
      s: "n*vd + vd -> (n+1)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "vd + n*vd -> (1+n)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n^n1 * n -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      l: "n*cd + cd",
      r: "(n+1)*cd"
    },
    {
      s: "cd*n + cd -> cd*(n+1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "cd + cd*n -> cd*(1+n)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    v,
    // Second: before returning expressions to "standard form"
    // make factors positive (and undo 'make non-constant terms positive')
    {
      s: "(-n)*n1 -> -(n*n1)",
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n1*(-n) -> -(n1*n)",
      // in case * non-commutative
      assuming: {
        subtract: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    // final ordering of constants
    {
      s: "ce+ve -> ve+ce",
      assuming: {
        add: {
          commutative: !0
        }
      },
      imposeContext: {
        add: {
          commutative: !1
        }
      }
    },
    {
      s: "vd*cd -> cd*vd",
      assuming: {
        multiply: {
          commutative: !0
        }
      },
      imposeContext: {
        multiply: {
          commutative: !1
        }
      }
    },
    // undo temporary rules
    // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
    {
      l: "n+-n1",
      r: "n-n1"
    },
    // undo replace 'subtract'
    {
      l: "n+-(n1)",
      r: "n-(n1)"
    },
    {
      s: "n*(n1^-1) -> n/n1",
      // undo replace 'divide'; for * commutative
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n*n1^-n2 -> n/n1^n2",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n^-1 -> 1/n",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      l: "n^1",
      r: "n"
    },
    // can be produced by power cancellation
    {
      s: "n*(n1/n2) -> (n*n1)/n2",
      // '*' before '/'
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      s: "n-(n1+n2) -> n-n1-n2",
      // '-' before '+'
      assuming: {
        addition: {
          associative: !0,
          commutative: !0
        }
      }
    },
    // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
    // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
    // simplifyConstant can leave an extra factor of 1, which can always
    // be eliminated, since the identity always commutes
    {
      l: "1*n",
      r: "n",
      imposeContext: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "n1/(n2/n3) -> (n1*n3)/n2",
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      l: "n1/(-n2)",
      r: "-n1/n2"
    }
  ];
  function ae(V, J) {
    var $ = {};
    if (V.s) {
      var pe = V.s.split("->");
      if (pe.length === 2)
        $.l = pe[0], $.r = pe[1];
      else
        throw SyntaxError("Could not parse rule: " + V.s);
    } else
      $.l = V.l, $.r = V.r;
    $.l = R(n($.l)), $.r = R(n($.r));
    for (var ve of ["imposeContext", "repeat", "assuming"])
      ve in V && ($[ve] = V[ve]);
    if (V.evaluate && ($.evaluate = n(V.evaluate)), F($.l, J)) {
      var q = !S($.l, J), G;
      q && (G = te());
      var ee = H($.l), se = te();
      $.expanded = {}, $.expanded.l = ee([$.l, se]), z($.expanded.l, J), P($.expanded.l, J), $.expanded.r = ee([$.r, se]), q && ($.expandedNC1 = {}, $.expandedNC1.l = ee([G, $.l]), $.expandedNC1.r = ee([G, $.r]), $.expandedNC2 = {}, $.expandedNC2.l = ee([G, $.expanded.l]), $.expandedNC2.r = ee([G, $.expanded.r]));
    }
    return $;
  }
  function _(V, J) {
    for (var $ = [], pe = 0; pe < V.length; pe++) {
      var ve = V[pe], q = void 0, G = typeof ve;
      switch (G) {
        case "string":
          ve = {
            s: ve
          };
        case "object":
          q = ae(ve, J);
          break;
        case "function":
          q = ve;
          break;
        default:
          throw TypeError("Unsupported type of rule: " + G);
      }
      $.push(q);
    }
    return $;
  }
  var re = 0;
  function te() {
    return new D("_p" + re++);
  }
  function ne(V, J) {
    var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $i(), pe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, ve = pe.consoleDebug;
    J = _(J || L.rules, pe.context);
    var q = l(V, $);
    q = R(q);
    for (var G = {}, ee = q.toString({
      parenthesis: "all"
    }); !G[ee]; ) {
      G[ee] = !0, re = 0;
      var se = ee;
      ve && console.log("Working on: ", ee);
      for (var de = 0; de < J.length; de++) {
        var me = "";
        if (typeof J[de] == "function" ? (q = J[de](q, pe), ve && (me = J[de].name)) : (z(q, pe.context), q = le(q, J[de], pe.context), ve && (me = "".concat(J[de].l.toString(), " -> ").concat(J[de].r.toString()))), ve) {
          var be = q.toString({
            parenthesis: "all"
          });
          be !== se && (console.log("Applying", me, "produced", be), se = be);
        }
        M(q, pe.context);
      }
      ee = q.toString({
        parenthesis: "all"
      });
    }
    return q;
  }
  function oe(V, J, $) {
    var pe = V;
    if (V)
      for (var ve = 0; ve < V.length; ++ve) {
        var q = le(V[ve], J, $);
        q !== V[ve] && (pe === V && (pe = V.slice()), pe[ve] = q);
      }
    return pe;
  }
  function le(V, J, $) {
    if (J.assuming) {
      for (var pe in J.assuming)
        for (var ve in J.assuming[pe])
          if (B(pe, ve, $) !== J.assuming[pe][ve])
            return V;
    }
    var q = I(J.imposeContext, $), G = V;
    if (G instanceof N || G instanceof w) {
      var ee = oe(G.args, J, $);
      ee !== G.args && (G = G.clone(), G.args = ee);
    } else if (G instanceof C) {
      if (G.content) {
        var se = le(G.content, J, $);
        se !== G.content && (G = new C(se));
      }
    } else if (G instanceof m) {
      var de = oe(G.items, J, $);
      de !== G.items && (G = new m(de));
    } else if (G instanceof y) {
      var me = G.object;
      G.object && (me = le(G.object, J, $));
      var be = G.index;
      G.index && (be = le(G.index, J, $)), (me !== G.object || be !== G.index) && (G = new y(me, be));
    } else if (G instanceof A) {
      var xe = oe(G.dimensions, J, $);
      xe !== G.dimensions && (G = new A(xe));
    } else if (G instanceof E) {
      var Ee = !1, ye = {};
      for (var er in G.properties)
        ye[er] = le(G.properties[er], J, $), ye[er] !== G.properties[er] && (Ee = !0);
      Ee && (G = new E(ye));
    }
    var rr = J.r, Fe = Y(J.l, G, q)[0];
    if (!Fe && J.expanded && (rr = J.expanded.r, Fe = Y(J.expanded.l, G, q)[0]), !Fe && J.expandedNC1 && (rr = J.expandedNC1.r, Fe = Y(J.expandedNC1.l, G, q)[0], Fe || (rr = J.expandedNC2.r, Fe = Y(J.expandedNC2.l, G, q)[0])), Fe) {
      var Er = G.implicit;
      G = rr.clone(), Er && "implicit" in rr && (G.implicit = !0), G = G.transform(function(T) {
        return T.isSymbolNode && Pe(Fe.placeholders, T.name) ? Fe.placeholders[T.name].clone() : T;
      });
    }
    return J.repeat && G !== V && (G = le(G, J, $)), G;
  }
  function fe(V, J) {
    var $ = [], pe, ve, q = H(V);
    if (S(V, J))
      for (var G = 0; G < V.args.length; G++)
        ve = V.args.slice(0), ve.splice(G, 1), pe = ve.length === 1 ? ve[0] : q(ve), $.push(q([V.args[G], pe]));
    else
      for (var ee = 1; ee < V.args.length; ee++) {
        var se = V.args[0];
        ee > 1 && (se = q(V.args.slice(0, ee))), ve = V.args.slice(ee), pe = ve.length === 1 ? ve[0] : q(ve), $.push(q([se, pe]));
      }
    return $;
  }
  function ge(V, J) {
    var $ = {
      placeholders: {}
    };
    if (!V.placeholders && !J.placeholders)
      return $;
    if (V.placeholders) {
      if (!J.placeholders)
        return V;
    } else
      return J;
    for (var pe in V.placeholders)
      if (Pe(V.placeholders, pe) && ($.placeholders[pe] = V.placeholders[pe], Pe(J.placeholders, pe) && !ie(V.placeholders[pe], J.placeholders[pe])))
        return null;
    for (var ve in J.placeholders)
      Pe(J.placeholders, ve) && ($.placeholders[ve] = J.placeholders[ve]);
    return $;
  }
  function Be(V, J) {
    var $ = [];
    if (V.length === 0 || J.length === 0)
      return $;
    for (var pe, ve = 0; ve < V.length; ve++)
      for (var q = 0; q < J.length; q++)
        pe = ge(V[ve], J[q]), pe && $.push(pe);
    return $;
  }
  function j(V) {
    if (V.length === 0)
      return V;
    for (var J = V.reduce(Be), $ = [], pe = {}, ve = 0; ve < J.length; ve++) {
      var q = JSON.stringify(J[ve]);
      pe[q] || (pe[q] = !0, $.push(J[ve]));
    }
    return $;
  }
  function Y(V, J, $, pe) {
    var ve = [{
      placeholders: {}
    }];
    if (V instanceof N && J instanceof N || V instanceof w && J instanceof w) {
      if (V instanceof N) {
        if (V.op !== J.op || V.fn !== J.fn)
          return [];
      } else if (V instanceof w && V.name !== J.name)
        return [];
      if (J.args.length === 1 && V.args.length === 1 || !F(J, $) && J.args.length === V.args.length || pe) {
        for (var q = [], G = 0; G < V.args.length; G++) {
          var ee = Y(V.args[G], J.args[G], $);
          if (ee.length === 0)
            break;
          q.push(ee);
        }
        if (q.length !== V.args.length) {
          if (!S(J, $) || // exact match in order needed
          V.args.length === 1)
            return [];
          if (V.args.length > 2)
            throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
          var se = Y(V.args[0], J.args[1], $);
          if (se.length === 0)
            return [];
          var de = Y(V.args[1], J.args[0], $);
          if (de.length === 0)
            return [];
          q = [se, de];
        }
        ve = j(q);
      } else if (J.args.length >= 2 && V.args.length === 2) {
        for (var me = fe(J, $), be = [], xe = 0; xe < me.length; xe++) {
          var Ee = Y(V, me[xe], $, !0);
          be = be.concat(Ee);
        }
        return be;
      } else {
        if (V.args.length > 2)
          throw Error("Unexpected non-binary associative function: " + V.toString());
        return [];
      }
    } else if (V instanceof D) {
      if (V.name.length === 0)
        throw new Error("Symbol in rule has 0 length...!?");
      if (X[V.name]) {
        if (V.name !== J.name)
          return [];
      } else
        switch (V.name[1] >= "a" && V.name[1] <= "z" ? V.name.substring(0, 2) : V.name[0]) {
          case "n":
          case "_p":
            ve[0].placeholders[V.name] = J;
            break;
          case "c":
          case "cl":
            if (ar(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "v":
            if (!ar(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "vl":
            if (Ur(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "cd":
            if (Bw(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "vd":
            if (!Bw(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "ce":
            if (Js(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          case "ve":
            if (!Js(J))
              ve[0].placeholders[V.name] = J;
            else
              return [];
            break;
          default:
            throw new Error("Invalid symbol in rule: " + V.name);
        }
    } else if (V instanceof b) {
      if (!s(V.value, J.value))
        return [];
    } else
      return [];
    return ve;
  }
  function ie(V, J) {
    if (V instanceof b && J instanceof b) {
      if (!s(V.value, J.value))
        return !1;
    } else if (V instanceof D && J instanceof D) {
      if (V.name !== J.name)
        return !1;
    } else if (V instanceof N && J instanceof N || V instanceof w && J instanceof w) {
      if (V instanceof N) {
        if (V.op !== J.op || V.fn !== J.fn)
          return !1;
      } else if (V instanceof w && V.name !== J.name)
        return !1;
      if (V.args.length !== J.args.length)
        return !1;
      for (var $ = 0; $ < V.args.length; $++)
        if (!ie(V.args[$], J.args[$]))
          return !1;
    } else
      return !1;
    return !0;
  }
  return L;
}), Hq = "simplifyConstant", Lq = ["typed", "config", "mathWithTransform", "matrix", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], X0 = /* @__PURE__ */ U(Hq, Lq, (r) => {
  var {
    typed: e,
    config: t,
    mathWithTransform: n,
    matrix: a,
    fraction: i,
    bignumber: u,
    AccessorNode: f,
    ArrayNode: c,
    ConstantNode: o,
    FunctionNode: s,
    IndexNode: l,
    ObjectNode: v,
    OperatorNode: p,
    SymbolNode: h
  } = r, {
    isCommutative: d,
    isAssociative: x,
    allChildren: g,
    createMakeNodeFunction: y
  } = zh({
    FunctionNode: s,
    OperatorNode: p,
    SymbolNode: h
  }), m = e("simplifyConstant", {
    Node: (z) => E(I(z, {})),
    "Node, Object": function(P, M) {
      return E(I(P, M));
    }
  });
  function b(z) {
    return na(z) ? z.valueOf() : z instanceof Array ? z.map(b) : Oe(z) ? a(b(z.valueOf())) : z;
  }
  function w(z, P, M) {
    try {
      return n[z].apply(null, P);
    } catch {
      return P = P.map(b), C(n[z].apply(null, P), M);
    }
  }
  var A = e({
    Fraction: B,
    number: function(P) {
      return P < 0 ? D(new o(-P)) : new o(P);
    },
    BigNumber: function(P) {
      return P < 0 ? D(new o(-P)) : new o(P);
    },
    Complex: function(P) {
      throw new Error("Cannot convert Complex number to Node");
    },
    string: function(P) {
      return new o(P);
    },
    Matrix: function(P) {
      return new c(P.valueOf().map((M) => A(M)));
    }
  });
  function E(z) {
    return vr(z) ? z : A(z);
  }
  function N(z, P) {
    var M = P && P.exactFractions !== !1;
    if (M && isFinite(z) && i) {
      var H = i(z), O = P && typeof P.fractionsLimit == "number" ? P.fractionsLimit : 1 / 0;
      if (H.valueOf() === z && H.n < O && H.d < O)
        return H;
    }
    return z;
  }
  var C = e({
    "string, Object": function(P, M) {
      if (t.number === "BigNumber")
        return u === void 0 && Dh(), u(P);
      if (t.number === "Fraction")
        return i === void 0 && a4(), i(P);
      var H = parseFloat(P);
      return N(H, M);
    },
    "Fraction, Object": function(P, M) {
      return P;
    },
    // we don't need options here
    "BigNumber, Object": function(P, M) {
      return P;
    },
    // we don't need options here
    "number, Object": function(P, M) {
      return N(P, M);
    },
    "Complex, Object": function(P, M) {
      return P.im !== 0 ? P : N(P.re, M);
    },
    "Matrix, Object": function(P, M) {
      return a(N(P.valueOf()));
    },
    "Array, Object": function(P, M) {
      return P.map(N);
    }
  });
  function D(z) {
    return new p("-", "unaryMinus", [z]);
  }
  function B(z) {
    var P, M = z.s * z.n;
    return M < 0 ? P = new p("-", "unaryMinus", [new o(-M)]) : P = new o(M), z.d === 1 ? P : new p("/", "divide", [P, new o(z.d)]);
  }
  function S(z, P, M) {
    if (!aa(P))
      return new f(E(z), E(P));
    if (Mt(z) || Oe(z)) {
      for (var H = Array.from(P.dimensions); H.length > 0; )
        if (ar(H[0]) && typeof H[0].value != "string") {
          var O = C(H.shift().value, M);
          Mt(z) ? z = z.items[O - 1] : (z = z.valueOf()[O - 1], z instanceof Array && (z = a(z)));
        } else if (H.length > 1 && ar(H[1]) && typeof H[1].value != "string") {
          var Q = C(H[1].value, M), k = [], L = Mt(z) ? z.items : z.valueOf();
          for (var R of L)
            if (Mt(R))
              k.push(R.items[Q - 1]);
            else if (Oe(z))
              k.push(R[Q - 1]);
            else
              break;
          if (k.length === L.length)
            Mt(z) ? z = new c(k) : z = a(k), H.splice(1, 1);
          else
            break;
        } else
          break;
      return H.length === P.dimensions.length ? new f(E(z), P) : H.length > 0 ? (P = new l(H), new f(E(z), P)) : z;
    }
    if (xi(z) && P.dimensions.length === 1 && ar(P.dimensions[0])) {
      var X = P.dimensions[0].value;
      return X in z.properties ? z.properties[X] : new o();
    }
    return new f(E(z), P);
  }
  function F(z, P, M, H) {
    var O = P.shift(), Q = P.reduce((k, L) => {
      if (!vr(L)) {
        var R = k.pop();
        if (vr(R))
          return [R, L];
        try {
          return k.push(w(z, [R, L], H)), k;
        } catch {
          k.push(R);
        }
      }
      k.push(E(k.pop()));
      var X = k.length === 1 ? k[0] : M(k);
      return [M([X, E(L)])];
    }, [O]);
    return Q.length === 1 ? Q[0] : M([Q[0], A(Q[1])]);
  }
  function I(z, P) {
    switch (z.type) {
      case "SymbolNode":
        return z;
      case "ConstantNode":
        switch (typeof z.value) {
          case "number":
            return C(z.value, P);
          case "string":
            return z.value;
          default:
            if (!isNaN(z.value))
              return C(z.value, P);
        }
        return z;
      case "FunctionNode":
        if (n[z.name] && n[z.name].rawArgs)
          return z;
        {
          var M = ["add", "multiply"];
          if (!M.includes(z.name)) {
            var H = z.args.map((le) => I(le, P));
            if (!H.some(vr))
              try {
                return w(z.name, H, P);
              } catch {
              }
            if (z.name === "size" && H.length === 1 && Mt(H[0])) {
              for (var O = [], Q = H[0]; Mt(Q); )
                O.push(Q.items.length), Q = Q.items[0];
              return a(O);
            }
            return new s(z.name, H.map(E));
          }
        }
      case "OperatorNode": {
        var k = z.fn.toString(), L, R, X = y(z);
        if (zr(z) && z.isUnary())
          L = [I(z.args[0], P)], vr(L[0]) ? R = X(L) : R = w(k, L, P);
        else if (x(z, P.context))
          if (L = g(z, P.context), L = L.map((le) => I(le, P)), d(k, P.context)) {
            for (var ae = [], _ = [], re = 0; re < L.length; re++)
              vr(L[re]) ? _.push(L[re]) : ae.push(L[re]);
            ae.length > 1 ? (R = F(k, ae, X, P), _.unshift(R), R = F(k, _, X, P)) : R = F(k, L, X, P);
          } else
            R = F(k, L, X, P);
        else
          L = z.args.map((le) => I(le, P)), R = F(k, L, X, P);
        return R;
      }
      case "ParenthesisNode":
        return I(z.content, P);
      case "AccessorNode":
        return S(I(z.object, P), I(z.index, P), P);
      case "ArrayNode": {
        var te = z.items.map((le) => I(le, P));
        return te.some(vr) ? new c(te.map(E)) : a(te);
      }
      case "IndexNode":
        return new l(z.dimensions.map((le) => m(le, P)));
      case "ObjectNode": {
        var ne = {};
        for (var oe in z.properties)
          ne[oe] = m(z.properties[oe], P);
        return new v(ne);
      }
      case "AssignmentNode":
      case "BlockNode":
      case "FunctionAssignmentNode":
      case "RangeNode":
      case "ConditionalNode":
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(z.type));
    }
  }
  return m;
}), Pw = "simplifyCore", qq = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], j0 = /* @__PURE__ */ U(Pw, qq, (r) => {
  var {
    typed: e,
    parse: t,
    equal: n,
    isZero: a,
    add: i,
    subtract: u,
    multiply: f,
    divide: c,
    pow: o,
    AccessorNode: s,
    ArrayNode: l,
    ConstantNode: v,
    FunctionNode: p,
    IndexNode: h,
    ObjectNode: d,
    OperatorNode: x,
    ParenthesisNode: g,
    SymbolNode: y
  } = r, m = new v(0), b = new v(1), w = new v(!0), A = new v(!1);
  function E(B) {
    return zr(B) && ["and", "not", "or"].includes(B.op);
  }
  var {
    hasProperty: N,
    isCommutative: C
  } = zh({
    FunctionNode: p,
    OperatorNode: x,
    SymbolNode: y
  });
  function D(B) {
    var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = S ? S.context : void 0;
    if (N(B, "trivial", F)) {
      if (An(B) && B.args.length === 1)
        return D(B.args[0], S);
      var I = !1, z = 0;
      if (B.forEach((_) => {
        ++z, z === 1 && (I = D(_, S));
      }), z === 1)
        return I;
    }
    var P = B;
    if (An(P)) {
      var M = $T(P.name);
      if (M) {
        if (P.args.length > 2 && N(P, "associative", F))
          for (; P.args.length > 2; ) {
            var H = P.args.pop(), O = P.args.pop();
            P.args.push(new x(M, P.name, [H, O]));
          }
        P = new x(M, P.name, P.args);
      } else
        return new p(D(P.fn), P.args.map((_) => D(_, S)));
    }
    if (zr(P) && P.isUnary()) {
      var Q = D(P.args[0], S);
      if (P.op === "~" && zr(Q) && Q.isUnary() && Q.op === "~" || P.op === "not" && zr(Q) && Q.isUnary() && Q.op === "not" && E(Q.args[0]))
        return Q.args[0];
      var k = !0;
      if (P.op === "-" && zr(Q) && (Q.isBinary() && Q.fn === "subtract" && (P = new x("-", "subtract", [Q.args[1], Q.args[0]]), k = !1), Q.isUnary() && Q.op === "-"))
        return Q.args[0];
      if (k)
        return new x(P.op, P.fn, [Q]);
    }
    if (zr(P) && P.isBinary()) {
      var L = D(P.args[0], S), R = D(P.args[1], S);
      if (P.op === "+") {
        if (ar(L) && a(L.value))
          return R;
        if (ar(R) && a(R.value))
          return L;
        zr(R) && R.isUnary() && R.op === "-" && (R = R.args[0], P = new x("-", "subtract", [L, R]));
      }
      if (P.op === "-")
        return zr(R) && R.isUnary() && R.op === "-" ? D(new x("+", "add", [L, R.args[0]]), S) : ar(L) && a(L.value) ? D(new x("-", "unaryMinus", [R])) : ar(R) && a(R.value) ? L : new x(P.op, P.fn, [L, R]);
      if (P.op === "*") {
        if (ar(L)) {
          if (a(L.value))
            return m;
          if (n(L.value, 1))
            return R;
        }
        if (ar(R)) {
          if (a(R.value))
            return m;
          if (n(R.value, 1))
            return L;
          if (C(P, F))
            return new x(P.op, P.fn, [R, L], P.implicit);
        }
        return new x(P.op, P.fn, [L, R], P.implicit);
      }
      if (P.op === "/")
        return ar(L) && a(L.value) ? m : ar(R) && n(R.value, 1) ? L : new x(P.op, P.fn, [L, R]);
      if (P.op === "^" && ar(R)) {
        if (a(R.value))
          return b;
        if (n(R.value, 1))
          return L;
      }
      if (P.op === "and") {
        if (ar(L))
          if (L.value) {
            if (E(R))
              return R;
            if (ar(R))
              return R.value ? w : A;
          } else
            return A;
        if (ar(R))
          if (R.value) {
            if (E(L))
              return L;
          } else
            return A;
      }
      if (P.op === "or") {
        if (ar(L)) {
          if (L.value)
            return w;
          if (E(R))
            return R;
        }
        if (ar(R)) {
          if (R.value)
            return w;
          if (E(L))
            return L;
        }
      }
      return new x(P.op, P.fn, [L, R]);
    }
    if (zr(P))
      return new x(P.op, P.fn, P.args.map((_) => D(_, S)));
    if (Mt(P))
      return new l(P.items.map((_) => D(_, S)));
    if (In(P))
      return new s(D(P.object, S), D(P.index, S));
    if (aa(P))
      return new h(P.dimensions.map((_) => D(_, S)));
    if (xi(P)) {
      var X = {};
      for (var ae in P.properties)
        X[ae] = D(P.properties[ae], S);
      return new d(X);
    }
    return P;
  }
  return e(Pw, {
    Node: D,
    "Node,Object": D
  });
}), Uq = "resolve", kq = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], G0 = /* @__PURE__ */ U(Uq, kq, (r) => {
  var {
    typed: e,
    parse: t,
    ConstantNode: n,
    FunctionNode: a,
    OperatorNode: i,
    ParenthesisNode: u
  } = r;
  function f(c, o) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!o)
      return c;
    if (Ur(c)) {
      if (s.has(c.name)) {
        var l = Array.from(s).join(", ");
        throw new ReferenceError("recursive loop of variable definitions among {".concat(l, "}"));
      }
      var v = o.get(c.name);
      if (vr(v)) {
        var p = new Set(s);
        return p.add(c.name), f(v, o, p);
      } else
        return typeof v == "number" ? t(String(v)) : v !== void 0 ? new n(v) : c;
    } else if (zr(c)) {
      var h = c.args.map(function(x) {
        return f(x, o, s);
      });
      return new i(c.op, c.fn, h, c.implicit);
    } else {
      if (un(c))
        return new u(f(c.content, o, s));
      if (An(c)) {
        var d = c.args.map(function(x) {
          return f(x, o, s);
        });
        return new a(c.name, d);
      }
    }
    return c.map((x) => f(x, o, s));
  }
  return e("resolve", {
    Node: f,
    "Node, Map | null | undefined": f,
    "Node, Object": (c, o) => f(c, ri(o)),
    // For arrays and matrices, we map `self` rather than `_resolve`
    // because resolve is fairly expensive anyway, and this way
    // we get nice error messages if one entry in the array has wrong type.
    "Array | Matrix": e.referToSelf((c) => (o) => o.map((s) => c(s))),
    "Array | Matrix, null | undefined": e.referToSelf((c) => (o) => o.map((s) => c(s))),
    "Array, Object": e.referTo("Array,Map", (c) => (o, s) => c(o, ri(s))),
    "Matrix, Object": e.referTo("Matrix,Map", (c) => (o, s) => c(o, ri(s))),
    "Array | Matrix, Map": e.referToSelf((c) => (o, s) => o.map((l) => c(l, s)))
  });
}), Mw = "symbolicEqual", Xq = ["parse", "simplify", "typed", "OperatorNode"], V0 = /* @__PURE__ */ U(Mw, Xq, (r) => {
  var {
    parse: e,
    simplify: t,
    typed: n,
    OperatorNode: a
  } = r;
  function i(u, f) {
    var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = new a("-", "subtract", [u, f]), s = t(o, {}, c);
    return ar(s) && !s.value;
  }
  return n(Mw, {
    "Node, Node": i,
    "Node, Node, Object": i
  });
}), Fw = "derivative", jq = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], Q0 = /* @__PURE__ */ U(Fw, jq, (r) => {
  var {
    typed: e,
    config: t,
    parse: n,
    simplify: a,
    equal: i,
    isZero: u,
    numeric: f,
    ConstantNode: c,
    FunctionNode: o,
    OperatorNode: s,
    ParenthesisNode: l,
    SymbolNode: v
  } = r;
  function p(m, b) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      simplify: !0
    }, A = {};
    x(A, m, b.name);
    var E = g(m, A);
    return w.simplify ? a(E) : E;
  }
  e.addConversion({
    from: "identifier",
    to: "SymbolNode",
    convert: n
  });
  var h = e(Fw, {
    "Node, SymbolNode": p,
    "Node, SymbolNode, Object": p
    /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
    'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
      let res = expr
      for (let i = 0; i < order; i++) {
        let constNodes = {}
        constTag(constNodes, expr, variable.name)
        res = _derivative(res, constNodes)
      }
      return res
    }
    */
  });
  e.removeConversion({
    from: "identifier",
    to: "SymbolNode",
    convert: n
  }), h._simplify = !0, h.toTex = function(m) {
    return d.apply(null, m.args);
  };
  var d = e("_derivTex", {
    "Node, SymbolNode": function(b, w) {
      return ar(b) && br(b.value) === "string" ? d(n(b.value).toString(), w.toString(), 1) : d(b.toTex(), w.toString(), 1);
    },
    "Node, ConstantNode": function(b, w) {
      if (br(w.value) === "string")
        return d(b, n(w.value));
      throw new Error("The second parameter to 'derivative' is a non-string constant");
    },
    "Node, SymbolNode, ConstantNode": function(b, w, A) {
      return d(b.toString(), w.name, A.value);
    },
    "string, string, number": function(b, w, A) {
      var E;
      return A === 1 ? E = "{d\\over d" + w + "}" : E = "{d^{" + A + "}\\over d" + w + "^{" + A + "}}", E + "\\left[".concat(b, "\\right]");
    }
  }), x = e("constTag", {
    "Object, ConstantNode, string": function(b, w) {
      return b[w] = !0, !0;
    },
    "Object, SymbolNode, string": function(b, w, A) {
      return w.name !== A ? (b[w] = !0, !0) : !1;
    },
    "Object, ParenthesisNode, string": function(b, w, A) {
      return x(b, w.content, A);
    },
    "Object, FunctionAssignmentNode, string": function(b, w, A) {
      return w.params.includes(A) ? x(b, w.expr, A) : (b[w] = !0, !0);
    },
    "Object, FunctionNode | OperatorNode, string": function(b, w, A) {
      if (w.args.length > 0) {
        for (var E = x(b, w.args[0], A), N = 1; N < w.args.length; ++N)
          E = x(b, w.args[N], A) && E;
        if (E)
          return b[w] = !0, !0;
      }
      return !1;
    }
  }), g = e("_derivative", {
    "ConstantNode, Object": function(b) {
      return y(0);
    },
    "SymbolNode, Object": function(b, w) {
      return w[b] !== void 0 ? y(0) : y(1);
    },
    "ParenthesisNode, Object": function(b, w) {
      return new l(g(b.content, w));
    },
    "FunctionAssignmentNode, Object": function(b, w) {
      return w[b] !== void 0 ? y(0) : g(b.expr, w);
    },
    "FunctionNode, Object": function(b, w) {
      if (w[b] !== void 0)
        return y(0);
      var A = b.args[0], E, N = !1, C = !1, D;
      switch (b.name) {
        case "cbrt":
          N = !0, D = new s("*", "multiply", [y(3), new s("^", "pow", [A, new s("/", "divide", [y(2), y(3)])])]);
          break;
        case "sqrt":
        case "nthRoot":
          if (b.args.length === 1)
            N = !0, D = new s("*", "multiply", [y(2), new o("sqrt", [A])]);
          else if (b.args.length === 2)
            return E = new s("/", "divide", [y(1), b.args[1]]), w[E] = w[b.args[1]], g(new s("^", "pow", [A, E]), w);
          break;
        case "log10":
          E = y(10);
        case "log":
          if (!E && b.args.length === 1)
            D = A.clone(), N = !0;
          else if (b.args.length === 1 && E || b.args.length === 2 && w[b.args[1]] !== void 0)
            D = new s("*", "multiply", [A.clone(), new o("log", [E || b.args[1]])]), N = !0;
          else if (b.args.length === 2)
            return g(new s("/", "divide", [new o("log", [A]), new o("log", [b.args[1]])]), w);
          break;
        case "pow":
          if (b.args.length === 2)
            return w[E] = w[b.args[1]], g(new s("^", "pow", [A, b.args[1]]), w);
          break;
        case "exp":
          D = new o("exp", [A.clone()]);
          break;
        case "sin":
          D = new o("cos", [A.clone()]);
          break;
        case "cos":
          D = new s("-", "unaryMinus", [new o("sin", [A.clone()])]);
          break;
        case "tan":
          D = new s("^", "pow", [new o("sec", [A.clone()]), y(2)]);
          break;
        case "sec":
          D = new s("*", "multiply", [b, new o("tan", [A.clone()])]);
          break;
        case "csc":
          C = !0, D = new s("*", "multiply", [b, new o("cot", [A.clone()])]);
          break;
        case "cot":
          C = !0, D = new s("^", "pow", [new o("csc", [A.clone()]), y(2)]);
          break;
        case "asin":
          N = !0, D = new o("sqrt", [new s("-", "subtract", [y(1), new s("^", "pow", [A.clone(), y(2)])])]);
          break;
        case "acos":
          N = !0, C = !0, D = new o("sqrt", [new s("-", "subtract", [y(1), new s("^", "pow", [A.clone(), y(2)])])]);
          break;
        case "atan":
          N = !0, D = new s("+", "add", [new s("^", "pow", [A.clone(), y(2)]), y(1)]);
          break;
        case "asec":
          N = !0, D = new s("*", "multiply", [new o("abs", [A.clone()]), new o("sqrt", [new s("-", "subtract", [new s("^", "pow", [A.clone(), y(2)]), y(1)])])]);
          break;
        case "acsc":
          N = !0, C = !0, D = new s("*", "multiply", [new o("abs", [A.clone()]), new o("sqrt", [new s("-", "subtract", [new s("^", "pow", [A.clone(), y(2)]), y(1)])])]);
          break;
        case "acot":
          N = !0, C = !0, D = new s("+", "add", [new s("^", "pow", [A.clone(), y(2)]), y(1)]);
          break;
        case "sinh":
          D = new o("cosh", [A.clone()]);
          break;
        case "cosh":
          D = new o("sinh", [A.clone()]);
          break;
        case "tanh":
          D = new s("^", "pow", [new o("sech", [A.clone()]), y(2)]);
          break;
        case "sech":
          C = !0, D = new s("*", "multiply", [b, new o("tanh", [A.clone()])]);
          break;
        case "csch":
          C = !0, D = new s("*", "multiply", [b, new o("coth", [A.clone()])]);
          break;
        case "coth":
          C = !0, D = new s("^", "pow", [new o("csch", [A.clone()]), y(2)]);
          break;
        case "asinh":
          N = !0, D = new o("sqrt", [new s("+", "add", [new s("^", "pow", [A.clone(), y(2)]), y(1)])]);
          break;
        case "acosh":
          N = !0, D = new o("sqrt", [new s("-", "subtract", [new s("^", "pow", [A.clone(), y(2)]), y(1)])]);
          break;
        case "atanh":
          N = !0, D = new s("-", "subtract", [y(1), new s("^", "pow", [A.clone(), y(2)])]);
          break;
        case "asech":
          N = !0, C = !0, D = new s("*", "multiply", [A.clone(), new o("sqrt", [new s("-", "subtract", [y(1), new s("^", "pow", [A.clone(), y(2)])])])]);
          break;
        case "acsch":
          N = !0, C = !0, D = new s("*", "multiply", [new o("abs", [A.clone()]), new o("sqrt", [new s("+", "add", [new s("^", "pow", [A.clone(), y(2)]), y(1)])])]);
          break;
        case "acoth":
          N = !0, C = !0, D = new s("-", "subtract", [y(1), new s("^", "pow", [A.clone(), y(2)])]);
          break;
        case "abs":
          D = new s("/", "divide", [new o(new v("abs"), [A.clone()]), A.clone()]);
          break;
        case "gamma":
        default:
          throw new Error('Cannot process function "' + b.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
      }
      var B, S;
      N ? (B = "/", S = "divide") : (B = "*", S = "multiply");
      var F = g(A, w);
      return C && (F = new s("-", "unaryMinus", [F])), new s(B, S, [F, D]);
    },
    "OperatorNode, Object": function(b, w) {
      if (w[b] !== void 0)
        return y(0);
      if (b.op === "+")
        return new s(b.op, b.fn, b.args.map(function(z) {
          return g(z, w);
        }));
      if (b.op === "-") {
        if (b.isUnary())
          return new s(b.op, b.fn, [g(b.args[0], w)]);
        if (b.isBinary())
          return new s(b.op, b.fn, [g(b.args[0], w), g(b.args[1], w)]);
      }
      if (b.op === "*") {
        var A = b.args.filter(function(z) {
          return w[z] !== void 0;
        });
        if (A.length > 0) {
          var E = b.args.filter(function(z) {
            return w[z] === void 0;
          }), N = E.length === 1 ? E[0] : new s("*", "multiply", E), C = A.concat(g(N, w));
          return new s("*", "multiply", C);
        }
        return new s("+", "add", b.args.map(function(z) {
          return new s("*", "multiply", b.args.map(function(P) {
            return P === z ? g(P, w) : P.clone();
          }));
        }));
      }
      if (b.op === "/" && b.isBinary()) {
        var D = b.args[0], B = b.args[1];
        return w[B] !== void 0 ? new s("/", "divide", [g(D, w), B]) : w[D] !== void 0 ? new s("*", "multiply", [new s("-", "unaryMinus", [D]), new s("/", "divide", [g(B, w), new s("^", "pow", [B.clone(), y(2)])])]) : new s("/", "divide", [new s("-", "subtract", [new s("*", "multiply", [g(D, w), B.clone()]), new s("*", "multiply", [D.clone(), g(B, w)])]), new s("^", "pow", [B.clone(), y(2)])]);
      }
      if (b.op === "^" && b.isBinary()) {
        var S = b.args[0], F = b.args[1];
        if (w[S] !== void 0)
          return ar(S) && (u(S.value) || i(S.value, 1)) ? y(0) : new s("*", "multiply", [b, new s("*", "multiply", [new o("log", [S.clone()]), g(F.clone(), w)])]);
        if (w[F] !== void 0) {
          if (ar(F)) {
            if (u(F.value))
              return y(0);
            if (i(F.value, 1))
              return g(S, w);
          }
          var I = new s("^", "pow", [S.clone(), new s("-", "subtract", [F, y(1)])]);
          return new s("*", "multiply", [F.clone(), new s("*", "multiply", [g(S, w), I])]);
        }
        return new s("*", "multiply", [new s("^", "pow", [S.clone(), F.clone()]), new s("+", "add", [new s("*", "multiply", [g(S, w), new s("/", "divide", [F.clone(), S.clone()])]), new s("*", "multiply", [g(F, w), new o("log", [S.clone()])])])]);
      }
      throw new Error('Cannot process operator "' + b.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
    }
  });
  function y(m, b) {
    return new c(f(m, b || t.number));
  }
  return h;
}), Tw = "rationalize", Gq = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplifyConstant", "simplifyCore", "simplify", "?bignumber", "?fraction", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode", "ParenthesisNode"], Y0 = /* @__PURE__ */ U(Tw, Gq, (r) => {
  var {
    config: e,
    typed: t,
    equal: n,
    isZero: a,
    add: i,
    subtract: u,
    multiply: f,
    divide: c,
    pow: o,
    parse: s,
    simplifyConstant: l,
    simplifyCore: v,
    simplify: p,
    fraction: h,
    bignumber: d,
    mathWithTransform: x,
    matrix: g,
    AccessorNode: y,
    ArrayNode: m,
    ConstantNode: b,
    FunctionNode: w,
    IndexNode: A,
    ObjectNode: E,
    OperatorNode: N,
    SymbolNode: C,
    ParenthesisNode: D
  } = r;
  function B(P) {
    var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, H = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, O = F(), Q = S(P, M, !0, O.firstRules), k = Q.variables.length, L = {
      exactFractions: !1
    }, R = {
      exactFractions: !0
    };
    if (P = Q.expression, k >= 1) {
      P = I(P);
      var X, ae, _ = !0, re = !1;
      P = p(P, O.firstRules, {}, L);
      for (var te; ae = _ ? O.distrDivRules : O.sucDivRules, P = p(P, ae, {}, R), _ = !_, te = P.toString(), te !== X; )
        re = !0, X = te;
      re && (P = p(P, O.firstRulesAgain, {}, L)), P = p(P, O.finalRules, {}, L);
    }
    var ne = [], oe = {};
    return P.type === "OperatorNode" && P.isBinary() && P.op === "/" ? (k === 1 && (P.args[0] = z(P.args[0], ne), P.args[1] = z(P.args[1])), H && (oe.numerator = P.args[0], oe.denominator = P.args[1])) : (k === 1 && (P = z(P, ne)), H && (oe.numerator = P, oe.denominator = null)), H ? (oe.coefficients = ne, oe.variables = Q.variables, oe.expression = P, oe) : P;
  }
  return t(Tw, {
    Node: B,
    "Node, boolean": (P, M) => B(P, {}, M),
    "Node, Object": B,
    "Node, Object, boolean": B
  });
  function S(P, M, H, O) {
    var Q = [], k = p(P, O, M, {
      exactFractions: !1
    });
    H = !!H;
    var L = "+-*" + (H ? "/" : "");
    X(k);
    var R = {};
    return R.expression = k, R.variables = Q, R;
    function X(ae) {
      var _ = ae.type;
      if (_ === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (_ === "OperatorNode")
        if (ae.op === "^") {
          if (ae.args[1].type !== "ConstantNode" || !Me(parseFloat(ae.args[1].value)))
            throw new Error("There is a non-integer exponent");
          X(ae.args[0]);
        } else {
          if (!L.includes(ae.op))
            throw new Error("Operator " + ae.op + " invalid in polynomial expression");
          for (var re = 0; re < ae.args.length; re++)
            X(ae.args[re]);
        }
      else if (_ === "SymbolNode") {
        var te = ae.name, ne = Q.indexOf(te);
        ne === -1 && Q.push(te);
      } else if (_ === "ParenthesisNode")
        X(ae.content);
      else if (_ !== "ConstantNode")
        throw new Error("type " + _ + " is not allowed in polynomial expression");
    }
  }
  function F() {
    var P = [
      v,
      // sCore
      {
        l: "n+n",
        r: "2*n"
      },
      {
        l: "n+-n",
        r: "0"
      },
      l,
      // sConstant
      {
        l: "n*(n1^-1)",
        r: "n/n1"
      },
      {
        l: "n*n1^-n2",
        r: "n/n1^n2"
      },
      {
        l: "n1^-1",
        r: "1/n1"
      },
      {
        l: "n*(n1/n2)",
        r: "(n*n1)/n2"
      },
      {
        l: "1*n",
        r: "n"
      }
    ], M = [
      {
        l: "(-n1)/(-n2)",
        r: "n1/n2"
      },
      // Unary division
      {
        l: "(-n1)*(-n2)",
        r: "n1*n2"
      },
      // Unary multiplication
      {
        l: "n1--n2",
        r: "n1+n2"
      },
      // '--' elimination
      {
        l: "n1-n2",
        r: "n1+(-n2)"
      },
      // Subtraction turn into add with un�ry minus
      {
        l: "(n1+n2)*n3",
        r: "(n1*n3 + n2*n3)"
      },
      // Distributive 1
      {
        l: "n1*(n2+n3)",
        r: "(n1*n2+n1*n3)"
      },
      // Distributive 2
      {
        l: "c1*n + c2*n",
        r: "(c1+c2)*n"
      },
      // Joining constants
      {
        l: "c1*n + n",
        r: "(c1+1)*n"
      },
      // Joining constants
      {
        l: "c1*n - c2*n",
        r: "(c1-c2)*n"
      },
      // Joining constants
      {
        l: "c1*n - n",
        r: "(c1-1)*n"
      },
      // Joining constants
      {
        l: "v/c",
        r: "(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "v/-c",
        r: "-(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "-v*-c",
        r: "c*v"
      },
      // Inversion constant and variable 1
      {
        l: "-v*c",
        r: "-c*v"
      },
      // Inversion constant and variable 2
      {
        l: "v*-c",
        r: "-c*v"
      },
      // Inversion constant and variable 3
      {
        l: "v*c",
        r: "c*v"
      },
      // Inversion constant and variable 4
      {
        l: "-(-n1*n2)",
        r: "(n1*n2)"
      },
      // Unary propagation
      {
        l: "-(n1*n2)",
        r: "(-n1*n2)"
      },
      // Unary propagation
      {
        l: "-(-n1+n2)",
        r: "(n1-n2)"
      },
      // Unary propagation
      {
        l: "-(n1+n2)",
        r: "(-n1-n2)"
      },
      // Unary propagation
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      },
      // Power to Power
      {
        l: "-(-n1/n2)",
        r: "(n1/n2)"
      },
      // Division and Unary
      {
        l: "-(n1/n2)",
        r: "(-n1/n2)"
      }
    ], H = [
      {
        l: "(n1/n2 + n3/n4)",
        r: "((n1*n4 + n3*n2)/(n2*n4))"
      },
      // Sum of fractions
      {
        l: "(n1/n2 + n3)",
        r: "((n1 + n3*n2)/n2)"
      },
      // Sum fraction with number 1
      {
        l: "(n1 + n2/n3)",
        r: "((n1*n3 + n2)/n3)"
      }
    ], O = [
      {
        l: "(n1/(n2/n3))",
        r: "((n1*n3)/n2)"
      },
      // Division simplification
      {
        l: "(n1/n2/n3)",
        r: "(n1/(n2*n3))"
      }
    ], Q = {};
    return Q.firstRules = P.concat(M, O), Q.distrDivRules = H, Q.sucDivRules = O, Q.firstRulesAgain = P.concat(M), Q.finalRules = [
      v,
      // simplify.rules[0]
      {
        l: "n*-n",
        r: "-n^2"
      },
      // Joining multiply with power 1
      {
        l: "n*n",
        r: "n^2"
      },
      // Joining multiply with power 2
      l,
      // simplify.rules[14] old 3rd index in oldRules
      {
        l: "n*-n^n1",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 3
      {
        l: "n*n^n1",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 4
      {
        l: "n^n1*-n^n2",
        r: "-n^(n1+n2)"
      },
      // Joining multiply with power 5
      {
        l: "n^n1*n^n2",
        r: "n^(n1+n2)"
      },
      // Joining multiply with power 6
      {
        l: "n^n1*-n",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 7
      {
        l: "n^n1*n",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/-n",
        r: "-n^(n1-1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/n",
        r: "n^(n1-1)"
      },
      // Joining division with power 1
      {
        l: "n/-n^n1",
        r: "-n^(1-n1)"
      },
      // Joining division with power 2
      {
        l: "n/n^n1",
        r: "n^(1-n1)"
      },
      // Joining division with power 3
      {
        l: "n^n1/-n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 4
      {
        l: "n^n1/n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 5
      {
        l: "n1+(-n2*n3)",
        r: "n1-n2*n3"
      },
      // Solving useless parenthesis 1
      {
        l: "v*(-c)",
        r: "-c*v"
      },
      // Solving useless unary 2
      {
        l: "n1+-n2",
        r: "n1-n2"
      },
      // Solving +- together (new!)
      {
        l: "v*c",
        r: "c*v"
      },
      // inversion constant with variable
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      }
      // Power to Power
    ], Q;
  }
  function I(P, M, H) {
    var O = P.type, Q = arguments.length > 1;
    if (O === "OperatorNode" && P.isBinary()) {
      var k = !1, L;
      if (P.op === "^" && (P.args[0].type === "ParenthesisNode" || P.args[0].type === "OperatorNode") && P.args[1].type === "ConstantNode" && (L = parseFloat(P.args[1].value), k = L >= 2 && Me(L)), k) {
        if (L > 2) {
          var R = P.args[0], X = new N("^", "pow", [P.args[0].cloneDeep(), new b(L - 1)]);
          P = new N("*", "multiply", [R, X]);
        } else
          P = new N("*", "multiply", [P.args[0], P.args[0].cloneDeep()]);
        Q && (H === "content" ? M.content = P : M.args[H] = P);
      }
    }
    if (O === "ParenthesisNode")
      I(P.content, P, "content");
    else if (O !== "ConstantNode" && O !== "SymbolNode")
      for (var ae = 0; ae < P.args.length; ae++)
        I(P.args[ae], P, ae);
    if (!Q)
      return P;
  }
  function z(P, M) {
    M === void 0 && (M = []), M[0] = 0;
    var H = {};
    H.cte = 1, H.oper = "+", H.fire = "";
    var O = 0, Q = "";
    te(P, null, H), O = M.length - 1;
    for (var k = !0, L, R = O; R >= 0; R--)
      if (M[R] !== 0) {
        var X = new b(k ? M[R] : Math.abs(M[R])), ae = M[R] < 0 ? "-" : "+";
        if (R > 0) {
          var _ = new C(Q);
          if (R > 1) {
            var re = new b(R);
            _ = new N("^", "pow", [_, re]);
          }
          M[R] === -1 && k ? X = new N("-", "unaryMinus", [_]) : Math.abs(M[R]) === 1 ? X = _ : X = new N("*", "multiply", [X, _]);
        }
        k ? L = X : ae === "+" ? L = new N("+", "add", [L, X]) : L = new N("-", "subtract", [L, X]), k = !1;
      }
    if (k)
      return new b(0);
    return L;
    function te(ne, oe, le) {
      var fe = ne.type;
      if (fe === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (fe === "OperatorNode") {
        if (!"+-*^".includes(ne.op))
          throw new Error("Operator " + ne.op + " invalid");
        if (oe !== null) {
          if ((ne.fn === "unaryMinus" || ne.fn === "pow") && oe.fn !== "add" && oe.fn !== "subtract" && oe.fn !== "multiply")
            throw new Error("Invalid " + ne.op + " placing");
          if ((ne.fn === "subtract" || ne.fn === "add" || ne.fn === "multiply") && oe.fn !== "add" && oe.fn !== "subtract")
            throw new Error("Invalid " + ne.op + " placing");
          if ((ne.fn === "subtract" || ne.fn === "add" || ne.fn === "unaryMinus") && le.noFil !== 0)
            throw new Error("Invalid " + ne.op + " placing");
        }
        (ne.op === "^" || ne.op === "*") && (le.fire = ne.op);
        for (var ge = 0; ge < ne.args.length; ge++)
          ne.fn === "unaryMinus" && (le.oper = "-"), (ne.op === "+" || ne.fn === "subtract") && (le.fire = "", le.cte = 1, le.oper = ge === 0 ? "+" : ne.op), le.noFil = ge, te(ne.args[ge], ne, le);
      } else if (fe === "SymbolNode") {
        if (ne.name !== Q && Q !== "")
          throw new Error("There is more than one variable");
        if (Q = ne.name, oe === null) {
          M[1] = 1;
          return;
        }
        if (oe.op === "^" && le.noFil !== 0)
          throw new Error("In power the variable should be the first parameter");
        if (oe.op === "*" && le.noFil !== 1)
          throw new Error("In multiply the variable should be the second parameter");
        (le.fire === "" || le.fire === "*") && (O < 1 && (M[1] = 0), M[1] += le.cte * (le.oper === "+" ? 1 : -1), O = Math.max(1, O));
      } else if (fe === "ConstantNode") {
        var Be = parseFloat(ne.value);
        if (oe === null) {
          M[0] = Be;
          return;
        }
        if (oe.op === "^") {
          if (le.noFil !== 1)
            throw new Error("Constant cannot be powered");
          if (!Me(Be) || Be <= 0)
            throw new Error("Non-integer exponent is not allowed");
          for (var j = O + 1; j < Be; j++)
            M[j] = 0;
          Be > O && (M[Be] = 0), M[Be] += le.cte * (le.oper === "+" ? 1 : -1), O = Math.max(Be, O);
          return;
        }
        le.cte = Be, le.fire === "" && (M[0] += le.cte * (le.oper === "+" ? 1 : -1));
      } else
        throw new Error("Type " + fe + " is not allowed");
    }
  }
}), Ow = "zpk2tf", Vq = ["typed", "add", "multiply", "Complex", "number"], Z0 = /* @__PURE__ */ U(Ow, Vq, (r) => {
  var {
    typed: e,
    add: t,
    multiply: n,
    Complex: a,
    number: i
  } = r;
  return e(Ow, {
    "Array,Array,number": function(o, s, l) {
      return u(o, s, l);
    },
    "Array,Array": function(o, s) {
      return u(o, s, 1);
    },
    "Matrix,Matrix,number": function(o, s, l) {
      return u(o.valueOf(), s.valueOf(), l);
    },
    "Matrix,Matrix": function(o, s) {
      return u(o.valueOf(), s.valueOf(), 1);
    }
  });
  function u(c, o, s) {
    c.some((y) => y.type === "BigNumber") && (c = c.map((y) => i(y))), o.some((y) => y.type === "BigNumber") && (o = o.map((y) => i(y)));
    for (var l = [a(1, 0)], v = [a(1, 0)], p = 0; p < c.length; p++) {
      var h = c[p];
      typeof h == "number" && (h = a(h, 0)), l = f(l, [a(1, 0), a(-h.re, -h.im)]);
    }
    for (var d = 0; d < o.length; d++) {
      var x = o[d];
      typeof x == "number" && (x = a(x, 0)), v = f(v, [a(1, 0), a(-x.re, -x.im)]);
    }
    for (var g = 0; g < l.length; g++)
      l[g] = n(l[g], s);
    return [l, v];
  }
  function f(c, o) {
    for (var s = [], l = 0; l < c.length + o.length - 1; l++) {
      s[l] = a(0, 0);
      for (var v = 0; v < c.length; v++)
        l - v >= 0 && l - v < o.length && (s[l] = t(s[l], n(c[v], o[l - v])));
    }
    return s;
  }
}), zw = "freqz", Qq = ["typed", "add", "multiply", "Complex", "divide", "matrix"], W0 = /* @__PURE__ */ U(zw, Qq, (r) => {
  var {
    typed: e,
    add: t,
    multiply: n,
    Complex: a,
    divide: i,
    matrix: u
  } = r;
  return e(zw, {
    "Array, Array": function(s, l) {
      var v = c(512);
      return f(s, l, v);
    },
    "Array, Array, Array": function(s, l, v) {
      return f(s, l, v);
    },
    "Array, Array, number": function(s, l, v) {
      if (v < 0)
        throw new Error("w must be a positive number");
      var p = c(v);
      return f(s, l, p);
    },
    "Matrix, Matrix": function(s, l) {
      var v = c(512), {
        w: p,
        h
      } = f(s.valueOf(), l.valueOf(), v);
      return {
        w: u(p),
        h: u(h)
      };
    },
    "Matrix, Matrix, Matrix": function(s, l, v) {
      var {
        h: p
      } = f(s.valueOf(), l.valueOf(), v.valueOf());
      return {
        h: u(p),
        w: u(v)
      };
    },
    "Matrix, Matrix, number": function(s, l, v) {
      if (v < 0)
        throw new Error("w must be a positive number");
      var p = c(v), {
        h
      } = f(s.valueOf(), l.valueOf(), p);
      return {
        h: u(h),
        w: u(p)
      };
    }
  });
  function f(o, s, l) {
    for (var v = [], p = [], h = 0; h < l.length; h++) {
      for (var d = a(0, 0), x = a(0, 0), g = 0; g < o.length; g++)
        d = t(d, n(o[g], a(Math.cos(-g * l[h]), Math.sin(-g * l[h]))));
      for (var y = 0; y < s.length; y++)
        x = t(x, n(s[y], a(Math.cos(-y * l[h]), Math.sin(-y * l[h]))));
      v.push(d), p.push(x);
    }
    for (var m = [], b = 0; b < v.length; b++)
      m.push(i(v[b], p[b]));
    return {
      h: m,
      w: l
    };
  }
  function c(o) {
    for (var s = [], l = 0; l < o; l++)
      s.push(l / o * Math.PI);
    return s;
  }
}), Yq = "reviver", Zq = ["classes"], K0 = /* @__PURE__ */ U(Yq, Zq, (r) => {
  var {
    classes: e
  } = r;
  return function(n, a) {
    var i = e[a && a.mathjs];
    return i && typeof i.fromJSON == "function" ? i.fromJSON(a) : a;
  };
}), Wq = "replacer", Kq = [], J0 = /* @__PURE__ */ U(Wq, Kq, () => function(e, t) {
  return typeof t == "number" && (!isFinite(t) || isNaN(t)) ? {
    mathjs: "number",
    value: String(t)
  } : t;
}), Jq = "12.4.3", _0 = /* @__PURE__ */ U("true", [], () => !0), $0 = /* @__PURE__ */ U("false", [], () => !1), ev = /* @__PURE__ */ U("null", [], () => null), rv = /* @__PURE__ */ kt("Infinity", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1 / 0) : 1 / 0;
}), tv = /* @__PURE__ */ kt("NaN", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(NaN) : NaN;
}), nv = /* @__PURE__ */ kt("pi", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? Nh(t) : q7;
}), av = /* @__PURE__ */ kt("tau", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? JF(t) : U7;
}), iv = /* @__PURE__ */ kt("e", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? WF(t) : k7;
}), ov = /* @__PURE__ */ kt("phi", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? KF(t) : X7;
}), sv = /* @__PURE__ */ kt("LN2", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(2).ln() : Math.LN2;
}), uv = /* @__PURE__ */ kt("LN10", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(10).ln() : Math.LN10;
}), cv = /* @__PURE__ */ kt("LOG2E", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1).div(new t(2).ln()) : Math.LOG2E;
}), lv = /* @__PURE__ */ kt("LOG10E", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(1).div(new t(10).ln()) : Math.LOG10E;
}), fv = /* @__PURE__ */ kt(
  // eslint-disable-line camelcase
  "SQRT1_2",
  ["config", "?BigNumber"],
  (r) => {
    var {
      config: e,
      BigNumber: t
    } = r;
    return e.number === "BigNumber" ? new t("0.5").sqrt() : Math.SQRT1_2;
  }
), vv = /* @__PURE__ */ kt("SQRT2", ["config", "?BigNumber"], (r) => {
  var {
    config: e,
    BigNumber: t
  } = r;
  return e.number === "BigNumber" ? new t(2).sqrt() : Math.SQRT2;
}), pv = /* @__PURE__ */ kt("i", ["Complex"], (r) => {
  var {
    Complex: e
  } = r;
  return e.I;
}), Rh = /* @__PURE__ */ U("PI", ["pi"], (r) => {
  var {
    pi: e
  } = r;
  return e;
}), Ih = /* @__PURE__ */ U("E", ["e"], (r) => {
  var {
    e
  } = r;
  return e;
}), dv = /* @__PURE__ */ U("version", [], () => Jq);
function kt(r, e, t) {
  return U(r, e, t, {
    recreateOnConfigChange: !0
  });
}
var mv = /* @__PURE__ */ Ge("speedOfLight", "299792458", "m s^-1"), hv = /* @__PURE__ */ Ge("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), gv = /* @__PURE__ */ Ge("planckConstant", "6.62607015e-34", "J s"), xv = /* @__PURE__ */ Ge("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), yv = /* @__PURE__ */ Ge("magneticConstant", "1.25663706212e-6", "N A^-2"), Av = /* @__PURE__ */ Ge("electricConstant", "8.8541878128e-12", "F m^-1"), bv = /* @__PURE__ */ Ge("vacuumImpedance", "376.730313667", "ohm"), wv = /* @__PURE__ */ Ge("coulomb", "8.987551792261171e9", "N m^2 C^-2"), Dv = /* @__PURE__ */ Ge("elementaryCharge", "1.602176634e-19", "C"), Cv = /* @__PURE__ */ Ge("bohrMagneton", "9.2740100783e-24", "J T^-1"), Ev = /* @__PURE__ */ Ge("conductanceQuantum", "7.748091729863649e-5", "S"), Nv = /* @__PURE__ */ Ge("inverseConductanceQuantum", "12906.403729652257", "ohm"), Bv = /* @__PURE__ */ Ge("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), Sv = /* @__PURE__ */ Ge("nuclearMagneton", "5.0507837461e-27", "J T^-1"), Pv = /* @__PURE__ */ Ge("klitzing", "25812.807459304513", "ohm"), Mv = /* @__PURE__ */ Ge("bohrRadius", "5.29177210903e-11", "m"), Fv = /* @__PURE__ */ Ge("classicalElectronRadius", "2.8179403262e-15", "m"), Tv = /* @__PURE__ */ Ge("electronMass", "9.1093837015e-31", "kg"), Ov = /* @__PURE__ */ Ge("fermiCoupling", "1.1663787e-5", "GeV^-2"), zv = fp("fineStructure", 0.0072973525693), Rv = /* @__PURE__ */ Ge("hartreeEnergy", "4.3597447222071e-18", "J"), Iv = /* @__PURE__ */ Ge("protonMass", "1.67262192369e-27", "kg"), Hv = /* @__PURE__ */ Ge("deuteronMass", "3.3435830926e-27", "kg"), Lv = /* @__PURE__ */ Ge("neutronMass", "1.6749271613e-27", "kg"), qv = /* @__PURE__ */ Ge("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), Uv = /* @__PURE__ */ Ge("rydberg", "10973731.568160", "m^-1"), kv = /* @__PURE__ */ Ge("thomsonCrossSection", "6.6524587321e-29", "m^2"), Xv = fp("weakMixingAngle", 0.2229), jv = fp("efimovFactor", 22.7), Gv = /* @__PURE__ */ Ge("atomicMass", "1.66053906660e-27", "kg"), Vv = /* @__PURE__ */ Ge("avogadro", "6.02214076e23", "mol^-1"), Qv = /* @__PURE__ */ Ge("boltzmann", "1.380649e-23", "J K^-1"), Yv = /* @__PURE__ */ Ge("faraday", "96485.33212331001", "C mol^-1"), Zv = /* @__PURE__ */ Ge("firstRadiation", "3.7417718521927573e-16", "W m^2"), Wv = /* @__PURE__ */ Ge("loschmidt", "2.686780111798444e25", "m^-3"), Kv = /* @__PURE__ */ Ge("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), Jv = /* @__PURE__ */ Ge("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), _v = /* @__PURE__ */ Ge("molarVolume", "0.022413969545014137", "m^3 mol^-1"), $v = fp("sackurTetrode", -1.16487052358), ep = /* @__PURE__ */ Ge("secondRadiation", "0.014387768775039337", "m K"), rp = /* @__PURE__ */ Ge("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), tp = /* @__PURE__ */ Ge("wienDisplacement", "2.897771955e-3", "m K"), np = /* @__PURE__ */ Ge("molarMass", "0.99999999965e-3", "kg mol^-1"), ap = /* @__PURE__ */ Ge("molarMassC12", "11.9999999958e-3", "kg mol^-1"), ip = /* @__PURE__ */ Ge("gravity", "9.80665", "m s^-2"), op = /* @__PURE__ */ Ge("planckLength", "1.616255e-35", "m"), sp = /* @__PURE__ */ Ge("planckMass", "2.176435e-8", "kg"), up = /* @__PURE__ */ Ge("planckTime", "5.391245e-44", "s"), cp = /* @__PURE__ */ Ge("planckCharge", "1.87554603778e-18", "C"), lp = /* @__PURE__ */ Ge("planckTemperature", "1.416785e+32", "K");
function Ge(r, e, t) {
  var n = ["config", "Unit", "BigNumber"];
  return U(r, n, (a) => {
    var {
      config: i,
      Unit: u,
      BigNumber: f
    } = a, c = i.number === "BigNumber" ? new f(e) : parseFloat(e), o = new u(c, t);
    return o.fixPrefix = !0, o;
  });
}
function fp(r, e) {
  var t = ["config", "BigNumber"];
  return U(r, t, (n) => {
    var {
      config: a,
      BigNumber: i
    } = n;
    return a.number === "BigNumber" ? new i(e) : e;
  });
}
var _q = "apply", $q = ["typed", "isInteger"], vp = /* @__PURE__ */ U(_q, $q, (r) => {
  var {
    typed: e,
    isInteger: t
  } = r, n = Di({
    typed: e,
    isInteger: t
  });
  return e("apply", {
    "...any": function(i) {
      var u = i[1];
      Xe(u) ? i[1] = u - 1 : Ue(u) && (i[1] = u.minus(1));
      try {
        return n.apply(null, i);
      } catch (f) {
        throw Et(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), eU = "column", rU = ["typed", "Index", "matrix", "range"], pp = /* @__PURE__ */ U(eU, rU, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r, i = go({
    typed: e,
    Index: t,
    matrix: n,
    range: a
  });
  return e("column", {
    "...any": function(f) {
      var c = f.length - 1, o = f[c];
      Xe(o) && (f[c] = o - 1);
      try {
        return i.apply(null, f);
      } catch (s) {
        throw Et(s);
      }
    }
  });
}, {
  isTransformFunction: !0
});
function Hh(r, e, t) {
  var n = r.filter(function(c) {
    return Ur(c) && !(c.name in e) && !t.has(c.name);
  })[0];
  if (!n)
    throw new Error('No undefined variable found in inline expression "' + r + '"');
  var a = n.name, i = /* @__PURE__ */ new Map(), u = new z2(t, i, /* @__PURE__ */ new Set([a])), f = r.compile();
  return function(o) {
    return i.set(a, o), f.evaluate(u);
  };
}
var tU = "filter", nU = ["typed"], dp = /* @__PURE__ */ U(tU, nU, (r) => {
  var {
    typed: e
  } = r;
  function t(a, i, u) {
    var f, c;
    return a[0] && (f = a[0].compile().evaluate(u)), a[1] && (Ur(a[1]) || Pa(a[1]) ? c = a[1].compile().evaluate(u) : c = Hh(a[1], i, u)), n(f, c);
  }
  t.rawArgs = !0;
  var n = e("filter", {
    "Array, function": Rw,
    "Matrix, function": function(i, u) {
      return i.create(Rw(i.toArray(), u));
    },
    "Array, RegExp": Is,
    "Matrix, RegExp": function(i, u) {
      return i.create(Is(i.toArray(), u));
    }
  });
  return t;
}, {
  isTransformFunction: !0
});
function Rw(r, e) {
  return nD(r, function(t, n, a) {
    return Ci(e, t, [n + 1], a, "filter");
  });
}
var aU = "forEach", iU = ["typed"], mp = /* @__PURE__ */ U(aU, iU, (r) => {
  var {
    typed: e
  } = r;
  function t(a, i, u) {
    var f, c;
    return a[0] && (f = a[0].compile().evaluate(u)), a[1] && (Ur(a[1]) || Pa(a[1]) ? c = a[1].compile().evaluate(u) : c = Hh(a[1], i, u)), n(f, c);
  }
  t.rawArgs = !0;
  var n = e("forEach", {
    "Array | Matrix, function": function(i, u) {
      var f = function c(o, s) {
        if (Array.isArray(o))
          wu(o, function(l, v) {
            c(l, s.concat(v + 1));
          });
        else
          return Ci(u, o, s, i, "forEach");
      };
      f(i.valueOf(), []);
    }
  });
  return t;
}, {
  isTransformFunction: !0
}), oU = "index", sU = ["Index", "getMatrixDataType"], hp = /* @__PURE__ */ U(oU, sU, (r) => {
  var {
    Index: e,
    getMatrixDataType: t
  } = r;
  return function() {
    for (var a = [], i = 0, u = arguments.length; i < u; i++) {
      var f = arguments[i];
      if (so(f))
        f.start--, f.end -= f.step > 0 ? 0 : 2;
      else if (f && f.isSet === !0)
        f = f.map(function(o) {
          return o - 1;
        });
      else if (ur(f) || Oe(f))
        t(f) !== "boolean" && (f = f.map(function(o) {
          return o - 1;
        }));
      else if (Xe(f))
        f--;
      else if (Ue(f))
        f = f.toNumber() - 1;
      else if (typeof f != "string")
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      a[i] = f;
    }
    var c = new e();
    return e.apply(c, a), c;
  };
}, {
  isTransformFunction: !0
}), uU = "map", cU = ["typed"], gp = /* @__PURE__ */ U(uU, cU, (r) => {
  var {
    typed: e
  } = r;
  function t(a, i, u) {
    var f, c;
    return a[0] && (f = a[0].compile().evaluate(u)), a[1] && (Ur(a[1]) || Pa(a[1]) ? c = a[1].compile().evaluate(u) : c = Hh(a[1], i, u)), n(f, c);
  }
  t.rawArgs = !0;
  var n = e("map", {
    "Array, function": function(i, u) {
      return Iw(i, u, i);
    },
    "Matrix, function": function(i, u) {
      return i.create(Iw(i.valueOf(), u, i));
    }
  });
  return t;
}, {
  isTransformFunction: !0
});
function Iw(r, e, t) {
  function n(a, i) {
    return Array.isArray(a) ? Rn(a, function(u, f) {
      return n(u, i.concat(f + 1));
    }) : Ci(e, a, i, t, "map");
  }
  return n(r, []);
}
function sa(r) {
  if (r.length === 2 && Tt(r[0])) {
    r = r.slice();
    var e = r[1];
    Xe(e) ? r[1] = e - 1 : Ue(e) && (r[1] = e.minus(1));
  }
  return r;
}
var lU = "max", fU = ["typed", "config", "numeric", "larger"], xp = /* @__PURE__ */ U(lU, fU, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    larger: a
  } = r, i = Eo({
    typed: e,
    config: t,
    numeric: n,
    larger: a
  });
  return e("max", {
    "...any": function(f) {
      f = sa(f);
      try {
        return i.apply(null, f);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), vU = "mean", pU = ["typed", "add", "divide"], yp = /* @__PURE__ */ U(vU, pU, (r) => {
  var {
    typed: e,
    add: t,
    divide: n
  } = r, a = Po({
    typed: e,
    add: t,
    divide: n
  });
  return e("mean", {
    "...any": function(u) {
      u = sa(u);
      try {
        return a.apply(null, u);
      } catch (f) {
        throw Et(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), dU = "min", mU = ["typed", "config", "numeric", "smaller"], Ap = /* @__PURE__ */ U(dU, mU, (r) => {
  var {
    typed: e,
    config: t,
    numeric: n,
    smaller: a
  } = r, i = No({
    typed: e,
    config: t,
    numeric: n,
    smaller: a
  });
  return e("min", {
    "...any": function(f) {
      f = sa(f);
      try {
        return i.apply(null, f);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), hU = "range", gU = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], bp = /* @__PURE__ */ U(hU, gU, (r) => {
  var {
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    smaller: i,
    smallerEq: u,
    larger: f,
    largerEq: c,
    add: o,
    isPositive: s
  } = r, l = yo({
    typed: e,
    config: t,
    matrix: n,
    bignumber: a,
    smaller: i,
    smallerEq: u,
    larger: f,
    largerEq: c,
    add: o,
    isPositive: s
  });
  return e("range", {
    "...any": function(p) {
      var h = p.length - 1, d = p[h];
      return typeof d != "boolean" && p.push(!0), l.apply(null, p);
    }
  });
}, {
  isTransformFunction: !0
}), xU = "row", yU = ["typed", "Index", "matrix", "range"], wp = /* @__PURE__ */ U(xU, yU, (r) => {
  var {
    typed: e,
    Index: t,
    matrix: n,
    range: a
  } = r, i = Ao({
    typed: e,
    Index: t,
    matrix: n,
    range: a
  });
  return e("row", {
    "...any": function(f) {
      var c = f.length - 1, o = f[c];
      Xe(o) && (f[c] = o - 1);
      try {
        return i.apply(null, f);
      } catch (s) {
        throw Et(s);
      }
    }
  });
}, {
  isTransformFunction: !0
}), AU = "subset", bU = ["typed", "matrix", "zeros", "add"], Dp = /* @__PURE__ */ U(AU, bU, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r, i = bo({
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  });
  return e("subset", {
    "...any": function(f) {
      try {
        return i.apply(null, f);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), wU = "concat", DU = ["typed", "matrix", "isInteger"], Cp = /* @__PURE__ */ U(wU, DU, (r) => {
  var {
    typed: e,
    matrix: t,
    isInteger: n
  } = r, a = ho({
    typed: e,
    matrix: t,
    isInteger: n
  });
  return e("concat", {
    "...any": function(u) {
      var f = u.length - 1, c = u[f];
      Xe(c) ? u[f] = c - 1 : Ue(c) && (u[f] = c.minus(1));
      try {
        return a.apply(null, u);
      } catch (o) {
        throw Et(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), Hw = "diff", CU = ["typed", "matrix", "subtract", "number", "bignumber"], Ep = /* @__PURE__ */ U(Hw, CU, (r) => {
  var {
    typed: e,
    matrix: t,
    subtract: n,
    number: a,
    bignumber: i
  } = r, u = xo({
    typed: e,
    matrix: t,
    subtract: n,
    number: a,
    bignumber: i
  });
  return e(Hw, {
    "...any": function(c) {
      c = sa(c);
      try {
        return u.apply(null, c);
      } catch (o) {
        throw Et(o);
      }
    }
  });
}, {
  isTransformFunction: !0
}), EU = "std", NU = ["typed", "map", "sqrt", "variance"], Np = /* @__PURE__ */ U(EU, NU, (r) => {
  var {
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  } = r, i = To({
    typed: e,
    map: t,
    sqrt: n,
    variance: a
  });
  return e("std", {
    "...any": function(f) {
      f = sa(f);
      try {
        return i.apply(null, f);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), Lw = "sum", BU = ["typed", "config", "add", "numeric"], Bp = /* @__PURE__ */ U(Lw, BU, (r) => {
  var {
    typed: e,
    config: t,
    add: n,
    numeric: a
  } = r, i = Bo({
    typed: e,
    config: t,
    add: n,
    numeric: a
  });
  return e(Lw, {
    "...any": function(f) {
      f = sa(f);
      try {
        return i.apply(null, f);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), SU = "quantileSeq", PU = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger"], Sp = /* @__PURE__ */ U(SU, PU, (r) => {
  var {
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: u,
    partitionSelect: f,
    compare: c,
    isInteger: o,
    smaller: s,
    smallerEq: l,
    larger: v
  } = r, p = Fo({
    typed: e,
    bignumber: t,
    add: n,
    subtract: a,
    divide: i,
    multiply: u,
    partitionSelect: f,
    compare: c,
    isInteger: o,
    smaller: s,
    smallerEq: l,
    larger: v
  });
  return e("quantileSeq", {
    "Array | Matrix, number | BigNumber": p,
    "Array | Matrix, number | BigNumber, number": (d, x, g) => p(d, x, h(g)),
    "Array | Matrix, number | BigNumber, boolean": p,
    "Array | Matrix, number | BigNumber, boolean, number": (d, x, g, y) => p(d, x, g, h(y)),
    "Array | Matrix, Array | Matrix": p,
    "Array | Matrix, Array | Matrix, number": (d, x, g) => p(d, x, h(g)),
    "Array | Matrix, Array | Matrix, boolean": p,
    "Array | Matrix, Array | Matrix, boolean, number": (d, x, g, y) => p(d, x, g, h(y))
  });
  function h(d) {
    return sa([[], d])[1];
  }
}, {
  isTransformFunction: !0
}), qw = "cumsum", MU = ["typed", "add", "unaryPlus"], Pp = /* @__PURE__ */ U(qw, MU, (r) => {
  var {
    typed: e,
    add: t,
    unaryPlus: n
  } = r, a = So({
    typed: e,
    add: t,
    unaryPlus: n
  });
  return e(qw, {
    "...any": function(u) {
      if (u.length === 2 && Tt(u[0])) {
        var f = u[1];
        Xe(f) ? u[1] = f - 1 : Ue(f) && (u[1] = f.minus(1));
      }
      try {
        return a.apply(null, u);
      } catch (c) {
        throw Et(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), Uw = "variance", FU = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], Mp = /* @__PURE__ */ U(Uw, FU, (r) => {
  var {
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    apply: u,
    isNaN: f
  } = r, c = Mo({
    typed: e,
    add: t,
    subtract: n,
    multiply: a,
    divide: i,
    apply: u,
    isNaN: f
  });
  return e(Uw, {
    "...any": function(s) {
      s = sa(s);
      try {
        return c.apply(null, s);
      } catch (l) {
        throw Et(l);
      }
    }
  });
}, {
  isTransformFunction: !0
}), kw = "print", TU = ["typed", "matrix", "zeros", "add"], Fp = /* @__PURE__ */ U(kw, TU, (r) => {
  var {
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  } = r, i = wo({
    typed: e,
    matrix: t,
    zeros: n,
    add: a
  });
  return e(kw, {
    "string, Object | Array": function(c, o) {
      return i(u(c), o);
    },
    "string, Object | Array, number | Object": function(c, o, s) {
      return i(u(c), o, s);
    }
  });
  function u(f) {
    return f.replace(o4, (c) => {
      var o = c.slice(1).split("."), s = o.map(function(l) {
        return !isNaN(l) && l.length > 0 ? parseInt(l) - 1 : l;
      });
      return "$" + s.join(".");
    });
  }
}, {
  isTransformFunction: !0
}), OU = "and", zU = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], Tp = /* @__PURE__ */ U(OU, zU, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: u
  } = r, f = Co({
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: u
  });
  function c(o, s, l) {
    var v = o[0].compile().evaluate(l);
    if (!Tt(v) && !f(v, !0))
      return !1;
    var p = o[1].compile().evaluate(l);
    return f(v, p);
  }
  return c.rawArgs = !0, c;
}, {
  isTransformFunction: !0
}), RU = "or", IU = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Op = /* @__PURE__ */ U(RU, IU, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, u = mo({
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  });
  function f(c, o, s) {
    var l = c[0].compile().evaluate(s);
    if (!Tt(l) && u(l, !1))
      return !0;
    var v = c[1].compile().evaluate(s);
    return u(l, v);
  }
  return f.rawArgs = !0, f;
}, {
  isTransformFunction: !0
}), HU = "bitAnd", LU = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], zp = /* @__PURE__ */ U(HU, LU, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: u
  } = r, f = vo({
    typed: e,
    matrix: t,
    equalScalar: n,
    zeros: a,
    not: i,
    concat: u
  });
  function c(o, s, l) {
    var v = o[0].compile().evaluate(l);
    if (!Tt(v)) {
      if (isNaN(v))
        return NaN;
      if (v === 0 || v === !1)
        return 0;
    }
    var p = o[1].compile().evaluate(l);
    return f(v, p);
  }
  return c.rawArgs = !0, c;
}, {
  isTransformFunction: !0
}), qU = "bitOr", UU = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Rp = /* @__PURE__ */ U(qU, UU, (r) => {
  var {
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  } = r, u = po({
    typed: e,
    matrix: t,
    equalScalar: n,
    DenseMatrix: a,
    concat: i
  });
  function f(c, o, s) {
    var l = c[0].compile().evaluate(s);
    if (!Tt(l)) {
      if (isNaN(l))
        return NaN;
      if (l === -1)
        return -1;
      if (l === !0)
        return 1;
    }
    var v = c[1].compile().evaluate(s);
    return u(l, v);
  }
  return f.rawArgs = !0, f;
}, {
  isTransformFunction: !0
});
const kU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAbs: Ku,
  createAccessorNode: Rf,
  createAcos: Ql,
  createAcosh: Yl,
  createAcot: Zl,
  createAcoth: Wl,
  createAcsc: Kl,
  createAcsch: Jl,
  createAdd: Sf,
  createAddScalar: Ju,
  createAnd: Co,
  createAndTransform: Tp,
  createApply: Di,
  createApplyTransform: vp,
  createArg: Dc,
  createArrayNode: If,
  createAsec: _l,
  createAsech: $l,
  createAsin: ef,
  createAsinh: rf,
  createAssignmentNode: Hf,
  createAtan: tf,
  createAtan2: nf,
  createAtanh: af,
  createAtomicMass: Gv,
  createAvogadro: Vv,
  createBellNumbers: H0,
  createBigNumberClass: gu,
  createBignumber: Uu,
  createBin: nl,
  createBitAnd: vo,
  createBitAndTransform: zp,
  createBitNot: bc,
  createBitOr: po,
  createBitOrTransform: Rp,
  createBitXor: wc,
  createBlockNode: Lf,
  createBohrMagneton: Cv,
  createBohrRadius: Mv,
  createBoltzmann: Qv,
  createBoolean: qu,
  createCatalan: L0,
  createCbrt: $u,
  createCeil: ec,
  createChain: c0,
  createChainClass: s0,
  createClassicalElectronRadius: Fv,
  createClone: Cu,
  createColumn: go,
  createColumnTransform: pp,
  createCombinations: E0,
  createCombinationsWithRep: N0,
  createCompare: Cl,
  createCompareNatural: El,
  createCompareText: Nl,
  createCompile: Jf,
  createComplex: ku,
  createComplexClass: xu,
  createComposition: q0,
  createConcat: ho,
  createConcatTransform: Cp,
  createConditionalNode: qf,
  createConductanceQuantum: Ev,
  createConj: Cc,
  createConstantNode: Uf,
  createCorr: C0,
  createCos: of,
  createCosh: sf,
  createCot: uf,
  createCoth: cf,
  createCoulomb: wv,
  createCount: Pc,
  createCreateUnit: Vl,
  createCross: Mc,
  createCsc: lf,
  createCsch: ff,
  createCtranspose: Yc,
  createCube: rc,
  createCumSum: So,
  createCumSumTransform: Pp,
  createDeepEqual: Ol,
  createDenseMatrixClass: Du,
  createDerivative: Q0,
  createDet: l0,
  createDeuteronMass: Hv,
  createDiag: Fc,
  createDiff: xo,
  createDiffTransform: Ep,
  createDistance: A0,
  createDivide: y0,
  createDivideScalar: cl,
  createDot: Ff,
  createDotDivide: hl,
  createDotMultiply: Ac,
  createDotPow: ml,
  createE: iv,
  createEfimovFactor: jv,
  createEigs: p0,
  createElectricConstant: Av,
  createElectronMass: Tv,
  createElementaryCharge: Dv,
  createEqual: Bl,
  createEqualScalar: Ru,
  createEqualText: Sl,
  createErf: _c,
  createEvaluate: _f,
  createExp: tc,
  createExpm: d0,
  createExpm1: nc,
  createFactorial: P0,
  createFalse: $0,
  createFaraday: Yv,
  createFermiCoupling: Ov,
  createFft: Wc,
  createFibonacciHeapClass: ql,
  createFilter: Tc,
  createFilterTransform: dp,
  createFineStructure: zv,
  createFirstRadiation: Zv,
  createFix: ac,
  createFlatten: Oc,
  createFloor: lo,
  createForEach: zc,
  createForEachTransform: mp,
  createFormat: tl,
  createFraction: Xu,
  createFractionClass: yu,
  createFreqz: W0,
  createFunctionAssignmentNode: kf,
  createFunctionNode: Wf,
  createGamma: B0,
  createGasConstant: Kv,
  createGcd: oc,
  createGetMatrixDataType: Rc,
  createGravitationConstant: hv,
  createGravity: ip,
  createHartreeEnergy: Rv,
  createHasNumericValue: Mu,
  createHelp: u0,
  createHelpClass: o0,
  createHex: il,
  createHypot: Pf,
  createI: pv,
  createIdentity: Ic,
  createIfft: Kc,
  createIm: Ec,
  createImmutableDenseMatrixClass: Hl,
  createIndex: Of,
  createIndexClass: Ll,
  createIndexNode: Xf,
  createIndexTransform: hp,
  createInfinity: rv,
  createIntersect: b0,
  createInv: f0,
  createInverseConductanceQuantum: Nv,
  createInvmod: yc,
  createIsInteger: Nu,
  createIsNaN: Ou,
  createIsNegative: Su,
  createIsNumeric: Pu,
  createIsPositive: Fu,
  createIsPrime: sl,
  createIsZero: Tu,
  createKldivergence: M0,
  createKlitzing: Pv,
  createKron: Hc,
  createLN10: uv,
  createLN2: sv,
  createLOG10E: lv,
  createLOG2E: cv,
  createLarger: Fl,
  createLargerEq: Tl,
  createLcm: uc,
  createLeafCount: U0,
  createLeftShift: bl,
  createLgamma: S0,
  createLog: vl,
  createLog10: cc,
  createLog1p: pl,
  createLog2: lc,
  createLoschmidt: Wv,
  createLsolve: gl,
  createLsolveAll: yl,
  createLup: r0,
  createLusolve: a0,
  createLyap: x0,
  createMad: D0,
  createMagneticConstant: yv,
  createMagneticFluxQuantum: Bv,
  createMap: Lc,
  createMapTransform: gp,
  createMatrix: ju,
  createMatrixClass: bu,
  createMatrixFromColumns: Qu,
  createMatrixFromFunction: Gu,
  createMatrixFromRows: Vu,
  createMax: Eo,
  createMaxTransform: xp,
  createMean: Po,
  createMeanTransform: yp,
  createMedian: w0,
  createMin: No,
  createMinTransform: Ap,
  createMod: fo,
  createMode: el,
  createMolarMass: np,
  createMolarMassC12: ap,
  createMolarPlanckConstant: Jv,
  createMolarVolume: _v,
  createMultinomial: F0,
  createMultiply: vc,
  createMultiplyScalar: fc,
  createNaN: tv,
  createNeutronMass: Lv,
  createNode: zf,
  createNorm: Mf,
  createNot: Bc,
  createNthRoot: pc,
  createNthRoots: dl,
  createNuclearMagneton: Sv,
  createNull: ev,
  createNumber: Hu,
  createNumeric: ul,
  createObjectNode: jf,
  createOct: al,
  createOnes: qc,
  createOperatorNode: Gf,
  createOr: mo,
  createOrTransform: Op,
  createParenthesisNode: Vf,
  createParse: Kf,
  createParser: e0,
  createParserClass: $f,
  createPartitionSelect: Rl,
  createPermutations: T0,
  createPhi: ov,
  createPi: nv,
  createPickRandom: O0,
  createPinv: v0,
  createPlanckCharge: cp,
  createPlanckConstant: gv,
  createPlanckLength: op,
  createPlanckMass: sp,
  createPlanckTemperature: lp,
  createPlanckTime: up,
  createPolynomialRoot: i0,
  createPow: ll,
  createPrint: wo,
  createPrintTransform: Fp,
  createProd: rl,
  createProtonMass: Iv,
  createQr: t0,
  createQuantileSeq: Fo,
  createQuantileSeqTransform: Sp,
  createQuantumOfCirculation: qv,
  createRandom: z0,
  createRandomInt: R0,
  createRange: yo,
  createRangeClass: Au,
  createRangeNode: Qf,
  createRangeTransform: bp,
  createRationalize: Y0,
  createRe: Nc,
  createReducedPlanckConstant: xv,
  createRelationalNode: Yf,
  createReplacer: J0,
  createReshape: Uc,
  createResize: kc,
  createResolve: G0,
  createResultSet: pu,
  createReviver: K0,
  createRightArithShift: wl,
  createRightLogShift: Dl,
  createRotate: Xc,
  createRotationMatrix: jc,
  createRound: fl,
  createRow: Ao,
  createRowTransform: wp,
  createRydberg: Uv,
  createSQRT1_2: fv,
  createSQRT2: vv,
  createSackurTetrode: $v,
  createSchur: g0,
  createSec: vf,
  createSech: pf,
  createSecondRadiation: ep,
  createSetCartesian: xf,
  createSetDifference: yf,
  createSetDistinct: Af,
  createSetIntersect: bf,
  createSetIsSubset: wf,
  createSetMultiplicity: Df,
  createSetPowerset: Cf,
  createSetSize: Ef,
  createSetSymDifference: Nf,
  createSetUnion: Bf,
  createSign: dc,
  createSimplify: k0,
  createSimplifyConstant: X0,
  createSimplifyCore: j0,
  createSin: df,
  createSinh: mf,
  createSize: Gc,
  createSlu: n0,
  createSmaller: Pl,
  createSmallerEq: Ml,
  createSolveODE: Jc,
  createSort: Il,
  createSpaClass: Ul,
  createSparse: Gl,
  createSparseMatrixClass: Iu,
  createSpeedOfLight: mv,
  createSplitUnit: Yu,
  createSqrt: mc,
  createSqrtm: m0,
  createSquare: hc,
  createSqueeze: Vc,
  createStd: To,
  createStdTransform: Np,
  createStefanBoltzmann: rp,
  createStirlingS2: I0,
  createString: Lu,
  createSubset: bo,
  createSubsetTransform: Dp,
  createSubtract: gc,
  createSubtractScalar: _u,
  createSum: Bo,
  createSumTransform: Bp,
  createSylvester: h0,
  createSymbolNode: Zf,
  createSymbolicEqual: V0,
  createTan: hf,
  createTanh: gf,
  createTau: av,
  createThomsonCrossSection: kv,
  createTo: ol,
  createTrace: Tf,
  createTranspose: Qc,
  createTrue: _0,
  createTypeOf: zu,
  createTyped: vu,
  createUnaryMinus: Zu,
  createUnaryPlus: Wu,
  createUnequal: zl,
  createUnitClass: Xl,
  createUnitFunction: jl,
  createUppercaseE: Ih,
  createUppercasePi: Rh,
  createUsolve: xl,
  createUsolveAll: Al,
  createVacuumImpedance: bv,
  createVariance: Mo,
  createVarianceTransform: Mp,
  createVersion: dv,
  createWeakMixingAngle: Xv,
  createWienDisplacement: tp,
  createXgcd: xc,
  createXor: Sc,
  createZeros: Zc,
  createZeta: $c,
  createZpk2tf: Z0
}, Symbol.toStringTag, { value: "Module" }));
var Ne = /* @__PURE__ */ gu({
  config: he
}), gr = /* @__PURE__ */ xu({}), Qm = /* @__PURE__ */ iv({
  BigNumber: Ne,
  config: he
}), m4 = /* @__PURE__ */ $0({}), h4 = /* @__PURE__ */ zv({
  BigNumber: Ne,
  config: he
}), ua = /* @__PURE__ */ yu({}), Lh = /* @__PURE__ */ pv({
  Complex: gr
}), g4 = /* @__PURE__ */ rv({
  BigNumber: Ne,
  config: he
}), x4 = /* @__PURE__ */ uv({
  BigNumber: Ne,
  config: he
}), y4 = /* @__PURE__ */ lv({
  BigNumber: Ne,
  config: he
}), Oo = /* @__PURE__ */ bu({}), A4 = /* @__PURE__ */ tv({
  BigNumber: Ne,
  config: he
}), b4 = /* @__PURE__ */ ev({}), w4 = /* @__PURE__ */ ov({
  BigNumber: Ne,
  config: he
}), D4 = /* @__PURE__ */ Au({}), qh = /* @__PURE__ */ pu({}), C4 = /* @__PURE__ */ fv({
  BigNumber: Ne,
  config: he
}), E4 = /* @__PURE__ */ $v({
  BigNumber: Ne,
  config: he
}), Uh = /* @__PURE__ */ av({
  BigNumber: Ne,
  config: he
}), N4 = /* @__PURE__ */ _0({}), B4 = /* @__PURE__ */ dv({}), Qe = /* @__PURE__ */ Du({
  Matrix: Oo
}), S4 = /* @__PURE__ */ jv({
  BigNumber: Ne,
  config: he
}), P4 = /* @__PURE__ */ sv({
  BigNumber: Ne,
  config: he
}), _s = /* @__PURE__ */ nv({
  BigNumber: Ne,
  config: he
}), M4 = /* @__PURE__ */ J0({}), F4 = /* @__PURE__ */ vv({
  BigNumber: Ne,
  config: he
}), Z = /* @__PURE__ */ vu({
  BigNumber: Ne,
  Complex: gr,
  DenseMatrix: Qe,
  Fraction: ua
}), Ip = /* @__PURE__ */ Wu({
  BigNumber: Ne,
  config: he,
  typed: Z
}), T4 = /* @__PURE__ */ Xv({
  BigNumber: Ne,
  config: he
}), dt = /* @__PURE__ */ Ku({
  typed: Z
}), O4 = /* @__PURE__ */ Ql({
  Complex: gr,
  config: he,
  typed: Z
}), z4 = /* @__PURE__ */ Zl({
  BigNumber: Ne,
  typed: Z
}), R4 = /* @__PURE__ */ Kl({
  BigNumber: Ne,
  Complex: gr,
  config: he,
  typed: Z
}), kr = /* @__PURE__ */ Ju({
  typed: Z
}), I4 = /* @__PURE__ */ Dc({
  typed: Z
}), H4 = /* @__PURE__ */ $l({
  BigNumber: Ne,
  Complex: gr,
  config: he,
  typed: Z
}), L4 = /* @__PURE__ */ rf({
  typed: Z
}), kh = /* @__PURE__ */ tf({
  typed: Z
}), q4 = /* @__PURE__ */ af({
  Complex: gr,
  config: he,
  typed: Z
}), qr = /* @__PURE__ */ Uu({
  BigNumber: Ne,
  typed: Z
}), U4 = /* @__PURE__ */ bc({
  typed: Z
}), k4 = /* @__PURE__ */ qu({
  typed: Z
}), X4 = /* @__PURE__ */ Cu({
  typed: Z
}), zo = /* @__PURE__ */ E0({
  typed: Z
}), Ro = /* @__PURE__ */ ku({
  Complex: gr,
  typed: Z
}), ca = /* @__PURE__ */ Cc({
  typed: Z
}), Hp = /* @__PURE__ */ of({
  typed: Z
}), j4 = /* @__PURE__ */ uf({
  BigNumber: Ne,
  typed: Z
}), G4 = /* @__PURE__ */ lf({
  BigNumber: Ne,
  typed: Z
}), V4 = /* @__PURE__ */ rc({
  typed: Z
}), _e = /* @__PURE__ */ Ru({
  config: he,
  typed: Z
}), Q4 = /* @__PURE__ */ _c({
  typed: Z
}), Xh = /* @__PURE__ */ tc({
  typed: Z
}), Y4 = /* @__PURE__ */ nc({
  Complex: gr,
  typed: Z
}), Z4 = /* @__PURE__ */ Tc({
  typed: Z
}), W4 = /* @__PURE__ */ zc({
  typed: Z
}), Ni = /* @__PURE__ */ tl({
  typed: Z
}), Lp = /* @__PURE__ */ Rc({
  typed: Z
}), K4 = /* @__PURE__ */ il({
  format: Ni,
  typed: Z
}), qp = /* @__PURE__ */ Ec({
  typed: Z
}), bt = /* @__PURE__ */ Nu({
  typed: Z
}), kn = /* @__PURE__ */ Su({
  typed: Z
}), la = /* @__PURE__ */ Fu({
  typed: Z
}), _t = /* @__PURE__ */ Tu({
  typed: Z
}), J4 = /* @__PURE__ */ cv({
  BigNumber: Ne,
  config: he
}), _4 = /* @__PURE__ */ S0({
  Complex: gr,
  typed: Z
}), $4 = /* @__PURE__ */ cc({
  Complex: gr,
  config: he,
  typed: Z
}), jh = /* @__PURE__ */ lc({
  Complex: gr,
  config: he,
  typed: Z
}), fa = /* @__PURE__ */ Lc({
  typed: Z
}), Or = /* @__PURE__ */ fc({
  typed: Z
}), ao = /* @__PURE__ */ Bc({
  typed: Z
}), Cn = /* @__PURE__ */ Hu({
  typed: Z
}), eC = /* @__PURE__ */ al({
  format: Ni,
  typed: Z
}), rC = /* @__PURE__ */ O0({
  config: he,
  typed: Z
}), tC = /* @__PURE__ */ wo({
  typed: Z
}), nC = /* @__PURE__ */ z0({
  config: he,
  typed: Z
}), Up = /* @__PURE__ */ Nc({
  typed: Z
}), aC = /* @__PURE__ */ vf({
  BigNumber: Ne,
  typed: Z
}), Gh = /* @__PURE__ */ dc({
  BigNumber: Ne,
  Fraction: ua,
  complex: Ro,
  typed: Z
}), Io = /* @__PURE__ */ df({
  typed: Z
}), En = /* @__PURE__ */ Iu({
  Matrix: Oo,
  equalScalar: _e,
  typed: Z
}), iC = /* @__PURE__ */ Yu({
  typed: Z
}), oC = /* @__PURE__ */ hc({
  typed: Z
}), sC = /* @__PURE__ */ Lu({
  typed: Z
}), Xt = /* @__PURE__ */ _u({
  typed: Z
}), uC = /* @__PURE__ */ hf({
  typed: Z
}), Vh = /* @__PURE__ */ zu({
  typed: Z
}), cC = /* @__PURE__ */ Yl({
  Complex: gr,
  config: he,
  typed: Z
}), lC = /* @__PURE__ */ Jl({
  BigNumber: Ne,
  typed: Z
}), kp = /* @__PURE__ */ Di({
  isInteger: bt,
  typed: Z
}), fC = /* @__PURE__ */ _l({
  BigNumber: Ne,
  Complex: gr,
  config: he,
  typed: Z
}), vC = /* @__PURE__ */ nl({
  format: Ni,
  typed: Z
}), pC = /* @__PURE__ */ N0({
  typed: Z
}), dC = /* @__PURE__ */ sf({
  typed: Z
}), mC = /* @__PURE__ */ ff({
  BigNumber: Ne,
  typed: Z
}), Bi = /* @__PURE__ */ Ou({
  typed: Z
}), hC = /* @__PURE__ */ sl({
  typed: Z
}), gC = /* @__PURE__ */ R0({
  config: he,
  typed: Z
}), xC = /* @__PURE__ */ pf({
  BigNumber: Ne,
  typed: Z
}), yC = /* @__PURE__ */ mf({
  typed: Z
}), AC = /* @__PURE__ */ Gl({
  SparseMatrix: En,
  typed: Z
}), $t = /* @__PURE__ */ mc({
  Complex: gr,
  config: he,
  typed: Z
}), bC = /* @__PURE__ */ gf({
  typed: Z
}), vn = /* @__PURE__ */ Zu({
  typed: Z
}), wC = /* @__PURE__ */ Wl({
  BigNumber: Ne,
  Complex: gr,
  config: he,
  typed: Z
}), DC = /* @__PURE__ */ cf({
  BigNumber: Ne,
  typed: Z
}), Ta = /* @__PURE__ */ Xu({
  Fraction: ua,
  typed: Z
}), va = /* @__PURE__ */ Pu({
  typed: Z
}), De = /* @__PURE__ */ ju({
  DenseMatrix: Qe,
  Matrix: Oo,
  SparseMatrix: En,
  typed: Z
}), CC = /* @__PURE__ */ Gu({
  isZero: _t,
  matrix: De,
  typed: Z
}), EC = /* @__PURE__ */ el({
  isNaN: Bi,
  isNumeric: va,
  typed: Z
}), Kt = /* @__PURE__ */ ul({
  bignumber: qr,
  fraction: Ta,
  number: Cn
}), Qh = /* @__PURE__ */ rl({
  config: he,
  multiplyScalar: Or,
  numeric: Kt,
  typed: Z
}), Yh = /* @__PURE__ */ Uc({
  isInteger: bt,
  matrix: De,
  typed: Z
}), _r = /* @__PURE__ */ Gc({
  matrix: De,
  config: he,
  typed: Z
}), NC = /* @__PURE__ */ Vc({
  matrix: De,
  typed: Z
}), Si = /* @__PURE__ */ Qc({
  matrix: De,
  typed: Z
}), Zh = /* @__PURE__ */ xc({
  BigNumber: Ne,
  config: he,
  matrix: De,
  typed: Z
}), Kr = /* @__PURE__ */ Zc({
  BigNumber: Ne,
  config: he,
  matrix: De,
  typed: Z
}), BC = /* @__PURE__ */ ef({
  Complex: gr,
  config: he,
  typed: Z
}), Wh = /* @__PURE__ */ $u({
  BigNumber: Ne,
  Complex: gr,
  Fraction: ua,
  config: he,
  isNegative: kn,
  matrix: De,
  typed: Z,
  unaryMinus: vn
}), ir = /* @__PURE__ */ ho({
  isInteger: bt,
  matrix: De,
  typed: Z
}), SC = /* @__PURE__ */ Pc({
  prod: Qh,
  size: _r,
  typed: Z
}), Xp = /* @__PURE__ */ Yc({
  conj: ca,
  transpose: Si,
  typed: Z
}), Kh = /* @__PURE__ */ Fc({
  DenseMatrix: Qe,
  SparseMatrix: En,
  matrix: De,
  typed: Z
}), Nr = /* @__PURE__ */ cl({
  numeric: Kt,
  typed: Z
}), Pi = /* @__PURE__ */ hl({
  DenseMatrix: Qe,
  concat: ir,
  divideScalar: Nr,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), jt = /* @__PURE__ */ Bl({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), Mi = /* @__PURE__ */ Oc({
  matrix: De,
  typed: Z
}), PC = /* @__PURE__ */ Mu({
  isNumeric: va,
  typed: Z
}), Xn = /* @__PURE__ */ Ic({
  BigNumber: Ne,
  DenseMatrix: Qe,
  SparseMatrix: En,
  config: he,
  matrix: De,
  typed: Z
}), MC = /* @__PURE__ */ Hc({
  matrix: De,
  multiplyScalar: Or,
  typed: Z
}), Ho = /* @__PURE__ */ Tl({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  matrix: De,
  typed: Z
}), FC = /* @__PURE__ */ bl({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z,
  zeros: Kr
}), Jh = /* @__PURE__ */ gl({
  DenseMatrix: Qe,
  divideScalar: Nr,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  subtractScalar: Xt,
  typed: Z
}), jp = /* @__PURE__ */ Qu({
  flatten: Mi,
  matrix: De,
  size: _r,
  typed: Z
}), TC = /* @__PURE__ */ pc({
  BigNumber: Ne,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), OC = /* @__PURE__ */ qc({
  BigNumber: Ne,
  config: he,
  matrix: De,
  typed: Z
}), Gp = /* @__PURE__ */ t0({
  addScalar: kr,
  complex: Ro,
  conj: ca,
  divideScalar: Nr,
  equal: jt,
  identity: Xn,
  isZero: _t,
  matrix: De,
  multiplyScalar: Or,
  sign: Gh,
  sqrt: $t,
  subtractScalar: Xt,
  typed: Z,
  unaryMinus: vn,
  zeros: Kr
}), zC = /* @__PURE__ */ kc({
  config: he,
  matrix: De
}), RC = /* @__PURE__ */ wl({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z,
  zeros: Kr
}), Oa = /* @__PURE__ */ fl({
  BigNumber: Ne,
  DenseMatrix: Qe,
  config: he,
  equalScalar: _e,
  matrix: De,
  typed: Z,
  zeros: Kr
}), ut = /* @__PURE__ */ Pl({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  matrix: De,
  typed: Z
}), Br = /* @__PURE__ */ gc({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  subtractScalar: Xt,
  typed: Z,
  unaryMinus: vn
}), IC = /* @__PURE__ */ ol({
  concat: ir,
  matrix: De,
  typed: Z
}), HC = /* @__PURE__ */ zl({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), Vp = /* @__PURE__ */ xl({
  DenseMatrix: Qe,
  divideScalar: Nr,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  subtractScalar: Xt,
  typed: Z
}), LC = /* @__PURE__ */ Sc({
  DenseMatrix: Qe,
  concat: ir,
  matrix: De,
  typed: Z
}), We = /* @__PURE__ */ Sf({
  DenseMatrix: Qe,
  SparseMatrix: En,
  addScalar: kr,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), qC = /* @__PURE__ */ nf({
  BigNumber: Ne,
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), UC = /* @__PURE__ */ vo({
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), kC = /* @__PURE__ */ po({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), XC = /* @__PURE__ */ wc({
  DenseMatrix: Qe,
  concat: ir,
  matrix: De,
  typed: Z
}), jC = /* @__PURE__ */ L0({
  addScalar: kr,
  combinations: zo,
  divideScalar: Nr,
  isInteger: bt,
  isNegative: kn,
  multiplyScalar: Or,
  typed: Z
}), pa = /* @__PURE__ */ Cl({
  BigNumber: Ne,
  DenseMatrix: Qe,
  Fraction: ua,
  concat: ir,
  config: he,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), _h = /* @__PURE__ */ Nl({
  concat: ir,
  matrix: De,
  typed: Z
}), GC = /* @__PURE__ */ So({
  add: We,
  typed: Z,
  unaryPlus: Ip
}), Qp = /* @__PURE__ */ Ol({
  equal: jt,
  typed: Z
}), VC = /* @__PURE__ */ xo({
  matrix: De,
  number: Cn,
  subtract: Br,
  typed: Z
}), QC = /* @__PURE__ */ A0({
  abs: dt,
  addScalar: kr,
  deepEqual: Qp,
  divideScalar: Nr,
  multiplyScalar: Or,
  sqrt: $t,
  subtractScalar: Xt,
  typed: Z
}), Lo = /* @__PURE__ */ Ff({
  addScalar: kr,
  conj: ca,
  multiplyScalar: Or,
  size: _r,
  typed: Z
}), YC = /* @__PURE__ */ Sl({
  compareText: _h,
  isZero: _t,
  typed: Z
}), $h = /* @__PURE__ */ lo({
  DenseMatrix: Qe,
  config: he,
  equalScalar: _e,
  matrix: De,
  round: Oa,
  typed: Z,
  zeros: Kr
}), ZC = /* @__PURE__ */ oc({
  BigNumber: Ne,
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  equalScalar: _e,
  matrix: De,
  round: Oa,
  typed: Z,
  zeros: Kr
}), WC = /* @__PURE__ */ Pf({
  abs: dt,
  addScalar: kr,
  divideScalar: Nr,
  isPositive: la,
  multiplyScalar: Or,
  smaller: ut,
  sqrt: $t,
  typed: Z
}), eg = /* @__PURE__ */ Hl({
  DenseMatrix: Qe,
  smaller: ut
}), tt = /* @__PURE__ */ Ll({
  ImmutableDenseMatrix: eg,
  getMatrixDataType: Lp
}), ct = /* @__PURE__ */ Fl({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  matrix: De,
  typed: Z
}), Yp = /* @__PURE__ */ vl({
  Complex: gr,
  config: he,
  divideScalar: Nr,
  typed: Z
}), KC = /* @__PURE__ */ yl({
  DenseMatrix: Qe,
  divideScalar: Nr,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  subtractScalar: Xt,
  typed: Z
}), JC = /* @__PURE__ */ Vu({
  flatten: Mi,
  matrix: De,
  size: _r,
  typed: Z
}), _C = /* @__PURE__ */ No({
  config: he,
  numeric: Kt,
  smaller: ut,
  typed: Z
}), rg = /* @__PURE__ */ fo({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  equalScalar: _e,
  matrix: De,
  round: Oa,
  typed: Z,
  zeros: Kr
}), fr = /* @__PURE__ */ vc({
  addScalar: kr,
  dot: Lo,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  typed: Z
}), $C = /* @__PURE__ */ dl({
  Complex: gr,
  config: he,
  divideScalar: Nr,
  typed: Z
}), e8 = /* @__PURE__ */ mo({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), qo = /* @__PURE__ */ Rl({
  compare: pa,
  isNaN: Bi,
  isNumeric: va,
  typed: Z
}), r8 = /* @__PURE__ */ Dl({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z,
  zeros: Kr
}), tg = /* @__PURE__ */ n0({
  SparseMatrix: En,
  abs: dt,
  add: We,
  divideScalar: Nr,
  larger: ct,
  largerEq: Ho,
  multiply: fr,
  subtract: Br,
  transpose: Si,
  typed: Z
}), Rt = /* @__PURE__ */ bo({
  add: We,
  matrix: De,
  typed: Z,
  zeros: Kr
}), Zp = /* @__PURE__ */ Bo({
  add: We,
  config: he,
  numeric: Kt,
  typed: Z
}), t8 = /* @__PURE__ */ Tf({
  add: We,
  matrix: De,
  typed: Z
}), ng = /* @__PURE__ */ Al({
  DenseMatrix: Qe,
  divideScalar: Nr,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  subtractScalar: Xt,
  typed: Z
}), n8 = /* @__PURE__ */ Z0({
  Complex: gr,
  add: We,
  multiply: fr,
  number: Cn,
  typed: Z
}), Wp = /* @__PURE__ */ ec({
  DenseMatrix: Qe,
  config: he,
  equalScalar: _e,
  matrix: De,
  round: Oa,
  typed: Z,
  zeros: Kr
}), pn = /* @__PURE__ */ El({
  compare: pa,
  typed: Z
}), a8 = /* @__PURE__ */ q0({
  addScalar: kr,
  combinations: zo,
  isInteger: bt,
  isNegative: kn,
  isPositive: la,
  larger: ct,
  typed: Z
}), i8 = /* @__PURE__ */ Mc({
  matrix: De,
  multiply: fr,
  subtract: Br,
  typed: Z
}), ag = /* @__PURE__ */ l0({
  divideScalar: Nr,
  isZero: _t,
  matrix: De,
  multiply: fr,
  subtractScalar: Xt,
  typed: Z,
  unaryMinus: vn
}), o8 = /* @__PURE__ */ Ac({
  concat: ir,
  equalScalar: _e,
  matrix: De,
  multiplyScalar: Or,
  typed: Z
}), ig = /* @__PURE__ */ ql({
  larger: ct,
  smaller: ut
}), og = /* @__PURE__ */ ac({
  Complex: gr,
  DenseMatrix: Qe,
  ceil: Wp,
  equalScalar: _e,
  floor: $h,
  matrix: De,
  typed: Z,
  zeros: Kr
}), sg = /* @__PURE__ */ Of({
  Index: tt,
  typed: Z
}), s8 = /* @__PURE__ */ b0({
  abs: dt,
  add: We,
  addScalar: kr,
  config: he,
  divideScalar: Nr,
  equalScalar: _e,
  flatten: Mi,
  isNumeric: va,
  isZero: _t,
  matrix: De,
  multiply: fr,
  multiplyScalar: Or,
  smaller: ut,
  subtract: Br,
  typed: Z
}), u8 = /* @__PURE__ */ yc({
  BigNumber: Ne,
  add: We,
  config: he,
  equal: jt,
  isInteger: bt,
  mod: rg,
  smaller: ut,
  typed: Z,
  xgcd: Zh
}), c8 = /* @__PURE__ */ uc({
  concat: ir,
  equalScalar: _e,
  matrix: De,
  typed: Z
}), l8 = /* @__PURE__ */ pl({
  Complex: gr,
  config: he,
  divideScalar: Nr,
  log: Yp,
  typed: Z
}), Kp = /* @__PURE__ */ Eo({
  config: he,
  larger: ct,
  numeric: Kt,
  typed: Z
}), f8 = /* @__PURE__ */ xf({
  DenseMatrix: Qe,
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), v8 = /* @__PURE__ */ Af({
  DenseMatrix: Qe,
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), p8 = /* @__PURE__ */ wf({
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), d8 = /* @__PURE__ */ Cf({
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), Ca = /* @__PURE__ */ Ml({
  DenseMatrix: Qe,
  concat: ir,
  config: he,
  matrix: De,
  typed: Z
}), m8 = /* @__PURE__ */ Il({
  compare: pa,
  compareNatural: pn,
  matrix: De,
  typed: Z
}), h8 = /* @__PURE__ */ Co({
  concat: ir,
  equalScalar: _e,
  matrix: De,
  not: ao,
  typed: Z,
  zeros: Kr
}), Ea = /* @__PURE__ */ yo({
  bignumber: qr,
  matrix: De,
  add: We,
  config: he,
  isPositive: la,
  larger: ct,
  largerEq: Ho,
  smaller: ut,
  smallerEq: Ca,
  typed: Z
}), g8 = /* @__PURE__ */ Ao({
  Index: tt,
  matrix: De,
  range: Ea,
  typed: Z
}), ug = /* @__PURE__ */ yf({
  DenseMatrix: Qe,
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), x8 = /* @__PURE__ */ Df({
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), cg = /* @__PURE__ */ Nf({
  Index: tt,
  concat: ir,
  setDifference: ug,
  size: _r,
  subset: Rt,
  typed: Z
}), lg = /* @__PURE__ */ Ul({
  FibonacciHeap: ig,
  addScalar: kr,
  equalScalar: _e
}), fg = /* @__PURE__ */ go({
  Index: tt,
  matrix: De,
  range: Ea,
  typed: Z
}), da = /* @__PURE__ */ f0({
  abs: dt,
  addScalar: kr,
  det: ag,
  divideScalar: Nr,
  identity: Xn,
  matrix: De,
  multiply: fr,
  typed: Z,
  unaryMinus: vn
}), vg = /* @__PURE__ */ r0({
  DenseMatrix: Qe,
  Spa: lg,
  SparseMatrix: En,
  abs: dt,
  addScalar: kr,
  divideScalar: Nr,
  equalScalar: _e,
  larger: ct,
  matrix: De,
  multiplyScalar: Or,
  subtractScalar: Xt,
  typed: Z,
  unaryMinus: vn
}), y8 = /* @__PURE__ */ v0({
  Complex: gr,
  add: We,
  ctranspose: Xp,
  deepEqual: Qp,
  divideScalar: Nr,
  dot: Lo,
  dotDivide: Pi,
  equal: jt,
  inv: da,
  matrix: De,
  multiply: fr,
  typed: Z
}), Gt = /* @__PURE__ */ ll({
  Complex: gr,
  config: he,
  fraction: Ta,
  identity: Xn,
  inv: da,
  matrix: De,
  multiply: fr,
  number: Cn,
  typed: Z
}), pg = /* @__PURE__ */ bf({
  DenseMatrix: Qe,
  Index: tt,
  compareNatural: pn,
  size: _r,
  subset: Rt,
  typed: Z
}), A8 = /* @__PURE__ */ Bf({
  Index: tt,
  concat: ir,
  setIntersect: pg,
  setSymDifference: cg,
  size: _r,
  subset: Rt,
  typed: Z
}), b8 = /* @__PURE__ */ m0({
  abs: dt,
  add: We,
  identity: Xn,
  inv: da,
  map: fa,
  max: Kp,
  multiply: fr,
  size: _r,
  sqrt: $t,
  subtract: Br,
  typed: Z
}), He = /* @__PURE__ */ Xl({
  BigNumber: Ne,
  Complex: gr,
  Fraction: ua,
  abs: dt,
  addScalar: kr,
  config: he,
  divideScalar: Nr,
  equal: jt,
  fix: og,
  format: Ni,
  isNumeric: va,
  multiplyScalar: Or,
  number: Cn,
  pow: Gt,
  round: Oa,
  subtractScalar: Xt
}), w8 = /* @__PURE__ */ bv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), D8 = /* @__PURE__ */ tp({
  BigNumber: Ne,
  Unit: He,
  config: he
}), C8 = /* @__PURE__ */ Gv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), E8 = /* @__PURE__ */ Cv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), N8 = /* @__PURE__ */ Qv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), B8 = /* @__PURE__ */ Ev({
  BigNumber: Ne,
  Unit: He,
  config: he
}), S8 = /* @__PURE__ */ wv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), P8 = /* @__PURE__ */ Hv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), M8 = /* @__PURE__ */ ml({
  DenseMatrix: Qe,
  concat: ir,
  equalScalar: _e,
  matrix: De,
  pow: Gt,
  typed: Z
}), F8 = /* @__PURE__ */ Av({
  BigNumber: Ne,
  Unit: He,
  config: he
}), T8 = /* @__PURE__ */ Dv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), O8 = /* @__PURE__ */ d0({
  abs: dt,
  add: We,
  identity: Xn,
  inv: da,
  multiply: fr,
  typed: Z
}), z8 = /* @__PURE__ */ Yv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), dg = /* @__PURE__ */ Wc({
  addScalar: kr,
  ceil: Wp,
  conj: ca,
  divideScalar: Nr,
  dotDivide: Pi,
  exp: Xh,
  i: Lh,
  log2: jh,
  matrix: De,
  multiplyScalar: Or,
  pow: Gt,
  tau: Uh,
  typed: Z
}), Jp = /* @__PURE__ */ B0({
  BigNumber: Ne,
  Complex: gr,
  config: he,
  multiplyScalar: Or,
  pow: Gt,
  typed: Z
}), R8 = /* @__PURE__ */ hv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), I8 = /* @__PURE__ */ Rv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), H8 = /* @__PURE__ */ Kc({
  conj: ca,
  dotDivide: Pi,
  fft: dg,
  typed: Z
}), L8 = /* @__PURE__ */ Pv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), q8 = /* @__PURE__ */ Wv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), U8 = /* @__PURE__ */ yv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), k8 = /* @__PURE__ */ np({
  BigNumber: Ne,
  Unit: He,
  config: he
}), X8 = /* @__PURE__ */ Jv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), j8 = /* @__PURE__ */ Lv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), G8 = /* @__PURE__ */ Sv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), V8 = /* @__PURE__ */ cp({
  BigNumber: Ne,
  Unit: He,
  config: he
}), Q8 = /* @__PURE__ */ op({
  BigNumber: Ne,
  Unit: He,
  config: he
}), Y8 = /* @__PURE__ */ lp({
  BigNumber: Ne,
  Unit: He,
  config: he
}), Z8 = /* @__PURE__ */ Iv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), W8 = /* @__PURE__ */ qv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), K8 = /* @__PURE__ */ xv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), J8 = /* @__PURE__ */ Uv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), _8 = /* @__PURE__ */ ep({
  BigNumber: Ne,
  Unit: He,
  config: he
}), $8 = /* @__PURE__ */ mv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), eE = /* @__PURE__ */ rp({
  BigNumber: Ne,
  Unit: He,
  config: he
}), rE = /* @__PURE__ */ kv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), tE = /* @__PURE__ */ Vv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), nE = /* @__PURE__ */ Mv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), aE = /* @__PURE__ */ Vl({
  Unit: He,
  typed: Z
}), Vr = /* @__PURE__ */ y0({
  divideScalar: Nr,
  equalScalar: _e,
  inv: da,
  matrix: De,
  multiply: fr,
  typed: Z
}), iE = /* @__PURE__ */ Tv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), Fi = /* @__PURE__ */ P0({
  gamma: Jp,
  typed: Z
}), oE = /* @__PURE__ */ Zv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), sE = /* @__PURE__ */ ip({
  BigNumber: Ne,
  Unit: He,
  config: he
}), uE = /* @__PURE__ */ Nv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), mg = /* @__PURE__ */ a0({
  DenseMatrix: Qe,
  lsolve: Jh,
  lup: vg,
  matrix: De,
  slu: tg,
  typed: Z,
  usolve: Vp
}), cE = /* @__PURE__ */ Bv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), lE = /* @__PURE__ */ ap({
  BigNumber: Ne,
  Unit: He,
  config: he
}), fE = /* @__PURE__ */ F0({
  add: We,
  divide: Vr,
  factorial: Fi,
  isInteger: bt,
  isPositive: la,
  multiply: fr,
  typed: Z
}), vE = /* @__PURE__ */ T0({
  factorial: Fi,
  typed: Z
}), pE = /* @__PURE__ */ sp({
  BigNumber: Ne,
  Unit: He,
  config: he
}), dE = /* @__PURE__ */ i0({
  add: We,
  cbrt: Wh,
  divide: Vr,
  equalScalar: _e,
  im: qp,
  isZero: _t,
  multiply: fr,
  re: Up,
  sqrt: $t,
  subtract: Br,
  typeOf: Vh,
  typed: Z,
  unaryMinus: vn
}), mE = /* @__PURE__ */ Ef({
  compareNatural: pn,
  typed: Z
}), hE = /* @__PURE__ */ Jc({
  abs: dt,
  add: We,
  bignumber: qr,
  divide: Vr,
  isNegative: kn,
  isPositive: la,
  larger: ct,
  map: fa,
  matrix: De,
  max: Kp,
  multiply: fr,
  smaller: ut,
  subtract: Br,
  typed: Z,
  unaryMinus: vn
}), hg = /* @__PURE__ */ I0({
  bignumber: qr,
  addScalar: kr,
  combinations: zo,
  divideScalar: Nr,
  factorial: Fi,
  isInteger: bt,
  isNegative: kn,
  larger: ct,
  multiplyScalar: Or,
  number: Cn,
  pow: Gt,
  subtractScalar: Xt,
  typed: Z
}), gE = /* @__PURE__ */ jl({
  Unit: He,
  typed: Z
}), xE = /* @__PURE__ */ H0({
  addScalar: kr,
  isInteger: bt,
  isNegative: kn,
  stirlingS2: hg,
  typed: Z
}), gg = /* @__PURE__ */ p0({
  abs: dt,
  add: We,
  addScalar: kr,
  atan: kh,
  bignumber: qr,
  column: fg,
  complex: Ro,
  config: he,
  cos: Hp,
  diag: Kh,
  divideScalar: Nr,
  dot: Lo,
  equal: jt,
  flatten: Mi,
  im: qp,
  inv: da,
  larger: ct,
  matrix: De,
  matrixFromColumns: jp,
  multiply: fr,
  multiplyScalar: Or,
  number: Cn,
  qr: Gp,
  re: Up,
  reshape: Yh,
  sin: Io,
  size: _r,
  smaller: ut,
  sqrt: $t,
  subtract: Br,
  typed: Z,
  usolve: Vp,
  usolveAll: ng
}), yE = /* @__PURE__ */ Ov({
  BigNumber: Ne,
  Unit: He,
  config: he
}), AE = /* @__PURE__ */ Kv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), bE = /* @__PURE__ */ M0({
  divide: Vr,
  dotDivide: Pi,
  isNumeric: va,
  log: Yp,
  map: fa,
  matrix: De,
  multiply: fr,
  sum: Zp,
  typed: Z
}), xg = /* @__PURE__ */ Po({
  add: We,
  divide: Vr,
  typed: Z
}), wE = /* @__PURE__ */ _v({
  BigNumber: Ne,
  Unit: He,
  config: he
}), DE = /* @__PURE__ */ gv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), CE = /* @__PURE__ */ Fo({
  bignumber: qr,
  add: We,
  compare: pa,
  divide: Vr,
  isInteger: bt,
  larger: ct,
  multiply: fr,
  partitionSelect: qo,
  smaller: ut,
  smallerEq: Ca,
  subtract: Br,
  typed: Z
}), _p = /* @__PURE__ */ Mo({
  add: We,
  apply: kp,
  divide: Vr,
  isNaN: Bi,
  multiply: fr,
  subtract: Br,
  typed: Z
}), EE = /* @__PURE__ */ Fv({
  BigNumber: Ne,
  Unit: He,
  config: he
}), yg = /* @__PURE__ */ w0({
  add: We,
  compare: pa,
  divide: Vr,
  partitionSelect: qo,
  typed: Z
}), NE = /* @__PURE__ */ C0({
  add: We,
  divide: Vr,
  matrix: De,
  mean: xg,
  multiply: fr,
  pow: Gt,
  sqrt: $t,
  subtract: Br,
  sum: Zp,
  typed: Z
}), BE = /* @__PURE__ */ W0({
  Complex: gr,
  add: We,
  divide: Vr,
  matrix: De,
  multiply: fr,
  typed: Z
}), SE = /* @__PURE__ */ D0({
  abs: dt,
  map: fa,
  median: yg,
  subtract: Br,
  typed: Z
}), PE = /* @__PURE__ */ To({
  map: fa,
  sqrt: $t,
  typed: Z,
  variance: _p
}), ME = /* @__PURE__ */ $c({
  BigNumber: Ne,
  Complex: gr,
  add: We,
  config: he,
  divide: Vr,
  equal: jt,
  factorial: Fi,
  gamma: Jp,
  isNegative: kn,
  multiply: fr,
  pi: _s,
  pow: Gt,
  sin: Io,
  smallerEq: Ca,
  subtract: Br,
  typed: Z
}), $p = /* @__PURE__ */ Mf({
  abs: dt,
  add: We,
  conj: ca,
  ctranspose: Xp,
  eigs: gg,
  equalScalar: _e,
  larger: ct,
  matrix: De,
  multiply: fr,
  pow: Gt,
  smaller: ut,
  sqrt: $t,
  typed: Z
}), Ag = /* @__PURE__ */ jc({
  BigNumber: Ne,
  DenseMatrix: Qe,
  SparseMatrix: En,
  addScalar: kr,
  config: he,
  cos: Hp,
  matrix: De,
  multiplyScalar: Or,
  norm: $p,
  sin: Io,
  typed: Z,
  unaryMinus: vn
}), FE = /* @__PURE__ */ up({
  BigNumber: Ne,
  Unit: He,
  config: he
}), bg = /* @__PURE__ */ g0({
  identity: Xn,
  matrix: De,
  multiply: fr,
  norm: $p,
  qr: Gp,
  subtract: Br,
  typed: Z
}), TE = /* @__PURE__ */ Xc({
  multiply: fr,
  rotationMatrix: Ag,
  typed: Z
}), wg = /* @__PURE__ */ h0({
  abs: dt,
  add: We,
  concat: ir,
  identity: Xn,
  index: sg,
  lusolve: mg,
  matrix: De,
  matrixFromColumns: jp,
  multiply: fr,
  range: Ea,
  schur: bg,
  subset: Rt,
  subtract: Br,
  transpose: Si,
  typed: Z
}), OE = /* @__PURE__ */ x0({
  matrix: De,
  multiply: fr,
  sylvester: wg,
  transpose: Si,
  typed: Z
}), Ti = {}, Oi = {}, zE = {}, it = zf({
  mathWithTransform: Oi
}), za = jf({
  Node: it
}), Nn = Gf({
  Node: it
}), ma = Vf({
  Node: it
}), Dg = Yf({
  Node: it
}), Ra = If({
  Node: it
}), Cg = Lf({
  Node: it,
  ResultSet: qh
}), Eg = qf({
  Node: it
}), jn = Uf({
  Node: it
}), Ng = Qf({
  Node: it
}), RE = K0({
  classes: zE
}), ed = s0({
  math: Ti,
  typed: Z
}), Bg = kf({
  Node: it,
  typed: Z
}), IE = c0({
  Chain: ed,
  typed: Z
}), Ia = Xf({
  Node: it,
  size: _r
}), Ha = Rf({
  Node: it,
  subset: Rt
}), Sg = Hf({
  matrix: De,
  Node: it,
  subset: Rt
}), Gn = Zf({
  Unit: He,
  Node: it,
  math: Ti
}), Vn = Wf({
  Node: it,
  SymbolNode: Gn,
  math: Ti
}), dn = Kf({
  AccessorNode: Ha,
  ArrayNode: Ra,
  AssignmentNode: Sg,
  BlockNode: Cg,
  ConditionalNode: Eg,
  ConstantNode: jn,
  FunctionAssignmentNode: Bg,
  FunctionNode: Vn,
  IndexNode: Ia,
  ObjectNode: za,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  RangeNode: Ng,
  RelationalNode: Dg,
  SymbolNode: Gn,
  config: he,
  numeric: Kt,
  typed: Z
}), Pg = G0({
  ConstantNode: jn,
  FunctionNode: Vn,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  parse: dn,
  typed: Z
}), rd = X0({
  bignumber: qr,
  fraction: Ta,
  AccessorNode: Ha,
  ArrayNode: Ra,
  ConstantNode: jn,
  FunctionNode: Vn,
  IndexNode: Ia,
  ObjectNode: za,
  OperatorNode: Nn,
  SymbolNode: Gn,
  config: he,
  mathWithTransform: Oi,
  matrix: De,
  typed: Z
}), HE = Jf({
  parse: dn,
  typed: Z
}), td = j0({
  AccessorNode: Ha,
  ArrayNode: Ra,
  ConstantNode: jn,
  FunctionNode: Vn,
  IndexNode: Ia,
  ObjectNode: za,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  SymbolNode: Gn,
  add: We,
  divide: Vr,
  equal: jt,
  isZero: _t,
  multiply: fr,
  parse: dn,
  pow: Gt,
  subtract: Br,
  typed: Z
}), nd = _f({
  parse: dn,
  typed: Z
}), Mg = o0({
  evaluate: nd
}), Fg = $f({
  evaluate: nd
}), Uo = k0({
  bignumber: qr,
  fraction: Ta,
  AccessorNode: Ha,
  ArrayNode: Ra,
  ConstantNode: jn,
  FunctionNode: Vn,
  IndexNode: Ia,
  ObjectNode: za,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  SymbolNode: Gn,
  add: We,
  config: he,
  divide: Vr,
  equal: jt,
  isZero: _t,
  mathWithTransform: Oi,
  matrix: De,
  multiply: fr,
  parse: dn,
  pow: Gt,
  resolve: Pg,
  simplifyConstant: rd,
  simplifyCore: td,
  subtract: Br,
  typed: Z
}), LE = V0({
  OperatorNode: Nn,
  parse: dn,
  simplify: Uo,
  typed: Z
}), qE = U0({
  parse: dn,
  typed: Z
}), UE = e0({
  Parser: Fg,
  typed: Z
}), kE = Y0({
  bignumber: qr,
  fraction: Ta,
  AccessorNode: Ha,
  ArrayNode: Ra,
  ConstantNode: jn,
  FunctionNode: Vn,
  IndexNode: Ia,
  ObjectNode: za,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  SymbolNode: Gn,
  add: We,
  config: he,
  divide: Vr,
  equal: jt,
  isZero: _t,
  mathWithTransform: Oi,
  matrix: De,
  multiply: fr,
  parse: dn,
  pow: Gt,
  simplify: Uo,
  simplifyConstant: rd,
  simplifyCore: td,
  subtract: Br,
  typed: Z
}), XE = Q0({
  ConstantNode: jn,
  FunctionNode: Vn,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  SymbolNode: Gn,
  config: he,
  equal: jt,
  isZero: _t,
  numeric: Kt,
  parse: dn,
  simplify: Uo,
  typed: Z
}), jE = u0({
  Help: Mg,
  mathWithTransform: Oi,
  typed: Z
});
Lr(Ti, {
  e: Qm,
  false: m4,
  fineStructure: h4,
  i: Lh,
  Infinity: g4,
  LN10: x4,
  LOG10E: y4,
  NaN: A4,
  null: b4,
  phi: w4,
  SQRT1_2: C4,
  sackurTetrode: E4,
  tau: Uh,
  true: N4,
  E: Qm,
  version: B4,
  efimovFactor: S4,
  LN2: P4,
  pi: _s,
  replacer: M4,
  reviver: RE,
  SQRT2: F4,
  typed: Z,
  unaryPlus: Ip,
  PI: _s,
  weakMixingAngle: T4,
  abs: dt,
  acos: O4,
  acot: z4,
  acsc: R4,
  addScalar: kr,
  arg: I4,
  asech: H4,
  asinh: L4,
  atan: kh,
  atanh: q4,
  bignumber: qr,
  bitNot: U4,
  boolean: k4,
  clone: X4,
  combinations: zo,
  complex: Ro,
  conj: ca,
  cos: Hp,
  cot: j4,
  csc: G4,
  cube: V4,
  equalScalar: _e,
  erf: Q4,
  exp: Xh,
  expm1: Y4,
  filter: Z4,
  forEach: W4,
  format: Ni,
  getMatrixDataType: Lp,
  hex: K4,
  im: qp,
  isInteger: bt,
  isNegative: kn,
  isPositive: la,
  isZero: _t,
  LOG2E: J4,
  lgamma: _4,
  log10: $4,
  log2: jh,
  map: fa,
  multiplyScalar: Or,
  not: ao,
  number: Cn,
  oct: eC,
  pickRandom: rC,
  print: tC,
  random: nC,
  re: Up,
  sec: aC,
  sign: Gh,
  sin: Io,
  splitUnit: iC,
  square: oC,
  string: sC,
  subtractScalar: Xt,
  tan: uC,
  typeOf: Vh,
  acosh: cC,
  acsch: lC,
  apply: kp,
  asec: fC,
  bin: vC,
  chain: IE,
  combinationsWithRep: pC,
  cosh: dC,
  csch: mC,
  isNaN: Bi,
  isPrime: hC,
  randomInt: gC,
  sech: xC,
  sinh: yC,
  sparse: AC,
  sqrt: $t,
  tanh: bC,
  unaryMinus: vn,
  acoth: wC,
  coth: DC,
  fraction: Ta,
  isNumeric: va,
  matrix: De,
  matrixFromFunction: CC,
  mode: EC,
  numeric: Kt,
  prod: Qh,
  reshape: Yh,
  size: _r,
  squeeze: NC,
  transpose: Si,
  xgcd: Zh,
  zeros: Kr,
  asin: BC,
  cbrt: Wh,
  concat: ir,
  count: SC,
  ctranspose: Xp,
  diag: Kh,
  divideScalar: Nr,
  dotDivide: Pi,
  equal: jt,
  flatten: Mi,
  hasNumericValue: PC,
  identity: Xn,
  kron: MC,
  largerEq: Ho,
  leftShift: FC,
  lsolve: Jh,
  matrixFromColumns: jp,
  nthRoot: TC,
  ones: OC,
  qr: Gp,
  resize: zC,
  rightArithShift: RC,
  round: Oa,
  smaller: ut,
  subtract: Br,
  to: IC,
  unequal: HC,
  usolve: Vp,
  xor: LC,
  add: We,
  atan2: qC,
  bitAnd: UC,
  bitOr: kC,
  bitXor: XC,
  catalan: jC,
  compare: pa,
  compareText: _h,
  cumsum: GC,
  deepEqual: Qp,
  diff: VC,
  distance: QC,
  dot: Lo,
  equalText: YC,
  floor: $h,
  gcd: ZC,
  hypot: WC,
  larger: ct,
  log: Yp,
  lsolveAll: KC,
  matrixFromRows: JC,
  min: _C,
  mod: rg,
  multiply: fr,
  nthRoots: $C,
  or: e8,
  partitionSelect: qo,
  rightLogShift: r8,
  slu: tg,
  subset: Rt,
  sum: Zp,
  trace: t8,
  usolveAll: ng,
  zpk2tf: n8,
  ceil: Wp,
  compareNatural: pn,
  composition: a8,
  cross: i8,
  det: ag,
  dotMultiply: o8,
  fix: og,
  index: sg,
  intersect: s8,
  invmod: u8,
  lcm: c8,
  log1p: l8,
  max: Kp,
  setCartesian: f8,
  setDistinct: v8,
  setIsSubset: p8,
  setPowerset: d8,
  smallerEq: Ca,
  sort: m8,
  and: h8,
  range: Ea,
  row: g8,
  setDifference: ug,
  setMultiplicity: x8,
  setSymDifference: cg,
  column: fg,
  inv: da,
  lup: vg,
  pinv: y8,
  pow: Gt,
  setIntersect: pg,
  setUnion: A8,
  sqrtm: b8,
  vacuumImpedance: w8,
  wienDisplacement: D8,
  atomicMass: C8,
  bohrMagneton: E8,
  boltzmann: N8,
  conductanceQuantum: B8,
  coulomb: S8,
  deuteronMass: P8,
  dotPow: M8,
  electricConstant: F8,
  elementaryCharge: T8,
  expm: O8,
  faraday: z8,
  fft: dg,
  gamma: Jp,
  gravitationConstant: R8,
  hartreeEnergy: I8,
  ifft: H8,
  klitzing: L8,
  loschmidt: q8,
  magneticConstant: U8,
  molarMass: k8,
  molarPlanckConstant: X8,
  neutronMass: j8,
  nuclearMagneton: G8,
  planckCharge: V8,
  planckLength: Q8,
  planckTemperature: Y8,
  protonMass: Z8,
  quantumOfCirculation: W8,
  reducedPlanckConstant: K8,
  rydberg: J8,
  secondRadiation: _8,
  speedOfLight: $8,
  stefanBoltzmann: eE,
  thomsonCrossSection: rE,
  avogadro: tE,
  bohrRadius: nE,
  createUnit: aE,
  divide: Vr,
  electronMass: iE,
  factorial: Fi,
  firstRadiation: oE,
  gravity: sE,
  inverseConductanceQuantum: uE,
  lusolve: mg,
  magneticFluxQuantum: cE,
  molarMassC12: lE,
  multinomial: fE,
  parse: dn,
  permutations: vE,
  planckMass: pE,
  polynomialRoot: dE,
  resolve: Pg,
  setSize: mE,
  simplifyConstant: rd,
  solveODE: hE,
  stirlingS2: hg,
  unit: gE,
  bellNumbers: xE,
  compile: HE,
  eigs: gg,
  fermiCoupling: yE,
  gasConstant: AE,
  kldivergence: bE,
  mean: xg,
  molarVolume: wE,
  planckConstant: DE,
  quantileSeq: CE,
  simplifyCore: td,
  variance: _p,
  classicalElectronRadius: EE,
  evaluate: nd,
  median: yg,
  simplify: Uo,
  symbolicEqual: LE,
  corr: NE,
  freqz: BE,
  leafCount: qE,
  mad: SE,
  parser: UE,
  rationalize: kE,
  std: PE,
  zeta: ME,
  derivative: XE,
  norm: $p,
  rotationMatrix: Ag,
  help: jE,
  planckTime: FE,
  schur: bg,
  rotate: TE,
  sylvester: wg,
  lyap: OE,
  config: he
});
Lr(Oi, Ti, {
  filter: dp({
    typed: Z
  }),
  forEach: mp({
    typed: Z
  }),
  map: gp({
    typed: Z
  }),
  apply: vp({
    isInteger: bt,
    typed: Z
  }),
  or: Op({
    DenseMatrix: Qe,
    concat: ir,
    equalScalar: _e,
    matrix: De,
    typed: Z
  }),
  and: Tp({
    add: We,
    concat: ir,
    equalScalar: _e,
    matrix: De,
    not: ao,
    typed: Z,
    zeros: Kr
  }),
  concat: Cp({
    isInteger: bt,
    matrix: De,
    typed: Z
  }),
  max: xp({
    config: he,
    larger: ct,
    numeric: Kt,
    typed: Z
  }),
  print: Fp({
    add: We,
    matrix: De,
    typed: Z,
    zeros: Kr
  }),
  bitAnd: zp({
    add: We,
    concat: ir,
    equalScalar: _e,
    matrix: De,
    not: ao,
    typed: Z,
    zeros: Kr
  }),
  diff: Ep({
    bignumber: qr,
    matrix: De,
    number: Cn,
    subtract: Br,
    typed: Z
  }),
  min: Ap({
    config: he,
    numeric: Kt,
    smaller: ut,
    typed: Z
  }),
  subset: Dp({
    add: We,
    matrix: De,
    typed: Z,
    zeros: Kr
  }),
  bitOr: Rp({
    DenseMatrix: Qe,
    concat: ir,
    equalScalar: _e,
    matrix: De,
    typed: Z
  }),
  cumsum: Pp({
    add: We,
    typed: Z,
    unaryPlus: Ip
  }),
  index: hp({
    Index: tt,
    getMatrixDataType: Lp
  }),
  sum: Bp({
    add: We,
    config: he,
    numeric: Kt,
    typed: Z
  }),
  range: bp({
    bignumber: qr,
    matrix: De,
    add: We,
    config: he,
    isPositive: la,
    larger: ct,
    largerEq: Ho,
    smaller: ut,
    smallerEq: Ca,
    typed: Z
  }),
  row: wp({
    Index: tt,
    matrix: De,
    range: Ea,
    typed: Z
  }),
  column: pp({
    Index: tt,
    matrix: De,
    range: Ea,
    typed: Z
  }),
  mean: yp({
    add: We,
    divide: Vr,
    typed: Z
  }),
  quantileSeq: Sp({
    add: We,
    bignumber: qr,
    compare: pa,
    divide: Vr,
    isInteger: bt,
    larger: ct,
    multiply: fr,
    partitionSelect: qo,
    smaller: ut,
    smallerEq: Ca,
    subtract: Br,
    typed: Z
  }),
  variance: Mp({
    add: We,
    apply: kp,
    divide: Vr,
    isNaN: Bi,
    multiply: fr,
    subtract: Br,
    typed: Z
  }),
  std: Np({
    map: fa,
    sqrt: $t,
    typed: Z,
    variance: _p
  })
});
Lr(zE, {
  BigNumber: Ne,
  Complex: gr,
  Fraction: ua,
  Matrix: Oo,
  Node: it,
  ObjectNode: za,
  OperatorNode: Nn,
  ParenthesisNode: ma,
  Range: D4,
  RelationalNode: Dg,
  ResultSet: qh,
  ArrayNode: Ra,
  BlockNode: Cg,
  ConditionalNode: Eg,
  ConstantNode: jn,
  DenseMatrix: Qe,
  RangeNode: Ng,
  Chain: ed,
  FunctionAssignmentNode: Bg,
  SparseMatrix: En,
  IndexNode: Ia,
  ImmutableDenseMatrix: eg,
  Index: tt,
  AccessorNode: Ha,
  AssignmentNode: Sg,
  FibonacciHeap: ig,
  Spa: lg,
  Unit: He,
  SymbolNode: Gn,
  FunctionNode: Vn,
  Help: Mg,
  Parser: Fg
});
ed.createProxy(Ti);
var Se = {
  createBigNumberClass: gu
}, wr = {
  createComplexClass: xu
}, ad = {
  createMatrixClass: bu
}, Ze = {
  MatrixDependencies: ad,
  createDenseMatrixClass: Du
}, La = {
  createFractionClass: yu
}, W = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  DenseMatrixDependencies: Ze,
  FractionDependencies: La,
  createTyped: vu
}, Nt = {
  typedDependencies: W,
  createAbs: Ku
}, mt = {
  createNode: zf
}, tr = {
  typedDependencies: W,
  createEqualScalar: Ru
}, Qn = {
  MatrixDependencies: ad,
  equalScalarDependencies: tr,
  typedDependencies: W,
  createSparseMatrixClass: Iu
}, Yr = {
  typedDependencies: W,
  createAddScalar: Ju
}, It = {
  typedDependencies: W,
  createIsInteger: Nu
}, Ce = {
  DenseMatrixDependencies: Ze,
  MatrixDependencies: ad,
  SparseMatrixDependencies: Qn,
  typedDependencies: W,
  createMatrix: ju
}, or = {
  isIntegerDependencies: It,
  matrixDependencies: Ce,
  typedDependencies: W,
  createConcat: ho
}, nr = {
  DenseMatrixDependencies: Ze,
  SparseMatrixDependencies: Qn,
  addScalarDependencies: Yr,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createAdd: Sf
}, ot = {
  BigNumberDependencies: Se,
  matrixDependencies: Ce,
  typedDependencies: W,
  createZeros: Zc
}, Vt = {
  addDependencies: nr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createSubset: bo
}, zi = {
  NodeDependencies: mt,
  subsetDependencies: Vt,
  createAccessorNode: Rf
}, XU = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createAcos: Ql
}, jU = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createAcosh: Yl
}, GU = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createAcot: Zl
}, VU = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  typedDependencies: W,
  createAcoth: Wl
}, QU = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  typedDependencies: W,
  createAcsc: Kl
}, YU = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createAcsch: Jl
}, id = {
  typedDependencies: W,
  createNot: Bc
}, ZU = {
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  notDependencies: id,
  typedDependencies: W,
  zerosDependencies: ot,
  createAnd: Co
}, WU = {
  addDependencies: nr,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  notDependencies: id,
  typedDependencies: W,
  zerosDependencies: ot,
  createAndTransform: Tp
}, Tg = {
  isIntegerDependencies: It,
  typedDependencies: W,
  createApply: Di
}, KU = {
  isIntegerDependencies: It,
  typedDependencies: W,
  createApplyTransform: vp
}, JU = {
  typedDependencies: W,
  createArg: Dc
}, Ri = {
  NodeDependencies: mt,
  createArrayNode: If
}, _U = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  typedDependencies: W,
  createAsec: _l
}, $U = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  typedDependencies: W,
  createAsech: $l
}, ek = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createAsin: ef
}, rk = {
  typedDependencies: W,
  createAsinh: rf
}, GE = {
  matrixDependencies: Ce,
  NodeDependencies: mt,
  subsetDependencies: Vt,
  createAssignmentNode: Hf
}, VE = {
  typedDependencies: W,
  createAtan: tf
}, tk = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createAtan2: nf
}, nk = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createAtanh: af
}, Qt = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createBignumber: Uu
}, Ii = {
  FractionDependencies: La,
  typedDependencies: W,
  createFraction: Xu
}, Yn = {
  typedDependencies: W,
  createNumber: Hu
}, mn = {
  bignumberDependencies: Qt,
  fractionDependencies: Ii,
  numberDependencies: Yn,
  createNumeric: ul
}, Tr = {
  numericDependencies: mn,
  typedDependencies: W,
  createDivideScalar: cl
}, en = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createEqual: Bl
}, Hi = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createRound: fl
}, Og = {
  DenseMatrixDependencies: Ze,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  roundDependencies: Hi,
  typedDependencies: W,
  zerosDependencies: ot,
  createCeil: ec
}, QE = {
  DenseMatrixDependencies: Ze,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  roundDependencies: Hi,
  typedDependencies: W,
  zerosDependencies: ot,
  createFloor: lo
}, YE = {
  ComplexDependencies: wr,
  DenseMatrixDependencies: Ze,
  ceilDependencies: Og,
  equalScalarDependencies: tr,
  floorDependencies: QE,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createFix: ac
}, ko = {
  typedDependencies: W,
  createFormat: tl
}, qa = {
  typedDependencies: W,
  createIsNumeric: Pu
}, Ir = {
  typedDependencies: W,
  createMultiplyScalar: fc
}, ha = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  SparseMatrixDependencies: Qn,
  matrixDependencies: Ce,
  typedDependencies: W,
  createIdentity: Ic
}, hn = {
  typedDependencies: W,
  createIsZero: Tu
}, Ua = {
  typedDependencies: W,
  createConj: Cc
}, st = {
  matrixDependencies: Ce,
  typedDependencies: W,
  createSize: Gc
}, od = {
  addScalarDependencies: Yr,
  conjDependencies: Ua,
  multiplyScalarDependencies: Ir,
  sizeDependencies: st,
  typedDependencies: W,
  createDot: Ff
}, pr = {
  addScalarDependencies: Yr,
  dotDependencies: od,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  typedDependencies: W,
  createMultiply: vc
}, rn = {
  typedDependencies: W,
  createSubtractScalar: _u
}, Bn = {
  typedDependencies: W,
  createUnaryMinus: Zu
}, ZE = {
  divideScalarDependencies: Tr,
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createDet: l0
}, ka = {
  absDependencies: Nt,
  addScalarDependencies: Yr,
  detDependencies: ZE,
  divideScalarDependencies: Tr,
  identityDependencies: ha,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createInv: f0
}, tn = {
  ComplexDependencies: wr,
  fractionDependencies: Ii,
  identityDependencies: ha,
  invDependencies: ka,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  numberDependencies: Yn,
  typedDependencies: W,
  createPow: ll
}, Le = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  FractionDependencies: La,
  absDependencies: Nt,
  addScalarDependencies: Yr,
  divideScalarDependencies: Tr,
  equalDependencies: en,
  fixDependencies: YE,
  formatDependencies: ko,
  isNumericDependencies: qa,
  multiplyScalarDependencies: Ir,
  numberDependencies: Yn,
  powDependencies: tn,
  roundDependencies: Hi,
  subtractScalarDependencies: rn,
  createUnitClass: Xl
}, ak = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createAtomicMass: Gv
}, ik = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createAvogadro: Vv
}, ga = {
  typedDependencies: W,
  createIsNegative: Su
}, sd = {
  typedDependencies: W,
  createCombinations: E0
}, zg = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  multiplyScalarDependencies: Ir,
  powDependencies: tn,
  typedDependencies: W,
  createGamma: B0
}, Xo = {
  gammaDependencies: zg,
  typedDependencies: W,
  createFactorial: P0
}, Bt = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createLarger: Fl
}, WE = {
  bignumberDependencies: Qt,
  addScalarDependencies: Yr,
  combinationsDependencies: sd,
  divideScalarDependencies: Tr,
  factorialDependencies: Xo,
  isIntegerDependencies: It,
  isNegativeDependencies: ga,
  largerDependencies: Bt,
  multiplyScalarDependencies: Ir,
  numberDependencies: Yn,
  powDependencies: tn,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createStirlingS2: I0
}, ok = {
  addScalarDependencies: Yr,
  isIntegerDependencies: It,
  isNegativeDependencies: ga,
  stirlingS2Dependencies: WE,
  typedDependencies: W,
  createBellNumbers: H0
}, sk = {
  formatDependencies: ko,
  typedDependencies: W,
  createBin: nl
}, uk = {
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createBitAnd: vo
}, ck = {
  addDependencies: nr,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  notDependencies: id,
  typedDependencies: W,
  zerosDependencies: ot,
  createBitAndTransform: zp
}, lk = {
  typedDependencies: W,
  createBitNot: bc
}, fk = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createBitOr: po
}, vk = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createBitOrTransform: Rp
}, pk = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createBitXor: wc
}, KE = {
  createResultSet: pu
}, JE = {
  NodeDependencies: mt,
  ResultSetDependencies: KE,
  createBlockNode: Lf
}, dk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createBohrMagneton: Cv
}, mk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createBohrRadius: Mv
}, hk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createBoltzmann: Qv
}, gk = {
  typedDependencies: W,
  createBoolean: qu
}, xk = {
  addScalarDependencies: Yr,
  combinationsDependencies: sd,
  divideScalarDependencies: Tr,
  isIntegerDependencies: It,
  isNegativeDependencies: ga,
  multiplyScalarDependencies: Ir,
  typedDependencies: W,
  createCatalan: L0
}, _E = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  FractionDependencies: La,
  isNegativeDependencies: ga,
  matrixDependencies: Ce,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createCbrt: $u
}, $E = {
  typedDependencies: W,
  createChainClass: s0
}, yk = {
  ChainDependencies: $E,
  typedDependencies: W,
  createChain: c0
}, Ak = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createClassicalElectronRadius: Fv
}, bk = {
  typedDependencies: W,
  createClone: Cu
}, St = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createSmaller: Pl
}, e3 = {
  DenseMatrixDependencies: Ze,
  smallerDependencies: St,
  createImmutableDenseMatrixClass: Hl
}, Rg = {
  typedDependencies: W,
  createGetMatrixDataType: Rc
}, ht = {
  ImmutableDenseMatrixDependencies: e3,
  getMatrixDataTypeDependencies: Rg,
  createIndexClass: Ll
}, Xa = {
  typedDependencies: W,
  createIsPositive: Fu
}, ud = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createLargerEq: Tl
}, Li = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createSmallerEq: Ml
}, qi = {
  bignumberDependencies: Qt,
  matrixDependencies: Ce,
  addDependencies: nr,
  isPositiveDependencies: Xa,
  largerDependencies: Bt,
  largerEqDependencies: ud,
  smallerDependencies: St,
  smallerEqDependencies: Li,
  typedDependencies: W,
  createRange: yo
}, r3 = {
  IndexDependencies: ht,
  matrixDependencies: Ce,
  rangeDependencies: qi,
  typedDependencies: W,
  createColumn: go
}, wk = {
  IndexDependencies: ht,
  matrixDependencies: Ce,
  rangeDependencies: qi,
  typedDependencies: W,
  createColumnTransform: pp
}, Dk = {
  typedDependencies: W,
  createCombinationsWithRep: N0
}, ja = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  FractionDependencies: La,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createCompare: Cl
}, Sn = {
  compareDependencies: ja,
  typedDependencies: W,
  createCompareNatural: El
}, t3 = {
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createCompareText: Nl
}, n3 = {
  NodeDependencies: mt,
  createConditionalNode: qf
}, xa = {
  NodeDependencies: mt,
  createConstantNode: Uf
}, a3 = {
  NodeDependencies: mt,
  typedDependencies: W,
  createFunctionAssignmentNode: kf
}, ya = {
  UnitDependencies: Le,
  NodeDependencies: mt,
  createSymbolNode: Zf
}, Aa = {
  NodeDependencies: mt,
  SymbolNodeDependencies: ya,
  createFunctionNode: Wf
}, Ui = {
  NodeDependencies: mt,
  sizeDependencies: st,
  createIndexNode: Xf
}, ki = {
  NodeDependencies: mt,
  createObjectNode: jf
}, Zn = {
  NodeDependencies: mt,
  createOperatorNode: Gf
}, Ga = {
  NodeDependencies: mt,
  createParenthesisNode: Vf
}, i3 = {
  NodeDependencies: mt,
  createRangeNode: Qf
}, o3 = {
  NodeDependencies: mt,
  createRelationalNode: Yf
}, Pn = {
  AccessorNodeDependencies: zi,
  ArrayNodeDependencies: Ri,
  AssignmentNodeDependencies: GE,
  BlockNodeDependencies: JE,
  ConditionalNodeDependencies: n3,
  ConstantNodeDependencies: xa,
  FunctionAssignmentNodeDependencies: a3,
  FunctionNodeDependencies: Aa,
  IndexNodeDependencies: Ui,
  ObjectNodeDependencies: ki,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  RangeNodeDependencies: i3,
  RelationalNodeDependencies: o3,
  SymbolNodeDependencies: ya,
  numericDependencies: mn,
  typedDependencies: W,
  createParse: Kf
}, Ck = {
  parseDependencies: Pn,
  typedDependencies: W,
  createCompile: Jf
}, cd = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createComplex: ku
}, Ek = {
  addScalarDependencies: Yr,
  combinationsDependencies: sd,
  isIntegerDependencies: It,
  isNegativeDependencies: ga,
  isPositiveDependencies: Xa,
  largerDependencies: Bt,
  typedDependencies: W,
  createComposition: q0
}, Nk = {
  isIntegerDependencies: It,
  matrixDependencies: Ce,
  typedDependencies: W,
  createConcatTransform: Cp
}, Bk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createConductanceQuantum: Ev
}, $r = {
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  invDependencies: ka,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  typedDependencies: W,
  createDivide: y0
}, s3 = {
  addDependencies: nr,
  divideDependencies: $r,
  typedDependencies: W,
  createMean: Po
}, gn = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createSqrt: mc
}, Hr = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createSubtract: gc
}, Ig = {
  addDependencies: nr,
  numericDependencies: mn,
  typedDependencies: W,
  createSum: Bo
}, Sk = {
  addDependencies: nr,
  divideDependencies: $r,
  matrixDependencies: Ce,
  meanDependencies: s3,
  multiplyDependencies: pr,
  powDependencies: tn,
  sqrtDependencies: gn,
  subtractDependencies: Hr,
  sumDependencies: Ig,
  typedDependencies: W,
  createCorr: C0
}, Hg = {
  typedDependencies: W,
  createCos: of
}, Pk = {
  typedDependencies: W,
  createCosh: sf
}, Mk = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createCot: uf
}, Fk = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createCoth: cf
}, Tk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createCoulomb: wv
}, u3 = {
  multiplyScalarDependencies: Ir,
  numericDependencies: mn,
  typedDependencies: W,
  createProd: rl
}, Ok = {
  prodDependencies: u3,
  sizeDependencies: st,
  typedDependencies: W,
  createCount: Pc
}, zk = {
  UnitDependencies: Le,
  typedDependencies: W,
  createCreateUnit: Vl
}, Rk = {
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  subtractDependencies: Hr,
  typedDependencies: W,
  createCross: Mc
}, Ik = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createCsc: lf
}, Hk = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createCsch: ff
}, jo = {
  matrixDependencies: Ce,
  typedDependencies: W,
  createTranspose: Qc
}, Lg = {
  conjDependencies: Ua,
  transposeDependencies: jo,
  typedDependencies: W,
  createCtranspose: Yc
}, Lk = {
  typedDependencies: W,
  createCube: rc
}, qg = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createUnaryPlus: Wu
}, qk = {
  addDependencies: nr,
  typedDependencies: W,
  unaryPlusDependencies: qg,
  createCumSum: So
}, Uk = {
  addDependencies: nr,
  typedDependencies: W,
  unaryPlusDependencies: qg,
  createCumSumTransform: Pp
}, Ug = {
  equalDependencies: en,
  typedDependencies: W,
  createDeepEqual: Ol
}, c3 = {
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  parseDependencies: Pn,
  typedDependencies: W,
  createResolve: G0
}, kg = {
  bignumberDependencies: Qt,
  fractionDependencies: Ii,
  AccessorNodeDependencies: zi,
  ArrayNodeDependencies: Ri,
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  IndexNodeDependencies: Ui,
  ObjectNodeDependencies: ki,
  OperatorNodeDependencies: Zn,
  SymbolNodeDependencies: ya,
  matrixDependencies: Ce,
  typedDependencies: W,
  createSimplifyConstant: X0
}, Xg = {
  AccessorNodeDependencies: zi,
  ArrayNodeDependencies: Ri,
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  IndexNodeDependencies: Ui,
  ObjectNodeDependencies: ki,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  SymbolNodeDependencies: ya,
  addDependencies: nr,
  divideDependencies: $r,
  equalDependencies: en,
  isZeroDependencies: hn,
  multiplyDependencies: pr,
  parseDependencies: Pn,
  powDependencies: tn,
  subtractDependencies: Hr,
  typedDependencies: W,
  createSimplifyCore: j0
}, ld = {
  bignumberDependencies: Qt,
  fractionDependencies: Ii,
  AccessorNodeDependencies: zi,
  ArrayNodeDependencies: Ri,
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  IndexNodeDependencies: Ui,
  ObjectNodeDependencies: ki,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  SymbolNodeDependencies: ya,
  addDependencies: nr,
  divideDependencies: $r,
  equalDependencies: en,
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  parseDependencies: Pn,
  powDependencies: tn,
  resolveDependencies: c3,
  simplifyConstantDependencies: kg,
  simplifyCoreDependencies: Xg,
  subtractDependencies: Hr,
  typedDependencies: W,
  createSimplify: k0
}, kk = {
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  SymbolNodeDependencies: ya,
  equalDependencies: en,
  isZeroDependencies: hn,
  numericDependencies: mn,
  parseDependencies: Pn,
  simplifyDependencies: ld,
  typedDependencies: W,
  createDerivative: Q0
}, Xk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createDeuteronMass: Hv
}, l3 = {
  DenseMatrixDependencies: Ze,
  SparseMatrixDependencies: Qn,
  matrixDependencies: Ce,
  typedDependencies: W,
  createDiag: Fc
}, jk = {
  matrixDependencies: Ce,
  numberDependencies: Yn,
  subtractDependencies: Hr,
  typedDependencies: W,
  createDiff: xo
}, Gk = {
  bignumberDependencies: Qt,
  matrixDependencies: Ce,
  numberDependencies: Yn,
  subtractDependencies: Hr,
  typedDependencies: W,
  createDiffTransform: Ep
}, Vk = {
  absDependencies: Nt,
  addScalarDependencies: Yr,
  deepEqualDependencies: Ug,
  divideScalarDependencies: Tr,
  multiplyScalarDependencies: Ir,
  sqrtDependencies: gn,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createDistance: A0
}, Go = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createDotDivide: hl
}, Qk = {
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  typedDependencies: W,
  createDotMultiply: Ac
}, Yk = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  powDependencies: tn,
  typedDependencies: W,
  createDotPow: ml
}, f3 = {
  BigNumberDependencies: Se,
  createE: iv
}, Zk = {
  BigNumberDependencies: Se,
  createEfimovFactor: jv
}, Vo = {
  matrixDependencies: Ce,
  typedDependencies: W,
  createFlatten: Oc
}, jg = {
  typedDependencies: W,
  createIm: Ec
}, Gg = {
  flattenDependencies: Vo,
  matrixDependencies: Ce,
  sizeDependencies: st,
  typedDependencies: W,
  createMatrixFromColumns: Qu
}, v3 = {
  BigNumberDependencies: Se,
  FractionDependencies: La,
  complexDependencies: cd,
  typedDependencies: W,
  createSign: dc
}, Vg = {
  addScalarDependencies: Yr,
  complexDependencies: cd,
  conjDependencies: Ua,
  divideScalarDependencies: Tr,
  equalDependencies: en,
  identityDependencies: ha,
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  signDependencies: v3,
  sqrtDependencies: gn,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  zerosDependencies: ot,
  createQr: t0
}, Qg = {
  typedDependencies: W,
  createRe: Nc
}, p3 = {
  isIntegerDependencies: It,
  matrixDependencies: Ce,
  typedDependencies: W,
  createReshape: Uc
}, fd = {
  typedDependencies: W,
  createSin: df
}, Yg = {
  DenseMatrixDependencies: Ze,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createUsolve: xl
}, d3 = {
  DenseMatrixDependencies: Ze,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createUsolveAll: Al
}, m3 = {
  absDependencies: Nt,
  addDependencies: nr,
  addScalarDependencies: Yr,
  atanDependencies: VE,
  bignumberDependencies: Qt,
  columnDependencies: r3,
  complexDependencies: cd,
  cosDependencies: Hg,
  diagDependencies: l3,
  divideScalarDependencies: Tr,
  dotDependencies: od,
  equalDependencies: en,
  flattenDependencies: Vo,
  imDependencies: jg,
  invDependencies: ka,
  largerDependencies: Bt,
  matrixDependencies: Ce,
  matrixFromColumnsDependencies: Gg,
  multiplyDependencies: pr,
  multiplyScalarDependencies: Ir,
  numberDependencies: Yn,
  qrDependencies: Vg,
  reDependencies: Qg,
  reshapeDependencies: p3,
  sinDependencies: fd,
  sizeDependencies: st,
  smallerDependencies: St,
  sqrtDependencies: gn,
  subtractDependencies: Hr,
  typedDependencies: W,
  usolveDependencies: Yg,
  usolveAllDependencies: d3,
  createEigs: p0
}, Wk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createElectricConstant: Av
}, Kk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createElectronMass: Tv
}, Jk = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createElementaryCharge: Dv
}, _k = {
  compareTextDependencies: t3,
  isZeroDependencies: hn,
  typedDependencies: W,
  createEqualText: Sl
}, $k = {
  typedDependencies: W,
  createErf: _c
}, Zg = {
  parseDependencies: Pn,
  typedDependencies: W,
  createEvaluate: _f
}, h3 = {
  typedDependencies: W,
  createExp: tc
}, eX = {
  absDependencies: Nt,
  addDependencies: nr,
  identityDependencies: ha,
  invDependencies: ka,
  multiplyDependencies: pr,
  typedDependencies: W,
  createExpm: d0
}, rX = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createExpm1: nc
}, tX = {
  createFalse: $0
}, nX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createFaraday: Yv
}, aX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createFermiCoupling: Ov
}, g3 = {
  ComplexDependencies: wr,
  createI: pv
}, x3 = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createLog2: lc
}, y3 = {
  BigNumberDependencies: Se,
  createTau: av
}, A3 = {
  addScalarDependencies: Yr,
  ceilDependencies: Og,
  conjDependencies: Ua,
  divideScalarDependencies: Tr,
  dotDivideDependencies: Go,
  expDependencies: h3,
  iDependencies: g3,
  log2Dependencies: x3,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  powDependencies: tn,
  tauDependencies: y3,
  typedDependencies: W,
  createFft: Wc
}, b3 = {
  largerDependencies: Bt,
  smallerDependencies: St,
  createFibonacciHeapClass: ql
}, iX = {
  typedDependencies: W,
  createFilter: Tc
}, oX = {
  typedDependencies: W,
  createFilterTransform: dp
}, sX = {
  BigNumberDependencies: Se,
  createFineStructure: zv
}, uX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createFirstRadiation: Zv
}, cX = {
  typedDependencies: W,
  createForEach: zc
}, lX = {
  typedDependencies: W,
  createForEachTransform: mp
}, fX = {
  ComplexDependencies: wr,
  addDependencies: nr,
  divideDependencies: $r,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  typedDependencies: W,
  createFreqz: W0
}, vX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createGasConstant: Kv
}, pX = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  roundDependencies: Hi,
  typedDependencies: W,
  zerosDependencies: ot,
  createGcd: oc
}, dX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createGravitationConstant: hv
}, mX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createGravity: ip
}, hX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createHartreeEnergy: Rv
}, gX = {
  isNumericDependencies: qa,
  typedDependencies: W,
  createHasNumericValue: Mu
}, w3 = {
  evaluateDependencies: Zg,
  createHelpClass: o0
}, xX = {
  HelpDependencies: w3,
  typedDependencies: W,
  createHelp: u0
}, yX = {
  formatDependencies: ko,
  typedDependencies: W,
  createHex: il
}, AX = {
  absDependencies: Nt,
  addScalarDependencies: Yr,
  divideScalarDependencies: Tr,
  isPositiveDependencies: Xa,
  multiplyScalarDependencies: Ir,
  smallerDependencies: St,
  sqrtDependencies: gn,
  typedDependencies: W,
  createHypot: Pf
}, bX = {
  conjDependencies: Ua,
  dotDivideDependencies: Go,
  fftDependencies: A3,
  typedDependencies: W,
  createIfft: Kc
}, D3 = {
  IndexDependencies: ht,
  typedDependencies: W,
  createIndex: Of
}, wX = {
  IndexDependencies: ht,
  getMatrixDataTypeDependencies: Rg,
  createIndexTransform: hp
}, DX = {
  BigNumberDependencies: Se,
  createInfinity: rv
}, CX = {
  absDependencies: Nt,
  addDependencies: nr,
  addScalarDependencies: Yr,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  flattenDependencies: Vo,
  isNumericDependencies: qa,
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  multiplyScalarDependencies: Ir,
  smallerDependencies: St,
  subtractDependencies: Hr,
  typedDependencies: W,
  createIntersect: b0
}, EX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createInverseConductanceQuantum: Nv
}, C3 = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  roundDependencies: Hi,
  typedDependencies: W,
  zerosDependencies: ot,
  createMod: fo
}, E3 = {
  BigNumberDependencies: Se,
  matrixDependencies: Ce,
  typedDependencies: W,
  createXgcd: xc
}, NX = {
  BigNumberDependencies: Se,
  addDependencies: nr,
  equalDependencies: en,
  isIntegerDependencies: It,
  modDependencies: C3,
  smallerDependencies: St,
  typedDependencies: W,
  xgcdDependencies: E3,
  createInvmod: yc
}, Qo = {
  typedDependencies: W,
  createIsNaN: Ou
}, BX = {
  typedDependencies: W,
  createIsPrime: sl
}, Wg = {
  ComplexDependencies: wr,
  divideScalarDependencies: Tr,
  typedDependencies: W,
  createLog: vl
}, Va = {
  typedDependencies: W,
  createMap: Lc
}, SX = {
  divideDependencies: $r,
  dotDivideDependencies: Go,
  isNumericDependencies: qa,
  logDependencies: Wg,
  mapDependencies: Va,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  sumDependencies: Ig,
  typedDependencies: W,
  createKldivergence: M0
}, PX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createKlitzing: Pv
}, MX = {
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  typedDependencies: W,
  createKron: Hc
}, FX = {
  BigNumberDependencies: Se,
  createLN10: uv
}, TX = {
  BigNumberDependencies: Se,
  createLN2: sv
}, OX = {
  BigNumberDependencies: Se,
  createLOG10E: lv
}, zX = {
  BigNumberDependencies: Se,
  createLOG2E: cv
}, RX = {
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createLcm: uc
}, IX = {
  parseDependencies: Pn,
  typedDependencies: W,
  createLeafCount: U0
}, HX = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createLeftShift: bl
}, LX = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createLgamma: S0
}, qX = {
  ComplexDependencies: wr,
  typedDependencies: W,
  createLog10: cc
}, UX = {
  ComplexDependencies: wr,
  divideScalarDependencies: Tr,
  logDependencies: Wg,
  typedDependencies: W,
  createLog1p: pl
}, kX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createLoschmidt: Wv
}, N3 = {
  DenseMatrixDependencies: Ze,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createLsolve: gl
}, XX = {
  DenseMatrixDependencies: Ze,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  createLsolveAll: yl
}, B3 = {
  FibonacciHeapDependencies: b3,
  addScalarDependencies: Yr,
  equalScalarDependencies: tr,
  createSpaClass: Ul
}, S3 = {
  DenseMatrixDependencies: Ze,
  SpaDependencies: B3,
  SparseMatrixDependencies: Qn,
  absDependencies: Nt,
  addScalarDependencies: Yr,
  divideScalarDependencies: Tr,
  equalScalarDependencies: tr,
  largerDependencies: Bt,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  subtractScalarDependencies: rn,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createLup: r0
}, P3 = {
  SparseMatrixDependencies: Qn,
  absDependencies: Nt,
  addDependencies: nr,
  divideScalarDependencies: Tr,
  largerDependencies: Bt,
  largerEqDependencies: ud,
  multiplyDependencies: pr,
  subtractDependencies: Hr,
  transposeDependencies: jo,
  typedDependencies: W,
  createSlu: n0
}, M3 = {
  DenseMatrixDependencies: Ze,
  lsolveDependencies: N3,
  lupDependencies: S3,
  matrixDependencies: Ce,
  sluDependencies: P3,
  typedDependencies: W,
  usolveDependencies: Yg,
  createLusolve: a0
}, Kg = {
  absDependencies: Nt,
  addDependencies: nr,
  conjDependencies: Ua,
  ctransposeDependencies: Lg,
  eigsDependencies: m3,
  equalScalarDependencies: tr,
  largerDependencies: Bt,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  powDependencies: tn,
  smallerDependencies: St,
  sqrtDependencies: gn,
  typedDependencies: W,
  createNorm: Mf
}, F3 = {
  identityDependencies: ha,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  normDependencies: Kg,
  qrDependencies: Vg,
  subtractDependencies: Hr,
  typedDependencies: W,
  createSchur: g0
}, T3 = {
  absDependencies: Nt,
  addDependencies: nr,
  concatDependencies: or,
  identityDependencies: ha,
  indexDependencies: D3,
  lusolveDependencies: M3,
  matrixDependencies: Ce,
  matrixFromColumnsDependencies: Gg,
  multiplyDependencies: pr,
  rangeDependencies: qi,
  schurDependencies: F3,
  subsetDependencies: Vt,
  subtractDependencies: Hr,
  transposeDependencies: jo,
  typedDependencies: W,
  createSylvester: h0
}, jX = {
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  sylvesterDependencies: T3,
  transposeDependencies: jo,
  typedDependencies: W,
  createLyap: x0
}, vd = {
  compareDependencies: ja,
  isNaNDependencies: Qo,
  isNumericDependencies: qa,
  typedDependencies: W,
  createPartitionSelect: Rl
}, O3 = {
  addDependencies: nr,
  compareDependencies: ja,
  divideDependencies: $r,
  partitionSelectDependencies: vd,
  typedDependencies: W,
  createMedian: w0
}, GX = {
  absDependencies: Nt,
  mapDependencies: Va,
  medianDependencies: O3,
  subtractDependencies: Hr,
  typedDependencies: W,
  createMad: D0
}, VX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMagneticConstant: yv
}, QX = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMagneticFluxQuantum: Bv
}, YX = {
  typedDependencies: W,
  createMapTransform: gp
}, ZX = {
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  typedDependencies: W,
  createMatrixFromFunction: Gu
}, WX = {
  flattenDependencies: Vo,
  matrixDependencies: Ce,
  sizeDependencies: st,
  typedDependencies: W,
  createMatrixFromRows: Vu
}, Jg = {
  largerDependencies: Bt,
  numericDependencies: mn,
  typedDependencies: W,
  createMax: Eo
}, KX = {
  largerDependencies: Bt,
  numericDependencies: mn,
  typedDependencies: W,
  createMaxTransform: xp
}, JX = {
  addDependencies: nr,
  divideDependencies: $r,
  typedDependencies: W,
  createMeanTransform: yp
}, _X = {
  numericDependencies: mn,
  smallerDependencies: St,
  typedDependencies: W,
  createMin: No
}, $X = {
  numericDependencies: mn,
  smallerDependencies: St,
  typedDependencies: W,
  createMinTransform: Ap
}, ej = {
  isNaNDependencies: Qo,
  isNumericDependencies: qa,
  typedDependencies: W,
  createMode: el
}, rj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMolarMass: np
}, tj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMolarMassC12: ap
}, nj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMolarPlanckConstant: Jv
}, aj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createMolarVolume: _v
}, ij = {
  addDependencies: nr,
  divideDependencies: $r,
  factorialDependencies: Xo,
  isIntegerDependencies: It,
  isPositiveDependencies: Xa,
  multiplyDependencies: pr,
  typedDependencies: W,
  createMultinomial: F0
}, oj = {
  BigNumberDependencies: Se,
  createNaN: tv
}, sj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createNeutronMass: Lv
}, uj = {
  BigNumberDependencies: Se,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createNthRoot: pc
}, cj = {
  ComplexDependencies: wr,
  divideScalarDependencies: Tr,
  typedDependencies: W,
  createNthRoots: dl
}, lj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createNuclearMagneton: Sv
}, fj = {
  createNull: ev
}, vj = {
  formatDependencies: ko,
  typedDependencies: W,
  createOct: al
}, pj = {
  BigNumberDependencies: Se,
  matrixDependencies: Ce,
  typedDependencies: W,
  createOnes: qc
}, dj = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createOr: mo
}, mj = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createOrTransform: Op
}, z3 = {
  evaluateDependencies: Zg,
  createParserClass: $f
}, hj = {
  ParserDependencies: z3,
  typedDependencies: W,
  createParser: e0
}, gj = {
  factorialDependencies: Xo,
  typedDependencies: W,
  createPermutations: T0
}, xj = {
  BigNumberDependencies: Se,
  createPhi: ov
}, _g = {
  BigNumberDependencies: Se,
  createPi: nv
}, yj = {
  typedDependencies: W,
  createPickRandom: O0
}, Aj = {
  ComplexDependencies: wr,
  addDependencies: nr,
  ctransposeDependencies: Lg,
  deepEqualDependencies: Ug,
  divideScalarDependencies: Tr,
  dotDependencies: od,
  dotDivideDependencies: Go,
  equalDependencies: en,
  invDependencies: ka,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  typedDependencies: W,
  createPinv: v0
}, bj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckCharge: cp
}, wj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckConstant: gv
}, Dj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckLength: op
}, Cj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckMass: sp
}, Ej = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckTemperature: lp
}, Nj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createPlanckTime: up
}, R3 = {
  typedDependencies: W,
  createTypeOf: zu
}, Bj = {
  addDependencies: nr,
  cbrtDependencies: _E,
  divideDependencies: $r,
  equalScalarDependencies: tr,
  imDependencies: jg,
  isZeroDependencies: hn,
  multiplyDependencies: pr,
  reDependencies: Qg,
  sqrtDependencies: gn,
  subtractDependencies: Hr,
  typeOfDependencies: R3,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createPolynomialRoot: i0
}, Sj = {
  typedDependencies: W,
  createPrint: wo
}, Pj = {
  addDependencies: nr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createPrintTransform: Fp
}, Mj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createProtonMass: Iv
}, Fj = {
  bignumberDependencies: Qt,
  addDependencies: nr,
  compareDependencies: ja,
  divideDependencies: $r,
  isIntegerDependencies: It,
  largerDependencies: Bt,
  multiplyDependencies: pr,
  partitionSelectDependencies: vd,
  smallerDependencies: St,
  smallerEqDependencies: Li,
  subtractDependencies: Hr,
  typedDependencies: W,
  createQuantileSeq: Fo
}, Tj = {
  addDependencies: nr,
  bignumberDependencies: Qt,
  compareDependencies: ja,
  divideDependencies: $r,
  isIntegerDependencies: It,
  largerDependencies: Bt,
  multiplyDependencies: pr,
  partitionSelectDependencies: vd,
  smallerDependencies: St,
  smallerEqDependencies: Li,
  subtractDependencies: Hr,
  typedDependencies: W,
  createQuantileSeqTransform: Sp
}, Oj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createQuantumOfCirculation: qv
}, zj = {
  typedDependencies: W,
  createRandom: z0
}, Rj = {
  typedDependencies: W,
  createRandomInt: R0
}, Ij = {
  createRangeClass: Au
}, Hj = {
  bignumberDependencies: Qt,
  matrixDependencies: Ce,
  addDependencies: nr,
  isPositiveDependencies: Xa,
  largerDependencies: Bt,
  largerEqDependencies: ud,
  smallerDependencies: St,
  smallerEqDependencies: Li,
  typedDependencies: W,
  createRangeTransform: bp
}, Lj = {
  bignumberDependencies: Qt,
  fractionDependencies: Ii,
  AccessorNodeDependencies: zi,
  ArrayNodeDependencies: Ri,
  ConstantNodeDependencies: xa,
  FunctionNodeDependencies: Aa,
  IndexNodeDependencies: Ui,
  ObjectNodeDependencies: ki,
  OperatorNodeDependencies: Zn,
  ParenthesisNodeDependencies: Ga,
  SymbolNodeDependencies: ya,
  addDependencies: nr,
  divideDependencies: $r,
  equalDependencies: en,
  isZeroDependencies: hn,
  matrixDependencies: Ce,
  multiplyDependencies: pr,
  parseDependencies: Pn,
  powDependencies: tn,
  simplifyDependencies: ld,
  simplifyConstantDependencies: kg,
  simplifyCoreDependencies: Xg,
  subtractDependencies: Hr,
  typedDependencies: W,
  createRationalize: Y0
}, qj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createReducedPlanckConstant: xv
}, Uj = {
  createReplacer: J0
}, kj = {
  matrixDependencies: Ce,
  createResize: kc
}, Xj = {
  createReviver: K0
}, jj = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createRightArithShift: wl
}, Gj = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createRightLogShift: Dl
}, I3 = {
  BigNumberDependencies: Se,
  DenseMatrixDependencies: Ze,
  SparseMatrixDependencies: Qn,
  addScalarDependencies: Yr,
  cosDependencies: Hg,
  matrixDependencies: Ce,
  multiplyScalarDependencies: Ir,
  normDependencies: Kg,
  sinDependencies: fd,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createRotationMatrix: jc
}, Vj = {
  multiplyDependencies: pr,
  rotationMatrixDependencies: I3,
  typedDependencies: W,
  createRotate: Xc
}, Qj = {
  IndexDependencies: ht,
  matrixDependencies: Ce,
  rangeDependencies: qi,
  typedDependencies: W,
  createRow: Ao
}, Yj = {
  IndexDependencies: ht,
  matrixDependencies: Ce,
  rangeDependencies: qi,
  typedDependencies: W,
  createRowTransform: wp
}, Zj = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createRydberg: Uv
}, Wj = {
  // eslint-disable-line camelcase
  BigNumberDependencies: Se,
  createSQRT1_2: fv
}, Kj = {
  BigNumberDependencies: Se,
  createSQRT2: vv
}, Jj = {
  BigNumberDependencies: Se,
  createSackurTetrode: $v
}, _j = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createSec: vf
}, $j = {
  BigNumberDependencies: Se,
  typedDependencies: W,
  createSech: pf
}, eG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createSecondRadiation: ep
}, rG = {
  DenseMatrixDependencies: Ze,
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetCartesian: xf
}, H3 = {
  DenseMatrixDependencies: Ze,
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetDifference: yf
}, tG = {
  DenseMatrixDependencies: Ze,
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetDistinct: Af
}, L3 = {
  DenseMatrixDependencies: Ze,
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetIntersect: bf
}, nG = {
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetIsSubset: wf
}, aG = {
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetMultiplicity: Df
}, iG = {
  IndexDependencies: ht,
  compareNaturalDependencies: Sn,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetPowerset: Cf
}, oG = {
  compareNaturalDependencies: Sn,
  typedDependencies: W,
  createSetSize: Ef
}, q3 = {
  IndexDependencies: ht,
  concatDependencies: or,
  setDifferenceDependencies: H3,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetSymDifference: Nf
}, sG = {
  IndexDependencies: ht,
  concatDependencies: or,
  setIntersectDependencies: L3,
  setSymDifferenceDependencies: q3,
  sizeDependencies: st,
  subsetDependencies: Vt,
  typedDependencies: W,
  createSetUnion: Bf
}, uG = {
  typedDependencies: W,
  createSinh: mf
}, cG = {
  absDependencies: Nt,
  addDependencies: nr,
  bignumberDependencies: Qt,
  divideDependencies: $r,
  isNegativeDependencies: ga,
  isPositiveDependencies: Xa,
  largerDependencies: Bt,
  mapDependencies: Va,
  matrixDependencies: Ce,
  maxDependencies: Jg,
  multiplyDependencies: pr,
  smallerDependencies: St,
  subtractDependencies: Hr,
  typedDependencies: W,
  unaryMinusDependencies: Bn,
  createSolveODE: Jc
}, lG = {
  compareDependencies: ja,
  compareNaturalDependencies: Sn,
  matrixDependencies: Ce,
  typedDependencies: W,
  createSort: Il
}, fG = {
  SparseMatrixDependencies: Qn,
  typedDependencies: W,
  createSparse: Gl
}, vG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createSpeedOfLight: mv
}, pG = {
  typedDependencies: W,
  createSplitUnit: Yu
}, dG = {
  absDependencies: Nt,
  addDependencies: nr,
  identityDependencies: ha,
  invDependencies: ka,
  mapDependencies: Va,
  maxDependencies: Jg,
  multiplyDependencies: pr,
  sizeDependencies: st,
  sqrtDependencies: gn,
  subtractDependencies: Hr,
  typedDependencies: W,
  createSqrtm: m0
}, mG = {
  typedDependencies: W,
  createSquare: hc
}, hG = {
  matrixDependencies: Ce,
  typedDependencies: W,
  createSqueeze: Vc
}, $g = {
  addDependencies: nr,
  applyDependencies: Tg,
  divideDependencies: $r,
  isNaNDependencies: Qo,
  multiplyDependencies: pr,
  subtractDependencies: Hr,
  typedDependencies: W,
  createVariance: Mo
}, gG = {
  mapDependencies: Va,
  sqrtDependencies: gn,
  typedDependencies: W,
  varianceDependencies: $g,
  createStd: To
}, xG = {
  mapDependencies: Va,
  sqrtDependencies: gn,
  typedDependencies: W,
  varianceDependencies: $g,
  createStdTransform: Np
}, yG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createStefanBoltzmann: rp
}, AG = {
  typedDependencies: W,
  createString: Lu
}, bG = {
  addDependencies: nr,
  matrixDependencies: Ce,
  typedDependencies: W,
  zerosDependencies: ot,
  createSubsetTransform: Dp
}, wG = {
  addDependencies: nr,
  numericDependencies: mn,
  typedDependencies: W,
  createSumTransform: Bp
}, DG = {
  OperatorNodeDependencies: Zn,
  parseDependencies: Pn,
  simplifyDependencies: ld,
  typedDependencies: W,
  createSymbolicEqual: V0
}, CG = {
  typedDependencies: W,
  createTan: hf
}, EG = {
  typedDependencies: W,
  createTanh: gf
}, NG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createThomsonCrossSection: kv
}, BG = {
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createTo: ol
}, SG = {
  addDependencies: nr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createTrace: Tf
}, PG = {
  createTrue: _0
}, MG = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  equalScalarDependencies: tr,
  matrixDependencies: Ce,
  typedDependencies: W,
  createUnequal: zl
}, FG = {
  UnitDependencies: Le,
  typedDependencies: W,
  createUnitFunction: jl
}, TG = {
  eDependencies: f3,
  createUppercaseE: Ih
}, OG = {
  piDependencies: _g,
  createUppercasePi: Rh
}, zG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createVacuumImpedance: bv
}, RG = {
  addDependencies: nr,
  applyDependencies: Tg,
  divideDependencies: $r,
  isNaNDependencies: Qo,
  multiplyDependencies: pr,
  subtractDependencies: Hr,
  typedDependencies: W,
  createVarianceTransform: Mp
}, IG = {
  createVersion: dv
}, HG = {
  BigNumberDependencies: Se,
  createWeakMixingAngle: Xv
}, LG = {
  BigNumberDependencies: Se,
  UnitDependencies: Le,
  createWienDisplacement: tp
}, qG = {
  DenseMatrixDependencies: Ze,
  concatDependencies: or,
  matrixDependencies: Ce,
  typedDependencies: W,
  createXor: Sc
}, UG = {
  BigNumberDependencies: Se,
  ComplexDependencies: wr,
  addDependencies: nr,
  divideDependencies: $r,
  equalDependencies: en,
  factorialDependencies: Xo,
  gammaDependencies: zg,
  isNegativeDependencies: ga,
  multiplyDependencies: pr,
  piDependencies: _g,
  powDependencies: tn,
  sinDependencies: fd,
  smallerEqDependencies: Li,
  subtractDependencies: Hr,
  typedDependencies: W,
  createZeta: $c
}, kG = {
  ComplexDependencies: wr,
  addDependencies: nr,
  multiplyDependencies: pr,
  numberDependencies: Yn,
  typedDependencies: W,
  createZpk2tf: Z0
}, XG = kU, e1 = { exports: {} };
function r1() {
}
r1.prototype = {
  on: function(r, e, t) {
    var n = this.e || (this.e = {});
    return (n[r] || (n[r] = [])).push({
      fn: e,
      ctx: t
    }), this;
  },
  once: function(r, e, t) {
    var n = this;
    function a() {
      n.off(r, a), e.apply(t, arguments);
    }
    return a._ = e, this.on(r, a, t);
  },
  emit: function(r) {
    var e = [].slice.call(arguments, 1), t = ((this.e || (this.e = {}))[r] || []).slice(), n = 0, a = t.length;
    for (n; n < a; n++)
      t[n].fn.apply(t[n].ctx, e);
    return this;
  },
  off: function(r, e) {
    var t = this.e || (this.e = {}), n = t[r], a = [];
    if (n && e)
      for (var i = 0, u = n.length; i < u; i++)
        n[i].fn !== e && n[i].fn._ !== e && a.push(n[i]);
    return a.length ? t[r] = a : delete t[r], this;
  }
};
e1.exports = r1;
e1.exports.TinyEmitter = r1;
var jG = e1.exports;
const GG = /* @__PURE__ */ Ln(jG);
function VG(r) {
  var e = new GG();
  return r.on = e.on.bind(e), r.off = e.off.bind(e), r.once = e.once.bind(e), r.emit = e.emit.bind(e), r;
}
function QG(r, e, t, n) {
  function a(x, g) {
    var y = arguments.length;
    if (y !== 1 && y !== 2)
      throw new wn("import", y, 1, 2);
    g || (g = {});
    function m(E, N, C) {
      if (Array.isArray(N))
        N.forEach((S) => m(E, S));
      else if (typeof N == "object")
        for (var D in N)
          Pe(N, D) && m(E, N[D], D);
      else if (Ji(N) || C !== void 0) {
        var B = Ji(N) ? h(N) ? N.fn + ".transform" : N.fn : C;
        if (Pe(E, B) && E[B] !== N && !g.silent)
          throw new Error('Cannot import "' + B + '" twice');
        E[B] = N;
      } else if (!g.silent)
        throw new TypeError("Factory, Object, or Array expected");
    }
    var b = {};
    m(b, x);
    for (var w in b)
      if (Pe(b, w)) {
        var A = b[w];
        if (Ji(A))
          o(A, g);
        else if (s(A))
          i(w, A, g);
        else if (!g.silent)
          throw new TypeError("Factory, Object, or Array expected");
      }
  }
  function i(x, g, y) {
    if (y.wrap && typeof g == "function" && (g = c(g)), l(g) && (g = r(x, {
      [g.signature]: g
    })), r.isTypedFunction(t[x]) && r.isTypedFunction(g)) {
      y.override ? g = r(x, g.signatures) : g = r(t[x], g), t[x] = g, delete n[x], u(x, g), t.emit("import", x, function() {
        return g;
      });
      return;
    }
    if (t[x] === void 0 || y.override) {
      t[x] = g, delete n[x], u(x, g), t.emit("import", x, function() {
        return g;
      });
      return;
    }
    if (!y.silent)
      throw new Error('Cannot import "' + x + '": already exists');
  }
  function u(x, g) {
    g && typeof g.transform == "function" ? (t.expression.transform[x] = g.transform, v(x) && (t.expression.mathWithTransform[x] = g.transform)) : (delete t.expression.transform[x], v(x) && (t.expression.mathWithTransform[x] = g));
  }
  function f(x) {
    delete t.expression.transform[x], v(x) ? t.expression.mathWithTransform[x] = t[x] : delete t.expression.mathWithTransform[x];
  }
  function c(x) {
    var g = function() {
      for (var m = [], b = 0, w = arguments.length; b < w; b++) {
        var A = arguments[b];
        m[b] = A && A.valueOf();
      }
      return x.apply(t, m);
    };
    return x.transform && (g.transform = x.transform), g;
  }
  function o(x, g) {
    var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : x.fn;
    if (y.includes("."))
      throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(y));
    var m = h(x) ? t.expression.transform : t, b = y in t.expression.transform, w = Pe(m, y) ? m[y] : void 0, A = function() {
      var N = {};
      x.dependencies.map(F2).forEach((D) => {
        if (D.includes("."))
          throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(D));
        D === "math" ? N.math = t : D === "mathWithTransform" ? N.mathWithTransform = t.expression.mathWithTransform : D === "classes" ? N.classes = t : N[D] = t[D];
      });
      var C = /* @__PURE__ */ x(N);
      if (C && typeof C.transform == "function")
        throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with exports.path="expression.transform"');
      if (w === void 0 || g.override)
        return C;
      if (r.isTypedFunction(w) && r.isTypedFunction(C))
        return r(w, C);
      if (g.silent)
        return w;
      throw new Error('Cannot import "' + y + '": already exists');
    };
    !x.meta || x.meta.lazy !== !1 ? (Bs(m, y, A), w && b ? f(y) : (h(x) || p(x)) && Bs(t.expression.mathWithTransform, y, () => m[y])) : (m[y] = A(), w && b ? f(y) : (h(x) || p(x)) && Bs(t.expression.mathWithTransform, y, () => m[y])), n[y] = x, t.emit("import", y, A);
  }
  function s(x) {
    return typeof x == "function" || typeof x == "number" || typeof x == "string" || typeof x == "boolean" || x === null || yt(x) || Wt(x) || Ue(x) || na(x) || Oe(x) || Array.isArray(x);
  }
  function l(x) {
    return typeof x == "function" && typeof x.signature == "string";
  }
  function v(x) {
    return !Pe(d, x);
  }
  function p(x) {
    return !x.fn.includes(".") && // FIXME: make checking on path redundant, check on meta data instead
    !Pe(d, x.fn) && (!x.meta || !x.meta.isClass);
  }
  function h(x) {
    return x !== void 0 && x.meta !== void 0 && x.meta.isTransformFunction === !0 || !1;
  }
  var d = {
    expression: !0,
    type: !0,
    docs: !0,
    error: !0,
    json: !0,
    chain: !0
    // chain method not supported. Note that there is a unit chain too.
  };
  return a;
}
function U3(r, e) {
  var t = Lr({}, su, e);
  if (typeof Object.create != "function")
    throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var n = VG({
    // only here for backward compatibility for legacy factory functions
    isNumber: Xe,
    isComplex: Wt,
    isBigNumber: Ue,
    isFraction: na,
    isUnit: yt,
    isString: Wr,
    isArray: ur,
    isMatrix: Oe,
    isCollection: Tt,
    isDenseMatrix: oi,
    isSparseMatrix: Tn,
    isRange: so,
    isIndex: hi,
    isBoolean: ah,
    isResultSet: ih,
    isHelp: uu,
    isFunction: oh,
    isDate: sh,
    isRegExp: uh,
    isObject: gi,
    isNull: ch,
    isUndefined: lh,
    isAccessorNode: In,
    isArrayNode: Mt,
    isAssignmentNode: fh,
    isBlockNode: vh,
    isConditionalNode: ph,
    isConstantNode: ar,
    isFunctionAssignmentNode: Pa,
    isFunctionNode: An,
    isIndexNode: aa,
    isNode: vr,
    isObjectNode: xi,
    isOperatorNode: zr,
    isParenthesisNode: un,
    isRangeNode: dh,
    isRelationalNode: mh,
    isSymbolNode: Ur,
    isChain: cu
  });
  n.config = j6(t, n.emit), n.expression = {
    transform: {},
    mathWithTransform: {
      config: n.config
    }
  };
  var a = [], i = [];
  function u(s) {
    if (Ji(s))
      return s(n);
    var l = s[Object.keys(s)[0]];
    if (Ji(l))
      return l(n);
    if (!k6(s))
      throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", s), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var v = a.indexOf(s), p;
    return v === -1 ? (s.math === !0 ? p = s.factory(n.type, t, u, n.typed, n) : p = s.factory(n.type, t, u, n.typed), a.push(s), i.push(p)) : p = i[v], p;
  }
  var f = {};
  function c() {
    for (var s = arguments.length, l = new Array(s), v = 0; v < s; v++)
      l[v] = arguments[v];
    return n.typed.apply(n.typed, l);
  }
  c.isTypedFunction = ba.isTypedFunction;
  var o = QG(c, u, n, f);
  return n.import = o, n.on("config", () => {
    Object.values(f).forEach((s) => {
      s && s.meta && s.meta.recreateOnConfigChange && o(s, {
        override: !0
      });
    });
  }), n.create = U3.bind(null, r), n.factory = U, n.import(Object.values(U6(r))), n.ArgumentsError = wn, n.DimensionError = Ye, n.IndexError = Ut, n;
}
const YG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccessorNode: Ha,
  AccessorNodeDependencies: zi,
  ArgumentsError: wn,
  ArrayNode: Ra,
  ArrayNodeDependencies: Ri,
  AssignmentNode: Sg,
  AssignmentNodeDependencies: GE,
  BigNumber: Ne,
  BigNumberDependencies: Se,
  BlockNode: Cg,
  BlockNodeDependencies: JE,
  Chain: ed,
  ChainDependencies: $E,
  Complex: gr,
  ComplexDependencies: wr,
  ConditionalNode: Eg,
  ConditionalNodeDependencies: n3,
  ConstantNode: jn,
  ConstantNodeDependencies: xa,
  DenseMatrix: Qe,
  DenseMatrixDependencies: Ze,
  DimensionError: Ye,
  EDependencies: TG,
  FibonacciHeap: ig,
  FibonacciHeapDependencies: b3,
  Fraction: ua,
  FractionDependencies: La,
  FunctionAssignmentNode: Bg,
  FunctionAssignmentNodeDependencies: a3,
  FunctionNode: Vn,
  FunctionNodeDependencies: Aa,
  Help: Mg,
  HelpDependencies: w3,
  ImmutableDenseMatrix: eg,
  ImmutableDenseMatrixDependencies: e3,
  Index: tt,
  IndexDependencies: ht,
  IndexError: Ut,
  IndexNode: Ia,
  IndexNodeDependencies: Ui,
  InfinityDependencies: DX,
  LN10: x4,
  LN10Dependencies: FX,
  LN2: P4,
  LN2Dependencies: TX,
  LOG10E: y4,
  LOG10EDependencies: OX,
  LOG2E: J4,
  LOG2EDependencies: zX,
  Matrix: Oo,
  MatrixDependencies: ad,
  NaNDependencies: oj,
  Node: it,
  NodeDependencies: mt,
  ObjectNode: za,
  ObjectNodeDependencies: ki,
  OperatorNode: Nn,
  OperatorNodeDependencies: Zn,
  PIDependencies: OG,
  ParenthesisNode: ma,
  ParenthesisNodeDependencies: Ga,
  Parser: Fg,
  ParserDependencies: z3,
  Range: D4,
  RangeDependencies: Ij,
  RangeNode: Ng,
  RangeNodeDependencies: i3,
  RelationalNode: Dg,
  RelationalNodeDependencies: o3,
  ResultSet: qh,
  ResultSetDependencies: KE,
  SQRT1_2: C4,
  SQRT1_2Dependencies: Wj,
  SQRT2: F4,
  SQRT2Dependencies: Kj,
  Spa: lg,
  SpaDependencies: B3,
  SparseMatrix: En,
  SparseMatrixDependencies: Qn,
  SymbolNode: Gn,
  SymbolNodeDependencies: ya,
  Unit: He,
  UnitDependencies: Le,
  _Infinity: g4,
  _NaN: A4,
  _false: m4,
  _null: b4,
  _true: N4,
  abs: dt,
  absDependencies: Nt,
  acos: O4,
  acosDependencies: XU,
  acosh: cC,
  acoshDependencies: jU,
  acot: z4,
  acotDependencies: GU,
  acoth: wC,
  acothDependencies: VU,
  acsc: R4,
  acscDependencies: QU,
  acsch: lC,
  acschDependencies: YU,
  add: We,
  addDependencies: nr,
  addScalar: kr,
  addScalarDependencies: Yr,
  all: XG,
  and: h8,
  andDependencies: ZU,
  andTransformDependencies: WU,
  apply: kp,
  applyDependencies: Tg,
  applyTransformDependencies: KU,
  arg: I4,
  argDependencies: JU,
  asec: fC,
  asecDependencies: _U,
  asech: H4,
  asechDependencies: $U,
  asin: BC,
  asinDependencies: ek,
  asinh: L4,
  asinhDependencies: rk,
  atan: kh,
  atan2: qC,
  atan2Dependencies: tk,
  atanDependencies: VE,
  atanh: q4,
  atanhDependencies: nk,
  atomicMass: C8,
  atomicMassDependencies: ak,
  avogadro: tE,
  avogadroDependencies: ik,
  bellNumbers: xE,
  bellNumbersDependencies: ok,
  bignumber: qr,
  bignumberDependencies: Qt,
  bin: vC,
  binDependencies: sk,
  bitAnd: UC,
  bitAndDependencies: uk,
  bitAndTransformDependencies: ck,
  bitNot: U4,
  bitNotDependencies: lk,
  bitOr: kC,
  bitOrDependencies: fk,
  bitOrTransformDependencies: vk,
  bitXor: XC,
  bitXorDependencies: pk,
  bohrMagneton: E8,
  bohrMagnetonDependencies: dk,
  bohrRadius: nE,
  bohrRadiusDependencies: mk,
  boltzmann: N8,
  boltzmannDependencies: hk,
  boolean: k4,
  booleanDependencies: gk,
  catalan: jC,
  catalanDependencies: xk,
  cbrt: Wh,
  cbrtDependencies: _E,
  ceil: Wp,
  ceilDependencies: Og,
  chain: IE,
  chainDependencies: yk,
  classicalElectronRadius: EE,
  classicalElectronRadiusDependencies: Ak,
  clone: X4,
  cloneDependencies: bk,
  column: fg,
  columnDependencies: r3,
  columnTransformDependencies: wk,
  combinations: zo,
  combinationsDependencies: sd,
  combinationsWithRep: pC,
  combinationsWithRepDependencies: Dk,
  compare: pa,
  compareDependencies: ja,
  compareNatural: pn,
  compareNaturalDependencies: Sn,
  compareText: _h,
  compareTextDependencies: t3,
  compile: HE,
  compileDependencies: Ck,
  complex: Ro,
  complexDependencies: cd,
  composition: a8,
  compositionDependencies: Ek,
  concat: ir,
  concatDependencies: or,
  concatTransformDependencies: Nk,
  conductanceQuantum: B8,
  conductanceQuantumDependencies: Bk,
  config: he,
  conj: ca,
  conjDependencies: Ua,
  corr: NE,
  corrDependencies: Sk,
  cos: Hp,
  cosDependencies: Hg,
  cosh: dC,
  coshDependencies: Pk,
  cot: j4,
  cotDependencies: Mk,
  coth: DC,
  cothDependencies: Fk,
  coulomb: S8,
  coulombDependencies: Tk,
  count: SC,
  countDependencies: Ok,
  create: U3,
  createAbs: Ku,
  createAccessorNode: Rf,
  createAcos: Ql,
  createAcosh: Yl,
  createAcot: Zl,
  createAcoth: Wl,
  createAcsc: Kl,
  createAcsch: Jl,
  createAdd: Sf,
  createAddScalar: Ju,
  createAnd: Co,
  createAndTransform: Tp,
  createApply: Di,
  createApplyTransform: vp,
  createArg: Dc,
  createArrayNode: If,
  createAsec: _l,
  createAsech: $l,
  createAsin: ef,
  createAsinh: rf,
  createAssignmentNode: Hf,
  createAtan: tf,
  createAtan2: nf,
  createAtanh: af,
  createAtomicMass: Gv,
  createAvogadro: Vv,
  createBellNumbers: H0,
  createBigNumberClass: gu,
  createBignumber: Uu,
  createBin: nl,
  createBitAnd: vo,
  createBitAndTransform: zp,
  createBitNot: bc,
  createBitOr: po,
  createBitOrTransform: Rp,
  createBitXor: wc,
  createBlockNode: Lf,
  createBohrMagneton: Cv,
  createBohrRadius: Mv,
  createBoltzmann: Qv,
  createBoolean: qu,
  createCatalan: L0,
  createCbrt: $u,
  createCeil: ec,
  createChain: c0,
  createChainClass: s0,
  createClassicalElectronRadius: Fv,
  createClone: Cu,
  createColumn: go,
  createColumnTransform: pp,
  createCombinations: E0,
  createCombinationsWithRep: N0,
  createCompare: Cl,
  createCompareNatural: El,
  createCompareText: Nl,
  createCompile: Jf,
  createComplex: ku,
  createComplexClass: xu,
  createComposition: q0,
  createConcat: ho,
  createConcatTransform: Cp,
  createConditionalNode: qf,
  createConductanceQuantum: Ev,
  createConj: Cc,
  createConstantNode: Uf,
  createCorr: C0,
  createCos: of,
  createCosh: sf,
  createCot: uf,
  createCoth: cf,
  createCoulomb: wv,
  createCount: Pc,
  createCreateUnit: Vl,
  createCross: Mc,
  createCsc: lf,
  createCsch: ff,
  createCtranspose: Yc,
  createCube: rc,
  createCumSum: So,
  createCumSumTransform: Pp,
  createDeepEqual: Ol,
  createDenseMatrixClass: Du,
  createDerivative: Q0,
  createDet: l0,
  createDeuteronMass: Hv,
  createDiag: Fc,
  createDiff: xo,
  createDiffTransform: Ep,
  createDistance: A0,
  createDivide: y0,
  createDivideScalar: cl,
  createDot: Ff,
  createDotDivide: hl,
  createDotMultiply: Ac,
  createDotPow: ml,
  createE: iv,
  createEfimovFactor: jv,
  createEigs: p0,
  createElectricConstant: Av,
  createElectronMass: Tv,
  createElementaryCharge: Dv,
  createEqual: Bl,
  createEqualScalar: Ru,
  createEqualText: Sl,
  createErf: _c,
  createEvaluate: _f,
  createExp: tc,
  createExpm: d0,
  createExpm1: nc,
  createFactorial: P0,
  createFalse: $0,
  createFaraday: Yv,
  createFermiCoupling: Ov,
  createFft: Wc,
  createFibonacciHeapClass: ql,
  createFilter: Tc,
  createFilterTransform: dp,
  createFineStructure: zv,
  createFirstRadiation: Zv,
  createFix: ac,
  createFlatten: Oc,
  createFloor: lo,
  createForEach: zc,
  createForEachTransform: mp,
  createFormat: tl,
  createFraction: Xu,
  createFractionClass: yu,
  createFreqz: W0,
  createFunctionAssignmentNode: kf,
  createFunctionNode: Wf,
  createGamma: B0,
  createGasConstant: Kv,
  createGcd: oc,
  createGetMatrixDataType: Rc,
  createGravitationConstant: hv,
  createGravity: ip,
  createHartreeEnergy: Rv,
  createHasNumericValue: Mu,
  createHelp: u0,
  createHelpClass: o0,
  createHex: il,
  createHypot: Pf,
  createI: pv,
  createIdentity: Ic,
  createIfft: Kc,
  createIm: Ec,
  createImmutableDenseMatrixClass: Hl,
  createIndex: Of,
  createIndexClass: Ll,
  createIndexNode: Xf,
  createIndexTransform: hp,
  createInfinity: rv,
  createIntersect: b0,
  createInv: f0,
  createInverseConductanceQuantum: Nv,
  createInvmod: yc,
  createIsInteger: Nu,
  createIsNaN: Ou,
  createIsNegative: Su,
  createIsNumeric: Pu,
  createIsPositive: Fu,
  createIsPrime: sl,
  createIsZero: Tu,
  createKldivergence: M0,
  createKlitzing: Pv,
  createKron: Hc,
  createLN10: uv,
  createLN2: sv,
  createLOG10E: lv,
  createLOG2E: cv,
  createLarger: Fl,
  createLargerEq: Tl,
  createLcm: uc,
  createLeafCount: U0,
  createLeftShift: bl,
  createLgamma: S0,
  createLog: vl,
  createLog10: cc,
  createLog1p: pl,
  createLog2: lc,
  createLoschmidt: Wv,
  createLsolve: gl,
  createLsolveAll: yl,
  createLup: r0,
  createLusolve: a0,
  createLyap: x0,
  createMad: D0,
  createMagneticConstant: yv,
  createMagneticFluxQuantum: Bv,
  createMap: Lc,
  createMapTransform: gp,
  createMatrix: ju,
  createMatrixClass: bu,
  createMatrixFromColumns: Qu,
  createMatrixFromFunction: Gu,
  createMatrixFromRows: Vu,
  createMax: Eo,
  createMaxTransform: xp,
  createMean: Po,
  createMeanTransform: yp,
  createMedian: w0,
  createMin: No,
  createMinTransform: Ap,
  createMod: fo,
  createMode: el,
  createMolarMass: np,
  createMolarMassC12: ap,
  createMolarPlanckConstant: Jv,
  createMolarVolume: _v,
  createMultinomial: F0,
  createMultiply: vc,
  createMultiplyScalar: fc,
  createNaN: tv,
  createNeutronMass: Lv,
  createNode: zf,
  createNorm: Mf,
  createNot: Bc,
  createNthRoot: pc,
  createNthRoots: dl,
  createNuclearMagneton: Sv,
  createNull: ev,
  createNumber: Hu,
  createNumeric: ul,
  createObjectNode: jf,
  createOct: al,
  createOnes: qc,
  createOperatorNode: Gf,
  createOr: mo,
  createOrTransform: Op,
  createParenthesisNode: Vf,
  createParse: Kf,
  createParser: e0,
  createParserClass: $f,
  createPartitionSelect: Rl,
  createPermutations: T0,
  createPhi: ov,
  createPi: nv,
  createPickRandom: O0,
  createPinv: v0,
  createPlanckCharge: cp,
  createPlanckConstant: gv,
  createPlanckLength: op,
  createPlanckMass: sp,
  createPlanckTemperature: lp,
  createPlanckTime: up,
  createPolynomialRoot: i0,
  createPow: ll,
  createPrint: wo,
  createPrintTransform: Fp,
  createProd: rl,
  createProtonMass: Iv,
  createQr: t0,
  createQuantileSeq: Fo,
  createQuantileSeqTransform: Sp,
  createQuantumOfCirculation: qv,
  createRandom: z0,
  createRandomInt: R0,
  createRange: yo,
  createRangeClass: Au,
  createRangeNode: Qf,
  createRangeTransform: bp,
  createRationalize: Y0,
  createRe: Nc,
  createReducedPlanckConstant: xv,
  createRelationalNode: Yf,
  createReplacer: J0,
  createReshape: Uc,
  createResize: kc,
  createResolve: G0,
  createResultSet: pu,
  createReviver: K0,
  createRightArithShift: wl,
  createRightLogShift: Dl,
  createRotate: Xc,
  createRotationMatrix: jc,
  createRound: fl,
  createRow: Ao,
  createRowTransform: wp,
  createRydberg: Uv,
  createSQRT1_2: fv,
  createSQRT2: vv,
  createSackurTetrode: $v,
  createSchur: g0,
  createSec: vf,
  createSech: pf,
  createSecondRadiation: ep,
  createSetCartesian: xf,
  createSetDifference: yf,
  createSetDistinct: Af,
  createSetIntersect: bf,
  createSetIsSubset: wf,
  createSetMultiplicity: Df,
  createSetPowerset: Cf,
  createSetSize: Ef,
  createSetSymDifference: Nf,
  createSetUnion: Bf,
  createSign: dc,
  createSimplify: k0,
  createSimplifyConstant: X0,
  createSimplifyCore: j0,
  createSin: df,
  createSinh: mf,
  createSize: Gc,
  createSlu: n0,
  createSmaller: Pl,
  createSmallerEq: Ml,
  createSolveODE: Jc,
  createSort: Il,
  createSpaClass: Ul,
  createSparse: Gl,
  createSparseMatrixClass: Iu,
  createSpeedOfLight: mv,
  createSplitUnit: Yu,
  createSqrt: mc,
  createSqrtm: m0,
  createSquare: hc,
  createSqueeze: Vc,
  createStd: To,
  createStdTransform: Np,
  createStefanBoltzmann: rp,
  createStirlingS2: I0,
  createString: Lu,
  createSubset: bo,
  createSubsetTransform: Dp,
  createSubtract: gc,
  createSubtractScalar: _u,
  createSum: Bo,
  createSumTransform: Bp,
  createSylvester: h0,
  createSymbolNode: Zf,
  createSymbolicEqual: V0,
  createTan: hf,
  createTanh: gf,
  createTau: av,
  createThomsonCrossSection: kv,
  createTo: ol,
  createTrace: Tf,
  createTranspose: Qc,
  createTrue: _0,
  createTypeOf: zu,
  createTyped: vu,
  createUnaryMinus: Zu,
  createUnaryPlus: Wu,
  createUnequal: zl,
  createUnit: aE,
  createUnitClass: Xl,
  createUnitDependencies: zk,
  createUnitFunction: jl,
  createUppercaseE: Ih,
  createUppercasePi: Rh,
  createUsolve: xl,
  createUsolveAll: Al,
  createVacuumImpedance: bv,
  createVariance: Mo,
  createVarianceTransform: Mp,
  createVersion: dv,
  createWeakMixingAngle: Xv,
  createWienDisplacement: tp,
  createXgcd: xc,
  createXor: Sc,
  createZeros: Zc,
  createZeta: $c,
  createZpk2tf: Z0,
  cross: i8,
  crossDependencies: Rk,
  csc: G4,
  cscDependencies: Ik,
  csch: mC,
  cschDependencies: Hk,
  ctranspose: Xp,
  ctransposeDependencies: Lg,
  cube: V4,
  cubeDependencies: Lk,
  cumsum: GC,
  cumsumDependencies: qk,
  cumsumTransformDependencies: Uk,
  deepEqual: Qp,
  deepEqualDependencies: Ug,
  derivative: XE,
  derivativeDependencies: kk,
  det: ag,
  detDependencies: ZE,
  deuteronMass: P8,
  deuteronMassDependencies: Xk,
  diag: Kh,
  diagDependencies: l3,
  diff: VC,
  diffDependencies: jk,
  diffTransformDependencies: Gk,
  distance: QC,
  distanceDependencies: Vk,
  divide: Vr,
  divideDependencies: $r,
  divideScalar: Nr,
  divideScalarDependencies: Tr,
  docs: v4,
  dot: Lo,
  dotDependencies: od,
  dotDivide: Pi,
  dotDivideDependencies: Go,
  dotMultiply: o8,
  dotMultiplyDependencies: Qk,
  dotPow: M8,
  dotPowDependencies: Yk,
  e: Qm,
  eDependencies: f3,
  efimovFactor: S4,
  efimovFactorDependencies: Zk,
  eigs: gg,
  eigsDependencies: m3,
  electricConstant: F8,
  electricConstantDependencies: Wk,
  electronMass: iE,
  electronMassDependencies: Kk,
  elementaryCharge: T8,
  elementaryChargeDependencies: Jk,
  equal: jt,
  equalDependencies: en,
  equalScalar: _e,
  equalScalarDependencies: tr,
  equalText: YC,
  equalTextDependencies: _k,
  erf: Q4,
  erfDependencies: $k,
  evaluate: nd,
  evaluateDependencies: Zg,
  exp: Xh,
  expDependencies: h3,
  expm: O8,
  expm1: Y4,
  expm1Dependencies: rX,
  expmDependencies: eX,
  factorial: Fi,
  factorialDependencies: Xo,
  factory: U,
  falseDependencies: tX,
  faraday: z8,
  faradayDependencies: nX,
  fermiCoupling: yE,
  fermiCouplingDependencies: aX,
  fft: dg,
  fftDependencies: A3,
  filter: Z4,
  filterDependencies: iX,
  filterTransformDependencies: oX,
  fineStructure: h4,
  fineStructureDependencies: sX,
  firstRadiation: oE,
  firstRadiationDependencies: uX,
  fix: og,
  fixDependencies: YE,
  flatten: Mi,
  flattenDependencies: Vo,
  floor: $h,
  floorDependencies: QE,
  forEach: W4,
  forEachDependencies: cX,
  forEachTransformDependencies: lX,
  format: Ni,
  formatDependencies: ko,
  fraction: Ta,
  fractionDependencies: Ii,
  freqz: BE,
  freqzDependencies: fX,
  gamma: Jp,
  gammaDependencies: zg,
  gasConstant: AE,
  gasConstantDependencies: vX,
  gcd: ZC,
  gcdDependencies: pX,
  getMatrixDataType: Lp,
  getMatrixDataTypeDependencies: Rg,
  gravitationConstant: R8,
  gravitationConstantDependencies: dX,
  gravity: sE,
  gravityDependencies: mX,
  hartreeEnergy: I8,
  hartreeEnergyDependencies: hX,
  hasNumericValue: PC,
  hasNumericValueDependencies: gX,
  help: jE,
  helpDependencies: xX,
  hex: K4,
  hexDependencies: yX,
  hypot: WC,
  hypotDependencies: AX,
  i: Lh,
  iDependencies: g3,
  identity: Xn,
  identityDependencies: ha,
  ifft: H8,
  ifftDependencies: bX,
  im: qp,
  imDependencies: jg,
  index: sg,
  indexDependencies: D3,
  indexTransformDependencies: wX,
  intersect: s8,
  intersectDependencies: CX,
  inv: da,
  invDependencies: ka,
  inverseConductanceQuantum: uE,
  inverseConductanceQuantumDependencies: EX,
  invmod: u8,
  invmodDependencies: NX,
  isAccessorNode: In,
  isArray: ur,
  isArrayNode: Mt,
  isAssignmentNode: fh,
  isBigNumber: Ue,
  isBlockNode: vh,
  isBoolean: ah,
  isChain: cu,
  isCollection: Tt,
  isComplex: Wt,
  isConditionalNode: ph,
  isConstantNode: ar,
  isDate: sh,
  isDenseMatrix: oi,
  isFraction: na,
  isFunction: oh,
  isFunctionAssignmentNode: Pa,
  isFunctionNode: An,
  isHelp: uu,
  isIndex: hi,
  isIndexNode: aa,
  isInteger: bt,
  isIntegerDependencies: It,
  isMatrix: Oe,
  isNaN: Bi,
  isNaNDependencies: Qo,
  isNegative: kn,
  isNegativeDependencies: ga,
  isNode: vr,
  isNull: ch,
  isNumber: Xe,
  isNumeric: va,
  isNumericDependencies: qa,
  isObject: gi,
  isObjectNode: xi,
  isOperatorNode: zr,
  isParenthesisNode: un,
  isPositive: la,
  isPositiveDependencies: Xa,
  isPrime: hC,
  isPrimeDependencies: BX,
  isRange: so,
  isRangeNode: dh,
  isRegExp: uh,
  isRelationalNode: mh,
  isResultSet: ih,
  isSparseMatrix: Tn,
  isString: Wr,
  isSymbolNode: Ur,
  isUndefined: lh,
  isUnit: yt,
  isZero: _t,
  isZeroDependencies: hn,
  kldivergence: bE,
  kldivergenceDependencies: SX,
  klitzing: L8,
  klitzingDependencies: PX,
  kron: MC,
  kronDependencies: MX,
  larger: ct,
  largerDependencies: Bt,
  largerEq: Ho,
  largerEqDependencies: ud,
  lcm: c8,
  lcmDependencies: RX,
  leafCount: qE,
  leafCountDependencies: IX,
  leftShift: FC,
  leftShiftDependencies: HX,
  lgamma: _4,
  lgammaDependencies: LX,
  log: Yp,
  log10: $4,
  log10Dependencies: qX,
  log1p: l8,
  log1pDependencies: UX,
  log2: jh,
  log2Dependencies: x3,
  logDependencies: Wg,
  loschmidt: q8,
  loschmidtDependencies: kX,
  lsolve: Jh,
  lsolveAll: KC,
  lsolveAllDependencies: XX,
  lsolveDependencies: N3,
  lup: vg,
  lupDependencies: S3,
  lusolve: mg,
  lusolveDependencies: M3,
  lyap: OE,
  lyapDependencies: jX,
  mad: SE,
  madDependencies: GX,
  magneticConstant: U8,
  magneticConstantDependencies: VX,
  magneticFluxQuantum: cE,
  magneticFluxQuantumDependencies: QX,
  map: fa,
  mapDependencies: Va,
  mapTransformDependencies: YX,
  matrix: De,
  matrixDependencies: Ce,
  matrixFromColumns: jp,
  matrixFromColumnsDependencies: Gg,
  matrixFromFunction: CC,
  matrixFromFunctionDependencies: ZX,
  matrixFromRows: JC,
  matrixFromRowsDependencies: WX,
  max: Kp,
  maxDependencies: Jg,
  maxTransformDependencies: KX,
  mean: xg,
  meanDependencies: s3,
  meanTransformDependencies: JX,
  median: yg,
  medianDependencies: O3,
  min: _C,
  minDependencies: _X,
  minTransformDependencies: $X,
  mod: rg,
  modDependencies: C3,
  mode: EC,
  modeDependencies: ej,
  molarMass: k8,
  molarMassC12: lE,
  molarMassC12Dependencies: tj,
  molarMassDependencies: rj,
  molarPlanckConstant: X8,
  molarPlanckConstantDependencies: nj,
  molarVolume: wE,
  molarVolumeDependencies: aj,
  multinomial: fE,
  multinomialDependencies: ij,
  multiply: fr,
  multiplyDependencies: pr,
  multiplyScalar: Or,
  multiplyScalarDependencies: Ir,
  neutronMass: j8,
  neutronMassDependencies: sj,
  norm: $p,
  normDependencies: Kg,
  not: ao,
  notDependencies: id,
  nthRoot: TC,
  nthRootDependencies: uj,
  nthRoots: $C,
  nthRootsDependencies: cj,
  nuclearMagneton: G8,
  nuclearMagnetonDependencies: lj,
  nullDependencies: fj,
  number: Cn,
  numberDependencies: Yn,
  numeric: Kt,
  numericDependencies: mn,
  oct: eC,
  octDependencies: vj,
  ones: OC,
  onesDependencies: pj,
  or: e8,
  orDependencies: dj,
  orTransformDependencies: mj,
  parse: dn,
  parseDependencies: Pn,
  parser: UE,
  parserDependencies: hj,
  partitionSelect: qo,
  partitionSelectDependencies: vd,
  permutations: vE,
  permutationsDependencies: gj,
  phi: w4,
  phiDependencies: xj,
  pi: _s,
  piDependencies: _g,
  pickRandom: rC,
  pickRandomDependencies: yj,
  pinv: y8,
  pinvDependencies: Aj,
  planckCharge: V8,
  planckChargeDependencies: bj,
  planckConstant: DE,
  planckConstantDependencies: wj,
  planckLength: Q8,
  planckLengthDependencies: Dj,
  planckMass: pE,
  planckMassDependencies: Cj,
  planckTemperature: Y8,
  planckTemperatureDependencies: Ej,
  planckTime: FE,
  planckTimeDependencies: Nj,
  polynomialRoot: dE,
  polynomialRootDependencies: Bj,
  pow: Gt,
  powDependencies: tn,
  print: tC,
  printDependencies: Sj,
  printTransformDependencies: Pj,
  prod: Qh,
  prodDependencies: u3,
  protonMass: Z8,
  protonMassDependencies: Mj,
  qr: Gp,
  qrDependencies: Vg,
  quantileSeq: CE,
  quantileSeqDependencies: Fj,
  quantileSeqTransformDependencies: Tj,
  quantumOfCirculation: W8,
  quantumOfCirculationDependencies: Oj,
  random: nC,
  randomDependencies: zj,
  randomInt: gC,
  randomIntDependencies: Rj,
  range: Ea,
  rangeDependencies: qi,
  rangeTransformDependencies: Hj,
  rationalize: kE,
  rationalizeDependencies: Lj,
  re: Up,
  reDependencies: Qg,
  reducedPlanckConstant: K8,
  reducedPlanckConstantDependencies: qj,
  replacer: M4,
  replacerDependencies: Uj,
  reshape: Yh,
  reshapeDependencies: p3,
  resize: zC,
  resizeDependencies: kj,
  resolve: Pg,
  resolveDependencies: c3,
  reviver: RE,
  reviverDependencies: Xj,
  rightArithShift: RC,
  rightArithShiftDependencies: jj,
  rightLogShift: r8,
  rightLogShiftDependencies: Gj,
  rotate: TE,
  rotateDependencies: Vj,
  rotationMatrix: Ag,
  rotationMatrixDependencies: I3,
  round: Oa,
  roundDependencies: Hi,
  row: g8,
  rowDependencies: Qj,
  rowTransformDependencies: Yj,
  rydberg: J8,
  rydbergDependencies: Zj,
  sackurTetrode: E4,
  sackurTetrodeDependencies: Jj,
  schur: bg,
  schurDependencies: F3,
  sec: aC,
  secDependencies: _j,
  sech: xC,
  sechDependencies: $j,
  secondRadiation: _8,
  secondRadiationDependencies: eG,
  setCartesian: f8,
  setCartesianDependencies: rG,
  setDifference: ug,
  setDifferenceDependencies: H3,
  setDistinct: v8,
  setDistinctDependencies: tG,
  setIntersect: pg,
  setIntersectDependencies: L3,
  setIsSubset: p8,
  setIsSubsetDependencies: nG,
  setMultiplicity: x8,
  setMultiplicityDependencies: aG,
  setPowerset: d8,
  setPowersetDependencies: iG,
  setSize: mE,
  setSizeDependencies: oG,
  setSymDifference: cg,
  setSymDifferenceDependencies: q3,
  setUnion: A8,
  setUnionDependencies: sG,
  sign: Gh,
  signDependencies: v3,
  simplify: Uo,
  simplifyConstant: rd,
  simplifyConstantDependencies: kg,
  simplifyCore: td,
  simplifyCoreDependencies: Xg,
  simplifyDependencies: ld,
  sin: Io,
  sinDependencies: fd,
  sinh: yC,
  sinhDependencies: uG,
  size: _r,
  sizeDependencies: st,
  slu: tg,
  sluDependencies: P3,
  smaller: ut,
  smallerDependencies: St,
  smallerEq: Ca,
  smallerEqDependencies: Li,
  solveODE: hE,
  solveODEDependencies: cG,
  sort: m8,
  sortDependencies: lG,
  sparse: AC,
  sparseDependencies: fG,
  speedOfLight: $8,
  speedOfLightDependencies: vG,
  splitUnit: iC,
  splitUnitDependencies: pG,
  sqrt: $t,
  sqrtDependencies: gn,
  sqrtm: b8,
  sqrtmDependencies: dG,
  square: oC,
  squareDependencies: mG,
  squeeze: NC,
  squeezeDependencies: hG,
  std: PE,
  stdDependencies: gG,
  stdTransformDependencies: xG,
  stefanBoltzmann: eE,
  stefanBoltzmannDependencies: yG,
  stirlingS2: hg,
  stirlingS2Dependencies: WE,
  string: sC,
  stringDependencies: AG,
  subset: Rt,
  subsetDependencies: Vt,
  subsetTransformDependencies: bG,
  subtract: Br,
  subtractDependencies: Hr,
  subtractScalar: Xt,
  subtractScalarDependencies: rn,
  sum: Zp,
  sumDependencies: Ig,
  sumTransformDependencies: wG,
  sylvester: wg,
  sylvesterDependencies: T3,
  symbolicEqual: LE,
  symbolicEqualDependencies: DG,
  tan: uC,
  tanDependencies: CG,
  tanh: bC,
  tanhDependencies: EG,
  tau: Uh,
  tauDependencies: y3,
  thomsonCrossSection: rE,
  thomsonCrossSectionDependencies: NG,
  to: IC,
  toDependencies: BG,
  trace: t8,
  traceDependencies: SG,
  transpose: Si,
  transposeDependencies: jo,
  trueDependencies: PG,
  typeOf: Vh,
  typeOfDependencies: R3,
  typed: Z,
  typedDependencies: W,
  unaryMinus: vn,
  unaryMinusDependencies: Bn,
  unaryPlus: Ip,
  unaryPlusDependencies: qg,
  unequal: HC,
  unequalDependencies: MG,
  unit: gE,
  unitDependencies: FG,
  usolve: Vp,
  usolveAll: ng,
  usolveAllDependencies: d3,
  usolveDependencies: Yg,
  vacuumImpedance: w8,
  vacuumImpedanceDependencies: zG,
  variance: _p,
  varianceDependencies: $g,
  varianceTransformDependencies: RG,
  version: B4,
  versionDependencies: IG,
  weakMixingAngle: T4,
  weakMixingAngleDependencies: HG,
  wienDisplacement: D8,
  wienDisplacementDependencies: LG,
  xgcd: Zh,
  xgcdDependencies: E3,
  xor: LC,
  xorDependencies: qG,
  zeros: Kr,
  zerosDependencies: ot,
  zeta: ME,
  zetaDependencies: UG,
  zpk2tf: n8,
  zpk2tfDependencies: kG
}, Symbol.toStringTag, { value: "Module" })), k3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANDSURBVHgB7Zk9TBNhGMef9/ohHyaiYiIOpYPGFGKigcgEaFhwInEkGmkcZCM6O7g5wiiLYIwuRuOogzGAk8HohIMkXhnUhEIwlq9C7/X5v/S43rXHXQuFI+Gf9OPevHfP756v9/pWUF4DY7IhS2tDkuiakBTnoTjtr3QpSBcGPXt5t3bcHBRbcKvxrKSPBwDlJj0q6Pp4slZXgP1PV39ScOBMMWTNlVD/2OoAHwxQ8NSQk5vrmiRxhwIqzsluTUgZp4CK8y+uUfByr1AKMNAKPGCY9kAvkjXb319/3aQ33zZpr3QU4t3Kd4hvd0So+ZTwnNd1IUQtTaXvO7Vg0PPP5YXfN+D8P4PqIsWG66L243o+Tkv72DIv9CtZ/tygsuUb8N1Mjt9zReNnjgtqbw5tH0+nDBr9VAGJi8qq4np+xIg5wgxA25xjghJniz2dzkiaz0iqKmBbTKN7nRHPOW2xaNH48Ids9QEnZ3Pq5Ue9LSFVWKZSi+XDQVVrM4kmKy9nfhsVeQ/y7UHkFYoBVYu8g0G0DXjm+x/DNlcVTsy69ymfXq8IEGDIO2cxJPB23vISICd/5NRnW8waR3F8mTOoUu0I2M6G7vdEVIhGpzZojr2FngahaSuv8pwEN2Z8N6t3JWuFc4Khl7OVhdcT8FZHWHmlVF9DaFOLOdUf4d2bl8NqFYHqopa3saqkMyHl2T2tYhiB4eEZ7/yBYdzENIfyQY+9DRV6tjAN/MK6AtbnW5nf8CDkg53W5ZAWzjW5ElhXQJyEXOriQvB6vutt5Z531fKc+UzoDL0XLIrJ6ZDQpb6Hj9wMnzuh0Y3WsFroZ+eNkkYGucJ7LoaL4CCcB6NoM0iZ5tOl2665nsPGr792QME/2l39i4s+7otSY77FmP1uKz/txYB28oQr3dkTnSBuHsX5Q6/Wi8Z3BDRhsGx180UbHb0QKaAvSHrPhTQ9578ZlwJFGyu1jHoCFgqFYHoNcOkM7arHmaAK0OURrSzAg9DRj6bd6lAA6hRc6dh+0ymgwpYwtt8mKKDCfrUW1dZGKJhh1rGZro0nTy4ZvGFNwYLU80xkW7uwX40t4fyua5z2V/w3hOC/IeTEilYz8jYpljD4H6EMa4zBe80TAAAAAElFTkSuQmCC", ZG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN1SURBVHgB1VlLTBNRFD0zVCDBAokJHxtN1ZB0I8ZEWWiiNFLW1LWlLCWYuIEFrFyBiSxcQNiK3VvWfASMsCCaiJLQhACNpkKJGBzAlFIZ3512agudmTdtxfEk/d15M3Pevffc9+ZWQArO6ebq8tLSx5DlZsiCE4LsxGlCFsLsnmEcYTR0Z+KFahbozTXd7ETpmWnIcMIKEBBG/NAdcs+EkwTnPOuWIaeCkYzFD6+XuN54OtiPDlgP1TZRPBAhwg+rQhDuipYLbSYYN5GF1wmrQiCCFocNJuEoq8W9c7eVT7utQrF9jUWxvL+KBWkRu4l9FBPcBJsqG9F10YemqmuaYyRGbur7HIY/BxA5iKIYEFxvPbLRoN5LnWg/7wUviNzA+gimtudRKAxzsL+hxxQ5AoV/yPUE3hoPCoUuwfb6+1k3Ic9Q+HJ5ZmxrXDkmZeQgeZ7IFgLNHLTbzqLdke25pyxsk4xcUii30vbdxB56Vwb/nJfyOH3vb+iGf6kHRSdIYjg+ex/zqHS4p6j4xGTqvYqHM4mr1yG156tuTZGYFYYKIknhXthZhKO8Lj1JKkMh9jKrbk0PVpZUwCxebgQR2ltFG8vbrgu+nGOCqVzlJaopEumXuZBQWbGXJHNOr1Z6a1oxeSOgOQFuglRweUEhdZTVmSorj1jRp7w1gibBhR8fucMQYUtdZr6Gfq6ij6k683z6Trbl/bUskkZlSLcO9q08gxGmtudws6ox2/ZtXsk1mmSaNMtNso1Fx9M2Uj+FXA+GSx3NUi9fBtZG0Hu584SdFOuquMJhW4P3w0PN6xsudUNMceRJSaOO7WqI6TgRLZu6I8qbIIFCValxITsrR1IBW6xIbFP3ONd2i8oGkQhsvEKQ5ZCjvJZtv5KlJBKP4jXLw7baVuQDqgAFE4wcbKLl/YP0ckWKzBQArcX5EKTrBLcmdMdwh1hvLaXjw18CMAOKiP9Tt+G4oj2TkJh4SZLn/EvdXHW2qA9NRLLlnU/Jq1zCUW0kDCo5PODa8ucLKiuq+mm1IY/RyjF6dVCpfTxbsL9KUA+8e8R/9lzMu4G1/IP7f0BQZs1Cq4JxE5VuplXBWsLMg/IsrIojYVSMJRLPWaMwDKuBcaJmuhh2z+wgLrotRZK4ECekuvwqlH41tYSp63rajU0SK/0NIWOWoqo4juE3WuaMWUgcILcAAAAASUVORK5CYII=";
var WG = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "buyVipWayPc" }, [t("div", { staticClass: "title color_text_1", class: { isVipContent: e.orderType == 0 } }, [e._v("支付方式")]), t("div", { staticClass: "pay-way" }, [e.currentPackage.auto ? e._e() : t("div", { staticClass: "pay-way_type" }, [t("div", { staticClass: "type_wechat", class: n.payWay === "weixin" ? ["active", "color_label_2", "color_text_vip_2"] : "color_text_2", on: { click: function(a) {
    return n.changePayWay("weixin");
  } } }, [e._m(0), n.payWay === "weixin" ? t("div", { staticClass: "arrow color_label_2" }) : e._e()]), t("div", { staticClass: "type_alipay", class: n.payWay === "alipay" ? ["active", "color_label_2", "color_text_vip_2"] : "color_text_2", on: { click: function(a) {
    return n.changePayWay("alipay");
  } } }, [e._m(1), n.payWay === "alipay" ? t("div", { staticClass: "arrow color_label_2" }) : e._e()])]), t("div", { staticClass: "pay-way_qrcode", class: { "pay-way_qrcode_auto": e.currentPackage.auto } }, [e.useView === "vip" && (!e.isLogin || e.currentPackage.auto && e.vipInfo.auto) ? t("div", { staticClass: "no-qrcode" }, [e.isLogin ? e._e() : t("div", { staticClass: "no-qrcode_login color_text_2", on: { click: n.goToLogin } }, [e._v("点我购买")]), e.isLogin ? t("div", { staticClass: "no-qrcode_auto color_text_2" }, [e._v("已购买过")]) : e._e()]) : n.isFrequent ? t("div", { staticClass: "frequent", on: { click: n.getPayOrder } }, [t("div", { staticClass: "frequent-qrcode color_text_2" })]) : t("div", { staticClass: "haved-qrcode", on: { click: n.getPayOrder } }, [n.payWay === "weixin" || n.payWay == "alipay" && e.currentPackage.auto ? t("img", { staticClass: "qrcode", attrs: { src: n.qrCode.codePayUrl } }) : e._e(), n.payWay === "alipay" && !e.currentPackage.auto ? t("iframe", { staticClass: "qrcode iframe", attrs: { src: n.qrCode.codePayUrl, frameborder: "0", width: "89.66", height: "89.66", scrolling: "no" } }) : e._e()]), t("div", { staticClass: "price-content" }, [t("div", { staticClass: "price" }, [t("div", { staticClass: "pay_sum color_text_1" }, [e._v("支付金额：")]), t("div", { staticClass: "price_num color_vip_price" }, [t("span", { staticClass: "unit" }, [e._v("￥")]), t("span", { staticClass: "num" }, [e._v(e._s(n.currentPackageRealPrice))])])]), e.currentPackage.auto ? t("div", { staticClass: "price-content-pay_type color_text_3" }, [t("img", { staticClass: "icon", attrs: { src: k3 } }), t("span", { staticClass: "pay_type" }, [e._v("使用支付宝扫码支付")])]) : e._e(), t("div", { staticClass: "desc color_text_3" }, [e._v(e._s(e.currentPackage.desc))]), t("div", { staticClass: "regulation color_text_3" }, [t("span", [e._v("开通前阅读并同意")]), t("span", { staticClass: "service-agreement color_text_2", on: { click: n.openServiceAgreement } }, [e._v("《会员服务协议》")]), t("span", { staticClass: "renewal color_text_2", on: { click: n.openRenewalRule } }, [e._v("《自动续费规则》")])])])])])]);
}, KG = [function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "content" }, [e("img", { staticClass: "icon", attrs: { src: ZG } }), e("span", { staticClass: "name" }, [r._v("微信")])]);
}, function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "content" }, [e("img", { staticClass: "icon", attrs: { src: k3 } }), e("span", { staticClass: "name" }, [r._v("支付宝")])]);
}];
const JG = {
  __name: "buyVipWay",
  props: {
    currentPackage: Object,
    orderType: Number,
    vipInfo: Object,
    isLogin: Boolean,
    useView: String,
    isSVip: Boolean,
    isHaveWalfare: Boolean,
    routeQuery: Object,
    debug: Boolean,
    unionChooseList: Array,
    couponInfo: Object,
    activeTab: String
  },
  emits: ["buyVipSuccess"],
  setup(r, { emit: e }) {
    const t = r, { proxy: n } = yn();
    let a;
    a = (w) => {
      n.$toast instanceof Function ? n.$toast(w) : n.$toast instanceof Object && n.$toast.show(w);
    }, console.log("activeTab bugvip", t.activeTab);
    const i = t.debug ? Sr : Pr, u = ue("weixin"), f = ue({
      orderId: "",
      codePayUrl: ""
    }), c = ue(), o = ue(!1), s = ue(!1), l = ue(null), v = ue(""), p = dr(() => {
      var w, A;
      if (t.useView === "vip") {
        const E = ((w = t.unionChooseList) == null ? void 0 : w.reduce((D, B) => We(D, qr(B.price)), qr(0))) || 0, N = We(qr(t.currentPackage.price || 0), qr(E));
        return Br(qr(N), qr(((A = t.couponInfo) == null ? void 0 : A.couponPrice) || 0));
      }
      return t.currentPackage.price;
    });
    hr(() => {
      console.log("opener", window.opener), window.opener !== null && (l.value = window.opener);
    }), Je(
      () => u.value,
      () => {
        m();
      },
      { deep: !0 }
    ), Je(
      () => t.unionChooseList,
      () => {
        m();
      },
      { deep: !0 }
    ), Je(
      () => t.couponInfo,
      () => {
        m();
      },
      { deep: !0 }
    ), Je(
      () => t.currentPackage,
      (w) => {
        w.auto ? u.value = "alipay" : u.value = "weixin", m();
      },
      { deep: !0 }
    ), Je(
      () => f.value.orderId,
      (w) => {
        b(w);
      },
      { deep: !0 }
    ), Je(() => t.routeQuery, (w) => {
      w != null && w.source ? v.value = w.source : w != null && w.keyfrom ? v.value = w.keyfrom : v.value = t.isSVip ? "web_renew_vip" : "web_open_vip";
    }, { immediate: !0 });
    function h() {
      window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${encodeURIComponent(window.location.href)}&t=${(/* @__PURE__ */ new Date()).getTime()}`;
    }
    function d() {
      const w = "https://c.youdao.com/dict/law/VIP.html";
      window.open(w);
    }
    function x() {
      const w = "https://c.youdao.com/dict/law/renew.html";
      window.open(w);
    }
    function g(w) {
      u.value = w;
    }
    function y(w) {
      const A = document.cookie, E = `${w}=`, N = A.length;
      let C = 0;
      for (; C < N; ) {
        const D = C + E.length;
        if (A.substring(C, D) === E) {
          let B = A.indexOf(";", D);
          return B === -1 && (B = N), unescape(A.substring(D, B));
        }
        if (C = A.indexOf(" ", C) + 1, C === 0)
          break;
      }
      return -1;
    }
    function m() {
      var E, N;
      console.log("cookie", document.cookie);
      const A = {
        imei: y("OUTFOX_SEARCH_USER_ID_NCOO"),
        keyfrom: "webdict",
        apiversion: "1.0",
        paytype: u.value,
        platform: "webdict",
        pid: t.currentPackage.planId,
        orderType: t.orderType,
        // 0为会员订单
        source: v.value,
        couponId: t.orderType === 0 && t.couponInfo.couponId || "",
        unionId: t.orderType === 0 && ((N = (E = t.unionChooseList) == null ? void 0 : E.map((C) => C.id)) == null ? void 0 : N.join(",")) || "",
        channel: mr.getParameterByName("keyfrom")
      };
      i.getPayOrder(A).then((C) => {
        C.success ? (s.value = !1, f.value.orderId = C.orderId, u.value === "alipay" && !t.currentPackage.auto && (f.value.codePayUrl = C.url), (u.value === "weixin" || t.currentPackage.auto) && (f.value.codePayUrl = Ms.getQrBase64(C.url, {
          padding: 0,
          width: 128,
          height: 128
        }))) : C.errorCode === 2308 ? (s.value = !0, a("操作频繁，请稍后重试")) : console.log("其他操作");
      });
    }
    function b(w) {
      const A = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        platform: "webdict",
        orderid: w,
        orderType: t.orderType
        // 0为会员订单
      };
      o.value = !1, clearInterval(c.value);
      let E = 0;
      c.value = setInterval(() => {
        i.getOrderStatus(A).then((N) => {
          N.success ? (o.value = !0, t.isHaveWalfare ? a("购买成功，可在会员中心页面下方【我的福利】中查看权益") : a("支付成功"), clearInterval(c.value), t.useView === "vip" ? e("buyVipSuccess") : t.useView === "vipRecharge" ? e("buyVipMoreSuccess") : e("buyVipSuccess")) : E <= 600 ? E++ : clearInterval(c.value);
        });
      }, 1e3);
    }
    return n1(() => {
      console.log("buyVipWay onUnmounted"), clearInterval(c.value), c.value = null;
    }), { __sfc: !0, proxy: n, Toast: a, props: t, emits: e, service: i, payWay: u, qrCode: f, timer: c, isSucceed: o, isFrequent: s, win: l, source: v, currentPackageRealPrice: p, goToLogin: h, openServiceAgreement: d, openRenewalRule: x, changePayWay: g, _rl_get_cookie: y, getPayOrder: m, getPayStatus: b, ref: ue, computed: dr, watch: Je, onMounted: hr, isVue2: ru, isVue3: Ym, getCurrentInstance: yn, onUnmounted: n1, jrQrcode: Ms, serviceDev: Sr, serviceProd: Pr, math: YG, util: mr };
  }
};
var _G = /* @__PURE__ */ Rr(
  JG,
  WG,
  KG,
  !1,
  null,
  "5907a431",
  null,
  null
);
const t1 = _G.exports, Yo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ9SURBVHgB7ZjfddowFIev7JK8MgLdgBHKBnAAg5/qTpB2gpIJWiYoeYJQctwNSidoRmAEXltq3+r6xCTxH0lG12/6XgBLtn6fhG1JAA6Hw+GwQJhUWsdxT/xLh4hwDIPxClrmfhcP0yTtw5W3Ckejg6quViALf0p/y6/d7IAHq/lk/AFaYrN9+CY/oqefRw+SQRAEj3X1PdDxN40gD0+kEG12WSPsFMIT3QT9oeocvYCAQ+lYCxIV4evbf4FWgP7zKPCuVMAoURceEe9095x+BCThdBLJyy1LBQwSyvCzSaQ730iAmAeTj4jpbanAQqL2byM7yyQ8YSxAhLPpgkuivufhljoLDDF6DxRZ339fCOF9LhUYPmJV4cPZeAENuEiAqJUQYn/9Rowkx6rzOMNnzYEFtRKAj9cdf1CU4A5PWAkQphJthCesBQiVBIJYCiHey6TvSqWW4QkWAaJeohqO8ASbAGEqwRWeYBUgNtvdV3nZG0WV1Tzgm802epGZIOdNP5TlAL+AEVaBOI67AsUXVR0BeEP1gAk2AQr155T8lBH76pqiT/VooQQMsNwD5uFfccCON9AtGXVYj4A6PC5lyLeVE0AAWqpaj4TVCKjCFx+Vikes1UhcLNAkfE4bEhcJXBI+h1uisYBN+BxOiUYCT3tEMjz0imVNpwfr7UMkG69axTWSMBbgDH++JoOE+dYic/jztS0lTLcWWwl/bsNCQvsiEyekHYJe8TjnlDjbPAOomqHKzkuUOxRaARm0W3GMLXyOSkJ1nlbAF4Lm98+L8zT9xB0+p0LiiImvHAGzm3gd97xO0k8Rj+F0uoeWydu78v193faMw+FwOBzEf/KSrfgcsNNoAAAAAElFTkSuQmCC";
var $G = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "more-content color_bg_vip_1" }, [t("div", { staticClass: "vip-recharge_container" }, [t("img", { staticClass: "close-btn", attrs: { src: Yo }, on: { click: n.closeMorePackage } }), t("div", { staticClass: "title one-level color_text_1 remain" }, [e._v("余额")]), t("div", { ref: "transRef", staticClass: "trans-record", on: { scroll: n.onTransScroll } }, [n.recordList.length > 5 ? t("div", { staticClass: "btn-mask left", on: { click: function(a) {
    return n.handleTransScroll(-252);
  } } }, [t("img", { staticClass: "btn", class: n.btnClass.left, attrs: { src: "https://ydlunacommon-cdn.nosdn.127.net/e1028b8c11229daaac767f61f8369d96.png" } })]) : e._e(), t("div", { staticClass: "trans-cell" }, e._l(n.recordList, function(a, i) {
    return t("div", { key: `record-item_${i}`, staticClass: "tran-item" }, [t("div", { staticClass: "title color_text_vip_2", class: { "loading-title": !n.isShowRemain }, domProps: { innerHTML: e._s(n.isShowRemain ? a.name : "") } }), t("div", { staticClass: "num color_text_vip_0", class: { "loading-num": !n.isShowRemain } }, [e._v(e._s(n.isShowRemain ? a.value : ""))])]);
  }), 0), n.recordList.length > 5 ? t("div", { staticClass: "btn-mask right", on: { click: function(a) {
    return n.handleTransScroll(252);
  } } }, [t("img", { staticClass: "btn", class: n.btnClass.right, attrs: { src: "https://ydlunacommon-cdn.nosdn.127.net/e10d231d1a6b8d4ff98735bd248ac1cb.png" } })]) : e._e()]), t("div", { staticClass: "title one-level color_text_vip_2 plan-title" }, [e._v("超级会员加量包")]), t("div", { staticClass: "plan-type" }, e._l(n.typeList, function(a, i) {
    return t("div", { key: i, staticClass: "type color_label_2 color_text_2", class: { active: n.typeIndex === a.value }, on: { click: function(u) {
      return n.selectType(a.value);
    } } }, [e._v(e._s(a.name))]);
  }), 0), t("div", { ref: "planContent", staticClass: "plan-content", class: { "mutil-plan_content": n.planList.length > 3 } }, [e._l(n.planList, function(a, i) {
    return t("div", { key: i, staticClass: "plan-item color_label_1", class: { active: n.planIndex === a.planId }, style: { "margin-right": i === n.planList.length - 1 ? "0px" : "14px" }, on: { click: function(u) {
      return n.selectPlan(a, i);
    } } }, [t("div", { staticClass: "title color_text_vip_0" }, [e._v(e._s(a.permissions))]), t("div", { staticClass: "plan-price" }, [t("span", { staticClass: "mark color_text_vip_0" }, [e._v("¥")]), t("span", { staticClass: "price color_text_vip_0" }, [e._v(e._s(a.price))])])]);
  }), n.expire ? t("div", { staticClass: "plan-expire color_text_4" }, [e._v("有效期至" + e._s(n.expire) + "（剩" + e._s(n.limit) + "天）")]) : e._e()], 2), t("div", { staticClass: "pay-area" }), t(n.buyVipWay, { attrs: { debug: e.debug, routeQuery: e.routeQuery, currentPackage: n.currentPackage, orderType: n.orderType, useView: "vipRecharge" }, on: { buyVipMoreSuccess: n.buyVipMoreSuccess } })], 1)]);
}, eV = [];
const rV = {
  __name: "morePackage",
  props: {
    debug: {
      type: Boolean
    },
    routeQuery: {
      type: Object
    },
    isSVip: {
      type: Boolean
    },
    // 2024-08-05新增，是否展示AI PPT
    isShowPPT: {
      type: Boolean,
      default: !0
    },
    activeTab: {
      type: String
    },
    isShowSlidePackage: {
      type: Boolean
    },
    morePackageTypeIndex: Number
  },
  emits: ["closeMorePackage", "buyVipMoreSuccess"],
  setup(r, { emit: e }) {
    const t = r, n = t.debug ? Sr : Pr, a = ue(null), i = ue(1), u = ue([
      {
        name: "文档翻译字符数",
        value: 0
      },
      {
        name: "音频翻译时长",
        value: 0
      },
      {
        name: "同传翻译时长",
        value: 0
      },
      {
        name: `EPUB电子书
翻译次数`,
        value: 0
      }
    ]), f = ue([
      {
        name: "PPT生成次数",
        value: 0
      },
      {
        name: "PPT保存导出次数",
        value: 0
      },
      {
        name: "我的云空间存储",
        value: 0
      }
    ]), c = ue([
      {
        name: "文档翻译",
        value: 1
      }
    ]), o = [
      {
        name: "PPT生成/导出",
        value: 7
      },
      {
        name: "云空间存储",
        value: 8
      }
    ], s = ue([]), l = ue(t.morePackageTypeIndex ?? 1), v = ue(""), p = ue(""), h = ue(""), d = ue({}), x = ue(""), g = ue(""), y = ue("");
    function m() {
      e("closeMorePackage");
    }
    function b(k) {
      l.value = k, A(k);
    }
    function w(k, L) {
      v.value = k.planId, k.expire ? (p.value = mr.dateFormat("yyyy.MM.dd", new Date(k.expire)), h.value = Math.ceil(k.timeLeft / (1 * 24 * 60 * 60 * 1e3))) : p.value = "", d.value = k, L >= 3 ? a.value.scrollTo({
        left: 286,
        behavior: "smooth"
      }) : L <= 2 && a.value.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
    function A(k) {
      const L = {
        increaseType: k,
        imei: "1",
        keyfrom: "dictweb",
        apiversion: "1.0",
        product: "webdict",
        platform: "webdict"
      };
      n.getPlans(L).then((R) => {
        s.value = R.data.planList;
        const X = s.value[0];
        w(X);
      });
    }
    function E() {
      return new Promise((k) => {
        const L = {
          src: y.value
        };
        n.getDetailInfo(L).then((R) => {
          u.value[0].value = R.data.userAvailCount, u.value[3] && (u.value[3].value = R.data.availChaptersNum);
        }).finally(() => {
          k(!0);
        });
      });
    }
    async function N() {
      return new Promise((k) => {
        const { signData: L, mysticTime: R } = mr.getAudioSign();
        n.getAudioInfo(L, R).then((X) => {
          u.value[1].value = mr.secondToformat(X.relatedObject.audioTransRemainTime);
        }).finally(() => {
          k(!0);
        });
      });
    }
    async function C() {
      return new Promise((k) => {
        n.getSyncInfo().then((L) => {
          u.value[2].value = mr.secondToformat(L.data.remainTime);
        }).finally(() => {
          k(!0);
        });
      });
    }
    const D = "0ACRbNDAvBHIGrps", B = "aippt-web-api";
    async function S() {
      return new Promise((k) => {
        const L = qt.genParamV3({}, D, B, "ai-ppt-web", "webdict", "aippt.web");
        n.getSLideRemain(L).then((R) => {
          console.log("getSLideRemain res", R), R.code === 200 && (console.log("recordList", u, "slideRecord", f.value), f.value[0].value = R.data.createOutlineRemain, f.value[1].value = R.data.exportPPTRemain);
        }).finally(() => {
          k(!0);
        });
      });
    }
    async function F() {
      return new Promise((k) => {
        const L = qt.genParamV3({}, D, B, "ai-ppt-web", "webdict", "aippt.web");
        n.getSlideStore(L).then((R) => {
          if (R.code === 200) {
            const X = ((R.data.total - R.data.used) / 1073741824).toFixed(2);
            f.value[2].value = X > 0 ? `${X}G` : 0;
          }
        }), k(!0);
      });
    }
    const I = ue(!1);
    async function z() {
      await E(), await N(), await C(), await S(), await F(), I.value = !0;
    }
    function P() {
      y.value = "web", A(l.value), z(), e("buyVipMoreSuccess");
    }
    hr(() => {
      y.value = "web", t.isShowPPT && (t.activeTab === "aipptVip" || t.isShowSlidePackage) && (l.value = t.morePackageTypeIndex ?? o[0].value), A(l.value), z();
      const k = [
        {
          name: "音频翻译",
          value: 2
        },
        {
          name: "同传翻译",
          value: 4
        },
        {
          name: "电子书翻译",
          value: 5
        }
      ];
      t.isShowPPT && t.activeTab === "aipptVip" || t.isShowPPT && t.isShowSlidePackage ? (c.value = o, u.value = f.value) : t.isSVip && (c.value = c.value.concat(k).concat(o), u.value = u.value.concat(f.value));
    });
    const M = ue(null), H = a1({
      left: "left--disabled",
      right: ""
    });
    return { __sfc: !0, props: t, service: n, planContent: a, orderType: i, recordList: u, slideRecordList: f, typeList: c, slideList: o, planList: s, typeIndex: l, planIndex: v, expire: p, limit: h, currentPackage: d, platForm: x, vendor: g, src: y, emits: e, closeMorePackage: m, selectType: b, selectPlan: w, getPlans: A, fetchDetail: E, fetchAudio: N, fetchSync: C, key: D, keyId: B, fetchSlideRemain: S, fetchSlideUsage: F, isShowRemain: I, getDetailInfo: z, buyVipMoreSuccess: P, transRef: M, btnClass: H, onTransScroll: (k = null) => {
      const { scrollWidth: L, scrollLeft: R, clientWidth: X } = M.value;
      R === 0 ? H.left = "left--disabled" : R === L - X ? H.right = "right--disabled" : (H.left = "", H.right = "");
    }, handleTransScroll: (k) => {
      M.value.scrollTo({ left: k, behavior: "smooth" });
    }, ref: ue, computed: dr, watch: Je, onMounted: hr, reactive: a1, serviceDev: Sr, serviceProd: Pr, util: mr, buyVipWay: t1, v3: qt };
  }
};
var tV = /* @__PURE__ */ Rr(
  rV,
  $G,
  eV,
  !1,
  null,
  "7de1a764",
  null,
  null
);
const X3 = tV.exports, j3 = Lt.serviceUrl.dev.VUE_APP_DICT_URL, nV = ["option_avatar", "nickname"], aV = () => Mr(`${j3}/login/acc/query/accountinfo`, { withCredentials: !0 }), iV = (r) => Mr(`${j3}/profile/batch/get?content=${encodeURIComponent(JSON.stringify(nV))}`, r), $s = {
  getAccountInfos: aV,
  getBatchUrl: iV
}, G3 = Lt.serviceUrl.prod.VUE_APP_DICT_URL, oV = ["option_avatar", "nickname"], sV = () => Fr(`${G3}/login/acc/query/accountinfo`, { withCredentials: !0 }), uV = (r) => Fr(`${G3}/profile/batch/get?content=${encodeURIComponent(JSON.stringify(oV))}`, r), eu = {
  getAccountInfos: sV,
  getBatchUrl: uV
};
var cV = function() {
  var e = this;
  return e._self._c, e._m(0);
}, lV = [function() {
  var r = this, e = r._self._c;
  return e("div", { staticClass: "no-data color_bg_3" }, [e("div", { staticClass: "content" }, [e("div", { staticClass: "no-data_img" }), e("div", { staticClass: "no-data_content color_text_2" }, [r._v("暂无待领取福利")])])]);
}];
const fV = {
  data() {
    return {};
  }
};
var vV = /* @__PURE__ */ Rr(
  fV,
  cV,
  lV,
  !1,
  null,
  "1e09b743",
  null,
  null
);
const pV = vV.exports, V3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIISURBVHgBxVbdcdNAEN5dy5rhTSWYDkIBCcqrgRmnApsKAhWAO4grQOkgD8TwhiYpAHeA6MBvzEjyLftJUSajyLHjxJdv5nzy7eq+298TkWdwe0FHcVSWdMArihxTRDuAhTLMQUALvkiXnYTF+zgm1S82YnpW8CII+cSIs1vC8t3RWJUS2iOYaRJcXp3zv1E8CAr3m3Q39z0CyyCUN9Iv4Ma9kwFRmbtPoqQH5A38Vux3QN6gA/HkzgaRkGe8KOGsP79iEjnuUgycvIZciTMmTupn+djI8b89IIf+OsIx2lr/e5q2lUDAP9Os/HA4Ygs8PYB8GE8wbK9BOE+TlePjdYRVndQEen5Xqed4ilmdnNIGMLlvGLbXHxjwyg5qi4suQuAUStYRzkypbrrMKaxDR9q9z/JyHWFU5KtR1eGVZlhQdZW1VUfaDlNl/YxcwD7tg97LUmYZY4aV1tmzcH6d4CVVndAWsGT5Gl5en+Fqwg3Uy/XXXXlw7w07DRTtdKkF/wRLvXwVd1ydnSiGR4rZYlgb0JJ316HW7rMsuwm2bOvOjVhHWFmJx3x4ONlUCk8nNLBqFcsmps8FbnzeKWROupIFyYRyUXKWgRw3upg3JdeDhPuA3Ba4HyxFlT0Scib2DbkgT3Ckfy1LeUae0FNJBNeRPfsgnQU/0ouqDq3/4Vqa0v4wveGg/48Q6Rr6BAXeAAAAAElFTkSuQmCC", Q3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAcCAYAAACdz7SqAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMjSURBVHgBvVddUtswEN6V4/Ca3sCcoOkBCuatBWaaGzQ5AeUEiU8APQFwgoZpgb5FwAGaG+Ab1H2i9Y+2KzlKnDh2AkzYmUSytNpP3p9PMsKCJIe+D6Q+EWEHkVpA0ILnCkIEhCEijB0XAxzKMB8uSHy4c4QKTmFzMnCv74IpaLz/vouAZ7BhyYiOC6C7DwjkweYlauh/E0elvKesNPECHJs+kf+ElS1h1ijwVih+5V+wgDp2r273yMXj4igRXBCIHgGGVcZEvj6rzFD2f9hoilNOgEERWBH9MfPpLLs1YPPmrtu8ludsWNaCImElKAF4WaxG1PFbBhhzlyKRzIGytt2cuyW+6H6yv9MnoG6VzQbUi3ZrxMCQ/QOfM5zrli758dIlZ2jA0BlzfAKtk8RZ57HjS4gVTryiX+Zo0ShOdjbgpl/akRLb+DMv6OfI4wffawj1ULJbtygRNOJSKo2z6y622NX8Vp4T06jaAi0drQWtqltXiXPTJqRj58ETpRpUiD33h5RQt/jqtsdNr05nmYsrQSnL2kwa8yANGDNpR7pvCGU2HloyL44bO0s4oBIUEU+YpYpDfErcSWOYS4LnBnYiiyHkknpnNqSUD4WkxCW2BawSRGlcnZMDJAc7J9wMiiq6llNOKFvLqxipumQ0GGJg46oNWteuK9rVlKkun6efi+PViTQB1GBprI7iFJCNSBvXeN9vo5g/4O1c+tHvOFumL5lQPDa2JihRnz2wmyZKU1tL5PFlb4g3+Z7UCNTCreKv2AbNYEL1Oc6t9GBXKgJ/sV7rQFmZF8zr6ytHNDkKS3xt2YsMl3P9EnWXJdIq7p1Y490rCpo39+Yqw/0zLKlAOOvXE4YBJaSIT5q5iTz76BKFGNpYmfgm9I3fQBsNOKul1XdYR7dxx28z4cNKUCCHs3JeUTCs0xQDC6Zr08S3cDtcZCzj9phOYIWg3R3G6teS6SFr6Pi0S1dR7XLCaPa4PgdPfcpF//tFd9z1AcMpI3HsevAKooCCKWjju9Q3gQA2K0Hz+v68VEb6KHJQDVDg27zWXvZZoeMuECQhXtjE+w8xVIhHe38YjgAAAABJRU5ErkJggg==", Y3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGhSURBVHgB7ZbPUQIxFMa/l4X1KCVQAhYgf26COgMVSAdIBUAHdCBWwJ7g6KoFiB1QAjdnliXPF1BYQcAJsOro77JJ9ku+7Es2ecBfgbYJxue5OzDnRTpIuFQhzx8ua4JSPgNwl8BpqTaTvYcWbE3Dy9MyT6gbEQ8dVxWixmFRNIpuwEi9tzHUidvzB+vGVdiAnjipaJ2BdBjop7CYL5t6cJGtMcmkIoZfYWt4g2K2Q4Sr1Z7kz8K+QkvC28QupoZxKduUR2Objpnrbv+xvU1Hb4M2GFTdLJxuks2moOH6/hiJwjObjILSaZUgGyEulCooMcwgRmiClAq1am8Ky54tB84R/PlGCkrZtlRqOBDEqpLo+54pz//T2UIfDnYW4yt8A3amZGZNHiyxMmXNcurcV5hxCwusTBXttv6/aE3/TX+yaQIWSDpSk7zIlHLTfCIOUzHKyP1qfR3OwyuzHyImYltT1p8c+EkXHugwN41JXaMp6eJq8/wRs6pjz0xzZa0KS20feTnLpx2lrxXRsclzYQNjJGnrSEM/J5NOx3xQ9PUrH6SKtrir6IYAAAAASUVORK5CYII=", dV = "data:image/png;base64,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";
var mV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "welfare-container" }, [t("img", { staticClass: "close-btn", attrs: { src: Yo }, on: { click: n.closeVipWelfare } }), t("div", { staticClass: "banner" }, [t("img", { attrs: { src: dV } }), n.welfareTotal > 0 ? t("div", { staticClass: "content" }, [t("div", { staticClass: "content-one color_text_vip_2" }, [e._v("你还有" + e._s(n.welfareTotal) + "个福利未领取，")]), t("div", { staticClass: "content-two" }, [t("span", { staticClass: "color_text_vip_2" }, [e._v("价值")]), t("span", { staticClass: "price" }, [e._v("￥" + e._s(n.welfareWorth))])])]) : e._e()]), n.loading ? t("div", { staticClass: "welfare-loading color_bg_3" }, [e._m(0)]) : e._e(), n.welfareList.length > 0 && !n.loading ? t("div", { staticClass: "welfare-list color_bg_3" }, [t("div", { staticClass: "welfare-list-inner" }, e._l(n.welfareList, function(a, i) {
    return t("div", { key: i, staticClass: "welfare-item" }, [t("img", { staticClass: "welfare-item-icon", attrs: { src: a.welfareType === 0 ? n.walfareIcon0 : a.welfareType === 1 ? n.walfareIcon1 : a.logo || n.walfareIcon2 } }), t("div", { staticClass: "welfare-item-name color_text_vip_2" }, [e._v(e._s(a.planName))]), t("div", { staticClass: "welfare-item-rightsType color_text_vip_2" }, [e._v(e._s(a.rightsType))]), t("div", { staticClass: "welfare-item-price" }, [t("span", { staticClass: "unit" }, [e._v("￥")]), t("span", [e._v(e._s(a.price))])]), t("div", { staticClass: "welfare-item-desc color_text_vip_2" }, [a.welfareType === 2 ? t("span", [e._v(e._s(a.obtainStatus === 0 ? `该福利需要在${n.timeFormat(a.activeTime)}前领取` : "该福利已领取"))]) : a.welfareType === 0 ? t("span", [e._v("该福利已在" + e._s(n.timeFormat(a.activeTime)) + "发放")]) : a.welfareType === 1 ? t("span", [e._v("有效期至：" + e._s(n.timeNameFormat(a.activeTime)))]) : e._e()]), t("div", { staticClass: "welfare-item-operation" }, [a.welfareType === 2 && (a.obtainStatus === 1 || a.activeStatus !== 0) ? t("div", { staticClass: "button color_main_vip_1 color_text_vip_1", on: { click: function(u) {
      return n.goToVipWelfareView(a.planId, a.id, a.distributeType);
    } } }, [e._v(e._s(a.obtainStatus === 0 ? "去领取" : "去查看"))]) : e._e(), a.welfareType === 0 ? t("div", { staticClass: "button color_main_vip_1 color_text_vip_1", on: { click: n.buyRecharge } }, [e._v("去查看")]) : e._e()])]);
  }), 0)]) : t(n.noWelfare)], 1);
}, hV = [function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "content" }, [e("div", { staticClass: "loading-icon" })]);
}];
const gV = {
  __name: "vipWelfare",
  props: {
    debug: {
      type: Boolean
    }
  },
  emits: ["closeVipWelfare", "openMorePackage"],
  setup(r, { emit: e }) {
    const t = r, n = t.debug ? Lt.serviceUrl.dev.VUE_APP_WELFARE_URP : Lt.serviceUrl.prod.VUE_APP_WELFARE_URP, a = t.debug ? Sr : Pr, i = t.debug ? $s : eu, u = ue([]), f = ue(0), c = ue(0), o = ue(""), s = ue(!0);
    function l() {
      e("openMorePackage"), v();
    }
    function v() {
      e("closeVipWelfare");
    }
    function p() {
      i.getAccountInfos().then((y) => {
        y.code === 0 ? o.value = y.data.yduserid : o.value = "";
      }).catch((y) => {
        console.log("获取账户信息失败", y);
      });
    }
    function h(y) {
      return mr.formatTimeToYMD(y);
    }
    function d(y) {
      return mr.formatTimeToCYMD(y);
    }
    function x() {
      a.getWelfareList().then((y) => {
        u.value = y.data.welfareList, f.value = y.data.welfareTotal, c.value = y.data.welfareWorth, s.value = !1;
      });
    }
    function g(y, m, b) {
      const w = `${n}getWelfare?planId=${y}&id=${m}&type=${b}&userid=${o.value}`;
      window.open(w);
    }
    return hr(() => {
      x(), p();
    }), { __sfc: !0, props: t, welfareUrl: n, service: a, serviceLogin: i, welfareList: u, welfareTotal: f, welfareWorth: c, yduserid: o, loading: s, emits: e, buyRecharge: l, closeVipWelfare: v, getAccountInfo: p, timeFormat: h, timeNameFormat: d, getWelfareList: x, goToVipWelfareView: g, ref: ue, computed: dr, watch: Je, onMounted: hr, serviceDev: Sr, serviceProd: Pr, util: mr, serviceLoginDev: $s, serviceLoginProd: eu, noWelfare: pV, serviceUrl: Lt, walfareIcon2: V3, walfareIcon1: Q3, walfareIcon0: Y3 };
  }
};
var xV = /* @__PURE__ */ Rr(
  gV,
  mV,
  hV,
  !1,
  null,
  "af8f679e",
  null,
  null
);
const Z3 = xV.exports, yV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAANGSURBVFiFzZlBbxNHFIC/NzaLQD4ER6qNMMWHQE5IvqEiAWvlYlKsKKdKPTX33vo3euMHwAmJUxRBIYdGWS6R4GSpp6SWuirJkTSHNFETMq8HZ9NAvTPrxIv9nWzPm51P4zdvRjtCHw4fhSFq50SlbtEGgEC9X+x5UYgFdhDZAe0gZunCyyj6PE4+6dQK6x8L+gTVMA+pzIhExSNZkOUoPvkp+XAwGzYMdlFzmrlBEYgtZj54FXWOv/dm8sjY1XGRTBCIC9Y0ZTmKDcDHgj4ZN0kAhV4qAnL4KAyxdnXUUk6MaRrUzo3aw4vauSJIAzTfgYIA+aoKwUU4+Afd/HOg7qJSL6I6kYtcqYTUbiC1r+FKGYLgv4F3d7G/voa/dzM9yqKNosKE+GMzIZUqJHKlUnpgqYT55l5PNiPFc+04QYDUbkCl2pM7NWteKtXeTP+17Q0VqBcHlrtSRipXe2KV6sDdPxGoXEUziALI4ez9nFfScMg0ozI1DVO3hj/6/h5sbaLddW+oV9TMf4eEM0PxSkOjFezic7eHq1GmpnOXBJBwpvevOXCKcq02TB83ntRyi166PEyVc+EW3f7whTSArffOZudi0ndr6LXr7jzd/oB9u+YcxNy5C+XJ9HFev0B/65xdFMAuPsfs7yEP2/0H+X0dXX7hfIaWJ5E7d1Mlrac/DFDwzY8/ITfdK3NQtLuBffxzplh3jp5ma/OsPulsuvPyNNlFa9fPouJmgPKXaQs1rTaSUuf07Rr22VN3/+9/6JujcnMa02pnylH/Ftpqpy6kZDBppbcnMaltD9uYS5e9W6hTVG43nJIAlCcxvhgPEs4gW+/Rd+llzrOF5pCXaTjqLAyymPJmf8/Z7BbtbgxTxY2n/DlFtbuORitD9ek7TrTiPTxn2plkarpX8/I4TXU3Mp3w5WD2/h95vfscFgrx+CwmBwI7xiDu89U4ILJjVDQetYcf7RjELI1aw4uYJQE4/PbB6sjf26chEl345U3TABSPZEEgHrHS/xCIi0eyAMcFX5aj2GLmx0k2uWxIbkZOylPwKuoUrGkiEo1K7gSRqGBNM7kRgc/umRKSCzGQBqoTx+9Q63k46fG/aJCOisZpF2L/AqF3BmaUErWZAAAAAElFTkSuQmCC", AV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKLSURBVHgB7VcxaBRBFH1zp4GgKRRE7uws0lkFsT2wsPDOwi7pNYWanMZSMELURuWiIiQKdjlsRHIneI2cpYKVVgGt5EIKbU4JXDy//+9mdW9nZm9ub6/SB8vO7vyd93bmz/9/gH8dahDj03M0lVUokMIUf5kDYWJ3lDa3NxRfXULz5X313nVMJwHFy1Riw3NMknex51FbfK3W7ql6f9MYnC1Tbge4y81JJAEL6RBmGxW1aTPJ2DpK81TcUVhLTC7gGRsD1oplKsCq0QD5gDvuIE0QFmvL+pJoArxplz8PHCw9tDvATHQ5tCVg8pURkAsmxnx/glWAeLuzpyfDZOkKFa0CvK02ahDOwyRAgkyaf3/0CHD4IEwC8h5XVEA2iwJSwsnjQOUqMDdt7pdoqgmgYfZ7CPLn8zN+++Mns40XyqMCWMHQAoT85gW/XW3w9cpqmgsae0IvrVvvFg/6YxtYrgLft802st5Cvm8cWH8TS97DlYEDDh0AThwDli4C+8fN5Eu75K/fAU9ewBlhAW2b0bVHwNZXnuK8LiIgl/vbD+x8VbigrQvIwJqxtr6ZRYTJP3/xl8gRG5oALiZiiwiTiDC59Nn8IwopXDQB3S6a/T6MihByad9+6k7ucdFfrp5sWCrTOt/6RkMhnj4F/OL2s4YvbAC0ahV1JngIb0NQF49VFtf7jSCEFff17gVhNfzYsw3rD1QNIQcZAVrRokSLA3uBBcRsySEgBcls9KUm4LlULKQXDsOCfuKGqTg1RkKZJk5OnM9SmQk5MyzWH6qmqdOlLF8BEtYJvN87CgtxZbnbweQSH0yyXrXkKqQl3m6qghMJCPDnaJbh1O2n7yCryVJtSjQd9Gj2H78B5fXgtR9b2AcAAAAASUVORK5CYII=";
var bV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { ref: "vipListContainerRef", staticClass: "vip-list-container" }, [n.couponInfo.couponId ? t("div", { staticClass: "walfare-coupon" }, [t("div", { staticClass: "walfare-list-item color_label_vip_tint_1_opacity" }, [t("img", { staticClass: "walfare-item-icon", attrs: { src: yV } }), t("div", { staticClass: "walfare-item-title color_text_vip_2", on: { click: n.gotoWelfare } }, [e._v(e._s(n.couponInfo.couponName))]), n.couponInfo.couponPrice !== void 0 ? t("div", { staticClass: "walfare-item-price color_vip_price", on: { click: n.gotoWelfare } }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(n.couponInfo.couponPrice))])]) : e._e(), n.remainTime > 0 ? t("div", { staticClass: "walfare-item-timeLeft color_text_vip_2" }, [t("div", { staticClass: "digital color_label_stress_bg" }, [e._v(e._s(n.countDownTime.hour))]), t("span", [e._v("时")]), t("div", { staticClass: "digital color_label_stress_bg" }, [e._v(e._s(n.countDownTime.minute))]), t("span", [e._v("分")]), t("div", { staticClass: "digital color_label_stress_bg" }, [e._v(e._s(n.countDownTime.second))]), t("span", [e._v("秒")]), t("span", { staticClass: "last" }, [e._v("后结束")])]) : e._e()])]) : t("div", { staticClass: "title color_text_1" }, [e._v("有道翻译豪华特权升级+有道词典移动端全部特权+AI PPT会员")]), t("div", { ref: "vipListRef", staticClass: "vip-list" }, e._l(n.vipList, function(a, i) {
    return t("div", { key: i, ref: `vipItem_${i}`, refInFor: !0, staticClass: "vip-list-item color_main_vip_1_border", class: a.planId === n.currentPackage.planId ? ["active"] : "", on: { click: function(u) {
      return n.choiceItem(a, i);
    } } }, [t("div", { staticClass: "vip-type", class: a.planId === n.currentPackage.planId ? "color_text_vip_0" : "color_text_2" }, [e._v(e._s(a.trial ? a.pcPromoteInfo : a.period))]), t("div", { staticClass: "vip-price", class: a.planId === n.currentPackage.planId ? "color_vip_price" : "color_text_1" }, [a.trial ? e._e() : t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(a.trial ? a.periodDesc : a.price))])]), a.basicPrice ? t("div", { staticClass: "vip-basicprice", class: a.planId === n.currentPackage.planId ? "color_text_vip_2_change" : "color_text_3" }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(a.basicPrice))])]) : e._e(), t("div", { staticClass: "vip-desc", class: a.planId === n.currentPackage.planId ? "color_bg_vip_1_text" : "vip-desc-text" }, [e._v(e._s(a.shortDesc))]), a.firstTag && a.firstTag !== "" || a.tag !== "" ? t("div", { staticClass: "vip-tag" }, [e._v(e._s(a.firstTag || a.tag))]) : e._e()]);
  }), 0), n.walfareDetails.discountList && n.walfareDetails.discountList.length > 0 ? t("div", { staticClass: "walfare" }, [t("div", { staticClass: "walfare-header" }, [t("div", { staticClass: "walfare-title" }, [e._v(e._s(n.walfareDetails.discountTitle))]), n.walfareDetails.discountInfo ? t("div", { staticClass: "walfare-desc color_text_3" }, [e._v(e._s(n.walfareDetails.discountInfo))]) : e._e(), n.walfareDetails.policyInfo && n.walfareDetails.policyUrl ? t("div", { staticClass: "walfare-policy color_text_2", on: { click: n.openWalfarePolicy } }, [e._v(e._s(n.walfareDetails.policyInfo))]) : e._e(), t("div", { staticClass: "walfare-choose" }, [t("div", { staticClass: "walfare-choose-common" }, [t("span", [e._v("已选")]), t("span", { staticClass: "choose-num" }, [e._v(e._s(n.unionChooseList.length) + "/" + e._s(n.walfareDetails.discountList.length))]), t("span", [e._v("(可多选)")])])])]), t("div", { ref: "walfareListRef", staticClass: "walfare-list" }, e._l(n.walfareDetails.discountList, function(a, i) {
    var u;
    return t("div", { key: i, staticClass: "walfare-list-item color_label_vip_tint_1_opacity", on: { click: function(f) {
      return n.choiceWalfareItem(a, i);
    } } }, [t("img", { staticClass: "walfare-item-icon", attrs: { src: a.type === 0 ? n.walfareIcon0 : a.type === 1 ? n.walfareIcon1 : a.logo } }), t("div", { staticClass: "walfare-item-title color_text_vip_2" }, [e._v(e._s(a.name))]), a.basicPrice !== void 0 ? t("div", { staticClass: "walfare-item-price color_vip_price" }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price price1" }, [e._v(e._s(a.price))])]) : e._e(), t("div", { staticClass: "walfare-item-basicPrice" }, [e._v(e._s(a.basicPrice))]), t("div", { staticClass: "select-type" }, [((u = n.unionChooseList) == null ? void 0 : u.findIndex((f) => f.id === a.id)) !== -1 ? t("img", { staticClass: "icon", attrs: { src: AV }, on: { click: function(f) {
      return n.handleSelectUnion(a);
    } } }) : t("div", { staticClass: "circle", on: { click: function(f) {
      return f.stopPropagation(), n.handleSelectUnion(a);
    } } })])]);
  }), 0)]) : e._e(), n.showVipWelfare ? t(n.vipWelfare, { attrs: { debug: e.debug }, on: { closeVipWelfare: n.closeVipWelfare, openMorePackage: e.openMorePackage } }) : e._e()], 1);
}, wV = [];
const DV = {
  __name: "vipPackageList",
  props: {
    isSVip: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    },
    debug: {
      type: Boolean
    },
    routeQuery: {
      type: Object
    }
  },
  emits: ["currentChoose", "currentIsHaveWalfare"],
  setup(r, { expose: e, emit: t }) {
    const n = r, a = n.debug ? Sr : Pr, i = ue([]), u = ue({}), f = ue(!1), c = ue(""), o = ue(!1), s = ue({
      discountInfo: "",
      discountTitle: "",
      policyInfo: "",
      policyUrl: "",
      discountList: []
    }), l = ue(null), v = ue(null), p = ue(null), h = ue(null), d = ue(""), x = ue({
      hour: "",
      minute: "",
      second: ""
    }), g = ue(0), y = ue([]), m = ue({}), b = ue(!1), w = ue("");
    e({
      getVipList: z,
      resetVipListPosition: H
    }), hr(() => {
      z();
    }), Je(() => n.routeQuery, (R) => {
      console.log("routeQuery choosePlanId", n.routeQuery), w.value = (R == null ? void 0 : R.planId) || "";
    }, { immediate: !0 }), Je(() => u.value, (R) => {
      clearInterval(d.value), t("currentChoose", R), O(u.value.planId);
    }, { deep: !0 }), Je(() => y.value, (R) => {
      t("currentUnionChoose", R);
    }, { deep: !0 }), Je(() => m.value, (R) => {
      t("currentCouponChoose", R);
    }, { deep: !0 });
    function A() {
      g.value -= 1e3, g.value <= 1e3 ? (clearInterval(d.value), O(u.value.planId), x.value = {
        hour: "",
        minute: "",
        second: ""
      }) : x.value = mr.dateFormatHMS(new Date(g.value));
    }
    function E() {
      clearInterval(d.value), d.value = setInterval(() => {
        A();
      }, 1e3);
    }
    function N(R) {
      a.getSingleSvipWelfare({ planId: R }).then((X) => {
        if (X.code === 0) {
          if (s.value = X.data, X.data.discountList !== void 0 && X.data.discountList.length > 0) {
            t("currentIsHaveWalfare", !0);
            const { timeLeft: ae } = X.data.discountList.find((_) => _.type === 1) || 0;
            g.value = ae && ae <= 864e5 * 3 ? ae : 0;
          } else
            t("currentIsHaveWalfare", !1);
          g.value > 0 && E();
        }
      });
    }
    function C() {
      window.open(s.value.policyUrl);
    }
    function D(R, X) {
      X >= 2 ? l.value.scrollTo({
        left: l.value.children[X].offsetLeft - 186,
        behavior: "smooth"
      }) : X <= 2 && l.value.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
    function B() {
      o.value = !1;
    }
    function S() {
      f.value = !0;
    }
    function F() {
      f.value = !1;
    }
    function I() {
      o.value = !0;
    }
    function z() {
      const R = {
        imei: "1",
        // 高价实验
        // keyfrom: util.getInfo('spec_vip_benefit') ? 'vip_benefit' : 'webdict',
        keyfrom: "webdict",
        apiversion: "1.0",
        appVersion: "1",
        client: "web",
        product: "web",
        vendor: "",
        yduuid: "1"
      };
      a.getVipList(R).then((X) => {
        i.value = X, console.log("调用 choosePlanId ==> ", w.value);
        const ae = X.findIndex((_) => _.planId === w.value);
        if (ae !== -1)
          ni(() => {
            M(X[ae], ae);
          });
        else {
          const _ = X[0];
          u.value = _;
        }
      });
    }
    function P() {
      v.showPopUp();
    }
    function M(R, X) {
      const ae = p.value.children[X].offsetLeft - h.value.clientWidth / 2 + 79;
      p.value.scrollTo({
        left: ae,
        behavior: "smooth"
      }), u.value = R;
    }
    function H() {
      p.value.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
    function O(R) {
      a.getSingleSvipActivity({ planId: R }).then((X) => {
        var ae, _, re;
        if (X.code === 0) {
          console.log("调用 service.getSingleSvipActivity ==> ", X);
          const {
            discountInfo: te,
            discountTitle: ne,
            policyInfo: oe,
            policyUrl: le,
            couponList: fe,
            unionList: ge
          } = X.data;
          s.value = {
            discountInfo: te,
            discountTitle: ne,
            policyInfo: oe,
            policyUrl: le,
            discountList: ge || []
          }, console.log("调用 service.getSingleSvipActivity ==> ", s.value), y.value = ge || [], m.value = (fe == null ? void 0 : fe[0]) || {}, g.value = (ae = fe == null ? void 0 : fe[0]) != null && ae.expiredTime && ((_ = fe == null ? void 0 : fe[0]) == null ? void 0 : _.expiredTime) <= 432e6 ? (re = fe == null ? void 0 : fe[0]) == null ? void 0 : re.expiredTime : 0, ge !== void 0 && ge.length > 0 ? (y.value = ge, t("currentIsHaveWalfare", !0)) : (y.value = [], t("currentIsHaveWalfare", !1)), g.value > 0 && E();
        }
      });
    }
    function Q() {
      b.value = !0;
    }
    function k() {
      b.value = !1;
    }
    function L(R) {
      var X;
      console.log("handleSelectUnion", R), ((X = y.value) == null ? void 0 : X.findIndex((ae) => ae.id === R.id)) !== -1 ? y.value = y.value.filter((ae) => ae.id !== R.id) : y.value.push(R);
    }
    return { __sfc: !0, props: n, vip: a, vipList: i, currentPackage: u, isShowDesc: f, source: c, showMore: o, walfareDetails: s, walfareListRef: l, exchangePopUpRef: v, vipListRef: p, vipListContainerRef: h, timer: d, countDownTime: x, remainTime: g, unionChooseList: y, couponInfo: m, showVipWelfare: b, choosePlanId: w, emits: t, countDown: A, timing: E, getCurrentWalfare: N, openWalfarePolicy: C, choiceWalfareItem: D, closeMorePackage: B, mouseenter: S, mouseleave: F, buyRecharge: I, getVipList: z, openExchange: P, choiceItem: M, resetVipListPosition: H, getSingleSvipActivity: O, gotoWelfare: Q, closeVipWelfare: k, handleSelectUnion: L, ref: ue, computed: dr, watch: Je, onMounted: hr, nextTick: ni, vipDev: Sr, vipProd: Pr, exchangePopUp: w2, morePackage: X3, vipWelfare: Z3, utilIndex: mr, walfareIcon2: V3, walfareIcon1: Q3, walfareIcon0: Y3 };
  }
};
var CV = /* @__PURE__ */ Rr(
  DV,
  bV,
  wV,
  !1,
  null,
  "70d365fd",
  null,
  null
);
const EV = CV.exports;
var NV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "buy-vip" }, [t(n.vipPackageList, { ref: "vipPackageListRef", attrs: { isSVip: e.isSVip, isLogin: e.isLogin, debug: e.debug, routeQuery: e.routeQuery }, on: { currentChoose: n.currentChoose, currentIsHaveWalfare: n.currentIsHaveWalfare, currentUnionChoose: n.currentUnionChoose, currentCouponChoose: n.currentCouponChoose } }), t(n.buyVipWay, { attrs: { routeQuery: e.routeQuery, currentPackage: n.currentPackage, orderType: n.orderType, vipInfo: e.vipInfo, isHaveWalfare: n.isHaveWalfare, isSVip: e.isSVip, isLogin: e.isLogin, useView: "vip", debug: e.debug, unionChooseList: n.unionChooseList, couponInfo: n.couponInfo, activeTab: e.activeTab }, on: { buyVipSuccess: n.buyVipSuccess } })], 1);
}, BV = [];
const SV = {
  __name: "buyContent",
  props: {
    isSVip: Boolean,
    isLogin: Boolean,
    vipInfo: Object,
    routeQuery: Object,
    debug: Boolean,
    activeTab: String
  },
  emits: ["buyVipSuccess"],
  setup(r, { expose: e, emit: t }) {
    const n = r;
    e({
      couponPopupBuyVipSuccess: l
    });
    const a = ue({}), i = ue(null), u = ue(0), f = ue(!1), c = ue([]), o = ue({});
    function s() {
      t("buyVipSuccess"), i.value.getVipList(), i.value.resetVipListPosition();
    }
    function l() {
      i.value.getVipList(), i.value.resetVipListPosition();
    }
    function v(x) {
      a.value = x;
    }
    function p(x) {
      f.value = x;
    }
    function h(x) {
      c.value = x;
    }
    function d(x) {
      o.value = x;
    }
    return { __sfc: !0, props: n, emits: t, currentPackage: a, vipPackageListRef: i, orderType: u, isHaveWalfare: f, unionChooseList: c, couponInfo: o, buyVipSuccess: s, couponPopupBuyVipSuccess: l, currentChoose: v, currentIsHaveWalfare: p, currentUnionChoose: h, currentCouponChoose: d, ref: ue, computed: dr, watch: Je, onMounted: hr, vipPackageList: EV, buyVipWay: t1 };
  }
};
var PV = /* @__PURE__ */ Rr(
  SV,
  NV,
  BV,
  !1,
  null,
  null,
  null,
  null
);
const MV = PV.exports, FV = "data:image/png;base64,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", TV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADJSURBVHgB7ZaxDYMwEEXPUTZIZkhNm5o2Q7BD5sgOSZtBYBpaWvNdISGQ/O1vISQ/6eTmrP90wAmzSuUseO8fqJeJuRK9LaqBxN059zURF6L3jxpRT0h0JsIxzQi+4XijwjkoJkEJlJCgBdQSSQJKiWQBlUSWgEIiWyBXgtkDuyAw7IePLXuijb0rEdhgim2UCKweQY+JDLF31S9hCP8x95WfIR2eJaAITxZQhScJKMNpAXU4JVAiPMDsgU4dToEJNCV+SiuVw5kB2LFqLzEvmmgAAAAASUVORK5CYII=", OV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACpSURBVHgB7ZKBDYIwEEV/naAjdARGcAQ2YATdQDZwBTdxBN2AERjhvItnuGBMJHAkkHvJTxpo77W9AkEQ7BoiOnIq++0AB1T04GFOKT3hhZyGc+d045N5yK70RmQFU+FFNaf5Y16R65slM8VaLdL8+C+96lUm0oy5qPRr9zw+0UC3iMwUv5niZ85lJCtYGtMncpepMKvgQ+8mM9KKhkdSYw20hy2CINgsLzzv6B8KefmHAAAAAElFTkSuQmCC";
var zV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "equity", class: [{ "equity-loading": n.isLoading }, { "equity-ppt-style": e.isShowPPT && e.activeTab === "aipptVip" }] }, [t("div", { staticClass: "header" }), t("div", { directives: [{ name: "show", rawName: "v-show", value: !n.isLoading, expression: "!isLoading" }], staticClass: "equity-title" }, [t("div", { staticClass: "equity-title-top" }, [t("img", { staticClass: "title-icon", attrs: { src: FV } }), t("span", { staticClass: "top-text" }, [e._v(e._s(n.wrapTitle))])]), t("div", { staticClass: "equity-title-main" }, [e._v(e._s(n.wrapInfo)), t("div", { staticClass: "check-text", on: { click: n.openRightPage } }, [e._v("查看权益对比")]), t("img", { staticClass: "check-icon", attrs: { src: TV } })])]), t("div", { staticClass: "equity-main" }, e._l(n.privilegeList, function(a, i) {
    return t("div", { key: `privilegeList_${i}`, staticClass: "equity-list" }, [t("div", { staticClass: "items-title" }, [e._v(e._s(a.privilegeType))]), t("div", { staticClass: "items-detail-list" }, e._l(a.detailList, function(u, f) {
      return t("div", { key: `detailList_${f}`, staticClass: "items-detail", class: { "one-column": a.showType === 0, "two-column": a.showType === 1, "auto-column": a.showType === 2 } }, [u.icon ? t("img", { staticClass: "detail-icon", attrs: { src: u.icon } }) : t("img", { staticClass: "detail-icon-default", attrs: { src: OV } }), t("div", { staticClass: "detail-text-title", class: { "detail-text-short-title": a.showType === 2, "detail-text-long-title": a.showType === 0 } }, [e._v(e._s(u.title))]), u.info ? t("div", { staticClass: "detail-text-info" }, [e._v(e._s(u.info))]) : e._e()]);
    }), 0)]);
  }), 0)]);
}, RV = [];
const IV = {
  __name: "Equity",
  props: {
    routeQuery: Object,
    debug: Boolean,
    // 2024-07-26新增
    isShowPPT: Boolean,
    activeTab: String
  },
  setup(r) {
    const e = r, t = ue([]), n = ue(""), a = ue(""), i = ue(""), u = ue(!0), f = ue(""), c = e.debug ? Sr : Pr;
    Je(() => e.routeQuery, (l) => {
      l != null && l.source ? f.value = l.source : l != null && l.keyfrom ? f.value = l.keyfrom : f.value = e.isSVip ? "web_renew_vip" : "web_open_vip";
    }, { immediate: !0 });
    function o() {
      const l = e.isShowPPT && e.activeTab === "aipptVip" ? "getPrivilege" : "privilegeShow";
      c[l]({ t: (/* @__PURE__ */ new Date()).getTime() }).then((v) => {
        u.value = !1;
        const p = e.isShowPPT && e.activeTab === "aipptVip" ? v.data.value.aipptVipPcInfoList : v.data.svipPcInfoList;
        t.value = p.privilegeList, n.value = f.value ? `${p.wrapUrl}?keyfrom=${f.value}` : p.wrapUrl, a.value = p.wrapInfo, i.value = p.wrapTitle;
      }).catch(() => {
        u.value = !0;
      });
    }
    Je(
      () => e.activeTab,
      (l) => {
        o();
      }
    );
    function s() {
      window.open(n.value);
      const l = mr.getQueryVariable("keyfrom") || mr.getQueryVariable("source");
      window._rlog.push([
        "_trackCustom",
        "event",
        [
          l ? ["keyfrom", l] : "",
          ["action", "privilege_comparison"]
        ]
      ]);
    }
    return hr(() => {
      o();
    }), { __sfc: !0, privilegeList: t, wrapUrl: n, wrapInfo: a, wrapTitle: i, isLoading: u, keyfrom: f, props: e, service: c, init: o, openRightPage: s, ref: ue, computed: dr, watch: Je, onMounted: hr, serviceDev: Sr, serviceProd: Pr, util: mr };
  }
};
var HV = /* @__PURE__ */ Rr(
  IV,
  zV,
  RV,
  !1,
  null,
  "60a1e350",
  null,
  null
);
const LV = HV.exports;
var qV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "purchase-record-tabs" }, e._l(n.selectList, function(a, i) {
    return t("div", { key: `select-item_${i}`, staticClass: "purchase-record-tab-panel color_text_vip_2", class: [{ "active color_text_vip_1": n.selectIndex === a.value }, [a.value === "svip" ? "left" : "right"]], on: { click: function(u) {
      return n.selectTab(a.value);
    } } }, [t("span", { staticClass: "tab-text" }, [e._v(e._s(a.label))])]);
  }), 0);
}, UV = [];
const kV = {
  __name: "PurchaseRecordTab",
  props: {
    isAllowChangeTab: {
      type: Boolean
    }
  },
  emits: ["handleClick"],
  setup(r, { emit: e }) {
    const t = r, n = ue("vip"), a = ue([
      {
        label: "会员订单",
        value: "vip"
      },
      {
        label: "加量包订单",
        value: "morePackage"
      }
    ]);
    function i(u) {
      t.isAllowChangeTab && (n.value = u, e("handleClick", u));
    }
    return { __sfc: !0, emits: e, props: t, selectIndex: n, selectList: a, selectTab: i, ref: ue, computed: dr, watch: Je, onMounted: hr };
  }
};
var XV = /* @__PURE__ */ Rr(
  kV,
  qV,
  UV,
  !1,
  null,
  "c6e6f8c8",
  null,
  null
);
const jV = XV.exports, GV = "data:image/png;base64,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", VV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAGkSURBVGiB7dRNbtNAGMbx/+tWEYgeohsOwhmQsgKF0KJuEBISZRywxJTQBXsgWXGAGgrXoAof4QqQrmkWCMXxvGyRMCVjO+rm/S3teWb8jO0BY4wxxhhjjDEXQ2IDz56/vpuIXF/HwwAE1beZu/1i1fFJ7ALTydZI0I+xuZUon6aTrVFMJLpAnndLCcUQZRabPZ/MEl08zfNuGZOKLgCQpntnoUicwlmd/F9U5wst0jTdi56vVgGALOvNkrI8QInasQohoEPv7nyvE65dAGAw2P3MBq+azBFgnLmdSd18owIAjx70jzWEN3WyCsfZw37eZP3GBQCKX99GoHG7qHy5un2l0duDlgp478PiUmeoyKrf8emiw0G3G3fiVGmlAIC/d2O+qaUDfpw/UuYbunT+fv8/41bTWgEA53ZOk7DpQZZV91VVgy4PXc0Tp0qrBQDS9OZURKq/bU3Gmds9aXO91gsADPZ770CO/rym8P5xeuvoX5m61lIAYLDfG4vwAQDVr8XP7ZfrWGdtBUREkxAOQU4ud+SJ99cq/wtjjDHGGGPMhfkNg1WQ0Koj+pwAAAAASUVORK5CYII=", QV = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG4SURBVHgB7ZZPVsIwEIcn4emaI3AEjkBPoPVPfaysJ/B5Ez0BuEKLmMcJ4AgcgSOw9UETM2CxYGyTSRcs8q2gTX/5yHQSAAKBQCBw0jDbgSMhOmyjBqBUj3GW3t1cvQKBco5iPOrfxvOq8RwsYRt5iaH4WUk1fP/4vAdHtnJrOStyQMpe3TPWglzxudZcFd9dJfdyAJ2fS0uQfFj3nHWJkSwTXQlKT6La+wCLcpvkVK7L24+X0KQgRdJHDrEucUGSxAsOLLIptxCizda5oMohzitYULeSKPe1zvV91qXKeQkio/G4xxSfHQRqyfMWmzYh5y24lcwmqQ4ZVAwhyyHegkiFpJcc4twkJvrJ9VD/1hdD/NxHbpsADYANoZvl4u8dmVJOnDLegr/dut9KDqAeiwVegsathMlIv9lPcCj5nGVZFwiQm6RunzM0zopDHiVJsgAHSIK2m3ATkqQSH8npSXls6lbsbgXwULrUltCauZTbWfAtmwyO5CI8n/8b7yvpVOKdHKS2cmWo5bZeQZyAKoeYV/Lsse45yjvoLFdwLMlUPoUmwX8vu1PDM2ckOk3kBAKBQOAE+AZzaS3CZNaRnQAAAABJRU5ErkJggg==";
var YV = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "issue-invoice-container color_bg_1" }, [t("el-form", { ref: "ruleFormRef", staticClass: "form demo-ruleForm", attrs: { model: n.ruleForm, rules: n.rules, "label-width": "90px", "label-position": "right" } }, [t("div", { staticClass: "title color_text_0" }, [e._v("发票详情")]), t("el-form-item", { attrs: { label: "抬头类型", prop: "billType" } }, [t("div", { staticClass: "bill-type" }, [t("div", { staticClass: "button", class: n.ruleForm.billType === 0 ? "color_main_1_text color_main_1_border" : "color_text_1 color_divider_1_border", on: { click: function(a) {
    return n.changeBillType(0);
  } } }, [e._v("企业单位")]), t("div", { staticClass: "button", class: n.ruleForm.billType === 1 ? "color_main_1_text color_main_1_border" : "color_text_1 color_divider_1_border", on: { click: function(a) {
    return n.changeBillType(1);
  } } }, [e._v("个人/非企业单位"), n.isShowBillTypeTips && n.ruleForm.billType === 1 ? t("img", { staticClass: "bill-type-tips", attrs: { src: GV } }) : e._e(), n.ruleForm.billType === 1 && n.isShowBillTypeTips ? t("div", { staticClass: "close-tips", on: { click: n.closeBillTypeTips } }) : e._e()])])]), t("el-form-item", { attrs: { label: "公司名称", prop: "companyName", required: "" } }, [t("el-input", { staticClass: "required-input", attrs: { placeholder: "请输入公司名称", clearable: "", maxlength: "50" }, model: { value: n.ruleForm.companyName, callback: function(a) {
    e.$set(n.ruleForm, "companyName", typeof a == "string" ? a.trim() : a);
  }, expression: "ruleForm.companyName" } })], 1), n.ruleForm.billType === 0 ? t("el-form-item", { attrs: { label: "公司税号", prop: "taxNumber", required: "" } }, [t("el-input", { staticClass: "required-input", attrs: { placeholder: "请输入公司税号", clearable: "", maxlength: "50" }, model: { value: n.ruleForm.taxNumber, callback: function(a) {
    e.$set(n.ruleForm, "taxNumber", typeof a == "string" ? a.trim() : a);
  }, expression: "ruleForm.taxNumber" } })], 1) : e._e(), t("el-form-item", { attrs: { label: "电子邮箱", prop: "email", required: "" } }, [t("el-input", { staticClass: "required-input", attrs: { placeholder: "请输入电子邮箱", clearable: "", maxlength: "50" }, model: { value: n.ruleForm.email, callback: function(a) {
    e.$set(n.ruleForm, "email", typeof a == "string" ? a.trim() : a);
  }, expression: "ruleForm.email" } })], 1), t("div", { staticClass: "title color_text_0", on: { click: n.isShowMore } }, [t("span", [e._v("更多内容")]), t("img", { staticClass: "icon", class: { "icon-rotate": n.showMore }, attrs: { src: VV } }), t("span", { staticClass: "fill-sum color_text_4" }, [e._v("(共5项，已填写" + e._s(n.FilledSum) + "项)")])]), n.showMore ? t("el-form-item", { attrs: { label: "公司地址", prop: "companyAddr" } }, [t("el-input", { attrs: { placeholder: "请输入公司地址", clearable: "", maxlength: "50", "show-word-limit": "", autosize: "" }, on: { input: function(a) {
    return n.changeInput(a, 0);
  } }, model: { value: n.ruleForm.companyAddr, callback: function(a) {
    e.$set(n.ruleForm, "companyAddr", a);
  }, expression: "ruleForm.companyAddr" } })], 1) : e._e(), n.showMore ? t("el-form-item", { attrs: { label: "公司电话", prop: "companyPhone" } }, [t("el-input", { attrs: { placeholder: "请输入公司电话", clearable: "", maxlength: "20" }, on: { input: function(a) {
    return n.changeInput(a, 1);
  } }, model: { value: n.ruleForm.companyPhone, callback: function(a) {
    e.$set(n.ruleForm, "companyPhone", a);
  }, expression: "ruleForm.companyPhone" } })], 1) : e._e(), n.showMore ? t("el-form-item", { attrs: { label: "公司开户行", prop: "bankName" } }, [t("el-input", { attrs: { placeholder: "请输入公司开户行", clearable: "", maxlength: "50", "show-word-limit": "" }, on: { input: function(a) {
    return n.changeInput(a, 2);
  } }, model: { value: n.ruleForm.bankName, callback: function(a) {
    e.$set(n.ruleForm, "bankName", a);
  }, expression: "ruleForm.bankName" } })], 1) : e._e(), n.showMore ? t("el-form-item", { attrs: { label: "开户行账号", prop: "bankAccount" } }, [t("el-input", { attrs: { placeholder: "请输入开户行账号", clearable: "", maxlength: "20" }, on: { input: function(a) {
    return n.changeInput(a, 3);
  } }, model: { value: n.ruleForm.bankAccount, callback: function(a) {
    e.$set(n.ruleForm, "bankAccount", a);
  }, expression: "ruleForm.bankAccount" } })], 1) : e._e(), n.showMore ? t("el-form-item", { attrs: { label: "备注", prop: "Info" } }, [t("el-input", { attrs: { placeholder: "请按企业报销要求填写", clearable: "", maxlength: "80", "show-word-limit": "" }, on: { input: function(a) {
    return n.changeInput(a, 4);
  } }, model: { value: n.ruleForm.Info, callback: function(a) {
    e.$set(n.ruleForm, "Info", a);
  }, expression: "ruleForm.Info" } }), t("div", { staticClass: "info-tips color_text_5" }, [e._v("该内容将会打印在发票上")])], 1) : e._e()], 1), t("div", { staticClass: "issue-invoice-footer color_bg_1" }, [t("div", { staticClass: "left" }, [t("div", { staticClass: "price" }, [t("div", { staticClass: "title color_text_0" }, [e._v("总金额")]), t("div", { staticClass: "unit color_main_1_text" }, [e._v("￥")]), t("div", { staticClass: "price-num color_main_1_text" }, [e._v(e._s(n.priceTotal.toFixed(2)))])]), t("div", { staticClass: "details" }, [t("div", { staticClass: "total" }, [e._v("共一张")]), t("div", { staticClass: "view-details color_main_2_text", on: { click: function(a) {
    return n.showInfoDetails(!0);
  } } }, [e._v("查看详情")])])]), t("div", { staticClass: "right" }, [t("div", { staticClass: "button last-step color_label_1 color_text_1", on: { click: n.lastStep } }, [e._v("上一步")]), t("div", { staticClass: "butttn submit color_main_1 color_text_white", class: { "must-input": !n.mustInputed }, on: { click: n.submit } }, [e._v("提交")])]), n.isShowInfoDetails ? t("div", { staticClass: "info-details-container color_table_bg" }, [t("div", { staticClass: "info-details-header" }, [t("img", { staticClass: "info-details-close", attrs: { src: QV }, on: { click: function(a) {
    return n.showInfoDetails(!1);
  } } })]), t("div", { staticClass: "info-details-content" }, [e._m(0), t("div", { staticClass: "right" }, [t("div", { staticClass: "value color_text_1" }, [e._v("无形资产*vip会员服务")]), t("div", { staticClass: "value color_text_1" }, [e._v("北京网易有道计算机系统有限公司")]), t("div", { staticClass: "value color_text_1" }, [e._v(e._s(n.priceTotal.toFixed(0)) + "元")]), t("div", { staticClass: "value color_text_1" }, [e._v("1张")])])]), t("div", { staticClass: "info-details-tips" }, [e._v("(发票将按照扣除优惠后的实际支出金额开具)")]), t("div", { staticClass: "line color_divider_1_background" }), t("div", { staticClass: "info-details-price" }, [t("div", { staticClass: "content color_text_0" }, [e._v("总金额")]), t("div", { staticClass: "info-details-price-num" }, [t("div", { staticClass: "unit color_main_1_text" }, [e._v("￥")]), t("div", { staticClass: "price-num color_main_1_text" }, [e._v(e._s(n.priceTotal.toFixed(2)))])])])]) : e._e()])], 1);
}, ZV = [function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "left" }, [e("div", { staticClass: "label color_text_2" }, [r._v("发票内容")]), e("div", { staticClass: "label color_text_2" }, [r._v("开票方")]), e("div", { staticClass: "label color_text_2" }, [r._v("发票总额")]), e("div", { staticClass: "label color_text_2" }, [r._v("发票数")])]);
}];
const WV = {
  __name: "issueInvoice",
  props: {
    debug: {
      type: Boolean
    }
  },
  emits: ["toPurchaseRecordPage"],
  setup(r, { emit: e }) {
    const t = r, { proxy: n } = yn();
    let a;
    a = (C) => {
      n.$toast instanceof Function ? n.$toast(C) : n.$toast instanceof Object && n.$toast.show(C);
    };
    const i = t.debug ? Sr : Pr, u = ue({
      billType: 0,
      companyName: "",
      taxNumber: "",
      email: "",
      companyAddr: "",
      bankName: "",
      companyPhone: "",
      bankAccount: "",
      Info: ""
    }), f = ue(null), c = ue({
      companyName: [
        { required: !0, message: "请输入公司名称", trigger: ["blur", "change"] }
      ],
      taxNumber: [
        { required: !0, message: "请输入公司税号", trigger: ["blur", "change"] }
      ],
      email: [
        { required: !0, message: "请输入电子邮箱", trigger: ["blur", "change"] },
        { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "电子邮箱格式不正确", trigger: "blur" }
      ]
    }), o = ue(!1), s = ue(!0), l = ue(!1), v = ue(0), p = ue([!1, !1, !1, !1, !1]), h = ue(0), d = ue(!1);
    Je(() => u.value, (C) => {
      C.billType === 0 ? C.companyName && C.taxNumber && C.email ? f.value.validate((D) => {
        if (D)
          d.value = !0;
        else
          return d.value = !1, !1;
      }) : d.value = !1 : C.companyName && C.email ? f.value.validate((D) => {
        if (D)
          d.value = !0;
        else
          return d.value = !1, !1;
      }) : d.value = !1;
    }, { deep: !0 }), hr(() => {
      s.value = JSON.parse(localStorage.getItem("isShowBillTypeTips")) ?? !0, Object.assign(u.value, JSON.parse(localStorage.getItem("invoiceLastInfo")) ?? {}), m(), JSON.parse(localStorage.getItem("invoiceLastInfo")) && (d.value = !0), x();
    });
    function x() {
      p.value[0] = !!u.value.companyAddr, p.value[1] = !!u.value.bankName, p.value[2] = !!u.value.companyPhone, p.value[3] = !!u.value.bankAccount, p.value[4] = !!u.value.Info, h.value = p.value.reduce((C, D) => C + D, 0);
    }
    function g(C, D) {
      C !== "" ? p.value[D] = !0 : p.value[D] = !1, h.value = p.value.reduce((B, S) => B + S, 0);
    }
    function y() {
      f.value.validate((C) => {
        if (C) {
          const {
            billType: D,
            companyName: B,
            taxNumber: S,
            email: F,
            companyAddr: I,
            bankName: z,
            companyPhone: P,
            bankAccount: M,
            Info: H
          } = u.value, O = {
            Info: H,
            bankAccount: M,
            bankName: z,
            billType: D,
            companyAddr: I,
            companyName: B,
            companyPhone: P,
            email: F,
            taxNumber: D === 0 ? S : "",
            serviceType: JSON.parse(localStorage.getItem("invoiceList")).serviceType,
            orderList: JSON.parse(localStorage.getItem("invoiceList")).paymentIdList.map((Q) => Q.paymentId).join(",")
          };
          i.applyBill(O).then((Q) => {
            Q.code === 0 ? (a("提交成功"), localStorage.setItem("invoiceLastInfo", JSON.stringify(u.value)), setTimeout(() => {
              e("toPurchaseRecordPage");
            }, 1500)) : a(Q.msg);
          });
        } else
          return console.log("error submit!!"), !1;
      });
    }
    function m() {
      const { paymentIdList: C } = JSON.parse(localStorage.getItem("invoiceList"));
      v.value = C.reduce((D, B) => (D += B.price, D), 0);
    }
    function b() {
      e("toPurchaseRecordPage");
    }
    function w(C) {
      l.value = C;
    }
    function A(C) {
      u.value.billType = C;
    }
    function E() {
      o.value = !o.value;
    }
    function N() {
      s.value = !1, localStorage.setItem("isShowBillTypeTips", !1);
    }
    return { __sfc: !0, props: t, proxy: n, emits: e, Toast: a, service: i, ruleForm: u, ruleFormRef: f, rules: c, showMore: o, isShowBillTypeTips: s, isShowInfoDetails: l, priceTotal: v, moreContentHasValue: p, FilledSum: h, mustInputed: d, updateFillSum: x, changeInput: g, submit: y, getPriceTotal: m, lastStep: b, showInfoDetails: w, changeBillType: A, isShowMore: E, closeBillTypeTips: N, ref: ue, computed: dr, watch: Je, onMounted: hr, getCurrentInstance: yn, serviceDev: Sr, serviceProd: Pr };
  }
};
var KV = /* @__PURE__ */ Rr(
  WV,
  YV,
  ZV,
  !1,
  null,
  "20506aa7",
  null,
  null
);
const JV = KV.exports;
var _V = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "invoice-popup-container", on: { click: n.closeOutSide } }, [t("div", { staticClass: "content", style: { top: n.top } }, [t("div", { staticClass: "popup", class: n.popupKind }, [t("div", { staticClass: "title" }, [e._v(e._s(e.popupType === 1 ? "发票开具中, 请耐心等待" : "电子发票已于" + n.dateFormat(e.popupContent.completeTime) + "开具成功, 并发送到您的邮箱, 请查收~"))]), t("div", { staticClass: "desc color_text_vip_2" }, [e._v(e._s(e.popupType === 1 ? "自提交后预计10-15个工作日内开票" : ""))]), t("div", { staticClass: "companyName" }, [e._v(e._s(e.popupContent.companyName))]), e.popupContent.taxNumber ? t("div", { staticClass: "taxNumber" }, [e._v(e._s(e.popupContent.taxNumber))]) : e._e(), t("div", { staticClass: "email" }, [e._v(e._s(e.popupContent.email))])]), t("div", { staticClass: "popup-close", on: { click: n.close } })])]);
}, $V = [];
const eQ = {
  __name: "invoicePopup",
  props: {
    popupType: {
      type: Number
    },
    popupContent: {
      type: Object
    },
    showPopup: {
      type: Boolean
    },
    billType: {
      type: Number
    }
  },
  emits: ["handleClick"],
  setup(r, { emit: e }) {
    const t = r, n = dr(() => t.popupType === 1 && t.billType === 0 ? "29px" : t.popupType === 1 && t.billType === 1 ? "63px" : t.popupType === 2 && t.billType === 0 ? "29px" : "63px"), a = dr(() => t.popupType === 1 && t.billType === 0 ? "popup1" : t.popupType === 1 && t.billType === 1 ? "popup3" : t.popupType === 2 && t.billType === 0 ? "popup2" : "popup4");
    function i(c) {
      return mr.dateFormat("yyyy.MM.dd", new Date(c));
    }
    function u() {
      t.showPopup && e("close");
    }
    function f(c) {
      c.target.classList.value === "invoice-popup-container" && u();
    }
    return { __sfc: !0, emits: e, props: t, top: n, popupKind: a, dateFormat: i, close: u, closeOutSide: f, ref: ue, computed: dr, watch: Je, onMounted: hr, util: mr };
  }
};
var rQ = /* @__PURE__ */ Rr(
  eQ,
  _V,
  $V,
  !1,
  null,
  "2498e869",
  null,
  null
);
const tQ = rQ.exports, Xw = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASTSURBVHgB1VldbhpXFD73zsBgwAMYJzY0UWnzI7UvNQ+1ZClSzArarqDKCpodJN5Bs4KqK6h3YCJFQnIfnKemcuuWKC0kinEGYhOGMHNzzuA7XEjsMDaGyffC/Rk0n87PnXO+y+CM2NnZSXc6vRXG2PfA4HMAtiKESDMGadoXAizOoSoALOGIh7hUXlv7tgxnBIOAqFR+XydySOBHSWpcEHnG2SYH58Hq6urjIP8dm6hHUGP3QMA6TAIMysLR7qytFavjPf4RkIvtrnsP7XF3dC8S0XuZTPp1PB630ymzrWmaq+u6S3u9Xo/bdjdi27bebLXiltVMdrtvIx+g8LMR5RvFYtGCsxKtVCoFxqNbSLKgrmezC81Li9lWKmW+gQA4OmobtfrzzMHBK3N4R1SFq5dOs+6JRB892l7RdL6lxmEikXhz4/oXdcMwenAOdDqdyLP/atlhwqLKmfjhpNhl45Akl+Zzy418fvkVTBD1+ov0/7X6ouM43KOKyaZxt/Qhsu8RHXV3NBp9e/PGtVoiEbfhAkDWffLn7hUZv0QWhFYcDYMhoseJs6OS/Pqrm8/O6+qgZCkMjKheVBOMq384zu4Cjcnd0yBJiMVi6LXrNXpnf4UV+lwG8ImSy9UjiGJyGiQlKLQ+y+f2ByviLp3dcuYTZVrkFzmm42fSiTMOcrklK5lMtMHnxHyrekS3t7dX1C/O1Sv5BswI174svPAnyEla1SPqOOC7nKw5TZePguJ1YSHTknOv6AHpesa/kxu55csWzBiXLy025ZiKHzqNeL8a6h/sdBzh1+dCzssgoE8z1RE0Jm5UTpJF1+UD6bR5CCEBFTtyTO7nmFm35YI5nwxUZFwkqCKTYxfPdo6fLL/ooECGkCBlzvtG44x/wzFaC3IBsz00RLGudeSYWhyulnGy6A0DVC7EkcMnAu6VVceg9gFCApWL19Fi6vtEZQEbBlC/5U8YYPUPwq+mrWYrDiFBB5tCOWZkUUfAU7nQbrcNCAlarYHRMOsfYj8lNuWCZbWSEBJQe61My7wT0x/LhOp2uxF0/xzMGNRWqz0USUG8hH0JVii/yof29xsmzBjU+8sxSUD062W56v5G4yBlK4E8bVCjp/b7pFP1fxGeyoZakNz8e+/fZZgRSJjwJwLKsscfHKqO2JDjw8OjOAoDGZgyavhO1ZpCaHfk2CdKVnUFPJBzVDGyFNQwJZDLa/hOfwG5qCLEcF9vaPcxYr1N+krt/rWXn0a8SgFi8GVEAcLjMsAQUe8EcLsl9bj648nu1YskS14bVUlI2RuVIccWybDnbqBAMNFen2KS3K2KZE7PLd26NYZIppLVI9pvqjZKrTT1/JOQHff+qS5R0sq100ieSpRwmpC7hG31fMCO1Wo2516+bKQmKuRKbGFPbdjOfSyzfhrdo/aaOlfTnG9H0cpz2Mqo0ji5lCoyKnZOlMYxuylxziWNq/Csy1CfYhO6bMDDHKuijXGvdAJf33iJpqEEhOrKma5vsK5AgptB75wCE1VxLGDRvdNtQaSxo1UvxBhQ9+AV5k+JXAwrtY+5+CS8A0Y7YLbuQwlWAAAAAElFTkSuQmCC", jw = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOXSURBVHgBzZk/aBNRHMe/7xIsItpQ0KFSjOikg+mg4NRkqlvroNBJuupgCio4tZ0ErTYdXC2CIOgSx05NXRwKtiI6tRixOijYo4tWTJ6/38vd5dLe5d6dl0s+EO7SvGs++b1/v/eeQESKMzKDQ8gJgXF6nZACOUhk6KOMVcSEQJWvsoaVNFCZuy0qiIhASIoPZJ7l6MlrLildTPrCcr2GhdIdsR7mQW1RJZjCNEUtjzgQqMhdTJbuiqpe8QC4io1+TMs6iugAJFCqG5gtTQkzoJw/xXsyKw5gmW6z6CxV+QeFdtE1/D4o3pc5klxD5yUZFRD+Tr8CnhFVkikVybCd5X/hEaLg1dH2iSZY3X6Y1AyG9zaDFlHuOOJwYtXdjqo0SNbVwVraKPdudF+SyRp15eLgRNSq8k/oIVJ1FOzZzImo6MMieoxaqhlVFVGrl6+hB7GjqiIqjM7MOnFQ47wCVkSnHsptJDxmHj8KDPQD7zcCi5o0ApxMc7KBLkhevwoc7ANWPwDPl9oWz6T/IsdVn0eCuCWZgSPBz3D1G9SJRpAQLDU51pTc3gmMpoKS8ixHNJFqZ0mOpB1Blnz8Avi5E/wsdaRzBiXCWWjC1XZ6CKHZK/l7V1/SIpOGZkTPnwUmRhv3S28ar4QklaihW9JuV8zoxcZL5xm3JPPkFfD1B0LDoqZOQR5Gvn1vvg+S9ZLkjrOxhSiY2qK/uMpe6suyJLdpm3Kl8WMjQctuFn2nW15XduJSqyS359dvEZ06RVRKtUmgTZDseJ463hm0SOp2PD/IcUWo9bqhlh6h4DZ44woweKz5t80vwKmheCUZzqAMpMELKa126sYrsp2QJEyV5vG6hEL7FBHwkmVWP8YmSfMRynxNW+/K1LNuIgIsO/cMuEATwiB1oM0trdRNH9qn4ouzZpp6JJdj21eKC4nK/C1R4FtnZqKF/yx6DJnCpH3viJaowVJbXUCvQC7Uf6r229a5PoUZa/O1u5CDZBcXLaJqBBDgNhF6uIoNliSHvduQ+7InDjdvVKEbsgIcqMvuKrfxTPN4N03JJtkMGpIcyXXvj9tQnKdtHonlMKuASDSru+pXpG3irJqBwHBHRwP63/wd7SQZ/cOGRnQX45oU6MdX6H/NljSPdMIf3/D2NW0BUcY1Zp0r6cPtsE55BU3ZpZBnTqFF3Vi7LHysM0ICGZLPOvIkRfcmJRXrdP2s8gnK1IJOP/z4B7CYYVsSmzhIAAAAAElFTkSuQmCC";
var nQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "vip-record color_bg_1" }, [t("div", { staticClass: "invioc-operation-area" }, [n.invoiceSwitch ? t("div", { staticClass: "enter-invoice" }, [t("div", { staticClass: "left" }, [t("div", { staticClass: "select-item" }, [n.multipleSelection.length !== n.list.length || n.list.length === 0 ? t("img", { staticClass: "select no-select", attrs: { src: Xw }, on: { click: function(a) {
    return n.selectAllCover("all");
  } } }) : e._e(), n.multipleSelection.length === n.list.length && n.list.length > 0 ? t("img", { staticClass: "select selected", attrs: { src: jw }, on: { click: function(a) {
    return n.selectAllCover("blank");
  } } }) : e._e()]), t("div", { staticClass: "content color_text_1" }, [e._v("全部")]), t("div", { staticClass: "invoice-total" }, [e._v("共" + e._s(n.billList.length) + "笔订单可开票")]), n.multipleSelection.length > 0 ? t("div", { staticClass: "invoice-select-total" }, [t("span", [e._v("已选" + e._s(n.multipleSelection.length) + "笔,")]), t("span", [e._v("共")]), t("span", { staticClass: "select-invoice-price" }, [e._v(e._s(n.invoicePriceTotal))]), t("span", [e._v("元")])]) : t("div", { staticClass: "invoice-select-total" }, [e._v("请选择需要开票的订单")])]), t("div", { staticClass: "right" }, [t("div", { staticClass: "quit-invoice-button color_divider_1_border color_text_1", on: { click: function(a) {
    return n.switchInvoice("close");
  } } }, [e._v("退出开票状态")]), t("div", { staticClass: "next-button color_divider_1_border", class: n.multipleSelection.length > 0 ? "color_text_1" : "color_text_2 non-clickable", on: { click: n.batchOperate } }, [e._v("下一步")])])]) : t("div", { staticClass: "before-invoice" }, [t("div", { staticClass: "before-invoice-button color_divider_1_border color_text_1", on: { click: function(a) {
    return n.switchInvoice("open");
  } } }, [e._v("批量开发票")])])]), n.loading ? t("div", { staticClass: "list-loading color_bg_1" }, [e._m(0)]) : e._e(), n.list.length === 0 ? t("div", { staticClass: "no-data color_table_bg" }, [t("div", { staticClass: "content" }, [t("div", { staticClass: "no-data_img" }), t("div", { staticClass: "no-data_content color_text_1" }, [e._v(e._s(n.invoiceSwitch ? "暂无可开票订单" : "暂无订单"))])])]) : e._e(), n.loading ? e._e() : t("div", { directives: [{ name: "infinite-scroll", rawName: "v-infinite-scroll", value: n.handleCurrentChange, expression: "handleCurrentChange" }], ref: "tableScroll", staticClass: "scroll", staticStyle: { "max-height": "385px", overflow: "auto" }, attrs: { "infinite-scroll-distance": 20, "infinite-scroll-immediate": !1 } }, [t("div", { staticClass: "record-list" }, e._l(n.list, function(a, i) {
    return t("div", { key: `record-item_${i}`, staticClass: "record-item color_divider_1_border", class: { "color_label_1 color_label_1_border": a.check } }, [t("div", { staticClass: "record-item-header" }, [t("div", { staticClass: "title color_text_1" }, [e._v(e._s(a.title))]), t("div", { staticClass: "price color_main_1_text" }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price-num" }, [e._v(e._s(a.price))])])]), t("div", { staticClass: "record-item-info" }, [t("div", { staticClass: "left" }, [t("div", { staticClass: "info-item" }, [t("div", { staticClass: "info-item-label color_text_1" }, [e._v("生效时间")]), t("div", { staticClass: "info-item-value color_text_3" }, [e._v(e._s(n.dataFormat(a.serviceStartTime)))])]), t("div", { staticClass: "info-item" }, [t("div", { staticClass: "info-item-label color_text_1" }, [e._v("到期时间")]), t("div", { staticClass: "info-item-value color_text_3" }, [e._v(e._s(n.dataFormat(a.serviceEndTime)))])])]), t("div", { staticClass: "right" }, [t("div", { staticClass: "info-item" }, [t("div", { staticClass: "info-item-label color_text_1" }, [e._v("支付时间")]), t("div", { staticClass: "info-item-value color_text_3" }, [e._v(e._s(n.dataFormat(a.payTime)))])]), t("div", { staticClass: "info-item" }, [t("div", { staticClass: "info-item-label color_text_1" }, [e._v("订单ID")]), t("div", { staticClass: "info-item-value color_text_3" }, [e._v(e._s(a.paymentId))])])])]), t("div", { staticClass: "line color_divider_1" }), t("div", { staticClass: "record-item-operation" }, [t("div", { staticClass: "operation-status color_text_3" }, [e._v("已完成")]), a.isShowBillBtn && !n.invoiceSwitch ? t("div", { staticClass: "operation-button color_divider_1_border color_text_1", on: { click: function(u) {
      return n.singleOperate(a);
    } } }, [e._v(e._s(a.billState === 0 ? "开发票" : a.billState === 1 ? "开票中" : "已开票"))]) : e._e()]), n.invoiceSwitch ? t("div", { staticClass: "check-box" }, [a.check ? e._e() : t("img", { staticClass: "select no-select", attrs: { src: Xw }, on: { click: function(u) {
      return n.selectCover(u, a, i);
    } } }), a.check ? t("img", { staticClass: "select selected", attrs: { src: jw }, on: { click: function(u) {
      return n.selectCover(u, a, i);
    } } }) : e._e()]) : e._e()]);
  }), 0)]), n.showPopup ? t(n.invoicePopup, { attrs: { showPopup: n.showPopup, popupType: n.popupType, popupContent: n.popupContent, billType: n.billType }, on: { close: n.closePopup } }) : e._e()], 1);
}, aQ = [function() {
  var r = this, e = r._self._c;
  return r._self._setupProxy, e("div", { staticClass: "content" }, [e("div", { staticClass: "loading-icon" })]);
}];
const iQ = {
  __name: "vipRecord",
  props: {
    debug: {
      type: Boolean
    },
    currentType: {
      type: String
    }
  },
  emits: ["toInvoicePage"],
  setup(r, { emit: e }) {
    const t = r, { proxy: n } = yn();
    let a;
    a = (H) => {
      n.$toast instanceof Function ? n.$toast(H) : n.$toast instanceof Object && n.$toast.show(H);
    };
    const i = t.debug ? Sr : Pr, u = ue(0), f = ue(20), c = ue(0), o = ue([]), s = ue(0), l = ue([]), v = ue(!1), p = ue([]), h = ue(0), d = ue(!0), x = ue({}), g = ue(!1), y = ue(1), m = ue(0), b = ue(!0), w = ue(null), A = ue(dr(() => v.value ? l.value : o.value));
    Je(() => p.value, (H) => {
      const O = H.reduce((Q, k) => Q + k.price, 0);
      h.value = O.toFixed(2);
    }, {
      deep: !0
    }), Je(() => t.currentType, () => {
      u.value = 0, s.value = 0, o.value = [], l.value = [], p.value = [], v.value = !1, d.value = !0, b.value = !0, e("setAllowChangeTab", !1), M(), P();
    }, {
      deep: !0
    }), hr(() => {
      M(), P();
    });
    function E() {
      g.value = !1;
    }
    function N(H) {
      if (H.billState === 0) {
        const O = [];
        O.push(H), localStorage.setItem("invoiceList", JSON.stringify({ paymentIdList: O, serviceType: t.currentType === "vip" ? 0 : 1 })), e("toInvoicePage");
      } else {
        const O = {
          orderNumber: H.paymentId,
          serviceType: t.currentType === "vip" ? 0 : 1
        };
        i.getBillStatus(O).then((Q) => {
          y.value = Q.data.billState, m.value = Q.data.taxNumber === "" ? 1 : 0, x.value = Q.data, g.value = !0;
        });
      }
    }
    function C() {
      if (p.value.length > 0) {
        const H = p.value;
        localStorage.setItem("invoiceList", JSON.stringify({ paymentIdList: H, serviceType: t.currentType === "vip" ? 0 : 1 })), D();
      }
    }
    function D() {
      e("toInvoicePage");
    }
    function B(H, O, Q) {
      H.stopPropagation(), O.check ? (O.check = !1, p.value.forEach((k, L) => {
        O.paymentId === k.paymentId && p.value.splice(L, 1);
      })) : (O.check = !0, p.value.push(O));
    }
    function S(H) {
      p.value = [], H === "all" ? l.value.forEach((O) => {
        O.check = !0, p.value.push(O);
      }) : l.value.forEach((O) => {
        O.check = !1;
      });
    }
    function F(H) {
      H === "open" ? v.value = !0 : (v.value = !1, S("blank"));
    }
    function I() {
      if (!v.value && A.value.length > 0) {
        if (b.value) {
          b.value = !1;
          return;
        }
        u.value += 1, M();
      }
    }
    function z(H) {
      return mr.dateFormat("yyyy.MM.dd hh:mm", new Date(H));
    }
    function P() {
      const H = {
        imei: "1",
        keyfrom: "webdict",
        type: t.currentType === "vip" ? 0 : 1
        // 会员订单
      };
      i.getBilllist(H).then((O) => {
        l.value = O.data.paymentList;
      });
    }
    function M() {
      const H = {
        imei: "1",
        keyfrom: "webdict",
        status: 2,
        // 已支付订单
        type: t.currentType === "vip" ? 0 : 1,
        // 会员订单
        pageNum: u.value,
        pageSize: f.value
      };
      u.value >= s.value && u.value !== 0 && w.value.scrollTop > 0 ? a("已经到底了") : i.getPaymentList(H).then((O) => {
        u.value === 0 ? o.value = O.data.paymentList : o.value = o.value.concat(O.data.paymentList), d.value = !1, c.value = O.data.total, s.value = Math.ceil(c.value / f.value), e("setAllowChangeTab", !0);
      });
    }
    return { __sfc: !0, props: t, proxy: n, emits: e, Toast: a, service: i, pageNum: u, pageSize: f, total: c, paymentList: o, pageCount: s, billList: l, invoiceSwitch: v, multipleSelection: p, invoicePriceTotal: h, loading: d, popupContent: x, showPopup: g, popupType: y, billType: m, isFirst: b, tableScroll: w, list: A, closePopup: E, singleOperate: N, batchOperate: C, goToIssueInvoice: D, selectCover: B, selectAllCover: S, switchInvoice: F, handleCurrentChange: I, dataFormat: z, getBilllist: P, getPaymentList: M, ref: ue, computed: dr, watch: Je, onMounted: hr, getCurrentInstance: yn, isVue2: ru, serviceDev: Sr, serviceProd: Pr, util: mr, invoicePopup: tQ };
  }
};
var oQ = /* @__PURE__ */ Rr(
  iQ,
  nQ,
  aQ,
  !1,
  null,
  "8653778b",
  null,
  null
);
const sQ = oQ.exports;
var uQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "purchase-record-container" }, [t("img", { staticClass: "close-btn", attrs: { src: Yo }, on: { click: n.closePurchaseRecord } }), n.showPurchaseRecord ? t("div", { staticClass: "purchase-record-page" }, [t(n.tab, { attrs: { isAllowChangeTab: n.isAllowChangeTab }, on: { handleClick: n.selectCombo } }), t(n.vipRecord, { attrs: { currentType: n.currentType, debug: e.debug }, on: { toInvoicePage: n.toInvoicePage, setAllowChangeTab: n.setAllowChangeTab } })], 1) : t("div", { staticClass: "invoice-page" }, [t(n.issueInvoice, { attrs: { debug: e.debug }, on: { toPurchaseRecordPage: n.toPurchaseRecordPage } })], 1)]);
}, cQ = [];
const lQ = {
  __name: "PurchaseRecord",
  props: {
    debug: {
      type: Boolean
    }
  },
  emits: ["closePurchaseRecord"],
  setup(r, { emit: e }) {
    const t = r, n = ue("vip"), a = ue(!0), i = ue(!1);
    function u() {
      a.value = !1;
    }
    function f() {
      a.value = !0, n.value = "vip";
    }
    function c(l) {
      n.value = l;
    }
    function o() {
      e("closePurchaseRecord");
    }
    function s(l) {
      i.value = l;
    }
    return { __sfc: !0, props: t, emits: e, currentType: n, showPurchaseRecord: a, isAllowChangeTab: i, toInvoicePage: u, toPurchaseRecordPage: f, selectCombo: c, closePurchaseRecord: o, setAllowChangeTab: s, ref: ue, computed: dr, watch: Je, onMounted: hr, tab: jV, issueInvoice: JV, vipRecord: sQ };
  }
};
var fQ = /* @__PURE__ */ Rr(
  lQ,
  uQ,
  cQ,
  !1,
  null,
  "612476d2",
  null,
  null
);
const vQ = fQ.exports;
var pQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "message-item-container" }, [t("span", { staticClass: "time" }, [e._v(e._s(n.formatedTime))]), t("div", { staticClass: "message-item" }, [t("div", { staticClass: "message-header" }, [t("i", { staticClass: "ic_svip" }), t("span", { staticClass: "title" }, [e._v(e._s(n.content.title || ""))]), n.content.redirectUrl ? t("div", { staticClass: "outlink", on: { click: function(a) {
    return n.goToOutlink(n.content.redirectUrl);
  } } }, [t("span", { staticClass: "color_text_vip_1" }, [e._v(e._s(n.content.redirectTitle || ""))]), t("i", { staticClass: "ic_arrow" })]) : e._e()]), t("div", { staticClass: "message-content" }, [t("p", { staticClass: "color_text_vip_2" }, [e._v(e._s(n.content.text || ""))]), n.content.imageUrl ? t("div", { staticClass: "img-container" }, [t("img", { staticClass: "message-img", attrs: { src: n.content.imageUrl }, on: { load: n.loadImg } })]) : e._e(), t("div", { staticClass: "divider" }), t("div", { staticClass: "account" }, [e.data.image ? t("img", { staticClass: "avatar", attrs: { src: e.data.image } }) : t("div", { staticClass: "defaultAvatar" }), t("span", { staticClass: "accountName color_text_2" }, [e._v(e._s(e.data.accountName || ""))])])])])]);
}, dQ = [];
const mQ = {
  __name: "MessageItem",
  props: {
    data: Object
  },
  emits: ["loadImg"],
  setup(r, { emit: e }) {
    const t = r, n = ue(dr(() => {
      const { time: f } = t.data, c = new Date(f), o = c.getFullYear(), s = c.getMonth() + 1, l = c.getDate(), v = /* @__PURE__ */ new Date(), p = new Date(v.getTime() - 24 * 60 * 60 * 1e3), h = (/* @__PURE__ */ new Date()).getFullYear() !== o, d = p.getFullYear() === o && p.getMonth() + 1 === s && p.getDate() === l;
      return v.getFullYear() === o && v.getMonth() + 1 === s && v.getDate() === l ? "今天" : d ? "昨天" : h ? `${o}年${s}月${l}日` : `${s}月${l}日`;
    })), a = ue(dr(() => {
      if (!t.data.content)
        return {};
      try {
        return JSON.parse(t.data.content);
      } catch (f) {
        return console.log(f), {};
      }
    }));
    function i() {
      e("loadImg");
    }
    function u(f) {
      window.open(f);
    }
    return { __sfc: !0, props: t, emits: e, formatedTime: n, content: a, loadImg: i, goToOutlink: u, ref: ue, computed: dr, watch: Je, onMounted: hr };
  }
};
var hQ = /* @__PURE__ */ Rr(
  mQ,
  pQ,
  dQ,
  !1,
  null,
  "1f92df09",
  null,
  null
);
const gQ = hQ.exports, xQ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAGVCAYAAABtk/EKAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAACAASURBVHic7L15dBzXdef/va+6ekEDjR0kQCzcQIAAFxHcRZHa5UVja4k8cexY4/zsWBkvUn6ek5Oc8zvJUBlnmUzs2FmsxIqPo3gcO7Yy2jyxFEkktXAHRIGEuIIgiZ3YG0DvXe/9/qiuRnWhN4AACJDvcw4OGtVVr15VN9637n333gdIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpEsCMrN7sDNQghBRMQOHTqkAKAsDyMALPY722MkEolEsoix3ewO3CyGhoZyS0tLt7nd7q0+n+8ygEMAxgFoll1Z7MfhdDrLGGMlQgg1Go36VVW97vf7RwFEAHAAYiGvQSKRSCQ3zm0phEKI3L6+vgdcLtfvq6paSUSjQojjAH4O4H0AgdiubqfT2cQ5v4+I7uCcl3LOXQCIiDRN03x2u/0qEZ0A8FYoFLoCIHyTLksikUgks+C2c40KIewAtrtcrv8vPz9/u9PpLOjv7y/xer21QogtAFYBCNlsthpVVZ8WQnyJiO4XQmwCUAOgHMByABUAqgHUAthCRDsURfFrmtYNIHSTLk8ikUgkM+S2EkIhBANQD+APGGP7PB6Pc/369diyZQt5PB5Hb2/vMp/PV09EuxVF+RiAfdCFMQ/6vbLOCxIAO4ACAFUAVttstg5N03oARBfswiQSiUQya24bIRRCEHSL7hsAHgGQyxijvLw8VFdXo7GxETU1Nay9vT1nfHy8XAhRDsCF7INiFAAlAAoVRTmpadrwvFyIRCKRSOYUdrM7sICUAfgsgMcB5MMkcKqqwul04sqVK/B6vRBi1jEvdiLaJYS4G4DnhnsskUgkknnnthBCIUQ+gIcA/Bb0+b0EK294eBg/+9nP8OKLL2JoaChbIRSYHiVKQoh8Irrf4XCUzEXfJRKJRDK/3PJCKIRwAdgJ4KsA1sByzZOTkzh06BB+/OMfo6urC5zzLJoUfgDnAPRBT50wC6IKYCPnPG+urkEikUgk88ctLYRCCBuABgBfB7AFljnRcDiMM2fO4B//8R/R3t4OTbOmECbCGIPb7SYiUqPRaJGmaREhRDOAswD80HMJiYiKoAuiRCKRSBY5t2weYSw4ZhWA3wFwL/ToTvP76OnpwQsvvICTJ08iHE6f/qcoClatWoUnn3wSQ0ND6htvvLHs0qVLgXA4zBljkwDeZIxp0KNHQ0QUSNugRCKRSBYFt6wQQs/z+zz0CFE3LPOCY2NjeOONN/DGG2/A7/enbYiIUFhYiM9//vP4whe+gGg0in379tHbb7+d8/rrr9dcvXrVFw6HhRCil4gOCCGOx1IoJBKJRLLIuSXTJ4QQxQAehT4vuAIWEYxEIvjwww/x3e9+NyuXqNvtxsc+9jH89m//Nqqrq1FYWIjVq1ejoaEBDQ0NVFhY6BgbGyudmJgoi0ajOQCYECIAYAjT5xAlEolEsoi45YRQCJEL3RX6TQDrkSQPsL+/Hy+88AJef/11hELpi8DYbDbU19fjmWeewZYtW2C36x5WRVFQWFiI2tparF+/3hBE59jY2IqJiYn1nPP10F2zADAMvfSaFESJRCJZZNxSQhgrn7YNugjuRpLrCwQCOHz4ML7//e9jcHAwY6pEcXExvvjFL+LTn/408vKmB4KaBbGhoQH19fVUWFjoGhsbq5ycnGyUgiiRSCSLm1tGCGPl09ZDrxzzcQCOZPt1d3fjH/7hH3D06FFEo+mroOXk5GDv3r146qmnUFlZCcaSB9kSUVwQ6+rqsH79etTV1RmCWGURRAXACPR6pFIQJRKJ5CZzSwihqXzalwD8OvTKMdPw+Xx499138fzzz8Pr9aZtkzGGyspKfO1rX8OOHTvgcCTV1QQMQSwqKkJ9fT3Wr1+PdevWUWFhodPr9VZNTk5u4JzXA1gNPYp1FEAQUhAlEonkpnGrRI2WAXgMuggWpdqpv78fr776KgYGBjK6RN1uN/bt24c9e/YgJydnRp0hIqiqitraWqxatQrbt2/H3r176d13381/55137rx69eqmSCRyZ2zpp3cBHAUwgOlrIUokEolknlnyFmGsfNrHAHwNwDqkKJIdCATw/vvv4/nnn8f4+HjaNhVFQW1tLZ5++mk0NDTAZpvd84LZQoxFmGLdunVUUlLi8Pl8KyYmJjZqmmZYiB4AE9AT86WFKJFIJAvEkhZCIYQTwB7o84I7kKZSTk9PD/7pn/4Jx44dy5guUVBQgMcffxy/9mu/Bo/nxmtnmwWxsbERjY2NqK2tpdLSUnswGCyfmJjYGI1GG6CXgCuELoaT0CvVSCQSiWQeWbJCGCufthl6+bQHYKkcYyYcDqO5uRnPPfccRkdH07Zrs9lQV1eHb3zjG1i9ejUUZe5uERGBMYaCggI0NDRgw4YNWLt2LS1btkzlnJeNj49vikQijQDWQl/SKQLdSpRrG0okEsk8sSSFMBYcUwvgy9CXVcpNt//169fx4osv4s0338xoDebn5+ORRx7BI488kjRdYi4gIhARPB4P6uvrsXnzZtTW1lJFRYVis9mKJyYmGkOh0EYhxFoA5dA/p0nISFOJRCKZc5ZqsEwFgCcwtbZgSjjn6OrqwltvvZVRBBVFQU1NDT71qU/NmwiaMQSxvLwcDz/8MHbv3o3W1lY6cuSI7ejRozWnTp2qHhgY2Ms5bxVCHANwAsApANehu02lKEokEskNsuQsQiFEEYBPA/ht6EEmaVeQ93q9eOutt/Dzn/88Y2Ht/Px8fPKTn8QTTzyB3Ny0RuacQ0TIycnBypUrsWXLFtTX11NVVRXl5+e7g8Hgap/Pt4Vz3gC9qHchdLepDzLSVCKRSG6IJSWEQogcAPdAryHahCyWkbp69Sqef/55nD9/Pm3KBBFh5cqV+NrXvoba2tpZR4reKEQEh8OByspKNDU1YcOGDVRTU0MlJSUOTdMqfT5fUyQS2QQ9OX8ZdKveB91tKpFIJJIZsmSEUAihAtgOXQTvQRZu3XA4jJaWFvzgBz/A5ORk2n3dbjf27t2LL3zhC/B4PCBKa2jOO0QEm82GsrIy3HHHHbjjjjto9erVVFZWZrPb7SV+v39jMBhsgp4yUgkgD7oYGusiSiQSiSQLloQQmsqnfQW6WzSrDPfBwUG8/PLLePvttzOuPF9eXo4vfelL2LJlC1R18aypa0Sa5ufno6GhAdu2bUNdXR1VVFQwj8eTGw6H1/r9/q2c840AqqEXF7ADCEBaiRKJRJKRRS+EsQjRagD/BcBnoVeOycpcu3TpEv7+7/8e3d3dad2idrsdmzdvxlNPPYWSkpKbbg0mwwiscbvdWLVqFXbs2IFNmzZRTU0NiouL7YqilPv9/qZQKLSDiGqhBxTlQw+oCUBPwVh8FyaRSCQ3maUQNVoC3Qr8DPQ5sawG82AwiPb2dnz00UcZrcH8/Hzs2bMHZWVlKQtrLyaICC6XCxs3bkRjYyM9/PDD1NLSIo4fP66cPn264ty5c8t7enruDofDV4UQRqTpBQCXAfRCroAhkUgkcRa1RSiEyAPwEICnAGxAFsExBv39/XjppZfw/vvvZxUk8zu/8ztYtWrVnCbQzzeG29Tj8aCuro52795NTU1NVFNTI0pKSlSn01kaCAQ2BoPBuwBsBLAS+sNEHnQhDEKfT5SWokQiuW1ZtKN+bG3BO6EHx+zBDPoqhMClS5fw/PPPo7e3N+2+OTk52LVrF5588knk5uYuSrdoNhAR7HY7ysrKsGXLFrZnzx5WX18vKioqRElJictut5cHAoE7wuHwPiJqhL5aRzmAAuiegTD0lIyleQMkEolklixK16gQQgHQCOCLAO7GDPsZCoXQ0dGRMWUC0OuK7tmzB263e8mKoBmjrmlpaSkeeOAB5e6771YGBgZEc3Ozdvz4cXHu3LnCy5cv7+7s7Nw+MTERBHBBCHEGwFkAV6En61+HvojwJBJdqNKdKpFIbjkWnRDGgmNWAvhNAJ8A4JppG8PDw/jwww/h8/nS7kdEKC0txa5du2C3pyxVumQxrMQVK1ZQRUWF/ROf+IS9r6+PnzhxQmtpaeHt7e2ezs7OrZ2dnZtGRkagadoQgPNCiIsArgDogb6IsBfAWOz3BHSXqhUpkhKJZEmy6IQQevi/UT4t5dqC6RgYGEBLS0tGa9DpdGLt2rVYvXr1TUugXwiMiFOHw4GamhpWXV3teuyxxzAyMsJbW1sjJ0+ejFy8eNHV399f1d/fX97f3793bGyMIpFIALoYdgshumOvrwMYgi6IPuh5i37okanmn5lWvLF+WDM1zwn691k1/RjudB7rTwRTEbTJzimRSG5DFtXoH1tb8BPQ0yRqMIv5qmg0it7eXpw9ezYrt+j27dvhdDpn1d+liCGKjDEsW7aMPfjgg67777/fFQwG0d3dzT/66CN+/vz5yOXLl+2Dg4OFXq+3cGJiomFkZCQ6MTHBJycnKRKJhAAMQl9MeEQIMQLdchwBMArdepzE1Lyj+ScMXZTMK2pEMb0IgA1TwVE26KKmYErszKJnB+CA7j1wQc8zzYm9Z7Qfhi7Yo7F+DkEX9oHYexKJ5DZl0QihaW3BJ6FHOM5qwm58fBwXL17E8PBwxn0LCwuxbdu2RZVAv9AYc4putxvr1q1jtbW1TgDOaDSKsbExdHd3o6enB9euXYt2d3eL/v5+2+joqGdiYsLj8/nWBAIBBAIBEQgE4Pf7eTAYRDgcFpxzY01FP2KWoxDCsB7DmIpYRezvKBItNCd04aPYa3vsx0lEZsFzx35cNptNUVUVqqrCZrNBURQCAM650DQN4XAYoVAoqmnasBDiAoATiqIcVVX1w2Aw2A1Zt1UiuS1ZFEIYW1twE4D/B3qk6KyjWQcHB3H69OmM1qCqqigvL8e6detuabfoTDCsRQDxCNTS0lLccccdCgC3EAKcc/j9fvT19aG/vx8jIyMYHh6mkZERMTQ0RCMjIxgbG1MCgUB+JBLxRCIRRCIRRKNRxF6LaDQaz+0UQiAajU77vBhjUBQlLtSMMdhsNlIUBTabDTabDXa7HTHhI7vdDpfLhZycHOTk5MDtdkNVVRARIpEIQqEQvF4vRkdHldHR0fKBgYHy3t7efZOTk9eI6P8UFBT8ZGxsrA1y7UeJ5LbjpitALDhmFYDfgr7AruMG2sLQ0BDa2toyCmFubi4aGxuXdMrEQmAWR0Bfqio/P9/IXTTfZ4pF+0LTNExMTMDn85Hf74fP54Pf78fk5CT8fj+FQiGEw2EIISCEQDAYTFgiyxA/h8MBIoLT6YSqqnA6nfEfQ/Byc3ORm5sLl8uV1QNNKBRCb28vnTp1CocOHVLeeeedVZ2dnU9xzsvKy8v/vK+v7zxu87lDIQRraYHi2gqyt4MGnWB2ZcpDs0yDaI9C3LMSGvR7xYlI1reVLFluuhACWA49QvTTADw30lAkEkFfXx86Ojqymh/csmWLtAZniSGOyR4iFEVBcXExioqmxzpl+lyyPW+mbanIycnBmjVrsHr1atx///3493//d/qbv/mbvLa2to+HQqEOAP8Luvv2lkIIQS0tsKmVsHscUKM2qFrQr6pKjs3GYPNHYFMISjQK5exgRPVUwq4NqArPByukqE2FLX6TgypEhYDWPhCNMsUWZRyRS8MiIkLgig1RxY6ozw/NrSISiSLKHAi7goiUlyNERNL9LFl03FQViAXHPAa9fFo5bjCZ2+v14sKFC/D7049jRISCggJs3LhRCuE8cqOiNV8YVm5RUREeffRReL1efOtb3yodGhraUVBQUDs2NnYaS9QqjHlYbBeG4CQHHCwCZzAacpwdCTtcKyhXtameYBj5TNNyiZzuiAZ3NMLdCsHJAYdqg6oJReEKQOAQHCBiiJpjmWIvBRg0jUMDQFFwYggLxvzhMAI2BYFglPuJsUke0SbG7cq4bxCjlweFLxRByGVDiNkRUv0IXShH+F4i6ZKW3DRumgoIIVwA7oNuDdZhDiqaDA8P48KFCxn3U1UVy5cvR1VV1ZIqqSaZe9xuN5qamtDU1IR33nmnNjc3d8fY2NgZLBEh/LkQSt11OJ05cIUjcJ0fgotRpIAUtVgLo5QLlKiKWigEPIoKlQtOxEC6XgJgXL9QDiIRq7dnxOpyy+80CICBYBMadwH6P7PeDgdjJLjGAQIXgF9hGI1EMWKDGI4yZaSyNzL60YAYt4UQyPEgAA8CPwRC+6W7VbJA3BQhjAXHbAXwJQDbMIMaomnaxPDwMC5dupTV/GB9ff0tmUR/s4lGoxgZGYHf74fb7UZ+fn48aGWxUl5ejtWrV9O7775bJISoutn9SYcQgvUBTl8/3IoTOeFR5HM1ugxhW7kClDOGUgjFJTTOGEGXJwCMgwSSPG0aUmMWvxuTn+mn4Po2IcCEgIcIeUxBVVQQIDiIKZpd8EmouB4OsH7hj/Z/Hrbrv9kjJiIC/lwBf2UlgkS0JB5OJEuPBRfC2NqCtQB+G3r5tDnJXeCcY3h4GFevXs0ohHl5eVi/fr20BueByclJvPrqq2hubkZNTQ0aGxtRVVWF0tJSFBUVweVyLSpRJCLk5OQgLy8PmqbZA4GAC4us3mqzEGrhKHKiHLntI8jnAuVCQTWP8iowFDPBVAFOjEDgmDKjBMAI6YXNKoQscX/Sm5nrG0IcIKNhATAGFHCgQBN8nQLGiXgIKrtui2o9QRJdHT22visDYjzqhb+7G/5775WuVMncsaBCGJu/KIduCX4cev7XnODz+dDV1QWv15tx37y8PNTX18v5wXkgGo2iq6sLhw8fxksvvQRN07B27Vrs2rULO3fuRH19PcrLy1FUVLRoLHJN0xCNRgFAE0JEcJPdokIIOnsWqrYCboUjj7wo8XNtpY2UVRy8ggAnZ2BEIAYQp0SDDoj9vVhXFEumrCJmuRJI6D23gfNVTKEacOLMjkmh8W7kiGvV65WrF7r8IyU5ronTRfDL+UXJjbLQSlAA4HMAHoW+zuCcPWiOjY3hypUrGa1BY7X3mpqaJbH24FIjLy8Pjz32GFasWIHW1lacO3cOAwMDePHFF/GTn/wE69atw7333ou9e/dizZo1WL58+U0teC6EQG9vLzo6OoSmaaORSCT9ciXzyMGDwlZ5D3LaA/AoZVhu07CGC76GBEoZIzvnnBGBCUr8xzF/i5nZosvGxWnszzH/wmkIoGFmYrqAWyAhoICgcM4LAOQrNqoHEGR2R+9IRLtcfV3pON8phjUnxhtK4ZdpHJLZsGBCKIRwA/gk9PJpqzCH/3ZCCIyNjeHatWtZ1RetrKyU+YPzhMPhwMaNG9HQ0IBIJILR0VG0trbi6NGjOHHiBLq7u/HDH/4QP/7xj3HnnXfi4YcfRlNTE6qqqhb8MzHyTg8ePIijR49qkUjkQjgcPokFtAiFEHS0G848OzxOG0q0MazlGq8DUM4E7AQwATAIwHxrEvSLAzy2gZnfTEWq91KI4aw+EavVZ1nDJFkXrac2i6QACAQiAQZwlQRqGaPVnPOgamNdDoHzHT24cqFXjDAfJtauRVjOKUqyZUGEMLa24G7olWM2Yh6ePQ0hzITb7cbq1avl/OA8oigKFEWB3W5HTk4Oli9fjnvvvRejo6M4efIk3nzzTTQ3N+Pw4cM4ePAgdu7ciSeeeAI7d+5EVVUVnE7nvAtiNBrF9evX8corr+DHP/4xHxoa6nE6nQcCgcCCpE78XAhlywjcZ0dRkO9AjWpDgwasFhp3A1CIgWXqBAMQK9ADZlaVZEJn3pbMj2qxIg2jbdbzg6kOEtO7k8oYtXbZ3EVGYBBgTEAl4nXEsYYYxhVi7SwXZ7u70fPRR8Lb0CCtRElm5l0IY8Ex6wF8BcBOzFFwjOUc8bqYmSxCKYQLCxHFS6K5XC588pOfxH333YeLFy/iV7/6Fd566y20traiubkZ99xzDz772c9i27ZtKC0tnZc5XM45JiYm0N7ejpdeegk/+9nPtK6urj7O+c/C4fC/IvkSU3OGEMJ2phN56gRKNYZ6pvEGUrCMA3bobsDsHwH4LJ8ok4iicc45C4zJoOLJMjSSWYTm7dbfxpsCUASHIoASAi8EYxvDCu9xFbK2615cGh4Ww0VF8Mlkfkkq5lUIY8ExVQCegp4zmDMf5wmFQhgcHMwqUMblcqGyslLOD94EjPUR7XY7tmzZgvr6ejz++ON47bXX8Mtf/hKHDh1CS0sLfuM3fgOPPPII6uvr52xlkGg0ivHxcfT09ODo0aP4xS9+IU6ePBmYmJjoAPALzvkLALoxL9agoOZm2NzL4TnbH15uz7U3ighvBFAgADsHWCrzL271scRtKc2lZFhVJon1mOz0lGJ7SoydLfOAVliK15n2Tflm7PqIg0CwQfBcENaC8xq/nw1yaB8FhpSPTl8bGxyuzp+QwTUSK/NtERZBX2X+4djrefF3TUxMoL+/P17IOR1OpxPl5eVSCG8yiqLE8zmrq6tx77334qc//SnefvttfP/730drayueeuop7Nq1Cx6PZ1auUk3TMDk5ibGxMd7d3Y3jx4+zX/3qV7y1tTXk9XpHwuFwM4CfAngL+vJMc+5COyiErWwcHtJQIbi2hTFbvca5hxFUAZBIc1nM9MIQxBl/a5OJYBLhNFuEybanJJn4pVHPZF1J9X66/aYdZBF3gh5kI8BXMKKyaIRvybXntzn7cOb0NdE/3IEJmYIhMZgvIXT+7d/+rZtz/muMsc8AWIF5zM2anJxEf39/xv2ICLm5uSgrK5OBMosERVGQl5eHrVu3Yu3atdixYwdeeOEFHDlyBD09PfjGN76Bj3/84yguLs74mXHOEQgEMDk5yScmJvjw8DA7ffo0Dhw4ED158qQYGhqKBIPBkXA4fF4I8X8BvAHgGoAQ5tgS/LkQyvYx5EWGw+VhptxBUBoFKF8IqCA9148hmRAw8Niobp3CSxkIk25OMJUlqFtQABLnAmf0X2EJgElnCSYTsnQimMwlmvBmMpILPIOAQwPKFPC77MAGm5215a4LtQ4Pi76334bvP/9n6TK93ZkPISSbzdb07rvvbtu+ffsX1q1bty4vL0+Zrzk5IUTcIsyEw+FASUnJggRjSGaGzWaL1/6sq6vD3/3d3+HNN9/En/3ZnyEQCODRRx9FSUkJiAic8/jSSsFgkAeDQR4IBGh8fJx1dHTggw8+CDU3N4cvX75sHx8f14LBoDcUCg1xzs8CeBPAYeiL8gYxx2sQ7heC/Q7gmvCGlge57Q6QbZMCFEJwO1FmneHgU8IXUwOzJZhVlkOywJkkgmjWq1kLYIbtM7FgzV1lyTZmEsBUORjQ3aYCcDCGUsb5XQJqw3gIH+7cidOt/eL6pmUIyKCa25f5EEJbNBr91KuvvvrrAwMDy5944gll7969orq6mvLy8uYlSGVychIDAwNZpU4sX75cukUXKUaVl02bNuEP//APUVhYiH/7t3/Dd77zHTDGsHPnTsEYg8/no6GhISP/L3rhwoVAR0cHDQ0NOQKBAA+FQv5QKDQRiUTGYgvwHgZwDLr1N4nERYHnBCEEnQVUZQglIyoaRFTdQYQyRnBoAiwbIbPuw2MbzF9XZrHq0kabWBtGcoNtTkRw+qniZBJvs8U77UPJ5l812cFJAoIEAK4/ZzjAsAyC38sZ6nM13tzdHTl36ZIYkmkXtyfzIoQArgSDwStHjx51nDlzpmjTpk22xx57jO3bt49qamrmXBD9fj+GhoYy7ud0OrFixQophPNINBqF1+sFEcHlcsHhcMz4fquqiurqanzzm98EYwz/+q//ij/5kz8ReXl5kUAgAJ/Pp2iapkWj0XAkEglFIpFAOBwOcs4nhRBdAM4BOAOgDUAv9GWVgpinRXeFEOzqGDwAVnEFu4XG1yiMuTTBFU0A5lGapTBtzFut0ZJAsg1IOtgnC6IhPqVf5im9+SCZAZrtp8/NL5I9OaTLvre6RBkgTNuEyRUc258BcIJQrRAr05ijjjkix892BzoOHhTjcv7w9mI+hDAIPQDhvVAo9GAoFPrUkSNH1p85c6Z4w4YN6qOPPkr33HPPnAqi3+/HyMiItAgXAWNjY/jnf/5nRKNR1NXVYc2aNSgsLITH44Hb7c763iuKgvLycnz961/H6OgoXnrpJerq6lI559c55wMABqGLXA+ATgBXYz+j0Of8QgDCmMcV54UQ1N4O+9lRLCOOrQrxJkGsQAB2IabXsWbxvwCrCWM2avhs1CQLcZgTMswBZnvKlPODVsFPay6m6BafmrKMrayRTvgVweEmwnrGlBU55GmtWhtq6erq6qmsrJSFvm8T5kMIBYAJABehh6P/RygUuj8UCj1y9OjRhra2tuKXX35Zffzxx+nee++l6upqys3NnbU4cc4xOTmJycnJjPs6nU4sW7ZMzg/OI5OTk3jzzTdx4cIFcM5RXFyMrVu34s4770RTUxOWLVuGgoIC2O32jJ8DYwyVlZX46le/is7OTrz33ns8Eon8m6qq/xSJRHqgi1wUQMT0syDzPEII1jGKPK0AtSSwB4KvFAQXF5wAxANe9PmuzCoVH+d5ois0ya5T25IJZZJ9rXOBMx7ZrWZkqhBTpNfr5A8GptfWjWaSXFdKN6/JFUopjrUiBFQARUzw3YrNUcVF5bGeHpw7eFB4pXV46zOfWeUC+hP5KICzAA5rmtbt9/tdfX19eSdOnLCfOXOGcc6Rl5cHp9NJNpttxiLl9/tx/PhxvPHGGxktwoqKCnzmM59BRUWFFMN5QAgBzjkYY8jNzUUkjqjSugAAIABJREFUEsHIyAguXryIQ4cO4cCBA+jt7YXNZoOqqrDb7cj0mTPGUFxcjEgkgra2NvL7/XC5XIeCweA5AD7oHogw9KCXBXl6bxZCnRjCsojQ7oSC+7kQlWBwEPSljhgyr9rATJ1lXN9RGCLILQdbrypZSkSatAVCYkTojL/55oNT+FazScQ3n5+SbI83YhUu882yErt2Mtdf5YAQsQ9jZt8IEoAKIfIFxErByLNiOXxf/ep+/3e/u1979tlnZ9SYZOmwEOVVzIJ4DsBRTdOu+3y+3J6entxjx46pZ8+eZYqiwOPxwOFwzEgQx8fHcfToUbzzzjsZhbCqqgqf+9znUFhYKIVwHiAiOJ1OrFu3DnfddRc+8YlPYMeOHSgpKUEgEEBvby9aW1vx1ltvob29HTabDW63Gw6HA4qipPxMGGMoKyvDyZMnqb29vcjv958WQpyH7v5cMIQQ9OUv73cpEayGigcEsF0A+QpBMcZcQ8fSCaHZ20dAfPAn6xuGwFkxGk31vmVXgczCnJQsAmOsIptqH2H6MS7NLFzxRozrF6bfaQTeaJwo1nZMRCmdeGaGAXAyomWRKC8nRYsKjY1v3bo/+otfPCtdpbcgC1lnzBDEEQAfATgRjUZHJicn87q6utzHjh2zXbp0iTmdTuTn58Nut1M2JbbGxsZw5MgRHD16NKMQrly5Ek8++STc7jlb/UligYjgcDjgdrtRUFCAqqoqNDU14YEHHkBjYyOICL29vTh79iwOHjyIq1evIjc31/AKJHWRG9GkfX19aGtrU7xe7wiADwFkjpCaI2KuUE/Qjs1c4OOC87WC4GKx8diaVw5MFweG2EBNJmHgMcvFaMSqpGk7lXyz9fyzsgRTnTvWSLYTGVYdM44j605mSzBTYn7sngnDEjQ1RlblnxEJjwokBFcJyAdQFQwJx7LS0MR/+etvBX7w7LMyzeIW42YU3BTQn+SHoEf2tUQikYnx8fH8K1euuI8dO8a6u7spPz+fPB4PVFWlVPOHxqr07733HlpaWtIKIWMMtbW1+NznPrdo1sG71THqjLpcLhQUFGDVqlXYtWsXdu/eDZvNhs7OTrS1teG9997D6OgoysrK4PF4krpLGWMQQhiJ9gzA+9DTIeYdIYTSNoBSrmAn5/x+QCwTBNU6nZVJHAQAQVMBHMzsSzWLoLGzFUMgsxBK68IPWYtgluKRTXtWizFpP5Jdb6Y+WMxQMrlHswmsSTyRuWfWu2ZcBuUQiXLFbivImWS+Z76+f/J739uvAdJVeqtwMytPcwABANehP92fCofDobGxscKLFy/mnDhxgo2OjorCwkLKzc2FqqqUzHU2MDCAd955B6dPn04rhHa7HQ0NDXj88cehqnNe91uSASKCqqrIzc1FRUUFmpqa0NTUBCEE2tvb0dzcjLa2Nng8HhQXF0+zDokIeXl5hls1VwhxALqrfV5dVc3NQg26UCGAu4lwJ5EoEJQYz6IPoYm+uFSeubg4xCweDpMYwnJQgv8QiVZSGiG0/pfM1SSA+ZrM3tlU7Sfth3n+0+wGzmTBxU4U10A+ZQnGrUBrjkhazLKc7ArMaksEkJ0RSgC+TLWz8Fd+H96/+Yv9ETlveGuwGJZg4NDzvPoAtAghzoZCIWV4eLjozJkzrlOnTlE4HBYlJSWULKCmr68PBw8exLlz59IKodPpxKZNm/Dwww9LIbyJEBEURYHb7caKFSuwdetW1NXVYWBgAGfOnMH777+PQCCAFStWID8/PyG9RlVVvPfee+LcuXNKOBw+Cj0Ia17mCYUQ9Jv79zvgwBqN8wfBaDMR3BwiPjVlOQJmqbC6A6fFmIgkf5vFwOwmTGYBGnNjmD6cz1j4UvzbmOf3jHZTBrpYjktphVpFK4OFS6YXcbeykQ5hzA2mT4+IYe0RTdvOICBM2xloKqBJN+dtAOULISqUMFH/JEbv3rU/LOcNlz6LQQgNNOhVP7oANHPOO/x+v7u/v7/o1KlT6rlz55jL5RIlJSVkt9vJGCD7+vpw6NAhXLx4Ma0QulwuNDU14aGHHpqX5X0kM8Nwm+bl5aGmpgbbtm2Doig4d+4cjh49iv7+flRVVaG4uDj+eQkh0NLSEm1tbYXP5/sQuidhYq77JoSgs4NwR4PYoAj+kE3BWg7hEhDmcXka+kCapD3okaFkHYetO1uFzqpspvfJJKSZbJtp57C2FzuX1Yq1TtMZmpXJ1ZoglmZ3rlXszS7MbOb0Yu1Q7FgjMjT5Q0kyezT1dhbrtfkTnBJ+iitv7Da5FYbldkFqZaV/7NOf/pPACy/IecOlzGJUhAD0xOhBAB+EQqGHenp6fu2NN95obGtrczz00EP0uc99Tm1sbITb7SbOOaLRzGk+iqLA4XDMc9clM4WI4Ha7UVdXh69+9atYv349nnvuObz++usYHh7G7/7u72LHjh1wuVxG0XRNVVUGIBfAnE/2CiHY2W4UKHm4Q9OwF0AZF/r/SdKKLyaSTU9Nqw6T9A3L+8nKzKRhVhZgkukwTki5GrA19y8V1q7HDzZvSFYbNFmeYOyE8e5a7gmZXluOTNG76WKoH06xaxOm64vtkywKSoAJLgrBoncycrhXrw4dFkJ0klzeacmymCxCM0aE6TD0eaDWSCQSHB0dXXbhwoXclpYW+Hy+aHl5uTIyMoL33nuPLl++nLbBnJwcNDU14Z577pEW4SKEMQa3242amhqsX78enZ2dOHHiBNra2rBixQpUVFTAZrOhpaUlcOzYMTY+Pt4GvX7o6Fz14eBBYaNclEVV7S7OsY8gSgRBSWacpcIYahPcg+aUAINUaRHWubMUIpg2ACVTB82/LVjTHKznS4c5IjTBdDbP3SWxblN2k6YCi0jEDjefZFpkaTZ3wyyC+v6GHZh43TS1OwEQAoxMpyMQAzmEoBIwljcyHJn4whf+x/gPfiAtw6XIYlcEDXq6xXEAHZzz98fGxn6jpaVl79WrV/OOHDkS2bhxIwKBgIoM/wGMsayqmUhuHkQEj8eDXbt24Y/+6I/w7W9/GwcOHMCf//mfgzGGvXv3Ck3TIpqmmUMs5gQhhNrmRXUgiruIaCMBuYbRkY0lZAgWj2XEc3Ny/EwwmZWpvIXTZ7fSYBWfZG5RpLYEs8Fs4MUrxBhvWMnqZiZCZgvQ3H4C2T4SWE08YWmOErsoMOWHFmYDlMAhwEjkEMQGsqlq6QrYPvpIXGpspHBWFyZZNCx2ITQIQ68p+TqAc5FI5MH+/v5f/4//+I8Nzc3Nzkgkogkh0l6LMSclWfw4HA5s3LgRf/AHfwAhBA4ePIjvfOc7cDqd8Hq90UgkokJ3oUdwg1GjQgjqA1znhlDPCHcJ8NUCcFn3y8otGFOBafsmq5eZrHoKMM3VR0C8YHSqcI+0WIUvxbxksmI1QHaalfR6rQ1ZD0iyzbD2hHm/bApuA0h9NxIVP1mZNxYTP2NXlnDPBJjQ3cZcGPsjLo5cAAA5QaKeRWHLz4dNCHGWiCKpeipZfCw1ZfABuAA9wvTDQCDwRF9f36M2m215pgMZY1BVVVqE84wQAqFQCIqiZCyflg5VVbF+/Xr83u/9HgKBAA4fPoznnnsOw8PDLBgMEoBx6OXVbqSvysUJFGoRbAHDLkYog4DdGvGZLQkryGcSv2RiYRFA6/uzcoVaG0zz2JBMd6wknQNM1kCqAyxCFrd6TQpFpjbIes+mtZHsjljzA1PvN9VlEQ8YyupmGaI5tcUBaLVCEHV3MyGEOCfFcMbYMDVdp2EeC+YnO/FSQ4M+L3QMelDNZSHE/0tEVUgzRhhCKJlfvF4v3nzzTSxfvhzr1q1DXl5evITaTLHZbNiwYQO++c1vwuv14sCBAxSJRHICgQCDXpDBP9t+NguhXvCiUnDshuCbAORbdSxbmGWgT3APZovVCjT9NnPDgTFJGp2hpzJOgu5ZxTxt1JCpe1ZL0LB+WZJrjZ8w3eOANYbW+JssRb4NlyjF5//ix4h4b4AEa1Ek0fqEG2oHsAbgors7iuZmcW7bNimGWWIHsBbAOuienitYgDxhg6UohAYhAF2KohwjovMAqtLtTETSGpxnNE3DtWvX8P3vfx+jo6NYs2YN9u3bh/vuuw/V1dXIycmZsZWoqiq2b9+OL3/5y/jTP/1TnDt3zimECEEvxOCbaR/3C8E+M4gcDKOBK9jNNb5SUZgLgsecXQzJV4tA7F0AHFOL5pqtPuvAb91mJYVozCgdIhWZAnMwQ7Gf6XHW605jCcYDYmL3YdragQntZHIQJ0aEJp7aEDLTPgn3JlW7ZjGdlhFqQTgAWss5idLSsCaEOE9EWoqdJVPkAvgYgP8KwAvgXwCchxTCrBDQBdGHDF6jTHVIJXOD0+nExo0b8dZbb+Hw4cM4deoUfvrTn2Lnzp146KGHsG3btqyXYTK3+YlPfALHjh1DX18fGx0djWIWq00cFMJWPoQyqNo2EaUmobESYlC54FNzP2kwm4vxQdZ4bbWAUglBMldhsryLGyVJekSybqZjRrEus+g/Wa7biAq1brccZXo9PRXC6KMuetPjqcwGZXyuT5i3TdniPGFecSZfNeFgjNUSUaS7OxQWQlwmSintEv2G2wGUAKiEPkefs5AdWKzpE9lCNputGMAuABuQRgjdbje2bNmCO++8c04WA5ZMJ5bnh82bN+O+++5DbW0t/H4/Lly4gLa2Nhw5cgQffPABIpEIiouL46vXZyOIxlqSH330Ebq6uhjnvA266ySje9RYNcLJsV7jeICAOwgo4iTi+YGAkfM9VVvEmvFg1LQETeWJm7elHSvNqRFG47EBn0yJ4bMOhbX2wfSaWTZnO9eY7P1pc5dk+j0TrTCiQE0dihfSTiqC1tR+wHolxmcnTK7QhOsVhIT1mgQwVbU71obpT+MtjlT3KpXdTgBgA0SBppErEFCG/vIv9088+6ysQJMGBboAhqBXjDoB/f97wU6+lCGbzZZPRNsANCHN/7bdbhdr164V+/btS1m3VHJjGJG5+fn5qKioQF1dHXbv3o1du3bB7Xajo6MDbW1tOHHiBE6cOIHJyUmUlpbC5XKlXYbJaLuoqAjRaBRnz55lIyMjAsAp6KvUp0QIoZwbwrKIA3u44PcAtEoQ5QjSq8SYrRurCCWMWubwfWMstUaNiMT942O0eSQ1RuWY8JmPserYjEhzgNGm9Vpn1aT5Wsx5fDMY4uMCGLs/5r+t9yRzz8wWIcW3UGxuL0Gq4smIxkZK6DuLHQfSPbBTDtFMfUg1k0sqEQqEEOrwMLv+3e/u98vapCmJQs8MOAG9oP4F6JHhC8JSF0KoqprLOd9KRLuQ5v87Go3S+Ph4tKioKLhq1SpVURTSNE3OHc4TxtqExcXFWLlyJTZv3oy77roLpaWl8VUnWlpa0NzcjGg0imXLlsULbaf6PBRFQWlpKU6cOEEdHR1FnPMW6P8w06LL9gvB/uWp/a7uEDaA8IAA30KCFYNgA3jcWkiF1ZqAYakYB5ktlmmJ3UgcQQ0xNPaLmWjJhvNZzw2mmQecrZU57RhuesOc9J9JuEyKlHB9MSsw6f1L2ptUc3jGFt2daYggi/9tOiYufmZr0iixJsx7Ws5Alh9k02kQkZ1zUeBwCAwOevv++q//54KuobnEiEIvmWhEhC+YBb3khdDhcDg555sA3I00/++cc4yMjNDp06dFf39/hIhs7777LpWUlCA3NzfpOniSG8ewEj0eDyoqKtDY2Ig9e/agqqoKPT09aG1tRXNzM06fPg273Y6ysjI4nc6kYmisS3jp0iWcO3fO7vP5LkNfymvc2EcIQfv371fy+1AVcWj3gHAXg6gRhBxGgsjk+kxFoqtUD4gRQHz9u6znwqzilzj2Jr9fyFK0rBkCFo2wCn1q915qpu1v9a8aDWfT19i9E3zqHs7u8dP6qKDfgKkqMQA3vTbL4JQ1ON2VKUz7ZnaFztRuJwdA+aqaE/n2t/f3PPvsszJ4ZjrLANwF4E4AZdCtwTmvI5yKJS+EbrdbjUajGwA8gPTxDiFN0waGhoa0CxcuuI4dO8bee+896ujoQHV1NUpLS+Xc4TxjlFErLy9HfX09du7cibKyMrS3t+PDDz/E8ePH0d7ejtLSUhQVFSWNMCUijIyMoLm5GYODg6MATgLoBwAhBDvTiYLBCHbYVdwHoJEBRZz0oLCshy2YxndusgOyCQhJJX5J3IhWGyNrYUgmSJYLSDprlQUJFqRVEcz9T/NAQEB8pYj4BkMMZxxUk2o2k+KuzKl53Vi1F+iWJidD3ARM9dKn2iXdnRq/LBJpPodkTy/Z3dWY08kJwDM+HvXv3v3H/XLFigQIetrElwB8AUA1gA7oKRQLwpIf+YPBoFBVtU4I8Z+QXggjAFo0TXs+GAyuGBkZKfN6vezatWvo7+/HunXrUFJSIi3DBcCw7JYvX476+nrs2LEDHo8HbW1tOHXqFE6ePIlIJILq6mq43e5pYhgKhfDOO++gs7MzAODd/fv3X/3RwYOO66NYr9jxAGN8O4SoAMFJSFwAPltrMD6vZo3RSDd8WQf4FNbfjF2V1j4ka0BMD4qZqRU47ZsvMF3EmeXvZBj3wXzDs5r/S/YJJXNDUkL3zHafIYgg3UWa2gpE/Ej9dmbyFNzw9AkDkAMI19q1ytBf/MX+UTlfGMcQwk8B2AxgDMA70MVwQVjyQgiAM8ZWA/g4AGea/Ygxdpkx9k+MsQYiqgeghMNh9Pb2Ynh4GBs3bkRBQYEUwwXCWHmioqICDQ0N2LZtG0KhEJqbm3Hy5ElcunQJpaWlKC0tTbAONU3D66+/jsuXL2u5ubkH/+p/vxoWIdu9AvwuCLEaQJ6I5U8nzPMh/XCWkHBtuPDM42+yQdwaPGIliQjOmGQThxaRMQs4S7J7JpJ+45MJfzbzgdb9xUz6kmrPZAKpd4bFP2XruWlKBOMPEMYxid7d9K7Q2WPpmQIOD49qqs+vdH/728/OuiDELQYBMOpF90EPgjsOfQWiBeFWEEKy2WxVRHQPgEKk/08aJqLzRPR56DkrBADhcBg9PT3wer1oampKaoVI5g/GGDweD6qrq7Fx40asWrUKFy9exMmTJ+PBNNXV1cjNzQURgXOOX/7yl3SpvR2//sWnfHsf/GQFIOoAFCHmBrVagdlYYYJPedAok9UDTA8eyQLztF7WpJtXpKnamNbuZHOOpEFDZvfuTLFYjjO2fhOeKqyvCSxmwxmW4FReIFkOi4mfkT9MU9ahtTLMfP+nm9snIhsR8oQm+Dee+a3O733ve3LpJh0/gHboFcOaoUeDL1hVnltCCIloOWNsN/TqMimFkIhUACugm98J9daCwSC6urowMjKCjRs3Ii8vT4rhAqMoCoqKirB27Vps2rQJkUgEJ06cMOYDUVVVhaKiIkQiEbzyyivo6LiCez72qbEt23eTILIbQYgzmXdLiA6NDf5Zr8Qwi9QBZNGnpAekOYfZYExmPKYipd/Dei5rQqUVc1SoyfSmtPclnRs09Wt9PlCfF2TmqzW7P5NY6Cx+TKrzzR/TvouC7CDhJpY3kZ//x/2HDsn5QugFMvzQ3aLjWEARBG4RIbTZbAUAtgBYj/TfbieAitjvafsFAgFcuXIFg4OD2Lx5sxTDm4CRdlFZWYmGhgaUlpbizJkzaG5uxuXLl1FeXg6Xy4XXfvlLdHX1RHbdfX/35q07xxjFwyLiP6k+uYS5NMsgnvLTTmZiZZoztOw6I+so2byg6bU1CDUV6TQsqSVo7mg2Qm8yQ81zgOlFMNnZs7GT9X3M7l+9qSlrMNFinOqYMQOYeJaZPDbMnmmtE0iAcgBh37o13Pvtb39r4jafLyQAdwB4AvpcoYJYANxCcSsIIVRVdQCoB7AbmccFe7p9AoEArl27JrxeL61cuRIFBQUymvQmwBiLW4erV6/G1atXcfLkSZw/fx4A0NLSgjGvN3DnPQ90Nm7e5rXkRgNI7yMnYKqeZbJgECvJxmkjly7J/jO1zuLnsB6cgmQOxFT7pfpJwHovsrVRYo0ZFXayuf+pG0qGkR5h6XvChcdUm3TXdmLYy9RrhinNzO7csyOVXZuwj77gcy6DQ+R5cPXZZ5+9nYtzO6EHynwTwHboOYSHMTvn/Ky4JUZ4j8cjIpHIKuhFW2800iXs8/lGOjo6HD09Pay8vBxlZWVyLcObgBFMU1NTg9raWgwMDODkyZM4e/YsOjs7Ra6nYPyu+z7eWbu+cdKw3M1ZC1bi282WT7bBIMlE0Nie4pgZz4/NYOdsRdb8ftp5wxlYtwnEBNDqnp29tJgnRKdaFRCmLYb6WnaPYxG/af1J18PZ9956ZOZWSAXxnPERbdJT+Me9t7GLtADAgwAehi6KrQAOQgrhzAgEAlFFUVYAeAhJFlWdSVNCiKOc8x/5fL68q1evll29etWWm5uL6upq2O32OeqxZCbY7XasWLECtbW18Hq9aG1txfDwMCoqa0b33P9g98radX4yDZGpiNcFBWZm9SRTELP1JqZe3rgQZCbbJz3rftOsR3NQzAzuhTERG7eoWTau0KQ9SPL+FNMCY4RJAAnxyKapfMLpvuvUZ8wkhjMj2REZWyGQEOQUEOqde5Suv/iL/b7b1EVqgx6zMQq9zuix2O8F45YQQgAgopJYmbXlmN04JKBHKn1P07SXALSHw2F3d3d31bVr1xyMMaxZsyZl1RPJ/KIoCpYtW4Y1a9bA6/Wis7OTfL5JqqpeM7Ju/YZxh9OZNG7T7LkUMwrjj2ENxbSKxo2kRyTL6bCaekkazOYcycRy2nEzfd7mU+0YqSXm15lJ9zQRbxnAVN1QHguKoYTDjQ/S8ALE5g3J2g3j4SgbmZrd40uqo7JtiQgKI7i0qIh29bAr3//+bVl1Jgp9WbUPoRfIuABgciE7cMsIoaqqTugLO27G7IRwnIh+yRh7IRqN9gHoAnA1Go2K69evr7ly5YqLc05r1qyR6RU3CcYYSktLsWrVKoyOjuLixYtqd9c1e2FR8cSq1Wt9iqpOG44Txmgxy9QF8+803LAIziDwxoq17GfGvsy0TJxF7BLEb0aCav0EKMl2o1oMxVaMgCkNAonH0tTxZm935hqrM7pbKVuYG0gFhNPuiA595zv/Y/A2tQpD0CNGR7DAIgjcQkKoaVrYZrMVAbgHgGOGhwcAHOGc/3U4HDaKOBtPKVc0TQsNDw+vvnLlSm4wGKS1a9fK+qQ3CSJCaWkpqqqq0NvTQ22nT+dc7+uxla+o8VavXBOwjk7xMZqnnjtMwOoGTTWXaHkbmMXAmMwoMWEWt0wDuzXeJyMzTRGhRPdndq7QVKSzxqYSYKbSA0XSQw1LMZm3O/vPwnze7LE+v9yQKMZKsBEYC/ezy//rb58N30hzSwyCHuj4CPQVhNzQXaQLWpz8lhFCABHGGCeilQBqkf130y+EOMoY+14kEjmCxA+AQ/9QLnPOJ7xe76qOjo78iYkJrFmzBvn5+STFcOEhIpSVlaG0tBSXLl6kj86czrHZbP619Y1ej6cgmlRQZjLwm0c287yitR8pXmeFddy3nMO6ZNJMEuTjWOcAze7dbDEMMctc6OyxCg/F3df676nWmeHLnhYhqv+YH0DMlzQfuYLJHkJm/QCU/Aw2BuGIKtz77b/6497baO1Cgm68/C6Ae6F/fC2QrtHZwzmfVBRlHEAN9MT5TDPzXgCvM8b+LhQKvYPk619x6AmeHZxz78TExMqOjo7CkZERsWrVKlZUVES3WnqFECLhtflH3zRVwfhmuYgZY1i+fDkCgQCdOXPG1t/Xx6pXrx1ZW7feZ+QUJgxeM0kHmEEAyYyv3jyop2jfPJCbA1xTkdJaTBcRmylJ3nSM2Sib/aedOhzXbNGx2BZjXcCEK6NYt8nY37zaRCqL/8bdnskcBHP9rdevi+yKjdkmfXTlL/9yf+A2cZEqAPYB+HXoq060A3gNegrFgnbiViKsadp1RVH6AChEVAwgB4lDmwDgE0KcIqL/LYT453A4fAzpb7yAXvWgQwgx4vP5Kjs6OopHRkZo5cqVrLi4eMmLoSF0oVAI/f39uHjxIs6cOYNTp06hpaVFnDx5Mtrc3Ow7c+bM+KVLl8KDg4NKIBBgNpuNVHWqSM9CCqPNZkNhYSFOnTpFp1s/tFesqB7ZvHX7qN3h0EfG2ZYKS2KhpbqqWV9t7ECzHhmvzRZgNu2n3CeNSzfldvM9M4368UXcb9BOSZzLtKwiLwBKMN0tV0ZWT/VUrOgNuyctZ001hTtf3+7YdSkkhINHeSAvn129TaxCBj1qdBxTJdaOY4ZrlNwot2Jy3Gg4HH5DVdUrQojXiWgt9LWuHABCRDTCOe9ijJ0PhUKnAQwgu5vOAQwDeEkIERodHf2vL7300pZoNMqeeeYZtmnTJlqK6RVCCExMTODs2bNoaWnB5cuX0d/fj9HRUTE+Pg6/349QKCTC4TAikQgjIltOTo6tpKSEiouLUVxcLFasWKHVrltHDevXK+vWrUNOTs6CLHhMRKipqUFjYyOOHDni6Gg/V9jT2elc19jom1FD5k8/yTJBc+oCI72EGzcNccYprd1IhdVinIaR6D/DoSTBUGWxv7PtVNatT1lwU+gSw6w3WExJD4O+xBKHvvag9fLmaoIi1Wdttlrn41sdD04mlkdA49A1tAkh+olubDZ2CaBBL7J9FYAHukt0wSNnb0UhBABfJBL5EEBbbm5uQSQSKRJCqEQUURRlIhQKjUCfC5zpl8xwp/5SCBEZHx//2muvvbYNgOvpp5+mTZs2weGYaZzOzSMUCuH8+fN4+eWXcfToUZw/f1709/dHwuHwKPQSR0MAJogoACACIptNUZzOHHfpwODQsqgWLQkGAnlOp5MqKyuxatUqUVdXxzdv2RLds2uXrbKyUlFVdV4FUVVV1NfXo6xsGfp6ejzdnVdy1q5v8LFshqtkQjFfz6Ep5gINjIF9pgN6yv2GhXkNAAAgAElEQVRneh2Wk08Twdm0aYGZXJhxOYmbXrEbFP9bv1n6fTG/N5N/2dkFwqRraa6xCroQwsaYqIiAbwZsg9CD9m5lCPpY3B/7mY0P54a5VYUQ0G9mZHJychD6gG7efqPtTgD4lRBCGx8f/9qrr766k4hczzzzDNu4ceOSSLz3+Xw4fvw4nn/+eRw4cCA6NDTUBz1y9iMoSq8CDBGRt6isLNy0405X7frN+YUlJcucLtdywaOlAZ+/b3zcWzA8eD2vr6crr7fzWsHhI0cLDh485KyurqatW5toz517+D333M1Wr149b/eEiLBy5UqUlBTjaleve3jwerqluHRmOKDPKuUimb9uFt8889JQGTHELNsFhGONUwoLeDZWZXaQqQsC0+qeUfKbNtUdQyQz3VCzf3fxGlYJy38BEIJywaihuztwRgjRewtbhQS9PvRe6Fp0DsAH0NMoFpRbWQjNzPUXSUA34d8QQoiJiQn22muv7VAUxfX000/Thg0bYJ43W2yEQiF88MEH+Ku/+ivx9ttvTwaDwWM2m+3/wG4/9vCnP9/9+//9T+zOAk+xorBilVE5gELBqdCmsgLBeT4XQiHQGCDGQsEA67p6xdV+/qO89vNn8y+dayu+fOFc6csvv1J47OhR25Ejh/Hggw/ivvvuw7Jly+alVF1ZWRk8Hg8F/ZecAZ8v+xtvNcNMCePALELxUx0gEk9nKsgyrTvm/YwuMWQQxFQNZoKbrtVwhd6w+KV6bJj+LxhfMNKw9AiIL5cEYbof+k5T3cpgXmc472IiqXuXoJDgy5WouhF6CtetbBVuBvB1AHkAXgZwCbrXbUE/uNtFCOcLH4D/EEIwr9f79CuvvLLdbrc7n376aaqrq1u09Uk7OzvxL//yLzhw4IBPtTtO7P3Yf/rX//bf/+xceVVNCYhqGZQCEAoJvFAAHgVQuMLAOdfj+IhgjJgOVw5fu77Rt7a+wRcOhQa6r3V0f3DsSNGpE0fLzn7YUv7yK6+WtLa2qh9++CE9+uij2Lp1K3Jycub0evLy8uB0OhEOBdVgMGDLyseYcaJtFu6wGRge2XbPEE5m2R5/MxlphCzexVhDwqy4xvY5EEN9Tm96t1jsfYMEgZ/m+jSH8Cbun8jcWHw3J/45BURuMF4/cAWnhBADt6hVqAAoBlAJIBf6HKEPN+HpZWmHOi4OIgA6AXhDodDKzs7O0nA4rNTV1VF+fv6iS7r3+/04cOAAnnvuOeFwuQef/Oo3m//bs/9zrKCktJ4Ra2QKW0fgKxRQoYDIicV20FTQOjCV6Sym/gZBsdlEYXFppK5x88SmrTuHikuXjXOI8KUL512nPmixd3Z2EuccK1asgMvlmrO5w3A4jDfeeAPnz1/gm7ft6t6+e99w0rbNOXRGaGYSbiglItnBU9H/WUU4JsveSLp/spiTDENIPBLVFJaasPzUrGZorFdkXgZpqkTa1F5k2hMJU4Pmt430iKnNqZIabpyFEkFrBSDz9mmbCAoE9+YWsO5nn312QaMoFwiCrkFj0MuqHQFwAnKOcMniB/DvQgjH0NDQMz//+c83eDwe+1e+8hVUVlYuqnJsfX19OHz4MMa846G9D31y8IkvfpnZ7Y71TAAcPP4Yz6epRBIzIemIzqDYIMrKy8O7775v6MrlC57Wk0e4d3QSBw8eRGdnJ3p6evDZz34WK1eunBOrWdM0cM5BRIJRlsvqmi5l7kIqEnMw44ITu3UJdy/uF0wkmTE2l49SCbNm8zj/Z/6bQ4AJTEWF6nkS+rWK6Xdd/y4mQ6R4vfhJ9hlm+lwJlAeFGrxetAohxm5Bq1CDni5xGrplGMJNiBgFpBDOFcac4atCCNfAwMA3fvKTn9R5PB7bk08+ibKyskUhhkII9Pb24oMPPkBBcfHkrn339ns8+VGAW+Ml0pM0pBDx0VWLatR55ZLrxR//aNU7b7y6NhwMeO7et48qKytx+PBh/PCHP8To6Ci+/OUvo7a29obFcGJiAsFgEHaHM+J0ORPnU2ZwYak+IZFksAYHIpEI8/u9it/nV/z+SSXg8yuhcIjxaJSC4aAyde7EJwan3cEdLid3OJya05Wj5eTkark5bs3hdmuqYkuiDDQ9pHSmqRE81guTj3VmH3pqpgpkx5u2zH1NnzSdelyZegyZflwyN+ncsZD/kdaPzxogkwwBqIyh3D8eWZOfr57CTRKJecQF3SIMQPeq3TShl0I4dxipFS9yznM7Ozu/9qMf/aimsLDw/2fvu+PjKPJ8v9U9Oc9IGuWcZcmWJSNsGdvYJpicFwxLZpcFbvPb2/3cvrsz792727u3xz1279iF2yUajMlgDBjbgG2Mo5wlWbIVbOU8Gs1octf7o6dnepKSZUkGfT8fSa3u6urqmar61i8Wc8cdd8BoNM52+wAAFosF58+fhzYuwVlWcfmQ4KHnj+TC5JiD4cUK0Rzl83pIU2O9etNfnsvftf3TAoVUor3n7ruZ2267DZmZmdi6dSs2btyId955B4mJiXjkkUcQHx9/Qe/U2dmJ4eFhqtHqRnU6I5+ncYKvEeKfKCI8n89LbFarpLe3WzbQ2y0fGhqQWSxDMvuIVWq32SSjthHp6Khd6nSOSjxuF+t2uVmX2yXxet2Mz+tjOB/HRErVPKQSCSeTyjmJROKTyuVeqVTGKRQKr0qt9ShVKq9GrXWrNBqvQW9ym+Li3XFxiS5zUpLLaEpwS1lpgDGYiMC7GBA7AU2a/MI9gMT/870m2mQesAX61eahrBMZpi6QJRP4P5re98IgfoOLGQ4BRA9NjeYYM55UyFFORyizoKsLdeA1T98WEPC5Ra8EH0x/BMBhzHCOUQHzRDi9oOCzp2/y+XxxZ86cefi///u/E5OSksjq1auhVqtnu31wOBywWCyIT073JqelOUNNW2OpQznRDBJtaPMar7aWZuWmvzyX/9W2j4tNBr16/fr15L777kNmZiZYlsVDDz0Ek8mEbdu2wWg0XrANlVKKhoYGdHd3I96cZEtMSXMwIOM7fPhJjwKwWYclnZ3nFT1dHYreni5FX0+3YmigXzFsGVQMD1vkNuuw3DZiVdjtNpnD6ZC5nQ6Zy+mU+nw+Vi6XEblcDrlcAblcBplMBoZhIJPJomoBKKWwj3ow5HbD7XbD5XLB5XLD6XSA4zgqlco9coXCrVAo3Cq12q3V6V1ajcGlNxgdOr3BFWeMdyQkJrvMSSmOlKRUR0pGtkOr1fkIYSgTQ906EbtkbESqOqMfC16eRHwq9Fi0YBK2VxIIkwscT7SV4reaHElebElwnPwMk1J1M5TIOULSWQ+SKKWthEyXHD/rkAO4AsDfgs/q9Tz4wPpZwTwRTj8oeJfnV7xeb8LRY8fu+Otf/2pITEwk5eXlsx5WQSkFx/GkxsWcP0TDl4YNZcHPPoq5ZrC7S/bBpleydm//rNBo0Ksffvhhcv/99yMxMTFAeHq9HnfeeScWLlyIrKws6PX6C3qfoaEhHD16FD09vVxJ+dKhzOyCQFYZQWD1vzg4AG6Xg+nt6pS3n2tRdXScV3V3til7u7vVA33dqsHBftXw0JBq2DKoHB21K1mGSPR6PQwGAwx6PdJTk6DVaoharYb4R6FQQKFQQKlUQiaTgWXZMYnQ4/HA5XLB6XTC5XLB4XBgdHQUNpuN2Gw2ud1ul9tsNmqz2WCxWNDS1AmLxQKny+VTqdQuvcHkMBnj7EZT3GhcQqI9KTnNnpqSOZqenjmanVtgi0tIdEtZCY1M1XIhCFVTjj+ZR6FeGjwIT4wd9CadbFjE+GVnMopwrGw3U1nycQSEBfSU+krq6th2AN+WnSk04FWjgtuWG7MkDQLzRHix4KusrGw+ceLEXzmOS92+ffvK1NRUlclkItnZ2bPqSapQKKDX6+H2OCU9He0Kvd5gi1ToiP4SJmwW4aLOKqMjI+xX2z5O2rH1/SKZhNHcd++95IEHHkBiYmIIIRBCoFKpsGjRogu2m3o8Huzes4cePHgQSpXaumBRxUBSSoor2EwKt9PFdHe1y1tbzqrbWprVHW0tmq6udk1vd6emv7dHaxkc0Hi9Hrler2MSEhKQk5WGuLhFxGg0wmQyIT4+HvHx8TCZTDCZTDAYDNBqtdDpdFCpVNP2XVJK4Xa7YbVaYbVaMTw8TIaGhjAwMIC+vj709fVhYGBAMjAwIOnr61P19fXF1Z06B4vFQhVKpTMuLsFmNqeMJCanWFOSs0Yys7NtuflFttzsQrtWZ/AyDEMjAtejtwTjKxF5CS6qFCjuHGExgkxYESE4ngk8Z6z2RaOz4Lnwq3MhhH4yKeDGyizEUaqm4PL0enYfpXTwW+I04wawF/wrSzEL+UXFmCfCaQKllDz9NMiNP4RCqYPO6YRxaKBL+vKz/3p650fvlb777ruK9PR05qGHHiKz6Tyj1+uRlpaGAYtVfqb+lK6guNQ2ttfE+H3T5/GQsw31mo/ffTN/xDJouPXWW5l77713TCehC31/SilOnjyJ1zduRHNLi2fZqqvPVy5dMcBKJHRoaEDa2nxG1Xq2UdPafEbbfq5J19F+Xt/T1am3Dg9qFHK5NDExEdmZaUisqiQpKSlISUlBWloaUlJSkJycDLPZHLIBc3h7L8b3p1QqoVAoYDabQ95T+Ds6Oore3l50dHSQ9vZ2tLW1obOzk3R1dak6OzuVnZ3nEk4cPwRCGJc5MdmalpZpSc/MtWRl5lpz8gpGiosXWhPMyW6JREJjk04s1adgwxPnCo1uH4xaZ5hKVIjTYCYVVBLeThrz6kz6l4a//1RyoIbndRDfRwhYlmHjPF5P5ldf7R3GtyPAfgTATgC7wG+M4MO8s8ylCEooBc6ehWw0CfoTIzDe9nMYCBDn42CWymBOSk6Oe+Jv/0HDMuz5rW+/oXvp5Ze1iUlJ5LZbb71gleBUQAhBYmIiFixYgK2ffKo+cWh/4rU339UlkbJBgxkwoXgCn9dHRm0jbPu5ZmVHW6tq31c7U87UnUgxGg2ShQsXwu12Y3R09KIk4KaUoqmpCS+99BL27t3LJadm9lRVr+oa7OuWvfHXrzNbmxp155rPGNvOtxj7+3r0UgkrT0pKwoLiApKamoqsrCxkZ2cjMzMTWVlZSExMDKSAi0V8M4WxCFer1UKj0SAnJydAkC6XCx0dHWhqaiJnz55FU1MT2traFO3t7fKzZ2oTDh3ay2k0OntqWuZgfn7xQH5BiSW/sGS4sKBsJMGc6JZIpBOYfCLjBIHI4PjgNVF8qUgqFCTA0Il+qpQ1OZXoxfw2YzsLTeMzOE7DMrTwyqwr63DpE6EUQAJ4/unHLGSSCcfs+/RfYqCUMnWAinPASFwwccSbQCSSJHBIBpAAymng366XAgReDu1t5xR/+N+/Ldu7c1vhguIi1a9//WusWbMGGo1mxts/PDyM1157Df+4YQPNyi1s/+2//efeooWLrMEX9P+N4STocjqZc2cbVSePHjKcOV1raG9t1vf1dGl7Otrihi0WVUJCPFm0aBGysrKQm5uLwsJCFBYWIj09fVoSklNK0dzcjBdffBEbN26E1Wqzly6uaotPSBjtaGvVn29tNtltVq3RYGDTMzKQmZFBcnJyUFBQgIKCAuTm5gacdGab9KYLYqnR4/Ggo6MD9fX1qK2tRUNDA1pbW3H+/Hna09NDFUq1PT09eyC/sLivqHjRUNnCCktBfrFNqzP4J9fQz0Lw3uRCJEL/NZHaE/7DQIQ+gGAOBrFNcDqjNmNjNr7RCyW/se6nFBwobWU51yvPvaLu3bDhknWaIeAzydwMfgP1YwC+BtCEWSTDS3sGmCFQSpm6PqgggYnIEe/zIpkwSOU4pAJcHCGQ8FMGR0I7MwNwgM/nI6eOHtI+97uny48d2Ju98oor5L/+9a9x+eWXQ6EYP0f0NL8L9u/fj9/85jeoa2i03fS9+049+au/r1VptHyMUoyuSDmKrrYWxe6dn5sP7Pkipf7k0ZTBvl6DXqdjhVyfdrsdLMvC6XRiYGAANpsN2dnZqK6uxpo1a7B06dILyjfKcRyam5vx0ksv4bXXXkN7ezuMpvgRAMTrcSviE+LZrMxMkp2djaKiIixcuBAlJSVITEwEy7IzsjXUXICYGIeGhtDQ0IDjx4/jxIkTaGhoQHNzM+3vH+C0Or21sHBBb2lZRV/xgvKh0rLFltTUTGcsKTHCwzOcCAPngGDO0PB4QCA6GU7Nqhfrrov9LYcsCKahnonUwRAyQH3cVnOG5CAhxHMBj51NEPAhE78FsAr8bvT/AuAjzKtG5x4opaQVkA8PIO6YBQmQI4WhXCbjY9LBQM9RjiVEnDufi4zT8udtZBmWli6uHPn+Ez+rtVmH5bv37EmLj4+XaLVaUlpaOqO7VRBCkJ+fj9tuuw0N//qv6t3btuYUFJcN3HD73Z2sTBbWEflh6nI6mdpjR3Rb33kj8+svtuXahgeNubl57Krl1SgpKUFOTg7MZjMsFgtkMhmsVitaWlrQ0NCAhoYGvPPOO9i1axduu+023HLLLSgtLZ30AsDj8eDUqVPYuHEjNm/ejM7OTshkMui0am1WVhby8/OxaNEiVFZWoqioCDqd7lsj8U0W4veOi4vDsmXLsHTpUlitVtTV1eHgwYPk+PHj7OnTp431dccMR48eyEpOThssXVjRVV5+ee/ChUss+YUlNqVSLbgOCzUDIKJg+OD5oOQIv2MMHWeCn2yc4PhEOTOyZigmSoKxkqZPZustjlINQ0hhf3//CfCpHS9VSMDHRA4A6ABwbnabMy8RRuBLSiWqEegVQDzrQwplkQOKbABGSjgWAf+3UMZjAjm0+G7N+bu4uJN7PB6y9a3XU17903+Ud7edS/z+ffexTz75JCkoKJjRsApKKerq6vC73/0OWz7+2JOendf54JO/OHHl1df3qrTakOwVrtFR5uC+3abNLz5feOzg3tyE+Dj5qlWryPXXX4/q6mqYTKaAmlEckM5xHCwWCw4cOIDPPvsMe/bsQWdnJ66++mo89thjWLp0KZRK5YTaOjAwgEOHDuGVV17Bjh07wHEccnJysGDBAlRUVKCqqgrFxcUB8vuuEd9kQCkNfKZHjx7Fnj17cPToUTQ2NtLu7h5Oo9VZS0sXd1YsWd69ZMmygcLCBTat3hCwSTEix5dwyok6oUflr+nz6Zytb3qyEuG0SJAUlBDS6YbnjbQ0eQsh5FLNNJMK4DIA5QBaALwPPqh+1jCfdBsAKCVnNmyQP/G3G8yKUU++lEEFAVNNCapAuAwQoua1QZTwtj/B083/wwGUEBBekQ/CUH8iY2GY8qEyLMsit7DY5vG4PS0Np3WHDx1UAJTJycmBwWCYsbAKQggMBgPMZjNaWlrYulOn1I31J7Uer8er0WrdBmO8l2EYeF1ucqxmv+HVPz2z4NjBb/KLi4rkjz76KHnqqadQUVEBrVYbIMHwH4ZhoFKpkJeXh6qqKiQkJKC3txd79+5FZ2cnsrOzYTabY6pJKaWw2Wyora3Fhx9+iD/84Q84ePAgcnNzceONN+LRRx/FI488glWrViE9PT2QxHueBMeG8Bmp1Wrk5ORg+fLlqKysRGpqKtFoNIzdNqKsqz2RcOzIgYSmptOawYE+liEMZ9AaPVK5nAp9moHfBBgSP09iEFMsT9RJtn2Mmi5mthgxhKTZwjPD2xELAvVf0AgnIJRSwlLW3j90vvXZZ5+9VJ1mbAAaAewGn2fUObvN+Y4TIaWUPLZhg/IBC1KpB0UcxVKGkBUcJUUMoUYQIuGHO0FwG1Fxt+f4zPqEA+H4bs7nfGZ4hwEq3AcI7uKsRIqC0kVWu93maznToDty+JBSIpGQnJwczORuFSzLwmw2IyszE729PaTu5EnViZoD5o62NtnI8CBjGxlhu9rOKd959b/zD+3dVVhSXCz7+c9/jnvuuScgBU4EwqRbWFiIjIwMtLW1Yf/+/RgZGUFxcXFEXZRSWCwW1NfXY8eOHXjhhRfw5ptvglKKlStX4qc//SkefPBBlJWVQa1Whzi9zGNyIIRAIpEgISEBlZWVqK6uRk5ODtRqNXE6HfIzZ06bjtQcMDc1NaiHLAMsyzKcXqf3yGQyKiwGGUJAENxdIjohhZ+Z3PclJsBo5DMTJCgmwGjtGg+TKTtOTRJCCCRyY8Pvf7/B8fTTT09LrTMEAiAP/Ga8UvAEOGtB9GJ8J4mQUkoe37BB1eJEmtuJUgArKbCcMsgEqMqfGJ9EDsFoHnVElKKF+HmTAzhGdJ8IHIFUIqUl5RXD1uFBrrmxQXvs6FGFVColWVlZ0Ol0M0aGUqkUaWlpKC4poW63xzc0OKA6ceRQfM2+vcln6k/pTx49HHfom925Rr1B8cADD+Dee+8NhENMFhKJBCkpKUhMTERtbS0OHjwIo9GIkpISqFQquN1udHZ24uTJk9i2bRtefPFFvPLKK+jv70dpaSkeeOAB/OQnP0FFRcW0buE0j6CUqNFoUFhYiOrqahQVFUGtVhOHY1TW2FhvOnpkf2Jzc6NqZMRKFHKFV683eqUSNqRzx57sp++7ImF/ZyI8YiqjUSDOsRcIkwchYDhQwlBfr0bH9lxi2zMZADwC4CkA6QCGALTNaov8+E4RoSABtg4jbdSHhcSLVZRiGSVIAoGMCZBfUInBq0I5/18KBhTU360p+H3XCCGhEqDgRs4/1f9X4FYOIBQyqYKWLKqwDA32o6mhXnf0yBG5VCKZcTJkWRZJiYmketkySVZWNliGIaCcoq+709DUUB/vcjqkJpMJhYWFIIRX76rVarDs5LuORCJBUlISCCE4cuQIGhoakJ+fj5GRERw4cADvvvsuXnjhBbz//vsYHh5GSUkJ7rrrLvz0pz/F1VdfPS25SecxNgghUCqVyM7OxvLly1FcXAyZTEas1mHZ6dN1cUdq9ie0t59T+Lxen0ar82r1Ru90S4Cx7ggnQeF4JkhQ2MpyMhKgcJ+4nqlByELGg2UZhnCUc/nYM//2bxvcwCUhFRIAJQDuBrAGQAr43ehrMPtJgL47RPjJGSonSiRZ7N6FDMusIRyWgcAMgkCajWBXC3Z5IQw41G8OISrSQIgwAfhkziF5IRB1WFBArpBzxQsXWwYH+tDc0KA9cqRGzjIMyczMnFEyFCa/wsJCsnbtWrJ48WJkZmbCYDAQnU4Hu92OXbt2Yffu3ejr6wvY/wTV5GQglUqRnJyMuro6HD16FB0dHdi2bRtefvllnDx5EiqVCosXL8Y999yDn/zkJ7jhhhuQlJQEiUQyLwXOIAghkMvlyMrKwrJly1BYWAiJhCVDQ4PyU6eOxR09djh+cKCXZQjr1RlMHpVSNa2SSTRbYGzdzPQjXBU6UfueP344pM0X3lbBxOKfkygnASUSQplz//p7DD399NOzTiQTAAFPfjkAFACOA9iCeYlwZvAlpZJf/I8N8ToVij3AasLgCgKSCAIJRARIAms+vk/xkp/gDEN4gqMMKKUglOGdYSgQTAZP+XKBTkuD50LiKhj/IQcwgFKp5krLK4esFgttPtOgPXzokJxSjqSnp0Ov109J8poqhMkvLS0NVVVV5Prrr8eqVauQkZEBhUKBwcFBfPPNN9i9ezccDgcMBgNMJtOE4gKFXJrNzc04deoUBgcHUVtbi8bGRni9XuTn5+Paa6/FI488gieeeAKrVq1CfHz8PAHOMgghUCgUyMnJQXV1NbKzs+F2u5nOznbV4cP7E2prj+ldTien1Wo9JlOcZ+yF0dS+R7ENciYkQPGydbLPvHjtC10aEF5z47E5mJbf//7pWKEUBPwuDyb/D4tg2IUSvJ1OeM2ZQDf4rZbqwO80cRz8XoSzjm8tEW6glPnzhg0alQ25nNe3khCsJaDpFIyUBHqVmPyEtRwP6g99oOB4xTylCLoFiEBJ8CdQJ4L1EYKoJIjg45QqNbegsmrQPmJF69lG3YED+2UOh4OkpaXBaDROyy7uk4FgM5JIJDCZTCgvL8eaNWtQVFQEhmHQ3t6O3bt3o6mpCWazGUlJSZBKpTEJy+v1oqOjA9988w1eeOEF/PGPf0Rvby9SU1NRUVGB9evX42c/+xluv/12FBcXzzvBzEFQSkEIQVJSEvLz8+Hz+dDe3s6eP9+qO3nyiLmj87xMJpW5dTqjR63WTNmtfyy150z0hnApcLLPnZ42CtJfNIUsf45QIqGUSmWEOfO7328YEUmFDACZv6AUQBGA28AHsUsBtPvLLQFQCSAePBk5cXEJUQdeEhwGcBZ8Jpk5QYLAt5QIPzlD5dUEKdSDJT7KXcsQUgQCOcAQEqJvF9aZfHwU9f/PILjnNj8YiSD++W/hwAUoMVR/H6pEET2HC/ciFYOBUqHkFixeMuhxO2hbS7PmwL5vZBaLhUlOTkZcXNysbd8kkKJCoUBubi6WL1+OtLQ0dHd3o6amBqdOnUJmZibS0tIi2shxXGCbpFdffRX/8R//gbq6OmRmZuKmm27Cz3/+czz66KNYunQp4uLi5qW/OQJKKRwOB/r7+9HZ2YnW1lacPn0ahw8fxp49e3Do0CH09PTA6/XCarWSwcEBWUvLGdOJk0dNLpfTZ9CbXAaTycMyk59eopHfTIVGIOxZk5XupmbICJ8/gMj5SdwqP1fxW1AwnM/jGDnb1/bvL/w7wKseSwEUgN8KjgGwAsDfA1gOPq/nQX9lPwa/F+BVAE6BD2r3gZcgg6qx6YEKwFoA1eCD6R2YY5sMf6tmHUopUwNomWHkS1ksoxxXCMIEVKCRiJHznePABCJg/ecCxTjR/4yI18JyRHAAGP9FLnyICGWDG9EIxw67g3331Rdy3t/0alHH+eb4tWvWSH/wgx+guroaer1+ThCFy+XCqVOn8Mwzz+CLL75AWVkZ/umf/gmLFy+GVCoFpRQulwvNzc3YuXMnXnvtNbS0tCAlJQWrVq3C+vXrsWjRonnvzzkCSimcTicsFgsGBzn7xSQAACAASURBVAcxMDCA8+fPo76+HvX19Th79iw6OzvhdDqhVCrBb0Qsh1QqBcMwYBhGSKtHCWFGq6pWttx732ONSyqXWnQ6Q4xYt+AiVHwGYWcvau/gAIaJXJpO1Ut0yo0IqWEs9xoudOlO4OMoPecjntcrKrI8vb29jwK4D3yc3g8BNAAoA/An8BLZGwD+Czzh/T8AN4JXVz4IXlUZD2AheLtdM6YntIEAWAzgfwJYB141+m8AtuLiSqCTwrcmxVotpbKaISRJJSgHg6UcByMhQjcPdqrQ/6J3toCZgxGrMpkgCQaKimsTZw30j7DAY4T7hcvBXdzESy8CBkq10nfXw080aXTG0bdefb5kx84vUnp7e+U/+MEPsG7dOpjN5ln3nJTL5Vi4cCF+9atfwWaz4fDhw9i4cSMyMjIQHx+P3t5e1NTU4PXXX8eXX34JrVaLq666CuvXr8fKlStn1BFoHtHh8/lgs9kwMDCAgYEBNDc34/jx4zhy5Ahqa2thtVqhVCqh0Wig0WhQVFSEhIQEpKWlITExEWazGUajESqVCjKZDL29vdi1axfZu3evav/+rwrb21sMd9/9UN3atdf3ZKTlOvhNgiN3mhCfnQkbYAhEa9wL8fS5sJ4cbd8K8b6gQYIkojKE905nqcebwBCmNC+v9Exv7xeZ4LO2DIP30DwLPnPLJvAf7xHwkhgD3ltT7i/T5T++A8AT4EnxPwCcxPSkcksFb6Ok/vrmlDQIfAskQkopqeuD2i1FHiNBNeFQDAIpQt5NLIGF0iDnvy4kQ+N5j3dkYfxXELiLCxsx4k4cbgcUXw6XFsMlwsgWud1uZu8Xn8dt+stzxXXHDmeYE+KV999/P7nzrruQlZk5LTs5XCgcDge++OIL/PKXvwTLsnjmmWdgMBiwdetWbN68GVarFQUFBbjzzjtx2223BRJuz0uBswOfzwer1Yr+/n50d3fj1KlT2L9/Pw4fPozu7m4+d6tOB71ej+TkZBQUFKCkpAQFBQXIzMwMOEaJM/gIfymlsFqt2LVrF55//nnU1NRwLCuzXnPNTY133/1IU0nJIptUKomZbO2ieYSOkcwz+jJ4csQ2vcu5aE8XzxHBLYx9Pg9pazunaGysVeblFR/vHuzatH79DelOp/M34NOVvQLgS/BqSImoMmF2koC3JcrAS5AJ4CXHq8CrUDcAeA88qV4ICPiYwesAXAN+A94X/c+YM7ikbYSUUrZxBCZOhkoK7hpQkkMIJ+WNedF8vsQOLSS4PuUIKOFAQcBwAGUIGI4ChBHC/vyim2D/i+YdyiCwAzj1P4P4vUYpASjn9zwVVsIk0AJxIIbww7IMTc/MduQWFg8NW4Zo05lG9cEDByT9fX0kPj4eBoOByOXyWSUViUQCpVKJs2fPor6+HgMDA9iyZQs+/fRTaLVa3HTTTfjVr36Fa665BnFxcYEdIOYxc+A4DlarFR0dHaitrcW2bdvw0ksv4bnnnsNnn32Grq4uqNVqFBcXY+3atVi/fj0ef/xxPPTQQ7j66qtRXl4OwYNZJpOBZVmwLBtQiYp/BO/SRYsWwe12k5aWZvmJE0fizp49rYyLi7ebzUkumUxOw0fkRXWIEVUodoeLRWDjPX8idURHNFtg5NNDPwuBGINOegQcKCg6OtoUL778XN5fX/lT+dDQIJudntOtNykPHz58+BCANwHUgt8FniJIgOKFCAdeOnP5z2sBZIBXoX4CYDOAXgBqUR2TBev/GQHvIfoFeKl0YAp1XVRcskR4mFLpsBOpXi9WUmAlCI2jhDIk0D3DFS5AsC8EpTwCnq8o5Z1ZCMN7ilIKEMFBJtB9Qok0uJ5lRCES/rgKyoica0JoN9Au4nfREUcthoRwsCzizEnuBeVLBr1er7u97Zzy8KGD8vq6ekahVHLx8fFEpVSSmQyxEEOQDCwWC3bs2IH6+npYrVYsXrwYP/7xj/Hwww8jOzsbs03Y30U4HA709PSgoaEBO3bswMsvv4znnnsOO3bswMDAAIxGIyorK3Hrrbfi8ccfx6OPPop169ahrKwMZrMZCoUCEokkQHoT+f4ET2Oz2YzFixfDZDKR1tZWaX19rf7UqWN6hUI1mpiY7FSrVT4Stvy7mIiWH3Sq2V6mRoKYwJM4/xwh/lwET3XOH8zFzxacz0eOnzisf/HVPy88d74lvqun05ibnTt67ZrbjzjcKWfr6r4aAW8HnCgoADt4+10jePtdJ4BE8MHvDADLJOsEeEmwBDy5jvrrGMUcsg0KuCSJsIVSBWzI83FYQxgsAaACqKCs8ZcSS29iAqT+jKHU3/U4EMp3McL46YjzB09QEuMrI6IFnpi8GH/coJ8MOb8EyJCAJBhaS7BNsYYJwzDQ6vXe0vIlFmN8wvBAb6/kdH2tcv++/cRiscBkNEKj1UIul5PZIBtKKfr6+rB161YwDIN77rkHv/71r1FdXT1vC5wFDA8Po7W1FXv37sUbb7yBZ599Fh9//DG6urqg1+tRVVWF733ve3jqqadw//33Y/ny5cjIyIBGo4FUKp0WqZ1hGGi1WhQVFaGgoACdnZ1sY2O95ujRQ3Ec53UnJ6Y49Hqjh4SN2IuFaCEZEw2QFyDMJFMJqeARTSIMjV2ObJFAjDTgUEfAm4Psdjvb0d0hs9vtErM5yX7zjXd1lpaWWW9bve7c//3Pp6fi5ELBS5DnwKtW4wE8BuCX4AmtHrwkN1ESUwD4HoC/A+8tOgjeCcc9hbZddFxSy3TBHkjVKKY+rOQol0MII5msZp9B0EzHiO2HHBOwGYZvoRRq+PPnEmVEzxV7iQIih5hgZprodpBwb7FYLQZczlGmse6k5t3XXsrZv3tH9ohlSF9WVorvf//75Kq1V7HJyclEqVTM6HfqdDqxc+dOPPHEE8jIyMCLL76I3NzcGU0EMA8elFLs3r0bzz77LA4cOABCCPR6PQoKClBdXY2VK1ciLy8ParU6QHoXuz1utxt1dXX4r//6L3z66afU6+VGrr32tvrvf/+HTUWFxXaWjbQbXijC3NYiLPmTXZrF8vmeGMZqQfix4EEeiuB8wZenHAeO+kj/wIC0obFW43a7mMurlg+oVZp2yuGt5CzZWULIhexMwQK4AsA/g481bAdPiJ9jYrF/BLyDzP8EcD948vtPAH8Er26dc7hkZitKKTkLaB0eVBKCtZQigxIimfCaUrQg41dVAAgHwvHpzjjKS4cMoobNI7geFKtCxVIfDT6H8teIf/1JQ9ahQmcPV9KMBV6qlbASGp+Q5C5fsnRAqzeMDPT1Ss40Nij37t3LtLS2UrVKFZAOZ4qIHA4HampqsGvXLpSUlOCWW26BTqebkWfPIxJC4gKVSoXrr78eTz31FB555BGsWLEC6enpARKcCUldvLtFaWkpGIYh9fV1slOnjhm7u9olaemZ1oS4RDczzX1V7IATzZgxUQijNNy4MrlPLlaMoHAcNN1FkiDf6iAJAna7ja07fVLb3HxG5fW5mcyMbEdBXpFdrVJThhApAWF8I+y5f3lmg/MCd6YYBJAG/nW3gCfByUiEcgBG/08zeMebk5O4f0ZxSRDhBkoZeTuMoKhiJVhFOS6JEsIC43VsMfv5jzkOhPJqUMJRcAyfMYNQwT1Z3DlJaB0hQ4wTnRIcZfyOMRG+cP5sEIErsVWhfB5SGvZiNNB9GIaBUq3l8guLR4oXlveDcq6uzg75yRPHFV9/vYf09w9wGo2ayOVyyGSyi06Iw8PD2Lp1K2pra3HFFVdg5cqVE9pwdx7TD2FH+ry8PKxfvx7XXXcd8vLyoNPpIJPJLlq2Ho7j4HK5YLfbMTw8jMHBQfT396O/vx+9vb3o7++H2+2G2WwGAFJbe0ra0npWf+5csyI5Kc2aYE50SyTSaZkgQ1JZhC1+JwuxcUXAhX16YlWomKqDqk+IjDbBVgTLtZw7q3r2j/+24NXXXig7fvKI0aA3jObnFdklEhkFpRJCiMpDfP2aXrbv6T8+fSEb93rAZ3/5DMBO8JKcDOOv3Fl/OQd4h51jAPb5/9ovoD0XFXM+jnADpczdgNGlxjJWgmqO8vGBBJyfimIFooaqHQKKzpD4Psav3QzoSSNjBYW6xEHxTHgYBV+GcAxolNifICVOMGKJ+MvF7G4c5CoVV1xWMZKZmV+/eOmq3k/f35Rdf7wm9dVXX9Xs2L7dd9311+P666+T5OXmwWQykotBTpRSDA0NoaamBizLYuHChVAoFNP+nHlMHCqVCkuWLAk4uUw3BHWn3W6H3W7H6OgohoeH0dPTg/b2dnR2dqKzsxODg4OBMk6nExzHBXYtSUxMJGfPnlUc2L8n2zE6KvnR4788WV195aBSNfXE3cLIClGJTvL1xaNzcrGFwnzAjCMuhittOT8B8jdRkR0wFlwuFzM42K/sH+zT+qiP6e3tVXh9Pv8aniGUcnqGw+XtCkc7pbSLBJMhTxYcgPPgpy4t+GTZeeDJrR3RPx4C3vM0CzxxtoAnQGDyjjYzijlNhAIJekewTCLBco7jjES0KAvtc5GBqQw4PwWGxvDx5j1/p/UHuHPg+HOBusTDSlQ9x4SRpdB5gzE+VHQ+mu9qaEcPH3KxMk1EgpWwVGsyeK+85oa+svLK4f27v2zftuXt7KbTtUkvvfSiauvWj32rVq4k1157LbtgQSk1mYxEq9VOS+5SYQPdgwcP4vTp00hLS0N5efk8Ec4yCCHTno7P6/XCbrfDarXCYrGgra0tkHWmoaEBHR0dcLlckEgkAU9TwelGLIVaLBZ4vV44nU4oFApit9vlR48dzPz9M0/Ln3I5j65csWYgdiaasRGusoxmH4wG8SgLje6dpNfBmIXFNQbnGBI4H7QPRq59Qxf2WrXWm5dbMAQCxJviHfm5BSMSlqUiDZWUAhlSTlYxeBa7KKUjfDa2KUH4SK4Gn32mFMD/AR9aYY1SXgd+m6X14J1rngOwH3PUQUaMOessQyklp0dgcgPVLFDN8bpmf3vDuywP/gwT6gATXiIkG0yksVpcU0AKFGeGCSnrLyfK08S7Oos7uajcuC+NUNe0ScI9Osr0dnUoDuzdHbfzkw8zmxpqE90up1qlVEpLSxeQtWvXMpdddhlSU1OpRqMhGo1m0qENQvq0np4e7Nu3D3/4wx/Q1dWFhx9+GH/zN38Dk8k0tcbPY85A+I6tVitGRkbQ2dmJU6dOoaamBsePH0dXVxdYloVEIoFMJoNKpUJiYiJSU1ORmpqKlJQUmEwmaDQaqFSqQCo9u92OwcHBAJEeO3YM58+fh8Uy7E1Nzeh74vH/ceT662/t1mj1k5IeLkTuDR+Z49Y1YSNh5HgXbIA05BxfNnooRyQtez0uYhm2SNxuN8NKGKrT6L0BSVpoG+8K3y2Vyt7rGkDDggXkQoiIBfAbAD8Cnx3mr+DTszVHvB5QAd5LdB14onzGX37wAp4/I5iTREgpJa0W6G0MlhOCK0JJUIzIzibQIH/MBfutoCvhwu+L1qujrAnFKtQASUbv7DRCvTE5RUsIAqOG4e2cNPBfzJWrc3SU6e/rkZ04csjw1bat6adPHk2yWoa0AOQ6rYZdsKCEXnbZZcyiRYtIVlYWVavVVC6XE5lMRgRvQkGtRimF1+uFx+MJTI5nzpzBZ599hu3bt8PtdmP16tX4zW9+g7y8vHlv0UsUYvIbGhrC2bNnceDAARw8eBDNzc3weDyQSqWQyWRISEhAYWEhiouLUVJSguzsbOh0unElQkopfD4fvF4v3G43enp68Nlnn2HTpk2orz/tS01J7/373/5u3xUrrh6QSKPbDCdNXOMg3J9z6nWOdXeQPcWOL4LmiF/7jq0SFb+51+MhPX09sv7+XpnH7WIWlCwaUapUITMSAVyUok6jlH6oikfPBahIBYnwx+BJ8RPwji8dUcoaANwD3lP0HHgv0YOY42pRYI4SYS2lGtcwlspYrKQcEigJZ6QgQuW5oBKU46KXi44xHKQD/dt/wEUbOuJ6+HuJuI6Y5cdAiHQYKbVORIXjdDqZEcuQpL21RXVg766Ew/v2JLefa45zOexKhhApwzISjUaDrMwsb05uDpOWliZJiI8nWt7zFACflstisaCvrw8tLS04ffo0zp07B47jEBcXh3Xr1uHBBx9Ebm7urO2QMY+pw+12w2q1YnBwEI2Njdi3bx/27duHc+fOgVIKqVSK+Ph4lJaWoqKiAgsXLkR6ejqUSiVkMhlkMtmUvVCFlG/ffPMN/vmf/xn19acdq1Zee/of/+H/Hk8wJ8WUYqLZ8mJ5Cox1/xijfpKI9tToJg4SUWYii+TQMq2tZ5X//eJzeYdqvknhOEr+4bf/fLD68pVDEqmUBkpSUIaQER/n2y3zyncbc2C9ABWpHnwKNid4SW8UgKDClgAwg3euGQYfP7jEX+6U/545jzlHhFs6qSpDg0pCsZoCyYSE6CSjgvH/5gQtJRdplmYihk7o3QEpLyg+ImgEF1ckthEG6xJ/kFTU2UnUYRqGsaJ0J9F1Yw1in9dH7NYRdmRkWNLZdk557PA+U93xo/HnW86ahgb7NZTzSQghLCGE5Tgfy3EcSwDCSiSQinJLMgwDlmVhMpmwfPlyrFu3DosWLZqVPRPnMXX4fD7Y7XZYLBY0NTVhz5492LVrV2CBI5VKkZaWhssuuwzV1dUoKiqCyWSCQqGAXC6f1nyxlFIMDw/j/fffx9/93d9xOp2x5/8989KuBaXlIywroeHjWMCFqkMvDqKNb/EcIahGBSeZiSyMI8sdO3ZI93f/8POltfUnU3Q6w+jD9z927NGHnmrWG0xe4Y7gg2gvKNli80lPZWeTqZISQTA3qRw8CQqJs4vA73TRD+Bt8J6mglv9dCTsnhHMqdnrrVoqy9CjiPiwjAJJhETsX+RH6KqK11oKWycxolL8EIpOgqEONEGDtyD5icoHyC/UUYaEOcPw58TS4Fgk6L8ejQQnSH7jSoX+i6yEpTqTwWswGLwpqWmu4tKFI6M2W/vIyLCkt6db3nLmtLa1+Yyu5WyjsamhzjzU32PQaLUkOzUVycnJMJlMiI+PR0ZGBvLz85Gfnw+TyQStVguZTDafPu0SgLDVktVqRWdnJw4ePIidO3eitrYWDocDEokEGRkZqKqqwhVXXIHi4mIYjcbAtksXK+5QCPpfsmQJ8vLymObmVtWJk0f0+fklNqVKQmMsWSdFilNzgBkPohojKg+dn4IRyJx/fojm1jPec4IwJya7Lqtc2jkw2K8uLlrQU7Xkin61Wu2jHAci/p4IGAISR8GtVLGuIfolPUdWTznQPgFAFYBC8GrRneClvQcA3ImgJ9BfENz895LBnCFCSil7fARZ4LAUBBkEHBtLtRhqBURQUgtcD5aF6Ezocdj18E7MIFS0jGhLpDRIA/VGU76IOjxlgvGHgXMYVz4PV6rEUuWMpaBhGZbqDAavTmfwJiHNlZNXNFpSVj7SWF9nfeeNlxTHDu9XJ5iTmTvuvBM/+uEj0Ov1AbuPoAoTYtLmMfchSH+Dg4M4fvw4du7ciW+++QaDg4MghMBsNuOqq67CmjVrUFJSApPJBLVaPaP5YQUyzMvLQ9PZZsn58y0at9vJiMMpxH19Ij3vAqzyoYjJoKJ5xH8ohEjRcC0RJxruEaM2fJ4a63/+30Rzsvv++x5rWVhWMbh4UaUlPiHR3dXdLXc6HEx6RoZToVAFxAEKTkoIk8FSrLAvgJ1S2jtFe2EZgF8AKAawG7za8zT4/QxHwG++O4pLSAoUY04QIaWUHB1FIkuxFJQrBL+NEmKRGSf+xYguxRIgo3YuJtgnGVFv57goZTg+Hh+hIRI0YOgOplILfV6M/kYAUC7KuRjNF9U2kUkgXHMrhD0G7g15NIfuznb5x+9tytyz89MCnT5B9r3v3Ytf/OyHSE1Jnie8SxQulyvg8fn111/js88+Q2NjI1wuF5RKJaqqqnDVVVfhsssuQ0pKCjQaDRQKxaxJ9yzLQq/XA4QQh8Mh5Xw+Er5kjbXEHA9TJ0S/NihmjSGTT8hCWOwUE06UY7dqHApnABYszc7OH01LyXBIpCw9duKo7tXX/5LX39ejeuTBH9WvvGLtoEKhCDycUihA6AKH0zXoPS/fQym1TMFeaPO/gh5ANoA48E4wm8DvUGEH8CHm2PZKE8WcIMKGfmhYua+SIWwpCCMP5qcOndGZwHGY0jFmv4nSiTlR5w6x+wnFRUON8QfJB0iQE3Vm/qHiYPmQzi8gXNKjUcpMoOXRFKtj3RdcLCBC6yvA4/GQM/WnNG+89Fze51s/WqBUxynvuPtB8sufP4KUJDMYZl7leSmBUgqHw4Hh4WHU1dVh+/bt+Oqrr9Db2wtKKTIyMnDllVdi9erVyM3NhcFggEqlmhOevoLXKiGAXC7zMSxLA+tUTE4ijKUlmTwhjjfKePBr2KlQc7RWRVtQR4JlWSpVqWjz+WblqxtfyPt8xyeFPq+PUSnVnuLi0mPpqZlOjuP4LbIICEepljBslZvzWvr6JEcopfZJkmErgK/AB8sXALgS/E4VneB3vefAk+Wc9xCNhlknwlpKZd4RLKSEXQwOWj65WHT1gPCb4YKWP4YTZY0RlQoeh3VQRkQVgsNxIIE2IvqmoNcXE56QPSa6FBiGaJm2xelmREbG8GExUfITCgs8HhHZEaVpPo+HNNaf0rzx0p/zt3/ycYlMaVbddOdj+MVP7kdKchyYebvfJQOO4zA6OoqhoSEcOHAAW7ZsQU1NDWw2G2QyGSorK3HdddehqqoKycnJ0Gq1kEqlc8q263a70dfXB0rBGY0mF2HYKdnzxAvBaMaMqSEacfHH4iEc/DSZqKb/0LrGes7YEFrBgYNCKudMxninVCr1qVQqd2VlVa9GrfUOWQYlbedblUZjnCcuLsGtUqk4gJpYkFWcY9Te3q6qA6gTiEmGBLxzjAp8urQ+AN+AjxFMAnAr+E12e3AJxAmOh1klQkopc6If2YwMlSxFojhMIlT6E1GdSPwL2grFShMxYqk1BIlQpP6MqIInSN4hRhzjI3h8iZ8RrQNHIefISNqYmDAJCvwdHB2hH2IsEmysV7/58gt5Oz75qISVxSvX3vgDPPnD+5GeaponwUsEPp8PNpsNvb292L17Nz766CM0NDTA4XAgLi4Ot9xyC9atW4fi4mLExcVBrVbPSVU3pRQ2mw0tLS1gGMablZFrU8hkQfM/xpbNoq35pqJCjQ3R4Ao55iFOxy9ohWKnVLww62XwvXgnwQSz2b3+7gdbDQaj22YbkV537a1dBMD7W95K2fjGSwsy03OGHrj/0call11hkcmkGB4eSqMU13qcQ94vv/Q0rF4Nl79aif+veKPeJQBWgrcJHgZQ5/9JB3ACvNPMJSkBhmNWifAkoIcMiwEuhxK+LUyA/IJEF0h9xggKUg5MzG4+jlJRLC4xYcMlpCh/TQh6DXV5jqa0iWGHjNbpoy4Xha499tuMiQlIghxH0XSmQf3mS3/O2/7JByWQxisvX/MYue+++1GSFwd27s2T8wiD1+uFzWbDuXPnsGPHDnzyySc4f/48XC4XsrKycN1112HNmjXIzMyEwWCY8xsju91utLe3o6uzi9No9Y68/CKbTCbnJkNk4bKa+O/UEc0WGImJSX+RBDoVQgy9g4GUZWhBXtGoOT6p1evzEFNcnOdcS7Pyk20fZZ85e9rc09utXbFidWfFoiXWvr4e2dvvvpHOskxGVla2pqCg+M3nn3/+7OOPP54MPkeoHrzUNwBgIfgsMQvB70LhBLAaQC74YPnN4NOozRPhhaC2lsoYJxZ6GJSAMopQE3LYjC54e3BMgLtCB0mIxVC4CRGXBRUoF3YtDOHaTEEijIz/GYfsxM5Z0ZxhRFliIKLBYOti1B3tFbmIU5G3cRTnW5pU77zxcvbnWz8o5hiTqmzZo+TGW+/Hiso4yObj4ec0PB4PbDYbmpubsXXrVmzbtg1dXV3w+XwoLS3FjTfeiOrqaqSnpwcyvVwKGB4exqFDh+DjfN6szNwho97kGUtyDV9mXjjxRRlQY9YYVIuKfQNiE+LUW8Y/KVriyKCWjGVZGhcX5wF4NfmI3SrxebyMSqV2a7U6Z2Fe0YhEwnI1R/YbN7/32gKbbURevWyl8SdZ+bYsc8k2lUp1y+jo6E3gYwSfBLAXvO1PCj5AvhLA1+B3q18MPpn2CHjp8VuBWRkpGzZQxp2GTIkbiygQzxDOv2uKWB4EOC6UEiC6FmoXjNKBeQNipH6EC2eP6J0/SH7hpr1w1Wi0VR0XSXxTWpBHXzGKUpuG65LHXGR2dbQp3nvz5cxPPti8wEu1mtyK+8mqa+7HVcvioVNNpX3zmAl4PB6MjIzgzJkz2Lp1K7Zv346uri4wDIOqqircfPPNqKioQHJyMjQazZxwfpkoKKXo7+/Hnj17QAjrqqi4vEel0Y0b6xZOgrGobGKIpkUKPiE4lEMHl/gcv1FSLLXnxCW/6MpUsaEIIXNk0Ijkp0sGKMgpsv/2b//XkWMnjhhGHXZJXk6u3ev2Ma1trWqbbUQ2OmqXEw5ypVKVYzYnXpednZdfX1+bwnE+CXjpTw6gC7xzzAnw2yh1gU+ebQcwhG8RCQKzRIR3/SNUGMYiyiCLACwXvsURAlQIgBlDrR4+FETHYs/QkINIKU4IjBfyhPLnEDgXbg+IrvIQgTKh0qBwLqDYjX7neIM4Qrki5vlxxlp/b6/sw7dez/jonU2lTo9Mm7noHnLZ6oexvCIeWUn+7RTnMacgEGB9fT22bNmCL7/8Ej09PWBZFitXrsTtt9+OsrIyJCYmQqVSzUn733hwOByora1FXV0dp9PpbVcsu7JXrVLG7M3Rxs/0qULFTxEQNI+EtyJSyRNrZE8c0XRMsVXE4eIBD7VW66tcXDVcVLDA5nQ7GKMhzut2OUl2epZtefWq1sGBfmVR8YIhnVbHKpSKtOqqo4Wc9wAAIABJREFUFbqRYWtrT19Xp9frHfL5fBS8KvRP/odY/X//ETxResAn3Z6Tm+xOBTNOhG+9RVluGEUci0JCwcshomTW0eS9EHBiQkPYcZhpPaJXxVqtiZ1igmES46dBEg/B8IcxUZNkj20hGFusCyTAibb8HaOZVotFsvX9zakfbH5lgXXEq09bcCcpWfoDlBYmoaqIQHZpaNC+M/B6vQEC/OCDD/Dll1+it7cXUqkUa9euxS233IKysjIkJSXNauzfhYJSip6eHnzyySfweLzusgUV3ekZOQ6WlYyxE2cowslwYohQE8WoIXL8hybNFqtIx8LkiTF0JhGUo+FtDYaUcSFzEQCGgVar9amh9QEcFAolXb3q6v6yhRXDLpeTMeiN3jiTycOyEvLkYz/pvf3mu1rPNJ7+srnp9JGOoQ7n22+/TcEHy4ubdAz8LvME8xLhhWHROhhdPpQRjksGAQmX1HjpJmymj9qHoqhGA7eJ7IAhJCimIyZkRSeOZhDigkgEuUV7vr+MYBMM2AaDhMz4nxl7NTsBvaboNQIpUcWvFqOs2znK7PxsS+J7m18u7huwmlIKb2UKlj6FnKw0LC0hMGrHf+Q8ZgY+nw8jIyNobGzEBx98gJ07d6KrqwtyuRzr1q3DzTffjAULFiAxMfGSJkABbrcb9fX12LVrF1UqVPZ11958XqfTT0gtOtb/4yO2LClsoxYOEjbIBLVo9G8gfEBOjgT5lgm/wykw1EoolBLOB62JITMqwAAGg8FrMJi84e3JyMh0Z2Zmo2rJshIf5XolHsfoW2+9FZ6kOx787hOCenRqIu8cxYwSIaWUrXeiBJTLEbLHBNR6IVzAgGM4MFw4EUVTbwoGs3BxSfQ9iaoIJT+xm3NowHz4ppkRlYVkhhHZBAnjv+Y/F0N9EXol2tWwVxXfMxY/i+DxecjXe76Ke+/NV4rOt7YlxWddxeZX/QiJSdkoymJQkoXoiTPmMaMQ0qA1NTXhww8/xOeff46Ojg5IJBJcd911uOWWWwIEONc9QCcKSim6urrw4YcfwmodcS+pWNZVXl5lUSiCatFopoMLm33HV6QGCY4R/S8Gfz6cGKcfoVomJsq5cC9zcZhZKGmKP7nokwelnIRSJEsY5hqfVGXoabLtp5T2+9OxMQAeBnAN+DRqfwGfa9Q2nW88m5g5IqSU1IzCrORQTMCYqD/DC897kWI/I/ziwghHrPpElOuxtJ+Bji10ZP6Y+qU1cbB87GlGIEH/X7F7aUg2HKGcsKYLuTtWA6M+DQxCPUJDhdqY7+ujPnLiyCH9u2+8mH/qxLF0fVKVJL/qCejNJUgzs6gqAlSymC86jxmAEAh/7tw5vP/++9i2bRvOnz8PQghWr16N22+/HQsXLkRSUtK3hgAFOJ1OHDt2DNu2fU5VKrXtxhvuaI2PTwjJUxmxPkYs+hoLYYvmiJrDwZcNJsieOUTTC4VqjBClhLgsh8j8W+Kaxl7cEwKGcjSeIeQKiUJp7G517qKHaQdZQgh4b9Fl/pvfxrckbELAjBHhW2+DUV6DEo5BJiGQEOJf1YRsfST6G3PBJerEISlUxlIvMlEM2+Ld5IN1R+34gqQXOPaTYXi+UP91cYxj0OoZ2spYEMf4B86JXy18XYBo/1O0tZxVfrD5texD+3bnqozFsrzLHkdcWhUMWhlKsoCceQeZWYOQTqyzsxMfffQRtmzZgqamJvh8PqxYsQJ33HEHysvLkZKS8q1QgYaDUoq2tjZs3rwZNpvNecUVa9qWLVs1IJYGgajGjykglu1PQDSiFF8Lz5J44ZJg7PUrL9MF54rQ9giyYcClQkR8QXVpLEmAQfQnh50jIIQQHQeuXMYSkyXZ89WTT/6q689//vdujuM6wKtH+zBvI5wCKCU5/TBzLPLBwQAhiyADMII9L6aOLhrRCZJftA4dPB9pA+QibIIT6tjiNPLCzVHuC20NF2UIjqPcCV8LMBD7EY1fhf/a0NCg9KN3N2d8tf3TAsiSFNmLvo/EnLWQSpVISwAq8jEfMzgLoJTC4/Ggv78fn3/+Od59913U1dXB6XRi2bJluOOOO1BZWYm0tDQolcpvHQEKsFqt2LVrF3bt2sUZjfHDd9/5YFNiQpI7vGtHSkZTQGBaiBxEvGNctDkkaBqZmFvk5JW2IXdw/nkwoiWhJB2YHpig4lNsRQyhcg4Q78gT2EknApHtppQjAFQUyOM4qv/NT359dHS47/X3try3yWq1asE7zFxs3fCMYkaIkALkuARFHEU6oWADcXhjSTdjQqwfBIKBdUEmEdv6QvcMjKIfR6wg2CjKmdA9l0Rlg2XGWmOOiWi2QPHfsY79cLvdzOdb3k/+bMs7BXYntFnlt5H0kjsgleugUwNFGUC6eV4anElQSuHz+WCxWLB792689dZbOHr0KIaHh1FWVoa7774b1dXVyMjIgFqt/tYSIMDbQxsaGvDqq6/C4/E5Vq24qqW8/LJhViqN0K/EWuZOCkz4P2K7gtg5JvxacDEdbIG4jqkj4m5G3CJBshO3KfpsItBhQFIU1xz+YU3hwyMEElCaJGElK/7X3z9z9l82/HH325++VL9nzx7722+/PfkK5zBmhAgPjsCoJMgnFAYS0qFEatHAdxhbUx4Eh5Co8hgIhkGIvUBDEXvK4UQupFxowSjLxGi2wMjuO7Y0GNgEYyLjLEoZjvqwd9fncR+9tzG/q6M7PqngZia7/H7I1QkgAFLjgfJ8QHrpxFtf8uA4DiMjI6ipqcGmTZuwf/9+9Pb2IisrCz/84Q+xZs0a5OTkQKvVXpJxgJMBpRSdnZ14++23UVtb583KzOu/647vtxp0Bu9YpDc1EhQ0TeIaoptNhPKhpDeReUg4NzFiDH+n8RE+iwiyX3iCyWjap6m1MRxOl4N95fUXy2RSae7ihRWZN191z567rvvxobfuwiD5HvnW2AkvOhFSSskJK/IoQQoIJJQGv7KgGD+eMZgLlgnkWBN1Ei589SZkfw9Xq06kwf46CfweoMJ5jMGakVlCJysRCuN1wi2N0rfPNNRqPn7/zez6UyfTDCnVkpyKR6Ax5gCEQKsC8tKA9Ph5aXAmIOwI39jYiDfffBPbt29He3s74uLi8Pjjj+O6665DQUEBjEbjt54ABdhsNuzZswdvv/02VSiUI7feendjfl7RKMOETuyTE2ZijTJGdDqadmc81Wc4AXITOBcb479TuOo2tBQT5f9QhWk0RFMpTRwcR3Hs+BHdW+++XtTT161NNCcv+sXf/MZ847qbMi2Xefd1d9MziYkYncLehnMOF50I97VDodWggABxHBHEfhGibqYbNssLak9B1x/SH4NqURpywwScYMIRbvsL2RENQckwxia6kxnA0ewhEaaMCYIAsAwNSLe+/1b6/j1f5sh1ufKsRd+HKaUShJGAAEiOA8qyAel88PxFhaAG7ezsxIcffoh3330XZ86cgUwmw913341bbrkFxcXFSEhIuGRygU4HfD4fTp8+jeeffwHDw1bnyhVXn79+3S1dSrXKB0zRlADhTgFj1RAu4Ql2Qv6Yght7rXuBiC5Xhrd3rLcXaE9sHxT7iYbXcWHqWwKA83nJN4f2xHd2d+j6B/p0Br1pVCGXGQCUQCJNlLrcpwY7fQfol7QLV8J3KRPiRR2JlFJyYgQZFEgBIGUiNsoDxuy80YoCoeX9JBi+L1jsjh2rgzCigHhxRWHl6dhDbyKDOcT+N9HmjVHG6/ORzz/dkvTFZ1vynB6pJqfsViTnXwtWqgQAKGRAZhKQPe8pelHBcRyGhoawY8cObN68GceOHYPdbsfKlSuxfv16VFRUIDU1FVLpd89Tqb29HRs3bsTx48d96WlZAw/e98PGpKRU1xg5pKaAaJql0AVx6GI5aDIZe1hMn19IpJkk1gwS7ZkC6YlVpZFlpgMUAMNKaGX55YPNVzY3Hao5kLq4vLIrNTXDQQlkoDSJIdCCMhmWQu9htEpOUEqHL1UyvKhE+DRA7gDywSGeBPpjtM4apTPEkPqC50JVouGZ3yOFtomIWkxkjtAo0l/0Lhp8yjhP4N+WmaAtMNaDRKg59I3+04/eym5v70hILriVySj7HmRKY+C62QgUpfOEOI/pB6UUo6OjOHz4MF577TXs3bsXfX19KC0txfr167FixQpkZ2d/K0MhJoLh4WHs3LkT77zzDlWp1Nbv3flA3eLFVcMsK6XiaX9KdkBgjDvF0hET4iwXK5H2dDjDTA6hbQweh5fhwj6ji99GhiG4rGKpJSU5tb6jo601MTHJmZWZ7SAAQEAooAGHPHDeeEZC821t9EBbW1tTWnqak8Te8HdO4qIS4TVWGMAgnSFQRwu5C8L/9cYaDRFB9RARo+ACPZ4jTJTOJahCieh6+M7x4yCWXSNWWcG06c8nMPn+HHZPT3eHfOsHmzNPHj2UoTMvlmQtvBcaYzaEt2cZIDUBKEyflwYvBjweD1pbW7Fp0yZs2bIFra2tSEhIwFNPPYUbbrgBhYWF0Ol030kCBPg0ajU1NfjTn/6E0VGn49qrb2y68YbbuhQqVaAXT5wEo6kSoy2kxeXFQ1lYOIvVotHvmVhbxke4rBds6diGlMipIcwr9CJAmAZ5NwmK7r5emVaj8eVm5ToKcgtGY9zEAiSOgtN4OZqiYc21jg4coo20i6wm46bLmyu4aERIKSUnhpFFOSRQCjb66i3cDug/iPl9R1etxuatCTBNtHCImCQYSx0RGyEB8lwoGU6qX0cZ6z6vh3y+9YPkb77akQ1JvDK95HbEpV8OwgRVbyYtkJcC6NSTeNY8xgWlFAMDA/jkk0+wefNmnDhxApRS3HXXXbj11ltRWlqKpKSk74wjTDRwHIeGhgY899xzaGho9JSULOp86MEnz5gTU11T+1Ri+RMAkRKVYNsPqiCDSfSjkemFY0ImkTAbZaw2hNoUw+fOC29vrDlT8GXs7u+W/fYff7nY7hiVXn5ZdfcdN93VnpGe5SRM9OUDBeRgSCqhVO/yujKcubRmqIWeNGThklCXXjQifBogt8GXzYA18GeiqUTFx/7OEPEdx+5eJMZx9GdEuSbOsh21Z0S6tIxtDxQkWy7iVrEjzKQnAS7srx+H9n9t3PHph1l9fYOm9AX3kNTCGyGRaQLXCYBEE+8tGqP/zmOSENSgNTU12LhxI/bs2YP+/n4sWbIE9957byAe8LtoBwyHYBf88v+z955xUlRp+/B1qjrO9OQ8QxoyDMERQUFAgooZJAcREMOij256nvf5/97/h3U/vB+fdR/XRFhFEDAgiCiyIkFJomSYGQYmkCbn0DPdXV3nvB96arqquqq7uqeHdde5fj+Y7uqqU6eqTp3r3Pd9nfscPkzT0zIbV61cVzh69Ph2U9QHB8Hec8kKVMYEjR0bfi2CX5nWeSXJCxRHa7tAI3MgayEwy5Z/myAI5NDhb9N+PvdT/8bGBkdFxe2Eu8bkNw0cmOsKWqjPHxrHcRjGKFJFzjW48Sb3M2OslBDyi85E02tE+EQT4niez2CA3Z/BRWdEoymiUewApcor0IAz3M/rLZbLAC3ik0NrvKlZT5m/lAKB2WECi9beHqTN19dVW/Z/tat/0eUL/RIy7zb1y1sAe3w/xUVZzUC/NCAnpc8tGg0IgoCysjJ89tln2LdvH0pKSpCZmYnf//73mDNnDkaMGPFvPyHeKBobG/HNN99gx44dzGSytC14ekXh7Flz6qxmcy9YB4FeJnkiDfk+gXOJo2dlSaVIlp9Ebkp6C+wM/OvSBB6hfYboItAGYGhoqLcRwjGv18unpqQ5ExMTBe2jA0EZTCAkjSecg1GW1Xjbfb66pO1sxhBH3S/VOuwVImSMkcvtyGYiEolySXgo4oFAl2oEQchQ7trwQ98aDKNhBzCofH0vfxnBvfnq35TuXqr20IQDnWNEUSQH9u3J/PHooUGMT7b3GzUXKdn3gHDKmfIpCT6laJ9IpmeQ3KAHDhzAJ598grNnz0IURcybNw/z589Hfn4+0tLSftVuUDk6Ojpw7NgxrF+/Hu1tzo45c568tnjxyptxcXE9nICttoi0LCTfd/kC2/595fv0zCo0qgnQhpaVJ48Bql2h0RfwqA0K+Xczb2YPzX6kOi4u4edTp0+kz5g6q2rIoGHaMcIgYKB2jucGUoYEq8WU3X7Tc4pdYyVk2C/POuw1i5BQDOCAeM3Hp2vh6z9wvQcXRuHa0FCEclCuHWi0xG4Klrs/tcIVoQrR2U8auRVdvhB3+MDXA2qqa5JzRi8hWcMehcnqCNg3IwnIzULvTY76N4c0Kf7SpUvYsWMHvvvuO9TU1CA/Px9LlizB1KlTkZub2+cGlUEQBJw5cwZvv/02SkvL3HfnT7q1+tmXr2Vn94twqoT87dM73h//M6YUjw4Jyh2a2qs+6L/MyisJjA9yqk93DJSBMkpGDhvtHDJoWMf9k6fWZ6RmeBISEyMSvlBGOQDJlJDxIkFqi8V9rrW49Vzc8LiGX5J12CtEWAJYCEUOAEdAJ0zhl0tKfkMKBBv9yFeKl8ggpDtUvVRSAHo+ytIsQRUD5NDj03SDAejs7OS/3bc7p+DCuZzYlDxz9ognEJswAOoLtVmBrFQgLbGPByMBpRQVFRXYu3cvdu/ejYKCAiQmJmLdunV49NFHMWbMGDgcjtAF/YpAKUVhYSHee+89/PzTz8LQwSOqXnju1cJxY/LbjJOgVuevFVZRji6V6RS1vESRKNQCoayFrzwlCar31NumT5bBSLIn0Aoryd2iVBTIT6d/SvjuyP6sMaPHN02fOrNh+NCRYVuCOue2gbFc8CTBG2NOa7np/pExdoOQX0aatqgTIWOMXG5EOnikEErNgb2wmvi0lCCSP1/aribGELMbmJEd9RuYfgwwEPKrkHN80HdOz8MTwhKkjOHED9+l/Hj00IAON+KGjXsEqf3uA+FMAfunxAMD0gHLryd5SVTAGENbWxtOnTqFTz/9FD/88ANaW1sxY8YMLFy4EPfddx+ys7P74oAqMMZQVlaGzZs348CB72haelb9qmdeKpg+bXZD+C5jbbLzb+t+21THcapVZdR9i9YLZpwcAwa4iuP1rlG+WC5VfQ/cozfBqC9rpF7aZGdHJ/fxzo8GH/rhwOB9337lvnrtSvHKZc/dyM7Kjo4rk4CjjKXyhJ/ACE1orhBOMMaKCCGeqJTfA/ROjBDoxzEaF3yvcH2Gcmgn0JZ+C24J6h6h+G4U3VdBVVcR6pLU5BeEBKW/dTWV1gNff9G/rPRqekq/mVzWsEdgiUnWPC4t0bfKRB+Mw+v1oqSkBLt378a+fftw9eo1DBw4AM8//zwefvhhjBgxAjab7Z9dzV8c5Mm0P//8c2az2huXLHi28LHH5lebzdYI3V9ab6HaivKnSFN+78k59KFNd1oBFC1ylGeF0Sq190iw2x7QuNxuK5EyVFTctF26fD69tq4mvr6+jnncnhIzz0fdfSky6iAEowilsa0Vgr2ysvJidnZ2VCzPSBF1IvwzQBZwyALg8xt1L6oHA886VMPUH3WFLNzAJHn5uCxoTWQ7yLPDGH6tlCKxoJBGuKIokh8O7k+/cO5UDjGn27KHP4b4tFHQYnyTCUhPBDIS+9SiRsAYQ1NTE3744Qd89tlnOHHiBBhjeOqpJ/HUU09h0qRJSE9P77MCddDY2Iivv/4aW7ZsgdsttM6fu6x4wYLlt4yJY+REoBcL1HMzBhlFdq88ofN70O36oLJP2qQY6OrR60+0HKrRgLqrM8JkhCNITkoRnnp8wbWYWIdH8Hr4yffeX5eckmpYLRoK8rvNACsIBoGKFjtNstTWsrPp6aQ9WucKF1EnwlXXYWlPoOmE42yMdfX2wZhF5ib1+7DlI72AnVXg/PlA1fnViOxlMUiChiB/x+TvoxYfB3sLZPvqdbFStW/eKLN/f3B//+rKquScUUtJ+qAHunOJqpHo8CXZ7lOLhoYgCCguLsauXbvw9ddf48aNGxg9ejSefno+HnjgAQwenAur1frPruYvFs3Nzdi/fz82bNiI2tp654OzHytZueL58syMbIPurmCkp36xpPVFJXFMqGKjY2VpOS41lsLVOV8wz1fvWoJqBBvGMcqQnpbpeX7Vi9fHj8tvdrtdXP74CS18Dy1C5RX6ZnGiaxsBzADpx4FMN7tdpLqanc7MJM6enC9SRJUIGWOkqB5J4Lg4Bsprxrc1/Ye+HZkmi4Q6qWwfBn/ibPVvMqi5S+t3XUjGrZoMg+yrC06Z2lRLACRZg4f+sTez6NL5TGtcriVjyGzEaAhkpP1T4oHslBDn/pWDMYb6+np8//33+Pzzz3HixAmYzWYsWLAATzzxBO66Kx+JiYngujIRMMb6LEIV2tvbcfjwYbzzzjsoLS3rnDxpWvnqZ9ddGzJkhI6bK3gsLfR2v/Uover6L2s0CcYvjVHWKfDkkv0nrRzoiwxGzyI1gmCT5bVQXVNl/XLf7qy8kWNa7h4/sWXG1FkNgM9KjAak3j1wG3wp2gjLhhfTYniXeOvWrTP9+/fvjMqJw0DULUKRRxpjsCv6DAUBKtlQGh8wWaMKfftlDKuQQnG65Cc/czASDHpWKn8VEYTgQ2zX2BasoV67cjn2+Pff9WtsbE4YeNdCpPafDI7Xl+wnxwGZyX1uUT14PB4UFhZi9+7d+Oabb3Dz5k2MHTsWc+fOw/Tp0zFo0CCYTCZwHAeO48DzXB8JquByuXDy5Em89957uHKl2JU/fuKNNWtevnLXuAmtxkqQs5g6TqZPNIB/dZnehP/M6mTXvm3aeyujgJKelAvYNzp111KBhguns43fufvjnO07t46Oj0t0PfbQ4+VLFj5zKyM9IwoCFi1K1tiLMZ5wyKYid38cy3Cx0+wCuYdEzSVrBFEnQkqRyplgU06QD3z4gcoltTs0WGMJf4RlJOoQHL5r6G7yRsQw8hPp7K+X6EaCVxTJgW++zCm5UpARmzLanDFkFmyOTN3TWs1AakJfblEtMMZQW1uLw4cPY9euXTh58iTsdjsWLVqMJ554HPn5d3etFE/A877kBBIZ9sEPj8eDU6dO4Z133sHpn097RozIq1i7+uXCKVNmNga/V1q6SzXNBIZDSBedyMmPaO0aUG7kUNbKb+dpn0eyGPXcpFpyvJ7VTyuhiFZfEmzeNQNQW1dn2X/wm0Hl18vSGKMYOmRYY0eHszLc+oTysumDSRXkCVg/EDalIbXd+frrrxe//vrrd8xvHFUi/DNA5puQQhi6pHXqBk511Z6BMcEQZpbcj2hwSKTFTZoPTfUDB4Bq5A8NKFijmrq/q6Bnb1y5fCHu5x+PZbe0dcYNnTgbyVn5ARlk5Ehw+JZdMuvv8quE3Ar86quvUFlZifHjx+Opp57CtGnTkZubC6vVAkIICCHgOK7PHaoBQRBw7tw5rF+/HkePHhMGDRpWufKZFwsfeODhhshziGoNmKV4oDwdcKiAPHS2GYcWvSl/1Y7z+W3BUDMmo9e3G1koJ1jrJQBiYmLFe/InVjc21sV4PB7TxPx769LS0sKyBrWUHH7Vhzrgo/7uvwIGZiFggy0m66T/Wv1fza+//npVOPXoCaJKhH8CyCWRJoHnrMqnIwW6/Q1Jvf6tfz8g5JhCUxKlP8qKJCrR7azp+mAo9q729qig1WiDNVSvKJJD336dVV5yJc2ROtqUNvB+WGNSdfcnAJIcQFpCiHr+iiClR/vhhx+wc+dOHDt2DDExMViyZAkee+xxjBs3Dg5HLHie7yZBifzkn/vgm15y4cIFvPfeezh48JA3K7N/9TPLny985KG5NeaIcohqWVg++LtQTqejV7tTowstKYz+ueQrxYdypUanzno3O5zWyihDemq6Z93a10pGDhvR0tzaapk1fXadIzb8VHj6TxIIrK2/9+dUTm4CYgejo9xAfeXpysPZ99yZaRVRJcIjdbCn8IgFlZfru0yiah6BFiDV+ayCWiGqc0w45KfmLirbEHKMq2VW6lxKOCQIACVXLseePnU0q7Wt0zF01GwkZI7vUsLqI8Hhc432pZPxddzFxcX48ssvsWfPHty4cQNjx47DvHnzMHPmTOTk5HSRnT8OqCbDPvjg9Xpx8eJFrF+/Ht98842YnJRau3TJ6qInH19YFSNbWzA09D1C8oVz0fXZ12XqkV60SVDtEFVDy82jrFfoGkVWZwOzvwxDEARy9VpR7PFTx1InTbivYeSI0c4lC1ZWCIKbM5uthiqotpz9EiaptqFrrj3EIQBjiSaeG2tPjr/NGLt4J1KxRY0IGWPkXD3iOcLJRPvqtQK1b1V4ShPphMHro2VbGlKIar1z4ViCUqE9fEdFUSDf7d+bdb20OM2RMsqUOmAKbEGsQcC3CG+iw/fv19yNM8bQ0tKC48eP4/PPP8ehQ4dgNpsxb948zJv3NCZMmACHI9bn7gbA8zx4nu+KBZI+kZEKoiiioKAAGzZswFdffU3jHcm1ixatKpz/9LLbkSfSDhh+ApBbgFRlDd4JcYwR126gwCdUH9MTyFNKGtnXCOrqaix/37Jh6NGTRwYeOXqwftmClSUzZ8yuj8QSlEP/2tUu0mAZYRlACCFAFm/i89uqUAGgvif1MoKoWoQmgngQavHHP5V/1Z+Dy6l1EM2hkboGRmN68oO0SJNTbo+kX711/brtzE/HslpanHFDJ81GYua4kNag3QokxQHWX/H8QVEUUVpain379mHXrl24evUqRowYgSeffBIPPvgQhgwZApvNCo7jQCntjgf2WYHaEEURhYWF2LRpE/bu3UtjY+PqFi5cUbR04cpbyYnJESRiDvQCKUMm+qI67bJCxQzDq5GybvpqAk63A4gu9PKCqmG05fqswSuxJ348NuDGzeupDQ0NjvvumVI9VXigIZx6abtCtZK3qSd3+3/X1gp3TVcCsxEOQyC68hhjx3o7J2lUiZCY4CBN8sK2AAAgAElEQVSMM7HuRq12gWo1WgMK0FD3VFaqdGQoeg0w7SUtDIfAdGmhoEGG8rFPKGWoGowx/HDom4wbZaWp9sShppT+98EWkxb0GAKfUjTpV2wNOp1OnDp1Cp9//jn2798PShkeeeRRzJs3F/fcMxEJCfGKaRGSwrGPALVBKcWVK1fw97//HV988QW12WLrF85fUbhs8eqbKSlpYcrb1d0dVeUFlX6TryQvH1UG7qddfjShNcLt7XPqI1rj//iEeO/dd02o7HA5zTlZ/VrGjrmr2RHrMEA0odf+Ue6nvS3w6fknxCh8AJQlcxw32lmHYgDVoesXOaI8oR6xHKEmytA1L1Bq7BE0GC1JlMHnEA4JGi5DS3JqAFq6qVBorK+xnDrxQ1ZTY1P8gLsWICEjL6Q1CABxMT636K8NjDFUVFTgu+++w8cff4wLFy5g4MBBeOKJJ/Doo49g6NChMJst4Hmu2wXaR37BIYoiioqK8P7772PXrl3UYrbVL3h6eeHSJatvpqdnaqgKgw0/A18WpvpLoDe+1RKayAfR4VuF+gNmI66g0LrQaCGYfaW3nx4YZWhtbTHZ7TF0bF5+2+/+478Lhw4d0Txk0JC2u8dNaJHETnq6WCi2SzImI7XTXgEh+B2UxGowMbB+YodrNGOslhDSayOPqBHhn/8Msuj3iKEizIDcEuxB3fWGQEGGRsGtQXm2B9/OHOdThnaPPY29CyGhrYo1cBxj+PHYkZSykitpJnumJbX/fbA7sgwdG2cHEn5l8wc9Hg8uX76ML774Art27UJzczOmTZuGBQt8K0WkpCTDbDbDZDJ1u0H7EBxyd+ju3bupyWStnz9vedHyJc/dyMrI0VmJIFgXqu0BkneN0oCZqPZRQmt76GC+vnAumJKAKrYo9+yd/lh+PyIZQOuDoaL6lnXHp1sHOmLjhMceebJq2OBhHa++9PtSX8KI0GnUfP2jPP2JMftU7vTW1gVriWb83wkjCSDi0JabOAegydBJI0D0LMI/AaZm2LyE4/3XEU6DRlRs/1DdnGJ8Kds56HHqcEEQ9DTbg6ujgz96+Nus2prqhPRhC5CQMSbovEE54mJ8qtFfg7HDGENzczOOHj2Kjz/+GN9//z2SkpKwbNkyzJ+/AKNHj4LZ7JsXyPOmPivQICRhzMaNG7F79xfUarXXz5+7rGj5srXXs7L0SFAP/hdHvXCuco3RMN0sYcK4EsGIL+nOxAPV6EnLbWpqNn28c/uAjz7+cCzhCLt5+4bj5Rdfu9Y/Z6DLyPF6wxvtGgZafdr7G+shGZiZ57hMkXYMZoyd7S0FadSI8E8ArnCwwQven0BTr4F3bWddv0WhfzLmDvVbgtIfeQSip4hGN1tUcNFxtagg3UutttT+9yEmob+hknkecMQAsb+wVYJ6Y1I6pRQlJSXYv38/duzYgfLycowZMxYLFy7AQw89hOzsbNmq8QQc1yeEMQKv14vLly9jw4YN+PLLL0WbzVG3cP6KoqVLVt3UtwTlUBOF+s2SL58mkaD/c7Tgq4V/uVy5M9Vv0fkVbRzk2UADewP/sXr1jD5B6s+8Cx/tHe2moisFyY1NDbFe0ctfLb2a1N7WHjC6Dnxa2ur70NP0pRprfY8AhCTxhAwFcBFAr6Rei26KNQoLx4GjCoswCM3IE2QDQe+ZVrjcKLpXgeLCE9QoEKSdR+q3V6NrqaWsmuqqhKTM8SQhLQ+8yRiz2S2Aw+abQvFLgdvtRmVlJTIyMmC326NCRh0dHThz5gw+++wz7N27F4QQPP7441i0aDEmTpyIuLi47lhgH4xDmizvmyLxleiITahdOP+ZwqWLV90KjAkafQv906e0OvLouf7UZwX8dBgKWq5QrUnxoc8Ybeir7cNDUmKi8NDMR243NTXYWttabfMeX1DWP6d/gDUY/Kkak/zJ7Xz5cZH0291nprAzjsvuqEcqY6y6N6zCqBKhSKmVI+jqgdSBbR2lqIHpEJE6TgJGOLLWrftAwmbIHkJ27XXV1ZaL539Kb29vjx027n44kofAyCtA4LMEHdqrMt1xSKu8Hz9+HEeOHMH06dMxY8YMxMZGHsBkjKGmpgaHDx/Gli1bcPbsWQwcOBBz587DvHlzkZs7GFarpY8AI4AgCDh//jzee+897Nu3z5uQkFy7dOHqwsWLVt7SVoeGEsX439jecvcFnle9Ejy6t2m/0mo7Txkn1Lf+oo/eGAy4XC7uasmVWFdnB583enzbvCcXVOUOynVW1VTapk2e0eCIizekEpVPaZBvl2+TZ4fx39VwxDEhQBgBpcmipzMXsPeKejSqRMgR8OA44stLpg6sRa9hGbmpnNYXo1WQi9F0Thbl6YxgYPjp5PfJFTevJ1kcOaakzHxYY4yvpWS3/jLcopRS1NbWYv/+/di8eTOuX7+OmJgY3HvvvREToSiKuHr1Kvbs2YNt27ahsbERkydPwbJlSzFjxgykpKT2rRARIdxuN06fPo3169fjwLcHvEnJaTXLlqwuXDBvxe2UlOQw3FB6XaBSX6itAtWCcXejRFt6oQ6tV9hfurI+vSmG0UO0rWVBEMi5C2fiP9i6fnh7e7tl3pMLyx57+ImaSRMmNwMAzxl1SGvZpGq9rw+BbtToGm0c4eOoSAcC+AlABPNXgyOqREgBQiglii1azdDgxDq92UShoLlfJG1bVpART3dEjber1xBFL/npxOHMxsb6uNQh8xGXMjws1YvdCtj/yUQoCAKuX7+OL774Alu2bEFLSwtmz56NBx98EA5HZPM6JFfotm3b8NVXXyEuLg5LlizB0qVLMXp0HmJi7H1K0AjR0dGBU6dO4d1338Xhw0eEzIzsmuXL1hbMf3p5RWJ8YsST5ZXOMPVno4PjyMjIFxuUrwqv1Qf5o4LKUMmdJUC1ala+rSdDusamRvNX+7/od+DIt8PdLpfJ7XbxeSPzWkePGtdOOGWyS+3xvl4NtKdCAMFdnz1xi3afmTEbCJfeVtGWACCsyf9GEN0J9b7JCLI7aODSDbpFjUBh+FHlsd0PW0+BHWI6ktQ0jISJI0HFjeu2a8WFqS4PsyXn3AN7fE5YJVotvjjhPwtutxsXL17Exx9/jJ07dyImJgbLli3DmjVrMGTIEJl4xRjkSyZ98MEHOH/+PIYOHYbly5dh7ty5yMzM7E6U3Yfw0d7ejqNHj+Kdd97BiRMnPQP651atWLa2cO6Ti6vi4xMMkqC6S/Vv138q0Yk9KF9RKnv35RIZ/XMrCVA+M/DOkiEQ+JZHo0WbeTONd8R3thNic8QluEEIKKOEBy9JFAPguxfqidvBTQC5/R9Mf9HjJ05AOMbiCbhsxlhjtOOE0XaNEjC5BksmhiGyphttvyLUHn6jkl+dHzVaScTaJ622pP5OGU4ePZhWV1MTF5s8lItLHQ6TJSas09jMPqvwToMxhvb2dpw4cQIffvghDh48iNzcXCxZsgTLli1Denp62BabKIq4du0avvzyS2zevBnNzc2YMuV+rF27FtOmTUV8fHwfAfYALS0tOHToEN5++22cPXvePWzoyIpVz7xU8Ogj82qMJ9BW7ubPDWJkOkTkZKNtcXDd/yutQD2rFIrf74QsQGtyvHp7TyAIAqmrq7HwPM+Sk1OFF597udRitYq3K27GrXnm+WvDh41y6s0XVA5l9CQ6SvvVf78CSVCv/J6CERJLGLIAXI5Skd2IrliGUZHo2tU0pM3f0xsmN+gMlaUOY4YBww1Yj0Fl3z0eN3fmp+MZzc2Njuy8J+BIHBTOGQD4FuS1We7sHEJKKRoaGnDgwAFs3LgRhYWFyM/Px5o1a/Doo48iPj4+rPIYY+js7MS5c+ewdetW7NmzBw6HAwsXLsSqVauQl5cHq9XaR4I9QENDA7799lu88847KCws6hyTN/7W6mdfLnz4wcfr9JdSUlKF9rhOrRDVIB4KhM5YYQyBpeiNZtVDZOXv+sQZXagz6EQTgiCQixfPxe/+amd/q8UqLp6/9ObQwcM7/vDqf19zOlv5+Pgkr9lsZmr3p885rUyCGVhbbQQbPPTWoIKAxogcn/HZZ59xAKKaezS6FiHAAI6pE+dqOsP9x0SkBpXcn5CmRFCNBxCq8BCCGED50kfciLXSxclQefu6rbzsarIg8tbk7LthizOWSUYOi9lnFd4peL1eVFZW4ssvv8TGjRvR0NCAhx9+GC+++CImTpwImy28gCVjDPX19fj++++xceNGnD17FoMG5WLZsqVYsGABsrOzu7PD9CF8SK7mr7/+Gu+++y7Ky693TMi/9/ra1f9RdP+0WY1m3hTC2eF/USQbQEl2cuG8juMtij2kfhQweG+iLYbpXRKUw2i2znBQXV1p/ejTzYO/+HpXntlkFgVR4F598ffX0lIzPDabjWp1PNLaHr4sMVrOWa3cluoytIYWvQfGiAVgSYumL7IBcEaz7OjmGgUoAdW2/XWIwKhbQmfyRfABpvo3g54araqG3XD1LEACcMx/WkYZfjzxfWpjfb0jLnUkcSQPBW8K08dJfERouUNE6PF4UFpaik8//RSbN28Gz/NYuHAhXnrppa68nuFVRBRF3LhxA3v37sWmTZtQV1eHe++9D6tXr8bUqVORlJTYR4I9AGMMt27dwq5du/D3v/8d1VU17fdPnlm6dvUrxRMnTmnWdl1rSSrUxOfbLu9KjT+hcMlH3VNwGp/0jgtW2r++0Kq9o52vrK5weL1ejokM5dfLEzpdTt5/acqnoiVd0hbCBJ/8ok6N1ut3koAwwN4odiYzxjqiGSeM7oR6xgRCiMgA/2SuENaQHKHURRygXDG+F6Dm7ahO+lUVxAHwiF5y/txPaS2tLTHZo59CTEJ4IhkA4Ahg5u/MZHqXy4WLFy9i69at2LlzJ9LS0rB48WI899xzyMzMDDse6Ha7UVBQgO3bt+OTTz6B1WrF/PnzsXr1mi5S9TXR3shQ82sApRSlpaX46KOP8NFHH7G2NmfbQw8+cXXN6pevjRk9vk3/eek/R7/43keGSjG+muDUEgqt4awRyG0+Ck73PFo2SuB5lRZk77w46tyhQPT6k86OTq6i8pYtp19/V+7AIZ0vrfmPQkYZrBYrXbf21aKsrP4uraGG8inoxQC1IT/OaK7RaIOAWK2USwJwO5rlRpkI4aFaLTzIPQslcpGgmEIR7jsUoc0ecePVE1tp3IfGuhpLWUlxststWhMzx8MWmxF2Pc08YIrukwwAYwxOpxM//vgjNm3ahO+++w7Dhw/HqlWrsHjxYiQmJoZFVNKk+59++gkbNmzAkSNHkJPTD8uXL8PixYuRmZkJwGct+vbvI8Nw4fV6UVRUhA0bNmDXrt0UIM1zn1xcvHrli6VDh47qUO6t5eiSNIH+Fyh0ThG9rte4BRhK7BZIgvLfJAGMlsUYffGOHvQs5Gi03pbmJtM/Du1PO3biSOYD98+snvPg47VT7pvalJ2Zdc5ms4s5OQNcVlm8V8uODowJBsuPpZ4Qo+UvuzPEyDFYKGhCtMuNavfJm3g3ZRAZNd7gjWzrRpDpDWEjjDIMN16D6fW6R2WU4eyZk4lN9XWxMQkDuNikQeDN4aeHMZl8ZNhbkBJcS0rDS5cu4Z577sFLL72EOXPmICYmPIWrNOn+4MGDePvtt1FSUoIxY8bgN7/5DWbNmoWEhITuDDG+v75V4/tI0DjcbjfOnz+PN998EwcOHBAdsfGNC55eXrB86Zob2dkDdPKGBlpt6jUD/AhHZRZ6n1C2onYcUF4HGvBrOOePJnqzlQqCQH78+WTSWxveyC8rK0krKLqckZyU8vPU+x9oHDkyr1172oKf6ORPWB7xldfc/yyY6rtUZvDJ9b0JkTALARf35z9Hl32jtwwTgEUMblBtFjSgSwkOydSMxC2q9c5G+93QIcHAMbbsEEbJxTM/pba3tdoTc+6F3ZGJSF4jUy9ahJRS1NXV4auvvsJbb72F6upqzJo1C6+++iomTpwIqzW8eKbX60V5eTl2796NTZs2wel0YubMWVi3bh3y8/Nht9sUK8ZL5NdHgsYhWe5vvPEGTpw46U1Pz6pdueL5y0/PW1aRkiTPFhMqDoiA772VH1Sqge+MgS5PpSxGW6LBaRJjsBFv9EQyd8omcrtcXENDrbW9vc3q9Xr5pqZG+5WrhfETJ9zbbDZbRJ/9rpzAIo8DcjKyC+6uIkCQYdA/CxyBiYDG/OlPwOuvR6/caK4+wYo86CBmCFR1T9WjvXBubndcUDou3AJ02nlgGqgoxARDWILqaguCQEquFSc7nU5bv/QxsMWmR3RajgB8L/ROkjL0888/x9tvvw2Px4N58+bh1VdfxfDhw2EKk31dLhcuX76MzZs34/PPP0dsbCwWL16M1avXYMCAAeB5DqJIFflC+wgwPDQ1NeHIkSP4y1/+gsuXLntyc4dVrl3zH5cfnTO3JlaxCrnWi6QkBr3pr/rHRw7la6qX61N9Pr99IydBbRLQi5j1DPJ+Q0K05wk6nU7+xu3rNiaKZOSIUc7ZMx+tvVlxu/C7I/sHPTBl5s1F85ZWxMfFi/L4nUSGnKIW8rw1gZ0Up9jH7w6VO7YDCfTOgjGYOEKinlU5upllTOhgjPOqG1gkzU3h11a34R56Y/T89hE3Wg0PgdbLqO46Km6W2aurbsczWM1xqcNhtiWGfWoCHxFyUeYLQRBQXl6O7du3Y9OmTbDb7VixYgVeeeUVZGdnhyWKkeKBp06dwltvvYWTJ0+iX7/+WLnyGcydOw/JyckghIBSBo7T7nb7EByMMVRXV3db7rdu3e4cO27Crd+88NvLU6fMbrBarTKtsj60JsMTTRJRlxU9IX2gmlP9FmnVRC2CkTpviRjvrHsUiE4Lbm1tNh04vD9t91e7Bpk4E/uv3/6/l0ePzGtft/aV0tkzHqoeM2pcmz3G3n1xSg2vUbGCXPzCAhzkEpREeedBABAC3sto1JNJRnceIQenl9LuUaeerkv71x4g0PFtCBFNiQjjIH3Bd1d88PSPSe1tLba41GGwx2UaXoBXDV/8LKJDNeHxeFBUVITNmzdj+/btSE9Px4oVK7B27VqkpKSERYKUUtTX1+PQoUP429/+hrKyMowfPx4vvvgSpk2bhpiYGDDGwHEcTCYTTCa+yyUavev5d4c0/WTr1q3YvHkza21p65g6eWbpCy+8dmVC/qQW7Ywi/meo7cgI9/2UuyKDH6tPaf43xvdJ7QrVE8j4JTLB3rloQY8KotJkVRdw7drV2Pc/3JB3+vzPA+Mc8Z0D+w9q/a/f/p/ihMQk7z35k1pIwAhY7vpUE6KWFRhYa21BjQQtP9odBCWcuReSC0c7xVq7iXAeytR+++CjyaCvjZF3Uf3koimqkUOdJ0n2XYuHgz0txii5Ungxyel0WpMH5cEak4ZIXyWO67KaowCXy4Vz585h/fr12Lt3L4YMGYLnnnsOy5YtCzu1mdfrxe3bt7Fnzx6sX78ebW1tmDVrFl588SWMHj26W2RDqc8dajb3rSQfLtxuN65cuYJ3330Xe/bsoYxxbU88Nr/4udUvlwwfntfuaxehWqVcDygnSL24YagXK/RLp5S7SLTnX/2B04gFKh2mvmP8r36wNQSj2xH0qs+CA1xuF+fscPIpSSlCXEKikJPTv+VS0WW31WoVmhobbIJXIIC0ioSyI9Ke1hDoGtUWygQm0g5uBfYOCaq7WfXPlCDq0sCoESEBcMGFNrOFCtKFBAqZA6HbRI26P7XIL0gZPW68erlDWejRp/xaRa9Arl8vTejs7LDEpY2ANSY54ipFyyJ0Op04efIk3nrrLRw9ehRjx47FunXr8MQTTyAmJiYsgvJ4PLh69Sq2bduG7du3w2KxYOHChVi9ejX69+8PnjeBMQae58BxfHdc0Oce7YsNhoI0neXMmTN44403cOzYcW9cXELTogXPFCxetPJmTtYAV+DAWTvu5nOm+aP4cpsiPHVoOPup43eB35Xl+d8eTkaaVHa0/uoR0XeLBo+fRgZRFEll9W3rqVPHk2vr66yL5y+7nTswt3PV0udKPG63adiwkU1rVjxfnpSQ7AX8blDlHZJELoF0Iu3rv5NyR7h0jDI2+M+AVjq6bkIkIKD0l0uEIIQ5b7G2BCvchIHRrmswcjMDXKjhemTUwje9KoZRrAJy8lP/ZejOFBMOGhvqzXXVVXEi48yOpMEwWyOfGkOpX1AUCaTE2d0ii8uXMXnyZLz22muYPn16WOnSpHyh58+f961xd+AAUlNTsWzZcixYsABpaWndrlVKRXAcB4vFDEI4UCp2iY45hWK0D0owxtDY2IgjR47gr3/9KwoKCj052f1r1zy77uIjc+bVJKUkC5zhYZly3G8MPXG5KC05KYoXWFslxfnhP6e/pN6P/2lNjofO90hRU1tj2bL9w0Eff7ZlLMdxlOdNbNWy525OmjSleeTIvNNxsbGixWYPuFhO1kFxqu3ySG/Xm6WII/qfpPIq/tlqUfX97q4dAwuTIQwhqq7Ryf3gLm5kTjAicsRY2ZT63Xo9urwg70OPszoYnRcI/QYk52ovZSi8dC7e2d5qi4nvT6yx6RHHBxkAkQJihF4KxhhaWlrw7bff4o033kBpaSlmzpyJP/7xj8jPz4fFYnxtJ6ms48eP429/+1vX0klDsXbt893zA+XkxhjAcUQ2XYIHIbRvfcEgoJR253h99913UVlZ1Tlq5LiKl1547dLUKbMalcrQ7qO6/uq10lCWlN7zUCsAgr/Akr5TOlKt9wwslyq+qevvX463dxDoeNRWm/cEjDJ4RS8xm82svqHWcrngfGptfW2cyWQSD/7wbf95T8yrzMjI9qSlpAqAuq9RuzyVNaKK7Uy2TSJDH5T3X8sNemfjgFr3tPvqOFCI4i97Yd4/A1jC+CYQ6qKAQ93AOaA7RZo8Dk5hgATV76RKRapuCj0OZsvjy6oD9byvobpv+SUUXylM6OjotMQl58FiSwy3dspyWWQWIaUUjY2N+Oabb/DGG2+gqqoKjzzyCP7zP/8To0aNCitnqCSK+fbbb/Hmm2/i9u3bmDBhAn7zm3WYMGGCwrVKCOkSyBBFTJAQEvaUjF8TpByvXe5m1t7udN4/ZVbpi2tfvXLX+Imt/tUjghGYXraYUEQWflxQ+wilBejvCtQxQK0SpH2Ch1uiAQ3HT8/V5TIwytDY1Gi+crXA0dHRbppy37TG4UNHOJ9+fH759etlyTGxsZ7Z0x++lRCX7JWsOQSQV2gxjIRgfVZwN+idEcSoKZtAh94Zo4zjftlE+CeAFTA08YCbI3AAGi+DahhiqEFrvdeqgtU3TN5EepQireu7/HRqfZwe1I1M+isyL7l1oyzO43aZk5JyYbb3LGMQpT6rMLxjfNldvvjiC7z11ltobm7Gk08+iT/+8Y8YMmRIWIQkzTfcs2cP3nvvPbS3t+PBBx/ECy+8iBEjRigm3ctJjxCub8K8AUjxwAsXLuDdd9/FwYMHqYk3t8x9asmVlSteKBs6eHgHH7B6RCAN+Z1haldocAFNNKwudYRP7iDlVFuVx0kWpNyGVJaod6aeINSguqeor6+17Nq7M/vjnR+NEqlI/vt3//f043Oeqp0+dVZ9TIzjVHpGujtv1Ng2W4yNyuVLfktO6eKUIO9zqEIY478yNSmqfw/pAuslGCRDkQNc0T531IffJh4Nogi3pOrVfJ267n5YrlCDQ0AtV0bYB6pav7Jxhec/1+xiKFBZcTPe5XaZHUmDehQflMoLxyIURRFVVVXYuXMn3n33XbjdbixatAivvfZa18R2425aab7hjh07sGXLFnCcbyWKlStXYsCAATCZTGAskOgIIbBYzH2rSoSAtObj0aNH8dZbb+HixUtCSlJaw5JFz16eO29JRXZmP3egKzkwaB5IglpDu2DoOcHInaKcojqSlch1k6Vyf3WcMFidI69jMNKLlhiGUgqz2cxKbpTE/OO7rwcWFl/Oslptwpdf7x44e+ac+oyMLPecBx+r5UwEPG9mcvGKujZcQI2J4mn74Lf95c40fwsJ5Qq9M2So524OqBnhBEbFqC7BBPQCERKKBp6gU30B3Q+BKr8bQhjvYMTxwCA7U+IXxBiRIABqGYISrc3NpsaGuhiRwhQT3w9miyOcmgbWLwwi9Hq9qKiowI4dO7BhwwbwPI/ly5fjlVdeQVZWVljxObfbjaKiIrz//vvYvXs3EhISsGzZMixcuBDp6Rngeb6L5Hw3T3KJ+tFHgMEgTT/58ssvsWnTJlZZWeUaPHh41ZqV6wpmznioPiEhWfA/L62hmna3GNldj0wUA0WtlJpFSRyglL/ISU86Streu/FA6a9WsrGeQBAEUlNXYykpvRrLEeC+iVOahw8d6Zxy79TKwuKCTEdsnDs1Lb3T7XJxNpuNmq1m5rfkJNLTenI6eR27oG8zq2M+d979qXfWkEIkRr2UMafGoT1CdDPLEMJu3WKNbXY4OQbK5FY51SCG8MMO2ucNv6pKdLUJjvlIL8AaZKEtQfWl6MoLKENZWXFsZ0e7xRqTRiwxyRELZSSIzJhYxuv14ubNm9i2bRv+/ve/w263Y/ny5XjxxRcVas5QkCtD33nnHRw+fBhZWVl47rnnMGfOI0hOTpaRoPI4XxyQV0yZ6FtVQgnGGNxuN65evYrNmzdj9+7dtMPZ6Zxy7wPla1a/XHzX+IktMTExqrdDbv1JDrTA56m9aG50oKQv5Zw//7xAtXAn0C6VxwD9ZfU+CQK9M0ew/Ea5fev2D3IPHNw3JD09o+31//v/nckfd0/rg7MeqSaEOzNowCDnjOkP1cfHJ8hiX4HBHj8x+qdDANJ90ybFwKGRlEVGS5fZu2SoFckkOtvVx3TvT4iHY1x7tOsWdYuwXz+4r9SzRo4jbhHw5YTTcoUa9cYY2FfL+gvakLUO6CI79dNQE2AoQjTiQr15vSzW7fGY7PHZMFkcoerM7EAAACAASURBVGobEqIIeMXgVrDX6+3OPvLBBx/A4XBg1apVeO6555CSkmKYiKSpFidOnMCbb76Js2fPYtiwYXjppd9g2rRpikn3kvUn/SWEdGeQkYhSytHeN5HeB8YYWltbcfbsWbzzzjs4duyYaDZbm+fNXVq8Yuma8sGDR3SYZUvsqFsa0dgu1wtqIzpxNX9p6hUD9d4ITra/fDo9VZQFjSOh2BpdkuxpKxRFgXR2uDhwQKzdIRYVF8T9cOLQwLKbpekt7a22fxzYlzV+7N1teaPGtg/NHdphMluYbyV5H3x3K7Rvyy+gkU+NkH7zp02Tp1zTnnB/52KBaqerfGqE1lUGbKMQCCe2RbtevSHRYxzhaxmjnSCwc1TWTEO12xDtWc8xEF7tDJwgyOR4bR2ekgAV+6nMRFH0ksrbt2M9brfZlpYFkznWYMX14aWAR/ARIqfxRKUVH7Zs2YLNmzcjMTERq1evxurVq7vzfBqBtBzT4cOHu6da5OfnY926lwOUoXLIV5JgjHUn1u6bK6iEKIqora3FoUOH8N5777ErV64KaWmZdcuXrC54/NGnqzIzc9yBRruSxJhqG1E3QM2XLBqxP3nbV6pClecO3FtyhgaqQdVDUPVv0SNAdaccEShQ31hvvlx0Ma74akF8TvaAjkcffqJuXN641rvHT6iqrKpISEtNbY+NdXilWKHVbBLlQxR/BDdYjZRWH1XZVIF3RssGu3PkF02LmxHm9oBv6lkwKRC9olX3ElTzDE4OSAZ0SEG9Te3J0di3R1Mi1O1K7g5VnSBY1AXQJ76A/bX6IArU1FTEeAXBZI/PgsnScyIE8xGh2wuYVU/U6/WitLQUH374IT766CMkJydjzZo1ePbZZ5GUlGSYiCTRxj/+8Q/87//+L6qrqzF16jSsW7cOo0aNgs1mU80R9D8tvyXIQ+yStzLGulyi3K8+ryhjDB6PB9evX8enn36K7du3s4aGxs5RI8bcXrXyxaKp989qiI9P9CrjgdpQR3+U6B33YmgBmbRH4FvkJ0Cumw7VkUP9Mo1Dz/WmZY1EOt/Y5XFxe7/elfXB9o1jKqsqE6feN718/Li7W/vlDHA99fiCmzlZA9on3TOpIS9vfJvfqvc/MeU9DGYR+rf5J8hDVgbTGJTfeQKUEOx+ahGj7v4MjBCu08Nbmwghv9wYIeCLExZXshpm5dp9YUKFI1sf2lFdgAb3KxuvWNdflS5az5LTi/epR7p6BBlQsKzA+rpqu8fj4e2xmeDN4S1qqwe3ALg9gEOWBMbr9aKkpATvv/8+duzYgdTUVKxduxYrVqwIa0V5yVL58ssv8dZbb6GtrQ1z5jyC559/HkOGDOmedK8Ww8jL5zjfHEGOY93E2GcNontljgsXLmD9+vU4cuR7ykTWNnP6nNJnnnm+ZNyY/FabTSseKMHfcn1NmhqMA2rH6yKBcmafVjAhcLs6Bhj8Dew5gstKlDDSKhllaGtvMVXX1loAisz0TE9sbJzo7HSaGhobYlvbWuzXb11PPH32VOK8xxdUT550f9Pd4ya0xMTGimazmcnGxQAATtWj+e+Wnh/MnxJNK52a5CoNnJBw54nQXytjISzd+0+YwKjYeuykVWdh6cjRKxbh8Cw0X6kTmzmOCACMpyZRQ/YuhBUDVEOjDSgsQWlbkM+hR72Bx2l7pRhaW5psXq/AW2PTYDJFZ2ktj+AjQ99UBSUJbt++HRkZGXj++eexdOnSsEhQmiO4c+dOrF+/Hl6vF3PnzsOaNWvQv39/xXxDOQlKRCdZftJPPpdo4HSKXyOkAcbhw4exfv16VlR0xZuQkNz49JNLiubNXXx7wKDBnWberNNzKa0sabQZ+q7Ku2Ctz5FAK7onP18g5LVXukT1fCzRhUbsydgL3oXGpkbzvm/3ZuzdtzuXN5voM4uevfbYnKdq8++a2DR+bH5lSVmJ+578e6oGDRjYQTgCm81G5XFAwK8EVQ4KtKxDCXJLj3S5RKVjlOTpjw6rybD3Ecr6jtQ9SsB1cjyrLyz8c9QvpLfSeIhgfBUBdbJgRGigffdYzqweEMm2acb0gkDrFdWFjmnp9QhcW1ubTRQpb7EngTeFt8K7HjwC4PL4Pnu9XpSVleHDDz/Ejh07kJmZiRdeeAFLliwJSHMWDJLAZtu2bdi8eTN4nsfixUvwzDPPBF2TUEstKooiBMELq9XyqydBxlj3/MtPPvkEH3/8Mauvb+gcnDu8etWKFwqnTp1dn5qa7uECXAvyblDezVGVPaG2N+TQU6wZc9monZcS+UmqUH/aM+Xbxelch/Z7pONKiRD6jkXVKXUgigJpbWvnW5qbzAmJSUJifKK3rPxqzJ6vdw0+eeroYLs9xjNs0LDmh2Y9Wnf3uAktv3/l/7nc5mw1jRyW156cnCyor0h5WrmbM/SVUIVFqC5Lq7f857hC1VBrVCUnbTg9AeGYE15U/+lPf2KvR3N5evQeEYKacJswro2AJvk2IKwRl4SI/PUGpsgYJUCtcWnApegFE9WDbgBNzfVmj7vTRHgzMdviQXjjacyCwe2VBDMirl+/jg8//BDbtm1Deno61q5dGzYJCoKAkpISfPDBB9ixYwccDgdWrFiBRYsWIz09PYAE1UpR6bOkCvVZhfRXP1VCUt1euHABGzduxOHDh6kg0Lbp02aXPbv8hWtjxuS3xcbGqfKFShpALbGJOpoU2D3qO/pDk4zcmemnOLXQRYdwKSMQKeFED1EQH88xcGYGnrCAuYUG6xUu1BMF1FUN1hFcKS6K/fbQPzLPnj+dPv3+GRUrl625NXzoKGdOVk67zWYXTCYTbe9oNzc1N5gzMrI8d427uxUAlOpeH7TjgFINQytFpTLUd0jZQuSCiDsvijEizYmkBxBF5vS4SHV0gklK9AoREkJYeROrcAm0FQTKOKGWaCxEu480eN19sKogo3ys1aUAXdVVi3yCkaH0kTLUVFdZBUHgLbYk8CYbei7W9sEjAB0uETdv3cTWrVuxbdu2bmHM0qVLwybB4uJivPfee9i9ezdSUlKwevVqPPXUXKSmpoYsR4vsOI6A53/dWWREUURdXR2OHDmC9es3sMLCAm9CfHLjksVLiuY9sfD2wIFDO6XOUymBALSiRmpFqDLCpPVZ63twaNOU2vLjAFEknODm4O4wEbeH57weDp3tZq691cp1tFuI1+NbHZjnKTVbvYhLcLPYRDc1mSgsFgqzTaQ2q0gsNtmUWGNu0WDdvSE9gUaH4HF7CM8RgOPwya4dA3fv/WxUY1NjLGMU906Y3JiXN7Z95vTZlTE2uzd38LDWWdNn16Ym+xJjywlQO9zir5GSuOS1lvZTRn8DtQlEVobWOe4cGaoJUOtzJJagrxDmBUhLCmerj7ZQBuhFi3BQItqu1rFawsgQxqAfCAvSziO2BEMMTfQ4S999odw34L3R8vrICVKqDqOkpanJ7BUpZ7LFgeMiD5+q4XKLKCm7jaJTW7B161YkJCRgzZo1WLZsWVgxQUEQUFhYiHfeeQd79+5FZmYmXnzxJcyZM8eQylT+u08U4/vO83z36vO/NkgT5CVX6Keffsrq6xtcQ3OHV65Y8ULR1Kmz69O7XaFSU9VydKlHX+rtwVpvZJDcn4EyFw6gIuHcTp60t5q5lgabuao8ka+8mcw11iRwrc3xxN1hIZTyACNgzPfgpU6M4yjjzV7YHR1ifFKbmJbdLGbktIhZ/VtoXJIb9lgvtdpEcHzITs9IPEr6bLT13bp9wxYfFy+mpqZ7crL6Oa1WmwAAdXW1jhu3ymPGjhnf9uCMOXWT772/MdbuEGNjHWLgavF6tZU7sdXxO+VTl2J9Egn61xtE9zbtCfJ3TiEaKNUJTxxj6ByM62BMrMFQCBEWERS9meqfcjx/k1KMBqN+ItR5J6MybtEhQI4BVBUXDOYN0TJaNeOCcmYMNvCWfW5tb7FQKnImiyNqblHGKOrqqvDJyW04f2wrYmNjsXr1aqxYsSKseYKCIODSpUv429/+hv3792PgwIF4+eWXMWPGTN3V6bVcotI2jiMgxARCuF8tCVJK0dLSgtOnT2Pjxo04ceKkKHpZ+7T7Z5c9s+L5kvFj726NjY0V5a1OGdZW2QuUgy8zhbqV6pFdT9yMyuTY3fUTBI7vaDfzDTV2S3lhGl9alGNqqE4mLqcNXq8JotdEGOVAqd4rBgAgAENrUwKpq8wwXS/2wmT2MltMpzc1s0HMHV7tyR1dx1IyOhHjEKjZEnAheo5ErfEv1+k0McHLsViHAD44uTLK4Ha7ecEuUAJg8r33NxQWX77V0eGsmj3j4YpJE6c0EY7AERcnOuLkbmyZmKW78wjm/tS7omDUou52WDdZ/rOmSATTo/bImycvh4ptIs9u6pymx+jVNW9oB27CRpsZkEEAojc41QrnRaQKlT7LC5MRoAS9t1NLRaoXXdENxegNygFAANrb2kyUisRsjQXHR+P2M7g7G1B6eSfKz2xBSrwFzz77LFasWBFWxhiPx4OLFy/ir3/9K7777jsMHjwYr776GqZNmwaHw6FbjjJ3qHKbtKzSr3XyvCAIqKysxNdff43Nmzez8rJyITk5reHpp5YUP/b4vIrBg9RZYoBAp5d/GwHAAjLVG7H4jOyjFTXnlL8Ibo60tVgst0oTrUWn+/G3SrP5tuY4CG4LEb2mbqvPOAioyBMq8vB6zHADpKPVYW5tSDTfutbfcuYHp5gzuEoYPr5CGDi8CfHJbmqzKeKnaovPV6iscxYEjmustVsunsghHU6r5+4Hrov9c4NmJiEcgT3GLnLENwgZPmyk8z9f/T+FFBSpyalCYAxXdjmSi5IjqgG3Vk314I/2SrE/LW+UelX5f9bUCPmZe8URy8AA0sxDvNUbblGgF4mQEMIKClgdb2F1hJBcMFilN0rrbYlUUqvbBlTfdQlNZ7vC+tPqI7SCJxqKmm5+7homdjhbedFLObMjBhzp6e1n8HQ241bB5yj5+QMk2EUsW7YCK1asQFpammHicbvdOHfuHN544w0cOXIEQ4cOxW9/+zvcf//9iI2NDZvApP19k+dFEMKB5yNQSv2LgjGGjo4OFBUVYfPmzdi3bx9ta213jRo57vYzK164MvneaY2pqeke7TsiqUL97k95NClw1Qgj99WIVei3MAOUoaJIOGez2VRenGy99ONA082SHK6jzUEEjwVUjO6DZYwQwWOB4LHwro4YvqUpwVxeNNCbnlPnGX3PdWHYmDokpLnUhChBPqgmnU6T+cbVRMuxb0aZKstzCGWEWW0CTUguY/EJnmDV6JczwAX4SNFmtdH+/QcaXPpH+YTkw5pQCBwCyaPE/ikS0r6BBCvfN5jlaRxaxKZlc2j9Hi0QjnRy4KrtOfaWKBfdjV61CEePhnC1jr9BQEcwID3YvhFZgEGesdYY2GiXIY/AcOoD1SIfdb8E1fauv4QDIAIet4dnTCScydrjZNtejxMVxV+h9Oz7EFzNmDl3BZYsW4XMzMywSPD06dP4y1/+gqNHj2LEiBH43e9+h8mTp+imTAsG+f6UigAYeJ7vIsJ/f4tQFEU0NDTghx9+wIYNG3DhwkXRbLa0PPbYvJIlC1aWjxp1V1tMjI1qtUat2KBfJgEYIrQI1dn+ZizXhFKQzk6TqbI8znLu6CBLScFArq0pAYLHQsK3/sIHpRw8LhvxuK0mZ7vDVH07w3vpVJ0nb2K5MDK/hialuWA2d98UeYW49laz+dKPWdZTB/O4usp04vFYAMB68eQIMWdwozB6Ql0wF6mW4jM01BldtGmEC3iaWlMhWEA3Aui3GnkdelMgEx16DQ+MsRYB9IYd0LHEe45eXw6c41EOyjVQRtMk9WhUVKBagQAZjJCgZtxPD2qGDKVPkP2VX6/L4zUzBsLzVhASORGKQgeqru1H6ZmNcLVVYUDeAgy7ZzUSknNAiLGe0O124+eff8b//M//4Pjx4xg1ahR+97vf4b77JiMmJlKRsu9qJeUox/FhLe30rwppbuD169exY8cOfPrpp6ymqtaTnTOgdvHCZ4oemv1YTf/+g1z+BXTl3aWk+/P/DVTdBWo31eX4/hiNCfpbvlaomxNFwjfX2ywXTuRYLv04lK+rTOMEtzVU3K93wAjxesxo88SbO9tj+LqqNMvVC5Weu6eVikPyGsS4BI8kqmEAuJZGq/XnQwMtZ46O5ppqkyGKvn6O40V0OGPMlTcSvQNHNIeyCtUI5gDyQe3M9m2TXQf8w5pAwvIfq9e5GRXE9IwM1c5WLarVO2PUwUBBWANnFst7yy0K9DIREkJYAWO15nqxhiMklzHY1PuEfQNlQ5LuhshUL3HXXyOCGN3tWu5Q+fZg0HOlMkD0urpzbEYKKnpQU34Ypac3oq3hGvqNfAqDJzwPEjMY7S4eGQbKUJNgXl4efv/7P2DSpEmw2yPPdsO6uyOfdcjzPDiO/FvPH6SUorW1FWfOnMHGjRtx/Phx6nELzimTHyhftuy5a3ffNbHFnys02Pg+WKuMtiI08Fzd6/55PLz5+tUE2+nDQ8ylBbmcs9UB0dsrfYW6XTDG0J2GiEhC0+7fCbyCmWtrjidlTjtfV5nmHTam3DVxdhnN6t/OTFaRa2u22E4eGGQ++8MYrqUxCVTkQAijZosgZvSvEsdMKhHGTKxisY6w1YfKOy0teOvvkDjFd734oPx7Vzyx65s0FJI7weW/h+fyjL5LVF0D+Vl6681mYB0m8LftGfbGXjoFgDtgEY4GhBKRL6eEjgCQpf69JzdQPT422q3o7qMVSDQ6x0IGwnU1GCr7Lh3DfIxIeFNEZMioF01VZ1F+bisaq84hc+hDGDzhecSnDkenx4S2jtBleDyebnfo8ePHMWbMWPzhD3/AxIkTYbMFjFUigiSOoZRCFEXwPP9vSYaSIOaLL77A1q1b2fXrN7yJicmNSxYtKXr8sacrhw0Z4TSbrQzwW3b+7k/LfvBHh/wOtGCKULlKS65vVu2iQmAz9kUFibPdbLn4Y5bt9JERpppbmcTjskUgggkOKe2eKIKKIjizGRzPg4oiqNsNr9sNMAa+qy1yPA/ObAbp9ix0xRGb6lLMF3+M4atup7omTLvqHTSiwXT550zTz0fyuLamJDDKMY4XWVxCq3f0PVc94+67JebktlJ7rFe/ckahlSRbstD8Nnxwdag/7hfoUtU79s44JfXOolbq9ubbzBEwykgjBUrRi25R4A4QISGEXatipRzhahloBtC92LsxaJmMQQqIMETiQ7DAYlh+1C4SlJVHVCEyot5gAIxRtDVeQ/m5D1F7/QhS+9+HIROeR2LmWHCcBc5OoLUzeBmCIODMmTN44403cOzYMeTl5eF3v/ttVEnQX19fZhlKOZhM/16qUUopOjo6cOHCBWzatAmHDx+m7W1O15jR428tX7q2+N7J0xvTU1M9XPe6WMoJ8uru0j8rzLdNPtNM29ehWavATQHt1T8d3vdzV0OljJCGWlvM6UODLJd+HM411qWQXrACJQJkoghREEC9XpgJAWUMXpcL1OMBE319nuh2g3AcCM8HWiKMAZQS0uGM4SrK+tta6hLF5Kw6rvp2CtfenAiOcMxsFVhW/yrXPTOKPCPuqmWJqa5QUyc0agy/AMbvKOQCKEH7OOPuTPWxWui92J/W2dXueS2HrVqaE01QMJEjpMblar/uICm9euG9ToQAcPsKmvqNwS1Q5AKIj8gVCnQ/CS1fvdZnPYTkNLU1qBGaCRizSYIY2tUw1H4NCkVLol4BjOl1aBpgDJ1tFSg/txUVxV8hLnU4cvNXI7XfJPC8DQxAWyfQ6tQvwuv14ty5c3jzzTfx/fffY+TIkXjttdcwadK9USdBAIr0av9O8Hq9qKmpkaZF4NrVa6LdHtu8YP7y4vnzlt8YOWK0079ihDq4LG8Gks0gF8MEczlobQ/HNUq1jxDcnPlWabzt1MGh5msXh3DOVgeo2DMlVxAwxkBFEQQAbzYDXSTo7fC5MwghANclNaEUzOsFZMnd4SNB30dCQESviW9pSuSc7bEQBDM4jsBmdXuHjCkV7p1d7MnNa2J2e1hWoP8pSHIl+XYi6z8Co7nKz9rOQz3NQnBEXwijpwoNIcLv3k/+N/ogzZR4yw6eOxikV4sO7ggRzpgB8VoDSijBaI4hDmGbQsojIomKqMfSAbFArZ10TqbZFNUkKGdaWRkms5USQkCZV7twTTB4XM24cfET3CrYCas9FYPzVyNz8GzwsoV9O11Ai9O3Wr3WuoQXLlzAW2+9hYMHD2L48BF49dXXMHny5B7FBEPWvMsNRqlvMd5/ZTDG0NnZicLCQrz//vvYv38/a25udg8dMqrymaXPFU2ZOqMhJ2uASykOChaxlqJBagSz/HoWF/TXoKsMl4u3Fp1Jt506ONJUUZpDXC470HuKUEIIOJMv1Z5EhtTrhbezE9LSKYwxEMZ8ZMgYGKUApWAc57MmGfMJsBgD9fr4jeN5QryCBTzHWExchzAi/4pn0qwSb/8hrUymLDUKtQhGuV1yaeqtEiHt47MIuRBWoHw1+dDoHRIMRa93xhaVgYERymo5nr+6aNGiSBu8YdwRIiSEsAvV7KaNsEpCSD/GDCzNZGBIYtQFGlQ8o57+YKCfUYSsZRZi9/Yg5ZjNJkoIYVR0G7YIRa8Lt4t248bFbWCMYuD45cgZ8QTMtgTlfhRo6/D9S46XbRdFFBYWYv369di/fz+GDBmCV155BVOnToXd3hspbH2QL8VEKf2XXoNQyhN64MABvP/++7h8uUA08+a2Jx5bcG3h08+Ujxkzvs2XISYQytigBMnRpiWSB/TjfAYbqQoB7wBlxNTWajb/dHCQ9cKJ4aaG6lR4PdHL+RcEksXHPB54XS6fKKZrwASgmxClv5zJBNJFgmLX/sxkAvN6IXo83fFEU2wsY2mZTs/YyZc9Y+8rFzP6tYfvClVC+4noL5Ok/h62TuEOQm2rarlC9ezd3gYhrI2ClcfmxNT0plpUwh0hQgDYnYHOFbV8CRiGADRANKN513UuP5KGE0CCWv0PRVj9jJZLQVG+BswmMyWEMEZFQy5DRr2oLf8eNy5uh6u9FoPzV2Pg2CWwxqRp7t/WATQ7gaQ4X19CKUVxcTE2bdqEPXv2YNCgQVi3bh0eeOABxMbGapYRTfgX4f3XnELBGIPL5UJBQQE+/PBD7N+/n9XV1XsGDx5etXTRqisPTHuwbsCA3E6/IlRCoLXX3aQp9bvOA0ZicuhNidBoXFo8GkCeXf8Lbs5cUR5v+/HAUHPJpVzS1hLfm65QLXTF+MBEEYTnfUKYLsUoA3xCGkJAukQ08HhABQFUEMCZzQAhED0eHxECgMnESFKa0ztx5iXPuCllYkJqB7hwOlAtPaTcBeqLCwbe+eDzuPRset9voa3FaMKIElRNjr02LSIYGBg4rpp53EUAoiBsCo07RoSvE0KXVbJrhMc4ABlQ85nBu637rofYP6xuWIfEJBUo46QOLXyXgcVioYRwTPS6wWiIZ8woWuoKcP3CVjRVnUfOyKcwYNxS2ONzuqXlarR1AE1tQG6mjwTLysqwZcsWfPbZZ8jJycGLL76EWbNmw+FwhFHr8CGRvOTG+le0BqWFc7/55hts3boVBQUFlONMrY89+nTJogXPlI/Nu7s1Li5OVI6glNCMv3DByC9C6EimJfqjvgsipvZWs/XC8RzLxePDTDUVGcTdGX1VqBbkFh987lBGKXirtdu9STgOhOO6f6NeL4goApSCSkSJLne7IPhENYyBs1gY6TeoU7h3RoEQEQkCaulSYIektuv13nzjPcKdHBrqiV2kz+rt0Y9GGgfhWAcT2Y34wfE374Q1CNxBIgSA4VloulaLMkK4gYzRFL1JKFqrxwPGpkeooyu6lqBaDar+rD6Y6jQKTlZ9CgQbQxEC2GwxXo7jmCh0hCBChs72apSf24rq0oNIzpmIQeNXID51hO5EfAY/ETLGUFFRgR07dmDbtm1ISkrCypXP4uGHH0ZcXFyQ80YP/tXpmR5v/yIhWYGXLl3C5s2b8e2337L6+gbP0MEjqhYvWtllBQ7u9McCtYZnnMKeAALjMaFvic6UCEPHyDeJxOQRONPV86nWM98PNVeUZnPtrXG9NTdQDUYpRLcboscDjufBWyxgXi+o1wveYgFnMkEUBHAWC3izGUJ7uy8uCHTHDCH6vc5MEHwiGsZA7HbwQ4a5xEkzC4S7ppVGRoI++Kc7aM0FlKBlO8nlT0phjVSG/LvWcb0NLUtPXQstN+g/xRoEqmEWCwCElfCgJ7ijRAiAur24YjdjBGNIBkA0Z2fKEG4cEAhiKWqRXDBhjERyahKkavKTQ2uuh7SNgyMuzstzHHW5W0FF/Tm9oteFm5c/xe0re2CPy8Kgu55BSr97wfHBwzitTqCxjaGurh67du3C5s2bYTab/3/23uw5jutOF/zOyaUqawGqABR2kAQI7hS1kBQpipJISZRlUYtl2VZ7un3t2bofZv6FjlE/zNONmCVibtyZe+94ouPanpFvu912y3LbbkqyRIr7TnADQew7UKh9yeWcecjKqqyqLKAAglgofBFAZeVWJzNPnu/8dnz44Yd47733UFtbO+/xy4+VU/0sBxhjmJiYwCeffIKf//znuH37NpMlV/Tdt7/X+8F3fji4Jy8FAvPpI0npLAoFJ/zFOchUJkBn+5XlEMMAxglUjbr6bwflq192icN9rTQWrjXTja2AFJgDZ8xUY2az4DnvT9OpLCf95SQ7MAamaWUmA24Y5v62SieEEFCfH+K2bSrf98IDbd+LfUZtKLlYEiwfJwr+uyVXUbS9fLmwj/WUy/2FK51veR1g7Gdf6jlWRSUKgFCSopT2KYYysFLSILDCRJhLxD1JQnhICTYxjtpKd3wxc+AKLgbzn7RKhi0KhUBBPVo9ii+uNlCnUipwLRkFM5wnPJwz8MU9SQAAIABJREFUTPadwnDPr8C0NDYf+O/R0n0CorywOlPVgZHxOH55+5/xH/7Df4SmafiLv/ghPvzwL1BfX7fYxi8r7FUp1hosKfDKlSv4+7//e5w6dQqzs+Hsjm27R7/33b+8//Irr09vau+0SYHlJGgNoSb128upwuEYp864NDUpK/nGDIMIqirI9683yLcubBLH+ptpNByAmnGtSI5Q5LQBjJkqUcYKf4YBzhioKIJRmneWIYTA0LT8/rYT5bPNcKvfiCKEhhCErd0637p7KLvn+fs82BRfqiToZJktd19yigEsH7xKZfiFzTfLO9bPR2CVSLLcMro6JGjaBtkY5fQW2lFlkvPlwUpLhNi9G1rvFO4Sju0AagCQUlVo6Vx6sbr0stCIKsMiHJFrAFmwIZWUD4V1lFLeUNeoiqLI1PQUDEci5IjP3MXAjV8gOtWDTXs/RPvO9+BSGqpqrqal8efP/wUPz/97zM2F8d3vfoAf/ehHaG5uxmp0b3Oiz6DrOkyPeJIvy7RWwBjD8PAwfvWrX+Ef/uEfcP/efeZ2eyLfff+Hve+/++Hgrp1Px/3+0tI75T2Ulwyf5qCykNphofXOKO6KDDA4EcEgDPfWivdvNskDd1qEmak6kor7iJaVVzpHqOUZChshAsjb/qgsg4iiKd2ZB5j7GuWOt4SQwtvl8ULavBlCa7vBWzdNZnYcvM1CHXOsChI0n0Sxawgrel+LozkrSYtOZFhQiZqlmIqPX3lr23yS4Xxv3mq+lQQ8wQze6zJcgyspDQKrQISEEN7by0epnz7ghLUxjpoKvnJly9XAMTwCqJ4EHQivKCyiDJXmUPbOb+5DCEFjY0tWlETD0FMw9DQ4Z0UelVomioEbv8BU/xeobzuITXu/D2+ws1gsrQDOdEwPnMa9M/8RamQIJ09+Gz/5yU/Q3t6+asTDOYdhMBBi5OII1w4Bcs6RSCTw1Vdf4Wc/+xm+/vprxCLxzK5dTw1/8P4Pe19+6bWZjrbNGZQlDS/o1S2pr7De/uStinELSXxLJ0FhdlJx9fWEpJG+oDA1WifE5vzIJDw0nVKgayJW+obnvD6BHBkSYtoFcwkbjFzmGJaT/uwSn3WMPYyCmysBSYbY1AShvQNCXT3jwdBctuvpW3rzlhkuCFXfwGLPT7uDjJNcVAmV7YJO21eaBO1T8rXzti0ADs4JHZJEfh0dyK70z684EQJAdzfUoShuqxl0U8BvN7lVS4JVEWS5fsMZ9l5sV4NWPMD+olTSqDu/TL6aGsPt9mgE4Go6QpiRhSCaAe2cM4ze+wRjdz+B6PJj81N/gfq2AwvaBc2DGcJjl/Hwyn9CbOoqXj32In7845+gq6tr1as/WDadtVSg1zAM3Lt3Dx9//DE++eQTPHzYb9QF62c+/MG/eXDyrfdH9ux+Nu7xeCoMsKVOMqVDa6kP4jJ5hjqcjUiKIamJoDzSu41OjNRAU1dttmHZArlhQJAkcEEAU1XTK9QiOms/TTMHakLyji95jyp7/xAE0Lo6iG0dEBpCID4fh+KNq5t29Oht3eNclqtyry+v6THfsFD6TjspE4u9SItdola/f1so9f6sFCax6qCYJQS33c3usZWWBoFVIkJCCP/8cz62aSfv5ZS0gaNm4aMKqGpYX4wEWPLdEr5K7YMFlKpTnLqT0zoOSZJZTU0gLYiink1OSoaWMomQc0Qnb2K451dIxobRfeCv0bT1BERXNbeGIzZzHwPX/jOm+j/Hwef24sc//gn27NmzZrK5mOPc6pMg5xwzMzP405/+hI8//hiXLl3i2ayWPPT80cF33/7+wxcOvRRubm7Llk8eyvUW1ZFe6SxruUjRPI/h9Wrpbc8MklRSkcG6ycSYB9qKOds5glAKCAJg8xa1wAFT0tN1c4C2O8bYyVAQQANBiK1tEOobQPx+EEniXFYSavuOW2rH7iFD8S58obmJcCUVKDBf0Eul8bhUHVp6jmrG8cevLnW6inKDzeqDgmvg5CFX9ZuEuFel864KEQLAsWPIDkwIPQZnXQD20EU8l6XYDReCPU8ot9sFgXk82EvnWhyVZ5Mk958jWNeQkSTJSMcnJF1LQVbqoWtJDN36JWZHzqGh/TDadrwNxd9cVdvT8XEM9fwSI3f/CTu62/FXf/WXOHToEFwu12Jvw2OBVYFC03RQWqhWb0mKK0GOnHNks1lcuXIFH3/8MU6dOoWRkVGto33zxJtvvNt34rWTEzt27Em43UqVTGVZgqxEW9UctnySIbV+UyDcaGqPZA6+2sP8vrT77pWdZGSoBokEAVtkwv58qAspkspKnZyYYZhERqkZ3J4DoRSCJJnbDQNMVWHkvEAJpYDNVgjGCoOy9XucA5IEoa4eQlMThGC9RYAApZxL7oTWuq0nu2nPgOGtqc6ZIj9QFCy25e9ntaRUID+nGiKLw+MlwTUr+ZWCgDNGxinYdW+nd2a1mrFqREgI4Zzzsf4pepdw1sqBeV0aFyS+xfRGe+iEzb2raLZkjwmc1zZo/54/umTZ7m1G0NjYlJRlWU8nxqGrqZyX6L9i4sEfIUhedOz9PgJN+0Dowo9HVxMY6/09hm5+jJYGBd///vfx2muvP/aA+cXCyOWINOsTyuCcQ9d1W83CxxdwbyUW+M1vfoNPPvkEPT09XBTlyBuvv91/8q3vDu5/7oVIqKFec+5l9rhAE3aLULmz/eNVQ+dDI0DBbKESWjAU5/uO3oe/LuWqubKbjg40YGZa4Kmkmb0lF6xeCZZak+k6BEnKlz1iuQoRVvYXngtxYLoOKkkF71AUE6WVBYYbhrPK015zUBBAFS9ofR2EhhBoTS2I12sSoEmSjMtKPNu6/ba6Zc9Doya46FhBe7V45xyhiydD87wrGxhfCU5WyTVLfjYQkCRn7E4qk7rnJc4pClcCq0aEAEAIUe8N89uSRDs5ZwHH/ollJkGHY8vcXPLTvGoN5uW2h0KTimeflAAtze0pSXTpmfgEDC2BdGwUQ7d/hXi4D53P/BhNW16B6Fo46N10jvkSA9d+BkWI4t13f4D33nsPdXWrGybhBNNpxgDAoesCCAEMgwGwKtkv/3DCOUc4HMZnn32GX//61zh79iyPRWOZ7Tv2jr75xtv9x19+Y6q7e2fKrBpfuRMVhz/M75G36PicKlAgP+TIj5atBwDmDaZTW58Z1L2BtMt/Zac0PtDGpiZcbHICJKuCikKejEjJxMNKfM00DUySICkKiCjm05gRQQBBThpkzJTkZdkk0EwGhq6DEpInW2s/AOXeoDkJkLjdoIEgaH0DhNoAqMcD4vGYatUcOCGMK/6w2r7jttqxc8jw1abnI8H5rLJWSrPi7DCVZCcniY/nSXQ5ldzVYj6qrmTRLHfZWzugBIxw9KtEvdawoyGxmm1ZVSIEgPgkpkId6DE42ghQpAtctC2wmn1psQ3QQlEnqfqc8ykgeNFLmV+mlHds6krIsqzH4mPQsnHMDl/A7PA5+Ou3o3X7t6HUtC/805xjbuI6+m/8HJm523jrzdfw/e//AG1tbatuh5sPjDFomlZUtd7yml2uOEO7GvQf//EfcerUKQwODOqNjS3T3/vgvf4Tr58c3bdvf6zWX1shML4Au8dn8VN2zjxpu9JHugYLtGiJObSyoNpgAKAoanbT9jEo3jQPhiKi7/5WWhus4bEIMaIRIB4HycXxEYtwrBqBup6X8AxVBc3Z7AghYDk7Xz4UIpcDVLAX1dX1osB3AHkpEoAp+Xl8oIFa0NoAqN8Popjkl5f+ii5N0Jg/MJnt2HVXb9s2anh8VXkTFk9CgXLv0FI6qaxAdH6K5jlWUxJ0MsqUuvChZHnNjQoEkzrj12s31Y6shoOMHatOhAcOEO3OCL8rUr6FEhIE4Kp6CFmkWSbfYXIOMcQ2rau+kzjNq4pfrmIn+txQao4QoBCwfduOpOJxa5MzYwiPXsZk/+dQ0xF0PfffItDyDKggYX5wJKNDGLr1S0z3f4bnn9uNDz/8AbZt27amSRAwx1BTTUpzWrFcSR7GwTnLxRpauUkXf35LDfrJJ5/g008/xfXr15lApNhLL70++MbrJ4ePHH5lttgZplIEK4q2c0cZ4PHIBZWdnZ3bZu5va4cgMK1506zh8WVcNfURebS3m85ONPNEXEY6BZJOgWSyQCYNqFkwTcvb8qgggAqCWemBcwgul1kYV1VNG6AsA5zD0DSzEkTO/idIMoycE4xpExRAXC5QjwJ4vCA+H6jHB+J2gyiK+elEfgBACOeClNHqWgb0TTseaE2d02xe79BKso5dHWrZ9Uqd2yp5fJfDKR/QamC+K61k/VwbLS+AEJIknPVwovUQoqyudxfWABECwM42zD2cFG4wztoIQRce03PjuXGEAEXjl3NHqf4FcfbLIsW2CNu0rLW1I1NbW5fmRp8xfPsfhVR0CMHW59DYeQxuT/2C16Fl4xi79wlG7/wTtrTX44MPPsCBAwchSQsR6NpAcVkmgDEDhmHAMFjejihJEgShershYwzT09M4deoUPv30U5w9e5ZHItHM9u5dYydee2vg2CtvTG7fvicpSVLJQ6wUIwibxGcNgY+PDO20bClB7TbA8gB+m0rUoQ0MAGrqklm3b8DwB2PyWN8mcXqkk6QTtURTKVQV0FRAVYFkEjQWBU8kzO+cgeQywTDNTIANSs2JnCSZWWAYA8tJ8NTlApFkUGI6zxBFAVXcILIbcMkgsgvEJYNIMspjMovBKTW44g/rTZsfqG3bhvVgU2zhOMFSTYxTgrvS/eZbZ8K5pasquORbUInK14UkyMEIRZ9q0Cv/20//18hqNwdYI0RICGETE/xhErSHcxYCQc2yqR1K4wKZSYikRFJ0aFWl1tqWnSk0/wI6buaQXS7W0twWvy1d1yLj1wRBdKNtx9uoCe0AKiTUzh/NDEwPfIWhWx/DKyXxzjs/wokTK5dIe7lhOdEYhgHGzEHGStQtisKCjjSccySTSZw/fx6//e1v8cUXX2BwcEhvbmqZ/u53fjhw4rW3xp7e93w0EKjRKyvbS+161QS+L5fvcuE8xS431Pa9PLrW+s9s1Gmnw/yVyLKutnZP6b5AUgqEZuXJwU1CZLKdaqoHnBMwBhrQgFAjqKoCugYwZhbEzalLwRgEZhrTiSSBCAJcBjNTngkCiCgCQk7VKoogsgwiiQBdROgOIRySnDKCzUNqS+egHto8xX01mcXSTmmsoP1eOK1nC8pLpVLl6qHSvVizhOcEM0nQOOHsSm1cGf7oo49W2tTqiDVBhADQ3IxU3xhuMqBDAPaBQHB0xlvsbXOYwD96h7GrWByCbbn1Uxz53MZF5kSCzZu7YoqiaOn0jLuh4wXUtz8P2bVQQmyO2PRtDPX8F6Tn7uDtt07gvffeQ1NT0yNf0WqAcwZdZ7kEI9y2nsMwdDBmQBBESJJYRIbWvoZh4ObNm/jd736HU6dOoaenh7lcSuSVl08Mv378zZGjL74609rcll1ICqnOX9DZ/WKpQ6NTdy49k50ei4nRXLMwfRfOyGrqkllv7aARaJqTpoYmxJnRdjE600IMVQGlhBaF2vCcns2W9cV6PrRg03X0Bl0sCOGciiqrqR/TGtpH9ObN49VJgba2OgSwlKtBnTU8BTJ0bBzWggRY2oqFiG8tqkItEEJijBnXs7p6x7PHs+oqUQtrhggBwuda+HjtqHENgtBIgFZu91VYzJlYeXTQ4h1hSrHQfMw2wyQwCdD+DuZ7J4FAKN+6dWdMUTwqiICWbW/CX78NC6VRU9NzGLn7W0z1f4Z9u7fjO995H93d3WveLugEU+orX18gO1PdybkOzhkoFXLxhwSGoWNoaAinTn2GP/7xD7hw4QJXs1pq1659o8deeWPo1ePfmuzu2pkqV4NWAnXuK46dr5R2ltahCopPavtWLB2WUl+xvFf5d230V7xBEJje0BLRa+oTUl3LjDQ7NiqEx1rEeLiZqBkvAGLWJsz1XUIe34BKCOeCmGG+ukmtvnVMD7VNGvVtc/PbAgH7Uyp4f1pZY3jJk6ykNCx2M6l8N4u7D10FUnTyRrCwlgnPGVwFcEek5LK/IxBd7dbYsYaIEDhAiDY3x+9GVbRyzgIAvIvyRrdCIZbVh6Gy+pPlt1u7kcKL6NRDrfeIUuzevS/q8XizhBAote2Q5PlVm5wZmBr4EmN3/xl1foKTJ9/CwYMHIctVpF9bxzDJ0MxVqmkE09PT+OqrL/HZZ5/h7NmzfHp6Rt2yeevEi0eODb92/NvjT+21l0kqOlPus3JHIkX7lS7Pf2z1KFDefF20oAC1U2Kh11VqZVUtlGVda940q9U1R6W5tilxbnJEjEw1CLHZRpJJBAgzzE613JUqCOGcEAbZE9N9dVNGXcOUXtc6YwRbIsztrliTbP7X2e7BSYrWzdMQ2JNkF0Il7FZhB03PKhChk39rKbWXjlBrkRwpAeMM/VynF84/lCeOt6+ul2gp1hQRAkAggOjMMK5DQAsl2EsWOfqUzuqXp1OUziBJmW2BFrlnEVOkIblj8+9QoVUdHV3phobG5MBgv55JTIq6noIkVFKNcsRn72Pkzq+Rjffh5HdO4o03voVgMLgsV7eWUFqLDgAY44hGIzh//jw+++wznDlzBsPDQ3pTY8v0ybfeH3n92Fujzz//4lx9fahygcfC2VDcpawnWc3s6dFmV8U2vGIbYHEnrxyubWWUcWrJomlalnWtqSOsNbRGhERkXIxM1YqxcIAmwkGajAVINllLdc0NzgunrpYc7e7wlOpc9sR1xR/hvkBYr62f48GmsF4TSjBJXFQQNa0w5Be8Qsu35RpeYV3x/pWlvtWRBp3iA9cD8RUhV2yXieSC35AfHj9OqsoPu5JYc0SYq04xAsW4DAj1REArL5R6mx+5kWbpUmFpZE75dlq0H0BzkmCZ56hFiEX7F2KPPB4P69y6Y+727ZutsZm7YjY1C6mCjVBXkxi7/ztMD3yJfXu24+2330FnZ+e6VIkuBpxzpNNpXLlyGZ999jlOn/4K9+7dYzW+wNzLL70+euzlEyOvvPLGdGtzu0Nu0FLYO0Q50SxMho+uZihIdeY3WkLIlY4wjyoOqnCKUV0yBIEZtfUJo7Y+kVXVSTEZVYR42E9TMa+QjPlJJumjWkYhWkaBqirE0CUwQySmH3ahk1NqcCpqXBBViHKGy+4Uc3mShuJNwBeI6/5gnPlDccPl1haTGaZcQVyQAK3rrxwjWLAXFmlwUHrf1pSAAsCZ8NafOhQgAomAG5eZpvWQzUp6tdvjhDVHhACwbRvJ9s/xuzxrNBJO/ByomXcMKp/kF96OJY1dpTNFh5eLO2wnzjYJatkLbdIOIeB7du0Lf/HZ77PRqVvebHIKvmAnyro55wiPXcZ47x/gVzR8+9vfxoED+9dNqMRSYAXE9/T04Msv/4wvv/wS169f56Ioxw7sPzJ29IXjo68ef2Oyq2uHzQ5YjQ69UCwXKAyNTl6ZS1A4LgLzke18R5UH1S+7F6Ms67ociuvBUBwAaCYj0VRMIZmEm2aTbqplZaJpEjU0AQYTwBllAEAoo4JoMEnSIMoaE10qU7wZ5qlNMa8/s5hSSZWwkFK7+HvhXXQmwLXhCGNH6bTZWl5X0l8JCOEpgeEGM3C5dnPtmgiVcMKaJEIA2BJAtL9fuw6PuxFgz4CjeOS3hVNZYRFl2yui2nlVuTa+fAZutxHmFkqXbZ6kFiilePbZ5+d8/tr04PB9pOPj4Mwoyy+qpmcxdv9TxKdv4ttvvITjx19FIPDkqUQBkwA1TcOdO3dw+vRpnDlzBpcuXeKMseTO7U9NHD780uiJ106O79q5d1HJse1PrNwhxtpnoXNUwmLcmUulQPtxTmH0pVJseVTh4wZzuzXmdmsEjbHyjZwQzsyevgxEVz3sdj07nKQ9XmFKs7ZIEFj/pFcGzjUCeocwnPNs9kyudvaY+bBmiZAQwi9d4mP1Mi5xgnoQdBKH8WtpnWUxJAg4Ks6IjdwctailKZjKd+rs3JZqDLUkBgb69PhMr6htiUJWbAH1nGFm+BymB/6M1qZavP76CWzduvWJU4laBNjb24uvv/4aZ86cxoULF3g6nUl3bdk2efD5I2MnXjs59sy+/TGv18kRBqgs/jsRjN09AhWOm++cdszvvens5+lEY05eqKUBE9W2afFw8qlcEJRwDmFZBjfn6UQlu16pm4iDXTm/HSh4mFYId1pjpPgkvN2UwOAcfYxrX3s2+YYJISs4UVo81iwRAmb6tZ4p/sCl0jpKmB9AKL+x8iizCDi9aM4GdZrbNe8VyotnnwwwQybyLtyFYyu9aG63m+3YsWu2p+dq69zENX86PlFEhNnUDMYf/AGZ6EMce/M7OHToEBRFWcJ1rk1YFSj6+vpw/vw5fPXVaZw/f44nEslsR0fn1P5nnx977dibYwcOvBgJBAKPYGAvJsNi+X4+VN+pyuPYnPcpnJfa1jp5p5YHyT8uAixVxa0GSu/dfFJc5QmmdTVOV1F8pYUnsLZI8IkAB+fggwa007GRWJ9/k78KJ7bVxZomQgDY00gSveP8JkDrKGdHGIPXvp0DWPxco5JqtHheXBg+K8wacw4xJgku/PKVWgEIEfnBgy9NnTr1aWp27Ko/HRtDbWh3Tto0pcHZkQvoaA/h6NGX0N5eRTLudQBLAnz48CEuXbqI06fP4Ny5szw6F8u2tW+efuWlNyeOHXtj7OgLr8zW1AT0+R1hSkmlgGKfQvtn6fZHh52sqE2+KQ+EL5X4yq/NyhdD80uPD6WeiKsnjZR4YcPMElOdKrP8/Sy2Azo50KwNrD159BHBwcHZGOP0TI2r5nbtkdo16RxTijVPhADQ3YyZgQlcYqB1lLB9vNReuGjMF1xRbGTPS3fEtp1bUmH5OcsT89q7esnLSoH9+5+PNDW1xscmrjbEw71Cw6bDEGU/NDWOyf7PkY724+WT38Uzzzyz7h1kOOdQVRV9fX24dOkizp49i3PnzvFweE5tbemYOfzm8fHjr5wYO3rk+GwwWK8trTRTgTgKWSdXDsXencUenpXUtMXH28Ec1q0MVto7sVhJbQXI21sDVFZtlu7nFE6x9rHuVaIEHATTxBDOanrqJtmsJFe7SdViXRAhIYRf4nw0OKKeBRH9ALqxzONDkTqGA5TY3K2dPSzyO5cr3pyiGZ1fyoaGRm3btp2zd+/dagmPXfY2b30d/jofopO3EBm/hubGGhw6dBitra2PdH2rCcsL9MGDB7h06RLOnv0a586d45FILNvS3Bp+4/UXJ1556cTYK6+8MV1ftxABlnp6VnZWedwk6KSdtys0S0MeCnvav7ESGbFchnxcqBSQvZooLXpbiQQLsbwF+z1QSXns5I+5elgr93q5QTifI4xfMATjSt3mujWVOWYhrAsiBMysM8PD/EEGuk8SqIdztKEsw+58AbWlsBvPi2OM8kNsxRFivhdqcS8bIZQf2H9k+quv/jUVHr3kTUYG4QtswfTgaSTCfXj1raPYs2cPRHHdPKo8GGNIp9Po7b2PK1eu5gjwPE8kEpnWlvbZQwdfmTz64vGJYy+fmK6vb9DMArkLwU45pYRZGA4XGhofB5wC5p39POeT9Iq3PU5pcL753UoP1uXThfnpmRW9v6Wwp19DhX1WHk8qAQIAAY9w4BIMfsG/yR9e7fYsFutqdO3oIOnZWd4TzcIvgB1jQEnNosWEnFpeoMV2CYAUv19W+IM9FAKlOQ2dBqzquj2lFAeffzHc2NgSm7h5sy42fUfw1G5CZPIGZJrGs88+i46O9nXlKcoYQywWw507d3D16hWcO3cOly5dZplMJtPWunn26IuvTb589MTY0aPHZ+urUoHOF+9nbS98Jw7r5sfSvK2cIxeZjcTm8w51auFCnq/Lg9WUj0qlaKBAasUKZcDZjWc+crSff21Z30rvuVOg/FqSzBcDDh4TCC4zmZ3xtnun1nKYRCWsKyIEgPp6Ehsf51eznPsJIYc5R03xHtV2pYL0V5AfSo7N9VArfZpFms7eZkv3v2ttbc/u3r1vuvfB3aaZ4XM+EIJkZBBbtnSgu7sbiuKp+lyrBauU0szMDG7fvo1r167izJkzuHbtOgNIqqNtc3jvU89MHjv2rbGjh6txginFfCQ43xSoVD05fwaXxWB+z1Dnayu0pqAULahQF4pXXB4yXIzeZLnhFDVpqTlpmbtOaaiE/RNF+zlHi64NzEeCdieltdXq6sA5j1PgCncrp70NWNOxgvNh3REhADQ3Y2ZkRDjHBEMhnOxn4J7qVKFAqS9hEamVjqTcJlsQOMQGLgXlXZ4Qyl9++fXxr7/+YvP46AWflokik5jAziOH0NbW9si/+DhheoCqGBkZxZ07t3HlyhWcOXMGd+/eNRTFG+/q3B7et/eZqePH3xw7dPDFOa/Xb1RPgE4yVympWQ4xThLgQgS4NFCH3yqsqaS6Zfkjy9uzUBzj41HvrhQJzifnFpYrTWWK31u7DbESday2R+hC1G2/yvUcQE/AY4SwqxT0S+XfYYJ8tD5JEFinREgI4Zzz8YEJ4TSnhkI5eYpzuBY+Eiifg+Uy0fPcy2gly67s7Gm1wmFDNfM6B1duSnHw4NG5TZs654aGv6gPZxIyNzLo7NyCUKhxTapFGWNIJBJ4+PAh7ty5g4sXL+L8+XN8aGhYD9QGY0/t3T+7/7lDE68df3N89659CUXxLIIAy2HeWecwiOLhsXTbcpOI/XdK5b9S5V6ltljONPPhUe+V8/rVQPkT4DYtTCVasL7zkuOK4Rwws7Lj8Xz3e+2H7y8NBDzGKS5T2ftnpWF9kyCwTokQAAgh7HPOR7pHhC8MCplztosQ57AKS+1Z7FJdrCCi9plnSUxgweazEDsuvS/4/TXG/mcPT/TcutYyMTkhy7KExsamNVV53or/m5qaQl9fH27duoVz587iypUrLJlMZxu96h6ZAAAgAElEQVTqG6OHn38pfPjwS2OvH39rcsuWrSmXy/UIL0gl5WOBUOxO9ysRKuHsCboQAQJ28nMKlUfZupUN+1hJFAe1lEqCpRKgZZIo9s6uHI25eiToRMNrwRFpuUHAo5TgEtf4V55WTKxXdagd65YIAeA4ITrnfGBwUP2MCKJICLYtHGNInF+cnOqz4ERjfwmrwWL6Qvm8UBBE/tLLr0/94U//HJ2anqh1uWTq83kXjB0k5by9bCCEgHOec36JYnBwCPfv38e1a1dx4cIF3L/fa7hc7mRzU1vkyKFdM0ePHh9/+ejrM42NjaogVFsU18JCzi0Mdhm+rK2L+7FHwMJxgKxkjWkNLB66zTAJpyF9ebHag27xtKVAeOXEVU4fhWPNbeXpEIq9vFeDBL9pIOBhClxiKjvt7VyfjjFOWNdECACEEK2nh/fJPvyrKDDKObpJ/roKLxC1qWLKg97zZytyu2ZFxxfO9+jguV8rPuPOXXsTu3fune7vv98IcA9gkpFFSACK6vWZGtPHo2whhCCbzWB4eAQPHz7E7ds9uHDhAq5evcrj8YRaV9cQ27vn2bmnn94/9drxN8f37dsf8yreR1J/5n8b89tVqvOuezTnkmIr5EJnKuzN8pJhsWRXKiuuRFjE6qN4YskwX85PC9WpN4tthauPSv1xvXqCloGDA2yGCTjPiHHW3+6ffVJIEHgCiBAA9uwhKue89+GITgUiUgZ0CYBY/KLYuqQ9JAK55dwmizStHRc3YC2elOwviUtysdffeHfk8tXzbf39vZ5weA6ZTAYej+k1apGgRY6W6ZAxOBa0XSw458hkMpicnMTo6CgePuzD5cuXceH8BQwND+leT00y1NgU2//ci+HDz780cfz4G1MdbZszgiDwRyPASsotuwLNHiNooZSiHk21WElZOf8a5xhBp2NYESk67LeYiI8cSnuck+/ySg/ExZfgRIbAQha0Sj7ClX9n9bCwZXOdkyEHB8ckIfyMrmoXgp3BNVtOaal4IogQAAgham8vvy+7VYCIJwhBF+VEYkCudiAH8hOYUocZM0bQtF04v4zL2tbCr+a/AwChFEcOvxJuaWmL9vf3NvX09AijoyPo7t5Weq0QBCFPiIwZMAwDjPGifYBSCZKULTPGkEwmMTU1hbGxMTx8+BDXr1/DpUuX8fBhHxMEKV0XrE/sf+ZQ5NlnDk2+/PJrk08/vT/mcpvOL8tzj5yIpGBzK3iFlg4oyxtzt1RpzSkjaLEEyMrWVzjRklBqZVuc5LwSsCu0K7XKuaXF9n3r+LUFpytysh2uR1ACg3GMgehfplO+q6GdJL7abXoceGKIEDAL+vb08Hs+HwyDsG8Rgq0ApHz4gwUCmORXIEOa/zThPCYtzSttMRGGikdh+/Y9N3379o3Wr78+U3vw4EE0NTWhpqa2TOqjlILmghwNgwHgNmnRVKfapUhLatM0DdFoFNPT05iYGEdfXx9u3LiJa9eu4cGDXkMUpUygNpjasX1vfPv23bMvH3l1/MiLx2cDwaAuEMqxJAJcKLwhf1WY34lkod9YOpyvyYr6KyyXH8XKW+iw6+OUYJzIb7W9RAuSH1A8+bSDlKg5i/2DzfOUJ7BYbTiFSDiR4epjCWqGHCi4yjmGDPDPa4mvx7+TrIsE2kvBE0WEQEFNOjBOGeE4AbBthNlCKzhsAfJ2yW8hh3NeYR+U7OP8wlaKkiqFIIj8O+/+V8M9PTcazp79s/Lxx/+f7Ha7cPToS2hoaIAoimDMGiY4GKP574Ig5MnRDHBn+TyfsVgM0WgUc3NhTExM4P79+7hx4wZu3bqF8fEJQ3ErmdraQGrnzqfi27ftnD104KWpFw6/NNvY3Ja1qz6XToBOJGi/P3afXic1qIXlCywvPWs5nNSsparY8vMwAIw6XfXS204AcIcxbe1QA2Dv4eUJr0vfpQLsDjHFT3454naXH+vLHrj4O2gOHzzDgAcwjFO1SV8f2UPUx9C4NYMnjggB04Hm88/5g67dULmGNyjBDlCicMYJCMDs72Hue/HsFaiO+KqLIFrsYLW1e3vqex/86EEqmZSvXbvWNjX1b5WbN2/ihRdeQGtrG2pqauDzeSHLriLPTkJMVWc2m0U8nkA0GkU0GsHk5BQGBgbw4EEv7t27h+HhEcYY07zemnStvybzzDMHEtu6d4WfP3Bk6vALL882NbaoAqF58lv6nBKLOLJ46CwPhZgvNGHpcAqCKN+DVfhmBcmXJ8peLgK0wMtP6mgfXAkUe4IWE5m1roBSepj/bSieNtnlrrVF+RZWJ3LxMYKDG+BxcH5H0umpc4OXRo8fP/4ItUDXB9beBGYZ8ctfcuHIEbQw4HVQthcMPg5Oinut3XZRWIeyddXD6bWvViK0YBg6+frsn4M//9l/2nb12vn2SCTsr62tkbZt20a6urrQ3NwMv78GoijAMBg0TUM2m0UqlUQ4HMbk5CRGRkYwPj6OZDJluN3urNvl0TweJVtTU5tub9sS3bPn6dnnn39xZt9Tz8XcboWRHPk9+iy8UpzdQvvPF6yyfERo/pJd5Vl8Zlq2xvkspZ6lKxX7Z+9Lq+8MUwlO0XUFr1GLPEvLL1V//tXDkzFoOqoXGKWYYZxfQ9b4yvcz3wz5aG1Xll8uPBnPdB5wzsnkJEKqYRwn4M8wToLgILTkBV3OOd1y3VTOGKZmpuQ//P6fmk99/umm4aH+YCIRd2fVrKRpqmgYBrUy4RBCuSAITKACE0TRkGVZl2WX7nK5tWCgPrWpY3Nsa9fOyN69T0d27X4q3hAMaaAExCb5WVgMhZXDSXVY2ZPS6Vhi/1q02/KoRcuJcL6rrC5w4nHCyf63mo4Y1V9zcSstW2Dlp/j4HdUWg0p+rU8iKIjGOB8HwZmMO3E5FAo9kU4xlfCkPtcicM5JJILaRAIvMLDDILyRFpkflioBlr8qj8NjjzOGVDol9N674712/WJwcLjfPzs9qSRTcdkwDEopZbLkMmSXW/d5vVp9Q2OmraUjtWnTlmRn59ZUqKElK4gUhAimhm2RoQ7V710doRSHVJcX1CkNp15uu6BT0MXCmM/zc74wjkeHUz9aO0TopPqsNhbQkgbLCXMtoPTePgleoGXg4ABPE4IBSMJn3ib5PiEku9rNWmk8Uc90IUxMcK+uY58B/RjlpBWAvBj7RbV4fDeVwTAYAePzuvZwAKIwD+kxgNJymnGS35ZXTVqQ+IoV0Y/iKbo42FWYDOVqYLu0WIziwPjSM5a2VTcMwhkDs93r/J6ME84ZDEMj1nZBkLggCNy8N+XTKEkQOaFkhVWhpuqyWG1ZUGU6941SY0Ax7H3Nqc8Vn3P1LXBPNBlyMEIxZ8C4IxH6xfn758e/CfZAJzwRz7N6cNLbC1mW1a2EkOMA6QKIl+QD7NY6ERajVGZa6jmWB5WGxlLvUBPORPiodsDK5GkYBjE0jWhalmRVlWqqSnVmEEPTiWFoRNcNohs6MXSdGEwjusEIYwYxdEZ0QyMGY4QZOgEHmGEQxjkYN4jBGAEDGNeJbjAzMIcxaKpKVVUVKg36uqpSVc0IHBwEBB63T6ci5c7xZwSKW9FFUczrMURRYBQUlFJOKQEhAhdFykEoKCGcUAECpVwQBS4KIqdU5JIkMkEQuEAEiLLIJFHmhFLIosgkUeKiJDNZFrksu5gkSNycQ5Eiic25z81HDyUhP6hMhGtBHWrHEz04cq4BZIII5LxXdV3EFkSfpEwxi8UT/awrgXMuDA+jCTBeppQ/xRipIwR0KTPQSvablbix88+mFz728Q0+xUNdITSiVD1a7i6xEHRNI1k1Q7OZDM2oWapmVarpKlGzGZrVNGpoWapqGtVUleiMEU3TqK5rRM2khXgiISWTcTGRTEqpVErIZtNiJpMRM2pG0FWVZtSMZJ5PE7LZjKhqGtU1VdR0VTAYI5qqipxz6JpBdaZTzhnRNF1kzCCMMaLrmmBeGwEVhIpFQyiljhVFGGOOGYI4NxMjcMY4z8WKiqJkEEKYJEpMEARGCLgsyQYVKCeEMkmSmSSITBBFw+126ZIoM0mSdVmWDVl2GS6Xy3DLLkOWJMOteHSP4tEVt0f3er263+fXvB6vLrtdTBJEJooiFyWJSaJskqQkMVkUucvlZrLsYm5ZZi6Xm7ndCpMkgQuCyK2nbPaC0tAIe79bfanPCZUofd0PmBycgycJQb8G9mVy2Nvb/gIy32QSBJ6A57pUcM7JwABqJUl/DqCHuIEWQiCbARbAQiqetXDjlkMKXD4ydJrfF4iwnPBsKZgZQ8Yit2yaptNpIZNN00wmI2TVLM1m0lTNqjSrZYVEIi5GIrNyJBKRY/GonEwk5HgiLiVScTmVTMmZTErKZDNiJpOSVFUVMtmspGmqBHCBmlISqCAQQaCgVIAgUAiCQGzLoFQApSQXk0mtBAXEWrZ/UjOjASgV8invBEGA2+12JDtKKWRZhiiKRdsZY1BVFbquO5KhrutQVTUfM2qFzHDOuUWg1qd9m2EYue8cjBlgjMEwDBgGA2MGN5fN9cxg3GDmNs4YJ5TqLtmlu1wu3eVyaS7ZrXsURfV6vJrX49U8Hp/m9/tUn7dGDdQE1bpgMFsbqNU8bsWQJTdzK27DLbuZyyUxt9tjuF0Kc7nczKsohtvtZpIk5QlzPRDhugfnOiVkhhB6K8WNr+vblUlCyDdSFVqKJ/J5VwvOOQHgGh9HJ9PYy5xiK+e8hhD7fSEgNqvNfFGDKyUFLgd5PT41VHnoBDMYyWTSNJWMC+lslqZTSSGdTgrpdEZIZ9JCJp2is3Ozrrm5WddseMY1Fwm7Y9E5VzQedcfjUVciEXcnEglXOp2SOSCIokAkUYIoSRBFgQiCmPsUkFuGKIpEEASIoghZlonX64WiKPk/j8cDl8tVtM7lcsHj8cDr9UKWZUiSlP+0yE0QBLhcLoiimN8uCAIURamqbuRC+1SbM1bXdWSzWTDGkE6nYRgGVFWFqqowDCO/LZPJQNM0qKqKTCaDTCaDVCqFdDpd9t0MvzGXrU9VVfNkqes613Udhe8GN3Qdmq5xXdehazoMw+CSJGkexZP1e/1Zn78mU+P3qzW1wUywJpCpD9Zn6urqs/X1Ddlaf43mdnuYV3EbbpdiKB6PoSgK83l8ukfxMrfbteKu+86q6XUuDZpSYEqkdBhgZ5OJZE/DjobEN10KtGPdPtvlBOdc6O9Hg0s0DjFCngEQIgQS55wUaNDEQu7ry/nCzOcuslxEuDwSoekUkk4nhWQyLsTjcTGVTgjpdFJIJJJCMpkQJ6fHlenJSffUzJQnHJ5RwnOzSnQurETjUSWVTrk454Isi0SSZCJJEpFlCaIokhzh5D/9fj9qa2tRV1eHQCAAv98Pv98Pn8+X/7SWre8WgVkkZKWgq7TslJO12nUrCaeKJE7L9nV2idL6rLSsaRpSqRQSiQTi8Tji8TgSiUT+eyKRyGcsikajiEQiiEQiSKVS0HWda1qeILmma9A1nauqClVTua7rXBQk3e/zpwO1gXSgNphuqG9IN9Q1pBtDTanmpqZ0fV2D6lE8htfr072K1/D6fIbP69P9Pr/hdrkrkmSlsIdq0mM8cSBcB0iYcOOOJghnAnPuceyGtkGCxXgin/1SkIs39OhpbRsRhCMg2MIJ/JxzWjpPJLZl09lh+bHYCLzFnHfp5GcSXjKZFOLxiBiPR8VkMikkUjExFo9Lk+Nj7pGxQd/4xKh3anLSOzs37Y3MzXlS6YSbEkolWSayLOXJTpJMcpNlF6mtrUVjYwiNjY0IhUKor69HMBhEIBDIk14gEIAsyyhVUVbzt4GlwSLH0j+7Gta+jjGGVCqFSCSC2dnZXFq/OczNzSEcDmN6ehrT09OYmZlBPB6Hqqpc0zTrD5qq8aya5aqqcYFS3e/zZ+rrGhKh+lCyuakl2dbakWxvbUuG6huzfr9P93n8utfrM2r9fr2mJqDLbpk5pYRwkvQqaXmeiN7CwQklCYCNMkO/qOv6zWBXME7INyNAfrF4Ip75cuLSJS51dKBO1/G8YbCnOeeNhECmuSlUSVqax64yeRSHmPnOVw00TSOxmEV4CSEaj0pz4VlpbGzY0z/w0D86NlgzPjHuD89Ne+PxmAJAlHNkJ0sykWSJyLJMFEUhDQ0NaG5uRlNTM0KhEBoaGvJ/dXV1cLlckCQJbrc7p4osssMVJQ3fwNqGnSjtn/ZlXdeRTCYxPT2NqakpzM7OYmpqCpOTkxgbG8P4+Djm5uaQzWa5mlW5qqlcVa0/jUmSpAZrg+nG+sZ4a2trvKNtc7xry9Z4c1NzJlAT0Hx+v17rr9Fr/QHd6y3UyVwLCQkeKzg4JVwDyAwjvEcl6fN1rXWTwIYUOB+euH6wHOCc08lJKNksNlOqvUCI0AXGAyArn5t1qUToJPnNG+5u2pNoJDorRWNRcW5uVp6ZnnL19d33PxzsrRkdHa6dnBz3z83Neg1mSLIsUVl2EVmWqcslE4/HQxobG9HW1obm5ha0tragubkZzc3NqK9vyKsnC4nBaf67KIr5daIoVPSq3MCTBYsU8846ub+cPRLxeBzj4+MYHx/Pk+Po6CiGh4cxNzfH0+k0z2azPJtVuZrNMlVTmeJWMqGGxkRLc0t8U9vm2Lat26NdW7qS9cFQNlBbo9fV1mk1tQHdctR5knoZJTA4JzHOjSEq4JxH8txHCKkNKXBhPEn9YNnx+edc7O5GjQj9KYNjPydo4Zz4KFl+XxOnnJeVti/mXPMhk0nRcHhWmpublWZmZ1xDw/2ee/d6An39vcGhoYFAeG7azxgTXS5ZcLncxO12EUXxkMbGEGlv78CmTZvQ3t6OzZs3o7W1FV6vF6Io5gnO+nNSU3LO81JeqQS4gQ0AKCJG+5+maZidncXQ0BAGBwfzf0NDQ4jMRXgqneKZTIZlMlmuqqrhdrmzrU2t0c2bOiM7urZFdu3cFW1rbksH6uq0+rqQGqwpEOO6dIrJOcNQgklwejWhateaIr457Ie+IQVWh3X3zFcauTALl19EfZYZz3HC9wFoAIgCsnz3b77cKstFgpaqc3ZuRgrPzLgeDjzw3uy5Wnfn9s3Q8MhAMJ6IeSRJom63m7rdburxeGhzcxO6urrQ1bUV3d1bsXnzFgQCgbwnpSiaXpqCIFaU4ioVBCaE2LwyNwhwA9XDUq9aXqxW0vmJiQn09fXh/v37ePDgAfr6+hAOh3k6nWbpVJpnM1mDcabX1zUkuju7Z/fu2TfzzN5n5tpb2tPBQJ0Wqg+pPq/XIOthQmaqQVUGEgbnd0RGLrgF98Tf/d/IfvQNSZa9XNggwiphqUs1Da2cGwcI4TsoEOScuJaDEB81vVmlfQ1DJ/F4TJicnHANjw4oV69erLt+83Jj/8CD+rm5Wb9IBVF2yYJbcdNAIEC6u7uxa9du7Ny5E52dnairC0KS5Hy4gKXGrBbFUh4vKRhMcrbByiS6gQ0sBhY5apqWJ8fR0VHcv38fPT09uHXrFgYHB5GIJ1gmk2GZbNYQqJBtbmqN7tq+Y/r55w5NP7Vzb7SppTXbVN+oer0+Y7WvqQwcHITr4DxKRTrAmXHR6/L24XOkyA/I2mvvOsDG6LNIcM6FmRl40mlsptzYD8K3EoLa5SDESumnFjrGgt2OmEwmhMmpCXlo8KHn+o3LwXMXT7f2PrgbSqUSXll2CR6PW6irq6c7dmzHnj17sWvXLnR1dcHv90GWTccVSZKWpKq0hxdYKk87IVrSoLldhJkibKMrbuDxwCJGVVWRzWYxPT2Nu3fv4ubNm7h27Rr6+/t5LBZjmXTG0DRdb2wIRfftfnri6OGXJvbs3B1ra2nLhELNaiEBwOqBEq5zTuMcbJRTXPZ7lTuoRSIXGL/q7Vuv2Bh9lgROLl2C2NUFTyqFTsKMZznlnYQvnRCXRRHDGGKxmDg2NuS+cu1i8M9f/bHt5q1rLfFY1Odyy6LX6xXb29vJ/v378dxz+7Fjxw4EAgG4XK68inI5CMkkPZInUicizHvxbRDgBlYYVvKBbDaLbDaLsbExXL9+HRcuXMDVq1cxOTnJ0qm0buiG1tLcEn7h4JHR40dfndi1Y0+8tbk563Z7Vl7tyGFw8CSlmOAgV5HRb/m4L4puqBt2wEfHxij0CMhlphEHBiJej+TdzECfYYR0coPVUkrcjC/Mb0uRAkuPB4BkMi4MDvYrp898Hvrjn/55y4OH95oYZ26PxyNu2tRBDx8+jBdeOILt27fD6/XC7XbnY/KWC3ZHGDMDi6lSddpuX7Zv28AGVhqGYSCTySCdTiMcDuPKlSv4/PPPceXKFUxOTBqZTEb3eHzxg88eGDl54uTwoQOH5pob27IrIiFyGITwJIApcHqDwHUzTEbm2tvbv/H5QZcTG6PP8oBwzsW5h/DERbWNMDwlSuI2AAEOrnBeOeyimvCI+YLruaGTqZkp6Ysv/hj6zT//cuvdezdbOeee5uYm4cCBg+TVV49j9+49CAaD8HgUSJL82EincF6e9wa1bIqWbRAolghNz0AOM/enuW49kSNjPCfxOm9fT9eygXwYEZLJJMbGxnD27Fn8y7/8C3p6elgsFtN9ij/28osv93/vne8PPrvv2VhNTeCx5Oo0VaBIAZiCQK9Tg/VEhMhcS0tLZiMcYvmx8XYuMzjn4swMFDaHEFOMnYyT3SAsBBCFc8ggIE6lbJbiHWoYOnnw8K7nFx///ZY//el32+LxuWBHe4d4/NVXybe+9Qa6urbC5/PB5XKt2EBcIIVCMLwkmWRoOclomp4nSF3XYBgs733Kc07spaEWpbCkyqVkjlkKOVkVIAgp9ny1SN1JsuacwzBydQxp9aEhVhq0jVCS1YVhGEilUgiHw7h48SJ++9vf4vz58ywyF1E7N3eN/+X3/vLuO2++N9FQH9KW5QfNIrk6ITQJzqbA6Y1Mht1W/RsE+LixQYSPCZxzYXwcrmwWNR5Z7+IQdxmMbSKc+TklLs4hLqVskh0PHtzx/J//1/+y4/Mv/rDDrbh8r776Kn3//fexe/ce+P1+SJK0jFdUPUrDJURRAECKMo1YbTMMHYyxfLJskyyRC8kQ8nFknPMcmRYCsQlBjlCF3K/xBYmRMQ7OGThH3kmnGkI0DNNd3yI0S8I1DJaLl6R5ArPOaVaU0MAYgyxL+ZhKa0LgRHSMMWianr9vG2S4+uCcI51OY3Z2FmfOnMEvfvELXLxwUa8L1E3/1fd/1POjH/5kKPAokqHpBaoSzhNcEEa5wW9Q3bjvlbwxtCO7QYCPHyueKeWbAkKIASDFOU8PDIiRAHA7IdKQSOl2wthOLqCB68xDCJFhC9AvtRk6gQKIJ+PCP/zq55u/+OKP2+vqg/4f/ejfkHfffRehUGjVCNCCJTlZgpyu67n1BWmssM4kPpPsWP4YS/Ky4sUK6lRSVLfPtEcWkkWLouBIbAXpkkHTTCnUzG5DHUNC7FKj2UaWi1djuVASscgRqNBOnidGgBQl+wYKUqR13YVNpoORuY+RJ2p7+4tDT5xRiTjtdtlKmG+fao5/UkEIgcfjgaIoeOedd7Bt2zb89Kc/FX/96183/sNv/4vW0tySfv/tDyYKdRirPTEMMJ6lhMQoJQPM4DcZV/v9hj+JTmQ3bIArhw0ifMzIdeYMgAznPD45iTEkUheZ4monlO5knG8VgBoCKnPOZeZAivbvJhju3Lnpu3LlQjMnzP/++++TDz/8EMFg0On3qy7t86iwqzKtn7Qv22FJT1bKNZMgDDBWXinBrJ3HcsRRkCwBQNctKY/DTLEhghC7rZEX/U4hCJvlCKw4801pIukC0VnEW5AMzestELN5bgOiKIIxmidEQaD57eZ5eO7TKKphCAhW0V0YhtnOgsetWSPRlJAZLOnXuk5zoiAUTQScrsnpeVn32p7tp/hZWRLsNzuJOSEEXq8X+/btw1//9V8jHA4Lv/vd75pOn/+68eSJdyYVTxVEaEp/GgHNgPNZAnrb0NR7noB/AkGkCSHqClzKBkqwQYQriJyUmOScpwBEwmE8yMyla5kidYicbgVhm8FZLQdkzonMK6RyYwwYHx9RIrGw0tLSSvbs2YtgMOhIeitFgouFvV1Og6uVf7L0GEvatFBaVshSK9r3BwBRNInCTramatOAYdAcEcGWyovlB39BEGxkTnL7MXCuF7XBImxVNccyq/ivSVSFc5rPiRV9z9VNzGfYsQjbUhObSQ0EaGbNP9u9MyVtU1VsgDGxJHZTAFAg4WIJlOalWcPQ8+pae9Fgu52TMVKkGrbjm0SOkiRh+/bt2LVrF/7whz/I4dlpJRKdkxSPJ1vpGEq4zhhUgCQo6DAVhNvc0PoVtzuKHleGdG0UyF1NbBDhKiAnJaoA1I8+4okf/xjTKiK3a6SATyO0nRtqNxHEzeAswAGJECqBccEenxgM1qsexatOTo1iaGgIqVQKHo9n9S4KiyNdy6nGIiPLe3S+8xXUoeW/a1eVOjnZmOdmjm007X+mdJYrOJtX0zJmSoOUFk8yMpkM5ubC+Yry5r4G0ulMPqOJ+bsM2WwmL8UB5nWbBXUzOUmOwOVyQ5alvPrX/H2eT24gyxI8Hk/u+mherWst2yt15AoTAyCQJDP3q3lNPEdkhTywppTJbXZYkiPVglRduKcF6draDjjbWp9kyZExhunpaYyPj0PXdN3n96s+n6+cyDgYCFcJpWlu8GlK6T2BoDfLstM1LTWpv/s7Ud1IhbY2sEGEq4yPPiLso49M1elHH30U+/GP/6cZIHXX7w141ZTRAsY3c2AzoWgAgZszIhFCxb17no3t3rVv+mH//ebf/OY3nsbGRrz66qvw+/3rysHCbu9bCuxqwPlUf/Z15mBfWGepLU1CoZAkiwzsAzyBIBQIvLf3Pv72b/8W09PT0DQdmUwGnBdLp/PBaZ9Ce4ur5FUiFUVRIMsyXC43FMUNt9sNj4Tkk2UAABOuSURBVMcDj8cDn88HRVFyy354vd5c0WJvrmhxDbxeby7pAQEhNK8+Nj14LTuo5eDD8ipSS61cfE8LUqJFxgXv2mJv2/UMVVUxMTGBn/3sZzj1r6dYW3Pb7IGnD8x4PF4GWBUguAbQLAgPc4aHhNJebujjHreSQA8y7uPuDelvjWH998wnFJxzcvs2pGYZbo0k3ILbF8hCbxcY2QzwdkpQ8/W5P4f+j3/3b5++euPyjo6ONvd7732HnDx5Eh0dHXC73WueEJfTflk8MCNvTywt3ms6oJCigdlOdtZpFnIOuXjxIv7mb/4G09PT+WuglEJRFAiCAEVR8ipPt9tddi5Kaf4ZmVJjtkjlabUhm83mE0tnMpmcV6mWV7+WXkNpSEnhumnZd7fbnS94HAwGUV/fgFCoAaFQCKGQWSDZrBUp5yVRK8G6VWWk9JxWMgXLS9YizsWEj6xFWPUTb926hV/84hf4/e9/z3TNiL5/8v2e/+G/+x/vtTa2JYlIs2A8zBl/SMH7QDzjWW0uGcwE0xtV4dc2NohwncAKxzCMmFtBjZLRtIZ4Mtzx2anf7/35//v/HOu5e+NZRfEEn332aemdd97Fiy++iIaGQh3AJxH2wd5UC5KcqpCgVEqx7+90jsVibm4Ot27dyktQFqmVFhF2cj6xYH8ulSRj+3p7VXiLPLPZLNLpNNLpNLLZLDKZDBKJBJLJZNFfIpFALBZDJBJBNBpFLBZDJpMpaqMlERZqRgrwej2or69HQ0MIjY0hNDc3o62tHW1tbQiFQvB4PJAkCS6XCy6XK69uFUUpHw6zXonQjHnVkEqlcP/+ffz+97/HH//4R/7g/gPN4/FMv/Pt9279Nz/8r293dXYPiiIZ4CofJAKZymrZDfJbZ9ggwnUIzjm5fBnipk3TrkuXRpR//7//z40Xr589HovFPiSE721oaPDu3LlTOn78OF588UV0dGx6LCnVVhIkF6RfGLRpEfHYSbFwzOPr3sXq1NUZ5O3FbEsL21b6M0NHzMK36XQakUgEs7OzmJ2dRTgcxuzsLKanpzE5OYnJyUlEo9FcnGeBJC3VqcfjQVtbG7Zu3Yru7m5s374dmzZtQk1NDWTZBUUx+xwAx+ezVqHrOrLZLBKJBG7evIlPP/0UZ86c4YODQ1oqmYxu7tjc8/orr3/x9rffO//03v0P3ZxEVK5m6rrr0sBGDcD1iLXfKzewID766CP605/+qnZmpm9rKpU6BuA9RVH2BAIBb3Nzs/TUU0+Ro0dfwnPPPYfGxkZbDcC1LSlaqkzTuYOWFfm19tnA0mDFPloli+x/2WwWqqoilUphZmYGo6OjGBsbw8jICEZGRjA0NIRwOAxCSM6Zx+xTNTU16OzsxJ49e7Bv3z7s3bs3p1515SqN0FyChbUDa1JjJeJ+8OABzpw5gy+//BL37t1jk5OT2WQyGXXJriuKR/nHrR1bz//owx9NvfeX7yVOnz6d/cEPfrBR+midY2MUebIgAqgFsBnAIQDfFgRhv9frrQ0EAq7W1lZxz549eO6557Bv39Po6OgoIsW1IC0SgpzkIeYzq5SS3wZWDpZN0lK7Wp9W6rHBwUH09/ejt7cXvb29GBsbA+ccLpcLbrcbDQ0N2LdvH44cOYIDBw4gFAqtatYjC5Z0rOs6EokE7t27h0uXLuHChQu4f/8+n56e1sLhcDaTyYxxzr8SBOEPAU/gVrApOPbgwYMEKue72MA6xMbI8mRCAOAH0AhgO4CjAF4WRXG7z+dT/H6/HAwGhc7OTvL0089g37592LFjOwKBYF7ttdLESIgZr2e5+xNCnxhPwycVlno1lUohlUohmUxicnISt2/fxrVr13Djxg0MDQ1BFEX4fD60trbi2LFjeOedd7Bjxw54PJ4Ve76WOtiS/EZHR9HT04PLly/j2rVrGB0dZZFIRI9EImomk4kwxq4B+ALABQCDAGYApLFR8++JxMYo8+TDBaAOQAjAVpiS4vOEkF1ut9tfW1sr+nw+sa6uTujq6sLOnTuxa9cubN3ajcbGxjwpFhwolp8cKaWQZSlfD3GD/NYvNE1DMplENBpFJBLB6Ogorly5gtOnT+PWrVsQBAGdnZ344IMP8OGHHyIUCi378y61i2YyGQwNDeHu3bu4desWbt++jeHhYR6NRo1oNKpHo1FN07RJADcAnAVwFcAwTPKLAdgId3jCsTHifHNAYJJiMPfXCuD/b+/uets49juOf5cUKS2fJFISKZKxjnukPBmVkcYwTpu47QsI0Mu8i1zltuc+L6AokN4V6MUBDtqL5BwgKBIYQd2gcdsgQZO6TuREsSzZeqAokTQlUaHYi9lZjtaULTt2rIffBxjMcklRkk3yr5md/3/mgD8D5mKx2Hnf95PZbDaeyWSGcrlcrFQqebOzs8zMzDIzM8OvfjVNPl8Ia3O67Uk/zMwy/uED1UzkdLCrLjc3N1lfX+fmzZt8+OGHfPzxx6RSKd5++23effddRkdHn+j57SpaW5Ch2+2yu7vL0tIS8/PzfPvtt8zPz/P9999Tq9VoNps0Gg1arVZ3d3e30ev1bgD/BXwBfAusAXVM8Hs6O0rIiaBPnrMrAWSAsaCVgZeBV4FXPc/7dSKRGM1ms0PpdDqWSqVimUwmViwWvenpac6dO4fpp6lUKqTT6QOjxmj+2mGSSbP0/jhcn5Rnp9frhSOzDz74gPfee4+XX36Z999/nwsXLjx04ZZbqNxWwNnb22NjY4PFxUUWFha4ffs2CwsLLCwsUKvVaLVaB9JInBzNfWAF+G/g34B/B+aBLUy1J137O4NUWebs2sP89VvH/EH0DfAfmGuL2V6vl+90OudrtdortVptFpjxPG86kUikU6lU3PdT8VTKj6dSKS+TyVAqlahWq7zwwjnK5TJTU1NMTU1RKBSC6iWxBxa+2ARsOd3cUVuz2eTGjRt0Oh2SySTpdBogDHBunuT+/j7tdpuVlRWWl5dZXl5macmUFFxcXKRWq3H//v0D1yi3t7fDnU0O4WFmRC4Ds8DfAP+DCYifA8uYIvm2Jp6cARoRymFigI8JjJmg5YAqZtT4G+AVYMLzvMTw8HDc9/2Y76cYGTHlvnx/hGw2y+TkJFNTJjiWSiWKxUkmJiYZHx8nl8uRSqUO7Nc3qFqKnCz9guZdGo0GX3zxBZ988gmffvopt2/fplQq8c477/DWW2+xs7PD2tpamL9og97du3dZX1+n3W6HRQPsitV2ux3Wef2Z9oEmUAPuAf8J/BEzXboFdFFAPPX0CSOPwwNGMAFxHDOlOgX8BfDXmMDoe54XCwSFo5P4fopUyg8T+00bJpVKMTk5SalUZGJigmKxSLFYJJ/PUygUyOfzjI6OhmXKHiyLNjiJXsHz6XMLm0d7t/C5rcdp0xG++eYb7ty5w+rqKu12m/Hx8bB8W7fbZXt7O8zhs6tQbdDrdDq/5KzBPib4LWMC4T8D1zCzJpoyPcX0aSE/hwckMUGxDPwaExT/0vO8VzzP84FYLpfzZmdnqVarxONx6vU6a2trrK6u0mq1wi2IbJmufqA0OY6JRIJsNnugLqYNkLlcjmw2SyaTCYpJm2YLSsPh1WYOC5ZPsxTb8zIoeDwsoLj3RY9tObdWq0Wz2TzQNxoNarUaS0tL3Lt3j3q9HpZ029jYYGNjg2azGe6tGI/Hw1JsdgrT/p96nhe+LqJ1V5+DFiZt4g/APwI3UTA8tU7Wu1uOM7sqdQITFF8E3vQ8768SicRsNptNZjIZr1wue5cuXeLy5ctUKhU6nU74gemW+bLHtnU6naCYcz9AJpPJYJeEhLNjQiLsfd8PA2QmkyGdToc7jbv9yMhImADe39FhOPw+tpao/RB364geF+5ozCaK7+7usr+/z87OTpjz59YntcfudTY7BWkXm9iAt7u7Gz6vbe73sV9nz8XjcXK5HIVCgfHxccbHxykUCuFt+8fM3t4en3/+OdeuXWNpaYl2ux3s5HEsZiN7mJWkvwf+HriBpklPpePzTpbTxMNcXyxi0jQuAFc8z3vT9/1zxWIxUalUvAsXLnhuxRG3ikm0tdttNjc3aTQaYdva2goLSNvb9oPbXkOKxWIHAqWtlen2bp6k29trlvY29He6t4E4Ho+H07bujhIP/IN4XhhYH8bdcWIQu/OEWxbMLipx6426Kyzd3k01sM0Gtug5G9R6vV64xVMmkyGXyzE6OhqOyN1mz2ezWXzfD//IcEf6AIuLi1y9epXPPvuM+fl5lpeXabfbxyUARt0D/hb4J+DQzXfl5FIglGfNwyy0KQHngIuYkeKfZ7PZUqlUSlSrVe/ixYtcuXKFN954I0zkd0dc3W6XTqcTjnjssdvsefshbmtl2hGP29sVhp1Oh52dnQPH9tqUO2qyAcc+v7sK1myC26+OY4+jjlqQwAauKHc1pb0dDXbDw8Nhnqcd5ZprtP6BYxuc+gubzOg4nU4/0EZGRg6MtKOjcvf28PBwOJ1tf1d7/bDZbHL9+nU++ugjrl+/zsLCAisrK+ztHfuUvZ+A3wJ/h5kylVNGgVB+STFMLdQyMA28DrwZi8Uuj46O5svlcnx6etp7/fXXuXLlCpcuXaJQKDyww8RR2aLS7ugm2ruPscfRkZEdRUUDT3R/QBsoBwUym0dng9jD2EAS/X1tgWsbZHzfD0erdsrWLY1nR712qyg7ynVL6Nnnik4ru+1JCibY4Le3t8fi4iLXrl3j6tWrfP311/z444/U6/Uj/VscAz1MnuFvgX9BifankgKhPC9xTOm3KvAnmLyuN+Px+MVCoZCrVqve9PS0Nzc3x2uvvcbc3Fy44TAcvmv7sxRdRGIDnp1qjI7Yol97lOX+0anYKBvA7OjTPXaf45cUXT3aarWYn5/nq6++4ssvv7Qlzbhz5w7b29vHdfpzkH1gAfgHzLTo0nP9aeSZUSCU583DFHaYxEydvogJir8ZGhp6NZ/Pp0ulUqxYLFKpVLyZmRleeuklZmZmOH/+PPl8/sDUZPikx2ghy2kxKG2i0+mwsrLCDz/8wK1bt/juu++4detWuJ/h6uoqjUbjJAU/MKPA+5gk+98BH2NSKk7EEFYenz4t5DixK0/LwAuY6dMLwGue580lk8ni2NhYYnx83AtyDL1SqUS5XKZarVIul6lUKlQqFfL5PMlk8rFTJ86yh6VQ2KR3W93F7k9ok97r9Xq44rfRaBx6nfMY6wWtjkmq/1fgM+D/MLVHT9QvI49HnwZyXHmYeqgTmJWnJcw+izOe572IqYtaHRkZGclms14ul/OCnlwux9jYGBMTE+HS/WgbGxt7IEk//MaPkV94HB0WgA5bgNPtdmm322xtbbGxsUG9Xg93ql9fX2dtbY1arcbm5mZYuNqu1m21WuEK1xMY+Gx/HxPwrmOC4P8Ct4BNNAo8E07GO1vOOvs6TWGS9ycxqRl5zOjxIvCnnudNY6reDA0NDXm+75NOpz277D+VSoUrI23vJuHb5Hybd2hzDW2zt20KQPjDPccAGQ0+dgVsNC/Qrpa1gazRaNBsNsOUk2j5sna7faBw9fb29oFrnycs6MHBwNfFpETcBL7G1Nm9hUmgv4upNXrifkF5cgqEchJ5Tp/BTKNWMItvJoDzmA2JZ4EXPM/LBI91X+/e0NDQgRQCm0ZgUwtsekC0Hx4exvf9B1ZXRhP9B+2qYdMaBgVPu+o0utjGTQfZ29sLWzSVxKZ62FzM6NfY3eVtWogNfjbxPuoEBjvLDXo9zIa6d4DvMYtfvgNuY4LeMmY3il0U/M4sBUI5DdzX8Qhm1FgKmq10cw4TMKv0g2bS/fogOD3yPeEm6bsJ+fa2m5JwWArEYYFw0MpSuyrVpnI8rD9qSsIJDnJWb8DxPmY68y5mhecSZoPdRWAVUyVmLThu0w+UcsYpEMppZV/bMcyosYAJkAXMlOoEpmB4MdImgsfHBjzXYbf7dzzjadJTEMCOalCgs8c7mN3j3eB2DzOyWwM2MIteNjC7SmxxcJf5M/OPKEejQChnRfS1nsRcTxwN2ljkOE8/aNo+H9yfxYw8H/U9Djt3Fg0KPtFzPUzAamGC1yb9oGYDmz23FWmbQYtOcSroySPpTSpn3aDRXhIzKswO6NOYRTv2ds7pM8F99v608/jkgO/1sJ/jSX/+J/WkAeNRX/cTZlVmO+jd4yYm6DUxKQrNoNnHtJxzLaffHvB9FfDkiSkQihzusPeHTe2wQS4VHI9gio0PB70fnBsJzo1Eztnz9r4hTMBMBs9vj4fo51jG6QfrWHCfvX+QOP1rYYcFi5+Ctu8cdzHlxOy5TnDb7XeD+3YxwWknaLvOcbRtO71tNjC2efiKTQU7eSYUCEV+nqO8hzxM0ErSD3xJ5/aQ0w9hgqDtE/SDXyJ4Hvc4Hjz2MEcJhF1MQLNTk11MAHT7veA+t+849+0GrUM/SHac530UBTl5bhQIRX55T/N99zSe62kHIQU1EREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREROc7+H6Ie5Q1uUIk5AAAAAElFTkSuQmCC";
var yQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "message-center-container" }, [t("div", { staticClass: "header" }, [t("span", [e._v("消息中心")]), t("img", { staticClass: "close-btn", attrs: { src: Yo }, on: { click: n.closeMessageCenter } })]), n.messageList.length ? t("ul", { ref: "list", staticClass: "message-list" }, [t("li", { staticClass: "message-item-container" }, e._l(n.messageList, function(a) {
    return t(n.MessageItem, { key: a.id, attrs: { data: a } });
  }), 1)]) : e._e(), n.messageList.length === 0 && !n.loading ? t("div", { staticClass: "message-empty" }, [t("img", { attrs: { src: xQ } }), t("div", { staticClass: "message-empty-text color_text_1" }, [e._v("暂无消息")])]) : e._e()]);
}, AQ = [];
const bQ = {
  __name: "MessageCenter",
  props: {
    debug: {
      type: Boolean
    }
  },
  emits: ["closeMessageCenter"],
  setup(r, { emit: e }) {
    const t = r, n = t.debug ? Sr : Pr, a = ue([]), i = ue(!0), u = ue("TphDcvmBvc12dzla");
    hr(() => {
      c();
    }), Je(() => a, () => {
      ni(() => {
        l();
      });
    });
    function f() {
      e("closeMessageCenter");
    }
    async function c() {
      try {
        const { svip: v, vip: p } = await s(), h = "dict-message-center", d = {
          app: "deskdict_bkd",
          type: "msg",
          userType: v || p ? "vip" : "nonVip"
        }, x = qt.genParamV3(
          {},
          u.value,
          h,
          "web",
          "webdict",
          "1",
          "1",
          "web",
          "",
          "",
          "",
          "",
          "1"
        ), g = await n.getMessageList({
          ...x,
          ...d
        });
        let y = [];
        if (g.list.length)
          y = g.list;
        else {
          a.value = [];
          return;
        }
        for (let m = 0; m < y.length; ++m) {
          const { accountId: b, accountName: w } = y[m], A = await n.getMessageDetail({
            ...x,
            ...d,
            accountId: b,
            pageSize: 100
          });
          a.value = a.value.concat(
            A.list.map((E) => ({
              ...E,
              accountName: w
            }))
          ), y[m].unReadCount && o(b, x);
        }
      } catch (v) {
        console.log(v), a.value = [];
      } finally {
        i.value = !1;
      }
    }
    function o(v, p) {
      n.setMessageRead({
        ...p,
        app: "deskdict_bkd",
        type: "msg",
        accountId: v
      }).catch((h) => {
        console.log("已读消息失败", h);
      });
    }
    async function s() {
      const v = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        product: "web"
      };
      try {
        return await n.getVipStatus(v);
      } catch {
        return {
          svip: !1,
          vip: !1
        };
      }
    }
    function l() {
      const { list: v } = this.$refs;
      v && (v.style.paddingRight = "20px");
    }
    return { __sfc: !0, props: t, service: n, messageList: a, loading: i, secretKey: u, emits: e, closeMessageCenter: f, getMessageList: c, setRead: o, getVipStatus: s, updateScroll: l, ref: ue, computed: dr, watch: Je, onMounted: hr, nextTick: ni, serviceDev: Sr, serviceProd: Pr, v3: qt, MessageItem: gQ };
  }
};
var wQ = /* @__PURE__ */ Rr(
  bQ,
  yQ,
  AQ,
  !1,
  null,
  "c489a37d",
  null,
  null
);
const DQ = wQ.exports, CQ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMCSURBVHgBnVXdcdpAEN49FJLJ5IF0QDqQK7BdQUgFNg/BQ/izKgAqwDaRNbYfRCoIdIArMCVQAjPJxAlIt9k9SQkGcQ7ZmRuO0923/98iWCQMw9L3n1EHiI6IqIwAZfOBYAEKZ6Rp8qKgx/V6fb4LA/MOgyAoR1QIBRj+QRBwVFBxP0+R2jwY+redKFYPidVsKeAlaPjgKP2u1ThDWQqiAzljT74kDtFppNXD1fXN+bbyJ+B3XQDdS/+Oo9fFqletLsAiA/bWiVWPkU4Sk1WvVf/Y31IglrMtF+aQwGs2zy5gDxkOgx6Dd41HCF77U/LeKDAxl7AglNiDfqtR78F/yNXnm3NEGPB2wSE9kJw48iFKXCxJspo54L7vuxpfDECTmxjBFQRw2W7URuv32uz18PrmkJNSMUUCcKzE+ix+K66ETfBhcHekwTFJT8BNEFwECvOSGv0qVsUDuT8YhCUVx6qSxApHXk6ZUUwGhC2eE+gqaH0sezlTBJ3N+54nRUGmupzi8lyRwvcGAGkCOdJu1ioCHCt93G7UR61WfSp5AptonJpfxEOHXXGNNQ7Od90X4PX/CIWO8QlSoA2JHD1ztOJqpLI0molro1abwTMi1HHl34aSAwlTXs5EslDznbIDe8i3x2WX6/pUwCVknoWDMlGYJkw60nZRvnMDmoSj1lUbuO/fuul2oQiT2DukXJsCAWTqeCsrSfRu0ZrKxhDEmYKY7s0p4ZHtkfSL87j6Kkvq23aXq6CSbGiioqiYcg6d2B4yW56aZuNVLK4qNkP+NC7qsTKNgabcSs7LZbjrIVP0OGk2mC9VPN1piNAO/G1cQ3aGcpnPRck6E+4rGd3LHIkL+kAUmIEjGz40Nc2VMmD+6cKektB9MksYtJ9V2dOBs8bptjG4LmZu/zChTfPylO63ZnLK6aKklCkiVBPl6HnW7UEQ8syOXSAtST8RlpWwiOWbgyp36G+NwWeE6326wji3+dD2UBQVmM4VMy43j4uYecXdzw1KcXwfvXl1YZvbvwHMapNxAlGJRAAAAABJRU5ErkJggg==";
var EQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "toolbar-container" }, [t("div", { staticClass: "bottom-toolbar color_text_3" }, [e.isLogin ? t("div", { staticClass: "message-center" }, [t("span", { on: { click: n.goToMessageCenter } }, [e._v("消息中心")]), n.hasUnread ? t("div", { staticClass: "message-point" }, [t("div", { staticClass: "message-point-inner" })]) : e._e()]) : e._e(), e.isLogin ? t("div", { staticClass: "line" }, [e._v("|")]) : e._e(), e.isLogin ? t("div", { staticClass: "welfare" }, [t("span", { on: { click: n.gotoWelfare } }, [e._v("我的福利")])]) : e._e(), e.isLogin ? t("div", { staticClass: "line" }, [e._v("|")]) : e._e(), e.isLogin ? t("div", { staticClass: "Invoice" }, [t("span", { staticClass: "log", on: { click: n.gotoInvoice } }, [e._v("购买记录")]), t("div", { staticClass: "new-tag" }, [t("svg", [t("text", { attrs: { x: "3", y: "10" } }, [e._v("开发票")])])])]) : e._e(), e.isLogin ? t("div", { staticClass: "line" }, [e._v("|")]) : e._e(), e.isLogin && (e.isVip || e.isSVip || e.activeTab === "aipptVip" && e.isSlideVip) ? t("div", { staticClass: "vip-recharge" }, [t("span", { on: { click: n.buyRecharge } }, [e._v("购买加量包")]), t("img", { staticClass: "icon", attrs: { src: CQ }, on: { mouseenter: n.mouseenter, mouseleave: n.mouseleave } }), n.isShowDesc ? t("div", { staticClass: "recharge-desc color_label_2 color_text_2 color_divider_2_border" }, [e._v("可享受更多翻译、PPT生成存储额度")]) : e._e()]) : e._e(), e.isLogin && (e.isVip || e.isSVip) ? t("div", { staticClass: "line" }, [e._v("|")]) : e._e(), t("div", { staticClass: "exchange" }, [t("span", { on: { click: n.openExchange } }, [e._v("兑换码开通")])])]), t(n.exchangePopUp, { ref: "exchangePopUpRef", on: { exchange: n.exchange } }), n.showMore ? t(n.morePackage, { attrs: { routeQuery: e.routeQuery, debug: e.debug, isSVip: e.isSVip, isShowPPT: e.isShowPPT, activeTab: e.activeTab, isShowSlidePackage: e.isShowSlidePackage, morePackageTypeIndex: e.morePackageTypeIndex }, on: { closeMorePackage: n.closeMorePackage, buyVipMoreSuccess: n.buyVipMoreSuccess } }) : e._e(), n.showVipWelfare ? t(n.vipWelfare, { attrs: { debug: e.debug }, on: { closeVipWelfare: n.closeVipWelfare, openMorePackage: n.openMorePackage } }) : e._e(), n.showMessageCenter ? t(n.MessageCenter, { attrs: { debug: e.debug }, on: { closeMessageCenter: n.closeMessageCenter } }) : e._e(), n.showPurchaseRecord ? t(n.PurchaseRecord, { attrs: { debug: e.debug }, on: { closePurchaseRecord: n.closePurchaseRecord } }) : e._e()], 1);
}, NQ = [];
const BQ = {
  __name: "bottomToolbar",
  props: {
    isSVip: Boolean,
    isVip: Boolean,
    isLogin: Boolean,
    routeQuery: Object,
    debug: Boolean,
    isShowWithMorePackage: Boolean,
    isShowVipCenterInvoice: Boolean,
    isShowPPT: Boolean,
    activeTab: String,
    isSlideVip: Boolean,
    isShowSlidePackage: Boolean,
    morePackageTypeIndex: Number
  },
  emits: ["buyVipMoreSuccess", "closeMoreWin"],
  setup(r, { emit: e }) {
    const t = r, { proxy: n } = yn();
    let a;
    a = (F) => {
      console.log(n.$toast instanceof Function, "proxy.$toast instanceof Function"), n.$toast instanceof Function ? n.$toast(F) : n.$toast instanceof Object && n.$toast.show(F);
    };
    const i = t.debug ? Sr : Pr, u = ue(!1), f = ue(""), c = ue(!1), o = ue(!1), s = ue(!1), l = ue(!1), v = ue(!1), p = ue(null);
    Je(() => [t.isShowWithMorePackage, t.isShowSlidePackage], ([F, I]) => {
      (F || I) && (o.value = !0);
    }, { immediate: !0 }), Je(() => t.isShowVipCenterInvoice, (F) => {
      v.value = F;
    }, { immediate: !0 }), Je(() => t.routeQuery, (F) => {
      F.buyMore !== void 0 && F.buyMore === "true" && (o.value = F);
    });
    function h() {
      e("buyVipMoreSuccess");
    }
    function d() {
      o.value = !0;
    }
    function x() {
      o.value = !0;
    }
    function g() {
      o.value = !1, e("closeMoreWin");
    }
    function y() {
      s.value = !0;
    }
    function m() {
      s.value = !1;
    }
    function b() {
      u.value = !0;
    }
    function w() {
      u.value = !1;
    }
    function A() {
      p.value.showPopUp();
    }
    function E(F) {
      const I = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        platform: "webdict",
        code: F
      };
      i.exchangeVipCode(I).then((z) => {
        z.success ? (a("兑换成功"), window.location.reload(!0)) : z.errorCode === 2308 ? a("兑换请求频繁") : z.errorCode === 2309 ? a("会员码兑换失败（已经是VIP会员）") : z.errorCode === 2310 ? a("会员码兑换失败（会员码已过期）") : z.errorCode === 2311 ? a("会员码兑换失败（会员码已被使用）") : z.errorCode === 2312 ? a("会员码兑换失败（会员码不存在）") : a("会员码兑换失败");
      });
    }
    function N() {
      window._rlog.push([
        "_trackCustom",
        "event",
        [
          ["action", "order_record"]
        ]
      ]), v.value = !0;
    }
    function C() {
      v.value = !1;
    }
    async function D() {
      try {
        const F = "dict-message-center", I = "TphDcvmBvc12dzla", z = {
          // app: utilIndex.getPlafrom() === 'mac' ? 'macdict_bkd' : 'deskdict_bkd',
          app: "deskdict_bkd",
          type: "msg",
          userType: t.isSVip || t.isVip ? "vip" : "nonVip"
        }, P = qt.genParamV3({}, I, F, "web", "webdict", "1", "1", "web", "", "", "", "", "1"), M = await i.getMessageUnread({
          ...P,
          ...z
        });
        c.value = !!M.totalUnRead;
      } catch {
        c.value = !1;
      }
    }
    function B() {
      c.value = !1, l.value = !0;
    }
    function S() {
      l.value = !1;
    }
    return hr(() => {
      f.value = t.routeQuery.source || "", D();
    }), { __sfc: !0, proxy: n, Toast: a, props: t, emits: e, vip: i, isShowDesc: u, source: f, hasUnread: c, showMore: o, showVipWelfare: s, showMessageCenter: l, showPurchaseRecord: v, exchangePopUpRef: p, buyVipMoreSuccess: h, openMorePackage: d, buyRecharge: x, closeMorePackage: g, gotoWelfare: y, closeVipWelfare: m, mouseenter: b, mouseleave: w, openExchange: A, exchange: E, gotoInvoice: N, closePurchaseRecord: C, checkUnreadMsg: D, goToMessageCenter: B, closeMessageCenter: S, ref: ue, computed: dr, watch: Je, onMounted: hr, isVue2: ru, isVue3: Ym, getCurrentInstance: yn, exchangePopUp: w2, morePackage: X3, PurchaseRecord: vQ, vipWelfare: Z3, MessageCenter: DQ, vipDev: Sr, vipProd: Pr, v3: qt };
  }
};
var SQ = /* @__PURE__ */ Rr(
  BQ,
  EQ,
  NQ,
  !1,
  null,
  "619500c4",
  null,
  null
);
const PQ = SQ.exports, MQ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABACAYAAAC5vjEqAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAHWSURBVHic7djPcdNAGIfhd5XBcAwdpATowFQAOxrs+EY6SCqwqYCUYE5CMUYlOKWkBJ+Z4I9DkIbRbJxYVnZ1+D0nS9af9TtjaSUQEREREREREREREZFBcLFO9GP1a4PZ2Iyvs2m+6H6c9SXG3MHtdJL7HocYlL30CQDK8ucnzMYAzjEvyvWiy3GKcr3A+AacGrzrcYiPihJoNDq5Be7q5S6RinK9cI55vWzG977Gt0+UQN77rf3JPtAxUiDOUX/TQ0S7BgEURXXmTnYb4Kxe99SPTRkHIgeCwyKljgMJAsHzIg0hDiQKBI9HejPKrn/fMzfbXf6/PkUcSBgIwpHaUsaBxIFgf6TUcWAAgeBhImnOVe3155M8+fiizIOeYs59DK3vOuPuU/JA/yJ8CX13zGNJX5IGat/KcVxlZO858rGkT+lu8+15DlzMJvkSwhdu57Lr6Wd/FXucaSaKe+I024TvbsvzSX4RZ5QP4j9qPCNOs+0AIsV9WD0gTrNP4kjRAnWJ0+ybMFKUQMWqGjvbberlQ+I0xwhEev0qe+u93/Y20IBIt/n7+sO2SxyA2czftV66LV86TlTFqhpXVXXax7Fubqoo76NFRERERERERERERGRA/gK0HPZqq1xR8AAAAABJRU5ErkJggg==", FQ = "data:image/png;base64,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", TQ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAALNSURBVFiF3Zc/SBtRHMe/7wykcDGCQ1IMipIOJ7TVpQ5CwKLNXDObuCopuLRQu5hsQl2ESF1tul/mU6lg6xA6GFroQQmGhKt64JAzBwbSvA7RM9fknZdoDPS7vfvde7/Pvd+fd4/gUsL+zBThuCVKMQ7QYXREJAfQHCiNy4GdPQAgNefBGAhd6YxThiiJywEpRoT9mSkQ8vlenRsQ9DkHQu73y+tEOG6JA8hwtwAoxTjXuYSzhTDssPuq2+GCwPvR28Pj/I8OWc9Cq5RujXAjwETfGKKDc5joG2uwpYsZpNRtiKrUNgARvrygLOPyyAIiA6EbF0kXM3j3aw1K+bRlAI5leDUUtuUcqO3S1pM1+JzeuwGobXv4GuZnDDPfwqaYJ/JJjH4NIl3MAAB8Ti+iQ+GGtdoCmO6fNI19D7wQeD/cDpfp2XT/JHzOh8azWU+wZYCmOSCOf4DA+20tIKoSZD2L3h6XAaiUT5BSt21Vie0y/FdapYTksQiB92N5ZLHBHh0MI6VK2Ch8sgRpGgI75MljES89wYZwXcntcCEyEMLW4/em0NkCSKnbls7TxQyeuZ8aWS+qEnbPDgy7rGeNscD78XZkoTUAUZUsm4usZ02NaffsAGktYwKsnz/rCTJ3gZkDq0eb8Dm9TTugVtFN48RozDSODIQaeojA+42SrRezEWmVEuZ/vGlqI4Q1i61zRl5ZVsFE3xiU8ilSqgTl4gQC/wi9Dh6ynm3JuVYpMdu0JYBycYL576/rJl8np6hKthvPRiHJrCxmCABAKZ8yyVePNm0dPhuFJD7+Fpl2SwAraZUSQoeLSOTZXyfrWSTySct1LI9ju7r6WfE5PQAApawCAKKDczce03cCcBu1HYL/CYDkuuee5DhCcNg9AJrjaLW63j3/NM7JgZ09UBK/f+ckLgd29oxj5fKSulK7qnXuek4IDmm1un51Pf8LSLUXvrFEIK0AAAAASUVORK5CYII=";
var OQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "popup-container" }, [t("img", { staticClass: "close", attrs: { src: MQ }, on: { click: n.closePop } }), t("img", { staticClass: "header-img", attrs: { src: n.vipInfo.deskPopupImg } }), t("div", { staticClass: "info-container" }, [t("div", { staticClass: "order-card" }, [t("div", { staticClass: "order-card-header" }, [t("div", { staticClass: "order-money" }, [t("span", { staticClass: "money" }, [e._v(e._s(n.vipInfo.couponPrice))]), t("span", { staticClass: "unit" }, [e._v("元")])]), t("div", { staticClass: "order-desc" }, [e._v(e._s(n.vipInfo.couponName))])]), t("div", { staticClass: "card-content" }, [t("div", { staticClass: "vip-type" }, [e._v(e._s(n.vipInfo.planTitle))]), t("div", { staticClass: "vip-price" }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(n.vipInfo.discountedPrice))])]), n.vipInfo.basicPrice ? t("div", { staticClass: "vip-basicprice" }, [e._v("￥" + e._s(n.vipInfo.basicPrice))]) : e._e(), t("div", { staticClass: "vip-desc" }, [e._v(e._s(n.vipInfo.planShortDesc))]), n.vipInfo.planTag ? t("div", { staticClass: "tag" }, [t("div", { staticClass: "tag-txt" }, [e._v(e._s(n.vipInfo.planTag))])]) : e._e()])]), t("div", { staticClass: "open-coupon-content" }, [t("div", { staticClass: "count-down-content" }, [n.remainTime > 0 && n.remainTime <= 432e6 ? t("div", { staticClass: "count-down" }, [t("span", { staticClass: "time" }, [e._v(e._s(n.countDownTime.hour))]), t("span", [e._v("时")]), t("span", { staticClass: "time" }, [e._v(e._s(n.countDownTime.minute))]), t("span", [e._v("分")]), t("span", { staticClass: "time" }, [e._v(e._s(n.countDownTime.second))]), t("span", [e._v("秒 后优惠失效")])]) : e._e()]), t("div", { staticClass: "qr-code", class: { "no-btn-qr": e.closeShowCoupon } }, [t("img", { staticClass: "scan", attrs: { src: FQ } }), !e.isLogin || n.loseEfficacy || n.isFrequent ? t("div", { staticClass: "no-qrcode" }, [e.isLogin ? n.loseEfficacy || n.isFrequent ? t("div", { staticClass: "no-qrcode_refresh", on: { click: n.getPayOrder } }) : e._e() : t("div", { staticClass: "no-qrcode_login", on: { click: n.goToLogin } }, [e._v("点我购买")])]) : t("div", { staticClass: "qr-code-img", on: { click: n.getPayOrder } }, [n.qrCode.codePayUrl ? t("img", { staticClass: "weixin-logo", attrs: { src: TQ } }) : e._e(), t("img", { staticClass: "qr-code-img", attrs: { src: n.qrCode.codePayUrl } })])]), e.closeShowCoupon ? e._e() : t("div", { staticClass: "coupon-btn coupon-btn-other", on: { click: n.openVip } }, [e._v("查看会员特权")]), t("div", { staticClass: "regulation" }, [t("div", { staticClass: "info" }, [e._v("开通前阅读并同意")]), t("span", { staticClass: "service-agreement agreement-content", on: { click: n.openServiceAgreement } }, [e._v("《会员服务协议》")]), t("span", { staticClass: "renewal agreement-content", on: { click: n.openRenewalRule } }, [e._v("《自动续费规则》")])])])])]);
}, zQ = [];
const RQ = {
  __name: "CouponPopup",
  props: {
    debug: Boolean,
    couponType: String,
    isLogin: Boolean,
    closeShowCoupon: Boolean,
    source: String
  },
  emits: ["closeCouponPopup", "buyVipSuccess", "openVipCenter"],
  setup(r, { emit: e }) {
    const t = r, { proxy: n } = yn();
    let a;
    a = (B) => {
      console.log(n.$toast instanceof Function, "proxy.$toast instanceof Function"), n.$toast instanceof Function ? n.$toast(B) : n.$toast instanceof Object && n.$toast.show(B);
    };
    const i = t.debug ? Sr : Pr, u = ue({}), f = ue(!1), c = ue(0), o = ue(""), s = ue(""), l = ue(""), v = ue(""), p = ue({
      hour: "",
      minute: "",
      second: ""
    }), h = ue({
      orderId: "",
      codePayUrl: ""
    });
    function d(B) {
      const S = document.cookie, F = `${B}=`, I = S.length;
      let z = 0;
      for (; z < I; ) {
        const P = z + F.length;
        if (S.substring(z, P) === F) {
          let M = S.indexOf(";", P);
          return M === -1 && (M = I), unescape(S.substring(P, M));
        }
        if (z = S.indexOf(" ", z) + 1, z === 0)
          break;
      }
      return -1;
    }
    Je(
      () => h.value.orderId,
      (B) => {
        g(B);
      },
      { deep: !0 }
    );
    function x() {
      console.log("cookie", document.cookie);
      const S = {
        imei: d("OUTFOX_SEARCH_USER_ID_NCOO"),
        keyfrom: "webdict",
        apiversion: "1.0",
        paytype: "weixin",
        platform: "webdict",
        pid: u.value.planId,
        orderType: 0,
        // 0为会员订单
        source: t.closeShowCoupon ? "fanyiweb_subscription_center_limit_vip_popup" : t.source,
        couponId: u.value.couponId
      };
      i.getPayOrder(S).then((F) => {
        F.success ? (f.value = !1, h.value.orderId = F.orderId, h.value.codePayUrl = Ms.getQrBase64(F.url, {
          padding: 0,
          width: 128,
          height: 128
        })) : F.errorCode === 2308 ? (f.value = !0, a("操作频繁，请稍后重试")) : console.log("其他操作");
      });
    }
    function g(B) {
      const S = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        platform: "webdict",
        orderid: B,
        orderType: 0
        // 0为会员订单
      };
      clearInterval(s.value);
      let F = 0;
      s.value = setInterval(() => {
        i.getOrderStatus(S).then((I) => {
          I.success ? (a("购买成功"), clearInterval(s.value), e("buyVipSuccess"), A()) : F <= 600 ? F++ : clearInterval(s.value);
        });
      }, 1e3);
    }
    function y() {
      c.value -= 1e3, c.value <= 1e3 ? (clearInterval(o.value), p.value = {
        hour: "",
        minute: "",
        second: ""
      }, A()) : p.value = mr.dateFormatHMS(new Date(c.value));
    }
    function m() {
      clearInterval(o.value), o.value = setInterval(() => {
        y();
      }, 1e3);
    }
    function b() {
      this.loseEfficacy = !1, clearTimeout(this.qrTimer), this.qrTimer = setTimeout(() => {
        this.loseEfficacy = !0;
      }, 12e5);
    }
    function w() {
      const B = d("OUTFOX_SEARCH_USER_ID_NCOO"), S = {
        type: t.closeShowCoupon ? "desktopVipClose" : t.couponType,
        reshow: 1,
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        appVersion: "1",
        client: "web",
        product: "web",
        vendor: "",
        yduuid: B
      };
      i.getCouponInfo(S).then((F) => {
        F.code === 0 && F.data && F.data.couponInfo && (console.log("调用 service.getCouponInfo ==> ", F), u.value = F.data.couponInfo, c.value = F.data.couponInfo.expiredTime, x(), m());
      });
    }
    function A() {
      clearInterval(o.value), clearTimeout(s.value), clearTimeout(l.value), e("closeCouponPopup");
    }
    function E() {
      window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${encodeURIComponent(window.location.href)}&t=${(/* @__PURE__ */ new Date()).getTime()}`;
    }
    function N() {
      const B = "https://c.youdao.com/dict/law/VIP.html";
      window.open(B);
    }
    function C() {
      const B = "https://c.youdao.com/dict/law/renew.html";
      window.open(B);
    }
    function D() {
      e("openVipCenter", u.value.planId), A();
    }
    return w(), hr(() => {
      document.addEventListener("visibilitychange", () => {
        document.visibilityState === "visible" && w();
      });
    }), { __sfc: !0, props: t, proxy: n, emits: e, Toast: a, service: i, vipInfo: u, isFrequent: f, remainTime: c, timer: o, payTimer: s, qrTimer: l, loseEfficacy: v, countDownTime: p, qrCode: h, _rl_get_cookie: d, getPayOrder: x, getPayStatus: g, countDown: y, timing: m, qrTiming: b, getCouponInfo: w, closePop: A, goToLogin: E, openServiceAgreement: N, openRenewalRule: C, openVip: D, ref: ue, computed: dr, watch: Je, onMounted: hr, isVue2: ru, isVue3: Ym, getCurrentInstance: yn, defineEmits: Gw, jrQrcode: Ms, serviceDev: Sr, serviceProd: Pr, utilIndex: mr };
  }
};
var IQ = /* @__PURE__ */ Rr(
  RQ,
  OQ,
  zQ,
  !1,
  null,
  "d7aa37c4",
  null,
  null
);
const HQ = IQ.exports;
var LQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "tab-list" }, e._l(n.tabList, function(a, i) {
    return t("div", { key: a.id, staticClass: "tab-item", class: { "tab-item-active": a.id === n.activeTab }, on: { click: function(u) {
      return n.changeTab(a.id);
    } } }, [t("span", { staticClass: "tab-content" }, [e._v(e._s(a.name))]), n.tabList.length > 2 && i !== n.tabList.length ? t("span", { staticClass: "tab-divider" }) : e._e()]);
  }), 0);
}, qQ = [];
const UQ = {
  __name: "VipTab",
  props: {
    activeTab: {
      type: String,
      default: "svip"
    }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const t = r, n = [
      {
        name: "SVIP超级会员",
        id: "svip"
      },
      {
        name: "AI PPT会员",
        id: "aipptVip"
      }
    ], { activeTab: a } = i1(t);
    return { __sfc: !0, tabList: n, emits: e, props: t, activeTab: a, changeTab: (u) => {
      console.log("activeTab.value:", a.value), e("change", u);
    }, toRefs: i1, defineEmits: Gw };
  }
};
var kQ = /* @__PURE__ */ Rr(
  UQ,
  LQ,
  qQ,
  !1,
  null,
  "a2d68a17",
  null,
  null
);
const XQ = kQ.exports;
var jQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { ref: "vipListContainerRef", staticClass: "vip-list-container" }, [t("div", { staticClass: "title color_text_1" }, [e._v("AI PPT会员")]), t("div", { ref: "vipListRef", staticClass: "vip-list" }, e._l(n.vipList, function(a, i) {
    return t("div", { key: i, ref: `vipItem_${i}`, refInFor: !0, staticClass: "vip-list-item color_main_vip_1_border", class: a.planId === n.currentPackage.planId ? ["active"] : "", on: { click: function(u) {
      return n.choiceItem(a, i);
    } } }, [t("div", { staticClass: "vip-type", class: a.planId === n.currentPackage.planId ? "color_text_vip_0" : "color_text_2" }, [e._v(e._s(a.trial ? a.pcPromoteInfo : a.period))]), t("div", { staticClass: "vip-price", class: a.planId === n.currentPackage.planId ? "color_vip_price" : "color_text_1" }, [a.trial ? e._e() : t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(a.trial ? a.periodDesc : a.price))])]), a.basicPrice ? t("div", { staticClass: "vip-basicprice", class: a.planId === n.currentPackage.planId ? "color_text_vip_2_change" : "color_text_3" }, [t("div", { staticClass: "unit" }, [e._v("￥")]), t("div", { staticClass: "price" }, [e._v(e._s(a.basicPrice))])]) : e._e(), t("div", { staticClass: "vip-desc", class: a.planId === n.currentPackage.planId ? "color_bg_vip_1_text" : "vip-desc-text" }, [e._v(e._s(a.shortDesc))]), a.firstTag && a.firstTag !== "" || a.tag !== "" ? t("div", { staticClass: "vip-tag" }, [e._v(e._s(a.firstTag || a.tag))]) : e._e()]);
  }), 0)]);
}, GQ = [];
const VQ = {
  __name: "PackageList",
  props: {
    isSVip: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    },
    debug: {
      type: Boolean
    },
    routeQuery: {
      type: Object
    }
  },
  emits: ["currentChoose"],
  setup(r, { expose: e, emit: t }) {
    const n = r, a = n.debug ? Sr : Pr, i = ue([]), u = ue({}), f = ue(""), c = ue(null), o = ue(null), s = ue(null), l = ue("");
    e({
      getVipList: v,
      resetVipListPosition: d
    }), hr(() => {
      v();
    }), Je(() => n.routeQuery, (x) => {
      console.log("routeQuery choosePlanId", n.routeQuery), l.value = (x == null ? void 0 : x.planId) || "";
    }, { immediate: !0 }), Je(() => u.value, (x) => {
      t("currentChoose", x);
    }, { deep: !0 });
    function v() {
      const x = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        appVersion: "1",
        client: "web",
        product: "web",
        vendor: "",
        yduuid: "1"
      };
      a.getSlidePlans(x).then((g) => {
        i.value = g, console.log("调用 choosePlanId ==> ", l.value);
        const y = g.findIndex((m) => m.planId === l.value);
        if (y !== -1)
          ni(() => {
            h(g[y], y);
          });
        else {
          const m = g[0];
          u.value = m;
        }
      });
    }
    function p() {
      c.showPopUp();
    }
    function h(x, g) {
      const y = o.value.children[g].offsetLeft - s.value.clientWidth / 2 + 79;
      o.value.scrollTo({
        left: y,
        behavior: "smooth"
      }), u.value = x;
    }
    function d() {
      o.value.scrollTo({
        left: 0,
        behavior: "smooth"
      });
    }
    return { __sfc: !0, props: n, vip: a, vipList: i, currentPackage: u, source: f, exchangePopUpRef: c, vipListRef: o, vipListContainerRef: s, choosePlanId: l, emits: t, getVipList: v, openExchange: p, choiceItem: h, resetVipListPosition: d, ref: ue, computed: dr, watch: Je, onMounted: hr, nextTick: ni, vipDev: Sr, vipProd: Pr, utilIndex: mr };
  }
};
var QQ = /* @__PURE__ */ Rr(
  VQ,
  jQ,
  GQ,
  !1,
  null,
  "8739c9f6",
  null,
  null
);
const YQ = QQ.exports;
var ZQ = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return t("div", { staticClass: "buy-view" }, [t(n.packageList, { ref: "vipPackageListRef", attrs: { isSVip: e.isSVip, isLogin: e.isLogin, debug: e.debug, routeQuery: e.routeQuery }, on: { currentChoose: n.currentChoose } }), t(n.buyVip, { attrs: { routeQuery: e.routeQuery, currentPackage: n.currentPackage, orderType: n.orderType, vipInfo: e.slideVipInfo, isSVip: e.isSVip, isLogin: e.isLogin, useView: "vip", couponInfo: n.couponInfo, debug: e.debug, activeTab: e.activeTab }, on: { buyVipSuccess: n.buyVipSuccess } })], 1);
}, WQ = [];
const KQ = {
  __name: "BuyView",
  props: {
    isSVip: Boolean,
    isLogin: Boolean,
    vipInfo: Object,
    routeQuery: Object,
    debug: Boolean,
    activeTab: String,
    slideVipInfo: Object
  },
  emits: ["buyVipSuccess"],
  setup(r, { emit: e }) {
    const t = r, n = ue({}), a = ue(null), i = ue(0);
    function u() {
      e("buyVipSuccess"), a.value.getVipList(), a.value.resetVipListPosition();
    }
    function f(o) {
      n.value = o;
    }
    const c = ue({});
    return { __sfc: !0, props: t, emits: e, currentPackage: n, vipPackageListRef: a, orderType: i, buyVipSuccess: u, currentChoose: f, couponInfo: c, ref: ue, packageList: YQ, buyVip: t1 };
  }
};
var JQ = /* @__PURE__ */ Rr(
  KQ,
  ZQ,
  WQ,
  !1,
  null,
  "e7c3cb88",
  null,
  null
);
const _Q = JQ.exports;
var $Q = function() {
  var e = this, t = e._self._c, n = e._self._setupProxy;
  return e.isShow || e.isShowWithMorePackage || e.isShowVipCenterInvoice || e.showCouponPopup ? t("div", { staticClass: "wrap" }, [t("div", { staticClass: "vip-center-version" }, [e._v("054")]), e.showCouponPopup ? e._e() : t("div", { staticClass: "content color_bg_vip_1" }, [t(n.Equity, { attrs: { routeQuery: e.routeQuery, debug: e.debug, isShowPPT: e.isShowPPT, activeTab: n.activeTab } }), t("div", { staticClass: "vip-container" }, [t("img", { staticClass: "close-vip-popup", attrs: { src: Yo }, on: { click: n.closeVip } }), t(n.login, { attrs: { isVip: n.isVip, isSVip: n.isSVip, slideVipInfo: n.slideVipInfo, isLogin: n.isLogin, userInfo: n.userInfo, vipInfo: n.vipInfo } }), e.isShowPPT ? t(n.vipTab, { staticClass: "vip-tab--area", attrs: { activeTab: n.activeTab }, on: { change: n.handleTabChange } }) : e._e(), t(n.activeTab === "aipptVip" && e.isShowPPT ? n.bugPpt : n.buyContent, { ref: "buyContentRef", tag: "component", attrs: { isSVip: n.isSVip, isLogin: n.isLogin, vipInfo: n.vipInfo, routeQuery: e.routeQuery, debug: e.debug, activeTab: n.activeTab, slideVipInfo: n.slideVipInfo }, on: { buyVipSuccess: n.buyVipSuccess } }), t(n.bottomToolbarVue, { attrs: { isVip: n.isVip, isSVip: n.isSVip, isLogin: n.isLogin, routeQuery: e.routeQuery, debug: e.debug, isShowVipCenterInvoice: e.isShowVipCenterInvoice, isShowWithMorePackage: e.isShowWithMorePackage, activeTab: n.activeTab, isShowPPT: e.isShowPPT, isSlideVip: n.slideVipInfo.aipptVip, isShowSlidePackage: e.isShowSlidePackage, morePackageTypeIndex: e.morePackageTypeIndex }, on: { buyVipMoreSuccess: n.buyVipMoreSuccess, closeMoreWin: n.closeMoreWin } })], 1)], 1), e.showCouponPopup || n.closeShowCoupon ? t(n.CouponPopup, { attrs: { closeShowCoupon: n.closeShowCoupon, source: e.couponSource, debug: e.debug, isLogin: n.isLogin, couponType: e.couponType }, on: { closeCouponPopup: n.closeCouponPopup, buyVipSuccess: function(a) {
    return n.buyVipSuccess("couponPopup");
  }, openVipCenter: n.openVipCenter } }) : e._e()], 1) : e._e();
}, eY = [];
const rY = {
  __name: "VipCenter",
  props: {
    debug: {
      type: Boolean,
      default: !1
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    routeQuery: {
      type: Object,
      default: () => ({})
    },
    isShowWithMorePackage: {
      type: Boolean,
      default: !1
    },
    isShowVipCenterInvoice: {
      type: Boolean,
      default: !1
    },
    showCouponPopup: {
      type: Boolean,
      default: !1
    },
    couponType: {
      type: String,
      default: ""
    },
    couponSource: {
      type: String,
      default: ""
    },
    // 2024-07-26新增是否展示 AIPPT 套餐
    isShowPPT: {
      type: Boolean,
      default: !1
    },
    // 2024-08-07新增是否展示 AIPPT 加量包
    isShowSlidePackage: {
      type: Boolean,
      default: !1
    },
    // 2024-08-09新增指定加量包type
    morePackageTypeIndex: {
      type: Number,
      default: null
    },
    // 2024-08-19新增是否默认选中 AIPPT 会员tab
    defaultActiveTab: {
      type: String,
      default: "svip"
    }
  },
  emits: ["closeVipCenter", "buyVipSuccess", "buyVipMoreSuccess", "openVipCenter", "closeCouponPopup", "closeMoreWin"],
  setup(r, { expose: e, emit: t }) {
    const n = r;
    e({
      getAccountInfo: w,
      getVipStatus: N,
      getSlideStatus: S
    });
    const a = n.debug ? Sr : Pr, i = n.debug ? $s : eu, u = ue("测试一下"), f = ue(!1), c = ue(!1), o = ue(!1), s = ue(null), l = ue({
      userAvatar: "",
      // 用户头像
      userName: "",
      svipExpire: ""
    }), v = ue(""), p = ue({}), h = ue(!1), d = (P) => {
      var M;
      t("buyVipSuccess"), N(), S(), w(), P === "couponPopup" && ((M = s.value) != null && M.couponPopupBuyVipSuccess) && s.value.couponPopupBuyVipSuccess();
    }, x = () => {
      t("buyVipMoreSuccess");
    }, g = () => {
      f.value ? (t("closeVipCenter"), h.value = !1) : E();
    }, y = () => {
      h.value = !1, t("closeCouponPopup");
    }, m = (P) => {
      console.log("openVipCenter", P), t("closeCouponPopup"), t("openVipCenter", P);
    };
    Je([() => n.isShow, () => n.isShowWithMorePackage, () => n.isShowVipCenterInvoice, () => n.showCouponPopup], ([P, M, H, O]) => {
      if (P || M || H || O)
        if (document.body.style.overflow = "hidden", N(), S(), w(), O)
          window._rlog.push([
            "_trackCustom",
            "event",
            [
              ["show", n.couponSource || "fanyiweb_subscription_center_limit_vip_popup"]
            ]
          ]);
        else {
          const Q = mr.getQueryVariable("keyfrom") || mr.getQueryVariable("source");
          window._rlog.push(["_trackCustom", "event", [Q ? ["keyfrom", Q] : "", ["type", mr.getPlatform()], ["show", "cidian_vip_purchase"]]]);
        }
      else
        document.body.style.overflow = "auto";
    }), Je(() => h.value, (P) => {
      P && window._rlog.push([
        "_trackCustom",
        "event",
        [
          ["show", "fanyiweb_subscription_center_limit_vip_popup"]
        ]
      ]);
    });
    function b(P) {
      const M = {
        userid: P
      };
      i.getBatchUrl(M).then((H) => {
        l.value.userName = H.values.nickname, l.value.userAvatar = H.values.option_avatar;
      });
    }
    function w() {
      i.getAccountInfos().then((P) => {
        P.code === 0 ? (o.value = !0, v.value = P.data.yduserid, b(v.value)) : (o.value = !1, v.value = "");
      }).catch((P) => {
        console.log("获取账户信息失败", P);
      });
    }
    function A(P) {
      const M = document.cookie, H = `${P}=`, O = M.length;
      let Q = 0;
      for (; Q < O; ) {
        const k = Q + H.length;
        if (M.substring(Q, k) === H) {
          let L = M.indexOf(";", k);
          return L === -1 && (L = O), unescape(M.substring(k, L));
        }
        if (Q = M.indexOf(" ", Q) + 1, Q === 0)
          break;
      }
      return -1;
    }
    function E() {
      const M = {
        type: "desktopVipClose",
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        appVersion: "1",
        client: "web",
        product: "web",
        vendor: "",
        yduuid: A("OUTFOX_SEARCH_USER_ID_NCOO")
      };
      a.getCouponInfo(M).then((H) => {
        H.code === 0 ? (console.log("调用 service.getCouponInfo ==> ", H), H.data && H.data.couponInfo ? h.value = !0 : (t("closeVipCenter"), h.value = !1)) : (t("closeVipCenter"), h.value = !1);
      }).catch((H) => {
        t("closeVipCenter"), h.value = !1;
      });
    }
    function N() {
      const P = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        product: ""
      };
      a.getVipStatus(P).then((M) => {
        c.value = M.vip, f.value = M.svip, p.value = M;
      });
    }
    const C = ue({}), D = "dict-vip", B = "PDdE4DR40ACSVW0KBIc3P1jgD31tbihD";
    function S() {
      const P = {
        imei: "1",
        keyfrom: "webdict",
        apiversion: "1.0",
        product: ""
      }, M = qt.genParamV3(P, B, D, "web", "webdict", "1", "1", "web", "", "", "", "", "1");
      a.getSlideStatus(M).then((H) => {
        H.code === 0 && (C.value = H.data);
      });
    }
    o1(() => {
      document.documentElement.classList.add("light");
    }), hr(() => {
      N(), n.isShowPPT && S(), w();
    });
    const F = ue(n.defaultActiveTab);
    return { __sfc: !0, emits: t, props: n, vip: a, serviceLogin: i, test: u, isSVip: f, isVip: c, isLogin: o, buyContentRef: s, userInfo: l, yduserid: v, vipInfo: p, closeShowCoupon: h, buyVipSuccess: d, buyVipMoreSuccess: x, closeVip: g, closeCouponPopup: y, openVipCenter: m, getBatchData: b, getAccountInfo: w, _rl_get_cookie: A, getCouponInfo: E, getVipStatus: N, slideVipInfo: C, key: D, serect: B, getSlideStatus: S, activeTab: F, handleTabChange: (P) => {
      console.log("handleTabChange", P), F.value = P;
    }, closeMoreWin: () => {
      t("closeMoreWin");
    }, computed: dr, ref: ue, watch: Je, onMounted: hr, onBeforeMount: o1, unref: Xr, util: mr, login: s5, buyContent: MV, Equity: LV, vipDev: Sr, serviceLoginDev: $s, vipProd: Pr, serviceLoginProd: eu, bottomToolbarVue: PQ, CouponPopup: HQ, vipTab: XQ, bugPpt: _Q, v3: qt };
  }
};
var tY = /* @__PURE__ */ Rr(
  rY,
  $Q,
  eY,
  !1,
  null,
  "d78e3406",
  null,
  null
);
const nY = tY.exports, iY = {
  install(r, e) {
    r.component("VipCenter", nY);
  }
};
export {
  iY as default
};
